(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8mPFi", function(module, exports) {

$parcel$export(module.exports, "YAML", function () { return $6178746541c82603$export$866dfa75bd13a786; });

var $5lj6y = parcelRequire("5lj6y");

var $4VNom = parcelRequire("4VNom");

var $lrFig = parcelRequire("lrFig");

var $2uhik = parcelRequire("2uhik");

var $5iO0y = parcelRequire("5iO0y");
var $6178746541c82603$var$defaultOptions = {
    anchorPrefix: 'a',
    customTags: null,
    indent: 2,
    indentSeq: true,
    keepCstNodes: false,
    keepNodeTypes: true,
    keepBlobsInJSON: true,
    mapAsMap: false,
    maxAliasCount: 100,
    prettyErrors: false,
    // TODO Set true in v2
    simpleKeys: false,
    version: '1.2'
};
var $6178746541c82603$var$scalarOptions = {
    get binary () {
        return 0, $lrFig.b;
    },
    set binary (opt){
        Object.assign((0, $lrFig.b), opt);
    },
    get bool () {
        return 0, $lrFig.a;
    },
    set bool (opt){
        Object.assign((0, $lrFig.a), opt);
    },
    get int () {
        return 0, $lrFig.i;
    },
    set int (opt){
        Object.assign((0, $lrFig.i), opt);
    },
    get null () {
        return 0, $lrFig.n;
    },
    set null (opt){
        Object.assign((0, $lrFig.n), opt);
    },
    get str () {
        return 0, $lrFig.s;
    },
    set str (opt){
        Object.assign((0, $lrFig.s), opt);
    }
};
var $6178746541c82603$var$documentOptions = {
    '1.0': {
        schema: 'yaml-1.1',
        merge: true,
        tagPrefixes: [
            {
                handle: '!',
                prefix: (0, $5lj6y.d)
            },
            {
                handle: '!!',
                prefix: 'tag:private.yaml.org,2002:'
            }
        ]
    },
    1.1: {
        schema: 'yaml-1.1',
        merge: true,
        tagPrefixes: [
            {
                handle: '!',
                prefix: '!'
            },
            {
                handle: '!!',
                prefix: (0, $5lj6y.d)
            }
        ]
    },
    1.2: {
        schema: 'core',
        merge: false,
        tagPrefixes: [
            {
                handle: '!',
                prefix: '!'
            },
            {
                handle: '!!',
                prefix: (0, $5lj6y.d)
            }
        ]
    }
};
function $6178746541c82603$var$stringifyTag(doc, tag) {
    if ((doc.version || doc.options.version) === '1.0') {
        var priv = tag.match(/^tag:private\.yaml\.org,2002:([^:/]+)$/);
        if (priv) return '!' + priv[1];
        var vocab = tag.match(/^tag:([a-zA-Z0-9-]+)\.yaml\.org,2002:(.*)/);
        return vocab ? "!".concat(vocab[1], "/").concat(vocab[2]) : "!".concat(tag.replace(/^tag:/, ''));
    }
    var p = doc.tagPrefixes.find(function(p) {
        return tag.indexOf(p.prefix) === 0;
    });
    if (!p) {
        var dtp = doc.getDefaults().tagPrefixes;
        p = dtp && dtp.find(function(p) {
            return tag.indexOf(p.prefix) === 0;
        });
    }
    if (!p) return tag[0] === '!' ? tag : "!<".concat(tag, ">");
    var suffix = tag.substr(p.prefix.length).replace(/[!,[\]{}]/g, function(ch) {
        return ({
            '!': '%21',
            ',': '%2C',
            '[': '%5B',
            ']': '%5D',
            '{': '%7B',
            '}': '%7D'
        })[ch];
    });
    return p.handle + suffix;
}
function $6178746541c82603$var$getTagObject(tags, item) {
    if (item instanceof (0, $lrFig.A)) return 0, $lrFig.A;
    if (item.tag) {
        var match = tags.filter(function(t) {
            return t.tag === item.tag;
        });
        if (match.length > 0) return match.find(function(t) {
            return t.format === item.format;
        }) || match[0];
    }
    var tagObj, obj;
    if (item instanceof (0, $lrFig.S)) {
        obj = item.value; // TODO: deprecate/remove class check
        var _match = tags.filter(function(t) {
            return t.identify && t.identify(obj) || t.class && obj instanceof t.class;
        });
        tagObj = _match.find(function(t) {
            return t.format === item.format;
        }) || _match.find(function(t) {
            return !t.format;
        });
    } else {
        obj = item;
        tagObj = tags.find(function(t) {
            return t.nodeClass && obj instanceof t.nodeClass;
        });
    }
    if (!tagObj) {
        var name = obj && obj.constructor ? obj.constructor.name : (0, $5lj6y.a)(obj);
        throw new Error("Tag not resolved for ".concat(name, " value"));
    }
    return tagObj;
} // needs to be called before value stringifier to allow for circular anchor refs
function $6178746541c82603$var$stringifyProps(node, tagObj, _ref) {
    var anchors = _ref.anchors, doc = _ref.doc;
    var props = [];
    var anchor = doc.anchors.getName(node);
    if (anchor) {
        anchors[anchor] = node;
        props.push("&".concat(anchor));
    }
    if (node.tag) props.push($6178746541c82603$var$stringifyTag(doc, node.tag));
    else if (!tagObj.default) props.push($6178746541c82603$var$stringifyTag(doc, tagObj.tag));
    return props.join(' ');
}
function $6178746541c82603$var$stringify$1(item, ctx, onComment, onChompKeep) {
    var _ctx$doc = ctx.doc, anchors = _ctx$doc.anchors, schema = _ctx$doc.schema;
    var tagObj;
    if (!(item instanceof (0, $lrFig.N))) {
        var createCtx = {
            aliasNodes: [],
            onTagObj: function onTagObj(o) {
                return tagObj = o;
            },
            prevObjects: new Map()
        };
        item = schema.createNode(item, true, null, createCtx);
        var _iterator = (0, $5lj6y._)(createCtx.aliasNodes), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var alias = _step.value;
                alias.source = alias.source.node;
                var name = anchors.getName(alias.source);
                if (!name) {
                    name = anchors.newName();
                    anchors.map[name] = alias.source;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    if (item instanceof (0, $lrFig.P)) return item.toString(ctx, onComment, onChompKeep);
    if (!tagObj) tagObj = $6178746541c82603$var$getTagObject(schema.tags, item);
    var props = $6178746541c82603$var$stringifyProps(item, tagObj, ctx);
    if (props.length > 0) ctx.indentAtStart = (ctx.indentAtStart || 0) + props.length + 1;
    var str = typeof tagObj.stringify === 'function' ? tagObj.stringify(item, ctx, onComment, onChompKeep) : item instanceof (0, $lrFig.S) ? (0, $lrFig.c)(item, ctx, onComment, onChompKeep) : item.toString(ctx, onComment, onChompKeep);
    if (!props) return str;
    return item instanceof (0, $lrFig.S) || str[0] === '{' || str[0] === '[' ? "".concat(props, " ").concat(str) : "".concat(props, "\n").concat(ctx.indent).concat(str);
}
var $6178746541c82603$var$Anchors = /*#__PURE__*/ function() {
    function Anchors(prefix) {
        (0, $5lj6y.c)(this, Anchors);
        (0, $5lj6y.e)(this, "map", Object.create(null));
        this.prefix = prefix;
    }
    (0, $5lj6y.b)(Anchors, [
        {
            key: "createAlias",
            value: function createAlias(node, name) {
                this.setAnchor(node, name);
                return new (0, $lrFig.A)(node);
            }
        },
        {
            key: "createMergePair",
            value: function createMergePair() {
                var _this = this;
                var merge = new (0, $lrFig.M)();
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                merge.value.items = sources.map(function(s) {
                    if (s instanceof (0, $lrFig.A)) {
                        if (s.source instanceof (0, $lrFig.d)) return s;
                    } else if (s instanceof (0, $lrFig.d)) return _this.createAlias(s);
                    throw new Error('Merge sources must be Map nodes or their Aliases');
                });
                return merge;
            }
        },
        {
            key: "getName",
            value: function getName(node) {
                var map = this.map;
                return Object.keys(map).find(function(a) {
                    return map[a] === node;
                });
            }
        },
        {
            key: "getNames",
            value: function getNames() {
                return Object.keys(this.map);
            }
        },
        {
            key: "getNode",
            value: function getNode(name) {
                return this.map[name];
            }
        },
        {
            key: "newName",
            value: function newName(prefix) {
                if (!prefix) prefix = this.prefix;
                var names = Object.keys(this.map);
                for(var i = 1;; ++i){
                    var name = "".concat(prefix).concat(i);
                    if (!names.includes(name)) return name;
                }
            } // During parsing, map & aliases contain CST nodes
        },
        {
            key: "resolveNodes",
            value: function resolveNodes() {
                var map = this.map, _cstAliases = this._cstAliases;
                Object.keys(map).forEach(function(a) {
                    map[a] = map[a].resolved;
                });
                _cstAliases.forEach(function(a) {
                    a.source = a.source.resolved;
                });
                delete this._cstAliases;
            }
        },
        {
            key: "setAnchor",
            value: function setAnchor(node, name) {
                if (node != null && !Anchors.validAnchorNode(node)) throw new Error('Anchors may only be set for Scalar, Seq and Map nodes');
                if (name && /[\x00-\x19\s,[\]{}]/.test(name)) throw new Error('Anchor names must not contain whitespace or control characters');
                var map = this.map;
                var prev = node && Object.keys(map).find(function(a) {
                    return map[a] === node;
                });
                if (prev) {
                    if (!name) return prev;
                    else if (prev !== name) {
                        delete map[prev];
                        map[name] = node;
                    }
                } else {
                    if (!name) {
                        if (!node) return null;
                        name = this.newName();
                    }
                    map[name] = node;
                }
                return name;
            }
        }
    ], [
        {
            key: "validAnchorNode",
            value: function validAnchorNode(node) {
                return node instanceof (0, $lrFig.S) || node instanceof (0, $lrFig.Y) || node instanceof (0, $lrFig.d);
            }
        }
    ]);
    return Anchors;
}();
var $6178746541c82603$var$visit = function visit(node, tags) {
    if (node && (0, $5lj6y.a)(node) === 'object') {
        var tag = node.tag;
        if (node instanceof (0, $lrFig.C)) {
            if (tag) tags[tag] = true;
            node.items.forEach(function(n) {
                return visit(n, tags);
            });
        } else if (node instanceof (0, $lrFig.P)) {
            visit(node.key, tags);
            visit(node.value, tags);
        } else if (node instanceof (0, $lrFig.S)) {
            if (tag) tags[tag] = true;
        }
    }
    return tags;
};
var $6178746541c82603$var$listTagNames = function listTagNames(node) {
    return Object.keys($6178746541c82603$var$visit(node, {}));
};
function $6178746541c82603$var$parseContents(doc, contents) {
    var comments = {
        before: [],
        after: []
    };
    var body = undefined;
    var spaceBefore = false;
    var _iterator = (0, $5lj6y._)(contents), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var node = _step.value;
            if (node.valueRange) {
                if (body !== undefined) {
                    var msg = 'Document contains trailing content not separated by a ... or --- line';
                    doc.errors.push(new (0, $5lj6y.Y)(node, msg));
                    break;
                }
                var res = (0, $lrFig.r)(doc, node);
                if (spaceBefore) {
                    res.spaceBefore = true;
                    spaceBefore = false;
                }
                body = res;
            } else if (node.comment !== null) {
                var cc = body === undefined ? comments.before : comments.after;
                cc.push(node.comment);
            } else if (node.type === (0, $5lj6y.T).BLANK_LINE) {
                spaceBefore = true;
                if (body === undefined && comments.before.length > 0 && !doc.commentBefore) {
                    // space-separated comments at start are parsed as document comments
                    doc.commentBefore = comments.before.join('\n');
                    comments.before = [];
                }
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    doc.contents = body || null;
    if (!body) doc.comment = comments.before.concat(comments.after).join('\n') || null;
    else {
        var cb = comments.before.join('\n');
        if (cb) {
            var cbNode = body instanceof (0, $lrFig.C) && body.items[0] ? body.items[0] : body;
            cbNode.commentBefore = cbNode.commentBefore ? "".concat(cb, "\n").concat(cbNode.commentBefore) : cb;
        }
        doc.comment = comments.after.join('\n') || null;
    }
}
function $6178746541c82603$var$resolveTagDirective(_ref, directive) {
    var tagPrefixes = _ref.tagPrefixes;
    var _directive$parameters = (0, $5lj6y.h)(directive.parameters, 2), handle = _directive$parameters[0], prefix = _directive$parameters[1];
    if (!handle || !prefix) {
        var msg = 'Insufficient parameters given for %TAG directive';
        throw new (0, $5lj6y.g)(directive, msg);
    }
    if (tagPrefixes.some(function(p) {
        return p.handle === handle;
    })) {
        var _msg = 'The %TAG directive must only be given at most once per handle in the same document.';
        throw new (0, $5lj6y.g)(directive, _msg);
    }
    return {
        handle: handle,
        prefix: prefix
    };
}
function $6178746541c82603$var$resolveYamlDirective(doc, directive) {
    var _directive$parameters2 = (0, $5lj6y.h)(directive.parameters, 1), version = _directive$parameters2[0];
    if (directive.name === 'YAML:1.0') version = '1.0';
    if (!version) {
        var msg = 'Insufficient parameters given for %YAML directive';
        throw new (0, $5lj6y.g)(directive, msg);
    }
    if (!$6178746541c82603$var$documentOptions[version]) {
        var v0 = doc.version || doc.options.version;
        var _msg2 = "Document will be parsed as YAML ".concat(v0, " rather than YAML ").concat(version);
        doc.warnings.push(new (0, $5lj6y.f)(directive, _msg2));
    }
    return version;
}
function $6178746541c82603$var$parseDirectives(doc, directives, prevDoc) {
    var directiveComments = [];
    var hasDirectives = false;
    var _iterator = (0, $5lj6y._)(directives), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var directive = _step.value;
            var comment = directive.comment, name = directive.name;
            switch(name){
                case 'TAG':
                    try {
                        doc.tagPrefixes.push($6178746541c82603$var$resolveTagDirective(doc, directive));
                    } catch (error) {
                        doc.errors.push(error);
                    }
                    hasDirectives = true;
                    break;
                case 'YAML':
                case 'YAML:1.0':
                    if (doc.version) {
                        var msg = 'The %YAML directive must only be given at most once per document.';
                        doc.errors.push(new (0, $5lj6y.g)(directive, msg));
                    }
                    try {
                        doc.version = $6178746541c82603$var$resolveYamlDirective(doc, directive);
                    } catch (error) {
                        doc.errors.push(error);
                    }
                    hasDirectives = true;
                    break;
                default:
                    if (name) {
                        var _msg3 = "YAML only supports %TAG and %YAML directives, and not %".concat(name);
                        doc.warnings.push(new (0, $5lj6y.f)(directive, _msg3));
                    }
            }
            if (comment) directiveComments.push(comment);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (prevDoc && !hasDirectives && '1.1' === (doc.version || prevDoc.version || doc.options.version)) {
        var copyTagPrefix = function copyTagPrefix(_ref2) {
            var handle = _ref2.handle, prefix = _ref2.prefix;
            return {
                handle: handle,
                prefix: prefix
            };
        };
        doc.tagPrefixes = prevDoc.tagPrefixes.map(copyTagPrefix);
        doc.version = prevDoc.version;
    }
    doc.commentBefore = directiveComments.join('\n') || null;
}
function $6178746541c82603$var$assertCollection(contents) {
    if (contents instanceof (0, $lrFig.C)) return true;
    throw new Error('Expected a YAML collection as document contents');
}
var $6178746541c82603$var$Document$1 = /*#__PURE__*/ function() {
    function Document(options) {
        (0, $5lj6y.c)(this, Document);
        this.anchors = new $6178746541c82603$var$Anchors(options.anchorPrefix);
        this.commentBefore = null;
        this.comment = null;
        this.contents = null;
        this.directivesEndMarker = null;
        this.errors = [];
        this.options = options;
        this.schema = null;
        this.tagPrefixes = [];
        this.version = null;
        this.warnings = [];
    }
    (0, $5lj6y.b)(Document, [
        {
            key: "add",
            value: function add(value) {
                $6178746541c82603$var$assertCollection(this.contents);
                return this.contents.add(value);
            }
        },
        {
            key: "addIn",
            value: function addIn(path, value) {
                $6178746541c82603$var$assertCollection(this.contents);
                this.contents.addIn(path, value);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                $6178746541c82603$var$assertCollection(this.contents);
                return this.contents.delete(key);
            }
        },
        {
            key: "deleteIn",
            value: function deleteIn(path) {
                if ((0, $lrFig.e)(path)) {
                    if (this.contents == null) return false;
                    this.contents = null;
                    return true;
                }
                $6178746541c82603$var$assertCollection(this.contents);
                return this.contents.deleteIn(path);
            }
        },
        {
            key: "getDefaults",
            value: function getDefaults() {
                return Document.defaults[this.version] || Document.defaults[this.options.version] || {};
            }
        },
        {
            key: "get",
            value: function get(key, keepScalar) {
                return this.contents instanceof (0, $lrFig.C) ? this.contents.get(key, keepScalar) : undefined;
            }
        },
        {
            key: "getIn",
            value: function getIn(path, keepScalar) {
                if ((0, $lrFig.e)(path)) return !keepScalar && this.contents instanceof (0, $lrFig.S) ? this.contents.value : this.contents;
                return this.contents instanceof (0, $lrFig.C) ? this.contents.getIn(path, keepScalar) : undefined;
            }
        },
        {
            key: "has",
            value: function has(key) {
                return this.contents instanceof (0, $lrFig.C) ? this.contents.has(key) : false;
            }
        },
        {
            key: "hasIn",
            value: function hasIn(path) {
                if ((0, $lrFig.e)(path)) return this.contents !== undefined;
                return this.contents instanceof (0, $lrFig.C) ? this.contents.hasIn(path) : false;
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                $6178746541c82603$var$assertCollection(this.contents);
                this.contents.set(key, value);
            }
        },
        {
            key: "setIn",
            value: function setIn(path, value) {
                if ((0, $lrFig.e)(path)) this.contents = value;
                else {
                    $6178746541c82603$var$assertCollection(this.contents);
                    this.contents.setIn(path, value);
                }
            }
        },
        {
            key: "setSchema",
            value: function setSchema(id, customTags) {
                if (!id && !customTags && this.schema) return;
                if (typeof id === 'number') id = id.toFixed(1);
                if (id === '1.0' || id === '1.1' || id === '1.2') {
                    if (this.version) this.version = id;
                    else this.options.version = id;
                    delete this.options.schema;
                } else if (id && typeof id === 'string') this.options.schema = id;
                if (Array.isArray(customTags)) this.options.customTags = customTags;
                var opt1 = Object.assign({}, this.getDefaults(), this.options);
                this.schema = new (0, $2uhik.S)(opt1);
            }
        },
        {
            key: "parse",
            value: function parse(node, prevDoc) {
                if (this.options.keepCstNodes) this.cstNode = node;
                if (this.options.keepNodeTypes) this.type = 'DOCUMENT';
                var _node$directives = node.directives, directives = _node$directives === void 0 ? [] : _node$directives, _node$contents = node.contents, contents = _node$contents === void 0 ? [] : _node$contents, directivesEndMarker = node.directivesEndMarker, error = node.error, valueRange = node.valueRange;
                if (error) {
                    if (!error.source) error.source = this;
                    this.errors.push(error);
                }
                $6178746541c82603$var$parseDirectives(this, directives, prevDoc);
                if (directivesEndMarker) this.directivesEndMarker = true;
                this.range = valueRange ? [
                    valueRange.start,
                    valueRange.end
                ] : null;
                this.setSchema();
                this.anchors._cstAliases = [];
                $6178746541c82603$var$parseContents(this, contents);
                this.anchors.resolveNodes();
                if (this.options.prettyErrors) {
                    var _iterator = (0, $5lj6y._)(this.errors), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var _error = _step.value;
                            if (_error instanceof (0, $5lj6y.i)) _error.makePretty();
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                    var _iterator2 = (0, $5lj6y._)(this.warnings), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var warn = _step2.value;
                            if (warn instanceof (0, $5lj6y.i)) warn.makePretty();
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
                return this;
            }
        },
        {
            key: "listNonDefaultTags",
            value: function listNonDefaultTags() {
                return $6178746541c82603$var$listTagNames(this.contents).filter(function(t) {
                    return t.indexOf((0, $2uhik.S).defaultPrefix) !== 0;
                });
            }
        },
        {
            key: "setTagPrefix",
            value: function setTagPrefix(handle, prefix) {
                if (handle[0] !== '!' || handle[handle.length - 1] !== '!') throw new Error('Handle must start and end with !');
                if (prefix) {
                    var prev = this.tagPrefixes.find(function(p) {
                        return p.handle === handle;
                    });
                    if (prev) prev.prefix = prefix;
                    else this.tagPrefixes.push({
                        handle: handle,
                        prefix: prefix
                    });
                } else this.tagPrefixes = this.tagPrefixes.filter(function(p) {
                    return p.handle !== handle;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON$1(arg, onAnchor) {
                var _this = this;
                var _this$options = this.options, keepBlobsInJSON = _this$options.keepBlobsInJSON, mapAsMap = _this$options.mapAsMap, maxAliasCount = _this$options.maxAliasCount;
                var keep = keepBlobsInJSON && (typeof arg !== 'string' || !(this.contents instanceof (0, $lrFig.S)));
                var ctx = {
                    doc: this,
                    indentStep: '  ',
                    keep: keep,
                    mapAsMap: keep && !!mapAsMap,
                    maxAliasCount: maxAliasCount,
                    stringify: $6178746541c82603$var$stringify$1 // Requiring directly in Pair would create circular dependencies
                };
                var anchorNames = Object.keys(this.anchors.map);
                if (anchorNames.length > 0) ctx.anchors = new Map(anchorNames.map(function(name) {
                    return [
                        _this.anchors.map[name],
                        {
                            alias: [],
                            aliasCount: 0,
                            count: 1
                        }
                    ];
                }));
                var res = (0, $lrFig.t)(this.contents, arg, ctx);
                if (typeof onAnchor === 'function' && ctx.anchors) {
                    var _iterator3 = (0, $5lj6y._)(ctx.anchors.values()), _step3;
                    try {
                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                            var _step3$value = _step3.value, count = _step3$value.count, _res = _step3$value.res;
                            onAnchor(_res, count);
                        }
                    } catch (err) {
                        _iterator3.e(err);
                    } finally{
                        _iterator3.f();
                    }
                }
                return res;
            }
        },
        {
            key: "toString",
            value: function toString() {
                if (this.errors.length > 0) throw new Error('Document with errors cannot be stringified');
                var indentSize = this.options.indent;
                if (!Number.isInteger(indentSize) || indentSize <= 0) {
                    var s = JSON.stringify(indentSize);
                    throw new Error("\"indent\" option must be a positive integer, not ".concat(s));
                }
                this.setSchema();
                var lines = [];
                var hasDirectives = false;
                if (this.version) {
                    var vd = '%YAML 1.2';
                    if (this.schema.name === 'yaml-1.1') {
                        if (this.version === '1.0') vd = '%YAML:1.0';
                        else if (this.version === '1.1') vd = '%YAML 1.1';
                    }
                    lines.push(vd);
                    hasDirectives = true;
                }
                var tagNames = this.listNonDefaultTags();
                this.tagPrefixes.forEach(function(_ref) {
                    var handle = _ref.handle, prefix = _ref.prefix;
                    if (tagNames.some(function(t) {
                        return t.indexOf(prefix) === 0;
                    })) {
                        lines.push("%TAG ".concat(handle, " ").concat(prefix));
                        hasDirectives = true;
                    }
                });
                if (hasDirectives || this.directivesEndMarker) lines.push('---');
                if (this.commentBefore) {
                    if (hasDirectives || !this.directivesEndMarker) lines.unshift('');
                    lines.unshift(this.commentBefore.replace(/^/gm, '#'));
                }
                var ctx = {
                    anchors: Object.create(null),
                    doc: this,
                    indent: '',
                    indentStep: ' '.repeat(indentSize),
                    stringify: $6178746541c82603$var$stringify$1 // Requiring directly in nodes would create circular dependencies
                };
                var chompKeep = false;
                var contentComment = null;
                if (this.contents) {
                    if (this.contents instanceof (0, $lrFig.N)) {
                        if (this.contents.spaceBefore && (hasDirectives || this.directivesEndMarker)) lines.push('');
                        if (this.contents.commentBefore) lines.push(this.contents.commentBefore.replace(/^/gm, '#')); // top-level block scalars need to be indented if followed by a comment
                        ctx.forceBlockIndent = !!this.comment;
                        contentComment = this.contents.comment;
                    }
                    var onChompKeep = contentComment ? null : function() {
                        return chompKeep = true;
                    };
                    var body = $6178746541c82603$var$stringify$1(this.contents, ctx, function() {
                        return contentComment = null;
                    }, onChompKeep);
                    lines.push((0, $lrFig.f)(body, '', contentComment));
                } else if (this.contents !== undefined) lines.push($6178746541c82603$var$stringify$1(this.contents, ctx));
                if (this.comment) {
                    if ((!chompKeep || contentComment) && lines[lines.length - 1] !== '') lines.push('');
                    lines.push(this.comment.replace(/^/gm, '#'));
                }
                return lines.join('\n') + '\n';
            }
        }
    ]);
    return Document;
}();
(0, $5lj6y.e)($6178746541c82603$var$Document$1, "defaults", $6178746541c82603$var$documentOptions);
function $6178746541c82603$var$createNode(value) {
    var wrapScalars = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var tag = arguments.length > 2 ? arguments[2] : undefined;
    if (tag === undefined && typeof wrapScalars === 'string') {
        tag = wrapScalars;
        wrapScalars = true;
    }
    var options = Object.assign({}, $6178746541c82603$var$Document$1.defaults[$6178746541c82603$var$defaultOptions.version], $6178746541c82603$var$defaultOptions);
    var schema = new (0, $2uhik.S)(options);
    return schema.createNode(value, wrapScalars, tag);
}
var $6178746541c82603$var$Document = /*#__PURE__*/ function(_YAMLDocument) {
    (0, $5lj6y.j)(Document, _YAMLDocument);
    var _super = (0, $5lj6y.k)(Document);
    function Document(options) {
        (0, $5lj6y.c)(this, Document);
        return _super.call(this, Object.assign({}, $6178746541c82603$var$defaultOptions, options));
    }
    return Document;
}($6178746541c82603$var$Document$1);
function $6178746541c82603$var$parseAllDocuments(src, options) {
    var stream = [];
    var prev;
    var _iterator = (0, $5lj6y._)((0, $4VNom.parse)(src)), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var cstDoc = _step.value;
            var doc = new $6178746541c82603$var$Document(options);
            doc.parse(cstDoc, prev);
            stream.push(doc);
            prev = doc;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return stream;
}
function $6178746541c82603$var$parseDocument(src, options) {
    var cst = (0, $4VNom.parse)(src);
    var doc = new $6178746541c82603$var$Document(options).parse(cst[0]);
    if (cst.length > 1) {
        var errMsg = 'Source contains multiple documents; please use YAML.parseAllDocuments()';
        doc.errors.unshift(new (0, $5lj6y.g)(cst[1], errMsg));
    }
    return doc;
}
function $6178746541c82603$var$parse(src, options) {
    var doc = $6178746541c82603$var$parseDocument(src, options);
    doc.warnings.forEach(function(warning) {
        return (0, $5iO0y.w)(warning);
    });
    if (doc.errors.length > 0) throw doc.errors[0];
    return doc.toJSON();
}
function $6178746541c82603$var$stringify(value, options) {
    var doc = new $6178746541c82603$var$Document(options);
    doc.contents = value;
    return String(doc);
}
var $6178746541c82603$export$866dfa75bd13a786 = {
    createNode: $6178746541c82603$var$createNode,
    defaultOptions: $6178746541c82603$var$defaultOptions,
    Document: $6178746541c82603$var$Document,
    parse: $6178746541c82603$var$parse,
    parseAllDocuments: $6178746541c82603$var$parseAllDocuments,
    parseCST: (0, $4VNom.parse),
    parseDocument: $6178746541c82603$var$parseDocument,
    scalarOptions: $6178746541c82603$var$scalarOptions,
    stringify: $6178746541c82603$var$stringify
};

});
parcelRegister("5lj6y", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $3e3dbbbc6bd98c15$export$407448d2b89b1813; });
$parcel$export(module.exports, "c", function () { return $3e3dbbbc6bd98c15$export$db3b6bfb95261072; });
$parcel$export(module.exports, "b", function () { return $3e3dbbbc6bd98c15$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "e", function () { return $3e3dbbbc6bd98c15$export$f1e1789686576879; });
$parcel$export(module.exports, "j", function () { return $3e3dbbbc6bd98c15$export$35e795649ee09318; });
$parcel$export(module.exports, "m", function () { return $3e3dbbbc6bd98c15$export$953cecd6e717a553; });
$parcel$export(module.exports, "p", function () { return $3e3dbbbc6bd98c15$export$ffb5f4729a158638; });
$parcel$export(module.exports, "r", function () { return $3e3dbbbc6bd98c15$export$43caf9889c228507; });
$parcel$export(module.exports, "k", function () { return $3e3dbbbc6bd98c15$export$342063e11d6c3cad; });
$parcel$export(module.exports, "l", function () { return $3e3dbbbc6bd98c15$export$882b5998b3b9117c; });
$parcel$export(module.exports, "h", function () { return $3e3dbbbc6bd98c15$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "q", function () { return $3e3dbbbc6bd98c15$export$9e5f44173e64f162; });
$parcel$export(module.exports, "_", function () { return $3e3dbbbc6bd98c15$export$71511d61b312f219; });
$parcel$export(module.exports, "C", function () { return $3e3dbbbc6bd98c15$export$e7094788287c5e9b; });
$parcel$export(module.exports, "T", function () { return $3e3dbbbc6bd98c15$export$971d5caa766a69d7; });
$parcel$export(module.exports, "d", function () { return $3e3dbbbc6bd98c15$export$4368d992c4eafac0; });
$parcel$export(module.exports, "n", function () { return $3e3dbbbc6bd98c15$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "R", function () { return $3e3dbbbc6bd98c15$export$db202ddc8be9136; });
$parcel$export(module.exports, "N", function () { return $3e3dbbbc6bd98c15$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "i", function () { return $3e3dbbbc6bd98c15$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "o", function () { return $3e3dbbbc6bd98c15$export$ae1af26003f05816; });
$parcel$export(module.exports, "g", function () { return $3e3dbbbc6bd98c15$export$39b482c5e57630a8; });
$parcel$export(module.exports, "Y", function () { return $3e3dbbbc6bd98c15$export$8743009a87fcb00f; });
$parcel$export(module.exports, "f", function () { return $3e3dbbbc6bd98c15$export$2d1720544b23b823; });
$parcel$export(module.exports, "P", function () { return $3e3dbbbc6bd98c15$export$56c0d5a1e737357d; });
function $3e3dbbbc6bd98c15$export$407448d2b89b1813(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3e3dbbbc6bd98c15$export$407448d2b89b1813 = function(obj) {
        return typeof obj;
    };
    else $3e3dbbbc6bd98c15$export$407448d2b89b1813 = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3e3dbbbc6bd98c15$export$407448d2b89b1813(obj);
}
function $3e3dbbbc6bd98c15$export$db3b6bfb95261072(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3e3dbbbc6bd98c15$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3e3dbbbc6bd98c15$export$8b22cf2602fb60ce(Constructor, protoProps, staticProps) {
    if (protoProps) $3e3dbbbc6bd98c15$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3e3dbbbc6bd98c15$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3e3dbbbc6bd98c15$export$f1e1789686576879(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3e3dbbbc6bd98c15$export$35e795649ee09318(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3e3dbbbc6bd98c15$var$_setPrototypeOf(subClass, superClass);
}
function $3e3dbbbc6bd98c15$export$953cecd6e717a553(o) {
    $3e3dbbbc6bd98c15$export$953cecd6e717a553 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3e3dbbbc6bd98c15$export$953cecd6e717a553(o);
}
function $3e3dbbbc6bd98c15$var$_setPrototypeOf(o, p) {
    $3e3dbbbc6bd98c15$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3e3dbbbc6bd98c15$var$_setPrototypeOf(o, p);
}
function $3e3dbbbc6bd98c15$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3e3dbbbc6bd98c15$var$_construct(Parent, args, Class) {
    if ($3e3dbbbc6bd98c15$var$_isNativeReflectConstruct()) $3e3dbbbc6bd98c15$var$_construct = Reflect.construct;
    else $3e3dbbbc6bd98c15$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $3e3dbbbc6bd98c15$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $3e3dbbbc6bd98c15$var$_construct.apply(null, arguments);
}
function $3e3dbbbc6bd98c15$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $3e3dbbbc6bd98c15$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $3e3dbbbc6bd98c15$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$3e3dbbbc6bd98c15$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $3e3dbbbc6bd98c15$var$_construct(Class, arguments, $3e3dbbbc6bd98c15$export$953cecd6e717a553(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $3e3dbbbc6bd98c15$var$_setPrototypeOf(Wrapper, Class);
    };
    return $3e3dbbbc6bd98c15$var$_wrapNativeSuper(Class);
}
function $3e3dbbbc6bd98c15$export$ffb5f4729a158638(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3e3dbbbc6bd98c15$export$43caf9889c228507(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $3e3dbbbc6bd98c15$export$ffb5f4729a158638(self);
}
function $3e3dbbbc6bd98c15$export$342063e11d6c3cad(Derived) {
    var hasNativeReflectConstruct = $3e3dbbbc6bd98c15$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3e3dbbbc6bd98c15$export$953cecd6e717a553(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3e3dbbbc6bd98c15$export$953cecd6e717a553(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3e3dbbbc6bd98c15$export$43caf9889c228507(this, result);
    };
}
function $3e3dbbbc6bd98c15$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $3e3dbbbc6bd98c15$export$953cecd6e717a553(object);
        if (object === null) break;
    }
    return object;
}
function $3e3dbbbc6bd98c15$export$882b5998b3b9117c(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $3e3dbbbc6bd98c15$export$882b5998b3b9117c = Reflect.get;
    else $3e3dbbbc6bd98c15$export$882b5998b3b9117c = function _get(target, property, receiver) {
        var base = $3e3dbbbc6bd98c15$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $3e3dbbbc6bd98c15$export$882b5998b3b9117c(target, property, receiver || target);
}
function $3e3dbbbc6bd98c15$export$dda1d9f60106f0e9(arr, i) {
    return $3e3dbbbc6bd98c15$var$_arrayWithHoles(arr) || $3e3dbbbc6bd98c15$var$_iterableToArrayLimit(arr, i) || $3e3dbbbc6bd98c15$var$_unsupportedIterableToArray(arr, i) || $3e3dbbbc6bd98c15$var$_nonIterableRest();
}
function $3e3dbbbc6bd98c15$export$9e5f44173e64f162(arr) {
    return $3e3dbbbc6bd98c15$var$_arrayWithHoles(arr) || $3e3dbbbc6bd98c15$var$_iterableToArray(arr) || $3e3dbbbc6bd98c15$var$_unsupportedIterableToArray(arr) || $3e3dbbbc6bd98c15$var$_nonIterableRest();
}
function $3e3dbbbc6bd98c15$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $3e3dbbbc6bd98c15$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $3e3dbbbc6bd98c15$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $3e3dbbbc6bd98c15$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3e3dbbbc6bd98c15$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3e3dbbbc6bd98c15$var$_arrayLikeToArray(o, minLen);
}
function $3e3dbbbc6bd98c15$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $3e3dbbbc6bd98c15$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $3e3dbbbc6bd98c15$export$71511d61b312f219(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $3e3dbbbc6bd98c15$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function() {};
            return {
                s: F,
                n: function() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function(e) {
                    throw e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function() {
            it = o[Symbol.iterator]();
        },
        n: function() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function(e) {
            didErr = true;
            err = e;
        },
        f: function() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
var $3e3dbbbc6bd98c15$export$e7094788287c5e9b = {
    ANCHOR: '&',
    COMMENT: '#',
    TAG: '!',
    DIRECTIVES_END: '-',
    DOCUMENT_END: '.'
};
var $3e3dbbbc6bd98c15$export$971d5caa766a69d7 = {
    ALIAS: 'ALIAS',
    BLANK_LINE: 'BLANK_LINE',
    BLOCK_FOLDED: 'BLOCK_FOLDED',
    BLOCK_LITERAL: 'BLOCK_LITERAL',
    COMMENT: 'COMMENT',
    DIRECTIVE: 'DIRECTIVE',
    DOCUMENT: 'DOCUMENT',
    FLOW_MAP: 'FLOW_MAP',
    FLOW_SEQ: 'FLOW_SEQ',
    MAP: 'MAP',
    MAP_KEY: 'MAP_KEY',
    MAP_VALUE: 'MAP_VALUE',
    PLAIN: 'PLAIN',
    QUOTE_DOUBLE: 'QUOTE_DOUBLE',
    QUOTE_SINGLE: 'QUOTE_SINGLE',
    SEQ: 'SEQ',
    SEQ_ITEM: 'SEQ_ITEM'
};
var $3e3dbbbc6bd98c15$export$4368d992c4eafac0 = 'tag:yaml.org,2002:';
var $3e3dbbbc6bd98c15$export$7ccc53e8f1e7dfc5 = {
    MAP: 'tag:yaml.org,2002:map',
    SEQ: 'tag:yaml.org,2002:seq',
    STR: 'tag:yaml.org,2002:str'
};
function $3e3dbbbc6bd98c15$var$findLineStarts(src) {
    var ls = [
        0
    ];
    var offset = src.indexOf('\n');
    while(offset !== -1){
        offset += 1;
        ls.push(offset);
        offset = src.indexOf('\n', offset);
    }
    return ls;
}
function $3e3dbbbc6bd98c15$var$getSrcInfo(cst) {
    var lineStarts, src;
    if (typeof cst === 'string') {
        lineStarts = $3e3dbbbc6bd98c15$var$findLineStarts(cst);
        src = cst;
    } else {
        if (Array.isArray(cst)) cst = cst[0];
        if (cst && cst.context) {
            if (!cst.lineStarts) cst.lineStarts = $3e3dbbbc6bd98c15$var$findLineStarts(cst.context.src);
            lineStarts = cst.lineStarts;
            src = cst.context.src;
        }
    }
    return {
        lineStarts: lineStarts,
        src: src
    };
}
/**
 * @typedef {Object} LinePos - One-indexed position in the source
 * @property {number} line
 * @property {number} col
 */ /**
 * Determine the line/col position matching a character offset.
 *
 * Accepts a source string or a CST document as the second parameter. With
 * the latter, starting indices for lines are cached in the document as
 * `lineStarts: number[]`.
 *
 * Returns a one-indexed `{ line, col }` location if found, or
 * `undefined` otherwise.
 *
 * @param {number} offset
 * @param {string|Document|Document[]} cst
 * @returns {?LinePos}
 */ function $3e3dbbbc6bd98c15$var$getLinePos(offset, cst) {
    if (typeof offset !== 'number' || offset < 0) return null;
    var _getSrcInfo = $3e3dbbbc6bd98c15$var$getSrcInfo(cst), lineStarts = _getSrcInfo.lineStarts, src = _getSrcInfo.src;
    if (!lineStarts || !src || offset > src.length) return null;
    for(var i = 0; i < lineStarts.length; ++i){
        var start = lineStarts[i];
        if (offset < start) return {
            line: i,
            col: offset - lineStarts[i - 1] + 1
        };
        if (offset === start) return {
            line: i + 1,
            col: 1
        };
    }
    var line = lineStarts.length;
    return {
        line: line,
        col: offset - lineStarts[line - 1] + 1
    };
}
/**
 * Get a specified line from the source.
 *
 * Accepts a source string or a CST document as the second parameter. With
 * the latter, starting indices for lines are cached in the document as
 * `lineStarts: number[]`.
 *
 * Returns the line as a string if found, or `null` otherwise.
 *
 * @param {number} line One-indexed line number
 * @param {string|Document|Document[]} cst
 * @returns {?string}
 */ function $3e3dbbbc6bd98c15$var$getLine(line, cst) {
    var _getSrcInfo2 = $3e3dbbbc6bd98c15$var$getSrcInfo(cst), lineStarts = _getSrcInfo2.lineStarts, src = _getSrcInfo2.src;
    if (!lineStarts || !(line >= 1) || line > lineStarts.length) return null;
    var start = lineStarts[line - 1];
    var end = lineStarts[line]; // undefined for last line; that's ok for slice()
    while(end && end > start && src[end - 1] === '\n')--end;
    return src.slice(start, end);
}
/**
 * Pretty-print the starting line from the source indicated by the range `pos`
 *
 * Trims output to `maxWidth` chars while keeping the starting column visible,
 * using `…` at either end to indicate dropped characters.
 *
 * Returns a two-line string (or `null`) with `\n` as separator; the second line
 * will hold appropriately indented `^` marks indicating the column range.
 *
 * @param {Object} pos
 * @param {LinePos} pos.start
 * @param {LinePos} [pos.end]
 * @param {string|Document|Document[]*} cst
 * @param {number} [maxWidth=80]
 * @returns {?string}
 */ function $3e3dbbbc6bd98c15$var$getPrettyContext(_ref, cst) {
    var start = _ref.start, end = _ref.end;
    var maxWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 80;
    var src = $3e3dbbbc6bd98c15$var$getLine(start.line, cst);
    if (!src) return null;
    var col = start.col;
    if (src.length > maxWidth) {
        if (col <= maxWidth - 10) src = src.substr(0, maxWidth - 1) + "\u2026";
        else {
            var halfWidth = Math.round(maxWidth / 2);
            if (src.length > col + halfWidth) src = src.substr(0, col + halfWidth - 1) + "\u2026";
            col -= src.length - maxWidth;
            src = "\u2026" + src.substr(1 - maxWidth);
        }
    }
    var errLen = 1;
    var errEnd = '';
    if (end) {
        if (end.line === start.line && col + (end.col - start.col) <= maxWidth + 1) errLen = end.col - start.col;
        else {
            errLen = Math.min(src.length + 1, maxWidth) - col;
            errEnd = "\u2026";
        }
    }
    var offset = col > 1 ? ' '.repeat(col - 1) : '';
    var err = '^'.repeat(errLen);
    return "".concat(src, "\n").concat(offset).concat(err).concat(errEnd);
}
var $3e3dbbbc6bd98c15$export$db202ddc8be9136 = /*#__PURE__*/ function() {
    function Range(start, end) {
        $3e3dbbbc6bd98c15$export$db3b6bfb95261072(this, Range);
        this.start = start;
        this.end = end || start;
    }
    $3e3dbbbc6bd98c15$export$8b22cf2602fb60ce(Range, [
        {
            key: "isEmpty",
            value: function isEmpty() {
                return typeof this.start !== 'number' || !this.end || this.end <= this.start;
            }
        },
        {
            key: "setOrigRange",
            value: function setOrigRange(cr, offset) {
                var start = this.start, end = this.end;
                if (cr.length === 0 || end <= cr[0]) {
                    this.origStart = start;
                    this.origEnd = end;
                    return offset;
                }
                var i = offset;
                while(i < cr.length){
                    if (cr[i] > start) break;
                    else ++i;
                }
                this.origStart = start + i;
                var nextOffset = i;
                while(i < cr.length){
                    // if end was at \n, it should now be at \r
                    if (cr[i] >= end) break;
                    else ++i;
                }
                this.origEnd = end + i;
                return nextOffset;
            }
        }
    ], [
        {
            key: "copy",
            value: function copy(orig) {
                return new Range(orig.start, orig.end);
            }
        }
    ]);
    return Range;
}();
/** Root class of all nodes */ var $3e3dbbbc6bd98c15$export$a07804094c3ecf2d = /*#__PURE__*/ function() {
    function Node(type, props, context) {
        $3e3dbbbc6bd98c15$export$db3b6bfb95261072(this, Node);
        Object.defineProperty(this, 'context', {
            value: context || null,
            writable: true
        });
        this.error = null;
        this.range = null;
        this.valueRange = null;
        this.props = props || [];
        this.type = type;
        this.value = null;
    }
    $3e3dbbbc6bd98c15$export$8b22cf2602fb60ce(Node, [
        {
            key: "getPropValue",
            value: function getPropValue(idx, key, skipKey) {
                if (!this.context) return null;
                var src = this.context.src;
                var prop = this.props[idx];
                return prop && src[prop.start] === key ? src.slice(prop.start + (skipKey ? 1 : 0), prop.end) : null;
            }
        },
        {
            key: "anchor",
            get: function get() {
                for(var i = 0; i < this.props.length; ++i){
                    var anchor = this.getPropValue(i, $3e3dbbbc6bd98c15$export$e7094788287c5e9b.ANCHOR, true);
                    if (anchor != null) return anchor;
                }
                return null;
            }
        },
        {
            key: "comment",
            get: function get() {
                var comments = [];
                for(var i = 0; i < this.props.length; ++i){
                    var comment = this.getPropValue(i, $3e3dbbbc6bd98c15$export$e7094788287c5e9b.COMMENT, true);
                    if (comment != null) comments.push(comment);
                }
                return comments.length > 0 ? comments.join('\n') : null;
            }
        },
        {
            key: "commentHasRequiredWhitespace",
            value: function commentHasRequiredWhitespace(start) {
                var src = this.context.src;
                if (this.header && start === this.header.end) return false;
                if (!this.valueRange) return false;
                var end = this.valueRange.end;
                return start !== end || Node.atBlank(src, end - 1);
            }
        },
        {
            key: "hasComment",
            get: function get() {
                if (this.context) {
                    var src = this.context.src;
                    for(var i = 0; i < this.props.length; ++i){
                        if (src[this.props[i].start] === $3e3dbbbc6bd98c15$export$e7094788287c5e9b.COMMENT) return true;
                    }
                }
                return false;
            }
        },
        {
            key: "hasProps",
            get: function get() {
                if (this.context) {
                    var src = this.context.src;
                    for(var i = 0; i < this.props.length; ++i){
                        if (src[this.props[i].start] !== $3e3dbbbc6bd98c15$export$e7094788287c5e9b.COMMENT) return true;
                    }
                }
                return false;
            }
        },
        {
            key: "includesTrailingLines",
            get: function get() {
                return false;
            }
        },
        {
            key: "jsonLike",
            get: function get() {
                var jsonLikeTypes = [
                    $3e3dbbbc6bd98c15$export$971d5caa766a69d7.FLOW_MAP,
                    $3e3dbbbc6bd98c15$export$971d5caa766a69d7.FLOW_SEQ,
                    $3e3dbbbc6bd98c15$export$971d5caa766a69d7.QUOTE_DOUBLE,
                    $3e3dbbbc6bd98c15$export$971d5caa766a69d7.QUOTE_SINGLE
                ];
                return jsonLikeTypes.indexOf(this.type) !== -1;
            }
        },
        {
            key: "rangeAsLinePos",
            get: function get() {
                if (!this.range || !this.context) return undefined;
                var start = $3e3dbbbc6bd98c15$var$getLinePos(this.range.start, this.context.root);
                if (!start) return undefined;
                var end = $3e3dbbbc6bd98c15$var$getLinePos(this.range.end, this.context.root);
                return {
                    start: start,
                    end: end
                };
            }
        },
        {
            key: "rawValue",
            get: function get() {
                if (!this.valueRange || !this.context) return null;
                var _this$valueRange = this.valueRange, start = _this$valueRange.start, end = _this$valueRange.end;
                return this.context.src.slice(start, end);
            }
        },
        {
            key: "tag",
            get: function get() {
                for(var i = 0; i < this.props.length; ++i){
                    var tag = this.getPropValue(i, $3e3dbbbc6bd98c15$export$e7094788287c5e9b.TAG, false);
                    if (tag != null) {
                        if (tag[1] === '<') return {
                            verbatim: tag.slice(2, -1)
                        };
                        else {
                            // eslint-disable-next-line no-unused-vars
                            var _tag$match = tag.match(/^(.*!)([^!]*)$/), _tag$match2 = $3e3dbbbc6bd98c15$export$dda1d9f60106f0e9(_tag$match, 3);
                            _tag$match2[0];
                            var handle = _tag$match2[1], suffix = _tag$match2[2];
                            return {
                                handle: handle,
                                suffix: suffix
                            };
                        }
                    }
                }
                return null;
            }
        },
        {
            key: "valueRangeContainsNewline",
            get: function get() {
                if (!this.valueRange || !this.context) return false;
                var _this$valueRange2 = this.valueRange, start = _this$valueRange2.start, end = _this$valueRange2.end;
                var src = this.context.src;
                for(var i = start; i < end; ++i){
                    if (src[i] === '\n') return true;
                }
                return false;
            }
        },
        {
            key: "parseComment",
            value: function parseComment(start) {
                var src = this.context.src;
                if (src[start] === $3e3dbbbc6bd98c15$export$e7094788287c5e9b.COMMENT) {
                    var end = Node.endOfLine(src, start + 1);
                    var commentRange = new $3e3dbbbc6bd98c15$export$db202ddc8be9136(start, end);
                    this.props.push(commentRange);
                    return end;
                }
                return start;
            }
        },
        {
            key: "setOrigRanges",
            value: function setOrigRanges(cr, offset) {
                if (this.range) offset = this.range.setOrigRange(cr, offset);
                if (this.valueRange) this.valueRange.setOrigRange(cr, offset);
                this.props.forEach(function(prop) {
                    return prop.setOrigRange(cr, offset);
                });
                return offset;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var src = this.context.src, range = this.range, value = this.value;
                if (value != null) return value;
                var str = src.slice(range.start, range.end);
                return Node.addStringTerminator(src, range.end, str);
            }
        }
    ], [
        {
            key: "addStringTerminator",
            value: function addStringTerminator(src, offset, str) {
                if (str[str.length - 1] === '\n') return str;
                var next = Node.endOfWhiteSpace(src, offset);
                return next >= src.length || src[next] === '\n' ? str + '\n' : str;
            } // ^(---|...)
        },
        {
            key: "atDocumentBoundary",
            value: function atDocumentBoundary(src, offset, sep) {
                var ch0 = src[offset];
                if (!ch0) return true;
                var prev = src[offset - 1];
                if (prev && prev !== '\n') return false;
                if (sep) {
                    if (ch0 !== sep) return false;
                } else {
                    if (ch0 !== $3e3dbbbc6bd98c15$export$e7094788287c5e9b.DIRECTIVES_END && ch0 !== $3e3dbbbc6bd98c15$export$e7094788287c5e9b.DOCUMENT_END) return false;
                }
                var ch1 = src[offset + 1];
                var ch2 = src[offset + 2];
                if (ch1 !== ch0 || ch2 !== ch0) return false;
                var ch3 = src[offset + 3];
                return !ch3 || ch3 === '\n' || ch3 === '\t' || ch3 === ' ';
            }
        },
        {
            key: "endOfIdentifier",
            value: function endOfIdentifier(src, offset) {
                var ch = src[offset];
                var isVerbatim = ch === '<';
                var notOk = isVerbatim ? [
                    '\n',
                    '\t',
                    ' ',
                    '>'
                ] : [
                    '\n',
                    '\t',
                    ' ',
                    '[',
                    ']',
                    '{',
                    '}',
                    ','
                ];
                while(ch && notOk.indexOf(ch) === -1)ch = src[offset += 1];
                if (isVerbatim && ch === '>') offset += 1;
                return offset;
            }
        },
        {
            key: "endOfIndent",
            value: function endOfIndent(src, offset) {
                var ch = src[offset];
                while(ch === ' ')ch = src[offset += 1];
                return offset;
            }
        },
        {
            key: "endOfLine",
            value: function endOfLine(src, offset) {
                var ch = src[offset];
                while(ch && ch !== '\n')ch = src[offset += 1];
                return offset;
            }
        },
        {
            key: "endOfWhiteSpace",
            value: function endOfWhiteSpace(src, offset) {
                var ch = src[offset];
                while(ch === '\t' || ch === ' ')ch = src[offset += 1];
                return offset;
            }
        },
        {
            key: "startOfLine",
            value: function startOfLine(src, offset) {
                var ch = src[offset - 1];
                if (ch === '\n') return offset;
                while(ch && ch !== '\n')ch = src[offset -= 1];
                return offset + 1;
            }
        },
        {
            key: "endOfBlockIndent",
            value: function endOfBlockIndent(src, indent, lineStart) {
                var inEnd = Node.endOfIndent(src, lineStart);
                if (inEnd > lineStart + indent) return inEnd;
                else {
                    var wsEnd = Node.endOfWhiteSpace(src, inEnd);
                    var ch = src[wsEnd];
                    if (!ch || ch === '\n') return wsEnd;
                }
                return null;
            }
        },
        {
            key: "atBlank",
            value: function atBlank(src, offset, endAsBlank) {
                var ch = src[offset];
                return ch === '\n' || ch === '\t' || ch === ' ' || endAsBlank && !ch;
            }
        },
        {
            key: "nextNodeIsIndented",
            value: function nextNodeIsIndented(ch, indentDiff, indicatorAsIndent) {
                if (!ch || indentDiff < 0) return false;
                if (indentDiff > 0) return true;
                return indicatorAsIndent && ch === '-';
            } // should be at line or string end, or at next non-whitespace char
        },
        {
            key: "normalizeOffset",
            value: function normalizeOffset(src, offset) {
                var ch = src[offset];
                return !ch ? offset : ch !== '\n' && src[offset - 1] === '\n' ? offset - 1 : Node.endOfWhiteSpace(src, offset);
            } // fold single newline into space, multiple newlines to N - 1 newlines
        },
        {
            key: "foldNewline",
            value: function foldNewline(src, offset, indent) {
                var inCount = 0;
                var error = false;
                var fold = '';
                var ch = src[offset + 1];
                while(ch === ' ' || ch === '\t' || ch === '\n'){
                    switch(ch){
                        case '\n':
                            inCount = 0;
                            offset += 1;
                            fold += '\n';
                            break;
                        case '\t':
                            if (inCount <= indent) error = true;
                            offset = Node.endOfWhiteSpace(src, offset + 2) - 1;
                            break;
                        case ' ':
                            inCount += 1;
                            offset += 1;
                            break;
                    }
                    ch = src[offset + 1];
                }
                if (!fold) fold = ' ';
                if (ch && inCount <= indent) error = true;
                return {
                    fold: fold,
                    offset: offset,
                    error: error
                };
            }
        }
    ]);
    return Node;
}();
var $3e3dbbbc6bd98c15$export$23f2a1d2818174ef = /*#__PURE__*/ function(_Error) {
    $3e3dbbbc6bd98c15$export$35e795649ee09318(YAMLError, _Error);
    var _super = $3e3dbbbc6bd98c15$export$342063e11d6c3cad(YAMLError);
    function YAMLError(name, source, message) {
        var _this;
        $3e3dbbbc6bd98c15$export$db3b6bfb95261072(this, YAMLError);
        if (!message || !(source instanceof $3e3dbbbc6bd98c15$export$a07804094c3ecf2d)) throw new Error("Invalid arguments for new ".concat(name));
        _this = _super.call(this);
        _this.name = name;
        _this.message = message;
        _this.source = source;
        return _this;
    }
    $3e3dbbbc6bd98c15$export$8b22cf2602fb60ce(YAMLError, [
        {
            key: "makePretty",
            value: function makePretty() {
                if (!this.source) return;
                this.nodeType = this.source.type;
                var cst = this.source.context && this.source.context.root;
                if (typeof this.offset === 'number') {
                    this.range = new $3e3dbbbc6bd98c15$export$db202ddc8be9136(this.offset, this.offset + 1);
                    var start = cst && $3e3dbbbc6bd98c15$var$getLinePos(this.offset, cst);
                    if (start) {
                        var end = {
                            line: start.line,
                            col: start.col + 1
                        };
                        this.linePos = {
                            start: start,
                            end: end
                        };
                    }
                    delete this.offset;
                } else {
                    this.range = this.source.range;
                    this.linePos = this.source.rangeAsLinePos;
                }
                if (this.linePos) {
                    var _this$linePos$start = this.linePos.start, line = _this$linePos$start.line, col = _this$linePos$start.col;
                    this.message += " at line ".concat(line, ", column ").concat(col);
                    var ctx = cst && $3e3dbbbc6bd98c15$var$getPrettyContext(this.linePos, cst);
                    if (ctx) this.message += ":\n\n".concat(ctx, "\n");
                }
                delete this.source;
            }
        }
    ]);
    return YAMLError;
}(/*#__PURE__*/ $3e3dbbbc6bd98c15$var$_wrapNativeSuper(Error));
var $3e3dbbbc6bd98c15$export$ae1af26003f05816 = /*#__PURE__*/ function(_YAMLError) {
    $3e3dbbbc6bd98c15$export$35e795649ee09318(YAMLReferenceError, _YAMLError);
    var _super2 = $3e3dbbbc6bd98c15$export$342063e11d6c3cad(YAMLReferenceError);
    function YAMLReferenceError(source, message) {
        $3e3dbbbc6bd98c15$export$db3b6bfb95261072(this, YAMLReferenceError);
        return _super2.call(this, 'YAMLReferenceError', source, message);
    }
    return YAMLReferenceError;
}($3e3dbbbc6bd98c15$export$23f2a1d2818174ef);
var $3e3dbbbc6bd98c15$export$39b482c5e57630a8 = /*#__PURE__*/ function(_YAMLError2) {
    $3e3dbbbc6bd98c15$export$35e795649ee09318(YAMLSemanticError, _YAMLError2);
    var _super3 = $3e3dbbbc6bd98c15$export$342063e11d6c3cad(YAMLSemanticError);
    function YAMLSemanticError(source, message) {
        $3e3dbbbc6bd98c15$export$db3b6bfb95261072(this, YAMLSemanticError);
        return _super3.call(this, 'YAMLSemanticError', source, message);
    }
    return YAMLSemanticError;
}($3e3dbbbc6bd98c15$export$23f2a1d2818174ef);
var $3e3dbbbc6bd98c15$export$8743009a87fcb00f = /*#__PURE__*/ function(_YAMLError3) {
    $3e3dbbbc6bd98c15$export$35e795649ee09318(YAMLSyntaxError, _YAMLError3);
    var _super4 = $3e3dbbbc6bd98c15$export$342063e11d6c3cad(YAMLSyntaxError);
    function YAMLSyntaxError(source, message) {
        $3e3dbbbc6bd98c15$export$db3b6bfb95261072(this, YAMLSyntaxError);
        return _super4.call(this, 'YAMLSyntaxError', source, message);
    }
    return YAMLSyntaxError;
}($3e3dbbbc6bd98c15$export$23f2a1d2818174ef);
var $3e3dbbbc6bd98c15$export$2d1720544b23b823 = /*#__PURE__*/ function(_YAMLError4) {
    $3e3dbbbc6bd98c15$export$35e795649ee09318(YAMLWarning, _YAMLError4);
    var _super5 = $3e3dbbbc6bd98c15$export$342063e11d6c3cad(YAMLWarning);
    function YAMLWarning(source, message) {
        $3e3dbbbc6bd98c15$export$db3b6bfb95261072(this, YAMLWarning);
        return _super5.call(this, 'YAMLWarning', source, message);
    }
    return YAMLWarning;
}($3e3dbbbc6bd98c15$export$23f2a1d2818174ef);
var $3e3dbbbc6bd98c15$export$56c0d5a1e737357d = /*#__PURE__*/ function(_Node) {
    $3e3dbbbc6bd98c15$export$35e795649ee09318(PlainValue, _Node);
    var _super = $3e3dbbbc6bd98c15$export$342063e11d6c3cad(PlainValue);
    function PlainValue() {
        $3e3dbbbc6bd98c15$export$db3b6bfb95261072(this, PlainValue);
        return _super.apply(this, arguments);
    }
    $3e3dbbbc6bd98c15$export$8b22cf2602fb60ce(PlainValue, [
        {
            key: "strValue",
            get: function get() {
                if (!this.valueRange || !this.context) return null;
                var _this$valueRange = this.valueRange, start = _this$valueRange.start, end = _this$valueRange.end;
                var src = this.context.src;
                var ch = src[end - 1];
                while(start < end && (ch === '\n' || ch === '\t' || ch === ' '))ch = src[--end - 1];
                var str = '';
                for(var i = start; i < end; ++i){
                    var _ch = src[i];
                    if (_ch === '\n') {
                        var _Node$foldNewline = $3e3dbbbc6bd98c15$export$a07804094c3ecf2d.foldNewline(src, i, -1), fold = _Node$foldNewline.fold, offset = _Node$foldNewline.offset;
                        str += fold;
                        i = offset;
                    } else if (_ch === ' ' || _ch === '\t') {
                        // trim trailing whitespace
                        var wsStart = i;
                        var next = src[i + 1];
                        while(i < end && (next === ' ' || next === '\t')){
                            i += 1;
                            next = src[i + 1];
                        }
                        if (next !== '\n') str += i > wsStart ? src.slice(wsStart, i + 1) : _ch;
                    } else str += _ch;
                }
                var ch0 = src[start];
                switch(ch0){
                    case '\t':
                        var msg = 'Plain value cannot start with a tab character';
                        var errors = [
                            new $3e3dbbbc6bd98c15$export$39b482c5e57630a8(this, msg)
                        ];
                        return {
                            errors: errors,
                            str: str
                        };
                    case '@':
                    case '`':
                        var _msg = "Plain value cannot start with reserved character ".concat(ch0);
                        var _errors = [
                            new $3e3dbbbc6bd98c15$export$39b482c5e57630a8(this, _msg)
                        ];
                        return {
                            errors: _errors,
                            str: str
                        };
                    default:
                        return str;
                }
            }
        },
        {
            key: "parseBlockValue",
            value: function parseBlockValue(start) {
                var _this$context = this.context, indent = _this$context.indent, inFlow = _this$context.inFlow, src = _this$context.src;
                var offset = start;
                var valueEnd = start;
                for(var ch = src[offset]; ch === '\n'; ch = src[offset]){
                    if ($3e3dbbbc6bd98c15$export$a07804094c3ecf2d.atDocumentBoundary(src, offset + 1)) break;
                    var end = $3e3dbbbc6bd98c15$export$a07804094c3ecf2d.endOfBlockIndent(src, indent, offset + 1);
                    if (end === null || src[end] === '#') break;
                    if (src[end] === '\n') offset = end;
                    else {
                        valueEnd = PlainValue.endOfLine(src, end, inFlow);
                        offset = valueEnd;
                    }
                }
                if (this.valueRange.isEmpty()) this.valueRange.start = start;
                this.valueRange.end = valueEnd;
                return valueEnd;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var inFlow = context.inFlow, src = context.src;
                var offset = start;
                var ch = src[offset];
                if (ch && ch !== '#' && ch !== '\n') offset = PlainValue.endOfLine(src, start, inFlow);
                this.valueRange = new $3e3dbbbc6bd98c15$export$db202ddc8be9136(start, offset);
                offset = $3e3dbbbc6bd98c15$export$a07804094c3ecf2d.endOfWhiteSpace(src, offset);
                offset = this.parseComment(offset);
                if (!this.hasComment || this.valueRange.isEmpty()) offset = this.parseBlockValue(offset);
                return offset;
            }
        }
    ], [
        {
            key: "endOfLine",
            value: function endOfLine(src, start, inFlow) {
                var ch = src[start];
                var offset = start;
                while(ch && ch !== '\n'){
                    if (inFlow && (ch === '[' || ch === ']' || ch === '{' || ch === '}' || ch === ',')) break;
                    var next = src[offset + 1];
                    if (ch === ':' && (!next || next === '\n' || next === '\t' || next === ' ' || inFlow && next === ',')) break;
                    if ((ch === ' ' || ch === '\t') && next === '#') break;
                    offset += 1;
                    ch = next;
                }
                return offset;
            }
        }
    ]);
    return PlainValue;
}($3e3dbbbc6bd98c15$export$a07804094c3ecf2d);

});

parcelRegister("4VNom", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $3972cc857ca762c6$export$98e6a39c04603d36; });

var $5lj6y = parcelRequire("5lj6y");
var $3972cc857ca762c6$var$BlankLine = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(BlankLine, _Node);
    var _super = (0, $5lj6y.k)(BlankLine);
    function BlankLine() {
        (0, $5lj6y.c)(this, BlankLine);
        return _super.call(this, (0, $5lj6y.T).BLANK_LINE);
    }
    /* istanbul ignore next */ (0, $5lj6y.b)(BlankLine, [
        {
            key: "includesTrailingLines",
            get: function get() {
                // This is never called from anywhere, but if it were,
                // this is the value it should return.
                return true;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                this.range = new (0, $5lj6y.R)(start, start + 1);
                return start + 1;
            }
        }
    ]);
    return BlankLine;
}((0, $5lj6y.N));
var $3972cc857ca762c6$var$CollectionItem = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(CollectionItem, _Node);
    var _super = (0, $5lj6y.k)(CollectionItem);
    function CollectionItem(type, props) {
        var _this;
        (0, $5lj6y.c)(this, CollectionItem);
        _this = _super.call(this, type, props);
        _this.node = null;
        return _this;
    }
    (0, $5lj6y.b)(CollectionItem, [
        {
            key: "includesTrailingLines",
            get: function get() {
                return !!this.node && this.node.includesTrailingLines;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var parseNode = context.parseNode, src = context.src;
                var atLineStart = context.atLineStart, lineStart = context.lineStart;
                if (!atLineStart && this.type === (0, $5lj6y.T).SEQ_ITEM) this.error = new (0, $5lj6y.g)(this, 'Sequence items must not have preceding content on the same line');
                var indent = atLineStart ? start - lineStart : context.indent;
                var offset = (0, $5lj6y.N).endOfWhiteSpace(src, start + 1);
                var ch = src[offset];
                var inlineComment = ch === '#';
                var comments = [];
                var blankLine = null;
                while(ch === '\n' || ch === '#'){
                    if (ch === '#') {
                        var _end = (0, $5lj6y.N).endOfLine(src, offset + 1);
                        comments.push(new (0, $5lj6y.R)(offset, _end));
                        offset = _end;
                    } else {
                        atLineStart = true;
                        lineStart = offset + 1;
                        var wsEnd = (0, $5lj6y.N).endOfWhiteSpace(src, lineStart);
                        if (src[wsEnd] === '\n' && comments.length === 0) {
                            blankLine = new $3972cc857ca762c6$var$BlankLine();
                            lineStart = blankLine.parse({
                                src: src
                            }, lineStart);
                        }
                        offset = (0, $5lj6y.N).endOfIndent(src, lineStart);
                    }
                    ch = src[offset];
                }
                if ((0, $5lj6y.N).nextNodeIsIndented(ch, offset - (lineStart + indent), this.type !== (0, $5lj6y.T).SEQ_ITEM)) this.node = parseNode({
                    atLineStart: atLineStart,
                    inCollection: false,
                    indent: indent,
                    lineStart: lineStart,
                    parent: this
                }, offset);
                else if (ch && lineStart > start + 1) offset = lineStart - 1;
                if (this.node) {
                    if (blankLine) {
                        // Only blank lines preceding non-empty nodes are captured. Note that
                        // this means that collection item range start indices do not always
                        // increase monotonically. -- eemeli/yaml#126
                        var items = context.parent.items || context.parent.contents;
                        if (items) items.push(blankLine);
                    }
                    if (comments.length) Array.prototype.push.apply(this.props, comments);
                    offset = this.node.range.end;
                } else if (inlineComment) {
                    var c = comments[0];
                    this.props.push(c);
                    offset = c.end;
                } else offset = (0, $5lj6y.N).endOfLine(src, start + 1);
                var end = this.node ? this.node.valueRange.end : offset;
                this.valueRange = new (0, $5lj6y.R)(start, end);
                return offset;
            }
        },
        {
            key: "setOrigRanges",
            value: function setOrigRanges(cr, offset) {
                offset = (0, $5lj6y.l)((0, $5lj6y.m)(CollectionItem.prototype), "setOrigRanges", this).call(this, cr, offset);
                return this.node ? this.node.setOrigRanges(cr, offset) : offset;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var src = this.context.src, node = this.node, range = this.range, value = this.value;
                if (value != null) return value;
                var str = node ? src.slice(range.start, node.range.start) + String(node) : src.slice(range.start, range.end);
                return (0, $5lj6y.N).addStringTerminator(src, range.end, str);
            }
        }
    ]);
    return CollectionItem;
}((0, $5lj6y.N));
var $3972cc857ca762c6$var$Comment = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(Comment, _Node);
    var _super = (0, $5lj6y.k)(Comment);
    function Comment() {
        (0, $5lj6y.c)(this, Comment);
        return _super.call(this, (0, $5lj6y.T).COMMENT);
    }
    /**
   * Parses a comment line from the source
   *
   * @param {ParseContext} context
   * @param {number} start - Index of first character
   * @returns {number} - Index of the character after this scalar
   */ (0, $5lj6y.b)(Comment, [
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var offset = this.parseComment(start);
                this.range = new (0, $5lj6y.R)(start, offset);
                return offset;
            }
        }
    ]);
    return Comment;
}((0, $5lj6y.N));
function $3972cc857ca762c6$var$grabCollectionEndComments(node) {
    var cnode = node;
    while(cnode instanceof $3972cc857ca762c6$var$CollectionItem)cnode = cnode.node;
    if (!(cnode instanceof $3972cc857ca762c6$var$Collection)) return null;
    var len = cnode.items.length;
    var ci = -1;
    for(var i = len - 1; i >= 0; --i){
        var n = cnode.items[i];
        if (n.type === (0, $5lj6y.T).COMMENT) {
            // Keep sufficiently indented comments with preceding node
            var _n$context = n.context, indent = _n$context.indent, lineStart = _n$context.lineStart;
            if (indent > 0 && n.range.start >= lineStart + indent) break;
            ci = i;
        } else if (n.type === (0, $5lj6y.T).BLANK_LINE) ci = i;
        else break;
    }
    if (ci === -1) return null;
    var ca = cnode.items.splice(ci, len - ci);
    var prevEnd = ca[0].range.start;
    while(true){
        cnode.range.end = prevEnd;
        if (cnode.valueRange && cnode.valueRange.end > prevEnd) cnode.valueRange.end = prevEnd;
        if (cnode === node) break;
        cnode = cnode.context.parent;
    }
    return ca;
}
var $3972cc857ca762c6$var$Collection = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(Collection, _Node);
    var _super = (0, $5lj6y.k)(Collection);
    function Collection(firstItem) {
        var _this;
        (0, $5lj6y.c)(this, Collection);
        _this = _super.call(this, firstItem.type === (0, $5lj6y.T).SEQ_ITEM ? (0, $5lj6y.T).SEQ : (0, $5lj6y.T).MAP);
        for(var i = firstItem.props.length - 1; i >= 0; --i)if (firstItem.props[i].start < firstItem.context.lineStart) {
            // props on previous line are assumed by the collection
            _this.props = firstItem.props.slice(0, i + 1);
            firstItem.props = firstItem.props.slice(i + 1);
            var itemRange = firstItem.props[0] || firstItem.valueRange;
            firstItem.range.start = itemRange.start;
            break;
        }
        _this.items = [
            firstItem
        ];
        var ec = $3972cc857ca762c6$var$grabCollectionEndComments(firstItem);
        if (ec) Array.prototype.push.apply(_this.items, ec);
        return _this;
    }
    (0, $5lj6y.b)(Collection, [
        {
            key: "includesTrailingLines",
            get: function get() {
                return this.items.length > 0;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var parseNode = context.parseNode, src = context.src; // It's easier to recalculate lineStart here rather than tracking down the
                // last context from which to read it -- eemeli/yaml#2
                var lineStart = (0, $5lj6y.N).startOfLine(src, start);
                var firstItem = this.items[0]; // First-item context needs to be correct for later comment handling
                // -- eemeli/yaml#17
                firstItem.context.parent = this;
                this.valueRange = (0, $5lj6y.R).copy(firstItem.valueRange);
                var indent = firstItem.range.start - firstItem.context.lineStart;
                var offset = start;
                offset = (0, $5lj6y.N).normalizeOffset(src, offset);
                var ch = src[offset];
                var atLineStart = (0, $5lj6y.N).endOfWhiteSpace(src, lineStart) === offset;
                var prevIncludesTrailingLines = false;
                while(ch){
                    while(ch === '\n' || ch === '#'){
                        if (atLineStart && ch === '\n' && !prevIncludesTrailingLines) {
                            var blankLine = new $3972cc857ca762c6$var$BlankLine();
                            offset = blankLine.parse({
                                src: src
                            }, offset);
                            this.valueRange.end = offset;
                            if (offset >= src.length) {
                                ch = null;
                                break;
                            }
                            this.items.push(blankLine);
                            offset -= 1; // blankLine.parse() consumes terminal newline
                        } else if (ch === '#') {
                            if (offset < lineStart + indent && !Collection.nextContentHasIndent(src, offset, indent)) return offset;
                            var comment = new $3972cc857ca762c6$var$Comment();
                            offset = comment.parse({
                                indent: indent,
                                lineStart: lineStart,
                                src: src
                            }, offset);
                            this.items.push(comment);
                            this.valueRange.end = offset;
                            if (offset >= src.length) {
                                ch = null;
                                break;
                            }
                        }
                        lineStart = offset + 1;
                        offset = (0, $5lj6y.N).endOfIndent(src, lineStart);
                        if ((0, $5lj6y.N).atBlank(src, offset)) {
                            var wsEnd = (0, $5lj6y.N).endOfWhiteSpace(src, offset);
                            var next = src[wsEnd];
                            if (!next || next === '\n' || next === '#') offset = wsEnd;
                        }
                        ch = src[offset];
                        atLineStart = true;
                    }
                    if (!ch) break;
                    if (offset !== lineStart + indent && (atLineStart || ch !== ':')) {
                        if (offset < lineStart + indent) {
                            if (lineStart > start) offset = lineStart;
                            break;
                        } else if (!this.error) {
                            var msg = 'All collection items must start at the same column';
                            this.error = new (0, $5lj6y.Y)(this, msg);
                        }
                    }
                    if (firstItem.type === (0, $5lj6y.T).SEQ_ITEM) {
                        if (ch !== '-') {
                            if (lineStart > start) offset = lineStart;
                            break;
                        }
                    } else if (ch === '-' && !this.error) {
                        // map key may start with -, as long as it's followed by a non-whitespace char
                        var _next = src[offset + 1];
                        if (!_next || _next === '\n' || _next === '\t' || _next === ' ') {
                            var _msg = 'A collection cannot be both a mapping and a sequence';
                            this.error = new (0, $5lj6y.Y)(this, _msg);
                        }
                    }
                    var node = parseNode({
                        atLineStart: atLineStart,
                        inCollection: true,
                        indent: indent,
                        lineStart: lineStart,
                        parent: this
                    }, offset);
                    if (!node) return offset; // at next document start
                    this.items.push(node);
                    this.valueRange.end = node.valueRange.end;
                    offset = (0, $5lj6y.N).normalizeOffset(src, node.range.end);
                    ch = src[offset];
                    atLineStart = false;
                    prevIncludesTrailingLines = node.includesTrailingLines; // Need to reset lineStart and atLineStart here if preceding node's range
                    // has advanced to check the current line's indentation level
                    // -- eemeli/yaml#10 & eemeli/yaml#38
                    if (ch) {
                        var ls = offset - 1;
                        var prev = src[ls];
                        while(prev === ' ' || prev === '\t')prev = src[--ls];
                        if (prev === '\n') {
                            lineStart = ls + 1;
                            atLineStart = true;
                        }
                    }
                    var ec = $3972cc857ca762c6$var$grabCollectionEndComments(node);
                    if (ec) Array.prototype.push.apply(this.items, ec);
                }
                return offset;
            }
        },
        {
            key: "setOrigRanges",
            value: function setOrigRanges(cr, offset) {
                offset = (0, $5lj6y.l)((0, $5lj6y.m)(Collection.prototype), "setOrigRanges", this).call(this, cr, offset);
                this.items.forEach(function(node) {
                    offset = node.setOrigRanges(cr, offset);
                });
                return offset;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var src = this.context.src, items = this.items, range = this.range, value = this.value;
                if (value != null) return value;
                var str = src.slice(range.start, items[0].range.start) + String(items[0]);
                for(var i = 1; i < items.length; ++i){
                    var item = items[i];
                    var _item$context = item.context, atLineStart = _item$context.atLineStart, indent = _item$context.indent;
                    if (atLineStart) for(var _i = 0; _i < indent; ++_i)str += ' ';
                    str += String(item);
                }
                return (0, $5lj6y.N).addStringTerminator(src, range.end, str);
            }
        }
    ], [
        {
            key: "nextContentHasIndent",
            value: function nextContentHasIndent(src, offset, indent) {
                var lineStart = (0, $5lj6y.N).endOfLine(src, offset) + 1;
                offset = (0, $5lj6y.N).endOfWhiteSpace(src, lineStart);
                var ch = src[offset];
                if (!ch) return false;
                if (offset >= lineStart + indent) return true;
                if (ch !== '#' && ch !== '\n') return false;
                return Collection.nextContentHasIndent(src, offset, indent);
            }
        }
    ]);
    return Collection;
}((0, $5lj6y.N));
var $3972cc857ca762c6$var$Directive = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(Directive, _Node);
    var _super = (0, $5lj6y.k)(Directive);
    function Directive() {
        var _this;
        (0, $5lj6y.c)(this, Directive);
        _this = _super.call(this, (0, $5lj6y.T).DIRECTIVE);
        _this.name = null;
        return _this;
    }
    (0, $5lj6y.b)(Directive, [
        {
            key: "parameters",
            get: function get() {
                var raw = this.rawValue;
                return raw ? raw.trim().split(/[ \t]+/) : [];
            }
        },
        {
            key: "parseName",
            value: function parseName(start) {
                var src = this.context.src;
                var offset = start;
                var ch = src[offset];
                while(ch && ch !== '\n' && ch !== '\t' && ch !== ' ')ch = src[offset += 1];
                this.name = src.slice(start, offset);
                return offset;
            }
        },
        {
            key: "parseParameters",
            value: function parseParameters(start) {
                var src = this.context.src;
                var offset = start;
                var ch = src[offset];
                while(ch && ch !== '\n' && ch !== '#')ch = src[offset += 1];
                this.valueRange = new (0, $5lj6y.R)(start, offset);
                return offset;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var offset = this.parseName(start + 1);
                offset = this.parseParameters(offset);
                offset = this.parseComment(offset);
                this.range = new (0, $5lj6y.R)(start, offset);
                return offset;
            }
        }
    ]);
    return Directive;
}((0, $5lj6y.N));
var $3972cc857ca762c6$var$Document = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(Document, _Node);
    var _super = (0, $5lj6y.k)(Document);
    function Document() {
        var _this;
        (0, $5lj6y.c)(this, Document);
        _this = _super.call(this, (0, $5lj6y.T).DOCUMENT);
        _this.directives = null;
        _this.contents = null;
        _this.directivesEndMarker = null;
        _this.documentEndMarker = null;
        return _this;
    }
    (0, $5lj6y.b)(Document, [
        {
            key: "parseDirectives",
            value: function parseDirectives(start) {
                var src = this.context.src;
                this.directives = [];
                var atLineStart = true;
                var hasDirectives = false;
                var offset = start;
                while(!(0, $5lj6y.N).atDocumentBoundary(src, offset, (0, $5lj6y.C).DIRECTIVES_END)){
                    offset = Document.startCommentOrEndBlankLine(src, offset);
                    switch(src[offset]){
                        case '\n':
                            if (atLineStart) {
                                var blankLine = new $3972cc857ca762c6$var$BlankLine();
                                offset = blankLine.parse({
                                    src: src
                                }, offset);
                                if (offset < src.length) this.directives.push(blankLine);
                            } else {
                                offset += 1;
                                atLineStart = true;
                            }
                            break;
                        case '#':
                            var comment = new $3972cc857ca762c6$var$Comment();
                            offset = comment.parse({
                                src: src
                            }, offset);
                            this.directives.push(comment);
                            atLineStart = false;
                            break;
                        case '%':
                            var directive = new $3972cc857ca762c6$var$Directive();
                            offset = directive.parse({
                                parent: this,
                                src: src
                            }, offset);
                            this.directives.push(directive);
                            hasDirectives = true;
                            atLineStart = false;
                            break;
                        default:
                            if (hasDirectives) this.error = new (0, $5lj6y.g)(this, 'Missing directives-end indicator line');
                            else if (this.directives.length > 0) {
                                this.contents = this.directives;
                                this.directives = [];
                            }
                            return offset;
                    }
                }
                if (src[offset]) {
                    this.directivesEndMarker = new (0, $5lj6y.R)(offset, offset + 3);
                    return offset + 3;
                }
                if (hasDirectives) this.error = new (0, $5lj6y.g)(this, 'Missing directives-end indicator line');
                else if (this.directives.length > 0) {
                    this.contents = this.directives;
                    this.directives = [];
                }
                return offset;
            }
        },
        {
            key: "parseContents",
            value: function parseContents(start) {
                var _this$context = this.context, parseNode = _this$context.parseNode, src = _this$context.src;
                if (!this.contents) this.contents = [];
                var lineStart = start;
                while(src[lineStart - 1] === '-')lineStart -= 1;
                var offset = (0, $5lj6y.N).endOfWhiteSpace(src, start);
                var atLineStart = lineStart === start;
                this.valueRange = new (0, $5lj6y.R)(offset);
                while(!(0, $5lj6y.N).atDocumentBoundary(src, offset, (0, $5lj6y.C).DOCUMENT_END)){
                    switch(src[offset]){
                        case '\n':
                            if (atLineStart) {
                                var blankLine = new $3972cc857ca762c6$var$BlankLine();
                                offset = blankLine.parse({
                                    src: src
                                }, offset);
                                if (offset < src.length) this.contents.push(blankLine);
                            } else {
                                offset += 1;
                                atLineStart = true;
                            }
                            lineStart = offset;
                            break;
                        case '#':
                            var comment = new $3972cc857ca762c6$var$Comment();
                            offset = comment.parse({
                                src: src
                            }, offset);
                            this.contents.push(comment);
                            atLineStart = false;
                            break;
                        default:
                            var iEnd = (0, $5lj6y.N).endOfIndent(src, offset);
                            var context = {
                                atLineStart: atLineStart,
                                indent: -1,
                                inFlow: false,
                                inCollection: false,
                                lineStart: lineStart,
                                parent: this
                            };
                            var node = parseNode(context, iEnd);
                            if (!node) return this.valueRange.end = iEnd; // at next document start
                            this.contents.push(node);
                            offset = node.range.end;
                            atLineStart = false;
                            var ec = $3972cc857ca762c6$var$grabCollectionEndComments(node);
                            if (ec) Array.prototype.push.apply(this.contents, ec);
                    }
                    offset = Document.startCommentOrEndBlankLine(src, offset);
                }
                this.valueRange.end = offset;
                if (src[offset]) {
                    this.documentEndMarker = new (0, $5lj6y.R)(offset, offset + 3);
                    offset += 3;
                    if (src[offset]) {
                        offset = (0, $5lj6y.N).endOfWhiteSpace(src, offset);
                        if (src[offset] === '#') {
                            var _comment = new $3972cc857ca762c6$var$Comment();
                            offset = _comment.parse({
                                src: src
                            }, offset);
                            this.contents.push(_comment);
                        }
                        switch(src[offset]){
                            case '\n':
                                offset += 1;
                                break;
                            case undefined:
                                break;
                            default:
                                this.error = new (0, $5lj6y.Y)(this, 'Document end marker line cannot have a non-comment suffix');
                        }
                    }
                }
                return offset;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                context.root = this;
                this.context = context;
                var src = context.src;
                var offset = src.charCodeAt(start) === 0xfeff ? start + 1 : start; // skip BOM
                offset = this.parseDirectives(offset);
                offset = this.parseContents(offset);
                return offset;
            }
        },
        {
            key: "setOrigRanges",
            value: function setOrigRanges(cr, offset) {
                offset = (0, $5lj6y.l)((0, $5lj6y.m)(Document.prototype), "setOrigRanges", this).call(this, cr, offset);
                this.directives.forEach(function(node) {
                    offset = node.setOrigRanges(cr, offset);
                });
                if (this.directivesEndMarker) offset = this.directivesEndMarker.setOrigRange(cr, offset);
                this.contents.forEach(function(node) {
                    offset = node.setOrigRanges(cr, offset);
                });
                if (this.documentEndMarker) offset = this.documentEndMarker.setOrigRange(cr, offset);
                return offset;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var contents = this.contents, directives = this.directives, value = this.value;
                if (value != null) return value;
                var str = directives.join('');
                if (contents.length > 0) {
                    if (directives.length > 0 || contents[0].type === (0, $5lj6y.T).COMMENT) str += '---\n';
                    str += contents.join('');
                }
                if (str[str.length - 1] !== '\n') str += '\n';
                return str;
            }
        }
    ], [
        {
            key: "startCommentOrEndBlankLine",
            value: function startCommentOrEndBlankLine(src, start) {
                var offset = (0, $5lj6y.N).endOfWhiteSpace(src, start);
                var ch = src[offset];
                return ch === '#' || ch === '\n' ? offset : start;
            }
        }
    ]);
    return Document;
}((0, $5lj6y.N));
var $3972cc857ca762c6$var$Alias = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(Alias, _Node);
    var _super = (0, $5lj6y.k)(Alias);
    function Alias() {
        (0, $5lj6y.c)(this, Alias);
        return _super.apply(this, arguments);
    }
    (0, $5lj6y.b)(Alias, [
        {
            key: "parse",
            value: /**
     * Parses an *alias from the source
     *
     * @param {ParseContext} context
     * @param {number} start - Index of first character
     * @returns {number} - Index of the character after this scalar
     */ function parse(context, start) {
                this.context = context;
                var src = context.src;
                var offset = (0, $5lj6y.N).endOfIdentifier(src, start + 1);
                this.valueRange = new (0, $5lj6y.R)(start + 1, offset);
                offset = (0, $5lj6y.N).endOfWhiteSpace(src, offset);
                offset = this.parseComment(offset);
                return offset;
            }
        }
    ]);
    return Alias;
}((0, $5lj6y.N));
var $3972cc857ca762c6$var$Chomp = {
    CLIP: 'CLIP',
    KEEP: 'KEEP',
    STRIP: 'STRIP'
};
var $3972cc857ca762c6$var$BlockValue = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(BlockValue, _Node);
    var _super = (0, $5lj6y.k)(BlockValue);
    function BlockValue(type, props) {
        var _this;
        (0, $5lj6y.c)(this, BlockValue);
        _this = _super.call(this, type, props);
        _this.blockIndent = null;
        _this.chomping = $3972cc857ca762c6$var$Chomp.CLIP;
        _this.header = null;
        return _this;
    }
    (0, $5lj6y.b)(BlockValue, [
        {
            key: "includesTrailingLines",
            get: function get() {
                return this.chomping === $3972cc857ca762c6$var$Chomp.KEEP;
            }
        },
        {
            key: "strValue",
            get: function get() {
                if (!this.valueRange || !this.context) return null;
                var _this$valueRange = this.valueRange, start = _this$valueRange.start, end = _this$valueRange.end;
                var _this$context = this.context, indent = _this$context.indent, src = _this$context.src;
                if (this.valueRange.isEmpty()) return '';
                var lastNewLine = null;
                var ch = src[end - 1];
                while(ch === '\n' || ch === '\t' || ch === ' '){
                    end -= 1;
                    if (end <= start) {
                        if (this.chomping === $3972cc857ca762c6$var$Chomp.KEEP) break;
                        else return ''; // probably never happens
                    }
                    if (ch === '\n') lastNewLine = end;
                    ch = src[end - 1];
                }
                var keepStart = end + 1;
                if (lastNewLine) {
                    if (this.chomping === $3972cc857ca762c6$var$Chomp.KEEP) {
                        keepStart = lastNewLine;
                        end = this.valueRange.end;
                    } else end = lastNewLine;
                }
                var bi = indent + this.blockIndent;
                var folded = this.type === (0, $5lj6y.T).BLOCK_FOLDED;
                var atStart = true;
                var str = '';
                var sep = '';
                var prevMoreIndented = false;
                for(var i = start; i < end; ++i){
                    for(var j = 0; j < bi; ++j){
                        if (src[i] !== ' ') break;
                        i += 1;
                    }
                    var _ch = src[i];
                    if (_ch === '\n') {
                        if (sep === '\n') str += '\n';
                        else sep = '\n';
                    } else {
                        var lineEnd = (0, $5lj6y.N).endOfLine(src, i);
                        var line = src.slice(i, lineEnd);
                        i = lineEnd;
                        if (folded && (_ch === ' ' || _ch === '\t') && i < keepStart) {
                            if (sep === ' ') sep = '\n';
                            else if (!prevMoreIndented && !atStart && sep === '\n') sep = '\n\n';
                            str += sep + line; //+ ((lineEnd < end && src[lineEnd]) || '')
                            sep = lineEnd < end && src[lineEnd] || '';
                            prevMoreIndented = true;
                        } else {
                            str += sep + line;
                            sep = folded && i < keepStart ? ' ' : '\n';
                            prevMoreIndented = false;
                        }
                        if (atStart && line !== '') atStart = false;
                    }
                }
                return this.chomping === $3972cc857ca762c6$var$Chomp.STRIP ? str : str + '\n';
            }
        },
        {
            key: "parseBlockHeader",
            value: function parseBlockHeader(start) {
                var src = this.context.src;
                var offset = start + 1;
                var bi = '';
                while(true){
                    var ch = src[offset];
                    switch(ch){
                        case '-':
                            this.chomping = $3972cc857ca762c6$var$Chomp.STRIP;
                            break;
                        case '+':
                            this.chomping = $3972cc857ca762c6$var$Chomp.KEEP;
                            break;
                        case '0':
                        case '1':
                        case '2':
                        case '3':
                        case '4':
                        case '5':
                        case '6':
                        case '7':
                        case '8':
                        case '9':
                            bi += ch;
                            break;
                        default:
                            this.blockIndent = Number(bi) || null;
                            this.header = new (0, $5lj6y.R)(start, offset);
                            return offset;
                    }
                    offset += 1;
                }
            }
        },
        {
            key: "parseBlockValue",
            value: function parseBlockValue(start) {
                var _this$context2 = this.context, indent = _this$context2.indent, src = _this$context2.src;
                var explicit = !!this.blockIndent;
                var offset = start;
                var valueEnd = start;
                var minBlockIndent = 1;
                for(var ch = src[offset]; ch === '\n'; ch = src[offset]){
                    offset += 1;
                    if ((0, $5lj6y.N).atDocumentBoundary(src, offset)) break;
                    var end = (0, $5lj6y.N).endOfBlockIndent(src, indent, offset); // should not include tab?
                    if (end === null) break;
                    var _ch2 = src[end];
                    var lineIndent = end - (offset + indent);
                    if (!this.blockIndent) {
                        // no explicit block indent, none yet detected
                        if (src[end] !== '\n') {
                            // first line with non-whitespace content
                            if (lineIndent < minBlockIndent) {
                                var msg = 'Block scalars with more-indented leading empty lines must use an explicit indentation indicator';
                                this.error = new (0, $5lj6y.g)(this, msg);
                            }
                            this.blockIndent = lineIndent;
                        } else if (lineIndent > minBlockIndent) // empty line with more whitespace
                        minBlockIndent = lineIndent;
                    } else if (_ch2 && _ch2 !== '\n' && lineIndent < this.blockIndent) {
                        if (src[end] === '#') break;
                        if (!this.error) {
                            var _src = explicit ? 'explicit indentation indicator' : 'first line';
                            var _msg = "Block scalars must not be less indented than their ".concat(_src);
                            this.error = new (0, $5lj6y.g)(this, _msg);
                        }
                    }
                    if (src[end] === '\n') offset = end;
                    else offset = valueEnd = (0, $5lj6y.N).endOfLine(src, end);
                }
                if (this.chomping !== $3972cc857ca762c6$var$Chomp.KEEP) offset = src[valueEnd] ? valueEnd + 1 : valueEnd;
                this.valueRange = new (0, $5lj6y.R)(start + 1, offset);
                return offset;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var src = context.src;
                var offset = this.parseBlockHeader(start);
                offset = (0, $5lj6y.N).endOfWhiteSpace(src, offset);
                offset = this.parseComment(offset);
                offset = this.parseBlockValue(offset);
                return offset;
            }
        },
        {
            key: "setOrigRanges",
            value: function setOrigRanges(cr, offset) {
                offset = (0, $5lj6y.l)((0, $5lj6y.m)(BlockValue.prototype), "setOrigRanges", this).call(this, cr, offset);
                return this.header ? this.header.setOrigRange(cr, offset) : offset;
            }
        }
    ]);
    return BlockValue;
}((0, $5lj6y.N));
var $3972cc857ca762c6$var$FlowCollection = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(FlowCollection, _Node);
    var _super = (0, $5lj6y.k)(FlowCollection);
    function FlowCollection(type, props) {
        var _this;
        (0, $5lj6y.c)(this, FlowCollection);
        _this = _super.call(this, type, props);
        _this.items = null;
        return _this;
    }
    (0, $5lj6y.b)(FlowCollection, [
        {
            key: "prevNodeIsJsonLike",
            value: function prevNodeIsJsonLike() {
                var idx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.items.length;
                var node = this.items[idx - 1];
                return !!node && (node.jsonLike || node.type === (0, $5lj6y.T).COMMENT && this.prevNodeIsJsonLike(idx - 1));
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var parseNode = context.parseNode, src = context.src;
                var indent = context.indent, lineStart = context.lineStart;
                var char = src[start]; // { or [
                this.items = [
                    {
                        char: char,
                        offset: start
                    }
                ];
                var offset = (0, $5lj6y.N).endOfWhiteSpace(src, start + 1);
                char = src[offset];
                while(char && char !== ']' && char !== '}'){
                    switch(char){
                        case '\n':
                            lineStart = offset + 1;
                            var wsEnd = (0, $5lj6y.N).endOfWhiteSpace(src, lineStart);
                            if (src[wsEnd] === '\n') {
                                var blankLine = new $3972cc857ca762c6$var$BlankLine();
                                lineStart = blankLine.parse({
                                    src: src
                                }, lineStart);
                                this.items.push(blankLine);
                            }
                            offset = (0, $5lj6y.N).endOfIndent(src, lineStart);
                            if (offset <= lineStart + indent) {
                                char = src[offset];
                                if (offset < lineStart + indent || char !== ']' && char !== '}') {
                                    var msg = 'Insufficient indentation in flow collection';
                                    this.error = new (0, $5lj6y.g)(this, msg);
                                }
                            }
                            break;
                        case ',':
                            this.items.push({
                                char: char,
                                offset: offset
                            });
                            offset += 1;
                            break;
                        case '#':
                            var comment = new $3972cc857ca762c6$var$Comment();
                            offset = comment.parse({
                                src: src
                            }, offset);
                            this.items.push(comment);
                            break;
                        case '?':
                        case ':':
                            var next = src[offset + 1];
                            if (next === '\n' || next === '\t' || next === ' ' || next === ',' || // in-flow : after JSON-like key does not need to be followed by whitespace
                            char === ':' && this.prevNodeIsJsonLike()) {
                                this.items.push({
                                    char: char,
                                    offset: offset
                                });
                                offset += 1;
                                break;
                            }
                        // fallthrough
                        default:
                            var node = parseNode({
                                atLineStart: false,
                                inCollection: false,
                                inFlow: true,
                                indent: -1,
                                lineStart: lineStart,
                                parent: this
                            }, offset);
                            if (!node) {
                                // at next document start
                                this.valueRange = new (0, $5lj6y.R)(start, offset);
                                return offset;
                            }
                            this.items.push(node);
                            offset = (0, $5lj6y.N).normalizeOffset(src, node.range.end);
                    }
                    offset = (0, $5lj6y.N).endOfWhiteSpace(src, offset);
                    char = src[offset];
                }
                this.valueRange = new (0, $5lj6y.R)(start, offset + 1);
                if (char) {
                    this.items.push({
                        char: char,
                        offset: offset
                    });
                    offset = (0, $5lj6y.N).endOfWhiteSpace(src, offset + 1);
                    offset = this.parseComment(offset);
                }
                return offset;
            }
        },
        {
            key: "setOrigRanges",
            value: function setOrigRanges(cr, offset) {
                offset = (0, $5lj6y.l)((0, $5lj6y.m)(FlowCollection.prototype), "setOrigRanges", this).call(this, cr, offset);
                this.items.forEach(function(node) {
                    if (node instanceof (0, $5lj6y.N)) offset = node.setOrigRanges(cr, offset);
                    else if (cr.length === 0) node.origOffset = node.offset;
                    else {
                        var i = offset;
                        while(i < cr.length){
                            if (cr[i] > node.offset) break;
                            else ++i;
                        }
                        node.origOffset = node.offset + i;
                        offset = i;
                    }
                });
                return offset;
            }
        },
        {
            key: "toString",
            value: function toString() {
                var src = this.context.src, items = this.items, range = this.range, value = this.value;
                if (value != null) return value;
                var nodes = items.filter(function(item) {
                    return item instanceof (0, $5lj6y.N);
                });
                var str = '';
                var prevEnd = range.start;
                nodes.forEach(function(node) {
                    var prefix = src.slice(prevEnd, node.range.start);
                    prevEnd = node.range.end;
                    str += prefix + String(node);
                    if (str[str.length - 1] === '\n' && src[prevEnd - 1] !== '\n' && src[prevEnd] === '\n') // Comment range does not include the terminal newline, but its
                    // stringified value does. Without this fix, newlines at comment ends
                    // get duplicated.
                    prevEnd += 1;
                });
                str += src.slice(prevEnd, range.end);
                return (0, $5lj6y.N).addStringTerminator(src, range.end, str);
            }
        }
    ]);
    return FlowCollection;
}((0, $5lj6y.N));
var $3972cc857ca762c6$var$QuoteDouble = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(QuoteDouble, _Node);
    var _super = (0, $5lj6y.k)(QuoteDouble);
    function QuoteDouble() {
        (0, $5lj6y.c)(this, QuoteDouble);
        return _super.apply(this, arguments);
    }
    (0, $5lj6y.b)(QuoteDouble, [
        {
            key: "strValue",
            get: /**
     * @returns {string | { str: string, errors: YAMLSyntaxError[] }}
     */ function get() {
                if (!this.valueRange || !this.context) return null;
                var errors = [];
                var _this$valueRange = this.valueRange, start = _this$valueRange.start, end = _this$valueRange.end;
                var _this$context = this.context, indent = _this$context.indent, src = _this$context.src;
                if (src[end - 1] !== '"') errors.push(new (0, $5lj6y.Y)(this, 'Missing closing "quote')); // Using String#replace is too painful with escaped newlines preceded by
                // escaped backslashes; also, this should be faster.
                var str = '';
                for(var i = start + 1; i < end - 1; ++i){
                    var ch = src[i];
                    if (ch === '\n') {
                        if ((0, $5lj6y.N).atDocumentBoundary(src, i + 1)) errors.push(new (0, $5lj6y.g)(this, 'Document boundary indicators are not allowed within string values'));
                        var _Node$foldNewline = (0, $5lj6y.N).foldNewline(src, i, indent), fold = _Node$foldNewline.fold, offset = _Node$foldNewline.offset, error = _Node$foldNewline.error;
                        str += fold;
                        i = offset;
                        if (error) errors.push(new (0, $5lj6y.g)(this, 'Multi-line double-quoted string needs to be sufficiently indented'));
                    } else if (ch === '\\') {
                        i += 1;
                        switch(src[i]){
                            case '0':
                                str += '\0';
                                break;
                            // null character
                            case 'a':
                                str += '\x07';
                                break;
                            // bell character
                            case 'b':
                                str += '\b';
                                break;
                            // backspace
                            case 'e':
                                str += '\x1b';
                                break;
                            // escape character
                            case 'f':
                                str += '\f';
                                break;
                            // form feed
                            case 'n':
                                str += '\n';
                                break;
                            // line feed
                            case 'r':
                                str += '\r';
                                break;
                            // carriage return
                            case 't':
                                str += '\t';
                                break;
                            // horizontal tab
                            case 'v':
                                str += '\v';
                                break;
                            // vertical tab
                            case 'N':
                                str += "\x85";
                                break;
                            // Unicode next line
                            case '_':
                                str += "\xA0";
                                break;
                            // Unicode non-breaking space
                            case 'L':
                                str += "\u2028";
                                break;
                            // Unicode line separator
                            case 'P':
                                str += "\u2029";
                                break;
                            // Unicode paragraph separator
                            case ' ':
                                str += ' ';
                                break;
                            case '"':
                                str += '"';
                                break;
                            case '/':
                                str += '/';
                                break;
                            case '\\':
                                str += '\\';
                                break;
                            case '\t':
                                str += '\t';
                                break;
                            case 'x':
                                str += this.parseCharCode(i + 1, 2, errors);
                                i += 2;
                                break;
                            case 'u':
                                str += this.parseCharCode(i + 1, 4, errors);
                                i += 4;
                                break;
                            case 'U':
                                str += this.parseCharCode(i + 1, 8, errors);
                                i += 8;
                                break;
                            case '\n':
                                // skip escaped newlines, but still trim the following line
                                while(src[i + 1] === ' ' || src[i + 1] === '\t')i += 1;
                                break;
                            default:
                                errors.push(new (0, $5lj6y.Y)(this, "Invalid escape sequence ".concat(src.substr(i - 1, 2))));
                                str += '\\' + src[i];
                        }
                    } else if (ch === ' ' || ch === '\t') {
                        // trim trailing whitespace
                        var wsStart = i;
                        var next = src[i + 1];
                        while(next === ' ' || next === '\t'){
                            i += 1;
                            next = src[i + 1];
                        }
                        if (next !== '\n') str += i > wsStart ? src.slice(wsStart, i + 1) : ch;
                    } else str += ch;
                }
                return errors.length > 0 ? {
                    errors: errors,
                    str: str
                } : str;
            }
        },
        {
            key: "parseCharCode",
            value: function parseCharCode(offset, length, errors) {
                var src = this.context.src;
                var cc = src.substr(offset, length);
                var ok = cc.length === length && /^[0-9a-fA-F]+$/.test(cc);
                var code = ok ? parseInt(cc, 16) : NaN;
                if (isNaN(code)) {
                    errors.push(new (0, $5lj6y.Y)(this, "Invalid escape sequence ".concat(src.substr(offset - 2, length + 2))));
                    return src.substr(offset - 2, length + 2);
                }
                return String.fromCodePoint(code);
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var src = context.src;
                var offset = QuoteDouble.endOfQuote(src, start + 1);
                this.valueRange = new (0, $5lj6y.R)(start, offset);
                offset = (0, $5lj6y.N).endOfWhiteSpace(src, offset);
                offset = this.parseComment(offset);
                return offset;
            }
        }
    ], [
        {
            key: "endOfQuote",
            value: function endOfQuote(src, offset) {
                var ch = src[offset];
                while(ch && ch !== '"'){
                    offset += ch === '\\' ? 2 : 1;
                    ch = src[offset];
                }
                return offset + 1;
            }
        }
    ]);
    return QuoteDouble;
}((0, $5lj6y.N));
var $3972cc857ca762c6$var$QuoteSingle = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(QuoteSingle, _Node);
    var _super = (0, $5lj6y.k)(QuoteSingle);
    function QuoteSingle() {
        (0, $5lj6y.c)(this, QuoteSingle);
        return _super.apply(this, arguments);
    }
    (0, $5lj6y.b)(QuoteSingle, [
        {
            key: "strValue",
            get: /**
     * @returns {string | { str: string, errors: YAMLSyntaxError[] }}
     */ function get() {
                if (!this.valueRange || !this.context) return null;
                var errors = [];
                var _this$valueRange = this.valueRange, start = _this$valueRange.start, end = _this$valueRange.end;
                var _this$context = this.context, indent = _this$context.indent, src = _this$context.src;
                if (src[end - 1] !== "'") errors.push(new (0, $5lj6y.Y)(this, "Missing closing 'quote"));
                var str = '';
                for(var i = start + 1; i < end - 1; ++i){
                    var ch = src[i];
                    if (ch === '\n') {
                        if ((0, $5lj6y.N).atDocumentBoundary(src, i + 1)) errors.push(new (0, $5lj6y.g)(this, 'Document boundary indicators are not allowed within string values'));
                        var _Node$foldNewline = (0, $5lj6y.N).foldNewline(src, i, indent), fold = _Node$foldNewline.fold, offset = _Node$foldNewline.offset, error = _Node$foldNewline.error;
                        str += fold;
                        i = offset;
                        if (error) errors.push(new (0, $5lj6y.g)(this, 'Multi-line single-quoted string needs to be sufficiently indented'));
                    } else if (ch === "'") {
                        str += ch;
                        i += 1;
                        if (src[i] !== "'") errors.push(new (0, $5lj6y.Y)(this, 'Unescaped single quote? This should not happen.'));
                    } else if (ch === ' ' || ch === '\t') {
                        // trim trailing whitespace
                        var wsStart = i;
                        var next = src[i + 1];
                        while(next === ' ' || next === '\t'){
                            i += 1;
                            next = src[i + 1];
                        }
                        if (next !== '\n') str += i > wsStart ? src.slice(wsStart, i + 1) : ch;
                    } else str += ch;
                }
                return errors.length > 0 ? {
                    errors: errors,
                    str: str
                } : str;
            }
        },
        {
            key: "parse",
            value: function parse(context, start) {
                this.context = context;
                var src = context.src;
                var offset = QuoteSingle.endOfQuote(src, start + 1);
                this.valueRange = new (0, $5lj6y.R)(start, offset);
                offset = (0, $5lj6y.N).endOfWhiteSpace(src, offset);
                offset = this.parseComment(offset);
                return offset;
            }
        }
    ], [
        {
            key: "endOfQuote",
            value: function endOfQuote(src, offset) {
                var ch = src[offset];
                while(ch)if (ch === "'") {
                    if (src[offset + 1] !== "'") break;
                    ch = src[offset += 2];
                } else ch = src[offset += 1];
                return offset + 1;
            }
        }
    ]);
    return QuoteSingle;
}((0, $5lj6y.N));
function $3972cc857ca762c6$var$createNewNode(type, props) {
    switch(type){
        case (0, $5lj6y.T).ALIAS:
            return new $3972cc857ca762c6$var$Alias(type, props);
        case (0, $5lj6y.T).BLOCK_FOLDED:
        case (0, $5lj6y.T).BLOCK_LITERAL:
            return new $3972cc857ca762c6$var$BlockValue(type, props);
        case (0, $5lj6y.T).FLOW_MAP:
        case (0, $5lj6y.T).FLOW_SEQ:
            return new $3972cc857ca762c6$var$FlowCollection(type, props);
        case (0, $5lj6y.T).MAP_KEY:
        case (0, $5lj6y.T).MAP_VALUE:
        case (0, $5lj6y.T).SEQ_ITEM:
            return new $3972cc857ca762c6$var$CollectionItem(type, props);
        case (0, $5lj6y.T).COMMENT:
        case (0, $5lj6y.T).PLAIN:
            return new (0, $5lj6y.P)(type, props);
        case (0, $5lj6y.T).QUOTE_DOUBLE:
            return new $3972cc857ca762c6$var$QuoteDouble(type, props);
        case (0, $5lj6y.T).QUOTE_SINGLE:
            return new $3972cc857ca762c6$var$QuoteSingle(type, props);
        /* istanbul ignore next */ default:
            return null;
    }
}
/**
 * @param {boolean} atLineStart - Node starts at beginning of line
 * @param {boolean} inFlow - true if currently in a flow context
 * @param {boolean} inCollection - true if currently in a collection context
 * @param {number} indent - Current level of indentation
 * @param {number} lineStart - Start of the current line
 * @param {Node} parent - The parent of the node
 * @param {string} src - Source of the YAML document
 */ var $3972cc857ca762c6$var$ParseContext = /*#__PURE__*/ function() {
    function ParseContext() {
        var _this = this;
        var orig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, atLineStart = _ref.atLineStart, inCollection = _ref.inCollection, inFlow = _ref.inFlow, indent = _ref.indent, lineStart = _ref.lineStart, parent = _ref.parent;
        (0, $5lj6y.c)(this, ParseContext);
        (0, $5lj6y.e)(this, "parseNode", function(overlay, start) {
            if ((0, $5lj6y.N).atDocumentBoundary(_this.src, start)) return null;
            var context = new ParseContext(_this, overlay);
            var _context$parseProps = context.parseProps(start), props = _context$parseProps.props, type = _context$parseProps.type, valueStart = _context$parseProps.valueStart;
            var node = $3972cc857ca762c6$var$createNewNode(type, props);
            var offset = node.parse(context, valueStart);
            node.range = new (0, $5lj6y.R)(start, offset);
            /* istanbul ignore if */ if (offset <= start) {
                // This should never happen, but if it does, let's make sure to at least
                // step one character forward to avoid a busy loop.
                node.error = new Error("Node#parse consumed no characters");
                node.error.parseEnd = offset;
                node.error.source = node;
                node.range.end = start + 1;
            }
            if (context.nodeStartsCollection(node)) {
                if (!node.error && !context.atLineStart && context.parent.type === (0, $5lj6y.T).DOCUMENT) node.error = new (0, $5lj6y.Y)(node, 'Block collection must not have preceding content here (e.g. directives-end indicator)');
                var collection = new $3972cc857ca762c6$var$Collection(node);
                offset = collection.parse(new ParseContext(context), offset);
                collection.range = new (0, $5lj6y.R)(start, offset);
                return collection;
            }
            return node;
        });
        this.atLineStart = atLineStart != null ? atLineStart : orig.atLineStart || false;
        this.inCollection = inCollection != null ? inCollection : orig.inCollection || false;
        this.inFlow = inFlow != null ? inFlow : orig.inFlow || false;
        this.indent = indent != null ? indent : orig.indent;
        this.lineStart = lineStart != null ? lineStart : orig.lineStart;
        this.parent = parent != null ? parent : orig.parent || {};
        this.root = orig.root;
        this.src = orig.src;
    }
    (0, $5lj6y.b)(ParseContext, [
        {
            key: "nodeStartsCollection",
            value: function nodeStartsCollection(node) {
                var inCollection = this.inCollection, inFlow = this.inFlow, src = this.src;
                if (inCollection || inFlow) return false;
                if (node instanceof $3972cc857ca762c6$var$CollectionItem) return true; // check for implicit key
                var offset = node.range.end;
                if (src[offset] === '\n' || src[offset - 1] === '\n') return false;
                offset = (0, $5lj6y.N).endOfWhiteSpace(src, offset);
                return src[offset] === ':';
            } // Anchor and tag are before type, which determines the node implementation
        },
        {
            key: "parseProps",
            value: function parseProps(offset) {
                var inFlow = this.inFlow, parent = this.parent, src = this.src;
                var props = [];
                var lineHasProps = false;
                offset = this.atLineStart ? (0, $5lj6y.N).endOfIndent(src, offset) : (0, $5lj6y.N).endOfWhiteSpace(src, offset);
                var ch = src[offset];
                while(ch === (0, $5lj6y.C).ANCHOR || ch === (0, $5lj6y.C).COMMENT || ch === (0, $5lj6y.C).TAG || ch === '\n'){
                    if (ch === '\n') {
                        var inEnd = offset;
                        var lineStart = void 0;
                        do {
                            lineStart = inEnd + 1;
                            inEnd = (0, $5lj6y.N).endOfIndent(src, lineStart);
                        }while (src[inEnd] === '\n');
                        var indentDiff = inEnd - (lineStart + this.indent);
                        var noIndicatorAsIndent = parent.type === (0, $5lj6y.T).SEQ_ITEM && parent.context.atLineStart;
                        if (src[inEnd] !== '#' && !(0, $5lj6y.N).nextNodeIsIndented(src[inEnd], indentDiff, !noIndicatorAsIndent)) break;
                        this.atLineStart = true;
                        this.lineStart = lineStart;
                        lineHasProps = false;
                        offset = inEnd;
                    } else if (ch === (0, $5lj6y.C).COMMENT) {
                        var end = (0, $5lj6y.N).endOfLine(src, offset + 1);
                        props.push(new (0, $5lj6y.R)(offset, end));
                        offset = end;
                    } else {
                        var _end = (0, $5lj6y.N).endOfIdentifier(src, offset + 1);
                        if (ch === (0, $5lj6y.C).TAG && src[_end] === ',' && /^[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+,\d\d\d\d(-\d\d){0,2}\/\S/.test(src.slice(offset + 1, _end + 13))) // Let's presume we're dealing with a YAML 1.0 domain tag here, rather
                        // than an empty but 'foo.bar' private-tagged node in a flow collection
                        // followed without whitespace by a plain string starting with a year
                        // or date divided by something.
                        _end = (0, $5lj6y.N).endOfIdentifier(src, _end + 5);
                        props.push(new (0, $5lj6y.R)(offset, _end));
                        lineHasProps = true;
                        offset = (0, $5lj6y.N).endOfWhiteSpace(src, _end);
                    }
                    ch = src[offset];
                } // '- &a : b' has an anchor on an empty node
                if (lineHasProps && ch === ':' && (0, $5lj6y.N).atBlank(src, offset + 1, true)) offset -= 1;
                var type = ParseContext.parseType(src, offset, inFlow);
                return {
                    props: props,
                    type: type,
                    valueStart: offset
                };
            }
        }
    ], [
        {
            key: "parseType",
            value: function parseType(src, offset, inFlow) {
                switch(src[offset]){
                    case '*':
                        return (0, $5lj6y.T).ALIAS;
                    case '>':
                        return (0, $5lj6y.T).BLOCK_FOLDED;
                    case '|':
                        return (0, $5lj6y.T).BLOCK_LITERAL;
                    case '{':
                        return (0, $5lj6y.T).FLOW_MAP;
                    case '[':
                        return (0, $5lj6y.T).FLOW_SEQ;
                    case '?':
                        return !inFlow && (0, $5lj6y.N).atBlank(src, offset + 1, true) ? (0, $5lj6y.T).MAP_KEY : (0, $5lj6y.T).PLAIN;
                    case ':':
                        return !inFlow && (0, $5lj6y.N).atBlank(src, offset + 1, true) ? (0, $5lj6y.T).MAP_VALUE : (0, $5lj6y.T).PLAIN;
                    case '-':
                        return !inFlow && (0, $5lj6y.N).atBlank(src, offset + 1, true) ? (0, $5lj6y.T).SEQ_ITEM : (0, $5lj6y.T).PLAIN;
                    case '"':
                        return (0, $5lj6y.T).QUOTE_DOUBLE;
                    case "'":
                        return (0, $5lj6y.T).QUOTE_SINGLE;
                    default:
                        return (0, $5lj6y.T).PLAIN;
                }
            }
        }
    ]);
    return ParseContext;
}();
// Published as 'yaml/parse-cst'
function $3972cc857ca762c6$export$98e6a39c04603d36(src) {
    var cr = [];
    if (src.indexOf('\r') !== -1) src = src.replace(/\r\n?/g, function(match, offset) {
        if (match.length > 1) cr.push(offset);
        return '\n';
    });
    var documents = [];
    var offset = 0;
    do {
        var doc = new $3972cc857ca762c6$var$Document();
        var context = new $3972cc857ca762c6$var$ParseContext({
            src: src
        });
        offset = doc.parse(context, offset);
        documents.push(doc);
    }while (offset < src.length);
    documents.setOrigRanges = function() {
        if (cr.length === 0) return false;
        for(var i = 1; i < cr.length; ++i)cr[i] -= i;
        var crOffset = 0;
        for(var _i = 0; _i < documents.length; ++_i)crOffset = documents[_i].setOrigRanges(cr, crOffset);
        cr.splice(0, cr.length);
        return true;
    };
    documents.toString = function() {
        return documents.join('...\n');
    };
    return documents;
}

});

parcelRegister("lrFig", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $f9cc26a8c8e9e9ae$export$2d1720544b23b823; });
$parcel$export(module.exports, "N", function () { return $f9cc26a8c8e9e9ae$export$a07804094c3ecf2d; });
$parcel$export(module.exports, "t", function () { return $f9cc26a8c8e9e9ae$export$625550452a3fa3ec; });
$parcel$export(module.exports, "S", function () { return $f9cc26a8c8e9e9ae$export$25ce5a424b770e84; });
$parcel$export(module.exports, "e", function () { return $f9cc26a8c8e9e9ae$export$f1e1789686576879; });
$parcel$export(module.exports, "C", function () { return $f9cc26a8c8e9e9ae$export$e7094788287c5e9b; });
$parcel$export(module.exports, "Y", function () { return $f9cc26a8c8e9e9ae$export$8743009a87fcb00f; });
$parcel$export(module.exports, "P", function () { return $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "A", function () { return $f9cc26a8c8e9e9ae$export$ebd11618f299a286; });
$parcel$export(module.exports, "l", function () { return $f9cc26a8c8e9e9ae$export$882b5998b3b9117c; });
$parcel$export(module.exports, "d", function () { return $f9cc26a8c8e9e9ae$export$4368d992c4eafac0; });
$parcel$export(module.exports, "M", function () { return $f9cc26a8c8e9e9ae$export$3a1a48c8f6ef640e; });
$parcel$export(module.exports, "b", function () { return $f9cc26a8c8e9e9ae$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "a", function () { return $f9cc26a8c8e9e9ae$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $f9cc26a8c8e9e9ae$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "n", function () { return $f9cc26a8c8e9e9ae$export$7ccc53e8f1e7dfc5; });
$parcel$export(module.exports, "s", function () { return $f9cc26a8c8e9e9ae$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "c", function () { return $f9cc26a8c8e9e9ae$export$db3b6bfb95261072; });
$parcel$export(module.exports, "k", function () { return $f9cc26a8c8e9e9ae$export$342063e11d6c3cad; });
$parcel$export(module.exports, "j", function () { return $f9cc26a8c8e9e9ae$export$35e795649ee09318; });
$parcel$export(module.exports, "r", function () { return $f9cc26a8c8e9e9ae$export$43caf9889c228507; });
$parcel$export(module.exports, "g", function () { return $f9cc26a8c8e9e9ae$export$39b482c5e57630a8; });
$parcel$export(module.exports, "h", function () { return $f9cc26a8c8e9e9ae$export$dda1d9f60106f0e9; });

var $5lj6y = parcelRequire("5lj6y");
function $f9cc26a8c8e9e9ae$var$addCommentBefore(str, indent, comment) {
    if (!comment) return str;
    var cc = comment.replace(/[\s\S]^/gm, "$&".concat(indent, "#"));
    return "#".concat(cc, "\n").concat(indent).concat(str);
}
function $f9cc26a8c8e9e9ae$export$2d1720544b23b823(str, indent, comment) {
    return !comment ? str : comment.indexOf('\n') === -1 ? "".concat(str, " #").concat(comment) : "".concat(str, "\n") + comment.replace(/^/gm, "".concat(indent || '', "#"));
}
var $f9cc26a8c8e9e9ae$export$a07804094c3ecf2d = function Node() {
    (0, $5lj6y.c)(this, Node);
};
function $f9cc26a8c8e9e9ae$export$625550452a3fa3ec(value, arg, ctx) {
    if (Array.isArray(value)) return value.map(function(v, i) {
        return $f9cc26a8c8e9e9ae$export$625550452a3fa3ec(v, String(i), ctx);
    });
    if (value && typeof value.toJSON === 'function') {
        var anchor = ctx && ctx.anchors && ctx.anchors.get(value);
        if (anchor) ctx.onCreate = function(res) {
            anchor.res = res;
            delete ctx.onCreate;
        };
        var res = value.toJSON(arg, ctx);
        if (anchor && ctx.onCreate) ctx.onCreate(res);
        return res;
    }
    if ((!ctx || !ctx.keep) && typeof value === 'bigint') return Number(value);
    return value;
}
var $f9cc26a8c8e9e9ae$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(Scalar, _Node);
    var _super = (0, $5lj6y.k)(Scalar);
    function Scalar(value) {
        var _this;
        (0, $5lj6y.c)(this, Scalar);
        _this = _super.call(this);
        _this.value = value;
        return _this;
    }
    (0, $5lj6y.b)(Scalar, [
        {
            key: "toJSON",
            value: function toJSON$1(arg, ctx) {
                return ctx && ctx.keep ? this.value : $f9cc26a8c8e9e9ae$export$625550452a3fa3ec(this.value, arg, ctx);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return String(this.value);
            }
        }
    ]);
    return Scalar;
}($f9cc26a8c8e9e9ae$export$a07804094c3ecf2d);
function $f9cc26a8c8e9e9ae$var$collectionFromPath(schema, path, value) {
    var v = value;
    for(var i = path.length - 1; i >= 0; --i){
        var k = path[i];
        if (Number.isInteger(k) && k >= 0) {
            var a = [];
            a[k] = v;
            v = a;
        } else {
            var o = {};
            Object.defineProperty(o, k, {
                value: v,
                writable: true,
                enumerable: true,
                configurable: true
            });
            v = o;
        }
    }
    return schema.createNode(v, false);
} // null, undefined, or an empty non-string iterable (e.g. [])
var $f9cc26a8c8e9e9ae$export$f1e1789686576879 = function isEmptyPath(path) {
    return path == null || (0, $5lj6y.a)(path) === 'object' && path[Symbol.iterator]().next().done;
};
var $f9cc26a8c8e9e9ae$export$e7094788287c5e9b = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(Collection, _Node);
    var _super = (0, $5lj6y.k)(Collection);
    function Collection(schema) {
        var _this;
        (0, $5lj6y.c)(this, Collection);
        _this = _super.call(this);
        (0, $5lj6y.e)((0, $5lj6y.p)(_this), "items", []);
        _this.schema = schema;
        return _this;
    }
    (0, $5lj6y.b)(Collection, [
        {
            key: "addIn",
            value: function addIn(path, value) {
                if ($f9cc26a8c8e9e9ae$export$f1e1789686576879(path)) this.add(value);
                else {
                    var _path = (0, $5lj6y.q)(path), key = _path[0], rest = _path.slice(1);
                    var node = this.get(key, true);
                    if (node instanceof Collection) node.addIn(rest, value);
                    else if (node === undefined && this.schema) this.set(key, $f9cc26a8c8e9e9ae$var$collectionFromPath(this.schema, rest, value));
                    else throw new Error("Expected YAML collection at ".concat(key, ". Remaining path: ").concat(rest));
                }
            }
        },
        {
            key: "deleteIn",
            value: function deleteIn(_ref) {
                var _ref2 = (0, $5lj6y.q)(_ref), key = _ref2[0], rest = _ref2.slice(1);
                if (rest.length === 0) return this.delete(key);
                var node = this.get(key, true);
                if (node instanceof Collection) return node.deleteIn(rest);
                else throw new Error("Expected YAML collection at ".concat(key, ". Remaining path: ").concat(rest));
            }
        },
        {
            key: "getIn",
            value: function getIn(_ref3, keepScalar) {
                var _ref4 = (0, $5lj6y.q)(_ref3), key = _ref4[0], rest = _ref4.slice(1);
                var node = this.get(key, true);
                if (rest.length === 0) return !keepScalar && node instanceof $f9cc26a8c8e9e9ae$export$25ce5a424b770e84 ? node.value : node;
                else return node instanceof Collection ? node.getIn(rest, keepScalar) : undefined;
            }
        },
        {
            key: "hasAllNullValues",
            value: function hasAllNullValues() {
                return this.items.every(function(node) {
                    if (!node || node.type !== 'PAIR') return false;
                    var n = node.value;
                    return n == null || n instanceof $f9cc26a8c8e9e9ae$export$25ce5a424b770e84 && n.value == null && !n.commentBefore && !n.comment && !n.tag;
                });
            }
        },
        {
            key: "hasIn",
            value: function hasIn(_ref5) {
                var _ref6 = (0, $5lj6y.q)(_ref5), key = _ref6[0], rest = _ref6.slice(1);
                if (rest.length === 0) return this.has(key);
                var node = this.get(key, true);
                return node instanceof Collection ? node.hasIn(rest) : false;
            }
        },
        {
            key: "setIn",
            value: function setIn(_ref7, value) {
                var _ref8 = (0, $5lj6y.q)(_ref7), key = _ref8[0], rest = _ref8.slice(1);
                if (rest.length === 0) this.set(key, value);
                else {
                    var node = this.get(key, true);
                    if (node instanceof Collection) node.setIn(rest, value);
                    else if (node === undefined && this.schema) this.set(key, $f9cc26a8c8e9e9ae$var$collectionFromPath(this.schema, rest, value));
                    else throw new Error("Expected YAML collection at ".concat(key, ". Remaining path: ").concat(rest));
                }
            } // overridden in implementations
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return null;
            }
        },
        {
            key: "toString",
            value: function toString(ctx, _ref9, onComment, onChompKeep) {
                var _this2 = this;
                var blockItem = _ref9.blockItem, flowChars = _ref9.flowChars, isMap = _ref9.isMap, itemIndent = _ref9.itemIndent;
                var _ctx = ctx, indent = _ctx.indent, indentStep = _ctx.indentStep, stringify = _ctx.stringify;
                var inFlow = this.type === (0, $5lj6y.T).FLOW_MAP || this.type === (0, $5lj6y.T).FLOW_SEQ || ctx.inFlow;
                if (inFlow) itemIndent += indentStep;
                var allNullValues = isMap && this.hasAllNullValues();
                ctx = Object.assign({}, ctx, {
                    allNullValues: allNullValues,
                    indent: itemIndent,
                    inFlow: inFlow,
                    type: null
                });
                var chompKeep = false;
                var hasItemWithNewLine = false;
                var nodes = this.items.reduce(function(nodes, item, i) {
                    var comment;
                    if (item) {
                        if (!chompKeep && item.spaceBefore) nodes.push({
                            type: 'comment',
                            str: ''
                        });
                        if (item.commentBefore) item.commentBefore.match(/^.*$/gm).forEach(function(line) {
                            nodes.push({
                                type: 'comment',
                                str: "#".concat(line)
                            });
                        });
                        if (item.comment) comment = item.comment;
                        if (inFlow && (!chompKeep && item.spaceBefore || item.commentBefore || item.comment || item.key && (item.key.commentBefore || item.key.comment) || item.value && (item.value.commentBefore || item.value.comment))) hasItemWithNewLine = true;
                    }
                    chompKeep = false;
                    var str = stringify(item, ctx, function() {
                        return comment = null;
                    }, function() {
                        return chompKeep = true;
                    });
                    if (inFlow && !hasItemWithNewLine && str.includes('\n')) hasItemWithNewLine = true;
                    if (inFlow && i < _this2.items.length - 1) str += ',';
                    str = $f9cc26a8c8e9e9ae$export$2d1720544b23b823(str, itemIndent, comment);
                    if (chompKeep && (comment || inFlow)) chompKeep = false;
                    nodes.push({
                        type: 'item',
                        str: str
                    });
                    return nodes;
                }, []);
                var str;
                if (nodes.length === 0) str = flowChars.start + flowChars.end;
                else if (inFlow) {
                    var start = flowChars.start, end = flowChars.end;
                    var strings = nodes.map(function(n) {
                        return n.str;
                    });
                    if (hasItemWithNewLine || strings.reduce(function(sum, str) {
                        return sum + str.length + 2;
                    }, 2) > Collection.maxFlowStringSingleLineLength) {
                        str = start;
                        var _iterator = (0, $5lj6y._)(strings), _step;
                        try {
                            for(_iterator.s(); !(_step = _iterator.n()).done;){
                                var s = _step.value;
                                str += s ? "\n".concat(indentStep).concat(indent).concat(s) : '\n';
                            }
                        } catch (err) {
                            _iterator.e(err);
                        } finally{
                            _iterator.f();
                        }
                        str += "\n".concat(indent).concat(end);
                    } else str = "".concat(start, " ").concat(strings.join(' '), " ").concat(end);
                } else {
                    var _strings = nodes.map(blockItem);
                    str = _strings.shift();
                    var _iterator2 = (0, $5lj6y._)(_strings), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _s = _step2.value;
                            str += _s ? "\n".concat(indent).concat(_s) : '\n';
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
                if (this.comment) {
                    str += '\n' + this.comment.replace(/^/gm, "".concat(indent, "#"));
                    if (onComment) onComment();
                } else if (chompKeep && onChompKeep) onChompKeep();
                return str;
            }
        }
    ]);
    return Collection;
}($f9cc26a8c8e9e9ae$export$a07804094c3ecf2d);
(0, $5lj6y.e)($f9cc26a8c8e9e9ae$export$e7094788287c5e9b, "maxFlowStringSingleLineLength", 60);
function $f9cc26a8c8e9e9ae$var$asItemIndex(key) {
    var idx = key instanceof $f9cc26a8c8e9e9ae$export$25ce5a424b770e84 ? key.value : key;
    if (idx && typeof idx === 'string') idx = Number(idx);
    return Number.isInteger(idx) && idx >= 0 ? idx : null;
}
var $f9cc26a8c8e9e9ae$export$8743009a87fcb00f = /*#__PURE__*/ function(_Collection) {
    (0, $5lj6y.j)(YAMLSeq, _Collection);
    var _super = (0, $5lj6y.k)(YAMLSeq);
    function YAMLSeq() {
        (0, $5lj6y.c)(this, YAMLSeq);
        return _super.apply(this, arguments);
    }
    (0, $5lj6y.b)(YAMLSeq, [
        {
            key: "add",
            value: function add(value) {
                this.items.push(value);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                var idx = $f9cc26a8c8e9e9ae$var$asItemIndex(key);
                if (typeof idx !== 'number') return false;
                var del = this.items.splice(idx, 1);
                return del.length > 0;
            }
        },
        {
            key: "get",
            value: function get(key, keepScalar) {
                var idx = $f9cc26a8c8e9e9ae$var$asItemIndex(key);
                if (typeof idx !== 'number') return undefined;
                var it = this.items[idx];
                return !keepScalar && it instanceof $f9cc26a8c8e9e9ae$export$25ce5a424b770e84 ? it.value : it;
            }
        },
        {
            key: "has",
            value: function has(key) {
                var idx = $f9cc26a8c8e9e9ae$var$asItemIndex(key);
                return typeof idx === 'number' && idx < this.items.length;
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                var idx = $f9cc26a8c8e9e9ae$var$asItemIndex(key);
                if (typeof idx !== 'number') throw new Error("Expected a valid index, not ".concat(key, "."));
                this.items[idx] = value;
            }
        },
        {
            key: "toJSON",
            value: function toJSON$1(_, ctx) {
                var seq = [];
                if (ctx && ctx.onCreate) ctx.onCreate(seq);
                var i = 0;
                var _iterator = (0, $5lj6y._)(this.items), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var item = _step.value;
                        seq.push($f9cc26a8c8e9e9ae$export$625550452a3fa3ec(item, String(i++), ctx));
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return seq;
            }
        },
        {
            key: "toString",
            value: function toString(ctx, onComment, onChompKeep) {
                if (!ctx) return JSON.stringify(this);
                return (0, $5lj6y.l)((0, $5lj6y.m)(YAMLSeq.prototype), "toString", this).call(this, ctx, {
                    blockItem: function blockItem(n) {
                        return n.type === 'comment' ? n.str : "- ".concat(n.str);
                    },
                    flowChars: {
                        start: '[',
                        end: ']'
                    },
                    isMap: false,
                    itemIndent: (ctx.indent || '') + '  '
                }, onComment, onChompKeep);
            }
        }
    ]);
    return YAMLSeq;
}($f9cc26a8c8e9e9ae$export$e7094788287c5e9b);
var $f9cc26a8c8e9e9ae$var$stringifyKey = function stringifyKey(key, jsKey, ctx) {
    if (jsKey === null) return '';
    if ((0, $5lj6y.a)(jsKey) !== 'object') return String(jsKey);
    if (key instanceof $f9cc26a8c8e9e9ae$export$a07804094c3ecf2d && ctx && ctx.doc) return key.toString({
        anchors: Object.create(null),
        doc: ctx.doc,
        indent: '',
        indentStep: ctx.indentStep,
        inFlow: true,
        inStringifyKey: true,
        stringify: ctx.stringify
    });
    return JSON.stringify(jsKey);
};
var $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(Pair, _Node);
    var _super = (0, $5lj6y.k)(Pair);
    function Pair(key) {
        var _this;
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        (0, $5lj6y.c)(this, Pair);
        _this = _super.call(this);
        _this.key = key;
        _this.value = value;
        _this.type = Pair.Type.PAIR;
        return _this;
    }
    (0, $5lj6y.b)(Pair, [
        {
            key: "commentBefore",
            get: function get() {
                return this.key instanceof $f9cc26a8c8e9e9ae$export$a07804094c3ecf2d ? this.key.commentBefore : undefined;
            },
            set: function set(cb) {
                if (this.key == null) this.key = new $f9cc26a8c8e9e9ae$export$25ce5a424b770e84(null);
                if (this.key instanceof $f9cc26a8c8e9e9ae$export$a07804094c3ecf2d) this.key.commentBefore = cb;
                else {
                    var msg = 'Pair.commentBefore is an alias for Pair.key.commentBefore. To set it, the key must be a Node.';
                    throw new Error(msg);
                }
            }
        },
        {
            key: "addToJSMap",
            value: function addToJSMap(ctx, map) {
                var key = $f9cc26a8c8e9e9ae$export$625550452a3fa3ec(this.key, '', ctx);
                if (map instanceof Map) {
                    var value = $f9cc26a8c8e9e9ae$export$625550452a3fa3ec(this.value, key, ctx);
                    map.set(key, value);
                } else if (map instanceof Set) map.add(key);
                else {
                    var stringKey = $f9cc26a8c8e9e9ae$var$stringifyKey(this.key, key, ctx);
                    var _value = $f9cc26a8c8e9e9ae$export$625550452a3fa3ec(this.value, stringKey, ctx);
                    if (stringKey in map) Object.defineProperty(map, stringKey, {
                        value: _value,
                        writable: true,
                        enumerable: true,
                        configurable: true
                    });
                    else map[stringKey] = _value;
                }
                return map;
            }
        },
        {
            key: "toJSON",
            value: function toJSON(_, ctx) {
                var pair = ctx && ctx.mapAsMap ? new Map() : {};
                return this.addToJSMap(ctx, pair);
            }
        },
        {
            key: "toString",
            value: function toString(ctx, onComment, onChompKeep) {
                if (!ctx || !ctx.doc) return JSON.stringify(this);
                var _ctx$doc$options = ctx.doc.options, indentSize = _ctx$doc$options.indent, indentSeq = _ctx$doc$options.indentSeq, simpleKeys = _ctx$doc$options.simpleKeys;
                var key = this.key, value = this.value;
                var keyComment = key instanceof $f9cc26a8c8e9e9ae$export$a07804094c3ecf2d && key.comment;
                if (simpleKeys) {
                    if (keyComment) throw new Error('With simple keys, key nodes cannot have comments');
                    if (key instanceof $f9cc26a8c8e9e9ae$export$e7094788287c5e9b) {
                        var msg = 'With simple keys, collection cannot be used as a key value';
                        throw new Error(msg);
                    }
                }
                var explicitKey = !simpleKeys && (!key || keyComment || (key instanceof $f9cc26a8c8e9e9ae$export$a07804094c3ecf2d ? key instanceof $f9cc26a8c8e9e9ae$export$e7094788287c5e9b || key.type === (0, $5lj6y.T).BLOCK_FOLDED || key.type === (0, $5lj6y.T).BLOCK_LITERAL : (0, $5lj6y.a)(key) === 'object'));
                var _ctx = ctx, doc = _ctx.doc, indent = _ctx.indent, indentStep = _ctx.indentStep, stringify = _ctx.stringify;
                ctx = Object.assign({}, ctx, {
                    implicitKey: !explicitKey,
                    indent: indent + indentStep
                });
                var chompKeep = false;
                var str = stringify(key, ctx, function() {
                    return keyComment = null;
                }, function() {
                    return chompKeep = true;
                });
                str = $f9cc26a8c8e9e9ae$export$2d1720544b23b823(str, ctx.indent, keyComment);
                if (!explicitKey && str.length > 1024) {
                    if (simpleKeys) throw new Error('With simple keys, single line scalar must not span more than 1024 characters');
                    explicitKey = true;
                }
                if (ctx.allNullValues && !simpleKeys) {
                    if (this.comment) {
                        str = $f9cc26a8c8e9e9ae$export$2d1720544b23b823(str, ctx.indent, this.comment);
                        if (onComment) onComment();
                    } else if (chompKeep && !keyComment && onChompKeep) onChompKeep();
                    return ctx.inFlow && !explicitKey ? str : "? ".concat(str);
                }
                str = explicitKey ? "? ".concat(str, "\n").concat(indent, ":") : "".concat(str, ":");
                if (this.comment) {
                    // expected (but not strictly required) to be a single-line comment
                    str = $f9cc26a8c8e9e9ae$export$2d1720544b23b823(str, ctx.indent, this.comment);
                    if (onComment) onComment();
                }
                var vcb = '';
                var valueComment = null;
                if (value instanceof $f9cc26a8c8e9e9ae$export$a07804094c3ecf2d) {
                    if (value.spaceBefore) vcb = '\n';
                    if (value.commentBefore) {
                        var cs = value.commentBefore.replace(/^/gm, "".concat(ctx.indent, "#"));
                        vcb += "\n".concat(cs);
                    }
                    valueComment = value.comment;
                } else if (value && (0, $5lj6y.a)(value) === 'object') value = doc.schema.createNode(value, true);
                ctx.implicitKey = false;
                if (!explicitKey && !this.comment && value instanceof $f9cc26a8c8e9e9ae$export$25ce5a424b770e84) ctx.indentAtStart = str.length + 1;
                chompKeep = false;
                if (!indentSeq && indentSize >= 2 && !ctx.inFlow && !explicitKey && value instanceof $f9cc26a8c8e9e9ae$export$8743009a87fcb00f && value.type !== (0, $5lj6y.T).FLOW_SEQ && !value.tag && !doc.anchors.getName(value)) // If indentSeq === false, consider '- ' as part of indentation where possible
                ctx.indent = ctx.indent.substr(2);
                var valueStr = stringify(value, ctx, function() {
                    return valueComment = null;
                }, function() {
                    return chompKeep = true;
                });
                var ws = ' ';
                if (vcb || this.comment) ws = "".concat(vcb, "\n").concat(ctx.indent);
                else if (!explicitKey && value instanceof $f9cc26a8c8e9e9ae$export$e7094788287c5e9b) {
                    var flow = valueStr[0] === '[' || valueStr[0] === '{';
                    if (!flow || valueStr.includes('\n')) ws = "\n".concat(ctx.indent);
                } else if (valueStr[0] === '\n') ws = '';
                if (chompKeep && !valueComment && onChompKeep) onChompKeep();
                return $f9cc26a8c8e9e9ae$export$2d1720544b23b823(str + ws + valueStr, ctx.indent, valueComment);
            }
        }
    ]);
    return Pair;
}($f9cc26a8c8e9e9ae$export$a07804094c3ecf2d);
(0, $5lj6y.e)($f9cc26a8c8e9e9ae$export$56c0d5a1e737357d, "Type", {
    PAIR: 'PAIR',
    MERGE_PAIR: 'MERGE_PAIR'
});
var $f9cc26a8c8e9e9ae$var$getAliasCount = function getAliasCount(node, anchors) {
    if (node instanceof $f9cc26a8c8e9e9ae$export$ebd11618f299a286) {
        var anchor = anchors.get(node.source);
        return anchor.count * anchor.aliasCount;
    } else if (node instanceof $f9cc26a8c8e9e9ae$export$e7094788287c5e9b) {
        var count = 0;
        var _iterator = (0, $5lj6y._)(node.items), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var item = _step.value;
                var c = getAliasCount(item, anchors);
                if (c > count) count = c;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return count;
    } else if (node instanceof $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d) {
        var kc = getAliasCount(node.key, anchors);
        var vc = getAliasCount(node.value, anchors);
        return Math.max(kc, vc);
    }
    return 1;
};
var $f9cc26a8c8e9e9ae$export$ebd11618f299a286 = /*#__PURE__*/ function(_Node) {
    (0, $5lj6y.j)(Alias, _Node);
    var _super = (0, $5lj6y.k)(Alias);
    function Alias(source) {
        var _this;
        (0, $5lj6y.c)(this, Alias);
        _this = _super.call(this);
        _this.source = source;
        _this.type = (0, $5lj6y.T).ALIAS;
        return _this;
    }
    (0, $5lj6y.b)(Alias, [
        {
            key: "tag",
            set: function set(t) {
                throw new Error('Alias nodes cannot have tags');
            }
        },
        {
            key: "toJSON",
            value: function toJSON$1(arg, ctx) {
                if (!ctx) return $f9cc26a8c8e9e9ae$export$625550452a3fa3ec(this.source, arg, ctx);
                var anchors = ctx.anchors, maxAliasCount = ctx.maxAliasCount;
                var anchor = anchors.get(this.source);
                /* istanbul ignore if */ if (!anchor || anchor.res === undefined) {
                    var msg = 'This should not happen: Alias anchor was not resolved?';
                    if (this.cstNode) throw new (0, $5lj6y.o)(this.cstNode, msg);
                    else throw new ReferenceError(msg);
                }
                if (maxAliasCount >= 0) {
                    anchor.count += 1;
                    if (anchor.aliasCount === 0) anchor.aliasCount = $f9cc26a8c8e9e9ae$var$getAliasCount(this.source, anchors);
                    if (anchor.count * anchor.aliasCount > maxAliasCount) {
                        var _msg = 'Excessive alias count indicates a resource exhaustion attack';
                        if (this.cstNode) throw new (0, $5lj6y.o)(this.cstNode, _msg);
                        else throw new ReferenceError(_msg);
                    }
                }
                return anchor.res;
            } // Only called when stringifying an alias mapping key while constructing
        },
        {
            key: "toString",
            value: function toString(ctx) {
                return Alias.stringify(this, ctx);
            }
        }
    ], [
        {
            key: "stringify",
            value: function stringify(_ref, _ref2) {
                var range = _ref.range, source = _ref.source;
                var anchors = _ref2.anchors, doc = _ref2.doc, implicitKey = _ref2.implicitKey, inStringifyKey = _ref2.inStringifyKey;
                var anchor = Object.keys(anchors).find(function(a) {
                    return anchors[a] === source;
                });
                if (!anchor && inStringifyKey) anchor = doc.anchors.getName(source) || doc.anchors.newName();
                if (anchor) return "*".concat(anchor).concat(implicitKey ? ' ' : '');
                var msg = doc.anchors.getName(source) ? 'Alias node must be after source node' : 'Source node not found for alias node';
                throw new Error("".concat(msg, " [").concat(range, "]"));
            }
        }
    ]);
    return Alias;
}($f9cc26a8c8e9e9ae$export$a07804094c3ecf2d);
(0, $5lj6y.e)($f9cc26a8c8e9e9ae$export$ebd11618f299a286, "default", true);
function $f9cc26a8c8e9e9ae$export$882b5998b3b9117c(items, key) {
    var k = key instanceof $f9cc26a8c8e9e9ae$export$25ce5a424b770e84 ? key.value : key;
    var _iterator = (0, $5lj6y._)(items), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var it = _step.value;
            if (it instanceof $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d) {
                if (it.key === key || it.key === k) return it;
                if (it.key && it.key.value === k) return it;
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return undefined;
}
var $f9cc26a8c8e9e9ae$export$4368d992c4eafac0 = /*#__PURE__*/ function(_Collection) {
    (0, $5lj6y.j)(YAMLMap, _Collection);
    var _super = (0, $5lj6y.k)(YAMLMap);
    function YAMLMap() {
        (0, $5lj6y.c)(this, YAMLMap);
        return _super.apply(this, arguments);
    }
    (0, $5lj6y.b)(YAMLMap, [
        {
            key: "add",
            value: function add(pair, overwrite) {
                if (!pair) pair = new $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d(pair);
                else if (!(pair instanceof $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d)) pair = new $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d(pair.key || pair, pair.value);
                var prev = $f9cc26a8c8e9e9ae$export$882b5998b3b9117c(this.items, pair.key);
                var sortEntries = this.schema && this.schema.sortMapEntries;
                if (prev) {
                    if (overwrite) prev.value = pair.value;
                    else throw new Error("Key ".concat(pair.key, " already set"));
                } else if (sortEntries) {
                    var i = this.items.findIndex(function(item) {
                        return sortEntries(pair, item) < 0;
                    });
                    if (i === -1) this.items.push(pair);
                    else this.items.splice(i, 0, pair);
                } else this.items.push(pair);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                var it = $f9cc26a8c8e9e9ae$export$882b5998b3b9117c(this.items, key);
                if (!it) return false;
                var del = this.items.splice(this.items.indexOf(it), 1);
                return del.length > 0;
            }
        },
        {
            key: "get",
            value: function get(key, keepScalar) {
                var it = $f9cc26a8c8e9e9ae$export$882b5998b3b9117c(this.items, key);
                var node = it && it.value;
                return !keepScalar && node instanceof $f9cc26a8c8e9e9ae$export$25ce5a424b770e84 ? node.value : node;
            }
        },
        {
            key: "has",
            value: function has(key) {
                return !!$f9cc26a8c8e9e9ae$export$882b5998b3b9117c(this.items, key);
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                this.add(new $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d(key, value), true);
            }
        },
        {
            key: "toJSON",
            value: function toJSON(_, ctx, Type) {
                var map = Type ? new Type() : ctx && ctx.mapAsMap ? new Map() : {};
                if (ctx && ctx.onCreate) ctx.onCreate(map);
                var _iterator2 = (0, $5lj6y._)(this.items), _step2;
                try {
                    for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                        var item = _step2.value;
                        item.addToJSMap(ctx, map);
                    }
                } catch (err) {
                    _iterator2.e(err);
                } finally{
                    _iterator2.f();
                }
                return map;
            }
        },
        {
            key: "toString",
            value: function toString(ctx, onComment, onChompKeep) {
                if (!ctx) return JSON.stringify(this);
                var _iterator3 = (0, $5lj6y._)(this.items), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var item = _step3.value;
                        if (!(item instanceof $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d)) throw new Error("Map items must all be pairs; found ".concat(JSON.stringify(item), " instead"));
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                return (0, $5lj6y.l)((0, $5lj6y.m)(YAMLMap.prototype), "toString", this).call(this, ctx, {
                    blockItem: function blockItem(n) {
                        return n.str;
                    },
                    flowChars: {
                        start: '{',
                        end: '}'
                    },
                    isMap: true,
                    itemIndent: ctx.indent || ''
                }, onComment, onChompKeep);
            }
        }
    ]);
    return YAMLMap;
}($f9cc26a8c8e9e9ae$export$e7094788287c5e9b);
var $f9cc26a8c8e9e9ae$var$MERGE_KEY = '<<';
var $f9cc26a8c8e9e9ae$export$3a1a48c8f6ef640e = /*#__PURE__*/ function(_Pair) {
    (0, $5lj6y.j)(Merge, _Pair);
    var _super = (0, $5lj6y.k)(Merge);
    function Merge(pair) {
        var _this;
        (0, $5lj6y.c)(this, Merge);
        if (pair instanceof $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d) {
            var seq = pair.value;
            if (!(seq instanceof $f9cc26a8c8e9e9ae$export$8743009a87fcb00f)) {
                seq = new $f9cc26a8c8e9e9ae$export$8743009a87fcb00f();
                seq.items.push(pair.value);
                seq.range = pair.value.range;
            }
            _this = _super.call(this, pair.key, seq);
            _this.range = pair.range;
        } else _this = _super.call(this, new $f9cc26a8c8e9e9ae$export$25ce5a424b770e84($f9cc26a8c8e9e9ae$var$MERGE_KEY), new $f9cc26a8c8e9e9ae$export$8743009a87fcb00f());
        _this.type = $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d.Type.MERGE_PAIR;
        return (0, $5lj6y.r)(_this);
    } // If the value associated with a merge key is a single mapping node, each of
    // its key/value pairs is inserted into the current mapping, unless the key
    // already exists in it. If the value associated with the merge key is a
    // sequence, then this sequence is expected to contain mapping nodes and each
    // of these nodes is merged in turn according to its order in the sequence.
    // Keys in mapping nodes earlier in the sequence override keys specified in
    // later mapping nodes. -- http://yaml.org/type/merge.html
    (0, $5lj6y.b)(Merge, [
        {
            key: "addToJSMap",
            value: function addToJSMap(ctx, map) {
                var _iterator = (0, $5lj6y._)(this.value.items), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var source = _step.value.source;
                        if (!(source instanceof $f9cc26a8c8e9e9ae$export$4368d992c4eafac0)) throw new Error('Merge sources must be maps');
                        var srcMap = source.toJSON(null, ctx, Map);
                        var _iterator2 = (0, $5lj6y._)(srcMap), _step2;
                        try {
                            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                                var _step2$value = (0, $5lj6y.h)(_step2.value, 2), key = _step2$value[0], value = _step2$value[1];
                                if (map instanceof Map) {
                                    if (!map.has(key)) map.set(key, value);
                                } else if (map instanceof Set) map.add(key);
                                else if (!Object.prototype.hasOwnProperty.call(map, key)) Object.defineProperty(map, key, {
                                    value: value,
                                    writable: true,
                                    enumerable: true,
                                    configurable: true
                                });
                            }
                        } catch (err) {
                            _iterator2.e(err);
                        } finally{
                            _iterator2.f();
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return map;
            }
        },
        {
            key: "toString",
            value: function toString(ctx, onComment) {
                var seq = this.value;
                if (seq.items.length > 1) return (0, $5lj6y.l)((0, $5lj6y.m)(Merge.prototype), "toString", this).call(this, ctx, onComment);
                this.value = seq.items[0];
                var str = (0, $5lj6y.l)((0, $5lj6y.m)(Merge.prototype), "toString", this).call(this, ctx, onComment);
                this.value = seq;
                return str;
            }
        }
    ]);
    return Merge;
}($f9cc26a8c8e9e9ae$export$56c0d5a1e737357d);
var $f9cc26a8c8e9e9ae$export$8b22cf2602fb60ce = {
    defaultType: (0, $5lj6y.T).BLOCK_LITERAL,
    lineWidth: 76
};
var $f9cc26a8c8e9e9ae$export$407448d2b89b1813 = {
    trueStr: 'true',
    falseStr: 'false'
};
var $f9cc26a8c8e9e9ae$export$23f2a1d2818174ef = {
    asBigInt: false
};
var $f9cc26a8c8e9e9ae$export$7ccc53e8f1e7dfc5 = {
    nullStr: 'null'
};
var $f9cc26a8c8e9e9ae$export$2408f22a0fab9ae5 = {
    defaultType: (0, $5lj6y.T).PLAIN,
    doubleQuoted: {
        jsonEncoding: false,
        minMultiLineLength: 40
    },
    fold: {
        lineWidth: 80,
        minContentWidth: 20
    }
};
function $f9cc26a8c8e9e9ae$var$resolveScalar(str, tags, scalarFallback) {
    var _iterator = (0, $5lj6y._)(tags), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, format = _step$value.format, test = _step$value.test, resolve = _step$value.resolve;
            if (test) {
                var match = str.match(test);
                if (match) {
                    var res = resolve.apply(null, match);
                    if (!(res instanceof $f9cc26a8c8e9e9ae$export$25ce5a424b770e84)) res = new $f9cc26a8c8e9e9ae$export$25ce5a424b770e84(res);
                    if (format) res.format = format;
                    return res;
                }
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (scalarFallback) str = scalarFallback(str);
    return new $f9cc26a8c8e9e9ae$export$25ce5a424b770e84(str);
}
var $f9cc26a8c8e9e9ae$var$FOLD_FLOW = 'flow';
var $f9cc26a8c8e9e9ae$var$FOLD_BLOCK = 'block';
var $f9cc26a8c8e9e9ae$var$FOLD_QUOTED = 'quoted'; // presumes i+1 is at the start of a line
// returns index of last newline in more-indented block
var $f9cc26a8c8e9e9ae$var$consumeMoreIndentedLines = function consumeMoreIndentedLines(text, i) {
    var ch = text[i + 1];
    while(ch === ' ' || ch === '\t'){
        do ch = text[i += 1];
        while (ch && ch !== '\n');
        ch = text[i + 1];
    }
    return i;
};
/**
 * Tries to keep input at up to `lineWidth` characters, splitting only on spaces
 * not followed by newlines or spaces unless `mode` is `'quoted'`. Lines are
 * terminated with `\n` and started with `indent`.
 *
 * @param {string} text
 * @param {string} indent
 * @param {string} [mode='flow'] `'block'` prevents more-indented lines
 *   from being folded; `'quoted'` allows for `\` escapes, including escaped
 *   newlines
 * @param {Object} options
 * @param {number} [options.indentAtStart] Accounts for leading contents on
 *   the first line, defaulting to `indent.length`
 * @param {number} [options.lineWidth=80]
 * @param {number} [options.minContentWidth=20] Allow highly indented lines to
 *   stretch the line width or indent content from the start
 * @param {function} options.onFold Called once if the text is folded
 * @param {function} options.onFold Called once if any line of text exceeds
 *   lineWidth characters
 */ function $f9cc26a8c8e9e9ae$var$foldFlowLines(text, indent, mode, _ref) {
    var indentAtStart = _ref.indentAtStart, _ref$lineWidth = _ref.lineWidth, lineWidth = _ref$lineWidth === void 0 ? 80 : _ref$lineWidth, _ref$minContentWidth = _ref.minContentWidth, minContentWidth = _ref$minContentWidth === void 0 ? 20 : _ref$minContentWidth, onFold = _ref.onFold, onOverflow = _ref.onOverflow;
    if (!lineWidth || lineWidth < 0) return text;
    var endStep = Math.max(1 + minContentWidth, 1 + lineWidth - indent.length);
    if (text.length <= endStep) return text;
    var folds = [];
    var escapedFolds = {};
    var end = lineWidth - indent.length;
    if (typeof indentAtStart === 'number') {
        if (indentAtStart > lineWidth - Math.max(2, minContentWidth)) folds.push(0);
        else end = lineWidth - indentAtStart;
    }
    var split = undefined;
    var prev = undefined;
    var overflow = false;
    var i = -1;
    var escStart = -1;
    var escEnd = -1;
    if (mode === $f9cc26a8c8e9e9ae$var$FOLD_BLOCK) {
        i = $f9cc26a8c8e9e9ae$var$consumeMoreIndentedLines(text, i);
        if (i !== -1) end = i + endStep;
    }
    for(var ch; ch = text[i += 1];){
        if (mode === $f9cc26a8c8e9e9ae$var$FOLD_QUOTED && ch === '\\') {
            escStart = i;
            switch(text[i + 1]){
                case 'x':
                    i += 3;
                    break;
                case 'u':
                    i += 5;
                    break;
                case 'U':
                    i += 9;
                    break;
                default:
                    i += 1;
            }
            escEnd = i;
        }
        if (ch === '\n') {
            if (mode === $f9cc26a8c8e9e9ae$var$FOLD_BLOCK) i = $f9cc26a8c8e9e9ae$var$consumeMoreIndentedLines(text, i);
            end = i + endStep;
            split = undefined;
        } else {
            if (ch === ' ' && prev && prev !== ' ' && prev !== '\n' && prev !== '\t') {
                // space surrounded by non-space can be replaced with newline + indent
                var next = text[i + 1];
                if (next && next !== ' ' && next !== '\n' && next !== '\t') split = i;
            }
            if (i >= end) {
                if (split) {
                    folds.push(split);
                    end = split + endStep;
                    split = undefined;
                } else if (mode === $f9cc26a8c8e9e9ae$var$FOLD_QUOTED) {
                    // white-space collected at end may stretch past lineWidth
                    while(prev === ' ' || prev === '\t'){
                        prev = ch;
                        ch = text[i += 1];
                        overflow = true;
                    } // Account for newline escape, but don't break preceding escape
                    var j = i > escEnd + 1 ? i - 2 : escStart - 1; // Bail out if lineWidth & minContentWidth are shorter than an escape string
                    if (escapedFolds[j]) return text;
                    folds.push(j);
                    escapedFolds[j] = true;
                    end = j + endStep;
                    split = undefined;
                } else overflow = true;
            }
        }
        prev = ch;
    }
    if (overflow && onOverflow) onOverflow();
    if (folds.length === 0) return text;
    if (onFold) onFold();
    var res = text.slice(0, folds[0]);
    for(var _i = 0; _i < folds.length; ++_i){
        var fold = folds[_i];
        var _end = folds[_i + 1] || text.length;
        if (fold === 0) res = "\n".concat(indent).concat(text.slice(0, _end));
        else {
            if (mode === $f9cc26a8c8e9e9ae$var$FOLD_QUOTED && escapedFolds[fold]) res += "".concat(text[fold], "\\");
            res += "\n".concat(indent).concat(text.slice(fold + 1, _end));
        }
    }
    return res;
}
var $f9cc26a8c8e9e9ae$var$getFoldOptions = function getFoldOptions(_ref) {
    var indentAtStart = _ref.indentAtStart;
    return indentAtStart ? Object.assign({
        indentAtStart: indentAtStart
    }, $f9cc26a8c8e9e9ae$export$2408f22a0fab9ae5.fold) : $f9cc26a8c8e9e9ae$export$2408f22a0fab9ae5.fold;
}; // Also checks for lines starting with %, as parsing the output as YAML 1.1 will
// presume that's starting a new document.
var $f9cc26a8c8e9e9ae$var$containsDocumentMarker = function containsDocumentMarker(str) {
    return /^(%|---|\.\.\.)/m.test(str);
};
function $f9cc26a8c8e9e9ae$var$lineLengthOverLimit(str, lineWidth, indentLength) {
    if (!lineWidth || lineWidth < 0) return false;
    var limit = lineWidth - indentLength;
    var strLen = str.length;
    if (strLen <= limit) return false;
    for(var i = 0, start = 0; i < strLen; ++i)if (str[i] === '\n') {
        if (i - start > limit) return true;
        start = i + 1;
        if (strLen - start <= limit) return false;
    }
    return true;
}
function $f9cc26a8c8e9e9ae$var$doubleQuotedString(value, ctx) {
    var implicitKey = ctx.implicitKey;
    var _strOptions$doubleQuo = $f9cc26a8c8e9e9ae$export$2408f22a0fab9ae5.doubleQuoted, jsonEncoding = _strOptions$doubleQuo.jsonEncoding, minMultiLineLength = _strOptions$doubleQuo.minMultiLineLength;
    var json = JSON.stringify(value);
    if (jsonEncoding) return json;
    var indent = ctx.indent || ($f9cc26a8c8e9e9ae$var$containsDocumentMarker(value) ? '  ' : '');
    var str = '';
    var start = 0;
    for(var i = 0, ch = json[i]; ch; ch = json[++i]){
        if (ch === ' ' && json[i + 1] === '\\' && json[i + 2] === 'n') {
            // space before newline needs to be escaped to not be folded
            str += json.slice(start, i) + '\\ ';
            i += 1;
            start = i;
            ch = '\\';
        }
        if (ch === '\\') switch(json[i + 1]){
            case 'u':
                str += json.slice(start, i);
                var code = json.substr(i + 2, 4);
                switch(code){
                    case '0000':
                        str += '\\0';
                        break;
                    case '0007':
                        str += '\\a';
                        break;
                    case '000b':
                        str += '\\v';
                        break;
                    case '001b':
                        str += '\\e';
                        break;
                    case '0085':
                        str += '\\N';
                        break;
                    case '00a0':
                        str += '\\_';
                        break;
                    case '2028':
                        str += '\\L';
                        break;
                    case '2029':
                        str += '\\P';
                        break;
                    default:
                        if (code.substr(0, 2) === '00') str += '\\x' + code.substr(2);
                        else str += json.substr(i, 6);
                }
                i += 5;
                start = i + 1;
                break;
            case 'n':
                if (implicitKey || json[i + 2] === '"' || json.length < minMultiLineLength) i += 1;
                else {
                    // folding will eat first newline
                    str += json.slice(start, i) + '\n\n';
                    while(json[i + 2] === '\\' && json[i + 3] === 'n' && json[i + 4] !== '"'){
                        str += '\n';
                        i += 2;
                    }
                    str += indent; // space after newline needs to be escaped to not be folded
                    if (json[i + 2] === ' ') str += '\\';
                    i += 1;
                    start = i + 1;
                }
                break;
            default:
                i += 1;
        }
    }
    str = start ? str + json.slice(start) : json;
    return implicitKey ? str : $f9cc26a8c8e9e9ae$var$foldFlowLines(str, indent, $f9cc26a8c8e9e9ae$var$FOLD_QUOTED, $f9cc26a8c8e9e9ae$var$getFoldOptions(ctx));
}
function $f9cc26a8c8e9e9ae$var$singleQuotedString(value, ctx) {
    if (ctx.implicitKey) {
        if (/\n/.test(value)) return $f9cc26a8c8e9e9ae$var$doubleQuotedString(value, ctx);
    } else {
        // single quoted string can't have leading or trailing whitespace around newline
        if (/[ \t]\n|\n[ \t]/.test(value)) return $f9cc26a8c8e9e9ae$var$doubleQuotedString(value, ctx);
    }
    var indent = ctx.indent || ($f9cc26a8c8e9e9ae$var$containsDocumentMarker(value) ? '  ' : '');
    var res = "'" + value.replace(/'/g, "''").replace(/\n+/g, "$&\n".concat(indent)) + "'";
    return ctx.implicitKey ? res : $f9cc26a8c8e9e9ae$var$foldFlowLines(res, indent, $f9cc26a8c8e9e9ae$var$FOLD_FLOW, $f9cc26a8c8e9e9ae$var$getFoldOptions(ctx));
}
function $f9cc26a8c8e9e9ae$var$blockString(_ref2, ctx, onComment, onChompKeep) {
    var comment = _ref2.comment, type = _ref2.type, value = _ref2.value;
    // 1. Block can't end in whitespace unless the last line is non-empty.
    // 2. Strings consisting of only whitespace are best rendered explicitly.
    if (/\n[\t ]+$/.test(value) || /^\s*$/.test(value)) return $f9cc26a8c8e9e9ae$var$doubleQuotedString(value, ctx);
    var indent = ctx.indent || (ctx.forceBlockIndent || $f9cc26a8c8e9e9ae$var$containsDocumentMarker(value) ? '  ' : '');
    var indentSize = indent ? '2' : '1'; // root is at -1
    var literal = type === (0, $5lj6y.T).BLOCK_FOLDED ? false : type === (0, $5lj6y.T).BLOCK_LITERAL ? true : !$f9cc26a8c8e9e9ae$var$lineLengthOverLimit(value, $f9cc26a8c8e9e9ae$export$2408f22a0fab9ae5.fold.lineWidth, indent.length);
    var header = literal ? '|' : '>';
    if (!value) return header + '\n';
    var wsStart = '';
    var wsEnd = '';
    value = value.replace(/[\n\t ]*$/, function(ws) {
        var n = ws.indexOf('\n');
        if (n === -1) header += '-'; // strip
        else if (value === ws || n !== ws.length - 1) {
            header += '+'; // keep
            if (onChompKeep) onChompKeep();
        }
        wsEnd = ws.replace(/\n$/, '');
        return '';
    }).replace(/^[\n ]*/, function(ws) {
        if (ws.indexOf(' ') !== -1) header += indentSize;
        var m = ws.match(/ +$/);
        if (m) {
            wsStart = ws.slice(0, -m[0].length);
            return m[0];
        } else {
            wsStart = ws;
            return '';
        }
    });
    if (wsEnd) wsEnd = wsEnd.replace(/\n+(?!\n|$)/g, "$&".concat(indent));
    if (wsStart) wsStart = wsStart.replace(/\n+/g, "$&".concat(indent));
    if (comment) {
        header += ' #' + comment.replace(/ ?[\r\n]+/g, ' ');
        if (onComment) onComment();
    }
    if (!value) return "".concat(header).concat(indentSize, "\n").concat(indent).concat(wsEnd);
    if (literal) {
        value = value.replace(/\n+/g, "$&".concat(indent));
        return "".concat(header, "\n").concat(indent).concat(wsStart).concat(value).concat(wsEnd);
    }
    value = value.replace(/\n+/g, '\n$&').replace(/(?:^|\n)([\t ].*)(?:([\n\t ]*)\n(?![\n\t ]))?/g, '$1$2') // more-indented lines aren't folded
    //         ^ ind.line  ^ empty     ^ capture next empty lines only at end of indent
    .replace(/\n+/g, "$&".concat(indent));
    var body = $f9cc26a8c8e9e9ae$var$foldFlowLines("".concat(wsStart).concat(value).concat(wsEnd), indent, $f9cc26a8c8e9e9ae$var$FOLD_BLOCK, $f9cc26a8c8e9e9ae$export$2408f22a0fab9ae5.fold);
    return "".concat(header, "\n").concat(indent).concat(body);
}
function $f9cc26a8c8e9e9ae$var$plainString(item, ctx, onComment, onChompKeep) {
    var comment = item.comment, type = item.type, value = item.value;
    var actualString = ctx.actualString, implicitKey = ctx.implicitKey, indent = ctx.indent, inFlow = ctx.inFlow;
    if (implicitKey && /[\n[\]{},]/.test(value) || inFlow && /[[\]{},]/.test(value)) return $f9cc26a8c8e9e9ae$var$doubleQuotedString(value, ctx);
    if (!value || /^[\n\t ,[\]{}#&*!|>'"%@`]|^[?-]$|^[?-][ \t]|[\n:][ \t]|[ \t]\n|[\n\t ]#|[\n\t :]$/.test(value)) // not allowed:
    // - empty string, '-' or '?'
    // - start with an indicator character (except [?:-]) or /[?-] /
    // - '\n ', ': ' or ' \n' anywhere
    // - '#' not preceded by a non-space char
    // - end with ' ' or ':'
    return implicitKey || inFlow || value.indexOf('\n') === -1 ? value.indexOf('"') !== -1 && value.indexOf("'") === -1 ? $f9cc26a8c8e9e9ae$var$singleQuotedString(value, ctx) : $f9cc26a8c8e9e9ae$var$doubleQuotedString(value, ctx) : $f9cc26a8c8e9e9ae$var$blockString(item, ctx, onComment, onChompKeep);
    if (!implicitKey && !inFlow && type !== (0, $5lj6y.T).PLAIN && value.indexOf('\n') !== -1) // Where allowed & type not set explicitly, prefer block style for multiline strings
    return $f9cc26a8c8e9e9ae$var$blockString(item, ctx, onComment, onChompKeep);
    if (indent === '' && $f9cc26a8c8e9e9ae$var$containsDocumentMarker(value)) {
        ctx.forceBlockIndent = true;
        return $f9cc26a8c8e9e9ae$var$blockString(item, ctx, onComment, onChompKeep);
    }
    var str = value.replace(/\n+/g, "$&\n".concat(indent)); // Verify that output will be parsed as a string, as e.g. plain numbers and
    // booleans get parsed with those types in v1.2 (e.g. '42', 'true' & '0.9e-3'),
    // and others in v1.1.
    if (actualString) {
        var tags = ctx.doc.schema.tags;
        var resolved = $f9cc26a8c8e9e9ae$var$resolveScalar(str, tags, tags.scalarFallback).value;
        if (typeof resolved !== 'string') return $f9cc26a8c8e9e9ae$var$doubleQuotedString(value, ctx);
    }
    var body = implicitKey ? str : $f9cc26a8c8e9e9ae$var$foldFlowLines(str, indent, $f9cc26a8c8e9e9ae$var$FOLD_FLOW, $f9cc26a8c8e9e9ae$var$getFoldOptions(ctx));
    if (comment && !inFlow && (body.indexOf('\n') !== -1 || comment.indexOf('\n') !== -1)) {
        if (onComment) onComment();
        return $f9cc26a8c8e9e9ae$var$addCommentBefore(body, indent, comment);
    }
    return body;
}
function $f9cc26a8c8e9e9ae$export$db3b6bfb95261072(item, ctx, onComment, onChompKeep) {
    var defaultType = $f9cc26a8c8e9e9ae$export$2408f22a0fab9ae5.defaultType;
    var implicitKey = ctx.implicitKey, inFlow = ctx.inFlow;
    var _item = item, type = _item.type, value = _item.value;
    if (typeof value !== 'string') {
        value = String(value);
        item = Object.assign({}, item, {
            value: value
        });
    }
    var _stringify = function _stringify(_type) {
        switch(_type){
            case (0, $5lj6y.T).BLOCK_FOLDED:
            case (0, $5lj6y.T).BLOCK_LITERAL:
                return $f9cc26a8c8e9e9ae$var$blockString(item, ctx, onComment, onChompKeep);
            case (0, $5lj6y.T).QUOTE_DOUBLE:
                return $f9cc26a8c8e9e9ae$var$doubleQuotedString(value, ctx);
            case (0, $5lj6y.T).QUOTE_SINGLE:
                return $f9cc26a8c8e9e9ae$var$singleQuotedString(value, ctx);
            case (0, $5lj6y.T).PLAIN:
                return $f9cc26a8c8e9e9ae$var$plainString(item, ctx, onComment, onChompKeep);
            default:
                return null;
        }
    };
    if (type !== (0, $5lj6y.T).QUOTE_DOUBLE && /[\x00-\x08\x0b-\x1f\x7f-\x9f]/.test(value)) // force double quotes on control characters
    type = (0, $5lj6y.T).QUOTE_DOUBLE;
    else if ((implicitKey || inFlow) && (type === (0, $5lj6y.T).BLOCK_FOLDED || type === (0, $5lj6y.T).BLOCK_LITERAL)) // should not happen; blocks are not valid inside flow containers
    type = (0, $5lj6y.T).QUOTE_DOUBLE;
    var res = _stringify(type);
    if (res === null) {
        res = _stringify(defaultType);
        if (res === null) throw new Error("Unsupported default string type ".concat(defaultType));
    }
    return res;
}
function $f9cc26a8c8e9e9ae$export$342063e11d6c3cad(_ref) {
    var format = _ref.format, minFractionDigits = _ref.minFractionDigits, tag = _ref.tag, value = _ref.value;
    if (typeof value === 'bigint') return String(value);
    if (!isFinite(value)) return isNaN(value) ? '.nan' : value < 0 ? '-.inf' : '.inf';
    var n = JSON.stringify(value);
    if (!format && minFractionDigits && (!tag || tag === 'tag:yaml.org,2002:float') && /^\d/.test(n)) {
        var i = n.indexOf('.');
        if (i < 0) {
            i = n.length;
            n += '.';
        }
        var d = minFractionDigits - (n.length - i - 1);
        while(d-- > 0)n += '0';
    }
    return n;
}
function $f9cc26a8c8e9e9ae$var$checkFlowCollectionEnd(errors, cst) {
    var char, name;
    switch(cst.type){
        case (0, $5lj6y.T).FLOW_MAP:
            char = '}';
            name = 'flow map';
            break;
        case (0, $5lj6y.T).FLOW_SEQ:
            char = ']';
            name = 'flow sequence';
            break;
        default:
            errors.push(new (0, $5lj6y.g)(cst, 'Not a flow collection!?'));
            return;
    }
    var lastItem;
    for(var i = cst.items.length - 1; i >= 0; --i){
        var item = cst.items[i];
        if (!item || item.type !== (0, $5lj6y.T).COMMENT) {
            lastItem = item;
            break;
        }
    }
    if (lastItem && lastItem.char !== char) {
        var msg = "Expected ".concat(name, " to end with ").concat(char);
        var err;
        if (typeof lastItem.offset === 'number') {
            err = new (0, $5lj6y.g)(cst, msg);
            err.offset = lastItem.offset + 1;
        } else {
            err = new (0, $5lj6y.g)(lastItem, msg);
            if (lastItem.range && lastItem.range.end) err.offset = lastItem.range.end - lastItem.range.start;
        }
        errors.push(err);
    }
}
function $f9cc26a8c8e9e9ae$var$checkFlowCommentSpace(errors, comment) {
    var prev = comment.context.src[comment.range.start - 1];
    if (prev !== '\n' && prev !== '\t' && prev !== ' ') {
        var msg = 'Comments must be separated from other tokens by white space characters';
        errors.push(new (0, $5lj6y.g)(comment, msg));
    }
}
function $f9cc26a8c8e9e9ae$var$getLongKeyError(source, key) {
    var sk = String(key);
    var k = sk.substr(0, 8) + '...' + sk.substr(-8);
    return new (0, $5lj6y.g)(source, "The \"".concat(k, "\" key is too long"));
}
function $f9cc26a8c8e9e9ae$var$resolveComments(collection, comments) {
    var _iterator = (0, $5lj6y._)(comments), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, afterKey = _step$value.afterKey, before = _step$value.before, comment = _step$value.comment;
            var item = collection.items[before];
            if (!item) {
                if (comment !== undefined) {
                    if (collection.comment) collection.comment += '\n' + comment;
                    else collection.comment = comment;
                }
            } else {
                if (afterKey && item.value) item = item.value;
                if (comment === undefined) {
                    if (afterKey || !item.commentBefore) item.spaceBefore = true;
                } else if (item.commentBefore) item.commentBefore += '\n' + comment;
                else item.commentBefore = comment;
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
// on error, will return { str: string, errors: Error[] }
function $f9cc26a8c8e9e9ae$export$35e795649ee09318(doc, node) {
    var res = node.strValue;
    if (!res) return '';
    if (typeof res === 'string') return res;
    res.errors.forEach(function(error) {
        if (!error.source) error.source = node;
        doc.errors.push(error);
    });
    return res.str;
}
function $f9cc26a8c8e9e9ae$var$resolveTagHandle(doc, node) {
    var _node$tag = node.tag, handle = _node$tag.handle, suffix = _node$tag.suffix;
    var prefix = doc.tagPrefixes.find(function(p) {
        return p.handle === handle;
    });
    if (!prefix) {
        var dtp = doc.getDefaults().tagPrefixes;
        if (dtp) prefix = dtp.find(function(p) {
            return p.handle === handle;
        });
        if (!prefix) throw new (0, $5lj6y.g)(node, "The ".concat(handle, " tag handle is non-default and was not declared."));
    }
    if (!suffix) throw new (0, $5lj6y.g)(node, "The ".concat(handle, " tag has no suffix."));
    if (handle === '!' && (doc.version || doc.options.version) === '1.0') {
        if (suffix[0] === '^') {
            doc.warnings.push(new (0, $5lj6y.f)(node, 'YAML 1.0 ^ tag expansion is not supported'));
            return suffix;
        }
        if (/[:/]/.test(suffix)) {
            // word/foo -> tag:word.yaml.org,2002:foo
            var vocab = suffix.match(/^([a-z0-9-]+)\/(.*)/i);
            return vocab ? "tag:".concat(vocab[1], ".yaml.org,2002:").concat(vocab[2]) : "tag:".concat(suffix);
        }
    }
    return prefix.prefix + decodeURIComponent(suffix);
}
function $f9cc26a8c8e9e9ae$var$resolveTagName(doc, node) {
    var tag = node.tag, type = node.type;
    var nonSpecific = false;
    if (tag) {
        var handle = tag.handle, suffix = tag.suffix, verbatim = tag.verbatim;
        if (verbatim) {
            if (verbatim !== '!' && verbatim !== '!!') return verbatim;
            var msg = "Verbatim tags aren't resolved, so ".concat(verbatim, " is invalid.");
            doc.errors.push(new (0, $5lj6y.g)(node, msg));
        } else if (handle === '!' && !suffix) nonSpecific = true;
        else try {
            return $f9cc26a8c8e9e9ae$var$resolveTagHandle(doc, node);
        } catch (error) {
            doc.errors.push(error);
        }
    }
    switch(type){
        case (0, $5lj6y.T).BLOCK_FOLDED:
        case (0, $5lj6y.T).BLOCK_LITERAL:
        case (0, $5lj6y.T).QUOTE_DOUBLE:
        case (0, $5lj6y.T).QUOTE_SINGLE:
            return (0, $5lj6y.n).STR;
        case (0, $5lj6y.T).FLOW_MAP:
        case (0, $5lj6y.T).MAP:
            return (0, $5lj6y.n).MAP;
        case (0, $5lj6y.T).FLOW_SEQ:
        case (0, $5lj6y.T).SEQ:
            return (0, $5lj6y.n).SEQ;
        case (0, $5lj6y.T).PLAIN:
            return nonSpecific ? (0, $5lj6y.n).STR : null;
        default:
            return null;
    }
}
function $f9cc26a8c8e9e9ae$var$resolveByTagName(doc, node, tagName) {
    var tags = doc.schema.tags;
    var matchWithTest = [];
    var _iterator = (0, $5lj6y._)(tags), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var tag = _step.value;
            if (tag.tag === tagName) {
                if (tag.test) matchWithTest.push(tag);
                else {
                    var res = tag.resolve(doc, node);
                    return res instanceof $f9cc26a8c8e9e9ae$export$e7094788287c5e9b ? res : new $f9cc26a8c8e9e9ae$export$25ce5a424b770e84(res);
                }
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var str = $f9cc26a8c8e9e9ae$export$35e795649ee09318(doc, node);
    if (typeof str === 'string' && matchWithTest.length > 0) return $f9cc26a8c8e9e9ae$var$resolveScalar(str, matchWithTest, tags.scalarFallback);
    return null;
}
function $f9cc26a8c8e9e9ae$var$getFallbackTagName(_ref) {
    var type = _ref.type;
    switch(type){
        case (0, $5lj6y.T).FLOW_MAP:
        case (0, $5lj6y.T).MAP:
            return (0, $5lj6y.n).MAP;
        case (0, $5lj6y.T).FLOW_SEQ:
        case (0, $5lj6y.T).SEQ:
            return (0, $5lj6y.n).SEQ;
        default:
            return (0, $5lj6y.n).STR;
    }
}
function $f9cc26a8c8e9e9ae$var$resolveTag(doc, node, tagName) {
    try {
        var res = $f9cc26a8c8e9e9ae$var$resolveByTagName(doc, node, tagName);
        if (res) {
            if (tagName && node.tag) res.tag = tagName;
            return res;
        }
    } catch (error) {
        /* istanbul ignore if */ if (!error.source) error.source = node;
        doc.errors.push(error);
        return null;
    }
    try {
        var fallback = $f9cc26a8c8e9e9ae$var$getFallbackTagName(node);
        if (!fallback) throw new Error("The tag ".concat(tagName, " is unavailable"));
        var msg = "The tag ".concat(tagName, " is unavailable, falling back to ").concat(fallback);
        doc.warnings.push(new (0, $5lj6y.f)(node, msg));
        var _res = $f9cc26a8c8e9e9ae$var$resolveByTagName(doc, node, fallback);
        _res.tag = tagName;
        return _res;
    } catch (error) {
        var refError = new (0, $5lj6y.o)(node, error.message);
        refError.stack = error.stack;
        doc.errors.push(refError);
        return null;
    }
}
var $f9cc26a8c8e9e9ae$var$isCollectionItem = function isCollectionItem(node) {
    if (!node) return false;
    var type = node.type;
    return type === (0, $5lj6y.T).MAP_KEY || type === (0, $5lj6y.T).MAP_VALUE || type === (0, $5lj6y.T).SEQ_ITEM;
};
function $f9cc26a8c8e9e9ae$var$resolveNodeProps(errors, node) {
    var comments = {
        before: [],
        after: []
    };
    var hasAnchor = false;
    var hasTag = false;
    var props = $f9cc26a8c8e9e9ae$var$isCollectionItem(node.context.parent) ? node.context.parent.props.concat(node.props) : node.props;
    var _iterator = (0, $5lj6y._)(props), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, start = _step$value.start, end = _step$value.end;
            switch(node.context.src[start]){
                case (0, $5lj6y.C).COMMENT:
                    if (!node.commentHasRequiredWhitespace(start)) {
                        var msg = 'Comments must be separated from other tokens by white space characters';
                        errors.push(new (0, $5lj6y.g)(node, msg));
                    }
                    var header = node.header, valueRange = node.valueRange;
                    var cc = valueRange && (start > valueRange.start || header && start > header.start) ? comments.after : comments.before;
                    cc.push(node.context.src.slice(start + 1, end));
                    break;
                // Actual anchor & tag resolution is handled by schema, here we just complain
                case (0, $5lj6y.C).ANCHOR:
                    if (hasAnchor) {
                        var _msg = 'A node can have at most one anchor';
                        errors.push(new (0, $5lj6y.g)(node, _msg));
                    }
                    hasAnchor = true;
                    break;
                case (0, $5lj6y.C).TAG:
                    if (hasTag) {
                        var _msg2 = 'A node can have at most one tag';
                        errors.push(new (0, $5lj6y.g)(node, _msg2));
                    }
                    hasTag = true;
                    break;
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return {
        comments: comments,
        hasAnchor: hasAnchor,
        hasTag: hasTag
    };
}
function $f9cc26a8c8e9e9ae$var$resolveNodeValue(doc, node) {
    var anchors = doc.anchors, errors = doc.errors, schema = doc.schema;
    if (node.type === (0, $5lj6y.T).ALIAS) {
        var name = node.rawValue;
        var src = anchors.getNode(name);
        if (!src) {
            var msg = "Aliased anchor not found: ".concat(name);
            errors.push(new (0, $5lj6y.o)(node, msg));
            return null;
        } // Lazy resolution for circular references
        var res = new $f9cc26a8c8e9e9ae$export$ebd11618f299a286(src);
        anchors._cstAliases.push(res);
        return res;
    }
    var tagName = $f9cc26a8c8e9e9ae$var$resolveTagName(doc, node);
    if (tagName) return $f9cc26a8c8e9e9ae$var$resolveTag(doc, node, tagName);
    if (node.type !== (0, $5lj6y.T).PLAIN) {
        var _msg3 = "Failed to resolve ".concat(node.type, " node here");
        errors.push(new (0, $5lj6y.Y)(node, _msg3));
        return null;
    }
    try {
        var str = $f9cc26a8c8e9e9ae$export$35e795649ee09318(doc, node);
        return $f9cc26a8c8e9e9ae$var$resolveScalar(str, schema.tags, schema.tags.scalarFallback);
    } catch (error) {
        if (!error.source) error.source = node;
        errors.push(error);
        return null;
    }
} // sets node.resolved on success
function $f9cc26a8c8e9e9ae$export$43caf9889c228507(doc, node) {
    if (!node) return null;
    if (node.error) doc.errors.push(node.error);
    var _resolveNodeProps = $f9cc26a8c8e9e9ae$var$resolveNodeProps(doc.errors, node), comments = _resolveNodeProps.comments, hasAnchor = _resolveNodeProps.hasAnchor, hasTag = _resolveNodeProps.hasTag;
    if (hasAnchor) {
        var anchors = doc.anchors;
        var name = node.anchor;
        var prev = anchors.getNode(name); // At this point, aliases for any preceding node with the same anchor
        // name have already been resolved, so it may safely be renamed.
        if (prev) anchors.map[anchors.newName(name)] = prev; // During parsing, we need to store the CST node in anchors.map as
        // anchors need to be available during resolution to allow for
        // circular references.
        anchors.map[name] = node;
    }
    if (node.type === (0, $5lj6y.T).ALIAS && (hasAnchor || hasTag)) {
        var msg = 'An alias node must not specify any properties';
        doc.errors.push(new (0, $5lj6y.g)(node, msg));
    }
    var res = $f9cc26a8c8e9e9ae$var$resolveNodeValue(doc, node);
    if (res) {
        res.range = [
            node.range.start,
            node.range.end
        ];
        if (doc.options.keepCstNodes) res.cstNode = node;
        if (doc.options.keepNodeTypes) res.type = node.type;
        var cb = comments.before.join('\n');
        if (cb) res.commentBefore = res.commentBefore ? "".concat(res.commentBefore, "\n").concat(cb) : cb;
        var ca = comments.after.join('\n');
        if (ca) res.comment = res.comment ? "".concat(res.comment, "\n").concat(ca) : ca;
    }
    return node.resolved = res;
}
function $f9cc26a8c8e9e9ae$export$39b482c5e57630a8(doc, cst) {
    if (cst.type !== (0, $5lj6y.T).MAP && cst.type !== (0, $5lj6y.T).FLOW_MAP) {
        var msg = "A ".concat(cst.type, " node cannot be resolved as a mapping");
        doc.errors.push(new (0, $5lj6y.Y)(cst, msg));
        return null;
    }
    var _ref = cst.type === (0, $5lj6y.T).FLOW_MAP ? $f9cc26a8c8e9e9ae$var$resolveFlowMapItems(doc, cst) : $f9cc26a8c8e9e9ae$var$resolveBlockMapItems(doc, cst), comments = _ref.comments, items = _ref.items;
    var map = new $f9cc26a8c8e9e9ae$export$4368d992c4eafac0();
    map.items = items;
    $f9cc26a8c8e9e9ae$var$resolveComments(map, comments);
    var hasCollectionKey = false;
    for(var i = 0; i < items.length; ++i){
        var iKey = items[i].key;
        if (iKey instanceof $f9cc26a8c8e9e9ae$export$e7094788287c5e9b) hasCollectionKey = true;
        if (doc.schema.merge && iKey && iKey.value === $f9cc26a8c8e9e9ae$var$MERGE_KEY) {
            items[i] = new $f9cc26a8c8e9e9ae$export$3a1a48c8f6ef640e(items[i]);
            var sources = items[i].value.items;
            var error = null;
            sources.some(function(node) {
                if (node instanceof $f9cc26a8c8e9e9ae$export$ebd11618f299a286) {
                    // During parsing, alias sources are CST nodes; to account for
                    // circular references their resolved values can't be used here.
                    var type = node.source.type;
                    if (type === (0, $5lj6y.T).MAP || type === (0, $5lj6y.T).FLOW_MAP) return false;
                    return error = 'Merge nodes aliases can only point to maps';
                }
                return error = 'Merge nodes can only have Alias nodes as values';
            });
            if (error) doc.errors.push(new (0, $5lj6y.g)(cst, error));
        } else for(var j = i + 1; j < items.length; ++j){
            var jKey = items[j].key;
            if (iKey === jKey || iKey && jKey && Object.prototype.hasOwnProperty.call(iKey, 'value') && iKey.value === jKey.value) {
                var _msg = "Map keys must be unique; \"".concat(iKey, "\" is repeated");
                doc.errors.push(new (0, $5lj6y.g)(cst, _msg));
                break;
            }
        }
    }
    if (hasCollectionKey && !doc.options.mapAsMap) {
        var warn = 'Keys with collection values will be stringified as YAML due to JS Object restrictions. Use mapAsMap: true to avoid this.';
        doc.warnings.push(new (0, $5lj6y.f)(cst, warn));
    }
    cst.resolved = map;
    return map;
}
var $f9cc26a8c8e9e9ae$var$valueHasPairComment = function valueHasPairComment(_ref2) {
    var _ref2$context = _ref2.context, lineStart = _ref2$context.lineStart, node = _ref2$context.node, src = _ref2$context.src, props = _ref2.props;
    if (props.length === 0) return false;
    var start = props[0].start;
    if (node && start > node.valueRange.start) return false;
    if (src[start] !== (0, $5lj6y.C).COMMENT) return false;
    for(var i = lineStart; i < start; ++i){
        if (src[i] === '\n') return false;
    }
    return true;
};
function $f9cc26a8c8e9e9ae$var$resolvePairComment(item, pair) {
    if (!$f9cc26a8c8e9e9ae$var$valueHasPairComment(item)) return;
    var comment = item.getPropValue(0, (0, $5lj6y.C).COMMENT, true);
    var found = false;
    var cb = pair.value.commentBefore;
    if (cb && cb.startsWith(comment)) {
        pair.value.commentBefore = cb.substr(comment.length + 1);
        found = true;
    } else {
        var cc = pair.value.comment;
        if (!item.node && cc && cc.startsWith(comment)) {
            pair.value.comment = cc.substr(comment.length + 1);
            found = true;
        }
    }
    if (found) pair.comment = comment;
}
function $f9cc26a8c8e9e9ae$var$resolveBlockMapItems(doc, cst) {
    var comments = [];
    var items = [];
    var key = undefined;
    var keyStart = null;
    for(var i = 0; i < cst.items.length; ++i){
        var item = cst.items[i];
        switch(item.type){
            case (0, $5lj6y.T).BLANK_LINE:
                comments.push({
                    afterKey: !!key,
                    before: items.length
                });
                break;
            case (0, $5lj6y.T).COMMENT:
                comments.push({
                    afterKey: !!key,
                    before: items.length,
                    comment: item.comment
                });
                break;
            case (0, $5lj6y.T).MAP_KEY:
                if (key !== undefined) items.push(new $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d(key));
                if (item.error) doc.errors.push(item.error);
                key = $f9cc26a8c8e9e9ae$export$43caf9889c228507(doc, item.node);
                keyStart = null;
                break;
            case (0, $5lj6y.T).MAP_VALUE:
                if (key === undefined) key = null;
                if (item.error) doc.errors.push(item.error);
                if (!item.context.atLineStart && item.node && item.node.type === (0, $5lj6y.T).MAP && !item.node.context.atLineStart) {
                    var msg = 'Nested mappings are not allowed in compact mappings';
                    doc.errors.push(new (0, $5lj6y.g)(item.node, msg));
                }
                var valueNode = item.node;
                if (!valueNode && item.props.length > 0) {
                    // Comments on an empty mapping value need to be preserved, so we
                    // need to construct a minimal empty node here to use instead of the
                    // missing `item.node`. -- eemeli/yaml#19
                    valueNode = new (0, $5lj6y.P)((0, $5lj6y.T).PLAIN, []);
                    valueNode.context = {
                        parent: item,
                        src: item.context.src
                    };
                    var pos = item.range.start + 1;
                    valueNode.range = {
                        start: pos,
                        end: pos
                    };
                    valueNode.valueRange = {
                        start: pos,
                        end: pos
                    };
                    if (typeof item.range.origStart === 'number') {
                        var origPos = item.range.origStart + 1;
                        valueNode.range.origStart = valueNode.range.origEnd = origPos;
                        valueNode.valueRange.origStart = valueNode.valueRange.origEnd = origPos;
                    }
                }
                var pair = new $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d(key, $f9cc26a8c8e9e9ae$export$43caf9889c228507(doc, valueNode));
                $f9cc26a8c8e9e9ae$var$resolvePairComment(item, pair);
                items.push(pair);
                if (key && typeof keyStart === 'number') {
                    if (item.range.start > keyStart + 1024) doc.errors.push($f9cc26a8c8e9e9ae$var$getLongKeyError(cst, key));
                }
                key = undefined;
                keyStart = null;
                break;
            default:
                if (key !== undefined) items.push(new $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d(key));
                key = $f9cc26a8c8e9e9ae$export$43caf9889c228507(doc, item);
                keyStart = item.range.start;
                if (item.error) doc.errors.push(item.error);
                next: for(var j = i + 1;; ++j){
                    var nextItem = cst.items[j];
                    switch(nextItem && nextItem.type){
                        case (0, $5lj6y.T).BLANK_LINE:
                        case (0, $5lj6y.T).COMMENT:
                            continue next;
                        case (0, $5lj6y.T).MAP_VALUE:
                            break next;
                        default:
                            var _msg2 = 'Implicit map keys need to be followed by map values';
                            doc.errors.push(new (0, $5lj6y.g)(item, _msg2));
                            break next;
                    }
                }
                if (item.valueRangeContainsNewline) {
                    var _msg3 = 'Implicit map keys need to be on a single line';
                    doc.errors.push(new (0, $5lj6y.g)(item, _msg3));
                }
        }
    }
    if (key !== undefined) items.push(new $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d(key));
    return {
        comments: comments,
        items: items
    };
}
function $f9cc26a8c8e9e9ae$var$resolveFlowMapItems(doc, cst) {
    var comments = [];
    var items = [];
    var key = undefined;
    var explicitKey = false;
    var next = '{';
    for(var i = 0; i < cst.items.length; ++i){
        var item = cst.items[i];
        if (typeof item.char === 'string') {
            var char = item.char, offset = item.offset;
            if (char === '?' && key === undefined && !explicitKey) {
                explicitKey = true;
                next = ':';
                continue;
            }
            if (char === ':') {
                if (key === undefined) key = null;
                if (next === ':') {
                    next = ',';
                    continue;
                }
            } else {
                if (explicitKey) {
                    if (key === undefined && char !== ',') key = null;
                    explicitKey = false;
                }
                if (key !== undefined) {
                    items.push(new $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d(key));
                    key = undefined;
                    if (char === ',') {
                        next = ':';
                        continue;
                    }
                }
            }
            if (char === '}') {
                if (i === cst.items.length - 1) continue;
            } else if (char === next) {
                next = ':';
                continue;
            }
            var msg = "Flow map contains an unexpected ".concat(char);
            var err = new (0, $5lj6y.Y)(cst, msg);
            err.offset = offset;
            doc.errors.push(err);
        } else if (item.type === (0, $5lj6y.T).BLANK_LINE) comments.push({
            afterKey: !!key,
            before: items.length
        });
        else if (item.type === (0, $5lj6y.T).COMMENT) {
            $f9cc26a8c8e9e9ae$var$checkFlowCommentSpace(doc.errors, item);
            comments.push({
                afterKey: !!key,
                before: items.length,
                comment: item.comment
            });
        } else if (key === undefined) {
            if (next === ',') doc.errors.push(new (0, $5lj6y.g)(item, 'Separator , missing in flow map'));
            key = $f9cc26a8c8e9e9ae$export$43caf9889c228507(doc, item);
        } else {
            if (next !== ',') doc.errors.push(new (0, $5lj6y.g)(item, 'Indicator : missing in flow map entry'));
            items.push(new $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d(key, $f9cc26a8c8e9e9ae$export$43caf9889c228507(doc, item)));
            key = undefined;
            explicitKey = false;
        }
    }
    $f9cc26a8c8e9e9ae$var$checkFlowCollectionEnd(doc.errors, cst);
    if (key !== undefined) items.push(new $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d(key));
    return {
        comments: comments,
        items: items
    };
}
function $f9cc26a8c8e9e9ae$export$dda1d9f60106f0e9(doc, cst) {
    if (cst.type !== (0, $5lj6y.T).SEQ && cst.type !== (0, $5lj6y.T).FLOW_SEQ) {
        var msg = "A ".concat(cst.type, " node cannot be resolved as a sequence");
        doc.errors.push(new (0, $5lj6y.Y)(cst, msg));
        return null;
    }
    var _ref = cst.type === (0, $5lj6y.T).FLOW_SEQ ? $f9cc26a8c8e9e9ae$var$resolveFlowSeqItems(doc, cst) : $f9cc26a8c8e9e9ae$var$resolveBlockSeqItems(doc, cst), comments = _ref.comments, items = _ref.items;
    var seq = new $f9cc26a8c8e9e9ae$export$8743009a87fcb00f();
    seq.items = items;
    $f9cc26a8c8e9e9ae$var$resolveComments(seq, comments);
    if (!doc.options.mapAsMap && items.some(function(it) {
        return it instanceof $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d && it.key instanceof $f9cc26a8c8e9e9ae$export$e7094788287c5e9b;
    })) {
        var warn = 'Keys with collection values will be stringified as YAML due to JS Object restrictions. Use mapAsMap: true to avoid this.';
        doc.warnings.push(new (0, $5lj6y.f)(cst, warn));
    }
    cst.resolved = seq;
    return seq;
}
function $f9cc26a8c8e9e9ae$var$resolveBlockSeqItems(doc, cst) {
    var comments = [];
    var items = [];
    for(var i = 0; i < cst.items.length; ++i){
        var item = cst.items[i];
        switch(item.type){
            case (0, $5lj6y.T).BLANK_LINE:
                comments.push({
                    before: items.length
                });
                break;
            case (0, $5lj6y.T).COMMENT:
                comments.push({
                    comment: item.comment,
                    before: items.length
                });
                break;
            case (0, $5lj6y.T).SEQ_ITEM:
                if (item.error) doc.errors.push(item.error);
                items.push($f9cc26a8c8e9e9ae$export$43caf9889c228507(doc, item.node));
                if (item.hasProps) {
                    var msg = 'Sequence items cannot have tags or anchors before the - indicator';
                    doc.errors.push(new (0, $5lj6y.g)(item, msg));
                }
                break;
            default:
                if (item.error) doc.errors.push(item.error);
                doc.errors.push(new (0, $5lj6y.Y)(item, "Unexpected ".concat(item.type, " node in sequence")));
        }
    }
    return {
        comments: comments,
        items: items
    };
}
function $f9cc26a8c8e9e9ae$var$resolveFlowSeqItems(doc, cst) {
    var comments = [];
    var items = [];
    var explicitKey = false;
    var key = undefined;
    var keyStart = null;
    var next = '[';
    var prevItem = null;
    for(var i = 0; i < cst.items.length; ++i){
        var item = cst.items[i];
        if (typeof item.char === 'string') {
            var char = item.char, offset = item.offset;
            if (char !== ':' && (explicitKey || key !== undefined)) {
                if (explicitKey && key === undefined) key = next ? items.pop() : null;
                items.push(new $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d(key));
                explicitKey = false;
                key = undefined;
                keyStart = null;
            }
            if (char === next) next = null;
            else if (!next && char === '?') explicitKey = true;
            else if (next !== '[' && char === ':' && key === undefined) {
                if (next === ',') {
                    key = items.pop();
                    if (key instanceof $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d) {
                        var msg = 'Chaining flow sequence pairs is invalid';
                        var err = new (0, $5lj6y.g)(cst, msg);
                        err.offset = offset;
                        doc.errors.push(err);
                    }
                    if (!explicitKey && typeof keyStart === 'number') {
                        var keyEnd = item.range ? item.range.start : item.offset;
                        if (keyEnd > keyStart + 1024) doc.errors.push($f9cc26a8c8e9e9ae$var$getLongKeyError(cst, key));
                        var src = prevItem.context.src;
                        for(var _i = keyStart; _i < keyEnd; ++_i)if (src[_i] === '\n') {
                            var _msg = 'Implicit keys of flow sequence pairs need to be on a single line';
                            doc.errors.push(new (0, $5lj6y.g)(prevItem, _msg));
                            break;
                        }
                    }
                } else key = null;
                keyStart = null;
                explicitKey = false;
                next = null;
            } else if (next === '[' || char !== ']' || i < cst.items.length - 1) {
                var _msg2 = "Flow sequence contains an unexpected ".concat(char);
                var _err = new (0, $5lj6y.Y)(cst, _msg2);
                _err.offset = offset;
                doc.errors.push(_err);
            }
        } else if (item.type === (0, $5lj6y.T).BLANK_LINE) comments.push({
            before: items.length
        });
        else if (item.type === (0, $5lj6y.T).COMMENT) {
            $f9cc26a8c8e9e9ae$var$checkFlowCommentSpace(doc.errors, item);
            comments.push({
                comment: item.comment,
                before: items.length
            });
        } else {
            if (next) {
                var _msg3 = "Expected a ".concat(next, " in flow sequence");
                doc.errors.push(new (0, $5lj6y.g)(item, _msg3));
            }
            var value = $f9cc26a8c8e9e9ae$export$43caf9889c228507(doc, item);
            if (key === undefined) {
                items.push(value);
                prevItem = item;
            } else {
                items.push(new $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d(key, value));
                key = undefined;
            }
            keyStart = item.range.start;
            next = ',';
        }
    }
    $f9cc26a8c8e9e9ae$var$checkFlowCollectionEnd(doc.errors, cst);
    if (key !== undefined) items.push(new $f9cc26a8c8e9e9ae$export$56c0d5a1e737357d(key));
    return {
        comments: comments,
        items: items
    };
}

});

parcelRegister("2uhik", function(module, exports) {

$parcel$export(module.exports, "S", function () { return $1cfbcc722fc3f2e8$export$25ce5a424b770e84; });

var $5lj6y = parcelRequire("5lj6y");

var $lrFig = parcelRequire("lrFig");

var $5iO0y = parcelRequire("5iO0y");
function $1cfbcc722fc3f2e8$var$createMap(schema, obj, ctx) {
    var map = new (0, $lrFig.d)(schema);
    if (obj instanceof Map) {
        var _iterator = (0, $5lj6y._)(obj), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = (0, $5lj6y.h)(_step.value, 2), key = _step$value[0], value = _step$value[1];
                map.items.push(schema.createPair(key, value, ctx));
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    } else if (obj && (0, $5lj6y.a)(obj) === 'object') for(var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++){
        var _key = _Object$keys[_i];
        map.items.push(schema.createPair(_key, obj[_key], ctx));
    }
    if (typeof schema.sortMapEntries === 'function') map.items.sort(schema.sortMapEntries);
    return map;
}
var $1cfbcc722fc3f2e8$var$map = {
    createNode: $1cfbcc722fc3f2e8$var$createMap,
    default: true,
    nodeClass: (0, $lrFig.d),
    tag: 'tag:yaml.org,2002:map',
    resolve: (0, $lrFig.g)
};
function $1cfbcc722fc3f2e8$var$createSeq(schema, obj, ctx) {
    var seq = new (0, $lrFig.Y)(schema);
    if (obj && obj[Symbol.iterator]) {
        var _iterator = (0, $5lj6y._)(obj), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var it = _step.value;
                var v = schema.createNode(it, ctx.wrapScalars, null, ctx);
                seq.items.push(v);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }
    return seq;
}
var $1cfbcc722fc3f2e8$var$seq = {
    createNode: $1cfbcc722fc3f2e8$var$createSeq,
    default: true,
    nodeClass: (0, $lrFig.Y),
    tag: 'tag:yaml.org,2002:seq',
    resolve: (0, $lrFig.h)
};
var $1cfbcc722fc3f2e8$var$string = {
    identify: function identify(value) {
        return typeof value === 'string';
    },
    default: true,
    tag: 'tag:yaml.org,2002:str',
    resolve: (0, $lrFig.j),
    stringify: function stringify(item, ctx, onComment, onChompKeep) {
        ctx = Object.assign({
            actualString: true
        }, ctx);
        return (0, $lrFig.c)(item, ctx, onComment, onChompKeep);
    },
    options: (0, $lrFig.s)
};
var $1cfbcc722fc3f2e8$var$failsafe = [
    $1cfbcc722fc3f2e8$var$map,
    $1cfbcc722fc3f2e8$var$seq,
    $1cfbcc722fc3f2e8$var$string
];
/* global BigInt */ var $1cfbcc722fc3f2e8$var$intIdentify$2 = function intIdentify(value) {
    return typeof value === 'bigint' || Number.isInteger(value);
};
var $1cfbcc722fc3f2e8$var$intResolve$1 = function intResolve(src, part, radix) {
    return (0, $lrFig.i).asBigInt ? BigInt(src) : parseInt(part, radix);
};
function $1cfbcc722fc3f2e8$var$intStringify$1(node, radix, prefix) {
    var value = node.value;
    if ($1cfbcc722fc3f2e8$var$intIdentify$2(value) && value >= 0) return prefix + value.toString(radix);
    return (0, $lrFig.k)(node);
}
var $1cfbcc722fc3f2e8$var$nullObj = {
    identify: function identify(value) {
        return value == null;
    },
    createNode: function createNode(schema, value, ctx) {
        return ctx.wrapScalars ? new (0, $lrFig.S)(null) : null;
    },
    default: true,
    tag: 'tag:yaml.org,2002:null',
    test: /^(?:~|[Nn]ull|NULL)?$/,
    resolve: function resolve() {
        return null;
    },
    options: (0, $lrFig.n),
    stringify: function stringify() {
        return (0, $lrFig.n).nullStr;
    }
};
var $1cfbcc722fc3f2e8$var$boolObj = {
    identify: function identify(value) {
        return typeof value === 'boolean';
    },
    default: true,
    tag: 'tag:yaml.org,2002:bool',
    test: /^(?:[Tt]rue|TRUE|[Ff]alse|FALSE)$/,
    resolve: function resolve(str) {
        return str[0] === 't' || str[0] === 'T';
    },
    options: (0, $lrFig.a),
    stringify: function stringify(_ref) {
        var value = _ref.value;
        return value ? (0, $lrFig.a).trueStr : (0, $lrFig.a).falseStr;
    }
};
var $1cfbcc722fc3f2e8$var$octObj = {
    identify: function identify(value) {
        return $1cfbcc722fc3f2e8$var$intIdentify$2(value) && value >= 0;
    },
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'OCT',
    test: /^0o([0-7]+)$/,
    resolve: function resolve(str, oct) {
        return $1cfbcc722fc3f2e8$var$intResolve$1(str, oct, 8);
    },
    options: (0, $lrFig.i),
    stringify: function stringify(node) {
        return $1cfbcc722fc3f2e8$var$intStringify$1(node, 8, '0o');
    }
};
var $1cfbcc722fc3f2e8$var$intObj = {
    identify: $1cfbcc722fc3f2e8$var$intIdentify$2,
    default: true,
    tag: 'tag:yaml.org,2002:int',
    test: /^[-+]?[0-9]+$/,
    resolve: function resolve(str) {
        return $1cfbcc722fc3f2e8$var$intResolve$1(str, str, 10);
    },
    options: (0, $lrFig.i),
    stringify: (0, $lrFig.k)
};
var $1cfbcc722fc3f2e8$var$hexObj = {
    identify: function identify(value) {
        return $1cfbcc722fc3f2e8$var$intIdentify$2(value) && value >= 0;
    },
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'HEX',
    test: /^0x([0-9a-fA-F]+)$/,
    resolve: function resolve(str, hex) {
        return $1cfbcc722fc3f2e8$var$intResolve$1(str, hex, 16);
    },
    options: (0, $lrFig.i),
    stringify: function stringify(node) {
        return $1cfbcc722fc3f2e8$var$intStringify$1(node, 16, '0x');
    }
};
var $1cfbcc722fc3f2e8$var$nanObj = {
    identify: function identify(value) {
        return typeof value === 'number';
    },
    default: true,
    tag: 'tag:yaml.org,2002:float',
    test: /^(?:[-+]?\.inf|(\.nan))$/i,
    resolve: function resolve(str, nan) {
        return nan ? NaN : str[0] === '-' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
    },
    stringify: (0, $lrFig.k)
};
var $1cfbcc722fc3f2e8$var$expObj = {
    identify: function identify(value) {
        return typeof value === 'number';
    },
    default: true,
    tag: 'tag:yaml.org,2002:float',
    format: 'EXP',
    test: /^[-+]?(?:\.[0-9]+|[0-9]+(?:\.[0-9]*)?)[eE][-+]?[0-9]+$/,
    resolve: function resolve(str) {
        return parseFloat(str);
    },
    stringify: function stringify(_ref2) {
        var value = _ref2.value;
        return Number(value).toExponential();
    }
};
var $1cfbcc722fc3f2e8$var$floatObj = {
    identify: function identify(value) {
        return typeof value === 'number';
    },
    default: true,
    tag: 'tag:yaml.org,2002:float',
    test: /^[-+]?(?:\.([0-9]+)|[0-9]+\.([0-9]*))$/,
    resolve: function resolve(str, frac1, frac2) {
        var frac = frac1 || frac2;
        var node = new (0, $lrFig.S)(parseFloat(str));
        if (frac && frac[frac.length - 1] === '0') node.minFractionDigits = frac.length;
        return node;
    },
    stringify: (0, $lrFig.k)
};
var $1cfbcc722fc3f2e8$var$core = $1cfbcc722fc3f2e8$var$failsafe.concat([
    $1cfbcc722fc3f2e8$var$nullObj,
    $1cfbcc722fc3f2e8$var$boolObj,
    $1cfbcc722fc3f2e8$var$octObj,
    $1cfbcc722fc3f2e8$var$intObj,
    $1cfbcc722fc3f2e8$var$hexObj,
    $1cfbcc722fc3f2e8$var$nanObj,
    $1cfbcc722fc3f2e8$var$expObj,
    $1cfbcc722fc3f2e8$var$floatObj
]);
/* global BigInt */ var $1cfbcc722fc3f2e8$var$intIdentify$1 = function intIdentify(value) {
    return typeof value === 'bigint' || Number.isInteger(value);
};
var $1cfbcc722fc3f2e8$var$stringifyJSON = function stringifyJSON(_ref) {
    var value = _ref.value;
    return JSON.stringify(value);
};
var $1cfbcc722fc3f2e8$var$json = [
    $1cfbcc722fc3f2e8$var$map,
    $1cfbcc722fc3f2e8$var$seq,
    {
        identify: function identify(value) {
            return typeof value === 'string';
        },
        default: true,
        tag: 'tag:yaml.org,2002:str',
        resolve: (0, $lrFig.j),
        stringify: $1cfbcc722fc3f2e8$var$stringifyJSON
    },
    {
        identify: function identify(value) {
            return value == null;
        },
        createNode: function createNode(schema, value, ctx) {
            return ctx.wrapScalars ? new (0, $lrFig.S)(null) : null;
        },
        default: true,
        tag: 'tag:yaml.org,2002:null',
        test: /^null$/,
        resolve: function resolve() {
            return null;
        },
        stringify: $1cfbcc722fc3f2e8$var$stringifyJSON
    },
    {
        identify: function identify(value) {
            return typeof value === 'boolean';
        },
        default: true,
        tag: 'tag:yaml.org,2002:bool',
        test: /^true|false$/,
        resolve: function resolve(str) {
            return str === 'true';
        },
        stringify: $1cfbcc722fc3f2e8$var$stringifyJSON
    },
    {
        identify: $1cfbcc722fc3f2e8$var$intIdentify$1,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        test: /^-?(?:0|[1-9][0-9]*)$/,
        resolve: function resolve(str) {
            return (0, $lrFig.i).asBigInt ? BigInt(str) : parseInt(str, 10);
        },
        stringify: function stringify(_ref2) {
            var value = _ref2.value;
            return $1cfbcc722fc3f2e8$var$intIdentify$1(value) ? value.toString() : JSON.stringify(value);
        }
    },
    {
        identify: function identify(value) {
            return typeof value === 'number';
        },
        default: true,
        tag: 'tag:yaml.org,2002:float',
        test: /^-?(?:0|[1-9][0-9]*)(?:\.[0-9]*)?(?:[eE][-+]?[0-9]+)?$/,
        resolve: function resolve(str) {
            return parseFloat(str);
        },
        stringify: $1cfbcc722fc3f2e8$var$stringifyJSON
    }
];
$1cfbcc722fc3f2e8$var$json.scalarFallback = function(str) {
    throw new SyntaxError("Unresolved plain scalar ".concat(JSON.stringify(str)));
};
/* global BigInt */ var $1cfbcc722fc3f2e8$var$boolStringify = function boolStringify(_ref) {
    var value = _ref.value;
    return value ? (0, $lrFig.a).trueStr : (0, $lrFig.a).falseStr;
};
var $1cfbcc722fc3f2e8$var$intIdentify = function intIdentify(value) {
    return typeof value === 'bigint' || Number.isInteger(value);
};
function $1cfbcc722fc3f2e8$var$intResolve(sign, src, radix) {
    var str = src.replace(/_/g, '');
    if ((0, $lrFig.i).asBigInt) {
        switch(radix){
            case 2:
                str = "0b".concat(str);
                break;
            case 8:
                str = "0o".concat(str);
                break;
            case 16:
                str = "0x".concat(str);
                break;
        }
        var _n = BigInt(str);
        return sign === '-' ? BigInt(-1) * _n : _n;
    }
    var n = parseInt(str, radix);
    return sign === '-' ? -1 * n : n;
}
function $1cfbcc722fc3f2e8$var$intStringify(node, radix, prefix) {
    var value = node.value;
    if ($1cfbcc722fc3f2e8$var$intIdentify(value)) {
        var str = value.toString(radix);
        return value < 0 ? '-' + prefix + str.substr(1) : prefix + str;
    }
    return (0, $lrFig.k)(node);
}
var $1cfbcc722fc3f2e8$var$yaml11 = $1cfbcc722fc3f2e8$var$failsafe.concat([
    {
        identify: function identify(value) {
            return value == null;
        },
        createNode: function createNode(schema, value, ctx) {
            return ctx.wrapScalars ? new (0, $lrFig.S)(null) : null;
        },
        default: true,
        tag: 'tag:yaml.org,2002:null',
        test: /^(?:~|[Nn]ull|NULL)?$/,
        resolve: function resolve() {
            return null;
        },
        options: (0, $lrFig.n),
        stringify: function stringify() {
            return (0, $lrFig.n).nullStr;
        }
    },
    {
        identify: function identify(value) {
            return typeof value === 'boolean';
        },
        default: true,
        tag: 'tag:yaml.org,2002:bool',
        test: /^(?:Y|y|[Yy]es|YES|[Tt]rue|TRUE|[Oo]n|ON)$/,
        resolve: function resolve() {
            return true;
        },
        options: (0, $lrFig.a),
        stringify: $1cfbcc722fc3f2e8$var$boolStringify
    },
    {
        identify: function identify(value) {
            return typeof value === 'boolean';
        },
        default: true,
        tag: 'tag:yaml.org,2002:bool',
        test: /^(?:N|n|[Nn]o|NO|[Ff]alse|FALSE|[Oo]ff|OFF)$/i,
        resolve: function resolve() {
            return false;
        },
        options: (0, $lrFig.a),
        stringify: $1cfbcc722fc3f2e8$var$boolStringify
    },
    {
        identify: $1cfbcc722fc3f2e8$var$intIdentify,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        format: 'BIN',
        test: /^([-+]?)0b([0-1_]+)$/,
        resolve: function resolve(str, sign, bin) {
            return $1cfbcc722fc3f2e8$var$intResolve(sign, bin, 2);
        },
        stringify: function stringify(node) {
            return $1cfbcc722fc3f2e8$var$intStringify(node, 2, '0b');
        }
    },
    {
        identify: $1cfbcc722fc3f2e8$var$intIdentify,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        format: 'OCT',
        test: /^([-+]?)0([0-7_]+)$/,
        resolve: function resolve(str, sign, oct) {
            return $1cfbcc722fc3f2e8$var$intResolve(sign, oct, 8);
        },
        stringify: function stringify(node) {
            return $1cfbcc722fc3f2e8$var$intStringify(node, 8, '0');
        }
    },
    {
        identify: $1cfbcc722fc3f2e8$var$intIdentify,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        test: /^([-+]?)([0-9][0-9_]*)$/,
        resolve: function resolve(str, sign, abs) {
            return $1cfbcc722fc3f2e8$var$intResolve(sign, abs, 10);
        },
        stringify: (0, $lrFig.k)
    },
    {
        identify: $1cfbcc722fc3f2e8$var$intIdentify,
        default: true,
        tag: 'tag:yaml.org,2002:int',
        format: 'HEX',
        test: /^([-+]?)0x([0-9a-fA-F_]+)$/,
        resolve: function resolve(str, sign, hex) {
            return $1cfbcc722fc3f2e8$var$intResolve(sign, hex, 16);
        },
        stringify: function stringify(node) {
            return $1cfbcc722fc3f2e8$var$intStringify(node, 16, '0x');
        }
    },
    {
        identify: function identify(value) {
            return typeof value === 'number';
        },
        default: true,
        tag: 'tag:yaml.org,2002:float',
        test: /^(?:[-+]?\.inf|(\.nan))$/i,
        resolve: function resolve(str, nan) {
            return nan ? NaN : str[0] === '-' ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
        },
        stringify: (0, $lrFig.k)
    },
    {
        identify: function identify(value) {
            return typeof value === 'number';
        },
        default: true,
        tag: 'tag:yaml.org,2002:float',
        format: 'EXP',
        test: /^[-+]?([0-9][0-9_]*)?(\.[0-9_]*)?[eE][-+]?[0-9]+$/,
        resolve: function resolve(str) {
            return parseFloat(str.replace(/_/g, ''));
        },
        stringify: function stringify(_ref2) {
            var value = _ref2.value;
            return Number(value).toExponential();
        }
    },
    {
        identify: function identify(value) {
            return typeof value === 'number';
        },
        default: true,
        tag: 'tag:yaml.org,2002:float',
        test: /^[-+]?(?:[0-9][0-9_]*)?\.([0-9_]*)$/,
        resolve: function resolve(str, frac) {
            var node = new (0, $lrFig.S)(parseFloat(str.replace(/_/g, '')));
            if (frac) {
                var f = frac.replace(/_/g, '');
                if (f[f.length - 1] === '0') node.minFractionDigits = f.length;
            }
            return node;
        },
        stringify: (0, $lrFig.k)
    }
], (0, $5iO0y.b), (0, $5iO0y.o), (0, $5iO0y.p), (0, $5iO0y.s), (0, $5iO0y.i), (0, $5iO0y.f), (0, $5iO0y.t));
var $1cfbcc722fc3f2e8$var$schemas = {
    core: $1cfbcc722fc3f2e8$var$core,
    failsafe: $1cfbcc722fc3f2e8$var$failsafe,
    json: $1cfbcc722fc3f2e8$var$json,
    yaml11: $1cfbcc722fc3f2e8$var$yaml11
};
var $1cfbcc722fc3f2e8$var$tags = {
    binary: (0, $5iO0y.b),
    bool: $1cfbcc722fc3f2e8$var$boolObj,
    float: $1cfbcc722fc3f2e8$var$floatObj,
    floatExp: $1cfbcc722fc3f2e8$var$expObj,
    floatNaN: $1cfbcc722fc3f2e8$var$nanObj,
    floatTime: (0, $5iO0y.f),
    int: $1cfbcc722fc3f2e8$var$intObj,
    intHex: $1cfbcc722fc3f2e8$var$hexObj,
    intOct: $1cfbcc722fc3f2e8$var$octObj,
    intTime: (0, $5iO0y.i),
    map: $1cfbcc722fc3f2e8$var$map,
    null: $1cfbcc722fc3f2e8$var$nullObj,
    omap: (0, $5iO0y.o),
    pairs: (0, $5iO0y.p),
    seq: $1cfbcc722fc3f2e8$var$seq,
    set: (0, $5iO0y.s),
    timestamp: (0, $5iO0y.t)
};
function $1cfbcc722fc3f2e8$var$findTagObject(value, tagName, tags) {
    if (tagName) {
        var match = tags.filter(function(t) {
            return t.tag === tagName;
        });
        var tagObj = match.find(function(t) {
            return !t.format;
        }) || match[0];
        if (!tagObj) throw new Error("Tag ".concat(tagName, " not found"));
        return tagObj;
    } // TODO: deprecate/remove class check
    return tags.find(function(t) {
        return (t.identify && t.identify(value) || t.class && value instanceof t.class) && !t.format;
    });
}
function $1cfbcc722fc3f2e8$var$createNode(value, tagName, ctx) {
    if (value instanceof (0, $lrFig.N)) return value;
    var defaultPrefix = ctx.defaultPrefix, onTagObj = ctx.onTagObj, prevObjects = ctx.prevObjects, schema = ctx.schema, wrapScalars = ctx.wrapScalars;
    if (tagName && tagName.startsWith('!!')) tagName = defaultPrefix + tagName.slice(2);
    var tagObj = $1cfbcc722fc3f2e8$var$findTagObject(value, tagName, schema.tags);
    if (!tagObj) {
        if (typeof value.toJSON === 'function') value = value.toJSON();
        if (!value || (0, $5lj6y.a)(value) !== 'object') return wrapScalars ? new (0, $lrFig.S)(value) : value;
        tagObj = value instanceof Map ? $1cfbcc722fc3f2e8$var$map : value[Symbol.iterator] ? $1cfbcc722fc3f2e8$var$seq : $1cfbcc722fc3f2e8$var$map;
    }
    if (onTagObj) {
        onTagObj(tagObj);
        delete ctx.onTagObj;
    } // Detect duplicate references to the same object & use Alias nodes for all
    // after first. The `obj` wrapper allows for circular references to resolve.
    var obj = {
        value: undefined,
        node: undefined
    };
    if (value && (0, $5lj6y.a)(value) === 'object' && prevObjects) {
        var prev = prevObjects.get(value);
        if (prev) {
            var alias = new (0, $lrFig.A)(prev); // leaves source dirty; must be cleaned by caller
            ctx.aliasNodes.push(alias); // defined along with prevObjects
            return alias;
        }
        obj.value = value;
        prevObjects.set(value, obj);
    }
    obj.node = tagObj.createNode ? tagObj.createNode(ctx.schema, value, ctx) : wrapScalars ? new (0, $lrFig.S)(value) : value;
    if (tagName && obj.node instanceof (0, $lrFig.N)) obj.node.tag = tagName;
    return obj.node;
}
function $1cfbcc722fc3f2e8$var$getSchemaTags(schemas, knownTags, customTags, schemaId) {
    var tags = schemas[schemaId.replace(/\W/g, '')]; // 'yaml-1.1' -> 'yaml11'
    if (!tags) {
        var keys = Object.keys(schemas).map(function(key) {
            return JSON.stringify(key);
        }).join(', ');
        throw new Error("Unknown schema \"".concat(schemaId, "\"; use one of ").concat(keys));
    }
    if (Array.isArray(customTags)) {
        var _iterator = (0, $5lj6y._)(customTags), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var tag = _step.value;
                tags = tags.concat(tag);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    } else if (typeof customTags === 'function') tags = customTags(tags.slice());
    for(var i = 0; i < tags.length; ++i){
        var _tag = tags[i];
        if (typeof _tag === 'string') {
            var tagObj = knownTags[_tag];
            if (!tagObj) {
                var _keys = Object.keys(knownTags).map(function(key) {
                    return JSON.stringify(key);
                }).join(', ');
                throw new Error("Unknown custom tag \"".concat(_tag, "\"; use one of ").concat(_keys));
            }
            tags[i] = tagObj;
        }
    }
    return tags;
}
var $1cfbcc722fc3f2e8$var$sortMapEntriesByKey = function sortMapEntriesByKey(a, b) {
    return a.key < b.key ? -1 : a.key > b.key ? 1 : 0;
};
var $1cfbcc722fc3f2e8$export$25ce5a424b770e84 = /*#__PURE__*/ function() {
    // TODO: remove in v2
    // TODO: remove in v2
    function Schema(_ref) {
        var customTags = _ref.customTags, merge = _ref.merge, schema = _ref.schema, sortMapEntries = _ref.sortMapEntries, deprecatedCustomTags = _ref.tags;
        (0, $5lj6y.c)(this, Schema);
        this.merge = !!merge;
        this.name = schema;
        this.sortMapEntries = sortMapEntries === true ? $1cfbcc722fc3f2e8$var$sortMapEntriesByKey : sortMapEntries || null;
        if (!customTags && deprecatedCustomTags) (0, $5iO0y.a)('tags', 'customTags');
        this.tags = $1cfbcc722fc3f2e8$var$getSchemaTags($1cfbcc722fc3f2e8$var$schemas, $1cfbcc722fc3f2e8$var$tags, customTags || deprecatedCustomTags, schema);
    }
    (0, $5lj6y.b)(Schema, [
        {
            key: "createNode",
            value: function createNode$1(value, wrapScalars, tagName, ctx) {
                var baseCtx = {
                    defaultPrefix: Schema.defaultPrefix,
                    schema: this,
                    wrapScalars: wrapScalars
                };
                var createCtx = ctx ? Object.assign(ctx, baseCtx) : baseCtx;
                return $1cfbcc722fc3f2e8$var$createNode(value, tagName, createCtx);
            }
        },
        {
            key: "createPair",
            value: function createPair(key, value, ctx) {
                if (!ctx) ctx = {
                    wrapScalars: true
                };
                var k = this.createNode(key, ctx.wrapScalars, null, ctx);
                var v = this.createNode(value, ctx.wrapScalars, null, ctx);
                return new (0, $lrFig.P)(k, v);
            }
        }
    ]);
    return Schema;
}();
(0, $5lj6y.e)($1cfbcc722fc3f2e8$export$25ce5a424b770e84, "defaultPrefix", (0, $5lj6y.d));
(0, $5lj6y.e)($1cfbcc722fc3f2e8$export$25ce5a424b770e84, "defaultTags", (0, $5lj6y.n));

});
parcelRegister("5iO0y", function(module, exports) {

$parcel$export(module.exports, "b", function () { return $3dc56cbd2fdf0b6d$export$8b22cf2602fb60ce; });
$parcel$export(module.exports, "p", function () { return $3dc56cbd2fdf0b6d$export$ffb5f4729a158638; });
$parcel$export(module.exports, "o", function () { return $3dc56cbd2fdf0b6d$export$ae1af26003f05816; });
$parcel$export(module.exports, "s", function () { return $3dc56cbd2fdf0b6d$export$2408f22a0fab9ae5; });
$parcel$export(module.exports, "i", function () { return $3dc56cbd2fdf0b6d$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "f", function () { return $3dc56cbd2fdf0b6d$export$2d1720544b23b823; });
$parcel$export(module.exports, "t", function () { return $3dc56cbd2fdf0b6d$export$625550452a3fa3ec; });
$parcel$export(module.exports, "w", function () { return $3dc56cbd2fdf0b6d$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "a", function () { return $3dc56cbd2fdf0b6d$export$407448d2b89b1813; });

var $5lj6y = parcelRequire("5lj6y");

var $lrFig = parcelRequire("lrFig");

var $bgvhE = parcelRequire("bgvhE");
var $3dc56cbd2fdf0b6d$require$Buffer = $bgvhE.Buffer;

var $fXitr = parcelRequire("fXitr");
/* global atob, btoa, Buffer */ var $3dc56cbd2fdf0b6d$export$8b22cf2602fb60ce = {
    identify: function identify(value) {
        return value instanceof Uint8Array;
    },
    // Buffer inherits from Uint8Array
    default: false,
    tag: 'tag:yaml.org,2002:binary',
    /**
   * Returns a Buffer in node and an Uint8Array in browsers
   *
   * To use the resulting buffer as an image, you'll want to do something like:
   *
   *   const blob = new Blob([buffer], { type: 'image/jpeg' })
   *   document.querySelector('#photo').src = URL.createObjectURL(blob)
   */ resolve: function resolve(doc, node) {
        var src = (0, $lrFig.j)(doc, node);
        if (typeof $3dc56cbd2fdf0b6d$require$Buffer === 'function') return $3dc56cbd2fdf0b6d$require$Buffer.from(src, 'base64');
        else if (typeof atob === 'function') {
            // On IE 11, atob() can't handle newlines
            var str = atob(src.replace(/[\n\r]/g, ''));
            var buffer = new Uint8Array(str.length);
            for(var i = 0; i < str.length; ++i)buffer[i] = str.charCodeAt(i);
            return buffer;
        } else {
            var msg = 'This environment does not support reading binary tags; either Buffer or atob is required';
            doc.errors.push(new (0, $5lj6y.o)(node, msg));
            return null;
        }
    },
    options: (0, $lrFig.b),
    stringify: function stringify(_ref, ctx, onComment, onChompKeep) {
        var comment = _ref.comment, type = _ref.type, value = _ref.value;
        var src;
        if (typeof $3dc56cbd2fdf0b6d$require$Buffer === 'function') src = value instanceof $3dc56cbd2fdf0b6d$require$Buffer ? value.toString('base64') : $3dc56cbd2fdf0b6d$require$Buffer.from(value.buffer).toString('base64');
        else if (typeof btoa === 'function') {
            var s = '';
            for(var i = 0; i < value.length; ++i)s += String.fromCharCode(value[i]);
            src = btoa(s);
        } else throw new Error('This environment does not support writing binary tags; either Buffer or btoa is required');
        if (!type) type = (0, $lrFig.b).defaultType;
        if (type === (0, $5lj6y.T).QUOTE_DOUBLE) value = src;
        else {
            var lineWidth = (0, $lrFig.b).lineWidth;
            var n = Math.ceil(src.length / lineWidth);
            var lines = new Array(n);
            for(var _i = 0, o = 0; _i < n; ++_i, o += lineWidth)lines[_i] = src.substr(o, lineWidth);
            value = lines.join(type === (0, $5lj6y.T).BLOCK_LITERAL ? '\n' : ' ');
        }
        return (0, $lrFig.c)({
            comment: comment,
            type: type,
            value: value
        }, ctx, onComment, onChompKeep);
    }
};
function $3dc56cbd2fdf0b6d$var$parsePairs(doc, cst) {
    var seq = (0, $lrFig.h)(doc, cst);
    for(var i = 0; i < seq.items.length; ++i){
        var item = seq.items[i];
        if (item instanceof (0, $lrFig.P)) continue;
        else if (item instanceof (0, $lrFig.d)) {
            if (item.items.length > 1) {
                var msg = 'Each pair must have its own sequence indicator';
                throw new (0, $5lj6y.g)(cst, msg);
            }
            var pair = item.items[0] || new (0, $lrFig.P)();
            if (item.commentBefore) pair.commentBefore = pair.commentBefore ? "".concat(item.commentBefore, "\n").concat(pair.commentBefore) : item.commentBefore;
            if (item.comment) pair.comment = pair.comment ? "".concat(item.comment, "\n").concat(pair.comment) : item.comment;
            item = pair;
        }
        seq.items[i] = item instanceof (0, $lrFig.P) ? item : new (0, $lrFig.P)(item);
    }
    return seq;
}
function $3dc56cbd2fdf0b6d$var$createPairs(schema, iterable, ctx) {
    var pairs = new (0, $lrFig.Y)(schema);
    pairs.tag = 'tag:yaml.org,2002:pairs';
    var _iterator = (0, $5lj6y._)(iterable), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var it = _step.value;
            var key = void 0, value = void 0;
            if (Array.isArray(it)) {
                if (it.length === 2) {
                    key = it[0];
                    value = it[1];
                } else throw new TypeError("Expected [key, value] tuple: ".concat(it));
            } else if (it && it instanceof Object) {
                var keys = Object.keys(it);
                if (keys.length === 1) {
                    key = keys[0];
                    value = it[key];
                } else throw new TypeError("Expected { key: value } tuple: ".concat(it));
            } else key = it;
            var pair = schema.createPair(key, value, ctx);
            pairs.items.push(pair);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return pairs;
}
var $3dc56cbd2fdf0b6d$export$ffb5f4729a158638 = {
    default: false,
    tag: 'tag:yaml.org,2002:pairs',
    resolve: $3dc56cbd2fdf0b6d$var$parsePairs,
    createNode: $3dc56cbd2fdf0b6d$var$createPairs
};
var $3dc56cbd2fdf0b6d$var$YAMLOMap = /*#__PURE__*/ function(_YAMLSeq) {
    (0, $5lj6y.j)(YAMLOMap, _YAMLSeq);
    var _super = (0, $5lj6y.k)(YAMLOMap);
    function YAMLOMap() {
        var _this;
        (0, $5lj6y.c)(this, YAMLOMap);
        _this = _super.call(this);
        (0, $5lj6y.e)((0, $5lj6y.p)(_this), "add", (0, $lrFig.d).prototype.add.bind((0, $5lj6y.p)(_this)));
        (0, $5lj6y.e)((0, $5lj6y.p)(_this), "delete", (0, $lrFig.d).prototype.delete.bind((0, $5lj6y.p)(_this)));
        (0, $5lj6y.e)((0, $5lj6y.p)(_this), "get", (0, $lrFig.d).prototype.get.bind((0, $5lj6y.p)(_this)));
        (0, $5lj6y.e)((0, $5lj6y.p)(_this), "has", (0, $lrFig.d).prototype.has.bind((0, $5lj6y.p)(_this)));
        (0, $5lj6y.e)((0, $5lj6y.p)(_this), "set", (0, $lrFig.d).prototype.set.bind((0, $5lj6y.p)(_this)));
        _this.tag = YAMLOMap.tag;
        return _this;
    }
    (0, $5lj6y.b)(YAMLOMap, [
        {
            key: "toJSON",
            value: function toJSON$1(_, ctx) {
                var map = new Map();
                if (ctx && ctx.onCreate) ctx.onCreate(map);
                var _iterator = (0, $5lj6y._)(this.items), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var pair = _step.value;
                        var key = void 0, value = void 0;
                        if (pair instanceof (0, $lrFig.P)) {
                            key = (0, $lrFig.t)(pair.key, '', ctx);
                            value = (0, $lrFig.t)(pair.value, key, ctx);
                        } else key = (0, $lrFig.t)(pair, '', ctx);
                        if (map.has(key)) throw new Error('Ordered maps must not include duplicate keys');
                        map.set(key, value);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return map;
            }
        }
    ]);
    return YAMLOMap;
}((0, $lrFig.Y));
(0, $5lj6y.e)($3dc56cbd2fdf0b6d$var$YAMLOMap, "tag", 'tag:yaml.org,2002:omap');
function $3dc56cbd2fdf0b6d$var$parseOMap(doc, cst) {
    var pairs = $3dc56cbd2fdf0b6d$var$parsePairs(doc, cst);
    var seenKeys = [];
    var _iterator2 = (0, $5lj6y._)(pairs.items), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var key = _step2.value.key;
            if (key instanceof (0, $lrFig.S)) {
                if (seenKeys.includes(key.value)) {
                    var msg = 'Ordered maps must not include duplicate keys';
                    throw new (0, $5lj6y.g)(cst, msg);
                } else seenKeys.push(key.value);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return Object.assign(new $3dc56cbd2fdf0b6d$var$YAMLOMap(), pairs);
}
function $3dc56cbd2fdf0b6d$var$createOMap(schema, iterable, ctx) {
    var pairs = $3dc56cbd2fdf0b6d$var$createPairs(schema, iterable, ctx);
    var omap = new $3dc56cbd2fdf0b6d$var$YAMLOMap();
    omap.items = pairs.items;
    return omap;
}
var $3dc56cbd2fdf0b6d$export$ae1af26003f05816 = {
    identify: function identify(value) {
        return value instanceof Map;
    },
    nodeClass: $3dc56cbd2fdf0b6d$var$YAMLOMap,
    default: false,
    tag: 'tag:yaml.org,2002:omap',
    resolve: $3dc56cbd2fdf0b6d$var$parseOMap,
    createNode: $3dc56cbd2fdf0b6d$var$createOMap
};
var $3dc56cbd2fdf0b6d$var$YAMLSet = /*#__PURE__*/ function(_YAMLMap) {
    (0, $5lj6y.j)(YAMLSet, _YAMLMap);
    var _super = (0, $5lj6y.k)(YAMLSet);
    function YAMLSet() {
        var _this;
        (0, $5lj6y.c)(this, YAMLSet);
        _this = _super.call(this);
        _this.tag = YAMLSet.tag;
        return _this;
    }
    (0, $5lj6y.b)(YAMLSet, [
        {
            key: "add",
            value: function add(key) {
                var pair = key instanceof (0, $lrFig.P) ? key : new (0, $lrFig.P)(key);
                var prev = (0, $lrFig.l)(this.items, pair.key);
                if (!prev) this.items.push(pair);
            }
        },
        {
            key: "get",
            value: function get(key, keepPair) {
                var pair = (0, $lrFig.l)(this.items, key);
                return !keepPair && pair instanceof (0, $lrFig.P) ? pair.key instanceof (0, $lrFig.S) ? pair.key.value : pair.key : pair;
            }
        },
        {
            key: "set",
            value: function set(key, value) {
                if (typeof value !== 'boolean') throw new Error("Expected boolean value for set(key, value) in a YAML set, not ".concat((0, $5lj6y.a)(value)));
                var prev = (0, $lrFig.l)(this.items, key);
                if (prev && !value) this.items.splice(this.items.indexOf(prev), 1);
                else if (!prev && value) this.items.push(new (0, $lrFig.P)(key));
            }
        },
        {
            key: "toJSON",
            value: function toJSON(_, ctx) {
                return (0, $5lj6y.l)((0, $5lj6y.m)(YAMLSet.prototype), "toJSON", this).call(this, _, ctx, Set);
            }
        },
        {
            key: "toString",
            value: function toString(ctx, onComment, onChompKeep) {
                if (!ctx) return JSON.stringify(this);
                if (this.hasAllNullValues()) return (0, $5lj6y.l)((0, $5lj6y.m)(YAMLSet.prototype), "toString", this).call(this, ctx, onComment, onChompKeep);
                else throw new Error('Set items must all have null values');
            }
        }
    ]);
    return YAMLSet;
}((0, $lrFig.d));
(0, $5lj6y.e)($3dc56cbd2fdf0b6d$var$YAMLSet, "tag", 'tag:yaml.org,2002:set');
function $3dc56cbd2fdf0b6d$var$parseSet(doc, cst) {
    var map = (0, $lrFig.g)(doc, cst);
    if (!map.hasAllNullValues()) throw new (0, $5lj6y.g)(cst, 'Set items must all have null values');
    return Object.assign(new $3dc56cbd2fdf0b6d$var$YAMLSet(), map);
}
function $3dc56cbd2fdf0b6d$var$createSet(schema, iterable, ctx) {
    var set = new $3dc56cbd2fdf0b6d$var$YAMLSet();
    var _iterator = (0, $5lj6y._)(iterable), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var value = _step.value;
            set.items.push(schema.createPair(value, null, ctx));
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return set;
}
var $3dc56cbd2fdf0b6d$export$2408f22a0fab9ae5 = {
    identify: function identify(value) {
        return value instanceof Set;
    },
    nodeClass: $3dc56cbd2fdf0b6d$var$YAMLSet,
    default: false,
    tag: 'tag:yaml.org,2002:set',
    resolve: $3dc56cbd2fdf0b6d$var$parseSet,
    createNode: $3dc56cbd2fdf0b6d$var$createSet
};
var $3dc56cbd2fdf0b6d$var$parseSexagesimal = function parseSexagesimal(sign, parts) {
    var n = parts.split(':').reduce(function(n, p) {
        return n * 60 + Number(p);
    }, 0);
    return sign === '-' ? -n : n;
}; // hhhh:mm:ss.sss
var $3dc56cbd2fdf0b6d$var$stringifySexagesimal = function stringifySexagesimal(_ref) {
    var value = _ref.value;
    if (isNaN(value) || !isFinite(value)) return (0, $lrFig.k)(value);
    var sign = '';
    if (value < 0) {
        sign = '-';
        value = Math.abs(value);
    }
    var parts = [
        value % 60
    ]; // seconds, including ms
    if (value < 60) parts.unshift(0); // at least one : is required
    else {
        value = Math.round((value - parts[0]) / 60);
        parts.unshift(value % 60); // minutes
        if (value >= 60) {
            value = Math.round((value - parts[0]) / 60);
            parts.unshift(value); // hours
        }
    }
    return sign + parts.map(function(n) {
        return n < 10 ? '0' + String(n) : String(n);
    }).join(':').replace(/000000\d*$/, '') // % 60 may introduce error
    ;
};
var $3dc56cbd2fdf0b6d$export$23f2a1d2818174ef = {
    identify: function identify(value) {
        return typeof value === 'number';
    },
    default: true,
    tag: 'tag:yaml.org,2002:int',
    format: 'TIME',
    test: /^([-+]?)([0-9][0-9_]*(?::[0-5]?[0-9])+)$/,
    resolve: function resolve(str, sign, parts) {
        return $3dc56cbd2fdf0b6d$var$parseSexagesimal(sign, parts.replace(/_/g, ''));
    },
    stringify: $3dc56cbd2fdf0b6d$var$stringifySexagesimal
};
var $3dc56cbd2fdf0b6d$export$2d1720544b23b823 = {
    identify: function identify(value) {
        return typeof value === 'number';
    },
    default: true,
    tag: 'tag:yaml.org,2002:float',
    format: 'TIME',
    test: /^([-+]?)([0-9][0-9_]*(?::[0-5]?[0-9])+\.[0-9_]*)$/,
    resolve: function resolve(str, sign, parts) {
        return $3dc56cbd2fdf0b6d$var$parseSexagesimal(sign, parts.replace(/_/g, ''));
    },
    stringify: $3dc56cbd2fdf0b6d$var$stringifySexagesimal
};
var $3dc56cbd2fdf0b6d$export$625550452a3fa3ec = {
    identify: function identify(value) {
        return value instanceof Date;
    },
    default: true,
    tag: 'tag:yaml.org,2002:timestamp',
    // If the time zone is omitted, the timestamp is assumed to be specified in UTC. The time part
    // may be omitted altogether, resulting in a date format. In such a case, the time part is
    // assumed to be 00:00:00Z (start of day, UTC).
    test: RegExp("^(?:([0-9]{4})-([0-9]{1,2})-([0-9]{1,2})(?:(?:t|T|[ \\t]+)([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2}(\\.[0-9]+)?)(?:[ \\t]*(Z|[-+][012]?[0-9](?::[0-9]{2})?))?)?)$"),
    resolve: function resolve(str, year, month, day, hour, minute, second, millisec, tz) {
        if (millisec) millisec = (millisec + '00').substr(1, 3);
        var date = Date.UTC(year, month - 1, day, hour || 0, minute || 0, second || 0, millisec || 0);
        if (tz && tz !== 'Z') {
            var d = $3dc56cbd2fdf0b6d$var$parseSexagesimal(tz[0], tz.slice(1));
            if (Math.abs(d) < 30) d *= 60;
            date -= 60000 * d;
        }
        return new Date(date);
    },
    stringify: function stringify(_ref2) {
        var value = _ref2.value;
        return value.toISOString().replace(/((T00:00)?:00)?\.000Z$/, '');
    }
};
/* global console, process, YAML_SILENCE_DEPRECATION_WARNINGS, YAML_SILENCE_WARNINGS */ function $3dc56cbd2fdf0b6d$var$shouldWarn(deprecation) {
    var env = typeof $fXitr !== 'undefined' && $fXitr.env || {};
    if (deprecation) {
        if (typeof YAML_SILENCE_DEPRECATION_WARNINGS !== 'undefined') return !YAML_SILENCE_DEPRECATION_WARNINGS;
        return !env.YAML_SILENCE_DEPRECATION_WARNINGS;
    }
    if (typeof YAML_SILENCE_WARNINGS !== 'undefined') return !YAML_SILENCE_WARNINGS;
    return !env.YAML_SILENCE_WARNINGS;
}
function $3dc56cbd2fdf0b6d$export$efccba1c4a2ef57b(warning, type) {
    if ($3dc56cbd2fdf0b6d$var$shouldWarn(false)) {
        var emit = typeof $fXitr !== 'undefined' && $fXitr.emitWarning; // This will throw in Jest if `warning` is an Error instance due to
        // https://github.com/facebook/jest/issues/2549
        if (emit) emit(warning, type);
        else // eslint-disable-next-line no-console
        console.warn(type ? "".concat(type, ": ").concat(warning) : warning);
    }
}
function $3dc56cbd2fdf0b6d$export$db3b6bfb95261072(filename) {
    if ($3dc56cbd2fdf0b6d$var$shouldWarn(true)) {
        var path = filename.replace(/.*yaml[/\\]/i, '').replace(/\.js$/, '').replace(/\\/g, '/');
        $3dc56cbd2fdf0b6d$export$efccba1c4a2ef57b("The endpoint 'yaml/".concat(path, "' will be removed in a future release."), 'DeprecationWarning');
    }
}
var $3dc56cbd2fdf0b6d$var$warned = {};
function $3dc56cbd2fdf0b6d$export$407448d2b89b1813(name, alternative) {
    if (!$3dc56cbd2fdf0b6d$var$warned[name] && $3dc56cbd2fdf0b6d$var$shouldWarn(true)) {
        $3dc56cbd2fdf0b6d$var$warned[name] = true;
        var msg = "The option '".concat(name, "' will be removed in a future release");
        msg += alternative ? ", use '".concat(alternative, "' instead.") : '.';
        $3dc56cbd2fdf0b6d$export$efccba1c4a2ef57b(msg, 'DeprecationWarning');
    }
}

});
parcelRegister("bgvhE", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $8339749b9185fcc2$export$a143d493d941bafc; }, function (v) { return $8339749b9185fcc2$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $8339749b9185fcc2$export$f99ded8fe4b79145; }, function (v) { return $8339749b9185fcc2$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $8339749b9185fcc2$export$a143d493d941bafc;
var $8339749b9185fcc2$export$e4cf37d7f6fb9e0a;
var $8339749b9185fcc2$export$f99ded8fe4b79145;
var $8339749b9185fcc2$export$599f31c3813fae4d;
'use strict';

var $a2sCk = parcelRequire("a2sCk");

var $9KGN4 = parcelRequire("9KGN4");
const $8339749b9185fcc2$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$8339749b9185fcc2$export$a143d493d941bafc = $8339749b9185fcc2$var$Buffer;
$8339749b9185fcc2$export$e4cf37d7f6fb9e0a = $8339749b9185fcc2$var$SlowBuffer;
$8339749b9185fcc2$export$f99ded8fe4b79145 = 50;
const $8339749b9185fcc2$var$K_MAX_LENGTH = 0x7fffffff;
$8339749b9185fcc2$export$599f31c3813fae4d = $8339749b9185fcc2$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $8339749b9185fcc2$var$Buffer.TYPED_ARRAY_SUPPORT = $8339749b9185fcc2$var$typedArraySupport();
if (!$8339749b9185fcc2$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $8339749b9185fcc2$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($8339749b9185fcc2$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$8339749b9185fcc2$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($8339749b9185fcc2$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$8339749b9185fcc2$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $8339749b9185fcc2$var$createBuffer(length) {
    if (length > $8339749b9185fcc2$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $8339749b9185fcc2$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $8339749b9185fcc2$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $8339749b9185fcc2$var$allocUnsafe(arg);
    }
    return $8339749b9185fcc2$var$from(arg, encodingOrOffset, length);
}
$8339749b9185fcc2$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $8339749b9185fcc2$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $8339749b9185fcc2$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $8339749b9185fcc2$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($8339749b9185fcc2$var$isInstance(value, ArrayBuffer) || value && $8339749b9185fcc2$var$isInstance(value.buffer, ArrayBuffer)) return $8339749b9185fcc2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($8339749b9185fcc2$var$isInstance(value, SharedArrayBuffer) || value && $8339749b9185fcc2$var$isInstance(value.buffer, SharedArrayBuffer))) return $8339749b9185fcc2$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $8339749b9185fcc2$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $8339749b9185fcc2$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $8339749b9185fcc2$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $8339749b9185fcc2$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $8339749b9185fcc2$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($8339749b9185fcc2$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($8339749b9185fcc2$var$Buffer, Uint8Array);
function $8339749b9185fcc2$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $8339749b9185fcc2$var$alloc(size, fill, encoding) {
    $8339749b9185fcc2$var$assertSize(size);
    if (size <= 0) return $8339749b9185fcc2$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $8339749b9185fcc2$var$createBuffer(size).fill(fill, encoding) : $8339749b9185fcc2$var$createBuffer(size).fill(fill);
    return $8339749b9185fcc2$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $8339749b9185fcc2$var$Buffer.alloc = function(size, fill, encoding) {
    return $8339749b9185fcc2$var$alloc(size, fill, encoding);
};
function $8339749b9185fcc2$var$allocUnsafe(size) {
    $8339749b9185fcc2$var$assertSize(size);
    return $8339749b9185fcc2$var$createBuffer(size < 0 ? 0 : $8339749b9185fcc2$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $8339749b9185fcc2$var$Buffer.allocUnsafe = function(size) {
    return $8339749b9185fcc2$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $8339749b9185fcc2$var$Buffer.allocUnsafeSlow = function(size) {
    return $8339749b9185fcc2$var$allocUnsafe(size);
};
function $8339749b9185fcc2$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$8339749b9185fcc2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $8339749b9185fcc2$var$byteLength(string, encoding) | 0;
    let buf = $8339749b9185fcc2$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $8339749b9185fcc2$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $8339749b9185fcc2$var$checked(array.length) | 0;
    const buf = $8339749b9185fcc2$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $8339749b9185fcc2$var$fromArrayView(arrayView) {
    if ($8339749b9185fcc2$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $8339749b9185fcc2$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $8339749b9185fcc2$var$fromArrayLike(arrayView);
}
function $8339749b9185fcc2$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $8339749b9185fcc2$var$Buffer.prototype);
    return buf;
}
function $8339749b9185fcc2$var$fromObject(obj) {
    if ($8339749b9185fcc2$var$Buffer.isBuffer(obj)) {
        const len = $8339749b9185fcc2$var$checked(obj.length) | 0;
        const buf = $8339749b9185fcc2$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $8339749b9185fcc2$var$numberIsNaN(obj.length)) return $8339749b9185fcc2$var$createBuffer(0);
        return $8339749b9185fcc2$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $8339749b9185fcc2$var$fromArrayLike(obj.data);
}
function $8339749b9185fcc2$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $8339749b9185fcc2$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $8339749b9185fcc2$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $8339749b9185fcc2$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $8339749b9185fcc2$var$Buffer.alloc(+length);
}
$8339749b9185fcc2$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $8339749b9185fcc2$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$8339749b9185fcc2$var$Buffer.compare = function compare(a, b) {
    if ($8339749b9185fcc2$var$isInstance(a, Uint8Array)) a = $8339749b9185fcc2$var$Buffer.from(a, a.offset, a.byteLength);
    if ($8339749b9185fcc2$var$isInstance(b, Uint8Array)) b = $8339749b9185fcc2$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$8339749b9185fcc2$var$Buffer.isBuffer(a) || !$8339749b9185fcc2$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$8339749b9185fcc2$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$8339749b9185fcc2$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $8339749b9185fcc2$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $8339749b9185fcc2$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($8339749b9185fcc2$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$8339749b9185fcc2$var$Buffer.isBuffer(buf)) buf = $8339749b9185fcc2$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$8339749b9185fcc2$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $8339749b9185fcc2$var$byteLength(string, encoding) {
    if ($8339749b9185fcc2$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $8339749b9185fcc2$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $8339749b9185fcc2$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $8339749b9185fcc2$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $8339749b9185fcc2$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$8339749b9185fcc2$var$Buffer.byteLength = $8339749b9185fcc2$var$byteLength;
function $8339749b9185fcc2$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $8339749b9185fcc2$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $8339749b9185fcc2$var$utf8Slice(this, start, end);
        case 'ascii':
            return $8339749b9185fcc2$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $8339749b9185fcc2$var$latin1Slice(this, start, end);
        case 'base64':
            return $8339749b9185fcc2$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8339749b9185fcc2$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$8339749b9185fcc2$var$Buffer.prototype._isBuffer = true;
function $8339749b9185fcc2$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$8339749b9185fcc2$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$8339749b9185fcc2$var$swap(this, i, i + 1);
    return this;
};
$8339749b9185fcc2$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $8339749b9185fcc2$var$swap(this, i, i + 3);
        $8339749b9185fcc2$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$8339749b9185fcc2$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $8339749b9185fcc2$var$swap(this, i, i + 7);
        $8339749b9185fcc2$var$swap(this, i + 1, i + 6);
        $8339749b9185fcc2$var$swap(this, i + 2, i + 5);
        $8339749b9185fcc2$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$8339749b9185fcc2$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $8339749b9185fcc2$var$utf8Slice(this, 0, length);
    return $8339749b9185fcc2$var$slowToString.apply(this, arguments);
};
$8339749b9185fcc2$var$Buffer.prototype.toLocaleString = $8339749b9185fcc2$var$Buffer.prototype.toString;
$8339749b9185fcc2$var$Buffer.prototype.equals = function equals(b) {
    if (!$8339749b9185fcc2$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $8339749b9185fcc2$var$Buffer.compare(this, b) === 0;
};
$8339749b9185fcc2$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $8339749b9185fcc2$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($8339749b9185fcc2$var$customInspectSymbol) $8339749b9185fcc2$var$Buffer.prototype[$8339749b9185fcc2$var$customInspectSymbol] = $8339749b9185fcc2$var$Buffer.prototype.inspect;
$8339749b9185fcc2$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($8339749b9185fcc2$var$isInstance(target, Uint8Array)) target = $8339749b9185fcc2$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$8339749b9185fcc2$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $8339749b9185fcc2$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($8339749b9185fcc2$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $8339749b9185fcc2$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($8339749b9185fcc2$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $8339749b9185fcc2$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $8339749b9185fcc2$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $8339749b9185fcc2$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$8339749b9185fcc2$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$8339749b9185fcc2$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $8339749b9185fcc2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$8339749b9185fcc2$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $8339749b9185fcc2$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $8339749b9185fcc2$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($8339749b9185fcc2$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $8339749b9185fcc2$var$utf8Write(buf, string, offset, length) {
    return $8339749b9185fcc2$var$blitBuffer($8339749b9185fcc2$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $8339749b9185fcc2$var$asciiWrite(buf, string, offset, length) {
    return $8339749b9185fcc2$var$blitBuffer($8339749b9185fcc2$var$asciiToBytes(string), buf, offset, length);
}
function $8339749b9185fcc2$var$base64Write(buf, string, offset, length) {
    return $8339749b9185fcc2$var$blitBuffer($8339749b9185fcc2$var$base64ToBytes(string), buf, offset, length);
}
function $8339749b9185fcc2$var$ucs2Write(buf, string, offset, length) {
    return $8339749b9185fcc2$var$blitBuffer($8339749b9185fcc2$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$8339749b9185fcc2$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $8339749b9185fcc2$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $8339749b9185fcc2$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $8339749b9185fcc2$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $8339749b9185fcc2$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $8339749b9185fcc2$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$8339749b9185fcc2$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $8339749b9185fcc2$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $a2sCk.fromByteArray(buf);
    else return $a2sCk.fromByteArray(buf.slice(start, end));
}
function $8339749b9185fcc2$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $8339749b9185fcc2$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $8339749b9185fcc2$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $8339749b9185fcc2$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $8339749b9185fcc2$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $8339749b9185fcc2$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $8339749b9185fcc2$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $8339749b9185fcc2$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $8339749b9185fcc2$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $8339749b9185fcc2$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $8339749b9185fcc2$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$8339749b9185fcc2$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $8339749b9185fcc2$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $8339749b9185fcc2$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$8339749b9185fcc2$var$Buffer.prototype.readUintLE = $8339749b9185fcc2$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$8339749b9185fcc2$var$Buffer.prototype.readUintBE = $8339749b9185fcc2$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$8339749b9185fcc2$var$Buffer.prototype.readUint8 = $8339749b9185fcc2$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$8339749b9185fcc2$var$Buffer.prototype.readUint16LE = $8339749b9185fcc2$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$8339749b9185fcc2$var$Buffer.prototype.readUint16BE = $8339749b9185fcc2$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$8339749b9185fcc2$var$Buffer.prototype.readUint32LE = $8339749b9185fcc2$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$8339749b9185fcc2$var$Buffer.prototype.readUint32BE = $8339749b9185fcc2$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$8339749b9185fcc2$var$Buffer.prototype.readBigUInt64LE = $8339749b9185fcc2$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $8339749b9185fcc2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8339749b9185fcc2$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$8339749b9185fcc2$var$Buffer.prototype.readBigUInt64BE = $8339749b9185fcc2$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $8339749b9185fcc2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8339749b9185fcc2$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$8339749b9185fcc2$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8339749b9185fcc2$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$8339749b9185fcc2$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$8339749b9185fcc2$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8339749b9185fcc2$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$8339749b9185fcc2$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$8339749b9185fcc2$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$8339749b9185fcc2$var$Buffer.prototype.readBigInt64LE = $8339749b9185fcc2$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $8339749b9185fcc2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8339749b9185fcc2$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$8339749b9185fcc2$var$Buffer.prototype.readBigInt64BE = $8339749b9185fcc2$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $8339749b9185fcc2$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $8339749b9185fcc2$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$8339749b9185fcc2$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, 4, this.length);
    return $9KGN4.read(this, offset, true, 23, 4);
};
$8339749b9185fcc2$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, 4, this.length);
    return $9KGN4.read(this, offset, false, 23, 4);
};
$8339749b9185fcc2$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, 8, this.length);
    return $9KGN4.read(this, offset, true, 52, 8);
};
$8339749b9185fcc2$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkOffset(offset, 8, this.length);
    return $9KGN4.read(this, offset, false, 52, 8);
};
function $8339749b9185fcc2$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$8339749b9185fcc2$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$8339749b9185fcc2$var$Buffer.prototype.writeUintLE = $8339749b9185fcc2$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8339749b9185fcc2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8339749b9185fcc2$var$Buffer.prototype.writeUintBE = $8339749b9185fcc2$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $8339749b9185fcc2$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$8339749b9185fcc2$var$Buffer.prototype.writeUint8 = $8339749b9185fcc2$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$8339749b9185fcc2$var$Buffer.prototype.writeUint16LE = $8339749b9185fcc2$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8339749b9185fcc2$var$Buffer.prototype.writeUint16BE = $8339749b9185fcc2$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8339749b9185fcc2$var$Buffer.prototype.writeUint32LE = $8339749b9185fcc2$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$8339749b9185fcc2$var$Buffer.prototype.writeUint32BE = $8339749b9185fcc2$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $8339749b9185fcc2$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $8339749b9185fcc2$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $8339749b9185fcc2$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $8339749b9185fcc2$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$8339749b9185fcc2$var$Buffer.prototype.writeBigUInt64LE = $8339749b9185fcc2$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $8339749b9185fcc2$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8339749b9185fcc2$var$Buffer.prototype.writeBigUInt64BE = $8339749b9185fcc2$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $8339749b9185fcc2$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$8339749b9185fcc2$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8339749b9185fcc2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8339749b9185fcc2$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $8339749b9185fcc2$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$8339749b9185fcc2$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$8339749b9185fcc2$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$8339749b9185fcc2$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$8339749b9185fcc2$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$8339749b9185fcc2$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$8339749b9185fcc2$var$Buffer.prototype.writeBigInt64LE = $8339749b9185fcc2$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $8339749b9185fcc2$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$8339749b9185fcc2$var$Buffer.prototype.writeBigInt64BE = $8339749b9185fcc2$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $8339749b9185fcc2$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $8339749b9185fcc2$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $8339749b9185fcc2$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9KGN4.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$8339749b9185fcc2$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $8339749b9185fcc2$var$writeFloat(this, value, offset, true, noAssert);
};
$8339749b9185fcc2$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $8339749b9185fcc2$var$writeFloat(this, value, offset, false, noAssert);
};
function $8339749b9185fcc2$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $8339749b9185fcc2$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9KGN4.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$8339749b9185fcc2$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $8339749b9185fcc2$var$writeDouble(this, value, offset, true, noAssert);
};
$8339749b9185fcc2$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $8339749b9185fcc2$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$8339749b9185fcc2$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$8339749b9185fcc2$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$8339749b9185fcc2$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$8339749b9185fcc2$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $8339749b9185fcc2$var$Buffer.isBuffer(val) ? val : $8339749b9185fcc2$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $8339749b9185fcc2$var$errors = {};
function $8339749b9185fcc2$var$E(sym, getMessage, Base) {
    $8339749b9185fcc2$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$8339749b9185fcc2$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$8339749b9185fcc2$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$8339749b9185fcc2$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $8339749b9185fcc2$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $8339749b9185fcc2$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $8339749b9185fcc2$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $8339749b9185fcc2$var$checkBounds(buf, offset, byteLength) {
    $8339749b9185fcc2$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $8339749b9185fcc2$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $8339749b9185fcc2$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $8339749b9185fcc2$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $8339749b9185fcc2$var$checkBounds(buf, offset, byteLength);
}
function $8339749b9185fcc2$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $8339749b9185fcc2$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $8339749b9185fcc2$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $8339749b9185fcc2$var$validateNumber(value, type);
        throw new $8339749b9185fcc2$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $8339749b9185fcc2$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $8339749b9185fcc2$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $8339749b9185fcc2$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $8339749b9185fcc2$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($8339749b9185fcc2$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $8339749b9185fcc2$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $8339749b9185fcc2$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $8339749b9185fcc2$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $8339749b9185fcc2$var$base64ToBytes(str) {
    return $a2sCk.toByteArray($8339749b9185fcc2$var$base64clean(str));
}
function $8339749b9185fcc2$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $8339749b9185fcc2$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $8339749b9185fcc2$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $8339749b9185fcc2$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $8339749b9185fcc2$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $8339749b9185fcc2$var$BufferBigIntNotDefined : fn;
}
function $8339749b9185fcc2$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("a2sCk", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $74f04a1256af8f61$export$d622b2ad8d90c771; }, function (v) { return $74f04a1256af8f61$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $74f04a1256af8f61$export$6100ba28696e12de; }, function (v) { return $74f04a1256af8f61$export$6100ba28696e12de = v; });
var $74f04a1256af8f61$export$a48f0734ac7c2329;
var $74f04a1256af8f61$export$d622b2ad8d90c771;
var $74f04a1256af8f61$export$6100ba28696e12de;
'use strict';
$74f04a1256af8f61$export$a48f0734ac7c2329 = $74f04a1256af8f61$var$byteLength;
$74f04a1256af8f61$export$d622b2ad8d90c771 = $74f04a1256af8f61$var$toByteArray;
$74f04a1256af8f61$export$6100ba28696e12de = $74f04a1256af8f61$var$fromByteArray;
var $74f04a1256af8f61$var$lookup = [];
var $74f04a1256af8f61$var$revLookup = [];
var $74f04a1256af8f61$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $74f04a1256af8f61$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $74f04a1256af8f61$var$i = 0, $74f04a1256af8f61$var$len = $74f04a1256af8f61$var$code.length; $74f04a1256af8f61$var$i < $74f04a1256af8f61$var$len; ++$74f04a1256af8f61$var$i){
    $74f04a1256af8f61$var$lookup[$74f04a1256af8f61$var$i] = $74f04a1256af8f61$var$code[$74f04a1256af8f61$var$i];
    $74f04a1256af8f61$var$revLookup[$74f04a1256af8f61$var$code.charCodeAt($74f04a1256af8f61$var$i)] = $74f04a1256af8f61$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$74f04a1256af8f61$var$revLookup['-'.charCodeAt(0)] = 62;
$74f04a1256af8f61$var$revLookup['_'.charCodeAt(0)] = 63;
function $74f04a1256af8f61$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $74f04a1256af8f61$var$byteLength(b64) {
    var lens = $74f04a1256af8f61$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $74f04a1256af8f61$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $74f04a1256af8f61$var$toByteArray(b64) {
    var tmp;
    var lens = $74f04a1256af8f61$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $74f04a1256af8f61$var$Arr($74f04a1256af8f61$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $74f04a1256af8f61$var$revLookup[b64.charCodeAt(i)] << 18 | $74f04a1256af8f61$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $74f04a1256af8f61$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $74f04a1256af8f61$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $74f04a1256af8f61$var$revLookup[b64.charCodeAt(i)] << 2 | $74f04a1256af8f61$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $74f04a1256af8f61$var$revLookup[b64.charCodeAt(i)] << 10 | $74f04a1256af8f61$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $74f04a1256af8f61$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $74f04a1256af8f61$var$tripletToBase64(num) {
    return $74f04a1256af8f61$var$lookup[num >> 18 & 0x3F] + $74f04a1256af8f61$var$lookup[num >> 12 & 0x3F] + $74f04a1256af8f61$var$lookup[num >> 6 & 0x3F] + $74f04a1256af8f61$var$lookup[num & 0x3F];
}
function $74f04a1256af8f61$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($74f04a1256af8f61$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $74f04a1256af8f61$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($74f04a1256af8f61$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($74f04a1256af8f61$var$lookup[tmp >> 2] + $74f04a1256af8f61$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($74f04a1256af8f61$var$lookup[tmp >> 10] + $74f04a1256af8f61$var$lookup[tmp >> 4 & 0x3F] + $74f04a1256af8f61$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9KGN4", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $71999a40d522a6fb$export$aafa59e2e03f2942; }, function (v) { return $71999a40d522a6fb$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $71999a40d522a6fb$export$68d8715fc104d294; }, function (v) { return $71999a40d522a6fb$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $71999a40d522a6fb$export$aafa59e2e03f2942;
var $71999a40d522a6fb$export$68d8715fc104d294;
$71999a40d522a6fb$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$71999a40d522a6fb$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("fXitr", function(module, exports) {
"use strict";

});




/*
export enum Direction {
    IDLE,
    FRONT,
    LEFT,
    BACK,
    RIGHT,
    ABOVE,
    BELOW
}*/ class $fcbf04e630656d3a$export$13807d9ee5a34a42 {
    x = 0;
    y = 0;
    z = 0;
    constructor(_x, _y, _z){
        this.x = _x;
        this.y = _y;
        this.z = _z;
    }
    toString() {
        return this.x + ',' + this.y + ',' + this.z;
    }
    to(dir) {
        return new $fcbf04e630656d3a$export$13807d9ee5a34a42(this.x + dir.x, this.y + dir.y, this.z + dir.z);
    }
}



class $20a0fde87a9870e1$export$29cd7b75162a9425 {
    #grid = {};
    seed = Math.random();
    topology;
    constructor(topology){
        this.topology = topology;
    }
    canonicalPosition(pos) {
        if (this.topology.type === 'torus') return new (0, $fcbf04e630656d3a$export$13807d9ee5a34a42)((pos.x + this.topology.x) % this.topology.x, (pos.y + this.topology.y) % this.topology.y, (pos.z + this.topology.z) % this.topology.z);
        return pos;
    }
    get(pos) {
        if (this.topology.type === 'finite-grid') {
            if (pos.x < -1 || pos.y < -1 || pos.z < -1) return '.';
            if (pos.x > this.topology.x || pos.y > this.topology.y || pos.z > this.topology.z) return '.';
            if (this.topology.dimension === 2) {
                if (pos.z != 0) return '.';
                if (pos.x == -1 || pos.y == -1 && pos.z == 0) return 'W';
                if (pos.x == this.topology.x || pos.y == this.topology.y && pos.z == 0) return 'W';
            } else {
                if (pos.x == -1 || pos.y == -1 || pos.z == -1) return 'W';
                if (pos.x == this.topology.x || pos.y == this.topology.y || pos.z == this.topology.z) return 'W';
            }
        } else if (this.topology.type === 'torus') {
            if (pos.z <= -1 || pos.z >= this.topology.z) return '.';
        }
        pos = this.canonicalPosition(pos);
        return this.#grid[pos.toString()]?.color || '.';
    }
    set(pos, color) {
        pos = this.canonicalPosition(pos);
        this.#grid[pos.toString()] = {
            pos: pos,
            color: color
        };
    }
    robots() {
        return Object.keys(this.#grid).map((k)=>this.#grid[k]);
    }
    copy() {
        const g = new $20a0fde87a9870e1$export$29cd7b75162a9425(this.topology);
        this.robots().forEach(({ pos: pos, color: color })=>g.set(pos, color));
        g.seed = this.seed;
        return g;
    }
    equals(conf) {
        const thisRobots = this.robots();
        const ok = thisRobots.reduce((ok, r)=>ok && conf.get(r.pos) === r.color, true);
        return ok && thisRobots.length === conf.robots().length;
    }
    getView(pos, visibilityRange, dimension) {
        const dirs = (0, $347b986847663c76$export$ee89fa751abcfe5a)(visibilityRange);
        const view = new (0, $347b986847663c76$export$27a5bd065ad55220)();
        for (const dir of dirs)view.set(dir, this.get(pos.to(dir)));
        return view;
    }
    asKey() {
        return this.robots().map((r)=>r.pos.toString() + ':' + r.color).sort().join('\n');
    }
    toString() {
        return 'config:\n' + this.robots().map((r)=>r.pos.toString() + ':' + r.color).join('\n');
    }
    toPrettyString() {
        const grid = new Array(this.topology.x).fill(0).map(()=>new Array(this.topology.y).fill('.'));
        this.robots().forEach((r)=>{
            grid[r.pos.x][r.pos.y] = r.color;
        });
        return grid.map((row)=>row.join('')).join('\n');
    }
}


function $948ebe9947c47692$var$mulberry32(seed) {
    return {
        seed: ()=>seed,
        next: ()=>{
            let t = seed += 0x6D2B79F5;
            t = Math.imul(t ^ t >>> 15, t | 1);
            t ^= t + Math.imul(t ^ t >>> 7, t | 61);
            return ((t ^ t >>> 14) >>> 0) / 4294967296;
        }
    };
}
var $948ebe9947c47692$export$2e2bcd8739ae039 = $948ebe9947c47692$var$mulberry32;



const $347b986847663c76$export$49984ede44adf88d = {
    x: 0,
    y: 0,
    z: 0
}, $347b986847663c76$export$51ec4a2fc467eaa7 = {
    x: 0,
    y: 1,
    z: 0
}, $347b986847663c76$export$1eeca8128376e4e9 = {
    x: 0,
    y: -1,
    z: 0
}, $347b986847663c76$export$f981f70d61d1405a = {
    x: -1,
    y: 0,
    z: 0
}, $347b986847663c76$export$1cac5500365a4eb4 = {
    x: 1,
    y: 0,
    z: 0
}, $347b986847663c76$export$50e63dfb05a215ef = {
    x: 0,
    y: 0,
    z: 1
}, $347b986847663c76$export$d73203a818a78b30 = {
    x: 0,
    y: 0,
    z: -1
};
const $347b986847663c76$export$26d4bba6d8733af8 = function({ x: x, y: y, z: z }) {
    return `${x},${y},${z}`;
};
const $347b986847663c76$export$e6f70e714c0fa418 = function(d1, d2) {
    return d1.x === d2.x && d1.y === d2.y && d1.z === d2.z;
};
const $347b986847663c76$export$12fe6b637cdfbfb3 = function(dir) {
    return ({
        [$347b986847663c76$export$26d4bba6d8733af8($347b986847663c76$export$49984ede44adf88d)]: 'idle',
        [$347b986847663c76$export$26d4bba6d8733af8($347b986847663c76$export$51ec4a2fc467eaa7)]: 'front',
        [$347b986847663c76$export$26d4bba6d8733af8($347b986847663c76$export$1eeca8128376e4e9)]: 'back',
        [$347b986847663c76$export$26d4bba6d8733af8($347b986847663c76$export$f981f70d61d1405a)]: 'left',
        [$347b986847663c76$export$26d4bba6d8733af8($347b986847663c76$export$1cac5500365a4eb4)]: 'right',
        [$347b986847663c76$export$26d4bba6d8733af8($347b986847663c76$export$50e63dfb05a215ef)]: 'above',
        [$347b986847663c76$export$26d4bba6d8733af8($347b986847663c76$export$d73203a818a78b30)]: 'below'
    })[$347b986847663c76$export$26d4bba6d8733af8(dir)];
}; /*
   export class Direction {
       x: number;
       y: number;
       z: number;
       constructor(x,y,z) {this.x = x; this.y = y; this.z = z};
       toString() { return  `${this.x},${this.y},${this.z}` };
       equals(dir: Direction) {
           return dir.x === this.x && dir.y === this.y && dir.z === this.z;
       }
   };
   */ 
function $347b986847663c76$export$ee89fa751abcfe5a(visibilityRange) {
    let s = [];
    for(let z = visibilityRange; z >= -visibilityRange; z--)for(let y = visibilityRange; y >= -visibilityRange; y--){
        for(let x = -visibilityRange; x <= visibilityRange; x++)if (Math.abs(x) + Math.abs(y) + Math.abs(z) <= visibilityRange) s.push({
            x: x,
            y: y,
            z: z
        });
    }
    return s;
} // Number of state in a view
// https://oeis.org/A001845
// formula a(n) = (2*n+1)*(2*n^2 + 2*n + 3)/3
const $347b986847663c76$var$StateCount = {
    7: 1,
    25: 2,
    63: 3,
    129: 4,
    231: 5,
    377: 6,
    575: 7,
    833: 8,
    1159: 9
};
class $347b986847663c76$export$27a5bd065ad55220 {
    states;
    wallsBoundaries;
    visibleCount;
    constructor(){
        this.states = {};
        this.wallsBoundaries = {
            wallX: [
                0,
                0
            ],
            wallY: [
                0,
                0
            ],
            wallZ: [
                0,
                0
            ]
        };
        this.visibleCount = 0;
    }
    set(dir, ns) {
        this.states[$347b986847663c76$export$26d4bba6d8733af8(dir)] = ns;
        if (ns != '.') this.visibleCount++;
    }
    get(dir) {
        return this.states[$347b986847663c76$export$26d4bba6d8733af8(dir)];
    }
    getCenter() {
        return this.get($347b986847663c76$export$49984ede44adf88d);
    }
    visibilityRange() {
        /*switch(Object.keys(this.states).length) {
        case 5: return 1;
        case 7: return 1;
        case 25: return 2;
        case 63: return 3;
    }
    throw `View with ${Object.keys(this.states).length} states is not implemented`;
    */ const vr = $347b986847663c76$var$StateCount[Object.keys(this.states).length];
        if (!vr) throw `View with ${Object.keys(this.states).length} states is not implemented`;
        return vr;
    }
    setWalls({ wallX: wallX, wallY: wallY, wallZ: wallZ }) {
        this.wallsBoundaries = {
            wallX: wallX,
            wallY: wallY,
            wallZ: wallZ
        };
    }
    hasWallsBoundaries() {
        return this.wallsBoundaries.wallX[0] != 0 || this.wallsBoundaries.wallX[1] != 0 || this.wallsBoundaries.wallY[0] != 0 || this.wallsBoundaries.wallY[1] != 0 || this.wallsBoundaries.wallZ[0] != 0 || this.wallsBoundaries.wallZ[1] != 0;
    }
    removeFirstWall(dimension) {
        const wallsType = [
            [
                'wallX',
                'x'
            ],
            [
                'wallY',
                'y'
            ],
            [
                'wallZ',
                'z'
            ]
        ];
        for (const [wallType, vec] of wallsType){
            for(let i = 0; i < 2; i++)if (this.wallsBoundaries[wallType][i]) {
                const nvW = this.copy();
                const nv = this.copy();
                nvW.wallsBoundaries[wallType][i] = 0;
                nv.wallsBoundaries[wallType][i] += nv.wallsBoundaries[wallType][i] > 0 ? 1 : -1;
                if (Math.abs(nv.wallsBoundaries[wallType][i]) > this.visibilityRange()) nv.wallsBoundaries[wallType][i] = 0;
                for (const dir of $347b986847663c76$export$ee89fa751abcfe5a(this.visibilityRange()))if ((dir.z === 0 || dimension > 2) && dir[vec] === this.wallsBoundaries[wallType][i]) {
                    const k = $347b986847663c76$export$26d4bba6d8733af8(dir);
                    nv.states[k] = '.';
                    nvW.states[k] = 'W';
                }
                return [
                    nv,
                    nvW
                ];
            }
        }
        throw 'You should call removeFirstWall only if there are walls to remove (use hasWallsBoundaries)';
    }
    toString() {
        const s = [];
        for (const { x: x, y: y, z: z } of $347b986847663c76$export$ee89fa751abcfe5a(this.visibilityRange()))s.push(this.get({
            x: x,
            y: y,
            z: z
        }));
        return s.join('') + (this.hasWallsBoundaries() ? JSON.stringify(this.wallsBoundaries) : '');
    }
    includes(s) {
        return Object.values(this.states).includes(s);
    }
    replaceOne(s, ns) {
        const nv = new $347b986847663c76$export$27a5bd065ad55220();
        let found = false;
        for(const k in this.states)if (!found && this.states[k] === s) {
            nv.states[k] = ns;
            found = true;
        } else nv.states[k] = this.states[k];
        return nv;
    }
    copy() {
        const nv = new $347b986847663c76$export$27a5bd065ad55220();
        nv.visibleCount = this.visibleCount;
        for(const k in this.states)nv.states[k] = this.states[k];
        nv.wallsBoundaries = {
            wallX: [
                this.wallsBoundaries.wallX[0],
                this.wallsBoundaries.wallX[1]
            ],
            wallY: [
                this.wallsBoundaries.wallY[0],
                this.wallsBoundaries.wallY[1]
            ],
            wallZ: [
                this.wallsBoundaries.wallZ[0],
                this.wallsBoundaries.wallZ[1]
            ]
        };
        return nv;
    }
    apply(f) {
        const nv = new $347b986847663c76$export$27a5bd065ad55220();
        for (const k of $347b986847663c76$export$ee89fa751abcfe5a(this.visibilityRange()))nv.states[$347b986847663c76$export$26d4bba6d8733af8(k)] = this.states[$347b986847663c76$export$26d4bba6d8733af8(f(k))];
        return nv;
    }
    static emptyView(vr, center = '.') {
        const v = new $347b986847663c76$export$27a5bd065ad55220();
        for (const dir of $347b986847663c76$export$ee89fa751abcfe5a(vr))v.set(dir, '.');
        v.set($347b986847663c76$export$49984ede44adf88d, center);
        return v;
    }
}
function $347b986847663c76$export$caf12596e928ac5a(o) {
    return o;
}
function $347b986847663c76$export$8783d4bd6ad8332f(dest, dir) {
    for (const d of dest.dir){
        if ($347b986847663c76$export$e6f70e714c0fa418(d, dir)) return true;
    }
    return false;
}
const $347b986847663c76$var$toCanonicalCache = new Map();
function $347b986847663c76$export$ccf06a718c55ce20(rule, options) {
    const modelKey = options.dimension.toString() + '-' + options.chirality.toString();
    const key = rule.view.toString();
    if (!$347b986847663c76$var$toCanonicalCache.has(modelKey)) $347b986847663c76$var$toCanonicalCache.set(modelKey, new Map());
    const cachedTransformation = $347b986847663c76$var$toCanonicalCache.get(modelKey)?.get(key);
    if (cachedTransformation) //console.log('cached');
    return {
        rule: (0, $3ef10935a69594bb$export$ba81535868594d6c)(cachedTransformation[0], rule),
        transformation: cachedTransformation[0],
        transformations: cachedTransformation
    };
    const transformations = (0, $3ef10935a69594bb$export$473fc1421c7ed5a2)(options); // find the transformations that minimizes the component
    let min = rule.view.toString();
    let minRule = rule;
    let minTransformations = [];
    for (const transformation of transformations){
        const transformedRule = (0, $3ef10935a69594bb$export$ba81535868594d6c)(transformation, rule);
        const transformedComponent = transformedRule.view.toString();
        if (transformedComponent < min) {
            min = transformedComponent;
            minTransformations = [
                transformation
            ];
            minRule = transformedRule;
        } else if (transformedComponent === min) minTransformations.push(transformation);
    }
    $347b986847663c76$var$toCanonicalCache.get(modelKey)?.set(key, minTransformations);
    return {
        rule: minRule,
        transformation: minTransformations[0],
        transformations: minTransformations
    };
}
const $347b986847663c76$export$881b1507e65a37ad = function(r) {
    return `${r.view.toString()} (${JSON.stringify(r.view.wallsBoundaries)})->[${r.destination.dir.map((d)=>$347b986847663c76$export$26d4bba6d8733af8(d)).join(',')}],${r.destination.color}`;
};
function $347b986847663c76$export$6b5c1373c40c0253(v, dimension = 3) {
    return $347b986847663c76$export$ea40dd710081b328(v.view, dimension, {
        dest: v.destination.dir.map($347b986847663c76$export$12fe6b637cdfbfb3).join(',') + ', ' + v.destination.color
    });
}
function $347b986847663c76$export$ea40dd710081b328(v, dimension = 3, { dest: dest } = {
    dest: ''
}) {
    let s = [];
    let visibilityRange = v.visibilityRange();
    for(let z = visibilityRange; z >= -visibilityRange; z--){
        if (dimension == 2 && z != 0) continue;
        for(let y = visibilityRange - Math.abs(z); y >= Math.abs(z) - visibilityRange; y--){
            for(let x = -visibilityRange; x <= visibilityRange; x++)if (Math.abs(x) + Math.abs(y) + Math.abs(z) <= visibilityRange) s.push(v.get({
                x: x,
                y: y,
                z: z
            }));
            else s.push(' ');
            if (dest !== '' && y === 0 && z === 0) s.push(' -> ' + dest);
            if (s[s.length - 1] !== '\n') s.push('\n');
        }
    }
    return s.join('');
}
function $347b986847663c76$var$randomInt(max, rng) {
    return Math.floor(rng() * max);
}
function $347b986847663c76$var$randomEl(array, rng) {
    return array[$347b986847663c76$var$randomInt(array.length, rng)];
}
function $347b986847663c76$export$17045a50f8f50a6c(algo, config, pos) {
    const view = config.getView(pos, algo.options.visibilityRange, algo.options.dimension);
    const { rule: rule, transformation: transformation } = $347b986847663c76$export$ccf06a718c55ce20({
        view: view,
        destination: {
            dir: [
                $347b986847663c76$export$49984ede44adf88d
            ],
            color: 'A'
        },
        options: {
            maxWalls: undefined,
            override: undefined
        }
    }, algo.options);
    const key = rule.view.toString();
    if (algo.rules[key]) return algo.rules[key].destination.dir.map((d)=>transformation.f(d));
    return [
        $347b986847663c76$export$49984ede44adf88d
    ];
}
function $347b986847663c76$export$8e29bb008a68fd1f(algo, config) {
    const nextConfig = new (0, $20a0fde87a9870e1$export$29cd7b75162a9425)(config.topology);
    const rng = config.seed === -1 ? (0, $948ebe9947c47692$export$2e2bcd8739ae039)(Math.floor(Math.random() * 1000000)) : (0, $948ebe9947c47692$export$2e2bcd8739ae039)(config.seed);
    for (const robot of config.robots()){
        if (robot.color === 'W') {
            if (nextConfig.get(robot.pos) != '.') throw 'Collision';
            nextConfig.set(robot.pos, 'W');
            continue;
        }
        const view = config.getView(robot.pos, algo.options.visibilityRange, algo.options.dimension);
        const { rule: rule, transformation: transformation } = $347b986847663c76$export$ccf06a718c55ce20({
            view: view,
            destination: {
                dir: [
                    $347b986847663c76$export$49984ede44adf88d
                ],
                color: robot.color
            },
            options: {
                maxWalls: undefined,
                override: undefined
            }
        }, algo.options); //console.log(robot.pos, rule.view.toString())
        //console.log(prettyView(rule.view, algo.options.dimension));
        const key = rule.view.toString();
        let nextPos = robot.pos;
        let nextColor = robot.color;
        if (algo.rules[key]) {
            if (algo.rulesReference && algo.rulesReference[key]) algo.usedViews.add(algo.rulesReference[key].line);
            const { dir: dir, color: color = robot.color } = algo.rules[key].destination;
            nextPos = robot.pos.to(transformation.f($347b986847663c76$var$randomEl(dir, rng.next)));
            nextColor = color;
        }
        if (nextConfig.get(nextPos) != '.') throw 'Collision';
        nextConfig.set(nextPos, nextColor);
    }
    nextConfig.seed = config.seed === -1 ? -1 : rng.seed();
    return nextConfig;
}


function $3ef10935a69594bb$export$ba81535868594d6c(t, rule) {
    return {
        view: rule.view.apply(t.f),
        destination: {
            ...rule.destination,
            dir: rule.destination.dir.map((d)=>t.inv(d))
        },
        options: rule.options
    };
}
function $3ef10935a69594bb$export$959c0b3fbb6394f0(dir) {
    return {
        x: dir.x,
        y: dir.y,
        z: -dir.z
    };
}
function $3ef10935a69594bb$export$834a9a25a208fadb(dir) {
    return {
        x: dir.x,
        y: dir.y,
        z: -dir.z
    };
}
const $3ef10935a69594bb$export$84aedb13b0eb9454 = {
    f: $3ef10935a69594bb$export$959c0b3fbb6394f0,
    inv: $3ef10935a69594bb$export$834a9a25a208fadb,
    name: 'Mirror XY'
};
function $3ef10935a69594bb$export$2b26620fbe87f335({ view: view, destination: destination, options: options }) {
    return {
        view: view.apply($3ef10935a69594bb$export$834a9a25a208fadb),
        destination: {
            ...destination,
            dir: destination.dir.map((d)=>$3ef10935a69594bb$export$959c0b3fbb6394f0(d))
        },
        options: options
    };
}
function $3ef10935a69594bb$export$4ab58b330ec555f6(dir) {
    return {
        x: dir.x,
        y: -dir.y,
        z: dir.z
    };
}
function $3ef10935a69594bb$export$d148c612b1b5c858(dir) {
    return {
        x: dir.x,
        y: -dir.y,
        z: dir.z
    };
}
const $3ef10935a69594bb$export$a6bdb2db81839959 = {
    f: $3ef10935a69594bb$export$4ab58b330ec555f6,
    inv: $3ef10935a69594bb$export$d148c612b1b5c858,
    name: 'Mirror XZ'
};
function $3ef10935a69594bb$export$a8fd18bcb55037f7({ view: view, destination: destination, options: options }) {
    return {
        view: view.apply($3ef10935a69594bb$export$d148c612b1b5c858),
        destination: {
            ...destination,
            dir: destination.dir.map((d)=>$3ef10935a69594bb$export$4ab58b330ec555f6(d))
        },
        options: options
    };
}
function $3ef10935a69594bb$export$6411c1d9c754a0aa(dir) {
    return {
        x: dir.x,
        y: dir.z,
        z: -dir.y
    };
}
function $3ef10935a69594bb$export$268172812447dba5(dir) {
    return {
        x: dir.x,
        y: -dir.z,
        z: dir.y
    };
}
const $3ef10935a69594bb$export$a59c8716592e09af = {
    f: $3ef10935a69594bb$export$6411c1d9c754a0aa,
    inv: $3ef10935a69594bb$export$268172812447dba5,
    name: 'Rotate X'
};
function $3ef10935a69594bb$export$63e963c548806bc3({ view: view, destination: destination, options: options }) {
    return {
        view: view.apply($3ef10935a69594bb$export$268172812447dba5),
        destination: {
            ...destination,
            dir: destination.dir.map((d)=>$3ef10935a69594bb$export$6411c1d9c754a0aa(d))
        },
        options: options
    };
}
function $3ef10935a69594bb$export$748fc64f58d7d2a3(dir) {
    return {
        x: -dir.z,
        y: dir.y,
        z: dir.x
    };
}
function $3ef10935a69594bb$export$855b894d2ccce728(dir) {
    return {
        x: dir.z,
        y: dir.y,
        z: -dir.x
    };
}
const $3ef10935a69594bb$export$cf71e4d4ca4d1cfd = {
    f: $3ef10935a69594bb$export$748fc64f58d7d2a3,
    inv: $3ef10935a69594bb$export$855b894d2ccce728,
    name: 'Rotate Y'
};
function $3ef10935a69594bb$export$34ae8471fb805a7a({ view: view, destination: destination, options: options }) {
    return {
        view: view.apply($3ef10935a69594bb$export$855b894d2ccce728),
        destination: {
            ...destination,
            dir: destination.dir.map((d)=>$3ef10935a69594bb$export$748fc64f58d7d2a3(d))
        },
        options: options
    };
}
function $3ef10935a69594bb$export$a96a716c76ed755d(dir) {
    return {
        x: dir.y,
        y: -dir.x,
        z: dir.z
    };
}
function $3ef10935a69594bb$export$4a30cd2b0e5759d3(dir) {
    return {
        x: -dir.y,
        y: dir.x,
        z: dir.z
    };
}
const $3ef10935a69594bb$export$ea6eae3365de5b9c = {
    f: $3ef10935a69594bb$export$a96a716c76ed755d,
    inv: $3ef10935a69594bb$export$4a30cd2b0e5759d3,
    name: 'Rotate Z'
};
function $3ef10935a69594bb$export$42595e5f79461535({ view: view, destination: destination, options: options }) {
    return {
        view: view.apply($3ef10935a69594bb$export$4a30cd2b0e5759d3),
        destination: {
            ...destination,
            dir: destination.dir.map((d)=>$3ef10935a69594bb$export$a96a716c76ed755d(d))
        },
        options: options
    };
}
function $3ef10935a69594bb$var$dirEqual(dir1, dir2) {
    return dir1.filter((d)=>!dir2.filter((d2)=>(0, $347b986847663c76$export$e6f70e714c0fa418)(d, d2)).length).length === 0 && dir2.filter((d)=>!dir1.filter((d1)=>(0, $347b986847663c76$export$e6f70e714c0fa418)(d, d1)).length).length === 0;
}
function $3ef10935a69594bb$export$985d576866ed897f(rules, { view: view, destination: destination, options: options }) {
    let k = view.toString();
    return !rules[k] || options.override || $3ef10935a69594bb$var$dirEqual(rules[k].destination.dir, destination.dir) && (rules[k].destination.color || view.getCenter()) == (destination.color || view.getCenter());
}
function $3ef10935a69594bb$var$resolveAlias(key, values, rule, f) {
    if (!rule.view.includes(key)) {
        f(rule);
        return;
    }
    for (let v of values){
        const new_view = rule.view.replaceOne(key, v);
        const new_dest = {
            ...rule.destination
        };
        if (new_view.getCenter() !== rule.view.getCenter() && new_dest.color == key) new_dest.color = v;
        $3ef10935a69594bb$var$resolveAlias(key, values, {
            view: new_view,
            destination: new_dest,
            options: rule.options
        }, f);
    }
}
function $3ef10935a69594bb$var$resolveWalls(view, dimension, f) {
    if (!view.hasWallsBoundaries()) {
        view = $3ef10935a69594bb$var$addConsistentWalls(view, dimension);
        f(view);
        return;
    }
    const [v1, v2] = view.removeFirstWall(dimension);
    $3ef10935a69594bb$var$resolveWalls(v1, dimension, f);
    $3ef10935a69594bb$var$resolveWalls(v2, dimension, f);
}
function $3ef10935a69594bb$var$addConsistentWalls(view, dimension) {
    let newView = null;
    const nv = ()=>newView === null ? newView = view.copy() : newView;
    const wallsBoundaries = [
        [
            -view.visibilityRange() - 1,
            view.visibilityRange() + 1
        ],
        [
            -view.visibilityRange() - 1,
            view.visibilityRange() + 1
        ],
        [
            -view.visibilityRange() - 1,
            view.visibilityRange() + 1
        ]
    ];
    for(let d = 1; d <= view.visibilityRange(); d++){
        if (view.get({
            x: -d,
            y: 0,
            z: 0
        }) === 'W' && wallsBoundaries[0][0] < d) wallsBoundaries[0][0] = -d;
        if (view.get({
            x: d,
            y: 0,
            z: 0
        }) === 'W' && wallsBoundaries[0][1] > d) wallsBoundaries[0][1] = d;
        if (view.get({
            x: 0,
            y: -d,
            z: 0
        }) === 'W' && wallsBoundaries[1][0] < d) wallsBoundaries[1][0] = -d;
        if (view.get({
            x: 0,
            y: d,
            z: 0
        }) === 'W' && wallsBoundaries[1][1] > d) wallsBoundaries[1][1] = d;
        if (view.get({
            x: 0,
            y: 0,
            z: -d
        }) === 'W' && wallsBoundaries[2][0] < d) wallsBoundaries[2][0] = -d;
        if (view.get({
            x: 0,
            y: 0,
            z: d
        }) === 'W' && wallsBoundaries[2][1] > d) wallsBoundaries[2][1] = d;
    }
    for (const dir of (0, $347b986847663c76$export$ee89fa751abcfe5a)(view.visibilityRange())){
        if (dir.z != 0 && dimension == 2) {
            nv().set(dir, '.');
            continue;
        }
        if ((dir.x === wallsBoundaries[0][0] || dir.x === wallsBoundaries[0][1]) && dir.y >= wallsBoundaries[1][0] && dir.y <= wallsBoundaries[1][1] && dir.z >= wallsBoundaries[1][0] && dir.z <= wallsBoundaries[1][1]) nv().set(dir, 'W');
        if (dir.x < wallsBoundaries[0][0] || dir.x > wallsBoundaries[0][1]) nv().set(dir, '.');
        if ((dir.y === wallsBoundaries[1][0] || dir.y === wallsBoundaries[1][1]) && dir.x >= wallsBoundaries[0][0] && dir.x <= wallsBoundaries[0][1] && dir.z >= wallsBoundaries[2][0] && dir.z <= wallsBoundaries[2][1]) nv().set(dir, 'W');
        if (dir.y < wallsBoundaries[1][0] || dir.y > wallsBoundaries[1][1]) nv().set(dir, '.');
        if ((dir.z === wallsBoundaries[2][0] || dir.z === wallsBoundaries[2][1]) && dir.x >= wallsBoundaries[0][0] && dir.x <= wallsBoundaries[0][1] && dir.y >= wallsBoundaries[1][0] && dir.y <= wallsBoundaries[1][1]) nv().set(dir, 'W');
        if (dir.z < wallsBoundaries[2][0] || dir.z > wallsBoundaries[2][1]) nv().set(dir, '.');
    }
    if (newView !== null) return newView;
    return view;
}
function $3ef10935a69594bb$export$1d528cd38f7ed1b7({ view: v1, destination: d1 }, { view: v2, destination: d2 }, ref1, ref2, dimension) {
    throw `
    Overlaping rules:
${(0, $347b986847663c76$export$ea40dd710081b328)(v1, dimension)} -> ${d1.dir.map((d)=>(0, $347b986847663c76$export$12fe6b637cdfbfb3)(d)).join(', ')} ${d1.color}
    obtained from rule at line ${ref1?.line}${ref1?.transformations.length ? ', after [' + ref1?.transformations.join(', ') + ']' : ''}
${(0, $347b986847663c76$export$ea40dd710081b328)(v2, dimension)} -> ${d2.dir.map((d)=>(0, $347b986847663c76$export$12fe6b637cdfbfb3)(d)).join(', ')} ${d2.color}
    obtained from rule at line ${ref2?.line}${ref2?.transformations.length ? ', after [' + ref2?.transformations.join(', ') + ']' : ''}
        `;
}
let $3ef10935a69594bb$var$cachedRules = {};
function $3ef10935a69594bb$var$cacheRule(key, t) {}
const $3ef10935a69594bb$var$mergeDirections = (rule1, rule2)=>{
    const dir = [
        ...rule1.destination.dir
    ];
    rule2.destination.dir.forEach((d)=>{
        if (dir.filter((d2)=>(0, $347b986847663c76$export$e6f70e714c0fa418)(d, d2)).length == 0) dir.push(d);
    });
    return dir;
};
function $3ef10935a69594bb$var$testAndAdd(rules, rulesReference, rule, ref, ignoreOverlap, options) {
    const k = rule.view.toString();
    if (!ignoreOverlap && !$3ef10935a69594bb$export$985d576866ed897f(rules, rule)) $3ef10935a69594bb$export$1d528cd38f7ed1b7(rule, rules[k], ref, rulesReference[k], options.dimension);
    if (rules[k]) {
        if (ignoreOverlap) {
            rules[k].destination.dir = $3ef10935a69594bb$var$mergeDirections(rules[k], rule);
            return;
        }
    }
    rules[k] = rule;
    if (ref) rulesReference[k] = ref;
}
function $3ef10935a69594bb$export$3f77d4ba3adcbe30(...f) {
    let a = [
        ...f
    ].reverse();
    return (x)=>a.reduce((acc, f)=>{
            return f(acc);
        }, x);
}
function $3ef10935a69594bb$export$f672e0b6f7222cd7(...ts) {
    const a = [
        ...ts
    ].reverse();
    const b = [
        ...ts
    ];
    return {
        f: (x)=>a.reduce((acc, f)=>{
                return f.f(acc);
            }, x),
        inv: (x)=>b.reduce((acc, f)=>{
                return f.inv(acc);
            }, x),
        name: b.map((t)=>t.name).join(', ')
    };
}
function $3ef10935a69594bb$export$473fc1421c7ed5a2(options) {
    const transformations = [];
    transformations.push({
        f: (x)=>x,
        inv: (x)=>x,
        name: 'identity'
    });
    transformations.push($3ef10935a69594bb$export$ea6eae3365de5b9c);
    transformations.push($3ef10935a69594bb$export$f672e0b6f7222cd7($3ef10935a69594bb$export$ea6eae3365de5b9c, $3ef10935a69594bb$export$ea6eae3365de5b9c));
    transformations.push($3ef10935a69594bb$export$f672e0b6f7222cd7($3ef10935a69594bb$export$ea6eae3365de5b9c, $3ef10935a69594bb$export$ea6eae3365de5b9c, $3ef10935a69594bb$export$ea6eae3365de5b9c));
    if (options.dimension === 3) {
        transformations.push($3ef10935a69594bb$export$f672e0b6f7222cd7($3ef10935a69594bb$export$a59c8716592e09af, $3ef10935a69594bb$export$a59c8716592e09af));
        transformations.push($3ef10935a69594bb$export$f672e0b6f7222cd7($3ef10935a69594bb$export$a59c8716592e09af, $3ef10935a69594bb$export$a59c8716592e09af, $3ef10935a69594bb$export$ea6eae3365de5b9c));
        transformations.push($3ef10935a69594bb$export$f672e0b6f7222cd7($3ef10935a69594bb$export$a59c8716592e09af, $3ef10935a69594bb$export$a59c8716592e09af, $3ef10935a69594bb$export$ea6eae3365de5b9c, $3ef10935a69594bb$export$ea6eae3365de5b9c));
        transformations.push($3ef10935a69594bb$export$f672e0b6f7222cd7($3ef10935a69594bb$export$a59c8716592e09af, $3ef10935a69594bb$export$a59c8716592e09af, $3ef10935a69594bb$export$ea6eae3365de5b9c, $3ef10935a69594bb$export$ea6eae3365de5b9c, $3ef10935a69594bb$export$ea6eae3365de5b9c));
        const otherSubgroup = [];
        otherSubgroup.push($3ef10935a69594bb$export$f672e0b6f7222cd7($3ef10935a69594bb$export$ea6eae3365de5b9c, $3ef10935a69594bb$export$a59c8716592e09af));
        otherSubgroup.push($3ef10935a69594bb$export$f672e0b6f7222cd7($3ef10935a69594bb$export$ea6eae3365de5b9c, $3ef10935a69594bb$export$a59c8716592e09af, $3ef10935a69594bb$export$ea6eae3365de5b9c, $3ef10935a69594bb$export$a59c8716592e09af));
        for (const t2 of [
            ...transformations
        ])for (const t of otherSubgroup)transformations.push($3ef10935a69594bb$export$f672e0b6f7222cd7(t, t2));
    }
    if (options.chirality === false) {
        let mir;
        if (options.dimension === 3) mir = $3ef10935a69594bb$export$84aedb13b0eb9454;
        else mir = $3ef10935a69594bb$export$a6bdb2db81839959;
        for (const t2 of [
            ...transformations
        ])transformations.push($3ef10935a69594bb$export$f672e0b6f7222cd7(mir, t2));
    }
    return transformations;
} /*
  export function namedTransformationsList(options: Options) : [(r:Rule) => Rule, number, string][] {
  
      const transformations: [(r:Rule) => Rule, number, string][] = []
      if(options.dimension === 3)
      {
          transformations.push([rotateX, 4, 'X rotation']);
          transformations.push([rotateY, 4, 'Y rotation']);
      }
      transformations.push([rotateZ, 4, 'Z rotation']);
      if(options.chirality === false)
      {
          if(options.dimension === 3)
              transformations.push([mirrorXY, 2, 'XY Mirroring']); //prettier in 3 dimentions
          else
              transformations.push([mirrorXZ, 2, 'X Mirroring']);
      }
  
      return transformations;
  }
  */ 
function $3ef10935a69594bb$var$_transformRule(rule, ruleReference, alias, options, { ignoreOverlap: ignoreOverlap } = {
    ignoreOverlap: false
}) {
    rule.view = $3ef10935a69594bb$var$addConsistentWalls(rule.view, options.dimension);
    const rules = {
        [rule.view.toString()]: rule
    };
    const rulesReference = {
        [rule.view.toString()]: ruleReference
    };
    if (rule.view.hasWallsBoundaries()) Object.entries(rules).forEach(([k, rule])=>{
        let ref = rulesReference[k] && {
            ...rulesReference[k],
            transformations: [
                ...rulesReference[k].transformations,
                'walls'
            ]
        };
        $3ef10935a69594bb$var$resolveWalls(rule.view, options.dimension, (view2)=>{
            $3ef10935a69594bb$var$testAndAdd(rules, rulesReference, {
                view: view2,
                destination: rule.destination,
                options: rule.options
            }, ref, ignoreOverlap, options);
        });
    });
    Object.entries(alias).forEach(([aliasKey, aliasValues])=>{
        Object.entries(rules).forEach(([k, rule])=>{
            let ref = {
                ...rulesReference[k],
                transformations: [
                    ...rulesReference[k].transformations,
                    'alias ' + aliasKey
                ]
            };
            $3ef10935a69594bb$var$resolveAlias(aliasKey, aliasValues, rule, (rule2)=>{
                $3ef10935a69594bb$var$testAndAdd(rules, rulesReference, rule2, ref, ignoreOverlap, options);
            });
        });
    });
    const rulesCanonical = {};
    const rulesCanonicalReference = {};
    for (const k of Object.keys(rules)){
        const can = (0, $347b986847663c76$export$ccf06a718c55ce20)(rules[k], options);
        if (can.transformations.length > 1 && !can.transformations.every((t)=>$3ef10935a69594bb$export$ba81535868594d6c(t, rules[k]).destination.dir.every((d)=>(0, $347b986847663c76$export$8783d4bd6ad8332f)(can.rule.destination, d)) // 
        )) can.transformations.forEach((t)=>$3ef10935a69594bb$export$ba81535868594d6c(t, rules[k]).destination.dir.forEach((d)=>{
                if (!(0, $347b986847663c76$export$8783d4bd6ad8332f)(can.rule.destination, d)) throw `
    Ambiguous rule at line ${rulesReference[k]?.line}:
${(0, $347b986847663c76$export$ea40dd710081b328)(rules[k].view, options.dimension)} -> ${rules[k].destination.dir.map((d)=>(0, $347b986847663c76$export$12fe6b637cdfbfb3)(d)).join(', ')} ${rules[k].destination.color}
    
    The rule is symmetric so the destinations should be 
    the set of undistinguishable destinations.

    In particular, two symmetric views are
${(0, $347b986847663c76$export$ea40dd710081b328)(can.rule.view, options.dimension)}
obtained after ${can.transformation.name}
and
${(0, $347b986847663c76$export$ea40dd710081b328)($3ef10935a69594bb$export$ba81535868594d6c(t, rules[k]).view, options.dimension)}
obtained after ${t.name}
`;
            }));
        const canonicalKey = can.rule.view.toString();
        rulesCanonical[canonicalKey] = can.rule;
        rulesCanonicalReference[canonicalKey] = rulesReference[k];
    } /*
        const transformations = namedTransformationsList(options);
    
        transformations.forEach(([transformation, order, tr_name] : [(r:Rule) => Rule, number, string]) => {
            Object.entries(rules).forEach(([k, rule]: [string, Rule]) => {
                let ref = rulesReference[k];
                ref = ref && {
                    ...ref,
                    transformations: [
                        ...ref.transformations,
                        tr_name
                    ]
                }
    
                for(let i = 0; i < order-1; i++) {
                    rule = transformation(rule);
                    
                    testAndAdd(rules, rulesReference,
                        rule,
                        ref,
                        ignoreOverlap, options)
                }
            })
        })*/ 
    return {
        rules: rulesCanonical,
        rulesReference: rulesCanonicalReference
    };
}
function $3ef10935a69594bb$export$c18765226966aa9(algo, { ignoreOverlap: ignoreOverlap } = {
    ignoreOverlap: false
}) {
    const { options: options, alias: alias } = algo;
    try {
        const rawRules = algo.rules;
        algo.rules = {};
        const rawRulesReference = algo.rulesReference;
        algo.rulesReference = {};
        Object.entries(rawRules).forEach(([key, rule])=>{
            let t = $3ef10935a69594bb$var$_transformRule(rule, rawRulesReference[key], alias, options, {
                ignoreOverlap: ignoreOverlap
            });
            for(const k in t.rules)$3ef10935a69594bb$var$testAndAdd(algo.rules, algo.rulesReference, t.rules[k], t.rulesReference[k], ignoreOverlap, options);
        }); //console.log('rules:', Object.keys(rules).length);
    //console.log('rules:', Object.keys(cachedRules));
    } catch (error) {
        $3ef10935a69594bb$var$cachedRules = {};
        console.log(error);
        throw error;
    }
}
var $3ef10935a69594bb$export$2e2bcd8739ae039 = {};



// https://oeis.org/A001844
const $0640cb604c7a0caa$var$ruleLineLength = [
    1,
    5,
    13,
    25,
    41,
    61,
    85,
    113,
    145,
    181
]; // odd numbers
// https://oeis.org/A005408  :)
const $0640cb604c7a0caa$var$mainRuleLineLength = [
    1,
    3,
    5,
    7,
    9,
    11,
    13,
    15,
    17,
    19
];
const $0640cb604c7a0caa$var$fill = (l, s = '.')=>{
    let r = [];
    for(let i = 0; i < l; i++)r.push(s);
    return r;
};
function $0640cb604c7a0caa$var$tokenize(line) {
    const tokens = [];
    let current = '';
    let inParen = false;
    for(let i = 0; i < line.length; i++){
        const char = line[i];
        if (char === '(') {
            if (inParen) current += char;
            else {
                current.length;
                inParen = true;
                current = '(';
            }
        } else if (char === ')') {
            if (inParen) {
                current += char;
                tokens.push(current);
                current = '';
                inParen = false;
            } else tokens.push(char);
        } else if (inParen) current += char;
        else if (char !== ' ') tokens.push(char);
    }
    if (current.length > 0) tokens.push(current);
    return tokens;
}
function $0640cb604c7a0caa$var$parseRuleOptions(lines) {
    const dict = new Map();
    for (let line of lines){
        let m = line.match(/^@([a-zA-Z0-9_]+)[ \t]*(.*)$/);
        if (!m) throw `invalid option ${line}`;
        dict.set(m[1], m[2]);
    }
    return {
        maxWalls: parseInt(dict.get('maxWalls') || '0'),
        override: dict.has('override')
    };
}
function $0640cb604c7a0caa$export$726deb39d943dc92(r, line, visibilityRange, dimension) {
    r = r.map((el)=>el.trim());
    let m = null;
    const options = $0640cb604c7a0caa$var$parseRuleOptions(r.filter((el)=>el.match(/^@/)));
    r = r.filter((el)=>!el.match(/^@/)); // Find the destination, which corresponds to the "middle" of the rule
    let middleIdx = null;
    for(let i = 0; i < r.length; i++)if (m = r[i].match(/^(.*)\->(.*)$/)) {
        if (middleIdx === null) middleIdx = i;
        else throw `rule at line ${line} contains two destination declarations (${line + middleIdx} and ${line + i})`;
    }
    if (middleIdx === null) throw `rule at line ${line} does not contain a destination declaration`;
    m = r[middleIdx].match(/^(.*)\->(.*)$/);
    if (!m) throw `rule at line ${line} does not contain a destination declaration`;
    let dest_text = m[2].trim();
    r[middleIdx] = m[1].trim();
    const grid = r.map((l)=>$0640cb604c7a0caa$var$tokenize(l));
    const wallX = [
        0,
        0
    ];
    const wallY = [
        0,
        0
    ];
    const wallZ = [
        0,
        0
    ];
    if (2 * visibilityRange + 1 !== grid[middleIdx].length) {
        console.log({
            visibilityRange: visibilityRange
        }, grid[middleIdx]);
        console.log(grid);
        throw `line ${line + middleIdx} should contain ${2 * visibilityRange + 1} states (found ${grid[middleIdx].length} instead: "${grid[middleIdx]}")`;
    }
    for(let i = 1; i <= visibilityRange; i++){
        //console.log(middleIdx, i, grid[middleIdx][visibilityRange - i], grid[middleIdx][visibilityRange + i], grid[middleIdx+i], grid[middleIdx-i])
        if (!wallX[0] && grid[middleIdx][visibilityRange - i] == '|') wallX[0] = -i;
        if (!wallX[1] && grid[middleIdx][visibilityRange + i] == '|') wallX[1] = i;
        if (!wallY[0] && grid[middleIdx + i].includes('-')) {
            wallY[0] = -i;
            grid[middleIdx - wallY[0]].push(...$0640cb604c7a0caa$var$fill(2 * (visibilityRange - i) + 1 - grid[middleIdx - wallY[0]].length));
        } else if (wallY[0]) grid[middleIdx - wallY[0]].push(...$0640cb604c7a0caa$var$fill(2 * (visibilityRange - i) + 1));
        else {
            if (2 * (visibilityRange - i) + 1 !== grid[middleIdx + i].length) throw `line ${line + middleIdx + i} should contain ${2 * (visibilityRange - i) + 1} states (found ${grid[middleIdx + i].length} instead)`;
        }
        if (!wallY[1] && grid[middleIdx - i].includes('-')) {
            wallY[1] = i;
            grid[middleIdx - wallY[1]].push(...$0640cb604c7a0caa$var$fill(2 * (visibilityRange - i) + 1 - grid[middleIdx - wallY[1]].length));
        } else if (wallY[1]) grid[middleIdx - wallY[1]].push(...$0640cb604c7a0caa$var$fill(2 * (visibilityRange - i) + 1));
        else {
            if (2 * (visibilityRange - i) + 1 !== grid[middleIdx - i].length) throw `line  ${line + middleIdx - i} should contain ${2 * (visibilityRange - i) + 1} states (found ${grid[middleIdx - i].length} instead)`;
        }
    }
    let zboundaries = [
        middleIdx + 1 + (-wallY[0] || visibilityRange),
        middleIdx - 1 - (wallY[1] || visibilityRange)
    ]; // we compute the zboundaries (and the z view) only in 3 dimensions
    if (dimension === 3) {
        if (grid[zboundaries[0]] === undefined) throw `There should be at least one more line containing states after line ${line + zboundaries[0] - 1}`;
        if (grid[zboundaries[1]] === undefined) throw `There should be at least one more line containing states before line ${line + zboundaries[1] + 1}`; //console.log({wallX, wallY}, zboundaries[0], zboundaries[1]);
        for(let i = 1; i <= visibilityRange; i++){
            if (!wallZ[0]) {
                if (grid[zboundaries[0]] == undefined) throw `There should be at least one more line containing states at the end of the rule starting line ${line + 1}`;
                if (grid[zboundaries[0]].includes('-')) {
                    wallZ[0] = -i;
                    zboundaries[0]++;
                }
            } else {
                if (grid[zboundaries[0]] != undefined) throw `There should be no more line containing states after line ${line + zboundaries[0] + 1}`;
            }
            if (!wallZ[1]) {
                if (grid[zboundaries[1]] == undefined) throw `There should be at least one more line containing states before line ${line}`;
                if (grid[zboundaries[1]].includes('-')) {
                    wallZ[1] = i;
                    zboundaries[1]--;
                }
            } else {
                if (grid[zboundaries[1]] != undefined) throw `There should be no more line containing states before line ${line + zboundaries[1] + 1}`;
            }
            if (!wallZ[1] && i != visibilityRange) zboundaries[1] -= (visibilityRange - i) * 2 + 1;
            if (!wallZ[0] && i != visibilityRange) zboundaries[0] += (visibilityRange - i) * 2 + 1;
        }
        if (grid[zboundaries[0] + 1] != undefined) throw `There should be no more line containing states after line ${line + zboundaries[0]}`;
        if (grid[zboundaries[1] - 1] != undefined) throw `There should be no one more line containing states before line ${line + zboundaries[1]}`;
        if (wallZ[1] > 0 && wallZ[1] < visibilityRange) grid[0].push(...$0640cb604c7a0caa$var$fill($0640cb604c7a0caa$var$ruleLineLength[visibilityRange - wallZ[1]]));
        if (wallZ[0] < 0 && wallZ[0] > -visibilityRange) grid[grid.length - 1].push(...$0640cb604c7a0caa$var$fill($0640cb604c7a0caa$var$ruleLineLength[visibilityRange + wallZ[0]]));
    } else if (dimension === 2) {
        if (grid[zboundaries[0]] != undefined) throw `There should be no more line containing states after line ${line + zboundaries[0] - 1}`;
        if (grid[zboundaries[1]] != undefined) throw `There should be no one more line containing states before line ${line + zboundaries[1] + 1}`;
        let s = '.'; //'W';
        for(let i = 1; i <= visibilityRange; i++){
            grid[0] = [
                ...$0640cb604c7a0caa$var$fill($0640cb604c7a0caa$var$ruleLineLength[visibilityRange - i], s),
                ...grid[0]
            ];
            grid[grid.length - 1].push(...$0640cb604c7a0caa$var$fill($0640cb604c7a0caa$var$ruleLineLength[visibilityRange - i], s));
            s = '.';
        }
    } else throw `Dimension is not defined in the options`;
     //console.log(grid);
    let flatGrid = grid.flat();
    flatGrid = flatGrid.map((s)=>s === '-' || s === '|' ? '.' : s);
    const view = new (0, $347b986847663c76$export$27a5bd065ad55220)();
    let v_r = 0;
    for (let { x: x, y: y, z: z } of (0, $347b986847663c76$export$ee89fa751abcfe5a)(visibilityRange))view.set({
        x: x,
        y: y,
        z: z
    }, flatGrid[v_r++]);
    view.setWalls({
        wallX: wallX,
        wallY: wallY,
        wallZ: wallZ
    });
    let color = view.getCenter();
    dest_text = dest_text.replaceAll(' ', '');
    let destArray = [];
    if (dest_text.startsWith('[')) {
        const endBracket = dest_text.indexOf(']');
        if (endBracket === -1) throw `invalid destination ${dest_text}`;
        destArray = dest_text.substring(1, endBracket).split(',');
        const rest = dest_text.substring(endBracket + 1);
        if (rest.length > 0) color = rest.startsWith(',') ? rest.substring(1) : rest;
    } else {
        const commaIndex = dest_text.indexOf(',');
        if (commaIndex !== -1) {
            destArray = [
                dest_text.substring(0, commaIndex)
            ];
            color = dest_text.substring(commaIndex + 1);
        } else destArray = [
            dest_text
        ];
    }
    if (!color) color = view.getCenter();
    const dir = destArray.map((d)=>{
        d = d.trim().toUpperCase();
        switch(d){
            case 'IDLE':
                return 0, $347b986847663c76$export$49984ede44adf88d;
            case 'FRONT':
                return 0, $347b986847663c76$export$51ec4a2fc467eaa7;
            case 'LEFT':
                return 0, $347b986847663c76$export$f981f70d61d1405a;
            case 'BACK':
                return 0, $347b986847663c76$export$1eeca8128376e4e9;
            case 'RIGHT':
                return 0, $347b986847663c76$export$1cac5500365a4eb4;
            case 'ABOVE':
                return 0, $347b986847663c76$export$50e63dfb05a215ef;
            case 'BELOW':
                return 0, $347b986847663c76$export$d73203a818a78b30;
            default:
                throw "unknown direction " + d;
        }
    });
    return {
        view: view,
        destination: {
            dir: dir,
            color: color
        },
        options: options
    };
}
function $0640cb604c7a0caa$export$2e2bcd8739ae039(text, visibilityRange, dimension) {
    let rules = {};
    let rulesReference = {};
    let alias = {};
    let currentRawRule = [];
    let lines = text.split('\n');
    let rule_starting_ln = 0;
    for(let ln = 0; ln < lines.length; ln++){
        let line = lines[ln];
        if (line.match(/^ *#/)) continue;
        let m;
        if (m = line.trim().match(/^alias: (.) \{(.*)\}$/)) {
            alias[m[1]] = m[2].split(',');
            continue;
        }
        if (m = line.trim().match(/^@alias +(.) +\{(.*)\}$/)) {
            alias[m[1]] = m[2].split(',');
            continue;
        }
        if (line.trim() === '' && currentRawRule.length > 0) {
            const rule = $0640cb604c7a0caa$export$726deb39d943dc92(currentRawRule, rule_starting_ln, visibilityRange, dimension);
            const viewKey = rule.view.toString();
            if (rules[viewKey]) throw `
    You cannot define two rules with exactly the same view:
    at line ${rulesReference[viewKey].line}
and at line ${rule_starting_ln}
        `;
            rules[viewKey] = rule;
            rulesReference[viewKey] = {
                line: rule_starting_ln,
                line_end: ln,
                view: rule.view,
                transformations: []
            };
            currentRawRule = [];
            continue;
        }
        if (currentRawRule.length === 0) rule_starting_ln = ln + 1;
        if (line.trim() === '') continue;
        currentRawRule.push(line);
    }
    return {
        rules: rules,
        rulesReference: rulesReference,
        alias: alias
    };
}
function $0640cb604c7a0caa$export$f3b12835057f7dfe(content) {
    if (content.toString().indexOf('****** OPTIONS ******') === -1) throw 'not a web-algo file';
    const rawOptions = [];
    const rawRules = [];
    const rawInitialConfig = [];
    let state = null;
    content.toString().split('\n').forEach((line)=>{
        if (line.trim() === '****** OPTIONS ******') {
            state = 'OPTIONS';
            return;
        }
        if (line.trim() === '****** INITIAL CONFIGURATIONS ******') {
            state = 'INITIAL_CONFIG';
            return;
        }
        if (line.trim() === '****** RULES ******') {
            state = 'RULES';
            return;
        }
        switch(state){
            case 'INITIAL_CONFIG':
                rawInitialConfig.push(line);
                break;
            case 'RULES':
                rawRules.push(line);
                break;
            case 'OPTIONS':
                rawOptions.push(line);
                break;
        }
    });
    const optionsText = rawOptions.join('\n');
    const rulesText = rawRules.join('\n');
    const initialConfigText = rawInitialConfig.join('\n');
    return [
        optionsText,
        rulesText,
        initialConfigText
    ];
}




function $0df899459436dd50$export$2e2bcd8739ae039(content, options) {
    if (content.trim() === '') content = '.\n';
    const intialConfigurations = {};
    const initialLines = content.split('\n');
    initialLines.push('__empty:[0,0,0],0');
    let currentConfigName = 'default';
    let currentConfigSize = options.walls ? options.walls[1].slice() : [
        6,
        6,
        6
    ];
    let currentConfigLines = [];
    let currentConfigSeed = 0;
    let currentConfigType = 'finite-grid';
    for (const line of initialLines){
        let m = line.replaceAll(' ', '').match(/^([a-zA-Zx0-9\-_]+):([^[]*)\[(\d+),(\d+),(\d+)\],(-?\d+)/);
        if (m) {
            const config = new (0, $20a0fde87a9870e1$export$29cd7b75162a9425)({
                type: currentConfigType,
                x: currentConfigSize[0],
                y: currentConfigSize[1],
                z: currentConfigSize[2],
                dimension: options.dimension
            });
            let z = 0;
            let y = 0;
            let empty = true;
            currentConfigLines.forEach((l)=>{
                if (l.trim() == '') {
                    z++;
                    y = 0;
                    return;
                }
                empty = false;
                l.split('').forEach((color, x)=>{
                    if (color == '.') return;
                    if (color == ' ') return;
                    config.set(new (0, $fcbf04e630656d3a$export$13807d9ee5a34a42)(x, currentConfigSize[1] - y - 1, z), color);
                });
                y++;
            });
            if (!empty) intialConfigurations[currentConfigName] = {
                config: config,
                gridSize: currentConfigSize,
                seed: currentConfigSeed
            };
            currentConfigLines = [];
            currentConfigName = m[1];
            currentConfigType = m[2] || 'finite-grid';
            if (![
                'finite-grid',
                'infinite-grid',
                'torus'
            ].includes(currentConfigType)) throw new Error('the configuration type ' + currentConfigType + ' is not supported. It must be finite-grid, infinite-grid or torus');
            currentConfigSize = [
                parseInt(m[3]),
                parseInt(m[4]),
                parseInt(m[5])
            ];
            currentConfigSeed = parseInt(m[6]);
            continue;
        } else if (line.replaceAll(' ', '').match(/^([a-zA-Zx0-9\-_]+):\[(\d+),(\d+),(-?\d+)\]/)) {
            m = line.replaceAll(' ', '').match(/^([a-zA-Zx0-9\-_]+):\[(\d+),(\d+),(-?\d+)\]/);
            throw new Error('please add ",SEED" at the end of the configuration ' + (m && m[1]));
        } else if (line.replaceAll(' ', '').match(/^([a-zA-Zx0-9\-_]+):/)) {
            m = line.replaceAll(' ', '').match(/^([a-zA-Zx0-9\-_]+):/);
            throw new Error('please add "[x,y,z],SEED" at the end of the configuration ' + (m && m[1]));
        }
        currentConfigLines.push(line);
    }
    return intialConfigurations;
}


var $e56d81185102178b$exports = {};

$e56d81185102178b$exports = (parcelRequire("8mPFi")).YAML;


// horizontal direction
(function resizableX() {
    const resizer = document.querySelector(".resizer-x");
    resizer.addEventListener("mousedown", onmousedown);
    function onmousedown(e) {
        e.preventDefault();
        document.addEventListener("mousemove", onmousemove);
        document.addEventListener("mouseup", onmouseup);
    }
    function onmousemove(e) {
        e.preventDefault();
        const clientX = e.clientX;
        const deltaX = clientX - (resizer._clientX || clientX);
        resizer._clientX = clientX;
        const l = resizer.previousElementSibling;
        const r = resizer.nextElementSibling; // LEFT
        if (deltaX < 0) {
            const w = Math.round(parseInt(getComputedStyle(l).width) + deltaX);
            l.style.flex = `0 ${w < 10 ? 0 : w}px`;
            r.style.flex = "1 0";
        }
        // RIGHT
        if (deltaX > 0) {
            const w = Math.round(parseInt(getComputedStyle(r).width) - deltaX);
            r.style.flex = `0 ${w < 10 ? 0 : w}px`;
            l.style.flex = "1 0";
        }
        window.dispatchEvent(new Event('resize'));
    }
    function onmouseup(e) {
        e.preventDefault();
        document.removeEventListener("mousemove", onmousemove);
        document.removeEventListener("mouseup", onmouseup);
        delete e._clientX;
    }
})();
// vertical direction
(function resizableY() {
    const resizer = document.querySelector(".resizer-y");
    resizer.addEventListener("mousedown", onmousedown);
    function onmousedown(e) {
        e.preventDefault();
        document.addEventListener("mousemove", onmousemove);
        document.addEventListener("mouseup", onmouseup);
    }
    function onmousemove(e) {
        e.preventDefault();
        const clientY = e.clientY;
        const deltaY = clientY - (resizer._clientY || clientY);
        resizer._clientY = clientY;
        const t = resizer.previousElementSibling;
        const b = resizer.nextElementSibling; // FRONT
        if (deltaY < 0) {
            const h = Math.round(parseInt(getComputedStyle(t).height) + deltaY);
            t.style.flex = `0 ${h < 10 ? 0 : h}px`;
            b.style.flex = "1 0";
        } // DOWN
        if (deltaY > 0) {
            const h = Math.round(parseInt(getComputedStyle(b).height) - deltaY);
            b.style.flex = `0 ${h < 10 ? 0 : h}px`;
            t.style.flex = "1 0";
        }
        window.dispatchEvent(new Event('resize'));
    }
    function onmouseup(e) {
        e.preventDefault();
        document.removeEventListener("mousemove", onmousemove);
        document.removeEventListener("mouseup", onmouseup);
        delete e._clientY;
    }
})();


var $8c4cd03c5db98c02$exports = {};
'use strict';
Object.defineProperty($8c4cd03c5db98c02$exports, "__esModule", {
    value: true
});
function $8c4cd03c5db98c02$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
/* FileSaver.js
 * A saveAs() FileSaver implementation.
 *
 * By Eli Grey, http://eligrey.com
 * ES6ified by Cole Chamberlain, https://github.com/cchamberlain
 *
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */ /*global self */ /*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */ /*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */ var $8c4cd03c5db98c02$var$saveAs = $8c4cd03c5db98c02$exports.saveAs = window.saveAs || function(view) {
    // IE <10 is explicitly unsupported
    if (typeof navigator !== 'undefined' && /MSIE [1-9]\./.test(navigator.userAgent)) return;
    var doc = view.document;
    // only get URL when necessary in case Blob.js hasn't overridden it yet
    var get_URL = function get_URL() {
        return view.URL || view.webkitURL || view;
    };
    var save_link = doc.createElementNS('http://www.w3.org/1999/xhtml', 'a');
    var can_use_save_link = 'download' in save_link;
    var click = function click(node) {
        var event = new MouseEvent('click');
        node.dispatchEvent(event);
    };
    var is_safari = /Version\/[\d\.]+.*Safari/.test(navigator.userAgent);
    var webkit_req_fs = view.webkitRequestFileSystem;
    var req_fs = view.requestFileSystem || webkit_req_fs || view.mozRequestFileSystem;
    var throw_outside = function throw_outside(ex) {
        (view.setImmediate || view.setTimeout)(function() {
            throw ex;
        }, 0);
    };
    var force_saveable_type = 'application/octet-stream';
    var fs_min_size = 0;
    // the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
    var arbitrary_revoke_timeout = 40000; // in ms
    var revoke = function revoke(file) {
        var revoker = function revoker() {
            if (typeof file === 'string') get_URL().revokeObjectURL(file);
            else file.remove();
        };
        /* // Take note W3C:
    var
      uri = typeof file === "string" ? file : file.toURL()
    , revoker = function(evt) {
      // idealy DownloadFinishedEvent.data would be the URL requested
      if (evt.data === uri) {
        if (typeof file === "string") { // file is an object URL
          get_URL().revokeObjectURL(file);
        } else { // file is a File
          file.remove();
        }
      }
    }
    ;
    view.addEventListener("downloadfinished", revoker);
    */ setTimeout(revoker, arbitrary_revoke_timeout);
    };
    var dispatch = function dispatch(filesaver, event_types, event) {
        event_types = [].concat(event_types);
        var i = event_types.length;
        while(i--){
            var listener = filesaver['on' + event_types[i]];
            if (typeof listener === 'function') try {
                listener.call(filesaver, event || filesaver);
            } catch (ex) {
                throw_outside(ex);
            }
        }
    };
    var auto_bom = function auto_bom(blob) {
        // prepend BOM for UTF-8 XML and text/* types (including HTML)
        if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
            "\uFEFF",
            blob
        ], {
            type: blob.type
        });
        return blob;
    };
    var FileSaver = function FileSaver(blob, name, no_auto_bom) {
        $8c4cd03c5db98c02$var$_classCallCheck(this, FileSaver);
        if (!no_auto_bom) blob = auto_bom(blob);
        // First try a.download, then web filesystem, then object URLs
        var filesaver = this, type = blob.type, blob_changed = false, object_url, target_view, dispatch_all = function dispatch_all() {
            dispatch(filesaver, 'writestart progress write writeend'.split(' '));
        }, fs_error = function fs_error() {
            if (target_view && is_safari && typeof FileReader !== 'undefined') {
                // Safari doesn't allow downloading of blob urls
                var reader = new FileReader();
                reader.onloadend = function() {
                    var base64Data = reader.result;
                    target_view.location.href = 'data:attachment/file' + base64Data.slice(base64Data.search(/[,;]/));
                    filesaver.readyState = filesaver.DONE;
                    dispatch_all();
                };
                reader.readAsDataURL(blob);
                filesaver.readyState = filesaver.INIT;
                return;
            }
            // don't create more object URLs than needed
            if (blob_changed || !object_url) object_url = get_URL().createObjectURL(blob);
            if (target_view) target_view.location.href = object_url;
            else {
                var new_tab = view.open(object_url, '_blank');
                if (new_tab === undefined && is_safari) //Apple do not allow window.open, see http://bit.ly/1kZffRI
                view.location.href = object_url;
            }
            filesaver.readyState = filesaver.DONE;
            dispatch_all();
            revoke(object_url);
        }, abortable = function abortable(func) {
            return function() {
                if (filesaver.readyState !== filesaver.DONE) return func.apply(this, arguments);
            };
        }, create_if_not_found = {
            create: true,
            exclusive: false
        }, slice;
        filesaver.readyState = filesaver.INIT;
        if (!name) name = 'download';
        if (can_use_save_link) {
            object_url = get_URL().createObjectURL(blob);
            setTimeout(function() {
                save_link.href = object_url;
                save_link.download = name;
                click(save_link);
                dispatch_all();
                revoke(object_url);
                filesaver.readyState = filesaver.DONE;
            });
            return;
        }
        // Object and web filesystem URLs have a problem saving in Google Chrome when
        // viewed in a tab, so I force save with application/octet-stream
        // http://code.google.com/p/chromium/issues/detail?id=91158
        // Update: Google errantly closed 91158, I submitted it again:
        // https://code.google.com/p/chromium/issues/detail?id=389642
        if (view.chrome && type && type !== force_saveable_type) {
            slice = blob.slice || blob.webkitSlice;
            blob = slice.call(blob, 0, blob.size, force_saveable_type);
            blob_changed = true;
        }
        // Since I can't be sure that the guessed media type will trigger a download
        // in WebKit, I append .download to the filename.
        // https://bugs.webkit.org/show_bug.cgi?id=65440
        if (webkit_req_fs && name !== 'download') name += '.download';
        if (type === force_saveable_type || webkit_req_fs) target_view = view;
        if (!req_fs) {
            fs_error();
            return;
        }
        fs_min_size += blob.size;
        req_fs(view.TEMPORARY, fs_min_size, abortable(function(fs) {
            fs.root.getDirectory('saved', create_if_not_found, abortable(function(dir) {
                var save = function save() {
                    dir.getFile(name, create_if_not_found, abortable(function(file) {
                        file.createWriter(abortable(function(writer) {
                            writer.onwriteend = function(event) {
                                target_view.location.href = file.toURL();
                                filesaver.readyState = filesaver.DONE;
                                dispatch(filesaver, 'writeend', event);
                                revoke(file);
                            };
                            writer.onerror = function() {
                                var error = writer.error;
                                if (error.code !== error.ABORT_ERR) fs_error();
                            };
                            'writestart progress write abort'.split(' ').forEach(function(event) {
                                writer['on' + event] = filesaver['on' + event];
                            });
                            writer.write(blob);
                            filesaver.abort = function() {
                                writer.abort();
                                filesaver.readyState = filesaver.DONE;
                            };
                            filesaver.readyState = filesaver.WRITING;
                        }), fs_error);
                    }), fs_error);
                };
                dir.getFile(name, {
                    create: false
                }, abortable(function(file) {
                    // delete file if it already exists
                    file.remove();
                    save();
                }), abortable(function(ex) {
                    if (ex.code === ex.NOT_FOUND_ERR) save();
                    else fs_error();
                }));
            }), fs_error);
        }), fs_error);
    };
    var FS_proto = FileSaver.prototype;
    var saveAs = function saveAs(blob, name, no_auto_bom) {
        return new FileSaver(blob, name, no_auto_bom);
    };
    // IE 10+ (native saveAs)
    if (typeof navigator !== 'undefined' && navigator.msSaveOrOpenBlob) return function(blob, name, no_auto_bom) {
        if (!no_auto_bom) blob = auto_bom(blob);
        return navigator.msSaveOrOpenBlob(blob, name || 'download');
    };
    FS_proto.abort = function() {
        var filesaver = this;
        filesaver.readyState = filesaver.DONE;
        dispatch(filesaver, 'abort');
    };
    FS_proto.readyState = FS_proto.INIT = 0;
    FS_proto.WRITING = 1;
    FS_proto.DONE = 2;
    FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;
    return saveAs;
}(typeof self !== 'undefined' && self || typeof window !== 'undefined' && window || undefined.content);
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window
$8c4cd03c5db98c02$exports.default = $8c4cd03c5db98c02$var$saveAs;




const $16f8882f3e3ce876$export$2288787135a8f66e = (errorMsg)=>{
    const el = document.getElementById('error-log');
    if (errorMsg === null) {
        el.style.display = 'none';
        return;
    }
    el.style.display = 'block';
    console.log(errorMsg);
    el.innerHTML = '<pre>' + errorMsg + '</pre>';
};


var $7781800665b28368$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7781800665b28368$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError(typeof iterable + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $7781800665b28368$exports));
try {
    regeneratorRuntime = $7781800665b28368$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $7781800665b28368$var$runtime;
    else Function("r", "regeneratorRuntime = r")($7781800665b28368$var$runtime);
}


var $e57e258fcaaba4f1$exports = {};
$e57e258fcaaba4f1$exports = JSON.parse("{\"hash\":\"927f1cb0f8502cbb577e4503ba52317dd981bf33\",\"date\":\"2026-01-09T09:54:29Z\"}");


const $2b39ea1e9ebe1cad$var$HTML4_NAMES_TO_HEX = {
    "aqua": 0x00ffff,
    "black": 0x000000,
    "blue": 0x0000ff,
    "fuchsia": 0xff00ff,
    "green": 0x008000,
    "gray": 0x808080,
    "lime": 0x00ff00,
    "maroon": 0x800000,
    "navy": 0x000080,
    "olive": 0x808000,
    "purple": 0x800080,
    "red": 0xff0000,
    "silver": 0xc0c0c0,
    "teal": 0x008080,
    "white": 0xffffff,
    "yellow": 0xffff00
};
var $2b39ea1e9ebe1cad$export$2e2bcd8739ae039 = (content)=>{
    if (content.toString().indexOf('****** OPTIONS ******') === -1) throw 'not a web-algo file';
    const rawOptions = [];
    const rawRules = [];
    const rawInitialConfig = [];
    let state = null;
    content.toString().split('\n').forEach((line)=>{
        if (line.trim() === '****** OPTIONS ******') {
            state = 'OPTIONS';
            return;
        }
        if (line.trim() === '****** INITIAL CONFIGURATIONS ******') {
            state = 'INITIAL_CONFIG';
            return;
        }
        if (line.trim() === '****** RULES ******') {
            state = 'RULES';
            return;
        }
        switch(state){
            case 'INITIAL_CONFIG':
                rawInitialConfig.push(line);
                break;
            case 'RULES':
                rawRules.push(line);
                break;
            case 'OPTIONS':
                rawOptions.push(line);
                break;
        }
    });
    return {
        initialConfigurations: rawInitialConfig.join('\n'),
        rules: rawRules.join('\n'),
        options: rawOptions.join('\n')
    };
};


// @ts-nocheck
const $786dfe013356b32a$var$HTML4_NAMES_TO_HEX = {
    "aqua": 0x00ffff,
    "black": 0x000000,
    "blue": 0x0000ff,
    "fuchsia": 0xff00ff,
    "green": 0x008000,
    "gray": 0x808080,
    "lime": 0x00ff00,
    "maroon": 0x800000,
    "navy": 0x000080,
    "olive": 0x808000,
    "purple": 0x800080,
    "red": 0xff0000,
    "silver": 0xc0c0c0,
    "teal": 0x008080,
    "white": 0xffffff,
    "yellow": 0xffff00
};
var $786dfe013356b32a$export$2e2bcd8739ae039 = (data)=>{
    if (!data.algorithm) throw 'not algorithm found';
    let algoRules = ''; //console.log(data);
    if (data.algorithm?.alias) for(let aliasKey in data.algorithm.alias)algoRules += `@alias ${aliasKey} ${data.algorithm.alias[aliasKey]}\n\n`;
    let visibilityRange = 1;
    for(let i = 0; i < data.algorithm.rules.length; i += 2){
        let r = data.algorithm.rules[i];
        let d = data.algorithm.rules[i + 1];
        r = r.trim().split(' ').filter((s)=>s.length > 0);
        visibilityRange = Math.floor((r[Math.floor(r.length / 2)].trim().length - 1) / 2);
        r[Math.floor(r.length / 2)] += ' -> ' + d.replace(/\(|\)/g, '').replace('up', 'front').replace('down', 'back');
        for(let i = 0; i < Math.floor(r.length / 2); i++){
            r[i] = r[i].replaceAll('|', '.').replaceAll('+', '.');
            r[r.length - i - 1] = r[r.length - i - 1].replaceAll('|', '.').replaceAll('+', '.');
            if (r[i].indexOf('-') != -1) for(let j = 0; j < i; j++)r[j] = '';
            if (r[r.length - i - 1].indexOf('-') != -1) for(let j = 0; j < i; j++)r[r.length - j - 1] = '';
        }
        algoRules += r.join('\n').replace('"', '') + '\n\n';
    }
    let colors = 'colors:\n';
    for (let [colorKey, colorValue] of Object.entries(data.graphics.colors)){
        if (isNaN(parseInt(colorValue))) colorValue = $786dfe013356b32a$var$HTML4_NAMES_TO_HEX[colorValue] || 0x555555;
        colors += `  ${colorKey}: ${colorValue}\n`;
    }
    const algoOptions = `
walls: [[0,0,0],[6,6,2]]
chirality: ${!!data.model.chirality}
visibilityRange: ${visibilityRange}
dimension: 2
topology: ${Object.values(data.algorithm.initial_configuration)[0].tore ? 'torus' : 'finite-grid'}
${colors}
`;
    let config_text = '';
    let configurationDict = data.algorithm.initial_configuration;
    if (Array.isArray(configurationDict)) configurationDict = {
        default: configurationDict
    };
    const defaultGridSize = data.algorithm.grid_size || 10;
    for (let [name, configuration] of Object.entries(configurationDict)){
        //defaut:[6,6,5],0
        let height = configuration.height || defaultGridSize;
        let width = configuration.width || defaultGridSize;
        let seed = configuration.seed || 0;
        let topologyType = 'infinite-grid';
        let offx = 0;
        let offy = 0;
        if (data.algorithm.offset) {
            offx = data.algorithm.offset[0];
            offy = data.algorithm.offset[1];
        }
        if (configuration.tore) {
            let toreOption = configuration.tore;
            height = parseInt(configuration.tore.height);
            width = parseInt(configuration.tore.width);
            seed = configuration.tore.seed || 0;
            configuration = configuration.tore.positions;
            topologyType = 'torus';
        }
        if (configuration[0].length > 0 && configuration[0].reduce((acc, c)=>acc && c == 'W', true)) {
            offx = 0;
            offy = 0;
            height = configuration[0].length - 1;
            width = configuration.length - 1; //topologyType = 'finite-grid'
        }
        config_text += `${name}:${topologyType}[${height + 1},${width + 1},1],${seed}\n`;
        for(let i = 0; i < offy; i++)config_text += '.\n';
        config_text += configuration.map((l)=>Array.from(Array(offx).keys()).map((i)=>'.').join('') + l.join('')).join('\n');
        config_text += '\n\n';
    }
    return {
        initialConfigurations: config_text,
        rules: algoRules,
        options: algoOptions
    };
};



function $78a992a6d52ab0c0$export$c4a4813d107edc0f(settings) {
    return 'algo/' + `${settings.synchrony}/` + `${settings.dimension}/` + `${settings.topology}/` + `${settings.chirality}/` + `range-${settings.range}/` + `${settings.robots}-robots-${settings.colors}-colors` + `${settings.opacity == 'opaque' ? '' : '-' + settings.opacity}` + `${settings['colors-mode'] == 'modifiable-colors' ? '' : '-' + settings['colors-mode']}`;
}
function $78a992a6d52ab0c0$var$parse_type_value(data, raw_v) {
    const types_list = Object.keys(data.types);
    if (raw_v.indexOf('-') !== -1 && types_list.includes(raw_v.split('-')[0])) {
        let [t, v] = raw_v.split('-');
        let parsed_v = parseInt(v);
        if (!isNaN(parsed_v)) return [
            t,
            parsed_v
        ];
        if (v == '*') return data.types[t] === 'int' ? [
            t,
            Number.POSITIVE_INFINITY
        ] : [
            t,
            v
        ];
        return [
            t,
            v
        ];
    } else for (let [key, value] of Object.entries(data.types)){
        if (value == 'int') throw new Error('int type should be used with a range');
        if (Array.isArray(value.values)) {
            if (value.values.includes(raw_v)) return [
                key,
                raw_v
            ];
        } else if (Array.isArray(value) && value.includes(raw_v)) return [
            key,
            raw_v
        ];
    }
    throw new Error('could not parse type value: ' + raw_v);
}
function $78a992a6d52ab0c0$export$9d28ec5d4ee42f13(data, type_list) {
    const types = [
        ...data.default,
        ...type_list
    ];
    const settings = {};
    types.forEach((type)=>{
        const [t, v] = $78a992a6d52ab0c0$var$parse_type_value(data, type);
        settings[t] = v;
    });
    return settings;
}
function $78a992a6d52ab0c0$export$7bd616347c8459e2(data, type_list) {
    return $78a992a6d52ab0c0$export$c4a4813d107edc0f($78a992a6d52ab0c0$export$9d28ec5d4ee42f13(data, type_list));
}


var $585fde6c032b7cd1$exports = {};
$585fde6c032b7cd1$exports = {
    "types": {
        "synchrony": [
            "async",
            "ssync",
            "fsync"
        ],
        "dimension": [
            "42d",
            "3d",
            "2d"
        ],
        "topology": {
            "values": [
                "infinite-grid",
                "torus",
                "finite-grid"
            ],
            "order": false
        },
        "chirality": [
            "without-chirality",
            "with-chirality"
        ],
        "opacity": [
            "opaque",
            "transparent"
        ],
        "colors-mode": [
            "fixed-colors",
            "modifiable-colors"
        ],
        "range": "int",
        "robots": "int",
        "colors": "int"
    },
    "default": [
        "fsync",
        "2d",
        "opaque",
        "modifiable-colors"
    ],
    "papers": {
        "TCS2023": {
            "pdf": "https://www.sciencedirect.com/science/article/pii/S0304397523004565?casa_token=XE46cqRFt6YAAAAA:cPmu5xbQSD_jlM7UEbuEXYlbuZX4Eh8LZx6okwToB4ZUKZx8KqHRg0vZBzEitelT9x1qtcD4gYsD",
            "type": [
                "2d",
                "torus",
                "opaque",
                "modifiable-colors"
            ],
            "algos": [
                {
                    "type": [
                        "with-chirality",
                        "range-1",
                        "robots-3",
                        "colors-2"
                    ]
                },
                {
                    "type": [
                        "without-chirality",
                        "range-1",
                        "robots-3",
                        "colors-3"
                    ]
                },
                {
                    "type": [
                        "with-chirality",
                        "range-2",
                        "robots-4",
                        "colors-1"
                    ]
                },
                {
                    "type": [
                        "without-chirality",
                        "range-2",
                        "robots-5",
                        "colors-1"
                    ]
                }
            ],
            "impossibility": [
                {
                    "type": [
                        "transparent",
                        "with-chirality",
                        "range-*",
                        "robots-2",
                        "colors-*"
                    ]
                },
                {
                    "type": [
                        "transparent",
                        "with-chirality",
                        "range-*",
                        "robots-3",
                        "colors-1"
                    ]
                }
            ]
        },
        "FUN2022": {
            "pdf": "https://drops.dagstuhl.de/storage/00lipics/lipics-vol226-fun2022/LIPIcs.FUN.2022.7/LIPIcs.FUN.2022.7.pdf",
            "type": [
                "3d",
                "finite-grid",
                "with-chirality",
                "opaque",
                "modifiable-colors"
            ],
            "algos": [
                {
                    "type": [
                        "range-1",
                        "robots-3",
                        "colors-5"
                    ]
                },
                {
                    "type": [
                        "range-2",
                        "transparent",
                        "robots-5",
                        "colors-1"
                    ]
                }
            ],
            "impossibility": [
                {
                    "type": [
                        "transparent",
                        "range-1",
                        "robots-2",
                        "colors-*"
                    ]
                }
            ]
        },
        "Netys2021": {
            "pdf": "https://univoak.eu/islandora/object/islandora:136781/datastream/PDF/download/citation.pdf",
            "type": [
                "2d",
                "finite-grid",
                "without-chirality",
                "opaque",
                "modifiable-colors"
            ],
            "algos": [
                {
                    "type": [
                        "range-1",
                        "robots-3",
                        "colors-3"
                    ]
                },
                {
                    "type": [
                        "range-2",
                        "transparent",
                        "robots-5",
                        "colors-1"
                    ]
                }
            ],
            "impossibility": [
                {
                    "type": [
                        "transparent",
                        "range-*",
                        "robots-2",
                        "colors-*"
                    ]
                }
            ]
        },
        "TCS2023-2": {
            "pdf": "https://uca.hal.science/hal-03130277/document",
            "type": [
                "2d",
                "finite-grid",
                "with-chirality",
                "opaque",
                "modifiable-colors"
            ],
            "algos": [
                {
                    "type": [
                        "range-1",
                        "robots-2",
                        "colors-3"
                    ]
                },
                {
                    "type": [
                        "range-2",
                        "robots-2",
                        "colors-2"
                    ]
                },
                {
                    "type": [
                        "range-2",
                        "robots-3",
                        "colors-1"
                    ]
                },
                {
                    "type": [
                        "async",
                        "range-2",
                        "robots-2",
                        "colors-3"
                    ]
                }
            ],
            "impossibility": [
                {
                    "type": [
                        "transparent",
                        "range-*",
                        "robots-1",
                        "colors-*"
                    ]
                },
                {
                    "type": [
                        "transparent",
                        "range-*",
                        "robots-2",
                        "colors-1"
                    ]
                },
                {
                    "type": [
                        "transparent",
                        "range-1",
                        "robots-2",
                        "colors-2"
                    ]
                },
                {
                    "type": [
                        "transparent",
                        "range-1",
                        "robots-3",
                        "colors-1"
                    ]
                }
            ]
        },
        "FUN2021": {
            "pdf": "https://drops.dagstuhl.de/storage/00lipics/lipics-vol157-fun2021/LIPIcs.FUN.2021.6/LIPIcs.FUN.2021.6.pdf",
            "type": [
                "2d",
                "infinite-grid",
                "without-chirality",
                "opaque",
                "modifiable-colors"
            ],
            "algos": [
                {
                    "type": [
                        "range-1",
                        "robots-6",
                        "colors-3"
                    ]
                },
                {
                    "type": [
                        "range-2",
                        "robots-8",
                        "colors-1"
                    ]
                }
            ],
            "impossibility": [
                {
                    "type": [
                        "transparent",
                        "topology-*",
                        "range-1",
                        "robots-*",
                        "colors-1"
                    ]
                }
            ]
        },
        "Netys2020": {
            "pdf": "https://arxiv.org/pdf/1905.09271.pdf",
            "type": [
                "2d",
                "infinite-grid",
                "with-chirality",
                "opaque"
            ],
            "algos": [
                {
                    "type": [
                        "range-1",
                        "robots-5",
                        "colors-5",
                        "modifiable-colors"
                    ]
                },
                {
                    "type": [
                        "range-1",
                        "robots-6",
                        "colors-3",
                        "fixed-colors"
                    ],
                    "notes": "not edge-exclusive"
                },
                {
                    "type": [
                        "range-2",
                        "robots-7",
                        "colors-1",
                        "modifiable-colors"
                    ]
                }
            ],
            "impossibility": [
                {
                    "type": [
                        "transparent",
                        "range-*",
                        "robots-4",
                        "colors-*",
                        "modifiable-colors"
                    ]
                }
            ]
        },
        "SSS2024": {
            "algos": [
                {
                    "type": [
                        "async",
                        "2d",
                        "finite-grid",
                        "with-chirality",
                        "opaque",
                        "range-2",
                        "robots-4",
                        "colors-1",
                        "modifiable-colors"
                    ],
                    "alias": "A1"
                },
                {
                    "type": [
                        "async",
                        "2d",
                        "finite-grid",
                        "without-chirality",
                        "transparent",
                        "range-2",
                        "robots-3",
                        "colors-2",
                        "modifiable-colors"
                    ],
                    "alias": "A2"
                },
                {
                    "type": [
                        "async",
                        "2d",
                        "finite-grid",
                        "without-chirality",
                        "opaque",
                        "range-3",
                        "robots-3",
                        "colors-1",
                        "modifiable-colors"
                    ],
                    "alias": "A3"
                }
            ],
            "impossibility": [
                {
                    "type": [
                        "async",
                        "2d",
                        "topology-*",
                        "with-chirality",
                        "transparent",
                        "range-1",
                        "robots-*",
                        "colors-*",
                        "modifiable-colors"
                    ]
                }
            ]
        },
        "unpublished": {
            "algos": [
                {
                    "type": [
                        "2d",
                        "infinite-grid",
                        "without-chirality",
                        "opaque",
                        "range-1",
                        "robots-20",
                        "colors-5",
                        "fixed-colors"
                    ],
                    "notes": "not edge-exclusive"
                },
                {
                    "type": [
                        "2d",
                        "infinite-grid",
                        "with-chirality",
                        "opaque",
                        "range-1",
                        "robots-7",
                        "colors-15",
                        "modifiable-colors"
                    ],
                    "notes": "Perpetual"
                },
                {
                    "type": [
                        "2d",
                        "infinite-grid",
                        "without-chirality",
                        "opaque",
                        "range-1",
                        "robots-5",
                        "colors-12",
                        "modifiable-colors"
                    ],
                    "notes": "Perpetual"
                },
                {
                    "type": [
                        "2d",
                        "infinite-grid",
                        "without-chirality",
                        "opaque",
                        "range-1",
                        "robots-6",
                        "colors-2",
                        "modifiable-colors"
                    ]
                },
                {
                    "type": [
                        "async",
                        "2d",
                        "infinite-grid",
                        "with-chirality",
                        "opaque",
                        "range-2",
                        "robots-6",
                        "colors-3",
                        "fixed-colors"
                    ]
                },
                {
                    "type": [
                        "async",
                        "2d",
                        "infinite-grid",
                        "with-chirality",
                        "opaque",
                        "range-3",
                        "robots-9",
                        "colors-1"
                    ]
                },
                {
                    "type": [
                        "2d",
                        "finite-grid",
                        "with-chirality",
                        "transparent",
                        "range-1",
                        "robots-2",
                        "colors-5",
                        "modifiable-colors"
                    ],
                    "notes": "obstacle"
                },
                {
                    "type": [
                        "3d",
                        "finite-grid",
                        "without-chirality",
                        "range-1",
                        "robots-3",
                        "colors-77"
                    ],
                    "notes": "ambiguous"
                },
                {
                    "type": [
                        "3d",
                        "finite-grid",
                        "without-chirality",
                        "range-2",
                        "robots-3",
                        "colors-4"
                    ]
                }
            ]
        }
    },
    "other": [
        {
            "title": "Non-exclusive",
            "description": "Non exlusive, so robots can form towers",
            "citation": "\"Terminating Grid Exploration with Myopic Luminous Robots\" by Shota Nagahama, Fukuhito Ooshita, and Michiko Inoue. 2021",
            "paper": "https://arxiv.org/pdf/2102.06006.pdf",
            "type": [
                "2d",
                "finite-grid",
                "transparent",
                "modifiable-colors"
            ],
            "algos": [
                {
                    "type": [
                        "fsync",
                        "range-2",
                        "colors-2",
                        "with-chirality",
                        "robots-2"
                    ]
                },
                {
                    "type": [
                        "fsync",
                        "range-2",
                        "colors-2",
                        "without-chirality",
                        "robots-3"
                    ]
                },
                {
                    "type": [
                        "fsync",
                        "range-2",
                        "colors-1",
                        "with-chirality",
                        "robots-3"
                    ]
                },
                {
                    "type": [
                        "fsync",
                        "range-2",
                        "colors-1",
                        "without-chirality",
                        "robots-4"
                    ]
                },
                {
                    "type": [
                        "fsync",
                        "range-1",
                        "colors-3",
                        "with-chirality",
                        "robots-2"
                    ]
                },
                {
                    "type": [
                        "fsync",
                        "range-1",
                        "colors-3",
                        "without-chirality",
                        "robots-4"
                    ]
                },
                {
                    "type": [
                        "fsync",
                        "range-1",
                        "colors-2",
                        "with-chirality",
                        "robots-3"
                    ]
                },
                {
                    "type": [
                        "fsync",
                        "range-1",
                        "colors-2",
                        "without-chirality",
                        "robots-5"
                    ]
                },
                {
                    "type": [
                        "async",
                        "range-2",
                        "colors-3",
                        "with-chirality",
                        "robots-2"
                    ]
                },
                {
                    "type": [
                        "async",
                        "range-2",
                        "colors-3",
                        "without-chirality",
                        "robots-3"
                    ]
                },
                {
                    "type": [
                        "async",
                        "range-2",
                        "colors-2",
                        "with-chirality",
                        "robots-3"
                    ]
                },
                {
                    "type": [
                        "async",
                        "range-2",
                        "colors-2",
                        "without-chirality",
                        "robots-4"
                    ]
                },
                {
                    "type": [
                        "async",
                        "range-1",
                        "colors-3",
                        "with-chirality",
                        "robots-3"
                    ]
                },
                {
                    "type": [
                        "async",
                        "range-1",
                        "colors-3",
                        "without-chirality",
                        "robots-6"
                    ]
                }
            ]
        },
        {
            "title": "Ants",
            "description": "Ants can see themselves when on the same node (there is no notion of visibility range). They move on a persistantly oriented grid.",
            "citation": "\"Tight Bounds for Deterministic High-Dimensional Grid Exploration\" by Sebastian Brandt, Julian Portmann, Jara Uitto. 2020",
            "type": [
                "42d",
                "infinite-grid",
                "modifiable-colors"
            ],
            "paper": "https://arxiv.org/pdf/2005.12623.pdf",
            "impossibility": [
                {
                    "type": [
                        "2d",
                        "fsync",
                        "robots-2"
                    ]
                },
                {
                    "type": [
                        "2d",
                        "ssync",
                        "robots-3"
                    ]
                }
            ],
            "algos": [
                {
                    "type": [
                        "fsync",
                        "robots-3"
                    ]
                },
                {
                    "type": [
                        "ssync",
                        "robots-4"
                    ]
                }
            ]
        }
    ]
};


console.log((0, (/*@__PURE__*/$parcel$interopDefault($585fde6c032b7cd1$exports))));
var $818bb3bf843b8c76$var$el;
document.getElementById('options-input-link').style.display = 'none';
document.getElementById('initial-input-link').style.display = 'none';
document.getElementById('files-tab-link').style.display = 'none';
document.getElementById('options-input-link').innerHTML = '';
document.getElementById('initial-input-link').innerHTML = '';
document.getElementById('files-tab-link').innerHTML = '';
console.log('CURRENT_VERSION', (0, (/*@__PURE__*/$parcel$interopDefault($e57e258fcaaba4f1$exports))));
document.getElementById('version-info').innerHTML = 'version: ' + (0, (/*@__PURE__*/$parcel$interopDefault($e57e258fcaaba4f1$exports))).date;
(async ()=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e57e258fcaaba4f1$exports))).date === 'now') return; //["localhost", "127.0.0.1", "[::]"].includes(location.hostname)) return;
    try {
        const content = await (await fetch('https://bramas.pages.unistra.fr/robot-grid-exploration-simulator/current_version.json?' + Math.random())).text();
        const data = JSON.parse(content);
        console.log('PUBLIC CURRENT_VERSION', data);
        if (data.hash != (0, (/*@__PURE__*/$parcel$interopDefault($e57e258fcaaba4f1$exports))).hash) alert('new version available, please reload the page');
    } catch (e) {
        console.log(e);
    }
})();
ace.config.set("basePath", "https://pagecdn.io/lib/ace/1.4.12/");
let $818bb3bf843b8c76$var$options = ace.edit("options-input"); //options.setTheme("ace/theme/monokai");
$818bb3bf843b8c76$var$options.session.setMode("ace/mode/yaml");
let $818bb3bf843b8c76$var$initial = ace.edit("initial-input"); //initial.setTheme("ace/theme/monokai");
//initial.session.setMode("ace/mode/json");
let $818bb3bf843b8c76$var$rules = ace.edit("rules-input"); //rules.setTheme("ace/theme/monokai");
//rules.session.setMode("ace/mode/json");
let $818bb3bf843b8c76$var$firstCompilation = true;
let $818bb3bf843b8c76$var$rulesDebounceID = null;
const $818bb3bf843b8c76$var$globals = {};
let $818bb3bf843b8c76$var$lockUpdate = false;
$818bb3bf843b8c76$var$rules.setReadOnly(true);
$818bb3bf843b8c76$var$initial.setReadOnly(true);
$818bb3bf843b8c76$var$options.setReadOnly(true);
function $818bb3bf843b8c76$export$79c0fc36dd8d1b46() {
    if (!$818bb3bf843b8c76$var$globals.onRules) return;
    $818bb3bf843b8c76$var$globals.onOptions($818bb3bf843b8c76$export$5157fbe9175db85e());
    $818bb3bf843b8c76$var$globals.onInitial($818bb3bf843b8c76$export$e0314bf46696456e());
    $818bb3bf843b8c76$var$globals.onRules($818bb3bf843b8c76$export$dd41bdd847bf46()); //console.log(getInitialText())
}
function $818bb3bf843b8c76$var$onRulesChanged(onRules) {
    if ($818bb3bf843b8c76$var$lockUpdate) return;
    $818bb3bf843b8c76$var$rulesDebounceID = setTimeout(()=>{
        $818bb3bf843b8c76$var$rulesDebounceID = null;
        let val = $818bb3bf843b8c76$var$rules.getValue();
        localStorage.setItem('rules', val);
        try {
            onRules(val);
        } catch (e) {
            console.log(e);
        }
    }, 1000);
}
function $818bb3bf843b8c76$var$onOptionsChanged(onRules, onOptions) {
    if ($818bb3bf843b8c76$var$lockUpdate) return;
    let val = $818bb3bf843b8c76$var$options.getValue();
    localStorage.setItem('options', val);
    try {
        onOptions(val);
        onRules($818bb3bf843b8c76$var$rules.getValue());
    } catch (e) {
        console.log(e);
    }
}
function $818bb3bf843b8c76$var$onInitialChanged(onInitial, options = {}) {
    if ($818bb3bf843b8c76$var$lockUpdate) return;
    let val = $818bb3bf843b8c76$var$initial.getValue();
    localStorage.setItem('initial', val);
    try {
        onInitial(val, options);
    } catch (e) {
        console.log(e);
    }
}
const $818bb3bf843b8c76$export$4256f76d7567e2ca = (onRules, onOptions, onInitial)=>{
    $818bb3bf843b8c76$var$globals.onRules = onRules;
    $818bb3bf843b8c76$var$globals.onOptions = onOptions;
    $818bb3bf843b8c76$var$globals.onInitial = onInitial;
    $818bb3bf843b8c76$var$rules.on('focus', ()=>$818bb3bf843b8c76$var$clearMarkers());
    var e, e1, e2;
    if (location.search.length > 1) {
        let algoUrl;
        if (location.search.slice(1).split('/').length == 2) {
            const [paperName, algoIdx] = location.search.slice(1).split('/');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($585fde6c032b7cd1$exports))).papers[paperName]) {
                let idx = -1;
                if (!isNaN(parseInt(algoIdx)) && (0, (/*@__PURE__*/$parcel$interopDefault($585fde6c032b7cd1$exports))).papers[paperName].algos[parseInt(algoIdx)] !== undefined) idx = parseInt(algoIdx);
                else {
                    for(let i = 0; i < (0, (/*@__PURE__*/$parcel$interopDefault($585fde6c032b7cd1$exports))).papers[paperName].algos.length; i++)if ((0, (/*@__PURE__*/$parcel$interopDefault($585fde6c032b7cd1$exports))).papers[paperName].algos[i].alias == algoIdx) {
                        idx = i;
                        break;
                    }
                }
                if (idx != -1) {
                    algoUrl = (0, $78a992a6d52ab0c0$export$7bd616347c8459e2)((0, (/*@__PURE__*/$parcel$interopDefault($585fde6c032b7cd1$exports))), [
                        ...(0, (/*@__PURE__*/$parcel$interopDefault($585fde6c032b7cd1$exports))).default,
                        ...(0, (/*@__PURE__*/$parcel$interopDefault($585fde6c032b7cd1$exports))).papers[paperName].type || [],
                        ...(0, (/*@__PURE__*/$parcel$interopDefault($585fde6c032b7cd1$exports))).papers[paperName].algos[idx].type
                    ]) + '.web-algo';
                    console.log({
                        algoUrl: algoUrl
                    });
                }
            }
        }
        if (!algoUrl) (0, $16f8882f3e3ce876$export$2288787135a8f66e)('Welcome to the 3D robot simulator. \n\nThe algorithm you provided in the url cannot be found.');
        else {
            (0, $16f8882f3e3ce876$export$2288787135a8f66e)('Welcome to the 3D robot simulator. \n\nThe algorithm is loading, you have to wait.\n\nIn case of error, please reload the page.');
            setTimeout(()=>{
                $818bb3bf843b8c76$var$loadFromUrl(algoUrl);
            }, 100);
        }
    }
};
function $818bb3bf843b8c76$export$dd41bdd847bf46() {
    return $818bb3bf843b8c76$var$rules.getValue();
}
function $818bb3bf843b8c76$export$e0314bf46696456e() {
    return $818bb3bf843b8c76$var$initial.getValue();
}
function $818bb3bf843b8c76$export$5157fbe9175db85e() {
    return $818bb3bf843b8c76$var$options.getValue();
}
ace.config.setModuleUrl('ace/mode/custom_rules', 'rulesMode.js');
$818bb3bf843b8c76$var$rules.session.setMode('ace/mode/custom_rules');
ace.config.set('basePath', './');
$818bb3bf843b8c76$var$rules.setTheme("ace/theme/rules");
const $818bb3bf843b8c76$var$saveButton = document.getElementById('save-button');
const $818bb3bf843b8c76$var$loadButton = document.getElementById('file-input');
const $818bb3bf843b8c76$var$urlLoadInput = document.getElementById('url-load-input');
const $818bb3bf843b8c76$var$urlLoadSubmit = document.getElementById('url-load-submit');
const $818bb3bf843b8c76$var$checkUnusedButton = document.getElementById('check-unused');
const $818bb3bf843b8c76$var$exportLatexButton = document.getElementById('export-latex');
const $818bb3bf843b8c76$var$exportV1Button = document.getElementById('export-v1');
$818bb3bf843b8c76$var$exportV1Button.style.display = 'none';
$818bb3bf843b8c76$var$saveButton.addEventListener('click', ()=>{
    /*
  var blob = new Blob([JSON.stringify({
      initial: initial.getValue(),
      options: options.getValue(),
      rules: rules.getValue()
  })], {type: "text/json;charset=utf-8"});
  */ var blob = new Blob([
        `
****** OPTIONS ******
${(0, (/*@__PURE__*/$parcel$interopDefault($e56d81185102178b$exports))).stringify({
            version: 1,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($e56d81185102178b$exports))).parse($818bb3bf843b8c76$var$options.getValue())
        })}

****** INITIAL CONFIGURATIONS ******
${$818bb3bf843b8c76$var$initial.getValue()}

****** RULES ******
${$818bb3bf843b8c76$var$rules.getValue()}
`
    ], {
        type: "text/json;charset=utf-8"
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8c4cd03c5db98c02$exports)))(blob, "algo.web-algo");
});
$818bb3bf843b8c76$var$exportLatexButton.addEventListener('click', ()=>{
    if (!$818bb3bf843b8c76$var$algo) return;
    const parsed = (0, $0640cb604c7a0caa$export$2e2bcd8739ae039)($818bb3bf843b8c76$var$rules.getValue(), $818bb3bf843b8c76$var$algo.options.visibilityRange, $818bb3bf843b8c76$var$algo.options.dimension);
    const setOfStates = new Set();
    const exportLines = [];
    const sanitizeLatexState = (state)=>state.replaceAll(',', '--').replaceAll('(', '-').replaceAll(')', '-');
    for (let r of Object.values(parsed.rules)){
        const getExportState = (dir)=>{
            let state = sanitizeLatexState(r.view.get(dir));
            setOfStates.add(state);
            if (r.view.hasWallsBoundaries()) {
                if (state != 'W') {
                    if (r.view.wallsBoundaries.wallX[0] && dir.x <= r.view.wallsBoundaries.wallX[0]) state = '|';
                    if (r.view.wallsBoundaries.wallX[1] && dir.x >= r.view.wallsBoundaries.wallX[1]) state = '|';
                    if (r.view.wallsBoundaries.wallY[0] && dir.y <= r.view.wallsBoundaries.wallY[0]) state = state == '|' ? '+' : '-';
                    if (r.view.wallsBoundaries.wallY[1] && dir.y >= r.view.wallsBoundaries.wallY[1]) state = state == '|' ? '+' : '-';
                    if (r.view.wallsBoundaries.wallZ[0] && dir.z <= r.view.wallsBoundaries.wallZ[0]) state = state == '|' ? '+' : '-';
                    if (r.view.wallsBoundaries.wallZ[1] && dir.z >= r.view.wallsBoundaries.wallZ[1]) state = state == '|' ? '+' : '-';
                }
            }
            return state;
        };
        const destColor = sanitizeLatexState(r.destination.color);
        const dest = r.destination.dir.map((d)=>(0, $347b986847663c76$export$12fe6b637cdfbfb3)(d)).join(',') + (r.destination.color != r.view.getCenter() ? '[' + destColor + ']' : '');
        if ($818bb3bf843b8c76$var$algo.options.dimension == 3 && $818bb3bf843b8c76$var$algo.options.visibilityRange == 1) {
            const above = getExportState((0, $347b986847663c76$export$50e63dfb05a215ef));
            const middle = [
                (0, $347b986847663c76$export$51ec4a2fc467eaa7),
                (0, $347b986847663c76$export$f981f70d61d1405a),
                (0, $347b986847663c76$export$49984ede44adf88d),
                (0, $347b986847663c76$export$1cac5500365a4eb4),
                (0, $347b986847663c76$export$1eeca8128376e4e9)
            ].map(getExportState).join(', ');
            const below = getExportState((0, $347b986847663c76$export$d73203a818a78b30));
            exportLines.push(`\\algoStepDDD{${above}}{${middle}}{${below}}{${dest}}`);
            continue;
        }
        if ($818bb3bf843b8c76$var$algo.options.dimension == 3 && $818bb3bf843b8c76$var$algo.options.visibilityRange == 2) {
            const dirs = (0, $347b986847663c76$export$ee89fa751abcfe5a)(2);
            const aboveDist2 = dirs.filter((d)=>d.z == 2).map(getExportState).join(', ');
            const above = dirs.filter((d)=>d.z == 1).map(getExportState).join(', ');
            const middle = dirs.filter((d)=>d.z == 0).map(getExportState).join(', ');
            const below = dirs.filter((d)=>d.z == -1).map(getExportState).join(', ');
            const belowDist2 = dirs.filter((d)=>d.z == -2).map(getExportState).join(', ');
            exportLines.push(`\\algoStepRRDDD{${aboveDist2}}{${above}}{${middle}}{${below}}{${belowDist2}}{${dest}}`);
            continue;
        }
        let tmp = [];
        for (const dir of (0, $347b986847663c76$export$ee89fa751abcfe5a)($818bb3bf843b8c76$var$algo.options.visibilityRange)){
            if (dir.z != 0 && $818bb3bf843b8c76$var$algo.options.dimension == 2) continue;
            const formatSpace = dir.x <= 0 && -dir.x + Math.abs(dir.y) == $818bb3bf843b8c76$var$algo.options.visibilityRange ? ' ' : '';
            tmp.push(formatSpace + getExportState(dir));
        }
        exportLines.push('\\algoStep{' + tmp.join(',') + '}{' + dest + '}');
    }
    // use shade of gray for all the colors of the states
    let gray = 10;
    for (const state of setOfStates){
        let latexColor = `black!${gray}`;
        exportLines.unshift(`\\algoSetRobotColor{${state}}{${latexColor}}`);
        gray += 1;
    } // save in the clipboard
    const el = document.createElement('textarea');
    el.value = exportLines.join('\n');
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el); //var blob = new Blob([exportLines.join('\n')], {type: "text/json;charset=utf-8"});
//saveAs(blob, "algo.tex");
});
$818bb3bf843b8c76$var$loadButton.addEventListener('input', (event)=>{
    var file = event.target.files[0];
    if (!file) {
        console.log('no file');
        return;
    }
    var reader = new FileReader();
    reader.onload = function(e) {
        var content = e.target.result;
        $818bb3bf843b8c76$var$loadFromString(content);
    };
    reader.readAsText(file);
});
function $818bb3bf843b8c76$var$loadFromString(content) {
    let algoInfo;
    try {
        algoInfo = (0, $2b39ea1e9ebe1cad$export$2e2bcd8739ae039)(content);
    } catch (e) {
        try {
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($e56d81185102178b$exports))).parse(content);
            algoInfo = (0, $786dfe013356b32a$export$2e2bcd8739ae039)(data);
        } catch (e2) {
            // ignore error
            // let the user retry
            console.log(e, e2);
            alert('there was an error, please retry!');
            throw new Error('Error while parsing');
        }
    }
    $818bb3bf843b8c76$var$initial.session.setValue(algoInfo.initialConfigurations);
    $818bb3bf843b8c76$var$options.session.setValue(algoInfo.options);
    $818bb3bf843b8c76$var$rules.session.setValue(algoInfo.rules);
    $818bb3bf843b8c76$var$initial.session.selection.clearSelection();
    $818bb3bf843b8c76$var$options.session.selection.clearSelection();
    $818bb3bf843b8c76$var$rules.session.selection.clearSelection();
    $818bb3bf843b8c76$export$79c0fc36dd8d1b46();
}
async function $818bb3bf843b8c76$var$loadFromUrl(url) {
    const content = await (await fetch(url + '?' + Math.random())).text();
    $818bb3bf843b8c76$var$loadFromString(content);
}
$818bb3bf843b8c76$var$urlLoadSubmit.addEventListener('click', (event)=>{
    event.preventDefault();
    const algoUrl = $818bb3bf843b8c76$var$urlLoadInput.value;
    $818bb3bf843b8c76$var$loadFromUrl(algoUrl);
});
let $818bb3bf843b8c76$var$algo = null;
const $818bb3bf843b8c76$export$62a6e6ed59805c20 = (_algo)=>{
    $818bb3bf843b8c76$var$algo = _algo;
};
const $818bb3bf843b8c76$var$logPanel = document.getElementById('log-panel');
const $818bb3bf843b8c76$export$82e4d778e253efa3 = (msg)=>{
    let el = document.createElement("div"); //el.innerHTML = `<textarea onclick="this.select()" class="view" readonly="readonly" rows="5" cols="5">${msg}</textarea>`;
    el.innerHTML = `<div>${msg}</div>`;
    $818bb3bf843b8c76$var$logPanel.prepend(el);
};
const $818bb3bf843b8c76$export$87422747c43910fd = (view)=>{
    if (!$818bb3bf843b8c76$var$algo) return;
    $818bb3bf843b8c76$var$clearMarkers();
    const { rule: rule, transformation: transformation } = (0, $347b986847663c76$export$ccf06a718c55ce20)({
        view: view,
        destination: {
            dir: [
                (0, $347b986847663c76$export$49984ede44adf88d)
            ],
            color: view.getCenter()
        }
    }, $818bb3bf843b8c76$var$algo.options);
    const key = rule.view.toString();
    if ($818bb3bf843b8c76$var$algo.rules[key]) {
        const ref = $818bb3bf843b8c76$var$algo.rulesReference[key];
        let el = document.createElement("div");
        el.innerHTML = `<div>Rule defined at line ${ref.line}</div>`;
        $818bb3bf843b8c76$var$logPanel.prepend(el);
        $818bb3bf843b8c76$var$rules.scrollToLine(ref.line, true, true, function() {});
        $818bb3bf843b8c76$var$rules.gotoLine(ref.line, 0, true);
        var Range = ace.require('ace/range').Range;
        $818bb3bf843b8c76$var$rules.session.addMarker(new Range(ref.line - 1, 0, ref.line_end, 0), "myMarker", "fullLine");
    } else {
        let el = document.createElement("div");
        el.innerHTML = `Rule not yet defined:<br/><textarea onclick="this.select()" class="view" readonly="readonly" rows="5" cols="5">${(0, $347b986847663c76$export$ea40dd710081b328)(view, $818bb3bf843b8c76$var$algo.options.dimension, {
            dest: 'idle'
        })}</textarea>`;
        $818bb3bf843b8c76$var$logPanel.prepend(el);
    }
};
$818bb3bf843b8c76$var$checkUnusedButton.addEventListener('click', ()=>{
    if (!$818bb3bf843b8c76$var$algo) return;
    const unused = new Set();
    let firstLines = null;
    Object.values($818bb3bf843b8c76$var$algo.rulesReference).forEach(({ view: view, line: line, line_end: line_end })=>{
        if (!$818bb3bf843b8c76$var$algo.usedViews.has(line)) {
            unused.add(view.toString() + ' lines ' + line + ':' + line_end);
            if (!firstLines) firstLines = {
                line: line,
                line_end: line_end
            };
        }
    });
    $818bb3bf843b8c76$export$82e4d778e253efa3('unused views:<br/>' + Array.from(unused.values()).join('<br/>'));
    if (firstLines) {
        $818bb3bf843b8c76$var$rules.scrollToLine(firstLines.line, true, true, function() {});
        $818bb3bf843b8c76$var$rules.gotoLine(firstLines.line, 0, true);
        var Range = ace.require('ace/range').Range;
        $818bb3bf843b8c76$var$rules.session.addMarker(new Range(firstLines.line - 1, 0, firstLines.line_end, 0), "myMarker", "fullLine");
    }
});
function $818bb3bf843b8c76$var$clearMarkers() {
    const prevMarkers = $818bb3bf843b8c76$var$rules.session.getMarkers();
    if (prevMarkers) {
        const prevMarkersArr = Object.keys(prevMarkers);
        for (let item of prevMarkersArr)$818bb3bf843b8c76$var$rules.session.removeMarker(prevMarkers[item].id);
    }
}
const $818bb3bf843b8c76$var$strDistance = (str1 = '', str2 = '')=>{
    let distance = 0;
    if (str1.length === str2.length) {
        for(let i = 0; i < str1.length; i++)if (str1[i] !== str2[i]) distance++;
        return distance;
    }
    return -1;
};
const $818bb3bf843b8c76$export$73235c61e66eff0b = (algo)=>{
    const buttonEl = document.getElementById('search-rules-button');
    const inputEl = document.getElementById('search-rules-input');
    const resultsEl = document.getElementById('search-rules-results');
    if (!buttonEl || !inputEl || !resultsEl) return;
    buttonEl.addEventListener('click', ()=>{
        const { view: view, destination: { dir: dir, color: color } } = (0, $0640cb604c7a0caa$export$726deb39d943dc92)(inputEl.value.split('\n'), 0, algo.options.visibilityRange, algo.options.dimension);
        console.log(0, (0, $347b986847663c76$export$ea40dd710081b328)(view, algo.options.dimension).replaceAll(/[ \t\n]/g, ''));
        Object.values(algo.rules).forEach((r)=>{
            const d = $818bb3bf843b8c76$var$strDistance((0, $347b986847663c76$export$ea40dd710081b328)(r.view, algo.options.dimension).replaceAll(/[ \t\n]/g, ''), (0, $347b986847663c76$export$ea40dd710081b328)(view, algo.options.dimension).replaceAll(/[ \t\n]/g, ''));
            if (d == 0 || d == 1) console.log(d, (0, $347b986847663c76$export$ea40dd710081b328)(r.view, algo.options.dimension).replaceAll(/[ \t\n]/g, ''));
        });
    });
};


/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const $ee56638efea8544d$export$3545e07a80636437 = '172';
const $ee56638efea8544d$export$7177b3e430c2d7ca = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const $ee56638efea8544d$export$d46bd3ead7cc759b = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const $ee56638efea8544d$export$3237e1f2c1ea1f44 = 0;
const $ee56638efea8544d$export$b9a7b4fc5cb15f9b = 1;
const $ee56638efea8544d$export$b8058bcc7037d3f3 = 2;
const $ee56638efea8544d$export$f24be24dcddeac0d = 3;
const $ee56638efea8544d$export$346307dbae2b7447 = 0;
const $ee56638efea8544d$export$5813f879eee7cd88 = 1;
const $ee56638efea8544d$export$a47c4b43a1be34f0 = 2;
const $ee56638efea8544d$export$896ae1ade6c829c4 = 3;
const $ee56638efea8544d$export$2ede184fc2998901 = 0;
const $ee56638efea8544d$export$d9f0486e75b5ace = 1;
const $ee56638efea8544d$export$3b296b6f144d5b03 = 2;
const $ee56638efea8544d$export$63b8d6b580fc65ba = 0;
const $ee56638efea8544d$export$5b29a26d96ee6af0 = 1;
const $ee56638efea8544d$export$777d8f9551c2216b = 2;
const $ee56638efea8544d$export$cdfa06f868e2e467 = 3;
const $ee56638efea8544d$export$4138e1c684b46a20 = 4;
const $ee56638efea8544d$export$eda4864c68df1fa2 = 5;
const $ee56638efea8544d$export$20183a0484ce21a0 = 100;
const $ee56638efea8544d$export$73e0df5177988548 = 101;
const $ee56638efea8544d$export$28e582859cbec660 = 102;
const $ee56638efea8544d$export$c8c1508da8d0600c = 103;
const $ee56638efea8544d$export$99948c02fb51055f = 104;
const $ee56638efea8544d$export$2110f05edf778d3d = 200;
const $ee56638efea8544d$export$8805bad65e24940e = 201;
const $ee56638efea8544d$export$7fbe15b28d28cf52 = 202;
const $ee56638efea8544d$export$947829af9f2c17f6 = 203;
const $ee56638efea8544d$export$d5773124e86cf28c = 204;
const $ee56638efea8544d$export$11d468cc7f19e971 = 205;
const $ee56638efea8544d$export$a78aed1ca2a87192 = 206;
const $ee56638efea8544d$export$5d0fe17fd8773bac = 207;
const $ee56638efea8544d$export$ef5f2dd8ffac5574 = 208;
const $ee56638efea8544d$export$56b85b2686ab16 = 209;
const $ee56638efea8544d$export$c05e2a1fc8609506 = 210;
const $ee56638efea8544d$export$7dd8f434fd59075 = 211;
const $ee56638efea8544d$export$99c8d898a9afbcee = 212;
const $ee56638efea8544d$export$310cd2be38d13b56 = 213;
const $ee56638efea8544d$export$db77b8fbcf45dbf4 = 214;
const $ee56638efea8544d$export$69025ce147cee220 = 0;
const $ee56638efea8544d$export$7182eb52ea3b3f04 = 1;
const $ee56638efea8544d$export$eedccec66ab7ebe = 2;
const $ee56638efea8544d$export$296f78a0b892f81a = 3;
const $ee56638efea8544d$export$a60d398fc7b7590e = 4;
const $ee56638efea8544d$export$7d7234c1240a1fc4 = 5;
const $ee56638efea8544d$export$c5e2c52991f30937 = 6;
const $ee56638efea8544d$export$2f843afa843d8916 = 7;
const $ee56638efea8544d$export$e50ac29801f1774d = 0;
const $ee56638efea8544d$export$9f9d94f963c85479 = 1;
const $ee56638efea8544d$export$e641dc52bc3494aa = 2;
const $ee56638efea8544d$export$9fcb6b4294603b2 = 0;
const $ee56638efea8544d$export$98f52c2a46c598ca = 1;
const $ee56638efea8544d$export$74b25e54b3bcd548 = 2;
const $ee56638efea8544d$export$932b3dd283d4a366 = 3;
const $ee56638efea8544d$export$a0d98fe6d7e4af64 = 4;
const $ee56638efea8544d$export$2c7b09c1e9abfb5e = 5;
const $ee56638efea8544d$export$212d53a513a325b2 = 6;
const $ee56638efea8544d$export$f2863e1668a8e317 = 7;
const $ee56638efea8544d$export$2595a3798997538 = 'attached';
const $ee56638efea8544d$export$d7e7dc2e114517a0 = 'detached';
const $ee56638efea8544d$export$1beec6768cbb3d2d = 300;
const $ee56638efea8544d$export$8759762a6477f2c4 = 301;
const $ee56638efea8544d$export$dc59f8aed047f61d = 302;
const $ee56638efea8544d$export$d64030b316d3b087 = 303;
const $ee56638efea8544d$export$ee99d97d46898098 = 304;
const $ee56638efea8544d$export$dbf3e70ff37af79 = 306;
const $ee56638efea8544d$export$533346c8e8dac0f5 = 1000;
const $ee56638efea8544d$export$9d9334239a5a5e06 = 1001;
const $ee56638efea8544d$export$c7e7c00b14f51a4f = 1002;
const $ee56638efea8544d$export$727aa5ec3fe39bf0 = 1003;
const $ee56638efea8544d$export$d129e38cf6feaa8c = 1004;
const $ee56638efea8544d$export$14a4936464a36496 = 1004;
const $ee56638efea8544d$export$d2327c1afe5bfdf2 = 1005;
const $ee56638efea8544d$export$cbc5b7f5647595d8 = 1005;
const $ee56638efea8544d$export$8a72f490b25c56c8 = 1006;
const $ee56638efea8544d$export$19a719f377145a13 = 1007;
const $ee56638efea8544d$export$dbe96bee3fe9dbf0 = 1007;
const $ee56638efea8544d$export$5d8599b6a933fb1b = 1008;
const $ee56638efea8544d$export$90d80f1e3506775f = 1008;
const $ee56638efea8544d$export$2e8ce08d3f6f5e10 = 1009;
const $ee56638efea8544d$export$545fce0311a9796a = 1010;
const $ee56638efea8544d$export$88572337f312435f = 1011;
const $ee56638efea8544d$export$c63dc51868b06a9d = 1012;
const $ee56638efea8544d$export$5c612977753abe2 = 1013;
const $ee56638efea8544d$export$c3c7fc4518ebba96 = 1014;
const $ee56638efea8544d$export$f6d331659b644596 = 1015;
const $ee56638efea8544d$export$2697304443f382bc = 1016;
const $ee56638efea8544d$export$b3969b01faf587f2 = 1017;
const $ee56638efea8544d$export$18886f8ae33e90de = 1018;
const $ee56638efea8544d$export$6c8ea339bfab1301 = 1020;
const $ee56638efea8544d$export$5a4c329b7e2092d3 = 35902;
const $ee56638efea8544d$export$988473390501ed4b = 1021;
const $ee56638efea8544d$export$7c67423a5ee6f5eb = 1022;
const $ee56638efea8544d$export$3f8bb04b555a363c = 1023;
const $ee56638efea8544d$export$cc09ccbf6d1ed449 = 1024;
const $ee56638efea8544d$export$9053a81c4a69c289 = 1025;
const $ee56638efea8544d$export$c1b6b5136be58045 = 1026;
const $ee56638efea8544d$export$1e113ac2d0905829 = 1027;
const $ee56638efea8544d$export$4e041a7967d15c4b = 1028;
const $ee56638efea8544d$export$aa92e870a709d190 = 1029;
const $ee56638efea8544d$export$6cdf0b461c7ce8a0 = 1030;
const $ee56638efea8544d$export$1ba1c45f9f77d4d7 = 1031;
const $ee56638efea8544d$export$d1fd40c11bfa798e = 1032;
const $ee56638efea8544d$export$c200e7d26f592f21 = 1033;
const $ee56638efea8544d$export$21d1799c6d552fc0 = 33776;
const $ee56638efea8544d$export$afa304c3e981b668 = 33777;
const $ee56638efea8544d$export$d2a1a68024a3e56c = 33778;
const $ee56638efea8544d$export$9a79c424327dacf9 = 33779;
const $ee56638efea8544d$export$19ada9bbb1af3573 = 35840;
const $ee56638efea8544d$export$d0f0355bb3d948e4 = 35841;
const $ee56638efea8544d$export$b82296714358084c = 35842;
const $ee56638efea8544d$export$b71692456c47b6c3 = 35843;
const $ee56638efea8544d$export$6ab91af2d757aee7 = 36196;
const $ee56638efea8544d$export$7800993ef8106a6a = 37492;
const $ee56638efea8544d$export$23ed8300a860e7d8 = 37496;
const $ee56638efea8544d$export$dc5570b4a2b92d48 = 37808;
const $ee56638efea8544d$export$68880cd325f8b2fb = 37809;
const $ee56638efea8544d$export$7d2c0be323373d95 = 37810;
const $ee56638efea8544d$export$22b52da301fc3a3e = 37811;
const $ee56638efea8544d$export$c009e2cb4a66485e = 37812;
const $ee56638efea8544d$export$118fff5afa255b63 = 37813;
const $ee56638efea8544d$export$120713c829ae0667 = 37814;
const $ee56638efea8544d$export$c79eeabbf53313e9 = 37815;
const $ee56638efea8544d$export$443cf6567cdd6424 = 37816;
const $ee56638efea8544d$export$6573984fc9840780 = 37817;
const $ee56638efea8544d$export$e7aee563f30091de = 37818;
const $ee56638efea8544d$export$2eb8634622ddeab7 = 37819;
const $ee56638efea8544d$export$202b1ce7b5d25742 = 37820;
const $ee56638efea8544d$export$18ab77abd087e467 = 37821;
const $ee56638efea8544d$export$ce40b115e188bc81 = 36492;
const $ee56638efea8544d$export$d279c5c4bac5121e = 36494;
const $ee56638efea8544d$export$cde52d17225fdbd3 = 36495;
const $ee56638efea8544d$export$b1688df4c4c21670 = 36283;
const $ee56638efea8544d$export$fc15e5d8261eed58 = 36284;
const $ee56638efea8544d$export$d220f6ade8463a0f = 36285;
const $ee56638efea8544d$export$768646d09dc1b6ef = 36286;
const $ee56638efea8544d$export$d62fdc9d1b1cccad = 2200;
const $ee56638efea8544d$export$dfaf4422ce096e29 = 2201;
const $ee56638efea8544d$export$f8f6f2041b78e210 = 2202;
const $ee56638efea8544d$export$995b32462a65e855 = 2300;
const $ee56638efea8544d$export$30fac1aace31cf4d = 2301;
const $ee56638efea8544d$export$198b11ff4c72bb30 = 2302;
const $ee56638efea8544d$export$7f795934b84ab523 = 2400;
const $ee56638efea8544d$export$24a4ccb5099273b5 = 2401;
const $ee56638efea8544d$export$8e8c3ecdcd8e1fee = 2402;
const $ee56638efea8544d$export$bcfbbdcf8de7f8cd = 2500;
const $ee56638efea8544d$export$d875e029ef558d3 = 2501;
const $ee56638efea8544d$export$4c28c87c2dc84758 = 0;
const $ee56638efea8544d$export$b23a071aa286eb29 = 1;
const $ee56638efea8544d$export$f0d8293634f88842 = 2;
const $ee56638efea8544d$export$deeb383078690b50 = 3200;
const $ee56638efea8544d$export$8f910f4c4f73df11 = 3201;
const $ee56638efea8544d$export$be2e2ddbc3983173 = 3202;
const $ee56638efea8544d$export$1a54198784742f80 = 3203;
const $ee56638efea8544d$export$2852a58ebdac27b8 = 0;
const $ee56638efea8544d$export$9990ad26f9db5b2c = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
const $ee56638efea8544d$export$bfcb490c2dd3db51 = '';
const $ee56638efea8544d$export$561f394b24edfcaa = 'srgb';
const $ee56638efea8544d$export$42429b3acfb233a4 = 'srgb-linear';
const $ee56638efea8544d$export$f197347d588c1b4a = 'linear';
const $ee56638efea8544d$export$8d0a61916cc26abb = 'srgb';
const $ee56638efea8544d$export$69433f11f42d5527 = 0;
const $ee56638efea8544d$export$9f542ae4b5baca34 = 7680;
const $ee56638efea8544d$export$8a4f28336ef203d3 = 7681;
const $ee56638efea8544d$export$2928c0231297c036 = 7682;
const $ee56638efea8544d$export$c0e9611c8a15f9a8 = 7683;
const $ee56638efea8544d$export$9c2c08927385dcc4 = 34055;
const $ee56638efea8544d$export$7c74ea00fa1315e6 = 34056;
const $ee56638efea8544d$export$22e2e5726612443 = 5386;
const $ee56638efea8544d$export$1343870698229224 = 512;
const $ee56638efea8544d$export$8e1d8ed281997fa6 = 513;
const $ee56638efea8544d$export$55648a1cde8329a7 = 514;
const $ee56638efea8544d$export$2dff107857e6aca2 = 515;
const $ee56638efea8544d$export$6f93765ab2f451a2 = 516;
const $ee56638efea8544d$export$6f3fb2d2440f2b76 = 517;
const $ee56638efea8544d$export$4119cf7b4c98fd5a = 518;
const $ee56638efea8544d$export$14cf96713ddd97a8 = 519;
const $ee56638efea8544d$export$d9e2d19a747baaab = 512;
const $ee56638efea8544d$export$36bcf49c713b3eb7 = 513;
const $ee56638efea8544d$export$66f28d946fc6a0d5 = 514;
const $ee56638efea8544d$export$64eea11eb407ddf1 = 515;
const $ee56638efea8544d$export$155af022118f3a38 = 516;
const $ee56638efea8544d$export$67ab95dde6bed156 = 517;
const $ee56638efea8544d$export$1cdcb70d53d65f61 = 518;
const $ee56638efea8544d$export$187b73a3e352c145 = 519;
const $ee56638efea8544d$export$763e8360f4d7f77d = 35044;
const $ee56638efea8544d$export$8505d14ac8546ca = 35048;
const $ee56638efea8544d$export$721e63549e51d81e = 35040;
const $ee56638efea8544d$export$415731dc4f48e299 = 35045;
const $ee56638efea8544d$export$9e809946455f13bc = 35049;
const $ee56638efea8544d$export$2ed9499a35b5f832 = 35041;
const $ee56638efea8544d$export$32ab2503ea19469a = 35046;
const $ee56638efea8544d$export$ab4022c2c3f86315 = 35050;
const $ee56638efea8544d$export$ba7f1db36a76a970 = 35042;
const $ee56638efea8544d$export$43600cc67fabd9f = '100';
const $ee56638efea8544d$export$f63012db5506e7dd = '300 es';
const $ee56638efea8544d$export$5a0e9190d10875d3 = 2000;
const $ee56638efea8544d$export$cc83beedcb9be9ac = 2001;
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ class $ee56638efea8544d$export$ec8b666c5fe2c75a {
    addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    hasEventListener(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    removeEventListener(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    dispatchEvent(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const $ee56638efea8544d$var$_lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let $ee56638efea8544d$var$_seed = 1234567;
const $ee56638efea8544d$var$DEG2RAD = Math.PI / 180;
const $ee56638efea8544d$export$914076c8150813e5 = 180 / Math.PI;
// http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
function $ee56638efea8544d$var$generateUUID() {
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = $ee56638efea8544d$var$_lut[d0 & 0xff] + $ee56638efea8544d$var$_lut[d0 >> 8 & 0xff] + $ee56638efea8544d$var$_lut[d0 >> 16 & 0xff] + $ee56638efea8544d$var$_lut[d0 >> 24 & 0xff] + '-' + $ee56638efea8544d$var$_lut[d1 & 0xff] + $ee56638efea8544d$var$_lut[d1 >> 8 & 0xff] + '-' + $ee56638efea8544d$var$_lut[d1 >> 16 & 0x0f | 0x40] + $ee56638efea8544d$var$_lut[d1 >> 24 & 0xff] + '-' + $ee56638efea8544d$var$_lut[d2 & 0x3f | 0x80] + $ee56638efea8544d$var$_lut[d2 >> 8 & 0xff] + '-' + $ee56638efea8544d$var$_lut[d2 >> 16 & 0xff] + $ee56638efea8544d$var$_lut[d2 >> 24 & 0xff] + $ee56638efea8544d$var$_lut[d3 & 0xff] + $ee56638efea8544d$var$_lut[d3 >> 8 & 0xff] + $ee56638efea8544d$var$_lut[d3 >> 16 & 0xff] + $ee56638efea8544d$var$_lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
function $ee56638efea8544d$var$clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
// compute euclidean modulo of m % n
// https://en.wikipedia.org/wiki/Modulo_operation
function $ee56638efea8544d$var$euclideanModulo(n, m) {
    return (n % m + m) % m;
}
// Linear mapping from range <a1, a2> to range <b1, b2>
function $ee56638efea8544d$var$mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
// https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
function $ee56638efea8544d$var$inverseLerp(x, y, value) {
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
// https://en.wikipedia.org/wiki/Linear_interpolation
function $ee56638efea8544d$var$lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
// http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
function $ee56638efea8544d$var$damp(x, y, lambda, dt) {
    return $ee56638efea8544d$var$lerp(x, y, 1 - Math.exp(-lambda * dt));
}
// https://www.desmos.com/calculator/vcsjnyz7x4
function $ee56638efea8544d$var$pingpong(x, length = 1) {
    return length - Math.abs($ee56638efea8544d$var$euclideanModulo(x, length * 2) - length);
}
// http://en.wikipedia.org/wiki/Smoothstep
function $ee56638efea8544d$var$smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
function $ee56638efea8544d$var$smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
// Random integer from <low, high> interval
function $ee56638efea8544d$var$randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
// Random float from <low, high> interval
function $ee56638efea8544d$var$randFloat(low, high) {
    return low + Math.random() * (high - low);
}
// Random float from <-range/2, range/2> interval
function $ee56638efea8544d$var$randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
// Deterministic pseudo-random float in the interval [ 0, 1 ]
function $ee56638efea8544d$var$seededRandom(s) {
    if (s !== undefined) $ee56638efea8544d$var$_seed = s;
    // Mulberry32 generator
    let t = $ee56638efea8544d$var$_seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function $ee56638efea8544d$var$degToRad(degrees) {
    return degrees * $ee56638efea8544d$var$DEG2RAD;
}
function $ee56638efea8544d$var$radToDeg(radians) {
    return radians * $ee56638efea8544d$export$914076c8150813e5;
}
function $ee56638efea8544d$var$isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
function $ee56638efea8544d$var$ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
function $ee56638efea8544d$var$floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
function $ee56638efea8544d$var$setQuaternionFromProperEuler(q, a, b, c, order) {
    // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
    // rotations are applied to the axes in the order specified by 'order'
    // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
    // angles are in radians
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
function $ee56638efea8544d$var$denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
function $ee56638efea8544d$var$normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
const $ee56638efea8544d$export$6a7ef315a0d1ef07 = {
    DEG2RAD: $ee56638efea8544d$var$DEG2RAD,
    RAD2DEG: $ee56638efea8544d$export$914076c8150813e5,
    generateUUID: $ee56638efea8544d$var$generateUUID,
    clamp: $ee56638efea8544d$var$clamp,
    euclideanModulo: $ee56638efea8544d$var$euclideanModulo,
    mapLinear: $ee56638efea8544d$var$mapLinear,
    inverseLerp: $ee56638efea8544d$var$inverseLerp,
    lerp: $ee56638efea8544d$var$lerp,
    damp: $ee56638efea8544d$var$damp,
    pingpong: $ee56638efea8544d$var$pingpong,
    smoothstep: $ee56638efea8544d$var$smoothstep,
    smootherstep: $ee56638efea8544d$var$smootherstep,
    randInt: $ee56638efea8544d$var$randInt,
    randFloat: $ee56638efea8544d$var$randFloat,
    randFloatSpread: $ee56638efea8544d$var$randFloatSpread,
    seededRandom: $ee56638efea8544d$var$seededRandom,
    degToRad: $ee56638efea8544d$var$degToRad,
    radToDeg: $ee56638efea8544d$var$radToDeg,
    isPowerOfTwo: $ee56638efea8544d$var$isPowerOfTwo,
    ceilPowerOfTwo: $ee56638efea8544d$var$ceilPowerOfTwo,
    floorPowerOfTwo: $ee56638efea8544d$var$floorPowerOfTwo,
    setQuaternionFromProperEuler: $ee56638efea8544d$var$setQuaternionFromProperEuler,
    normalize: $ee56638efea8544d$var$normalize,
    denormalize: $ee56638efea8544d$var$denormalize
};
class $ee56638efea8544d$export$c977b3e384af9ae1 {
    constructor(x = 0, y = 0){
        $ee56638efea8544d$export$c977b3e384af9ae1.prototype.isVector2 = true;
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $ee56638efea8544d$var$clamp(this.x, min.x, max.x);
        this.y = $ee56638efea8544d$var$clamp(this.y, min.y, max.y);
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = $ee56638efea8544d$var$clamp(this.x, minVal, maxVal);
        this.y = $ee56638efea8544d$var$clamp(this.y, minVal, maxVal);
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($ee56638efea8544d$var$clamp(length, min, max));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($ee56638efea8544d$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
class $ee56638efea8544d$export$8ff26dafa08918 {
    constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        $ee56638efea8544d$export$8ff26dafa08918.prototype.isMatrix3 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    //
    scale(sx, sy) {
        this.premultiply($ee56638efea8544d$var$_m3.makeScale(sx, sy));
        return this;
    }
    rotate(theta) {
        this.premultiply($ee56638efea8544d$var$_m3.makeRotation(-theta));
        return this;
    }
    translate(tx, ty) {
        this.premultiply($ee56638efea8544d$var$_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    //
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const $ee56638efea8544d$var$_m3 = /*@__PURE__*/ new $ee56638efea8544d$export$8ff26dafa08918();
function $ee56638efea8544d$export$bc6f937da07eae17(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const $ee56638efea8544d$var$TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function $ee56638efea8544d$var$getTypedArray(type, buffer) {
    return new $ee56638efea8544d$var$TYPED_ARRAYS[type](buffer);
}
function $ee56638efea8544d$export$7094a064528c7fee(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function $ee56638efea8544d$export$1033a2df66368859() {
    const canvas = $ee56638efea8544d$export$7094a064528c7fee('canvas');
    canvas.style.display = 'block';
    return canvas;
}
const $ee56638efea8544d$var$_cache = {};
function $ee56638efea8544d$export$5b28268982f175ba(message) {
    if (message in $ee56638efea8544d$var$_cache) return;
    $ee56638efea8544d$var$_cache[message] = true;
    console.warn(message);
}
function $ee56638efea8544d$export$d43f91ebeafb2c7(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
function $ee56638efea8544d$export$5238391f68c729b(projectionMatrix) {
    const m = projectionMatrix.elements;
    // Convert [-1, 1] to [0, 1] projection matrix
    m[2] = 0.5 * m[2] + 0.5 * m[3];
    m[6] = 0.5 * m[6] + 0.5 * m[7];
    m[10] = 0.5 * m[10] + 0.5 * m[11];
    m[14] = 0.5 * m[14] + 0.5 * m[15];
}
function $ee56638efea8544d$export$f8cf97d08da9bc86(projectionMatrix) {
    const m = projectionMatrix.elements;
    const isPerspectiveMatrix = m[11] === -1;
    // Reverse [0, 1] projection matrix
    if (isPerspectiveMatrix) {
        m[10] = -m[10] - 1;
        m[14] = -m[14];
    } else {
        m[10] = -m[10];
        m[14] = -m[14] + 1;
    }
}
const $ee56638efea8544d$var$LINEAR_REC709_TO_XYZ = /*@__PURE__*/ new $ee56638efea8544d$export$8ff26dafa08918().set(0.4123908, 0.3575843, 0.1804808, 0.2126390, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322);
const $ee56638efea8544d$var$XYZ_TO_LINEAR_REC709 = /*@__PURE__*/ new $ee56638efea8544d$export$8ff26dafa08918().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
function $ee56638efea8544d$var$createColorManagement() {
    const ColorManagement = {
        enabled: true,
        workingColorSpace: $ee56638efea8544d$export$42429b3acfb233a4,
        /**
		 * Implementations of supported color spaces.
		 *
		 * Required:
		 *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
		 *	- whitePoint: reference white [ x y ]
		 *	- transfer: transfer function (pre-defined)
		 *	- toXYZ: Matrix3 RGB to XYZ transform
		 *	- fromXYZ: Matrix3 XYZ to RGB transform
		 *	- luminanceCoefficients: RGB luminance coefficients
		 *
		 * Optional:
		 *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace }
		 *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
		 *
		 * Reference:
		 * - https://www.russellcottrell.com/photo/matrixCalculator.htm
		 */ spaces: {},
        convert: function(color, sourceColorSpace, targetColorSpace) {
            if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
            if (this.spaces[sourceColorSpace].transfer === $ee56638efea8544d$export$8d0a61916cc26abb) {
                color.r = $ee56638efea8544d$var$SRGBToLinear(color.r);
                color.g = $ee56638efea8544d$var$SRGBToLinear(color.g);
                color.b = $ee56638efea8544d$var$SRGBToLinear(color.b);
            }
            if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
                color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
                color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
            }
            if (this.spaces[targetColorSpace].transfer === $ee56638efea8544d$export$8d0a61916cc26abb) {
                color.r = $ee56638efea8544d$var$LinearToSRGB(color.r);
                color.g = $ee56638efea8544d$var$LinearToSRGB(color.g);
                color.b = $ee56638efea8544d$var$LinearToSRGB(color.b);
            }
            return color;
        },
        fromWorkingColorSpace: function(color, targetColorSpace) {
            return this.convert(color, this.workingColorSpace, targetColorSpace);
        },
        toWorkingColorSpace: function(color, sourceColorSpace) {
            return this.convert(color, sourceColorSpace, this.workingColorSpace);
        },
        getPrimaries: function(colorSpace) {
            return this.spaces[colorSpace].primaries;
        },
        getTransfer: function(colorSpace) {
            if (colorSpace === $ee56638efea8544d$export$bfcb490c2dd3db51) return $ee56638efea8544d$export$f197347d588c1b4a;
            return this.spaces[colorSpace].transfer;
        },
        getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
            return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
        },
        define: function(colorSpaces) {
            Object.assign(this.spaces, colorSpaces);
        },
        // Internal APIs
        _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
            return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
        },
        _getDrawingBufferColorSpace: function(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
            return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
        }
    };
    /******************************************************************************
	 * sRGB definitions
	 */ const REC709_PRIMARIES = [
        0.640,
        0.330,
        0.300,
        0.600,
        0.150,
        0.060
    ];
    const REC709_LUMINANCE_COEFFICIENTS = [
        0.2126,
        0.7152,
        0.0722
    ];
    const D65 = [
        0.3127,
        0.3290
    ];
    ColorManagement.define({
        [$ee56638efea8544d$export$42429b3acfb233a4]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $ee56638efea8544d$export$f197347d588c1b4a,
            toXYZ: $ee56638efea8544d$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $ee56638efea8544d$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            workingColorSpaceConfig: {
                unpackColorSpace: $ee56638efea8544d$export$561f394b24edfcaa
            },
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $ee56638efea8544d$export$561f394b24edfcaa
            }
        },
        [$ee56638efea8544d$export$561f394b24edfcaa]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: $ee56638efea8544d$export$8d0a61916cc26abb,
            toXYZ: $ee56638efea8544d$var$LINEAR_REC709_TO_XYZ,
            fromXYZ: $ee56638efea8544d$var$XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            outputColorSpaceConfig: {
                drawingBufferColorSpace: $ee56638efea8544d$export$561f394b24edfcaa
            }
        }
    });
    return ColorManagement;
}
const $ee56638efea8544d$export$5e6fd513f44698c = /*@__PURE__*/ $ee56638efea8544d$var$createColorManagement();
function $ee56638efea8544d$var$SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function $ee56638efea8544d$var$LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let $ee56638efea8544d$var$_canvas;
class $ee56638efea8544d$export$698882cf06df44aa {
    static getDataURL(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if ($ee56638efea8544d$var$_canvas === undefined) $ee56638efea8544d$var$_canvas = $ee56638efea8544d$export$7094a064528c7fee('canvas');
            $ee56638efea8544d$var$_canvas.width = image.width;
            $ee56638efea8544d$var$_canvas.height = image.height;
            const context = $ee56638efea8544d$var$_canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = $ee56638efea8544d$var$_canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) {
            console.warn('THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons', image);
            return canvas.toDataURL('image/jpeg', 0.6);
        } else return canvas.toDataURL('image/png');
    }
    static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = $ee56638efea8544d$export$7094a064528c7fee('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = $ee56638efea8544d$var$SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor($ee56638efea8544d$var$SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = $ee56638efea8544d$var$SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            console.warn('THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
let $ee56638efea8544d$var$_sourceId = 0;
class $ee56638efea8544d$export$1d2df86270c81ecb {
    constructor(data = null){
        this.isSource = true;
        Object.defineProperty(this, 'id', {
            value: $ee56638efea8544d$var$_sourceId++
        });
        this.uuid = $ee56638efea8544d$var$generateUUID();
        this.data = data;
        this.dataReady = true;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push($ee56638efea8544d$var$serializeImage(data[i].image));
                else url.push($ee56638efea8544d$var$serializeImage(data[i]));
            } else // texture
            url = $ee56638efea8544d$var$serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function $ee56638efea8544d$var$serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return $ee56638efea8544d$export$698882cf06df44aa.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let $ee56638efea8544d$var$_textureId = 0;
class $ee56638efea8544d$export$5431306cf43de24a extends $ee56638efea8544d$export$ec8b666c5fe2c75a {
    constructor(image = $ee56638efea8544d$export$5431306cf43de24a.DEFAULT_IMAGE, mapping = $ee56638efea8544d$export$5431306cf43de24a.DEFAULT_MAPPING, wrapS = $ee56638efea8544d$export$9d9334239a5a5e06, wrapT = $ee56638efea8544d$export$9d9334239a5a5e06, magFilter = $ee56638efea8544d$export$8a72f490b25c56c8, minFilter = $ee56638efea8544d$export$5d8599b6a933fb1b, format = $ee56638efea8544d$export$3f8bb04b555a363c, type = $ee56638efea8544d$export$2e8ce08d3f6f5e10, anisotropy = $ee56638efea8544d$export$5431306cf43de24a.DEFAULT_ANISOTROPY, colorSpace = $ee56638efea8544d$export$bfcb490c2dd3db51){
        super();
        this.isTexture = true;
        Object.defineProperty(this, 'id', {
            value: $ee56638efea8544d$var$_textureId++
        });
        this.uuid = $ee56638efea8544d$var$generateUUID();
        this.name = '';
        this.source = new $ee56638efea8544d$export$1d2df86270c81ecb(image);
        this.mipmaps = [];
        this.mapping = mapping;
        this.channel = 0;
        this.wrapS = wrapS;
        this.wrapT = wrapT;
        this.magFilter = magFilter;
        this.minFilter = minFilter;
        this.anisotropy = anisotropy;
        this.format = format;
        this.internalFormat = null;
        this.type = type;
        this.offset = new $ee56638efea8544d$export$c977b3e384af9ae1(0, 0);
        this.repeat = new $ee56638efea8544d$export$c977b3e384af9ae1(1, 1);
        this.center = new $ee56638efea8544d$export$c977b3e384af9ae1(0, 0);
        this.rotation = 0;
        this.matrixAutoUpdate = true;
        this.matrix = new $ee56638efea8544d$export$8ff26dafa08918();
        this.generateMipmaps = true;
        this.premultiplyAlpha = false;
        this.flipY = true;
        this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        this.colorSpace = colorSpace;
        this.userData = {};
        this.version = 0;
        this.onUpdate = null;
        this.renderTarget = null; // assign texture to a render target
        this.isRenderTargetTexture = false; // indicates whether a texture belongs to a render target or not
        this.pmremVersion = 0; // indicates whether this texture should be processed by PMREMGenerator or not (only relevant for render target textures)
    }
    get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.renderTarget = source.renderTarget;
        this.isRenderTargetTexture = source.isRenderTargetTexture;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.6,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    transformUv(uv) {
        if (this.mapping !== $ee56638efea8544d$export$1beec6768cbb3d2d) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case $ee56638efea8544d$export$533346c8e8dac0f5:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case $ee56638efea8544d$export$9d9334239a5a5e06:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case $ee56638efea8544d$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case $ee56638efea8544d$export$533346c8e8dac0f5:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case $ee56638efea8544d$export$9d9334239a5a5e06:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case $ee56638efea8544d$export$c7e7c00b14f51a4f:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    set needsPMREMUpdate(value) {
        if (value === true) this.pmremVersion++;
    }
}
$ee56638efea8544d$export$5431306cf43de24a.DEFAULT_IMAGE = null;
$ee56638efea8544d$export$5431306cf43de24a.DEFAULT_MAPPING = $ee56638efea8544d$export$1beec6768cbb3d2d;
$ee56638efea8544d$export$5431306cf43de24a.DEFAULT_ANISOTROPY = 1;
class $ee56638efea8544d$export$fa7daccca11cdbe3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        $ee56638efea8544d$export$fa7daccca11cdbe3.prototype.isVector4 = true;
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        this.w /= v.w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $ee56638efea8544d$var$clamp(this.x, min.x, max.x);
        this.y = $ee56638efea8544d$var$clamp(this.y, min.y, max.y);
        this.z = $ee56638efea8544d$var$clamp(this.z, min.z, max.z);
        this.w = $ee56638efea8544d$var$clamp(this.w, min.w, max.w);
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = $ee56638efea8544d$var$clamp(this.x, minVal, maxVal);
        this.y = $ee56638efea8544d$var$clamp(this.y, minVal, maxVal);
        this.z = $ee56638efea8544d$var$clamp(this.z, minVal, maxVal);
        this.w = $ee56638efea8544d$var$clamp(this.w, minVal, maxVal);
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($ee56638efea8544d$var$clamp(length, min, max));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class $ee56638efea8544d$export$efcb1f8bf367cbfb extends $ee56638efea8544d$export$ec8b666c5fe2c75a {
    constructor(width = 1, height = 1, options = {}){
        super();
        this.isRenderTarget = true;
        this.width = width;
        this.height = height;
        this.depth = 1;
        this.scissor = new $ee56638efea8544d$export$fa7daccca11cdbe3(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new $ee56638efea8544d$export$fa7daccca11cdbe3(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: 1
        };
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: $ee56638efea8544d$export$8a72f490b25c56c8,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1
        }, options);
        const texture = new $ee56638efea8544d$export$5431306cf43de24a(image, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        texture.flipY = false;
        texture.generateMipmaps = options.generateMipmaps;
        texture.internalFormat = options.internalFormat;
        this.textures = [];
        const count = options.count;
        for(let i = 0; i < count; i++){
            this.textures[i] = texture.clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
        }
        this.depthBuffer = options.depthBuffer;
        this.stencilBuffer = options.stencilBuffer;
        this.resolveDepthBuffer = options.resolveDepthBuffer;
        this.resolveStencilBuffer = options.resolveStencilBuffer;
        this._depthTexture = null;
        this.depthTexture = options.depthTexture;
        this.samples = options.samples;
    }
    get texture() {
        return this.textures[0];
    }
    set texture(value) {
        this.textures[0] = value;
    }
    set depthTexture(current) {
        if (this._depthTexture !== null) this._depthTexture.renderTarget = null;
        if (current !== null) current.renderTarget = this;
        this._depthTexture = current;
    }
    get depthTexture() {
        return this._depthTexture;
    }
    setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.textures.length; i < il; i++){
                this.textures[i].image.width = width;
                this.textures[i].image.height = height;
                this.textures[i].image.depth = depth;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for(let i = 0, il = source.textures.length; i < il; i++){
            this.textures[i] = source.textures[i].clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
        }
        // ensure image object is not shared, see #20328
        const image = Object.assign({}, source.texture.image);
        this.texture.source = new $ee56638efea8544d$export$1d2df86270c81ecb(image);
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class $ee56638efea8544d$export$3c052beb2e51e23f extends $ee56638efea8544d$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        this.isWebGLRenderTarget = true;
    }
}
class $ee56638efea8544d$export$dfac6c8e811406a3 extends $ee56638efea8544d$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        this.isDataArrayTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $ee56638efea8544d$export$727aa5ec3fe39bf0;
        this.minFilter = $ee56638efea8544d$export$727aa5ec3fe39bf0;
        this.wrapR = $ee56638efea8544d$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
        this.layerUpdates = new Set();
    }
    addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $ee56638efea8544d$export$c77a02c11ed180c7 extends $ee56638efea8544d$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        this.texture = new $ee56638efea8544d$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $ee56638efea8544d$export$d7a3086320f856db extends $ee56638efea8544d$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in Data3DTexture directly.
        //
        //	const texture = new THREE.Data3DTexture( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        this.isData3DTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height,
            depth: depth
        };
        this.magFilter = $ee56638efea8544d$export$727aa5ec3fe39bf0;
        this.minFilter = $ee56638efea8544d$export$727aa5ec3fe39bf0;
        this.wrapR = $ee56638efea8544d$export$9d9334239a5a5e06;
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
class $ee56638efea8544d$export$7ee06591009639df extends $ee56638efea8544d$export$3c052beb2e51e23f {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        this.texture = new $ee56638efea8544d$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $ee56638efea8544d$export$23d6a54f0bbc85a3 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t === 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t === 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < Number.EPSILON) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs($ee56638efea8544d$var$clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize(); // normalize calls _onChangeCallback()
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    random() {
        // sets this quaternion to a uniform random unit quaternnion
        // Ken Shoemake
        // Uniform random rotations
        // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
    }
    toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
class $ee56638efea8544d$export$64b5c384219d3699 {
    constructor(x = 0, y = 0, z = 0){
        $ee56638efea8544d$export$64b5c384219d3699.prototype.isVector3 = true;
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        return this.applyQuaternion($ee56638efea8544d$var$_quaternion$4.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion($ee56638efea8544d$var$_quaternion$4.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = $ee56638efea8544d$var$clamp(this.x, min.x, max.x);
        this.y = $ee56638efea8544d$var$clamp(this.y, min.y, max.y);
        this.z = $ee56638efea8544d$var$clamp(this.z, min.z, max.z);
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = $ee56638efea8544d$var$clamp(this.x, minVal, maxVal);
        this.y = $ee56638efea8544d$var$clamp(this.y, minVal, maxVal);
        this.z = $ee56638efea8544d$var$clamp(this.z, minVal, maxVal);
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar($ee56638efea8544d$var$clamp(length, min, max));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v) {
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        $ee56638efea8544d$var$_vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub($ee56638efea8544d$var$_vector$c);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub($ee56638efea8544d$var$_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos($ee56638efea8544d$var$clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    randomDirection() {
        // https://mathworld.wolfram.com/SpherePointPicking.html
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const $ee56638efea8544d$var$_vector$c = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_quaternion$4 = /*@__PURE__*/ new $ee56638efea8544d$export$23d6a54f0bbc85a3();
class $ee56638efea8544d$export$6f7d5a9418ab2aa3 {
    constructor(min = new $ee56638efea8544d$export$64b5c384219d3699(Infinity, Infinity, Infinity), max = new $ee56638efea8544d$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity)){
        this.isBox3 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint($ee56638efea8544d$var$_vector$b.fromArray(array, i));
        return this;
    }
    setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint($ee56638efea8544d$var$_vector$b.fromBufferAttribute(attribute, i));
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $ee56638efea8544d$var$_vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute('position');
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, $ee56638efea8544d$var$_vector$b);
                else $ee56638efea8544d$var$_vector$b.fromBufferAttribute(positionAttribute, i);
                $ee56638efea8544d$var$_vector$b.applyMatrix4(object.matrixWorld);
                this.expandByPoint($ee56638efea8544d$var$_vector$b);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    $ee56638efea8544d$var$_box$4.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    $ee56638efea8544d$var$_box$4.copy(geometry.boundingBox);
                }
                $ee56638efea8544d$var$_box$4.applyMatrix4(object.matrixWorld);
                this.union($ee56638efea8544d$var$_box$4);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, $ee56638efea8544d$var$_vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return $ee56638efea8544d$var$_vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter($ee56638efea8544d$var$_center);
        $ee56638efea8544d$var$_extents.subVectors(this.max, $ee56638efea8544d$var$_center);
        // translate triangle to aabb origin
        $ee56638efea8544d$var$_v0$2.subVectors(triangle.a, $ee56638efea8544d$var$_center);
        $ee56638efea8544d$var$_v1$7.subVectors(triangle.b, $ee56638efea8544d$var$_center);
        $ee56638efea8544d$var$_v2$4.subVectors(triangle.c, $ee56638efea8544d$var$_center);
        // compute edge vectors for triangle
        $ee56638efea8544d$var$_f0.subVectors($ee56638efea8544d$var$_v1$7, $ee56638efea8544d$var$_v0$2);
        $ee56638efea8544d$var$_f1.subVectors($ee56638efea8544d$var$_v2$4, $ee56638efea8544d$var$_v1$7);
        $ee56638efea8544d$var$_f2.subVectors($ee56638efea8544d$var$_v0$2, $ee56638efea8544d$var$_v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -$ee56638efea8544d$var$_f0.z,
            $ee56638efea8544d$var$_f0.y,
            0,
            -$ee56638efea8544d$var$_f1.z,
            $ee56638efea8544d$var$_f1.y,
            0,
            -$ee56638efea8544d$var$_f2.z,
            $ee56638efea8544d$var$_f2.y,
            $ee56638efea8544d$var$_f0.z,
            0,
            -$ee56638efea8544d$var$_f0.x,
            $ee56638efea8544d$var$_f1.z,
            0,
            -$ee56638efea8544d$var$_f1.x,
            $ee56638efea8544d$var$_f2.z,
            0,
            -$ee56638efea8544d$var$_f2.x,
            -$ee56638efea8544d$var$_f0.y,
            $ee56638efea8544d$var$_f0.x,
            0,
            -$ee56638efea8544d$var$_f1.y,
            $ee56638efea8544d$var$_f1.x,
            0,
            -$ee56638efea8544d$var$_f2.y,
            $ee56638efea8544d$var$_f2.x,
            0
        ];
        if (!$ee56638efea8544d$var$satForAxes(axes, $ee56638efea8544d$var$_v0$2, $ee56638efea8544d$var$_v1$7, $ee56638efea8544d$var$_v2$4, $ee56638efea8544d$var$_extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!$ee56638efea8544d$var$satForAxes(axes, $ee56638efea8544d$var$_v0$2, $ee56638efea8544d$var$_v1$7, $ee56638efea8544d$var$_v2$4, $ee56638efea8544d$var$_extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        $ee56638efea8544d$var$_triangleNormal.crossVectors($ee56638efea8544d$var$_f0, $ee56638efea8544d$var$_f1);
        axes = [
            $ee56638efea8544d$var$_triangleNormal.x,
            $ee56638efea8544d$var$_triangleNormal.y,
            $ee56638efea8544d$var$_triangleNormal.z
        ];
        return $ee56638efea8544d$var$satForAxes(axes, $ee56638efea8544d$var$_v0$2, $ee56638efea8544d$var$_v1$7, $ee56638efea8544d$var$_v2$4, $ee56638efea8544d$var$_extents);
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $ee56638efea8544d$var$_vector$b).distanceTo(point);
    }
    getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize($ee56638efea8544d$var$_vector$b).length() * 0.5;
        }
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        $ee56638efea8544d$var$_points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        $ee56638efea8544d$var$_points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        $ee56638efea8544d$var$_points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        $ee56638efea8544d$var$_points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        $ee56638efea8544d$var$_points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        $ee56638efea8544d$var$_points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        $ee56638efea8544d$var$_points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        $ee56638efea8544d$var$_points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints($ee56638efea8544d$var$_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $ee56638efea8544d$var$_points = [
    /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699(),
    /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699(),
    /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699(),
    /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699(),
    /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699(),
    /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699(),
    /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699(),
    /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699()
];
const $ee56638efea8544d$var$_vector$b = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_box$4 = /*@__PURE__*/ new $ee56638efea8544d$export$6f7d5a9418ab2aa3();
// triangle centered vertices
const $ee56638efea8544d$var$_v0$2 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_v1$7 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_v2$4 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
// triangle edge vectors
const $ee56638efea8544d$var$_f0 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_f1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_f2 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_center = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_extents = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_triangleNormal = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_testAxis = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
function $ee56638efea8544d$var$satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        $ee56638efea8544d$var$_testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs($ee56638efea8544d$var$_testAxis.x) + extents.y * Math.abs($ee56638efea8544d$var$_testAxis.y) + extents.z * Math.abs($ee56638efea8544d$var$_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot($ee56638efea8544d$var$_testAxis);
        const p1 = v1.dot($ee56638efea8544d$var$_testAxis);
        const p2 = v2.dot($ee56638efea8544d$var$_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const $ee56638efea8544d$var$_box$3 = /*@__PURE__*/ new $ee56638efea8544d$export$6f7d5a9418ab2aa3();
const $ee56638efea8544d$var$_v1$6 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_v2$3 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$805e8b72413ccaba {
    constructor(center = new $ee56638efea8544d$export$64b5c384219d3699(), radius = -1){
        this.isSphere = true;
        this.center = center;
        this.radius = radius;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else $ee56638efea8544d$var$_box$3.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        $ee56638efea8544d$var$_v1$6.subVectors(point, this.center);
        const lengthSq = $ee56638efea8544d$var$_v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector($ee56638efea8544d$var$_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            $ee56638efea8544d$var$_v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint($ee56638efea8544d$var$_v1$6.copy(sphere.center).add($ee56638efea8544d$var$_v2$3));
            this.expandByPoint($ee56638efea8544d$var$_v1$6.copy(sphere.center).sub($ee56638efea8544d$var$_v2$3));
        }
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $ee56638efea8544d$var$_vector$a = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_segCenter = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_segDir = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_diff = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_edge1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_edge2 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_normal$1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$a186db52eed6d40e {
    constructor(origin = new $ee56638efea8544d$export$64b5c384219d3699(), direction = new $ee56638efea8544d$export$64b5c384219d3699(0, 0, -1)){
        this.origin = origin;
        this.direction = direction;
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, $ee56638efea8544d$var$_vector$a));
        return this;
    }
    closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = $ee56638efea8544d$var$_vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        $ee56638efea8544d$var$_vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return $ee56638efea8544d$var$_vector$a.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        $ee56638efea8544d$var$_segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        $ee56638efea8544d$var$_segDir.copy(v1).sub(v0).normalize();
        $ee56638efea8544d$var$_diff.copy(this.origin).sub($ee56638efea8544d$var$_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot($ee56638efea8544d$var$_segDir);
        const b0 = $ee56638efea8544d$var$_diff.dot(this.direction);
        const b1 = -$ee56638efea8544d$var$_diff.dot($ee56638efea8544d$var$_segDir);
        const c = $ee56638efea8544d$var$_diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy($ee56638efea8544d$var$_segCenter).addScaledVector($ee56638efea8544d$var$_segDir, s1);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        $ee56638efea8544d$var$_vector$a.subVectors(sphere.center, this.origin);
        const tca = $ee56638efea8544d$var$_vector$a.dot(this.direction);
        const d2 = $ee56638efea8544d$var$_vector$a.dot($ee56638efea8544d$var$_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, $ee56638efea8544d$var$_vector$a) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        $ee56638efea8544d$var$_edge1.subVectors(b, a);
        $ee56638efea8544d$var$_edge2.subVectors(c, a);
        $ee56638efea8544d$var$_normal$1.crossVectors($ee56638efea8544d$var$_edge1, $ee56638efea8544d$var$_edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot($ee56638efea8544d$var$_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        $ee56638efea8544d$var$_diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot($ee56638efea8544d$var$_edge2.crossVectors($ee56638efea8544d$var$_diff, $ee56638efea8544d$var$_edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot($ee56638efea8544d$var$_edge1.cross($ee56638efea8544d$var$_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * $ee56638efea8544d$var$_diff.dot($ee56638efea8544d$var$_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $ee56638efea8544d$export$2ae72fc923e5eb5 {
    constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        $ee56638efea8544d$export$2ae72fc923e5eb5.prototype.isMatrix4 = true;
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new $ee56638efea8544d$export$2ae72fc923e5eb5().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / $ee56638efea8544d$var$_v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / $ee56638efea8544d$var$_v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / $ee56638efea8544d$var$_v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose($ee56638efea8544d$var$_zero, q, $ee56638efea8544d$var$_one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        $ee56638efea8544d$var$_z.subVectors(eye, target);
        if ($ee56638efea8544d$var$_z.lengthSq() === 0) // eye and target are in the same position
        $ee56638efea8544d$var$_z.z = 1;
        $ee56638efea8544d$var$_z.normalize();
        $ee56638efea8544d$var$_x.crossVectors(up, $ee56638efea8544d$var$_z);
        if ($ee56638efea8544d$var$_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) $ee56638efea8544d$var$_z.x += 0.0001;
            else $ee56638efea8544d$var$_z.z += 0.0001;
            $ee56638efea8544d$var$_z.normalize();
            $ee56638efea8544d$var$_x.crossVectors(up, $ee56638efea8544d$var$_z);
        }
        $ee56638efea8544d$var$_x.normalize();
        $ee56638efea8544d$var$_y.crossVectors($ee56638efea8544d$var$_z, $ee56638efea8544d$var$_x);
        te[0] = $ee56638efea8544d$var$_x.x;
        te[4] = $ee56638efea8544d$var$_y.x;
        te[8] = $ee56638efea8544d$var$_z.x;
        te[1] = $ee56638efea8544d$var$_x.y;
        te[5] = $ee56638efea8544d$var$_y.y;
        te[9] = $ee56638efea8544d$var$_z.y;
        te[2] = $ee56638efea8544d$var$_x.z;
        te[6] = $ee56638efea8544d$var$_y.z;
        te[10] = $ee56638efea8544d$var$_z.z;
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = $ee56638efea8544d$var$_v1$5.set(te[0], te[1], te[2]).length();
        const sy = $ee56638efea8544d$var$_v1$5.set(te[4], te[5], te[6]).length();
        const sz = $ee56638efea8544d$var$_v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        $ee56638efea8544d$var$_m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        $ee56638efea8544d$var$_m1$2.elements[0] *= invSX;
        $ee56638efea8544d$var$_m1$2.elements[1] *= invSX;
        $ee56638efea8544d$var$_m1$2.elements[2] *= invSX;
        $ee56638efea8544d$var$_m1$2.elements[4] *= invSY;
        $ee56638efea8544d$var$_m1$2.elements[5] *= invSY;
        $ee56638efea8544d$var$_m1$2.elements[6] *= invSY;
        $ee56638efea8544d$var$_m1$2.elements[8] *= invSZ;
        $ee56638efea8544d$var$_m1$2.elements[9] *= invSZ;
        $ee56638efea8544d$var$_m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix($ee56638efea8544d$var$_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far, coordinateSystem = $ee56638efea8544d$export$5a0e9190d10875d3) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (coordinateSystem === $ee56638efea8544d$export$5a0e9190d10875d3) {
            c = -(far + near) / (far - near);
            d = -2 * far * near / (far - near);
        } else if (coordinateSystem === $ee56638efea8544d$export$cc83beedcb9be9ac) {
            c = -far / (far - near);
            d = -far * near / (far - near);
        } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = $ee56638efea8544d$export$5a0e9190d10875d3) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        let z, zInv;
        if (coordinateSystem === $ee56638efea8544d$export$5a0e9190d10875d3) {
            z = (far + near) * p;
            zInv = -2 * p;
        } else if (coordinateSystem === $ee56638efea8544d$export$cc83beedcb9be9ac) {
            z = near * p;
            zInv = -1 * p;
        } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = zInv;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const $ee56638efea8544d$var$_v1$5 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_m1$2 = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_zero = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699(0, 0, 0);
const $ee56638efea8544d$var$_one = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699(1, 1, 1);
const $ee56638efea8544d$var$_x = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_y = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_z = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_matrix$2 = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_quaternion$3 = /*@__PURE__*/ new $ee56638efea8544d$export$23d6a54f0bbc85a3();
class $ee56638efea8544d$export$d93cc409a0768c5f {
    constructor(x = 0, y = 0, z = 0, order = $ee56638efea8544d$export$d93cc409a0768c5f.DEFAULT_ORDER){
        this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order = this._order, update = true) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin($ee56638efea8544d$var$clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-$ee56638efea8544d$var$clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin($ee56638efea8544d$var$clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-$ee56638efea8544d$var$clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin($ee56638efea8544d$var$clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-$ee56638efea8544d$var$clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        $ee56638efea8544d$var$_matrix$2.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix($ee56638efea8544d$var$_matrix$2, order, update);
    }
    setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        $ee56638efea8544d$var$_quaternion$3.setFromEuler(this);
        return this.setFromQuaternion($ee56638efea8544d$var$_quaternion$3, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
$ee56638efea8544d$export$d93cc409a0768c5f.DEFAULT_ORDER = 'XYZ';
class $ee56638efea8544d$export$89312ce47c0ca777 {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = (1 << channel | 0) >>> 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    isEnabled(channel) {
        return (this.mask & (1 << channel | 0)) !== 0;
    }
}
let $ee56638efea8544d$var$_object3DId = 0;
const $ee56638efea8544d$var$_v1$4 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_q1 = /*@__PURE__*/ new $ee56638efea8544d$export$23d6a54f0bbc85a3();
const $ee56638efea8544d$var$_m1$1 = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_target = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_position$3 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_scale$2 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_quaternion$2 = /*@__PURE__*/ new $ee56638efea8544d$export$23d6a54f0bbc85a3();
const $ee56638efea8544d$var$_xAxis = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699(1, 0, 0);
const $ee56638efea8544d$var$_yAxis = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699(0, 1, 0);
const $ee56638efea8544d$var$_zAxis = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699(0, 0, 1);
const $ee56638efea8544d$var$_addedEvent = {
    type: 'added'
};
const $ee56638efea8544d$var$_removedEvent = {
    type: 'removed'
};
const $ee56638efea8544d$var$_childaddedEvent = {
    type: 'childadded',
    child: null
};
const $ee56638efea8544d$var$_childremovedEvent = {
    type: 'childremoved',
    child: null
};
class $ee56638efea8544d$export$e4dd07dff30cc924 extends $ee56638efea8544d$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isObject3D = true;
        Object.defineProperty(this, 'id', {
            value: $ee56638efea8544d$var$_object3DId++
        });
        this.uuid = $ee56638efea8544d$var$generateUUID();
        this.name = '';
        this.type = 'Object3D';
        this.parent = null;
        this.children = [];
        this.up = $ee56638efea8544d$export$e4dd07dff30cc924.DEFAULT_UP.clone();
        const position = new $ee56638efea8544d$export$64b5c384219d3699();
        const rotation = new $ee56638efea8544d$export$d93cc409a0768c5f();
        const quaternion = new $ee56638efea8544d$export$23d6a54f0bbc85a3();
        const scale = new $ee56638efea8544d$export$64b5c384219d3699(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            modelViewMatrix: {
                value: new $ee56638efea8544d$export$2ae72fc923e5eb5()
            },
            normalMatrix: {
                value: new $ee56638efea8544d$export$8ff26dafa08918()
            }
        });
        this.matrix = new $ee56638efea8544d$export$2ae72fc923e5eb5();
        this.matrixWorld = new $ee56638efea8544d$export$2ae72fc923e5eb5();
        this.matrixAutoUpdate = $ee56638efea8544d$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE;
        this.matrixWorldAutoUpdate = $ee56638efea8544d$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        this.matrixWorldNeedsUpdate = false;
        this.layers = new $ee56638efea8544d$export$89312ce47c0ca777();
        this.visible = true;
        this.castShadow = false;
        this.receiveShadow = false;
        this.frustumCulled = true;
        this.renderOrder = 0;
        this.animations = [];
        this.userData = {};
    }
    onBeforeShadow() {}
    onAfterShadow() {}
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        $ee56638efea8544d$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply($ee56638efea8544d$var$_q1);
        return this;
    }
    rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        $ee56638efea8544d$var$_q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply($ee56638efea8544d$var$_q1);
        return this;
    }
    rotateX(angle) {
        return this.rotateOnAxis($ee56638efea8544d$var$_xAxis, angle);
    }
    rotateY(angle) {
        return this.rotateOnAxis($ee56638efea8544d$var$_yAxis, angle);
    }
    rotateZ(angle) {
        return this.rotateOnAxis($ee56638efea8544d$var$_zAxis, angle);
    }
    translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        $ee56638efea8544d$var$_v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add($ee56638efea8544d$var$_v1$4.multiplyScalar(distance));
        return this;
    }
    translateX(distance) {
        return this.translateOnAxis($ee56638efea8544d$var$_xAxis, distance);
    }
    translateY(distance) {
        return this.translateOnAxis($ee56638efea8544d$var$_yAxis, distance);
    }
    translateZ(distance) {
        return this.translateOnAxis($ee56638efea8544d$var$_zAxis, distance);
    }
    localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4($ee56638efea8544d$var$_m1$1.copy(this.matrixWorld).invert());
    }
    lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) $ee56638efea8544d$var$_target.copy(x);
        else $ee56638efea8544d$var$_target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        $ee56638efea8544d$var$_position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) $ee56638efea8544d$var$_m1$1.lookAt($ee56638efea8544d$var$_position$3, $ee56638efea8544d$var$_target, this.up);
        else $ee56638efea8544d$var$_m1$1.lookAt($ee56638efea8544d$var$_target, $ee56638efea8544d$var$_position$3, this.up);
        this.quaternion.setFromRotationMatrix($ee56638efea8544d$var$_m1$1);
        if (parent) {
            $ee56638efea8544d$var$_m1$1.extractRotation(parent.matrixWorld);
            $ee56638efea8544d$var$_q1.setFromRotationMatrix($ee56638efea8544d$var$_m1$1);
            this.quaternion.premultiply($ee56638efea8544d$var$_q1.invert());
        }
    }
    add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            object.removeFromParent();
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent($ee56638efea8544d$var$_addedEvent);
            $ee56638efea8544d$var$_childaddedEvent.child = object;
            this.dispatchEvent($ee56638efea8544d$var$_childaddedEvent);
            $ee56638efea8544d$var$_childaddedEvent.child = null;
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent($ee56638efea8544d$var$_removedEvent);
            $ee56638efea8544d$var$_childremovedEvent.child = object;
            this.dispatchEvent($ee56638efea8544d$var$_childremovedEvent);
            $ee56638efea8544d$var$_childremovedEvent.child = null;
        }
        return this;
    }
    removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    clear() {
        return this.remove(...this.children);
    }
    attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        $ee56638efea8544d$var$_m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            $ee56638efea8544d$var$_m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4($ee56638efea8544d$var$_m1$1);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent($ee56638efea8544d$var$_addedEvent);
        $ee56638efea8544d$var$_childaddedEvent.child = object;
        this.dispatchEvent($ee56638efea8544d$var$_childaddedEvent);
        $ee56638efea8544d$var$_childaddedEvent.child = null;
        return this;
    }
    getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
        return result;
    }
    getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($ee56638efea8544d$var$_position$3, target, $ee56638efea8544d$var$_scale$2);
        return target;
    }
    getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose($ee56638efea8544d$var$_position$3, $ee56638efea8544d$var$_quaternion$2, target);
        return target;
    }
    getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.matrixWorldAutoUpdate === true) {
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // make sure descendants are updated if required
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            child.updateMatrixWorld(force);
        }
    }
    updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
        // make sure descendants are updated
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                child.updateWorldMatrix(false, true);
            }
        }
    }
    toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.6,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
            object.type = 'BatchedMesh';
            object.perObjectFrustumCulled = this.perObjectFrustumCulled;
            object.sortObjects = this.sortObjects;
            object.drawRanges = this._drawRanges;
            object.reservedRanges = this._reservedRanges;
            object.visibility = this._visibility;
            object.active = this._active;
            object.bounds = this._bounds.map((bound)=>({
                    boxInitialized: bound.boxInitialized,
                    boxMin: bound.box.min.toArray(),
                    boxMax: bound.box.max.toArray(),
                    sphereInitialized: bound.sphereInitialized,
                    sphereRadius: bound.sphere.radius,
                    sphereCenter: bound.sphere.center.toArray()
                }));
            object.maxInstanceCount = this._maxInstanceCount;
            object.maxVertexCount = this._maxVertexCount;
            object.maxIndexCount = this._maxIndexCount;
            object.geometryInitialized = this._geometryInitialized;
            object.geometryCount = this._geometryCount;
            object.matricesTexture = this._matricesTexture.toJSON(meta);
            if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
            if (this.boundingSphere !== null) object.boundingSphere = {
                center: object.boundingSphere.center.toArray(),
                radius: object.boundingSphere.radius
            };
            if (this.boundingBox !== null) object.boundingBox = {
                min: object.boundingBox.min.toArray(),
                max: object.boundingBox.max.toArray()
            };
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
$ee56638efea8544d$export$e4dd07dff30cc924.DEFAULT_UP = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699(0, 1, 0);
$ee56638efea8544d$export$e4dd07dff30cc924.DEFAULT_MATRIX_AUTO_UPDATE = true;
$ee56638efea8544d$export$e4dd07dff30cc924.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const $ee56638efea8544d$var$_v0$1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_v1$3 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_v2$2 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_v3$2 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_vab = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_vac = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_vbc = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_vap = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_vbp = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_vcp = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_v40 = /*@__PURE__*/ new $ee56638efea8544d$export$fa7daccca11cdbe3();
const $ee56638efea8544d$var$_v41 = /*@__PURE__*/ new $ee56638efea8544d$export$fa7daccca11cdbe3();
const $ee56638efea8544d$var$_v42 = /*@__PURE__*/ new $ee56638efea8544d$export$fa7daccca11cdbe3();
class $ee56638efea8544d$export$5a465592bfe74b48 {
    constructor(a = new $ee56638efea8544d$export$64b5c384219d3699(), b = new $ee56638efea8544d$export$64b5c384219d3699(), c = new $ee56638efea8544d$export$64b5c384219d3699()){
        this.a = a;
        this.b = b;
        this.c = c;
    }
    static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        $ee56638efea8544d$var$_v0$1.subVectors(a, b);
        target.cross($ee56638efea8544d$var$_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        $ee56638efea8544d$var$_v0$1.subVectors(c, a);
        $ee56638efea8544d$var$_v1$3.subVectors(b, a);
        $ee56638efea8544d$var$_v2$2.subVectors(point, a);
        const dot00 = $ee56638efea8544d$var$_v0$1.dot($ee56638efea8544d$var$_v0$1);
        const dot01 = $ee56638efea8544d$var$_v0$1.dot($ee56638efea8544d$var$_v1$3);
        const dot02 = $ee56638efea8544d$var$_v0$1.dot($ee56638efea8544d$var$_v2$2);
        const dot11 = $ee56638efea8544d$var$_v1$3.dot($ee56638efea8544d$var$_v1$3);
        const dot12 = $ee56638efea8544d$var$_v1$3.dot($ee56638efea8544d$var$_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) {
            target.set(0, 0, 0);
            return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        // if the triangle is degenerate then we can't contain a point
        if (this.getBarycoord(point, a, b, c, $ee56638efea8544d$var$_v3$2) === null) return false;
        return $ee56638efea8544d$var$_v3$2.x >= 0 && $ee56638efea8544d$var$_v3$2.y >= 0 && $ee56638efea8544d$var$_v3$2.x + $ee56638efea8544d$var$_v3$2.y <= 1;
    }
    static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, $ee56638efea8544d$var$_v3$2) === null) {
            target.x = 0;
            target.y = 0;
            if ('z' in target) target.z = 0;
            if ('w' in target) target.w = 0;
            return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, $ee56638efea8544d$var$_v3$2.x);
        target.addScaledVector(v2, $ee56638efea8544d$var$_v3$2.y);
        target.addScaledVector(v3, $ee56638efea8544d$var$_v3$2.z);
        return target;
    }
    static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
        $ee56638efea8544d$var$_v40.setScalar(0);
        $ee56638efea8544d$var$_v41.setScalar(0);
        $ee56638efea8544d$var$_v42.setScalar(0);
        $ee56638efea8544d$var$_v40.fromBufferAttribute(attr, i1);
        $ee56638efea8544d$var$_v41.fromBufferAttribute(attr, i2);
        $ee56638efea8544d$var$_v42.fromBufferAttribute(attr, i3);
        target.setScalar(0);
        target.addScaledVector($ee56638efea8544d$var$_v40, barycoord.x);
        target.addScaledVector($ee56638efea8544d$var$_v41, barycoord.y);
        target.addScaledVector($ee56638efea8544d$var$_v42, barycoord.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        $ee56638efea8544d$var$_v0$1.subVectors(c, b);
        $ee56638efea8544d$var$_v1$3.subVectors(a, b);
        // strictly front facing
        return $ee56638efea8544d$var$_v0$1.cross($ee56638efea8544d$var$_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        $ee56638efea8544d$var$_v0$1.subVectors(this.c, this.b);
        $ee56638efea8544d$var$_v1$3.subVectors(this.a, this.b);
        return $ee56638efea8544d$var$_v0$1.cross($ee56638efea8544d$var$_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return $ee56638efea8544d$export$5a465592bfe74b48.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return $ee56638efea8544d$export$5a465592bfe74b48.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getInterpolation(point, v1, v2, v3, target) {
        return $ee56638efea8544d$export$5a465592bfe74b48.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    containsPoint(point) {
        return $ee56638efea8544d$export$5a465592bfe74b48.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return $ee56638efea8544d$export$5a465592bfe74b48.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        $ee56638efea8544d$var$_vab.subVectors(b, a);
        $ee56638efea8544d$var$_vac.subVectors(c, a);
        $ee56638efea8544d$var$_vap.subVectors(p, a);
        const d1 = $ee56638efea8544d$var$_vab.dot($ee56638efea8544d$var$_vap);
        const d2 = $ee56638efea8544d$var$_vac.dot($ee56638efea8544d$var$_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        $ee56638efea8544d$var$_vbp.subVectors(p, b);
        const d3 = $ee56638efea8544d$var$_vab.dot($ee56638efea8544d$var$_vbp);
        const d4 = $ee56638efea8544d$var$_vac.dot($ee56638efea8544d$var$_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector($ee56638efea8544d$var$_vab, v);
        }
        $ee56638efea8544d$var$_vcp.subVectors(p, c);
        const d5 = $ee56638efea8544d$var$_vab.dot($ee56638efea8544d$var$_vcp);
        const d6 = $ee56638efea8544d$var$_vac.dot($ee56638efea8544d$var$_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector($ee56638efea8544d$var$_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            $ee56638efea8544d$var$_vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector($ee56638efea8544d$var$_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector($ee56638efea8544d$var$_vab, v).addScaledVector($ee56638efea8544d$var$_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
const $ee56638efea8544d$var$_colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const $ee56638efea8544d$var$_hslA = {
    h: 0,
    s: 0,
    l: 0
};
const $ee56638efea8544d$var$_hslB = {
    h: 0,
    s: 0,
    l: 0
};
function $ee56638efea8544d$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
class $ee56638efea8544d$export$892596cec99bc70e {
    constructor(r, g, b){
        this.isColor = true;
        this.r = 1;
        this.g = 1;
        this.b = 1;
        return this.set(r, g, b);
    }
    set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex, colorSpace = $ee56638efea8544d$export$561f394b24edfcaa) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        $ee56638efea8544d$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
        return this;
    }
    setRGB(r, g, b, colorSpace = $ee56638efea8544d$export$5e6fd513f44698c.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        $ee56638efea8544d$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
        return this;
    }
    setHSL(h, s, l, colorSpace = $ee56638efea8544d$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = $ee56638efea8544d$var$euclideanModulo(h, 1);
        s = $ee56638efea8544d$var$clamp(s, 0, 1);
        l = $ee56638efea8544d$var$clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = $ee56638efea8544d$var$hue2rgb(q, p, h + 1 / 3);
            this.g = $ee56638efea8544d$var$hue2rgb(q, p, h);
            this.b = $ee56638efea8544d$var$hue2rgb(q, p, h - 1 / 3);
        }
        $ee56638efea8544d$export$5e6fd513f44698c.toWorkingColorSpace(this, colorSpace);
        return this;
    }
    setStyle(style, colorSpace = $ee56638efea8544d$export$561f394b24edfcaa) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace);
                    }
                    break;
                default:
                    console.warn('THREE.Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace);
            else console.warn('THREE.Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace);
        return this;
    }
    setColorName(style, colorSpace = $ee56638efea8544d$export$561f394b24edfcaa) {
        // color keywords
        const hex = $ee56638efea8544d$var$_colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copySRGBToLinear(color) {
        this.r = $ee56638efea8544d$var$SRGBToLinear(color.r);
        this.g = $ee56638efea8544d$var$SRGBToLinear(color.g);
        this.b = $ee56638efea8544d$var$SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = $ee56638efea8544d$var$LinearToSRGB(color.r);
        this.g = $ee56638efea8544d$var$LinearToSRGB(color.g);
        this.b = $ee56638efea8544d$var$LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex(colorSpace = $ee56638efea8544d$export$561f394b24edfcaa) {
        $ee56638efea8544d$export$5e6fd513f44698c.fromWorkingColorSpace($ee56638efea8544d$var$_color.copy(this), colorSpace);
        return Math.round($ee56638efea8544d$var$clamp($ee56638efea8544d$var$_color.r * 255, 0, 255)) * 65536 + Math.round($ee56638efea8544d$var$clamp($ee56638efea8544d$var$_color.g * 255, 0, 255)) * 256 + Math.round($ee56638efea8544d$var$clamp($ee56638efea8544d$var$_color.b * 255, 0, 255));
    }
    getHexString(colorSpace = $ee56638efea8544d$export$561f394b24edfcaa) {
        return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
    }
    getHSL(target, colorSpace = $ee56638efea8544d$export$5e6fd513f44698c.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        $ee56638efea8544d$export$5e6fd513f44698c.fromWorkingColorSpace($ee56638efea8544d$var$_color.copy(this), colorSpace);
        const r = $ee56638efea8544d$var$_color.r, g = $ee56638efea8544d$var$_color.g, b = $ee56638efea8544d$var$_color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getRGB(target, colorSpace = $ee56638efea8544d$export$5e6fd513f44698c.workingColorSpace) {
        $ee56638efea8544d$export$5e6fd513f44698c.fromWorkingColorSpace($ee56638efea8544d$var$_color.copy(this), colorSpace);
        target.r = $ee56638efea8544d$var$_color.r;
        target.g = $ee56638efea8544d$var$_color.g;
        target.b = $ee56638efea8544d$var$_color.b;
        return target;
    }
    getStyle(colorSpace = $ee56638efea8544d$export$561f394b24edfcaa) {
        $ee56638efea8544d$export$5e6fd513f44698c.fromWorkingColorSpace($ee56638efea8544d$var$_color.copy(this), colorSpace);
        const r = $ee56638efea8544d$var$_color.r, g = $ee56638efea8544d$var$_color.g, b = $ee56638efea8544d$var$_color.b;
        if (colorSpace !== $ee56638efea8544d$export$561f394b24edfcaa) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    offsetHSL(h, s, l) {
        this.getHSL($ee56638efea8544d$var$_hslA);
        return this.setHSL($ee56638efea8544d$var$_hslA.h + h, $ee56638efea8544d$var$_hslA.s + s, $ee56638efea8544d$var$_hslA.l + l);
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL($ee56638efea8544d$var$_hslA);
        color.getHSL($ee56638efea8544d$var$_hslB);
        const h = $ee56638efea8544d$var$lerp($ee56638efea8544d$var$_hslA.h, $ee56638efea8544d$var$_hslB.h, alpha);
        const s = $ee56638efea8544d$var$lerp($ee56638efea8544d$var$_hslA.s, $ee56638efea8544d$var$_hslB.s, alpha);
        const l = $ee56638efea8544d$var$lerp($ee56638efea8544d$var$_hslA.l, $ee56638efea8544d$var$_hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const $ee56638efea8544d$var$_color = /*@__PURE__*/ new $ee56638efea8544d$export$892596cec99bc70e();
$ee56638efea8544d$export$892596cec99bc70e.NAMES = $ee56638efea8544d$var$_colorKeywords;
let $ee56638efea8544d$var$_materialId = 0;
class $ee56638efea8544d$export$a2d8b23205c25948 extends $ee56638efea8544d$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isMaterial = true;
        Object.defineProperty(this, 'id', {
            value: $ee56638efea8544d$var$_materialId++
        });
        this.uuid = $ee56638efea8544d$var$generateUUID();
        this.name = '';
        this.type = 'Material';
        this.blending = $ee56638efea8544d$export$5b29a26d96ee6af0;
        this.side = $ee56638efea8544d$export$2ede184fc2998901;
        this.vertexColors = false;
        this.opacity = 1;
        this.transparent = false;
        this.alphaHash = false;
        this.blendSrc = $ee56638efea8544d$export$d5773124e86cf28c;
        this.blendDst = $ee56638efea8544d$export$11d468cc7f19e971;
        this.blendEquation = $ee56638efea8544d$export$20183a0484ce21a0;
        this.blendSrcAlpha = null;
        this.blendDstAlpha = null;
        this.blendEquationAlpha = null;
        this.blendColor = new $ee56638efea8544d$export$892596cec99bc70e(0, 0, 0);
        this.blendAlpha = 0;
        this.depthFunc = $ee56638efea8544d$export$296f78a0b892f81a;
        this.depthTest = true;
        this.depthWrite = true;
        this.stencilWriteMask = 0xff;
        this.stencilFunc = $ee56638efea8544d$export$14cf96713ddd97a8;
        this.stencilRef = 0;
        this.stencilFuncMask = 0xff;
        this.stencilFail = $ee56638efea8544d$export$9f542ae4b5baca34;
        this.stencilZFail = $ee56638efea8544d$export$9f542ae4b5baca34;
        this.stencilZPass = $ee56638efea8544d$export$9f542ae4b5baca34;
        this.stencilWrite = false;
        this.clippingPlanes = null;
        this.clipIntersection = false;
        this.clipShadows = false;
        this.shadowSide = null;
        this.colorWrite = true;
        this.precision = null; // override the renderer's default precision for this material
        this.polygonOffset = false;
        this.polygonOffsetFactor = 0;
        this.polygonOffsetUnits = 0;
        this.dithering = false;
        this.alphaToCoverage = false;
        this.premultipliedAlpha = false;
        this.forceSinglePass = false;
        this.visible = true;
        this.toneMapped = true;
        this.userData = {};
        this.version = 0;
        this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    // onBeforeRender and onBeforeCompile only supported in WebGLRenderer
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn(`THREE.Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn(`THREE.Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.6,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.dispersion !== undefined) data.dispersion = this.dispersion;
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== $ee56638efea8544d$export$5b29a26d96ee6af0) data.blending = this.blending;
        if (this.side !== $ee56638efea8544d$export$2ede184fc2998901) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== $ee56638efea8544d$export$d5773124e86cf28c) data.blendSrc = this.blendSrc;
        if (this.blendDst !== $ee56638efea8544d$export$11d468cc7f19e971) data.blendDst = this.blendDst;
        if (this.blendEquation !== $ee56638efea8544d$export$20183a0484ce21a0) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== $ee56638efea8544d$export$296f78a0b892f81a) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== $ee56638efea8544d$export$14cf96713ddd97a8) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== $ee56638efea8544d$export$9f542ae4b5baca34) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== $ee56638efea8544d$export$9f542ae4b5baca34) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== $ee56638efea8544d$export$9f542ae4b5baca34) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    onBuild() {
        console.warn('Material: onBuild() has been removed.'); // @deprecated, r166
    }
}
class $ee56638efea8544d$export$55cbcc9b622fe1f5 extends $ee56638efea8544d$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        this.color = new $ee56638efea8544d$export$892596cec99bc70e(0xffffff); // emissive
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $ee56638efea8544d$export$d93cc409a0768c5f();
        this.combine = $ee56638efea8544d$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const $ee56638efea8544d$var$_tables = /*@__PURE__*/ $ee56638efea8544d$var$_generateTables();
function $ee56638efea8544d$var$_generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
// float32 to float16
function $ee56638efea8544d$var$toHalfFloat(val) {
    if (Math.abs(val) > 65504) console.warn('THREE.DataUtils.toHalfFloat(): Value out of range.');
    val = $ee56638efea8544d$var$clamp(val, -65504, 65504);
    $ee56638efea8544d$var$_tables.floatView[0] = val;
    const f = $ee56638efea8544d$var$_tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return $ee56638efea8544d$var$_tables.baseTable[e] + ((f & 0x007fffff) >> $ee56638efea8544d$var$_tables.shiftTable[e]);
}
// float16 to float32
function $ee56638efea8544d$var$fromHalfFloat(val) {
    const m = val >> 10;
    $ee56638efea8544d$var$_tables.uint32View[0] = $ee56638efea8544d$var$_tables.mantissaTable[$ee56638efea8544d$var$_tables.offsetTable[m] + (val & 0x3ff)] + $ee56638efea8544d$var$_tables.exponentTable[m];
    return $ee56638efea8544d$var$_tables.floatView[0];
}
const $ee56638efea8544d$export$11ce8b759162cc80 = {
    toHalfFloat: $ee56638efea8544d$var$toHalfFloat,
    fromHalfFloat: $ee56638efea8544d$var$fromHalfFloat
};
const $ee56638efea8544d$var$_vector$9 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_vector2$1 = /*@__PURE__*/ new $ee56638efea8544d$export$c977b3e384af9ae1();
class $ee56638efea8544d$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        this.isBufferAttribute = true;
        this.name = '';
        this.array = array;
        this.itemSize = itemSize;
        this.count = array !== undefined ? array.length / itemSize : 0;
        this.normalized = normalized;
        this.usage = $ee56638efea8544d$export$763e8360f4d7f77d;
        this.updateRanges = [];
        this.gpuType = $ee56638efea8544d$export$f6d331659b644596;
        this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    copyArray(array) {
        this.array.set(array);
        return this;
    }
    applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            $ee56638efea8544d$var$_vector2$1.fromBufferAttribute(this, i);
            $ee56638efea8544d$var$_vector2$1.applyMatrix3(m);
            this.setXY(i, $ee56638efea8544d$var$_vector2$1.x, $ee56638efea8544d$var$_vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            $ee56638efea8544d$var$_vector$9.fromBufferAttribute(this, i);
            $ee56638efea8544d$var$_vector$9.applyMatrix3(m);
            this.setXYZ(i, $ee56638efea8544d$var$_vector$9.x, $ee56638efea8544d$var$_vector$9.y, $ee56638efea8544d$var$_vector$9.z);
        }
        return this;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $ee56638efea8544d$var$_vector$9.fromBufferAttribute(this, i);
            $ee56638efea8544d$var$_vector$9.applyMatrix4(m);
            this.setXYZ(i, $ee56638efea8544d$var$_vector$9.x, $ee56638efea8544d$var$_vector$9.y, $ee56638efea8544d$var$_vector$9.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $ee56638efea8544d$var$_vector$9.fromBufferAttribute(this, i);
            $ee56638efea8544d$var$_vector$9.applyNormalMatrix(m);
            this.setXYZ(i, $ee56638efea8544d$var$_vector$9.x, $ee56638efea8544d$var$_vector$9.y, $ee56638efea8544d$var$_vector$9.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $ee56638efea8544d$var$_vector$9.fromBufferAttribute(this, i);
            $ee56638efea8544d$var$_vector$9.transformDirection(m);
            this.setXYZ(i, $ee56638efea8544d$var$_vector$9.x, $ee56638efea8544d$var$_vector$9.y, $ee56638efea8544d$var$_vector$9.z);
        }
        return this;
    }
    set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = $ee56638efea8544d$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $ee56638efea8544d$var$normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = $ee56638efea8544d$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $ee56638efea8544d$var$normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = $ee56638efea8544d$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $ee56638efea8544d$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = $ee56638efea8544d$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $ee56638efea8544d$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = $ee56638efea8544d$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $ee56638efea8544d$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $ee56638efea8544d$var$normalize(x, this.array);
            y = $ee56638efea8544d$var$normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $ee56638efea8544d$var$normalize(x, this.array);
            y = $ee56638efea8544d$var$normalize(y, this.array);
            z = $ee56638efea8544d$var$normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $ee56638efea8544d$var$normalize(x, this.array);
            y = $ee56638efea8544d$var$normalize(y, this.array);
            z = $ee56638efea8544d$var$normalize(z, this.array);
            w = $ee56638efea8544d$var$normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== $ee56638efea8544d$export$763e8360f4d7f77d) data.usage = this.usage;
        return data;
    }
}
//
class $ee56638efea8544d$export$f9ff2d6a20248cbf extends $ee56638efea8544d$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
class $ee56638efea8544d$export$cacc90cf35d11cdd extends $ee56638efea8544d$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
class $ee56638efea8544d$export$baaa85a1a812c157 extends $ee56638efea8544d$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
class $ee56638efea8544d$export$2b755a102ccdcefe extends $ee56638efea8544d$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
class $ee56638efea8544d$export$640a853f68025f2e extends $ee56638efea8544d$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
class $ee56638efea8544d$export$46b369aed2968a0a extends $ee56638efea8544d$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
class $ee56638efea8544d$export$7eb8c9fa25cd5bd6 extends $ee56638efea8544d$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
class $ee56638efea8544d$export$dbd3698c64958d69 extends $ee56638efea8544d$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = $ee56638efea8544d$var$fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = $ee56638efea8544d$var$denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = $ee56638efea8544d$var$normalize(x, this.array);
        this.array[index * this.itemSize] = $ee56638efea8544d$var$toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = $ee56638efea8544d$var$fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = $ee56638efea8544d$var$denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = $ee56638efea8544d$var$normalize(y, this.array);
        this.array[index * this.itemSize + 1] = $ee56638efea8544d$var$toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = $ee56638efea8544d$var$fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = $ee56638efea8544d$var$denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = $ee56638efea8544d$var$normalize(z, this.array);
        this.array[index * this.itemSize + 2] = $ee56638efea8544d$var$toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = $ee56638efea8544d$var$fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = $ee56638efea8544d$var$denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = $ee56638efea8544d$var$normalize(w, this.array);
        this.array[index * this.itemSize + 3] = $ee56638efea8544d$var$toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $ee56638efea8544d$var$normalize(x, this.array);
            y = $ee56638efea8544d$var$normalize(y, this.array);
        }
        this.array[index + 0] = $ee56638efea8544d$var$toHalfFloat(x);
        this.array[index + 1] = $ee56638efea8544d$var$toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $ee56638efea8544d$var$normalize(x, this.array);
            y = $ee56638efea8544d$var$normalize(y, this.array);
            z = $ee56638efea8544d$var$normalize(z, this.array);
        }
        this.array[index + 0] = $ee56638efea8544d$var$toHalfFloat(x);
        this.array[index + 1] = $ee56638efea8544d$var$toHalfFloat(y);
        this.array[index + 2] = $ee56638efea8544d$var$toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = $ee56638efea8544d$var$normalize(x, this.array);
            y = $ee56638efea8544d$var$normalize(y, this.array);
            z = $ee56638efea8544d$var$normalize(z, this.array);
            w = $ee56638efea8544d$var$normalize(w, this.array);
        }
        this.array[index + 0] = $ee56638efea8544d$var$toHalfFloat(x);
        this.array[index + 1] = $ee56638efea8544d$var$toHalfFloat(y);
        this.array[index + 2] = $ee56638efea8544d$var$toHalfFloat(z);
        this.array[index + 3] = $ee56638efea8544d$var$toHalfFloat(w);
        return this;
    }
}
class $ee56638efea8544d$export$cbe7a62641830ebd extends $ee56638efea8544d$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
let $ee56638efea8544d$var$_id$1 = 0;
const $ee56638efea8544d$var$_m1 = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_obj = /*@__PURE__*/ new $ee56638efea8544d$export$e4dd07dff30cc924();
const $ee56638efea8544d$var$_offset = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_box$2 = /*@__PURE__*/ new $ee56638efea8544d$export$6f7d5a9418ab2aa3();
const $ee56638efea8544d$var$_boxMorphTargets = /*@__PURE__*/ new $ee56638efea8544d$export$6f7d5a9418ab2aa3();
const $ee56638efea8544d$var$_vector$8 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$b7be63a67df8959 extends $ee56638efea8544d$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isBufferGeometry = true;
        Object.defineProperty(this, 'id', {
            value: $ee56638efea8544d$var$_id$1++
        });
        this.uuid = $ee56638efea8544d$var$generateUUID();
        this.name = '';
        this.type = 'BufferGeometry';
        this.index = null;
        this.indirect = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.morphTargetsRelative = false;
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        this.drawRange = {
            start: 0,
            count: Infinity
        };
        this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(index) {
        if (Array.isArray(index)) this.index = new ($ee56638efea8544d$export$bc6f937da07eae17(index) ? $ee56638efea8544d$export$7eb8c9fa25cd5bd6 : $ee56638efea8544d$export$640a853f68025f2e)(index, 1);
        else this.index = index;
        return this;
    }
    setIndirect(indirect) {
        this.indirect = indirect;
        return this;
    }
    getIndirect() {
        return this.indirect;
    }
    getAttribute(name) {
        return this.attributes[name];
    }
    setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new $ee56638efea8544d$export$8ff26dafa08918().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    applyQuaternion(q) {
        $ee56638efea8544d$var$_m1.makeRotationFromQuaternion(q);
        this.applyMatrix4($ee56638efea8544d$var$_m1);
        return this;
    }
    rotateX(angle) {
        // rotate geometry around world x-axis
        $ee56638efea8544d$var$_m1.makeRotationX(angle);
        this.applyMatrix4($ee56638efea8544d$var$_m1);
        return this;
    }
    rotateY(angle) {
        // rotate geometry around world y-axis
        $ee56638efea8544d$var$_m1.makeRotationY(angle);
        this.applyMatrix4($ee56638efea8544d$var$_m1);
        return this;
    }
    rotateZ(angle) {
        // rotate geometry around world z-axis
        $ee56638efea8544d$var$_m1.makeRotationZ(angle);
        this.applyMatrix4($ee56638efea8544d$var$_m1);
        return this;
    }
    translate(x, y, z) {
        // translate geometry
        $ee56638efea8544d$var$_m1.makeTranslation(x, y, z);
        this.applyMatrix4($ee56638efea8544d$var$_m1);
        return this;
    }
    scale(x, y, z) {
        // scale geometry
        $ee56638efea8544d$var$_m1.makeScale(x, y, z);
        this.applyMatrix4($ee56638efea8544d$var$_m1);
        return this;
    }
    lookAt(vector) {
        $ee56638efea8544d$var$_obj.lookAt(vector);
        $ee56638efea8544d$var$_obj.updateMatrix();
        this.applyMatrix4($ee56638efea8544d$var$_obj.matrix);
        return this;
    }
    center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter($ee56638efea8544d$var$_offset).negate();
        this.translate($ee56638efea8544d$var$_offset.x, $ee56638efea8544d$var$_offset.y, $ee56638efea8544d$var$_offset.z);
        return this;
    }
    setFromPoints(points) {
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute === undefined) {
            const position = [];
            for(let i = 0, l = points.length; i < l; i++){
                const point = points[i];
                position.push(point.x, point.y, point.z || 0);
            }
            this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(position, 3));
        } else {
            const l = Math.min(points.length, positionAttribute.count); // make sure data do not exceed buffer size
            for(let i = 0; i < l; i++){
                const point = points[i];
                positionAttribute.setXYZ(i, point.x, point.y, point.z || 0);
            }
            if (points.length > positionAttribute.count) console.warn('THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.');
            positionAttribute.needsUpdate = true;
        }
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $ee56638efea8544d$export$6f7d5a9418ab2aa3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this);
            this.boundingBox.set(new $ee56638efea8544d$export$64b5c384219d3699(-Infinity, -Infinity, -Infinity), new $ee56638efea8544d$export$64b5c384219d3699(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $ee56638efea8544d$var$_box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $ee56638efea8544d$var$_vector$8.addVectors(this.boundingBox.min, $ee56638efea8544d$var$_box$2.min);
                    this.boundingBox.expandByPoint($ee56638efea8544d$var$_vector$8);
                    $ee56638efea8544d$var$_vector$8.addVectors(this.boundingBox.max, $ee56638efea8544d$var$_box$2.max);
                    this.boundingBox.expandByPoint($ee56638efea8544d$var$_vector$8);
                } else {
                    this.boundingBox.expandByPoint($ee56638efea8544d$var$_box$2.min);
                    this.boundingBox.expandByPoint($ee56638efea8544d$var$_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $ee56638efea8544d$export$805e8b72413ccaba();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this);
            this.boundingSphere.set(new $ee56638efea8544d$export$64b5c384219d3699(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            $ee56638efea8544d$var$_box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                $ee56638efea8544d$var$_boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    $ee56638efea8544d$var$_vector$8.addVectors($ee56638efea8544d$var$_box$2.min, $ee56638efea8544d$var$_boxMorphTargets.min);
                    $ee56638efea8544d$var$_box$2.expandByPoint($ee56638efea8544d$var$_vector$8);
                    $ee56638efea8544d$var$_vector$8.addVectors($ee56638efea8544d$var$_box$2.max, $ee56638efea8544d$var$_boxMorphTargets.max);
                    $ee56638efea8544d$var$_box$2.expandByPoint($ee56638efea8544d$var$_vector$8);
                } else {
                    $ee56638efea8544d$var$_box$2.expandByPoint($ee56638efea8544d$var$_boxMorphTargets.min);
                    $ee56638efea8544d$var$_box$2.expandByPoint($ee56638efea8544d$var$_boxMorphTargets.max);
                }
            }
            $ee56638efea8544d$var$_box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                $ee56638efea8544d$var$_vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($ee56638efea8544d$var$_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    $ee56638efea8544d$var$_vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        $ee56638efea8544d$var$_offset.fromBufferAttribute(position, j);
                        $ee56638efea8544d$var$_vector$8.add($ee56638efea8544d$var$_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared($ee56638efea8544d$var$_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new $ee56638efea8544d$export$8dea267bd6bde117(new Float32Array(4 * positionAttribute.count), 4));
        const tangentAttribute = this.getAttribute('tangent');
        const tan1 = [], tan2 = [];
        for(let i = 0; i < positionAttribute.count; i++){
            tan1[i] = new $ee56638efea8544d$export$64b5c384219d3699();
            tan2[i] = new $ee56638efea8544d$export$64b5c384219d3699();
        }
        const vA = new $ee56638efea8544d$export$64b5c384219d3699(), vB = new $ee56638efea8544d$export$64b5c384219d3699(), vC = new $ee56638efea8544d$export$64b5c384219d3699(), uvA = new $ee56638efea8544d$export$c977b3e384af9ae1(), uvB = new $ee56638efea8544d$export$c977b3e384af9ae1(), uvC = new $ee56638efea8544d$export$c977b3e384af9ae1(), sdir = new $ee56638efea8544d$export$64b5c384219d3699(), tdir = new $ee56638efea8544d$export$64b5c384219d3699();
        function handleTriangle(a, b, c) {
            vA.fromBufferAttribute(positionAttribute, a);
            vB.fromBufferAttribute(positionAttribute, b);
            vC.fromBufferAttribute(positionAttribute, c);
            uvA.fromBufferAttribute(uvAttribute, a);
            uvB.fromBufferAttribute(uvAttribute, b);
            uvC.fromBufferAttribute(uvAttribute, c);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: index.count
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
        }
        const tmp = new $ee56638efea8544d$export$64b5c384219d3699(), tmp2 = new $ee56638efea8544d$export$64b5c384219d3699();
        const n = new $ee56638efea8544d$export$64b5c384219d3699(), n2 = new $ee56638efea8544d$export$64b5c384219d3699();
        function handleVertex(v) {
            n.fromBufferAttribute(normalAttribute, v);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(index.getX(j + 0));
                handleVertex(index.getX(j + 1));
                handleVertex(index.getX(j + 2));
            }
        }
    }
    computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new $ee56638efea8544d$export$8dea267bd6bde117(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new $ee56638efea8544d$export$64b5c384219d3699(), pB = new $ee56638efea8544d$export$64b5c384219d3699(), pC = new $ee56638efea8544d$export$64b5c384219d3699();
            const nA = new $ee56638efea8544d$export$64b5c384219d3699(), nB = new $ee56638efea8544d$export$64b5c384219d3699(), nC = new $ee56638efea8544d$export$64b5c384219d3699();
            const cb = new $ee56638efea8544d$export$64b5c384219d3699(), ab = new $ee56638efea8544d$export$64b5c384219d3699();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            $ee56638efea8544d$var$_vector$8.fromBufferAttribute(normals, i);
            $ee56638efea8544d$var$_vector$8.normalize();
            normals.setXYZ(i, $ee56638efea8544d$var$_vector$8.x, $ee56638efea8544d$var$_vector$8.y, $ee56638efea8544d$var$_vector$8.z);
        }
    }
    toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new $ee56638efea8544d$export$8dea267bd6bde117(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new $ee56638efea8544d$export$b7be63a67df8959();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const $ee56638efea8544d$var$_inverseMatrix$3 = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_ray$3 = /*@__PURE__*/ new $ee56638efea8544d$export$a186db52eed6d40e();
const $ee56638efea8544d$var$_sphere$6 = /*@__PURE__*/ new $ee56638efea8544d$export$805e8b72413ccaba();
const $ee56638efea8544d$var$_sphereHitAt = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_vA$1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_vB$1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_vC$1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_tempA = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_morphA = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_intersectionPoint = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_intersectionPointWorld = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$e176487c05830cc5 extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(geometry = new $ee56638efea8544d$export$b7be63a67df8959(), material = new $ee56638efea8544d$export$55cbcc9b622fe1f5()){
        super();
        this.isMesh = true;
        this.type = 'Mesh';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            $ee56638efea8544d$var$_morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                $ee56638efea8544d$var$_tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) $ee56638efea8544d$var$_morphA.addScaledVector($ee56638efea8544d$var$_tempA, influence);
                else $ee56638efea8544d$var$_morphA.addScaledVector($ee56638efea8544d$var$_tempA.sub(target), influence);
            }
            target.add($ee56638efea8544d$var$_morphA);
        }
        return target;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $ee56638efea8544d$var$_sphere$6.copy(geometry.boundingSphere);
        $ee56638efea8544d$var$_sphere$6.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        $ee56638efea8544d$var$_ray$3.copy(raycaster.ray).recast(raycaster.near);
        if ($ee56638efea8544d$var$_sphere$6.containsPoint($ee56638efea8544d$var$_ray$3.origin) === false) {
            if ($ee56638efea8544d$var$_ray$3.intersectSphere($ee56638efea8544d$var$_sphere$6, $ee56638efea8544d$var$_sphereHitAt) === null) return;
            if ($ee56638efea8544d$var$_ray$3.origin.distanceToSquared($ee56638efea8544d$var$_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        $ee56638efea8544d$var$_inverseMatrix$3.copy(matrixWorld).invert();
        $ee56638efea8544d$var$_ray$3.copy(raycaster.ray).applyMatrix4($ee56638efea8544d$var$_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if ($ee56638efea8544d$var$_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $ee56638efea8544d$var$_ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = $ee56638efea8544d$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = $ee56638efea8544d$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = $ee56638efea8544d$var$checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = $ee56638efea8544d$var$checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function $ee56638efea8544d$var$checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === $ee56638efea8544d$export$d9f0486e75b5ace) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === $ee56638efea8544d$export$2ede184fc2998901, point);
    if (intersect === null) return null;
    $ee56638efea8544d$var$_intersectionPointWorld.copy(point);
    $ee56638efea8544d$var$_intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo($ee56638efea8544d$var$_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: $ee56638efea8544d$var$_intersectionPointWorld.clone(),
        object: object
    };
}
function $ee56638efea8544d$var$checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, $ee56638efea8544d$var$_vA$1);
    object.getVertexPosition(b, $ee56638efea8544d$var$_vB$1);
    object.getVertexPosition(c, $ee56638efea8544d$var$_vC$1);
    const intersection = $ee56638efea8544d$var$checkIntersection$1(object, material, raycaster, ray, $ee56638efea8544d$var$_vA$1, $ee56638efea8544d$var$_vB$1, $ee56638efea8544d$var$_vC$1, $ee56638efea8544d$var$_intersectionPoint);
    if (intersection) {
        const barycoord = new $ee56638efea8544d$export$64b5c384219d3699();
        $ee56638efea8544d$export$5a465592bfe74b48.getBarycoord($ee56638efea8544d$var$_intersectionPoint, $ee56638efea8544d$var$_vA$1, $ee56638efea8544d$var$_vB$1, $ee56638efea8544d$var$_vC$1, barycoord);
        if (uv) intersection.uv = $ee56638efea8544d$export$5a465592bfe74b48.getInterpolatedAttribute(uv, a, b, c, barycoord, new $ee56638efea8544d$export$c977b3e384af9ae1());
        if (uv1) intersection.uv1 = $ee56638efea8544d$export$5a465592bfe74b48.getInterpolatedAttribute(uv1, a, b, c, barycoord, new $ee56638efea8544d$export$c977b3e384af9ae1());
        if (normal) {
            intersection.normal = $ee56638efea8544d$export$5a465592bfe74b48.getInterpolatedAttribute(normal, a, b, c, barycoord, new $ee56638efea8544d$export$64b5c384219d3699());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new $ee56638efea8544d$export$64b5c384219d3699(),
            materialIndex: 0
        };
        $ee56638efea8544d$export$5a465592bfe74b48.getNormal($ee56638efea8544d$var$_vA$1, $ee56638efea8544d$var$_vB$1, $ee56638efea8544d$var$_vC$1, face.normal);
        intersection.face = face;
        intersection.barycoord = barycoord;
    }
    return intersection;
}
class $ee56638efea8544d$export$33e43285f7406bd5 extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ee56638efea8544d$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ee56638efea8544d$export$cbe7a62641830ebd(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new $ee56638efea8544d$export$64b5c384219d3699();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$33e43285f7406bd5(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Uniform Utilities
 */ function $ee56638efea8544d$export$acda854380553452(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    console.warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function $ee56638efea8544d$export$8916ce6879271f43(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = $ee56638efea8544d$export$acda854380553452(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function $ee56638efea8544d$var$cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function $ee56638efea8544d$export$a630742c640528c1(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return $ee56638efea8544d$export$5e6fd513f44698c.workingColorSpace;
}
// Legacy
const $ee56638efea8544d$export$d8ecdf8615bfea69 = {
    clone: $ee56638efea8544d$export$acda854380553452,
    merge: $ee56638efea8544d$export$8916ce6879271f43
};
var $ee56638efea8544d$var$default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var $ee56638efea8544d$var$default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
class $ee56638efea8544d$export$83c7d75d550a8b0d extends $ee56638efea8544d$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        this.defines = {};
        this.uniforms = {};
        this.uniformsGroups = [];
        this.vertexShader = $ee56638efea8544d$var$default_vertex;
        this.fragmentShader = $ee56638efea8544d$var$default_fragment;
        this.linewidth = 1;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.fog = false; // set to use scene fog
        this.lights = false; // set to use scene lights
        this.clipping = false; // set to use user-defined clipping planes
        this.forceSinglePass = true;
        this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        // When rendered geometry doesn't include these attributes but the material does,
        // use these default values in WebGL. This avoids errors when buffer data is missing.
        this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        this.index0AttributeName = undefined;
        this.uniformsNeedUpdate = false;
        this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = $ee56638efea8544d$export$acda854380553452(source.uniforms);
        this.uniformsGroups = $ee56638efea8544d$var$cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
class $ee56638efea8544d$export$79f141de891a5fed extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isCamera = true;
        this.type = 'Camera';
        this.matrixWorldInverse = new $ee56638efea8544d$export$2ae72fc923e5eb5();
        this.projectionMatrix = new $ee56638efea8544d$export$2ae72fc923e5eb5();
        this.projectionMatrixInverse = new $ee56638efea8544d$export$2ae72fc923e5eb5();
        this.coordinateSystem = $ee56638efea8544d$export$5a0e9190d10875d3;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $ee56638efea8544d$var$_v3$1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_minTarget = /*@__PURE__*/ new $ee56638efea8544d$export$c977b3e384af9ae1();
const $ee56638efea8544d$var$_maxTarget = /*@__PURE__*/ new $ee56638efea8544d$export$c977b3e384af9ae1();
class $ee56638efea8544d$export$74e4ae24825f68d7 extends $ee56638efea8544d$export$79f141de891a5fed {
    constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        this.fov = fov;
        this.zoom = 1;
        this.near = near;
        this.far = far;
        this.focus = 10;
        this.aspect = aspect;
        this.view = null;
        this.filmGauge = 35; // width of the film (default in millimeters)
        this.filmOffset = 0; // horizontal film offset (same unit as gauge)
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = $ee56638efea8544d$export$914076c8150813e5 * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 *
	 * @returns {number}
	 */ getFocalLength() {
        const vExtentSlope = Math.tan($ee56638efea8544d$var$DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    getEffectiveFOV() {
        return $ee56638efea8544d$export$914076c8150813e5 * 2 * Math.atan(Math.tan($ee56638efea8544d$var$DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets minTarget and maxTarget to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 *
	 * @param {number} distance
	 * @param {Vector2} minTarget
	 * @param {Vector2} maxTarget
	 */ getViewBounds(distance, minTarget, maxTarget) {
        $ee56638efea8544d$var$_v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set($ee56638efea8544d$var$_v3$1.x, $ee56638efea8544d$var$_v3$1.y).multiplyScalar(-distance / $ee56638efea8544d$var$_v3$1.z);
        $ee56638efea8544d$var$_v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set($ee56638efea8544d$var$_v3$1.x, $ee56638efea8544d$var$_v3$1.y).multiplyScalar(-distance / $ee56638efea8544d$var$_v3$1.z);
    }
    /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 *
	 * @param {number} distance
	 * @param {Vector2} target - Vector2 target used to store result where x is width and y is height.
	 * @returns {Vector2}
	 */ getViewSize(distance, target) {
        this.getViewBounds(distance, $ee56638efea8544d$var$_minTarget, $ee56638efea8544d$var$_maxTarget);
        return target.subVectors($ee56638efea8544d$var$_maxTarget, $ee56638efea8544d$var$_minTarget);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 *
	 * @param {number} fullWidth
	 * @param {number} fullHeight
	 * @param {number} x
	 * @param {number} y
	 * @param {number} width
	 * @param {number} height
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan($ee56638efea8544d$var$DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const $ee56638efea8544d$var$fov = -90; // negative fov is not an error
const $ee56638efea8544d$var$aspect = 1;
class $ee56638efea8544d$export$d0cdd0bd804995de extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        this.renderTarget = renderTarget;
        this.coordinateSystem = null;
        this.activeMipmapLevel = 0;
        const cameraPX = new $ee56638efea8544d$export$74e4ae24825f68d7($ee56638efea8544d$var$fov, $ee56638efea8544d$var$aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new $ee56638efea8544d$export$74e4ae24825f68d7($ee56638efea8544d$var$fov, $ee56638efea8544d$var$aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new $ee56638efea8544d$export$74e4ae24825f68d7($ee56638efea8544d$var$fov, $ee56638efea8544d$var$aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new $ee56638efea8544d$export$74e4ae24825f68d7($ee56638efea8544d$var$fov, $ee56638efea8544d$var$aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new $ee56638efea8544d$export$74e4ae24825f68d7($ee56638efea8544d$var$fov, $ee56638efea8544d$var$aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new $ee56638efea8544d$export$74e4ae24825f68d7($ee56638efea8544d$var$fov, $ee56638efea8544d$var$aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === $ee56638efea8544d$export$5a0e9190d10875d3) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === $ee56638efea8544d$export$cc83beedcb9be9ac) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget: renderTarget, activeMipmapLevel: activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
class $ee56638efea8544d$export$ee2e5a18258a4049 extends $ee56638efea8544d$export$5431306cf43de24a {
    constructor(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace){
        images = images !== undefined ? images : [];
        mapping = mapping !== undefined ? mapping : $ee56638efea8544d$export$8759762a6477f2c4;
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        this.isCubeTexture = true;
        this.flipY = false;
    }
    get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
class $ee56638efea8544d$export$ac386671d651941e extends $ee56638efea8544d$export$3c052beb2e51e23f {
    constructor(size = 1, options = {}){
        super(size, size, options);
        this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        this.texture = new $ee56638efea8544d$export$ee2e5a18258a4049(images, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.colorSpace);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : $ee56638efea8544d$export$8a72f490b25c56c8;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new $ee56638efea8544d$export$33e43285f7406bd5(5, 5, 5);
        const material = new $ee56638efea8544d$export$83c7d75d550a8b0d({
            name: 'CubemapFromEquirect',
            uniforms: $ee56638efea8544d$export$acda854380553452(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: $ee56638efea8544d$export$d9f0486e75b5ace,
            blending: $ee56638efea8544d$export$63b8d6b580fc65ba
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new $ee56638efea8544d$export$e176487c05830cc5(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === $ee56638efea8544d$export$5d8599b6a933fb1b) texture.minFilter = $ee56638efea8544d$export$8a72f490b25c56c8;
        const camera = new $ee56638efea8544d$export$d0cdd0bd804995de(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
class $ee56638efea8544d$export$6f1519f023b8d0f6 {
    constructor(color, density = 0.00025){
        this.isFogExp2 = true;
        this.name = '';
        this.color = new $ee56638efea8544d$export$892596cec99bc70e(color);
        this.density = density;
    }
    clone() {
        return new $ee56638efea8544d$export$6f1519f023b8d0f6(this.color, this.density);
    }
    toJSON() {
        return {
            type: 'FogExp2',
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class $ee56638efea8544d$export$3c890837b09508d4 {
    constructor(color, near = 1, far = 1000){
        this.isFog = true;
        this.name = '';
        this.color = new $ee56638efea8544d$export$892596cec99bc70e(color);
        this.near = near;
        this.far = far;
    }
    clone() {
        return new $ee56638efea8544d$export$3c890837b09508d4(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: 'Fog',
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class $ee56638efea8544d$export$38af1803e3442a7f extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isScene = true;
        this.type = 'Scene';
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.backgroundBlurriness = 0;
        this.backgroundIntensity = 1;
        this.backgroundRotation = new $ee56638efea8544d$export$d93cc409a0768c5f();
        this.environmentIntensity = 1;
        this.environmentRotation = new $ee56638efea8544d$export$d93cc409a0768c5f();
        this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
    }
}
class $ee56638efea8544d$export$3d5cd879f108f53f {
    constructor(array, stride){
        this.isInterleavedBuffer = true;
        this.array = array;
        this.stride = stride;
        this.count = array !== undefined ? array.length / stride : 0;
        this.usage = $ee56638efea8544d$export$763e8360f4d7f77d;
        this.updateRanges = [];
        this.version = 0;
        this.uuid = $ee56638efea8544d$var$generateUUID();
    }
    onUploadCallback() {}
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    addUpdateRange(start, count) {
        this.updateRanges.push({
            start: start,
            count: count
        });
    }
    clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    copyAt(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $ee56638efea8544d$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = $ee56638efea8544d$var$generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const $ee56638efea8544d$var$_vector$7 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$920b6d07334599c7 {
    constructor(interleavedBuffer, itemSize, offset, normalized = false){
        this.isInterleavedBufferAttribute = true;
        this.name = '';
        this.data = interleavedBuffer;
        this.itemSize = itemSize;
        this.offset = offset;
        this.normalized = normalized;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            $ee56638efea8544d$var$_vector$7.fromBufferAttribute(this, i);
            $ee56638efea8544d$var$_vector$7.applyMatrix4(m);
            this.setXYZ(i, $ee56638efea8544d$var$_vector$7.x, $ee56638efea8544d$var$_vector$7.y, $ee56638efea8544d$var$_vector$7.z);
        }
        return this;
    }
    applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $ee56638efea8544d$var$_vector$7.fromBufferAttribute(this, i);
            $ee56638efea8544d$var$_vector$7.applyNormalMatrix(m);
            this.setXYZ(i, $ee56638efea8544d$var$_vector$7.x, $ee56638efea8544d$var$_vector$7.y, $ee56638efea8544d$var$_vector$7.z);
        }
        return this;
    }
    transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            $ee56638efea8544d$var$_vector$7.fromBufferAttribute(this, i);
            $ee56638efea8544d$var$_vector$7.transformDirection(m);
            this.setXYZ(i, $ee56638efea8544d$var$_vector$7.x, $ee56638efea8544d$var$_vector$7.y, $ee56638efea8544d$var$_vector$7.z);
        }
        return this;
    }
    getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = $ee56638efea8544d$var$denormalize(value, this.array);
        return value;
    }
    setComponent(index, component, value) {
        if (this.normalized) value = $ee56638efea8544d$var$normalize(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
    }
    setX(index, x) {
        if (this.normalized) x = $ee56638efea8544d$var$normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    setY(index, y) {
        if (this.normalized) y = $ee56638efea8544d$var$normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    setZ(index, z) {
        if (this.normalized) z = $ee56638efea8544d$var$normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    setW(index, w) {
        if (this.normalized) w = $ee56638efea8544d$var$normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = $ee56638efea8544d$var$denormalize(x, this.array);
        return x;
    }
    getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = $ee56638efea8544d$var$denormalize(y, this.array);
        return y;
    }
    getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = $ee56638efea8544d$var$denormalize(z, this.array);
        return z;
    }
    getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = $ee56638efea8544d$var$denormalize(w, this.array);
        return w;
    }
    setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $ee56638efea8544d$var$normalize(x, this.array);
            y = $ee56638efea8544d$var$normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $ee56638efea8544d$var$normalize(x, this.array);
            y = $ee56638efea8544d$var$normalize(y, this.array);
            z = $ee56638efea8544d$var$normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = $ee56638efea8544d$var$normalize(x, this.array);
            y = $ee56638efea8544d$var$normalize(y, this.array);
            z = $ee56638efea8544d$var$normalize(z, this.array);
            w = $ee56638efea8544d$var$normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    clone(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new $ee56638efea8544d$export$8dea267bd6bde117(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new $ee56638efea8544d$export$920b6d07334599c7(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    toJSON(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
class $ee56638efea8544d$export$5ec7dd1c6994bf8e extends $ee56638efea8544d$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        this.color = new $ee56638efea8544d$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.rotation = 0;
        this.sizeAttenuation = true;
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let $ee56638efea8544d$var$_geometry;
const $ee56638efea8544d$var$_intersectPoint = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_worldScale = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_mvPosition = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_alignedPosition = /*@__PURE__*/ new $ee56638efea8544d$export$c977b3e384af9ae1();
const $ee56638efea8544d$var$_rotatedPosition = /*@__PURE__*/ new $ee56638efea8544d$export$c977b3e384af9ae1();
const $ee56638efea8544d$var$_viewWorldMatrix = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_vA = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_vB = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_vC = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_uvA = /*@__PURE__*/ new $ee56638efea8544d$export$c977b3e384af9ae1();
const $ee56638efea8544d$var$_uvB = /*@__PURE__*/ new $ee56638efea8544d$export$c977b3e384af9ae1();
const $ee56638efea8544d$var$_uvC = /*@__PURE__*/ new $ee56638efea8544d$export$c977b3e384af9ae1();
class $ee56638efea8544d$export$3075603db8e6204c extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(material = new $ee56638efea8544d$export$5ec7dd1c6994bf8e()){
        super();
        this.isSprite = true;
        this.type = 'Sprite';
        if ($ee56638efea8544d$var$_geometry === undefined) {
            $ee56638efea8544d$var$_geometry = new $ee56638efea8544d$export$b7be63a67df8959();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new $ee56638efea8544d$export$3d5cd879f108f53f(float32Array, 5);
            $ee56638efea8544d$var$_geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            $ee56638efea8544d$var$_geometry.setAttribute('position', new $ee56638efea8544d$export$920b6d07334599c7(interleavedBuffer, 3, 0, false));
            $ee56638efea8544d$var$_geometry.setAttribute('uv', new $ee56638efea8544d$export$920b6d07334599c7(interleavedBuffer, 2, 3, false));
        }
        this.geometry = $ee56638efea8544d$var$_geometry;
        this.material = material;
        this.center = new $ee56638efea8544d$export$c977b3e384af9ae1(0.5, 0.5);
    }
    raycast(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        $ee56638efea8544d$var$_worldScale.setFromMatrixScale(this.matrixWorld);
        $ee56638efea8544d$var$_viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        $ee56638efea8544d$var$_mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) $ee56638efea8544d$var$_worldScale.multiplyScalar(-$ee56638efea8544d$var$_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        $ee56638efea8544d$var$transformVertex($ee56638efea8544d$var$_vA.set(-0.5, -0.5, 0), $ee56638efea8544d$var$_mvPosition, center, $ee56638efea8544d$var$_worldScale, sin, cos);
        $ee56638efea8544d$var$transformVertex($ee56638efea8544d$var$_vB.set(0.5, -0.5, 0), $ee56638efea8544d$var$_mvPosition, center, $ee56638efea8544d$var$_worldScale, sin, cos);
        $ee56638efea8544d$var$transformVertex($ee56638efea8544d$var$_vC.set(0.5, 0.5, 0), $ee56638efea8544d$var$_mvPosition, center, $ee56638efea8544d$var$_worldScale, sin, cos);
        $ee56638efea8544d$var$_uvA.set(0, 0);
        $ee56638efea8544d$var$_uvB.set(1, 0);
        $ee56638efea8544d$var$_uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle($ee56638efea8544d$var$_vA, $ee56638efea8544d$var$_vB, $ee56638efea8544d$var$_vC, false, $ee56638efea8544d$var$_intersectPoint);
        if (intersect === null) {
            // check second triangle
            $ee56638efea8544d$var$transformVertex($ee56638efea8544d$var$_vB.set(-0.5, 0.5, 0), $ee56638efea8544d$var$_mvPosition, center, $ee56638efea8544d$var$_worldScale, sin, cos);
            $ee56638efea8544d$var$_uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle($ee56638efea8544d$var$_vA, $ee56638efea8544d$var$_vC, $ee56638efea8544d$var$_vB, false, $ee56638efea8544d$var$_intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo($ee56638efea8544d$var$_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: $ee56638efea8544d$var$_intersectPoint.clone(),
            uv: $ee56638efea8544d$export$5a465592bfe74b48.getInterpolation($ee56638efea8544d$var$_intersectPoint, $ee56638efea8544d$var$_vA, $ee56638efea8544d$var$_vB, $ee56638efea8544d$var$_vC, $ee56638efea8544d$var$_uvA, $ee56638efea8544d$var$_uvB, $ee56638efea8544d$var$_uvC, new $ee56638efea8544d$export$c977b3e384af9ae1()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function $ee56638efea8544d$var$transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    $ee56638efea8544d$var$_alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        $ee56638efea8544d$var$_rotatedPosition.x = cos * $ee56638efea8544d$var$_alignedPosition.x - sin * $ee56638efea8544d$var$_alignedPosition.y;
        $ee56638efea8544d$var$_rotatedPosition.y = sin * $ee56638efea8544d$var$_alignedPosition.x + cos * $ee56638efea8544d$var$_alignedPosition.y;
    } else $ee56638efea8544d$var$_rotatedPosition.copy($ee56638efea8544d$var$_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += $ee56638efea8544d$var$_rotatedPosition.x;
    vertexPosition.y += $ee56638efea8544d$var$_rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4($ee56638efea8544d$var$_viewWorldMatrix);
}
const $ee56638efea8544d$var$_v1$2 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_v2$1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$112e7237be0c5f30 extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            levels: {
                enumerable: true,
                value: []
            },
            isLOD: {
                value: true
            }
        });
        this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    removeLevel(distance) {
        const levels = this.levels;
        for(let i = 0; i < levels.length; i++)if (levels[i].distance === distance) {
            const removedElements = levels.splice(i, 1);
            this.remove(removedElements[0].object);
            return true;
        }
        return false;
    }
    getCurrentLevel() {
        return this._currentLevel;
    }
    getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            $ee56638efea8544d$var$_v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo($ee56638efea8544d$var$_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            $ee56638efea8544d$var$_v1$2.setFromMatrixPosition(camera.matrixWorld);
            $ee56638efea8544d$var$_v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = $ee56638efea8544d$var$_v1$2.distanceTo($ee56638efea8544d$var$_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const $ee56638efea8544d$var$_basePosition = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_skinIndex = /*@__PURE__*/ new $ee56638efea8544d$export$fa7daccca11cdbe3();
const $ee56638efea8544d$var$_skinWeight = /*@__PURE__*/ new $ee56638efea8544d$export$fa7daccca11cdbe3();
const $ee56638efea8544d$var$_vector3 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_matrix4 = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_vertex = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_sphere$5 = /*@__PURE__*/ new $ee56638efea8544d$export$805e8b72413ccaba();
const $ee56638efea8544d$var$_inverseMatrix$2 = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_ray$2 = /*@__PURE__*/ new $ee56638efea8544d$export$a186db52eed6d40e();
class $ee56638efea8544d$export$b303577035157ecf extends $ee56638efea8544d$export$e176487c05830cc5 {
    constructor(geometry, material){
        super(geometry, material);
        this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        this.bindMode = $ee56638efea8544d$export$2595a3798997538;
        this.bindMatrix = new $ee56638efea8544d$export$2ae72fc923e5eb5();
        this.bindMatrixInverse = new $ee56638efea8544d$export$2ae72fc923e5eb5();
        this.boundingBox = null;
        this.boundingSphere = null;
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new $ee56638efea8544d$export$6f7d5a9418ab2aa3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $ee56638efea8544d$var$_vertex);
            this.boundingBox.expandByPoint($ee56638efea8544d$var$_vertex);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new $ee56638efea8544d$export$805e8b72413ccaba();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, $ee56638efea8544d$var$_vertex);
            this.boundingSphere.expandByPoint($ee56638efea8544d$var$_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $ee56638efea8544d$var$_sphere$5.copy(this.boundingSphere);
        $ee56638efea8544d$var$_sphere$5.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($ee56638efea8544d$var$_sphere$5) === false) return;
        // convert ray to local space of skinned mesh
        $ee56638efea8544d$var$_inverseMatrix$2.copy(matrixWorld).invert();
        $ee56638efea8544d$var$_ray$2.copy(raycaster.ray).applyMatrix4($ee56638efea8544d$var$_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if ($ee56638efea8544d$var$_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, $ee56638efea8544d$var$_ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    pose() {
        this.skeleton.pose();
    }
    normalizeSkinWeights() {
        const vector = new $ee56638efea8544d$export$fa7daccca11cdbe3();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === $ee56638efea8544d$export$2595a3798997538) this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === $ee56638efea8544d$export$d7e7dc2e114517a0) this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    applyBoneTransform(index, vector) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        $ee56638efea8544d$var$_skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        $ee56638efea8544d$var$_skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        $ee56638efea8544d$var$_basePosition.copy(vector).applyMatrix4(this.bindMatrix);
        vector.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = $ee56638efea8544d$var$_skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = $ee56638efea8544d$var$_skinIndex.getComponent(i);
                $ee56638efea8544d$var$_matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                vector.addScaledVector($ee56638efea8544d$var$_vector3.copy($ee56638efea8544d$var$_basePosition).applyMatrix4($ee56638efea8544d$var$_matrix4), weight);
            }
        }
        return vector.applyMatrix4(this.bindMatrixInverse);
    }
}
class $ee56638efea8544d$export$b127726e56765aa4 extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isBone = true;
        this.type = 'Bone';
    }
}
class $ee56638efea8544d$export$b691f601014eabe1 extends $ee56638efea8544d$export$5431306cf43de24a {
    constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = $ee56638efea8544d$export$727aa5ec3fe39bf0, minFilter = $ee56638efea8544d$export$727aa5ec3fe39bf0, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        this.isDataTexture = true;
        this.image = {
            data: data,
            width: width,
            height: height
        };
        this.generateMipmaps = false;
        this.flipY = false;
        this.unpackAlignment = 1;
    }
}
const $ee56638efea8544d$var$_offsetMatrix = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_identityMatrix = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
class $ee56638efea8544d$export$8f31e4c4a37b8e9c {
    constructor(bones = [], boneInverses = []){
        this.uuid = $ee56638efea8544d$var$generateUUID();
        this.bones = bones.slice(0);
        this.boneInverses = boneInverses;
        this.boneMatrices = null;
        this.boneTexture = null;
        this.init();
    }
    init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new $ee56638efea8544d$export$2ae72fc923e5eb5());
        }
    }
    calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new $ee56638efea8544d$export$2ae72fc923e5eb5();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : $ee56638efea8544d$var$_identityMatrix;
            $ee56638efea8544d$var$_offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            $ee56638efea8544d$var$_offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    clone() {
        return new $ee56638efea8544d$export$8f31e4c4a37b8e9c(this.bones, this.boneInverses);
    }
    computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new $ee56638efea8544d$export$b691f601014eabe1(boneMatrices, size, size, $ee56638efea8544d$export$3f8bb04b555a363c, $ee56638efea8544d$export$f6d331659b644596);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        return this;
    }
    getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                bone = new $ee56638efea8544d$export$b127726e56765aa4();
            }
            this.bones.push(bone);
            this.boneInverses.push(new $ee56638efea8544d$export$2ae72fc923e5eb5().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
class $ee56638efea8544d$export$32ea87a8b54d744a extends $ee56638efea8544d$export$8dea267bd6bde117 {
    constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        this.isInstancedBufferAttribute = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const $ee56638efea8544d$var$_instanceLocalMatrix = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_instanceWorldMatrix = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_instanceIntersects = [];
const $ee56638efea8544d$var$_box3 = /*@__PURE__*/ new $ee56638efea8544d$export$6f7d5a9418ab2aa3();
const $ee56638efea8544d$var$_identity = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_mesh$1 = /*@__PURE__*/ new $ee56638efea8544d$export$e176487c05830cc5();
const $ee56638efea8544d$var$_sphere$4 = /*@__PURE__*/ new $ee56638efea8544d$export$805e8b72413ccaba();
class $ee56638efea8544d$export$f3c979c331175ad7 extends $ee56638efea8544d$export$e176487c05830cc5 {
    constructor(geometry, material, count){
        super(geometry, material);
        this.isInstancedMesh = true;
        this.instanceMatrix = new $ee56638efea8544d$export$32ea87a8b54d744a(new Float32Array(count * 16), 16);
        this.instanceColor = null;
        this.morphTexture = null;
        this.count = count;
        this.boundingBox = null;
        this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, $ee56638efea8544d$var$_identity);
    }
    computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new $ee56638efea8544d$export$6f7d5a9418ab2aa3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $ee56638efea8544d$var$_instanceLocalMatrix);
            $ee56638efea8544d$var$_box3.copy(geometry.boundingBox).applyMatrix4($ee56638efea8544d$var$_instanceLocalMatrix);
            this.boundingBox.union($ee56638efea8544d$var$_box3);
        }
    }
    computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new $ee56638efea8544d$export$805e8b72413ccaba();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, $ee56638efea8544d$var$_instanceLocalMatrix);
            $ee56638efea8544d$var$_sphere$4.copy(geometry.boundingSphere).applyMatrix4($ee56638efea8544d$var$_instanceLocalMatrix);
            this.boundingSphere.union($ee56638efea8544d$var$_sphere$4);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    getMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const array = this.morphTexture.source.data.data;
        const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
        const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
        for(let i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        $ee56638efea8544d$var$_mesh$1.geometry = this.geometry;
        $ee56638efea8544d$var$_mesh$1.material = this.material;
        if ($ee56638efea8544d$var$_mesh$1.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        $ee56638efea8544d$var$_sphere$4.copy(this.boundingSphere);
        $ee56638efea8544d$var$_sphere$4.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere($ee56638efea8544d$var$_sphere$4) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, $ee56638efea8544d$var$_instanceLocalMatrix);
            $ee56638efea8544d$var$_instanceWorldMatrix.multiplyMatrices(matrixWorld, $ee56638efea8544d$var$_instanceLocalMatrix);
            // the mesh represents this single instance
            $ee56638efea8544d$var$_mesh$1.matrixWorld = $ee56638efea8544d$var$_instanceWorldMatrix;
            $ee56638efea8544d$var$_mesh$1.raycast(raycaster, $ee56638efea8544d$var$_instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = $ee56638efea8544d$var$_instanceIntersects.length; i < l; i++){
                const intersect = $ee56638efea8544d$var$_instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            $ee56638efea8544d$var$_instanceIntersects.length = 0;
        }
    }
    setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new $ee56638efea8544d$export$32ea87a8b54d744a(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    setMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const len = objectInfluences.length + 1; // morphBaseInfluence + all influences
        if (this.morphTexture === null) this.morphTexture = new $ee56638efea8544d$export$b691f601014eabe1(new Float32Array(len * this.count), len, this.count, $ee56638efea8544d$export$4e041a7967d15c4b, $ee56638efea8544d$export$f6d331659b644596);
        const array = this.morphTexture.source.data.data;
        let morphInfluencesSum = 0;
        for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
        const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        const dataIndex = len * index;
        array[dataIndex] = morphBaseInfluence;
        array.set(objectInfluences, dataIndex + 1);
    }
    updateMorphTargets() {}
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        if (this.morphTexture !== null) {
            this.morphTexture.dispose();
            this.morphTexture = null;
        }
        return this;
    }
}
const $ee56638efea8544d$var$_vector1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_vector2 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_normalMatrix = /*@__PURE__*/ new $ee56638efea8544d$export$8ff26dafa08918();
class $ee56638efea8544d$export$7ff5ac152ef991b0 {
    constructor(normal = new $ee56638efea8544d$export$64b5c384219d3699(1, 0, 0), constant = 0){
        this.isPlane = true;
        // normal is assumed to be normalized
        this.normal = normal;
        this.constant = constant;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = $ee56638efea8544d$var$_vector1.subVectors(c, b).cross($ee56638efea8544d$var$_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    intersectLine(line, target) {
        const direction = line.delta($ee56638efea8544d$var$_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || $ee56638efea8544d$var$_normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint($ee56638efea8544d$var$_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $ee56638efea8544d$var$_sphere$3 = /*@__PURE__*/ new $ee56638efea8544d$export$805e8b72413ccaba();
const $ee56638efea8544d$var$_vector$6 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$35efe6f4c85463d2 {
    constructor(p0 = new $ee56638efea8544d$export$7ff5ac152ef991b0(), p1 = new $ee56638efea8544d$export$7ff5ac152ef991b0(), p2 = new $ee56638efea8544d$export$7ff5ac152ef991b0(), p3 = new $ee56638efea8544d$export$7ff5ac152ef991b0(), p4 = new $ee56638efea8544d$export$7ff5ac152ef991b0(), p5 = new $ee56638efea8544d$export$7ff5ac152ef991b0()){
        this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m, coordinateSystem = $ee56638efea8544d$export$5a0e9190d10875d3) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        if (coordinateSystem === $ee56638efea8544d$export$5a0e9190d10875d3) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        else if (coordinateSystem === $ee56638efea8544d$export$cc83beedcb9be9ac) planes[5].setComponents(me2, me6, me10, me14).normalize();
        else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        return this;
    }
    intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            $ee56638efea8544d$var$_sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            $ee56638efea8544d$var$_sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere($ee56638efea8544d$var$_sphere$3);
    }
    intersectsSprite(sprite) {
        $ee56638efea8544d$var$_sphere$3.center.set(0, 0, 0);
        $ee56638efea8544d$var$_sphere$3.radius = 0.7071067811865476;
        $ee56638efea8544d$var$_sphere$3.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere($ee56638efea8544d$var$_sphere$3);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            $ee56638efea8544d$var$_vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            $ee56638efea8544d$var$_vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            $ee56638efea8544d$var$_vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint($ee56638efea8544d$var$_vector$6) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
function $ee56638efea8544d$var$ascIdSort(a, b) {
    return a - b;
}
function $ee56638efea8544d$var$sortOpaque(a, b) {
    return a.z - b.z;
}
function $ee56638efea8544d$var$sortTransparent(a, b) {
    return b.z - a.z;
}
class $ee56638efea8544d$var$MultiDrawRenderList {
    constructor(){
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
    push(start, count, z, index) {
        const pool = this.pool;
        const list = this.list;
        if (this.index >= pool.length) pool.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const item = pool[this.index];
        list.push(item);
        this.index++;
        item.start = start;
        item.count = count;
        item.z = z;
        item.index = index;
    }
    reset() {
        this.list.length = 0;
        this.index = 0;
    }
}
const $ee56638efea8544d$var$_matrix$1 = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_whiteColor = /*@__PURE__*/ new $ee56638efea8544d$export$892596cec99bc70e(1, 1, 1);
const $ee56638efea8544d$var$_frustum = /*@__PURE__*/ new $ee56638efea8544d$export$35efe6f4c85463d2();
const $ee56638efea8544d$var$_box$1 = /*@__PURE__*/ new $ee56638efea8544d$export$6f7d5a9418ab2aa3();
const $ee56638efea8544d$var$_sphere$2 = /*@__PURE__*/ new $ee56638efea8544d$export$805e8b72413ccaba();
const $ee56638efea8544d$var$_vector$5 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_forward = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_temp = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_renderList = /*@__PURE__*/ new $ee56638efea8544d$var$MultiDrawRenderList();
const $ee56638efea8544d$var$_mesh = /*@__PURE__*/ new $ee56638efea8544d$export$e176487c05830cc5();
const $ee56638efea8544d$var$_batchIntersects = [];
// copies data from attribute "src" into "target" starting at "targetOffset"
function $ee56638efea8544d$var$copyAttributeData(src, target, targetOffset = 0) {
    const itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        const vertexCount = src.count;
        for(let i = 0; i < vertexCount; i++)for(let c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
// safely copies array contents to a potentially smaller array
function $ee56638efea8544d$var$copyArrayContents(src, target) {
    if (src.constructor !== target.constructor) {
        // if arrays are of a different type (eg due to index size increasing) then data must be per-element copied
        const len = Math.min(src.length, target.length);
        for(let i = 0; i < len; i++)target[i] = src[i];
    } else {
        // if the arrays use the same data layout we can use a fast block copy
        const len = Math.min(src.length, target.length);
        target.set(new src.constructor(src.buffer, 0, len));
    }
}
class $ee56638efea8544d$export$6e01c5ee52ed8f7b extends $ee56638efea8544d$export$e176487c05830cc5 {
    get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    get instanceCount() {
        return this._instanceInfo.length - this._availableInstanceIds.length;
    }
    get unusedVertexCount() {
        return this._maxVertexCount - this._nextVertexStart;
    }
    get unusedIndexCount() {
        return this._maxIndexCount - this._nextIndexStart;
    }
    constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material){
        super(new $ee56638efea8544d$export$b7be63a67df8959(), material);
        this.isBatchedMesh = true;
        this.perObjectFrustumCulled = true;
        this.sortObjects = true;
        this.boundingBox = null;
        this.boundingSphere = null;
        this.customSort = null;
        // stores visible, active, and geometry id per instance and reserved buffer ranges for geometries
        this._instanceInfo = [];
        this._geometryInfo = [];
        // instance, geometry ids that have been set as inactive, and are available to be overwritten
        this._availableInstanceIds = [];
        this._availableGeometryIds = [];
        // used to track where the next point is that geometry should be inserted
        this._nextIndexStart = 0;
        this._nextVertexStart = 0;
        this._geometryCount = 0;
        // flags
        this._visibilityChanged = true;
        this._geometryInitialized = false;
        // cached user options
        this._maxInstanceCount = maxInstanceCount;
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        // buffers for multi draw
        this._multiDrawCounts = new Int32Array(maxInstanceCount);
        this._multiDrawStarts = new Int32Array(maxInstanceCount);
        this._multiDrawCount = 0;
        this._multiDrawInstances = null;
        // Local matrix per geometry by using data texture
        this._matricesTexture = null;
        this._indirectTexture = null;
        this._colorsTexture = null;
        this._initMatricesTexture();
        this._initIndirectTexture();
    }
    _initMatricesTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
        let size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        const matricesTexture = new $ee56638efea8544d$export$b691f601014eabe1(matricesArray, size, size, $ee56638efea8544d$export$3f8bb04b555a363c, $ee56638efea8544d$export$f6d331659b644596);
        this._matricesTexture = matricesTexture;
    }
    _initIndirectTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        const indirectArray = new Uint32Array(size * size);
        const indirectTexture = new $ee56638efea8544d$export$b691f601014eabe1(indirectArray, size, size, $ee56638efea8544d$export$aa92e870a709d190, $ee56638efea8544d$export$c3c7fc4518ebba96);
        this._indirectTexture = indirectTexture;
    }
    _initColorsTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        // 4 floats per RGBA pixel initialized to white
        const colorsArray = new Float32Array(size * size * 4).fill(1);
        const colorsTexture = new $ee56638efea8544d$export$b691f601014eabe1(colorsArray, size, size, $ee56638efea8544d$export$3f8bb04b555a363c, $ee56638efea8544d$export$f6d331659b644596);
        colorsTexture.colorSpace = $ee56638efea8544d$export$5e6fd513f44698c.workingColorSpace;
        this._colorsTexture = colorsTexture;
    }
    _initializeGeometry(reference) {
        const geometry = this.geometry;
        const maxVertexCount = this._maxVertexCount;
        const maxIndexCount = this._maxIndexCount;
        if (this._geometryInitialized === false) {
            for(const attributeName in reference.attributes){
                const srcAttribute = reference.getAttribute(attributeName);
                const { array: array, itemSize: itemSize, normalized: normalized } = srcAttribute;
                const dstArray = new array.constructor(maxVertexCount * itemSize);
                const dstAttribute = new $ee56638efea8544d$export$8dea267bd6bde117(dstArray, itemSize, normalized);
                geometry.setAttribute(attributeName, dstAttribute);
            }
            if (reference.getIndex() !== null) {
                // Reserve last u16 index for primitive restart.
                const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                geometry.setIndex(new $ee56638efea8544d$export$8dea267bd6bde117(indexArray, 1));
            }
            this._geometryInitialized = true;
        }
    }
    // Make sure the geometry is compatible with the existing combined geometry attributes
    _validateGeometry(geometry) {
        // check to ensure the geometries are using consistent attributes and indices
        const batchGeometry = this.geometry;
        if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
        for(const attributeName in batchGeometry.attributes){
            if (!geometry.hasAttribute(attributeName)) throw new Error(`THREE.BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error('THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.');
        }
    }
    validateInstanceId(instanceId) {
        const instanceInfo = this._instanceInfo;
        if (instanceId < 0 || instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) throw new Error(`THREE.BatchedMesh: Invalid instanceId ${instanceId}. Instance is either out of range or has been deleted.`);
    }
    validateGeometryId(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId < 0 || geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) throw new Error(`THREE.BatchedMesh: Invalid geometryId ${geometryId}. Geometry is either out of range or has been deleted.`);
    }
    setCustomSort(func) {
        this.customSort = func;
        return this;
    }
    computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new $ee56638efea8544d$export$6f7d5a9418ab2aa3();
        const boundingBox = this.boundingBox;
        const instanceInfo = this._instanceInfo;
        boundingBox.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $ee56638efea8544d$var$_matrix$1);
            this.getBoundingBoxAt(geometryId, $ee56638efea8544d$var$_box$1).applyMatrix4($ee56638efea8544d$var$_matrix$1);
            boundingBox.union($ee56638efea8544d$var$_box$1);
        }
    }
    computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new $ee56638efea8544d$export$805e8b72413ccaba();
        const boundingSphere = this.boundingSphere;
        const instanceInfo = this._instanceInfo;
        boundingSphere.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, $ee56638efea8544d$var$_matrix$1);
            this.getBoundingSphereAt(geometryId, $ee56638efea8544d$var$_sphere$2).applyMatrix4($ee56638efea8544d$var$_matrix$1);
            boundingSphere.union($ee56638efea8544d$var$_sphere$2);
        }
    }
    addInstance(geometryId) {
        const atCapacity = this._instanceInfo.length >= this.maxInstanceCount;
        // ensure we're not over geometry
        if (atCapacity && this._availableInstanceIds.length === 0) throw new Error('THREE.BatchedMesh: Maximum item count reached.');
        const instanceInfo = {
            visible: true,
            active: true,
            geometryIndex: geometryId
        };
        let drawId = null;
        // Prioritize using previously freed instance ids
        if (this._availableInstanceIds.length > 0) {
            this._availableInstanceIds.sort($ee56638efea8544d$var$ascIdSort);
            drawId = this._availableInstanceIds.shift();
            this._instanceInfo[drawId] = instanceInfo;
        } else {
            drawId = this._instanceInfo.length;
            this._instanceInfo.push(instanceInfo);
        }
        const matricesTexture = this._matricesTexture;
        $ee56638efea8544d$var$_matrix$1.identity().toArray(matricesTexture.image.data, drawId * 16);
        matricesTexture.needsUpdate = true;
        const colorsTexture = this._colorsTexture;
        if (colorsTexture) {
            $ee56638efea8544d$var$_whiteColor.toArray(colorsTexture.image.data, drawId * 4);
            colorsTexture.needsUpdate = true;
        }
        this._visibilityChanged = true;
        return drawId;
    }
    addGeometry(geometry, reservedVertexCount = -1, reservedIndexCount = -1) {
        this._initializeGeometry(geometry);
        this._validateGeometry(geometry);
        const geometryInfo = {
            // geometry information
            vertexStart: -1,
            vertexCount: -1,
            reservedVertexCount: -1,
            indexStart: -1,
            indexCount: -1,
            reservedIndexCount: -1,
            // draw range information
            start: -1,
            count: -1,
            // state
            boundingBox: null,
            boundingSphere: null,
            active: true
        };
        const geometryInfoList = this._geometryInfo;
        geometryInfo.vertexStart = this._nextVertexStart;
        geometryInfo.reservedVertexCount = reservedVertexCount === -1 ? geometry.getAttribute('position').count : reservedVertexCount;
        const index = geometry.getIndex();
        const hasIndex = index !== null;
        if (hasIndex) {
            geometryInfo.indexStart = this._nextIndexStart;
            geometryInfo.reservedIndexCount = reservedIndexCount === -1 ? index.count : reservedIndexCount;
        }
        if (geometryInfo.indexStart !== -1 && geometryInfo.indexStart + geometryInfo.reservedIndexCount > this._maxIndexCount || geometryInfo.vertexStart + geometryInfo.reservedVertexCount > this._maxVertexCount) throw new Error('THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.');
        // update id
        let geometryId;
        if (this._availableGeometryIds.length > 0) {
            this._availableGeometryIds.sort($ee56638efea8544d$var$ascIdSort);
            geometryId = this._availableGeometryIds.shift();
            geometryInfoList[geometryId] = geometryInfo;
        } else {
            geometryId = this._geometryCount;
            this._geometryCount++;
            geometryInfoList.push(geometryInfo);
        }
        // update the geometry
        this.setGeometryAt(geometryId, geometry);
        // increment the next geometry position
        this._nextIndexStart = geometryInfo.indexStart + geometryInfo.reservedIndexCount;
        this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        return geometryId;
    }
    setGeometryAt(geometryId, geometry) {
        if (geometryId >= this._geometryCount) throw new Error('THREE.BatchedMesh: Maximum geometry count reached.');
        this._validateGeometry(geometry);
        const batchGeometry = this.geometry;
        const hasIndex = batchGeometry.getIndex() !== null;
        const dstIndex = batchGeometry.getIndex();
        const srcIndex = geometry.getIndex();
        const geometryInfo = this._geometryInfo[geometryId];
        if (hasIndex && srcIndex.count > geometryInfo.reservedIndexCount || geometry.attributes.position.count > geometryInfo.reservedVertexCount) throw new Error('THREE.BatchedMesh: Reserved space not large enough for provided geometry.');
        // copy geometry buffer data over
        const vertexStart = geometryInfo.vertexStart;
        const reservedVertexCount = geometryInfo.reservedVertexCount;
        geometryInfo.vertexCount = geometry.getAttribute('position').count;
        for(const attributeName in batchGeometry.attributes){
            // copy attribute data
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            $ee56638efea8544d$var$copyAttributeData(srcAttribute, dstAttribute, vertexStart);
            // fill the rest in with zeroes
            const itemSize = srcAttribute.itemSize;
            for(let i = srcAttribute.count, l = reservedVertexCount; i < l; i++){
                const index = vertexStart + i;
                for(let c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
            }
            dstAttribute.needsUpdate = true;
            dstAttribute.addUpdateRange(vertexStart * itemSize, reservedVertexCount * itemSize);
        }
        // copy index
        if (hasIndex) {
            const indexStart = geometryInfo.indexStart;
            const reservedIndexCount = geometryInfo.reservedIndexCount;
            geometryInfo.indexCount = geometry.getIndex().count;
            // copy index data over
            for(let i = 0; i < srcIndex.count; i++)dstIndex.setX(indexStart + i, vertexStart + srcIndex.getX(i));
            // fill the rest in with zeroes
            for(let i = srcIndex.count, l = reservedIndexCount; i < l; i++)dstIndex.setX(indexStart + i, vertexStart);
            dstIndex.needsUpdate = true;
            dstIndex.addUpdateRange(indexStart, geometryInfo.reservedIndexCount);
        }
        // update the draw range
        geometryInfo.start = hasIndex ? geometryInfo.indexStart : geometryInfo.vertexStart;
        geometryInfo.count = hasIndex ? geometryInfo.indexCount : geometryInfo.vertexCount;
        // store the bounding boxes
        geometryInfo.boundingBox = null;
        if (geometry.boundingBox !== null) geometryInfo.boundingBox = geometry.boundingBox.clone();
        geometryInfo.boundingSphere = null;
        if (geometry.boundingSphere !== null) geometryInfo.boundingSphere = geometry.boundingSphere.clone();
        this._visibilityChanged = true;
        return geometryId;
    }
    deleteGeometry(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) return this;
        // delete any instances associated with this geometry
        const instanceInfo = this._instanceInfo;
        for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].geometryIndex === geometryId) this.deleteInstance(i);
        geometryInfoList[geometryId].active = false;
        this._availableGeometryIds.push(geometryId);
        this._visibilityChanged = true;
        return this;
    }
    deleteInstance(instanceId) {
        this.validateInstanceId(instanceId);
        this._instanceInfo[instanceId].active = false;
        this._availableInstanceIds.push(instanceId);
        this._visibilityChanged = true;
        return this;
    }
    optimize() {
        // track the next indices to copy data to
        let nextVertexStart = 0;
        let nextIndexStart = 0;
        // Iterate over all geometry ranges in order sorted from earliest in the geometry buffer to latest
        // in the geometry buffer. Because draw range objects can be reused there is no guarantee of their order.
        const geometryInfoList = this._geometryInfo;
        const indices = geometryInfoList.map((e, i)=>i).sort((a, b)=>{
            return geometryInfoList[a].vertexStart - geometryInfoList[b].vertexStart;
        });
        const geometry = this.geometry;
        for(let i = 0, l = geometryInfoList.length; i < l; i++){
            // if a geometry range is inactive then don't copy anything
            const index = indices[i];
            const geometryInfo = geometryInfoList[index];
            if (geometryInfo.active === false) continue;
            // if a geometry contains an index buffer then shift it, as well
            if (geometry.index !== null) {
                if (geometryInfo.indexStart !== nextIndexStart) {
                    const { indexStart: indexStart, vertexStart: vertexStart, reservedIndexCount: reservedIndexCount } = geometryInfo;
                    const index = geometry.index;
                    const array = index.array;
                    // shift the index pointers based on how the vertex data will shift
                    // adjusting the index must happen first so the original vertex start value is available
                    const elementDelta = nextVertexStart - vertexStart;
                    for(let j = indexStart; j < indexStart + reservedIndexCount; j++)array[j] = array[j] + elementDelta;
                    index.array.copyWithin(nextIndexStart, indexStart, indexStart + reservedIndexCount);
                    index.addUpdateRange(nextIndexStart, reservedIndexCount);
                    geometryInfo.indexStart = nextIndexStart;
                }
                nextIndexStart += geometryInfo.reservedIndexCount;
            }
            // if a geometry needs to be moved then copy attribute data to overwrite unused space
            if (geometryInfo.vertexStart !== nextVertexStart) {
                const { vertexStart: vertexStart, reservedVertexCount: reservedVertexCount } = geometryInfo;
                const attributes = geometry.attributes;
                for(const key in attributes){
                    const attribute = attributes[key];
                    const { array: array, itemSize: itemSize } = attribute;
                    array.copyWithin(nextVertexStart * itemSize, vertexStart * itemSize, (vertexStart + reservedVertexCount) * itemSize);
                    attribute.addUpdateRange(nextVertexStart * itemSize, reservedVertexCount * itemSize);
                }
                geometryInfo.vertexStart = nextVertexStart;
            }
            nextVertexStart += geometryInfo.reservedVertexCount;
            geometryInfo.start = geometry.index ? geometryInfo.indexStart : geometryInfo.vertexStart;
            // step the next geometry points to the shifted position
            this._nextIndexStart = geometry.index ? geometryInfo.indexStart + geometryInfo.reservedIndexCount : 0;
            this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        }
        return this;
    }
    // get bounding box and compute it if it doesn't exist
    getBoundingBoxAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding box
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingBox === null) {
            const box = new $ee56638efea8544d$export$6f7d5a9418ab2aa3();
            const index = geometry.index;
            const position = geometry.attributes.position;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                box.expandByPoint($ee56638efea8544d$var$_vector$5.fromBufferAttribute(position, iv));
            }
            geometryInfo.boundingBox = box;
        }
        target.copy(geometryInfo.boundingBox);
        return target;
    }
    // get bounding sphere and compute it if it doesn't exist
    getBoundingSphereAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding sphere
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingSphere === null) {
            const sphere = new $ee56638efea8544d$export$805e8b72413ccaba();
            this.getBoundingBoxAt(geometryId, $ee56638efea8544d$var$_box$1);
            $ee56638efea8544d$var$_box$1.getCenter(sphere.center);
            const index = geometry.index;
            const position = geometry.attributes.position;
            let maxRadiusSq = 0;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                $ee56638efea8544d$var$_vector$5.fromBufferAttribute(position, iv);
                maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared($ee56638efea8544d$var$_vector$5));
            }
            sphere.radius = Math.sqrt(maxRadiusSq);
            geometryInfo.boundingSphere = sphere;
        }
        target.copy(geometryInfo.boundingSphere);
        return target;
    }
    setMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        const matricesTexture = this._matricesTexture;
        const matricesArray = this._matricesTexture.image.data;
        matrix.toArray(matricesArray, instanceId * 16);
        matricesTexture.needsUpdate = true;
        return this;
    }
    getMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        return matrix.fromArray(this._matricesTexture.image.data, instanceId * 16);
    }
    setColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        if (this._colorsTexture === null) this._initColorsTexture();
        color.toArray(this._colorsTexture.image.data, instanceId * 4);
        this._colorsTexture.needsUpdate = true;
        return this;
    }
    getColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        return color.fromArray(this._colorsTexture.image.data, instanceId * 4);
    }
    setVisibleAt(instanceId, value) {
        this.validateInstanceId(instanceId);
        if (this._instanceInfo[instanceId].visible === value) return this;
        this._instanceInfo[instanceId].visible = value;
        this._visibilityChanged = true;
        return this;
    }
    getVisibleAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].visible;
    }
    setGeometryIdAt(instanceId, geometryId) {
        this.validateInstanceId(instanceId);
        this.validateGeometryId(geometryId);
        this._instanceInfo[instanceId].geometryIndex = geometryId;
        return this;
    }
    getGeometryIdAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].geometryIndex;
    }
    getGeometryRangeAt(geometryId, target = {}) {
        this.validateGeometryId(geometryId);
        const geometryInfo = this._geometryInfo[geometryId];
        target.vertexStart = geometryInfo.vertexStart;
        target.vertexCount = geometryInfo.vertexCount;
        target.reservedVertexCount = geometryInfo.reservedVertexCount;
        target.indexStart = geometryInfo.indexStart;
        target.indexCount = geometryInfo.indexCount;
        target.reservedIndexCount = geometryInfo.reservedIndexCount;
        target.start = geometryInfo.start;
        target.count = geometryInfo.count;
        return target;
    }
    setInstanceCount(maxInstanceCount) {
        // shrink the available instances as much as possible
        const availableInstanceIds = this._availableInstanceIds;
        const instanceInfo = this._instanceInfo;
        availableInstanceIds.sort($ee56638efea8544d$var$ascIdSort);
        while(availableInstanceIds[availableInstanceIds.length - 1] === instanceInfo.length){
            instanceInfo.pop();
            availableInstanceIds.pop();
        }
        // throw an error if it can't be shrunk to the desired size
        if (maxInstanceCount < instanceInfo.length) throw new Error(`BatchedMesh: Instance ids outside the range ${maxInstanceCount} are being used. Cannot shrink instance count.`);
        // copy the multi draw counts
        const multiDrawCounts = new Int32Array(maxInstanceCount);
        const multiDrawStarts = new Int32Array(maxInstanceCount);
        $ee56638efea8544d$var$copyArrayContents(this._multiDrawCounts, multiDrawCounts);
        $ee56638efea8544d$var$copyArrayContents(this._multiDrawStarts, multiDrawStarts);
        this._multiDrawCounts = multiDrawCounts;
        this._multiDrawStarts = multiDrawStarts;
        this._maxInstanceCount = maxInstanceCount;
        // update texture data for instance sampling
        const indirectTexture = this._indirectTexture;
        const matricesTexture = this._matricesTexture;
        const colorsTexture = this._colorsTexture;
        indirectTexture.dispose();
        this._initIndirectTexture();
        $ee56638efea8544d$var$copyArrayContents(indirectTexture.image.data, this._indirectTexture.image.data);
        matricesTexture.dispose();
        this._initMatricesTexture();
        $ee56638efea8544d$var$copyArrayContents(matricesTexture.image.data, this._matricesTexture.image.data);
        if (colorsTexture) {
            colorsTexture.dispose();
            this._initColorsTexture();
            $ee56638efea8544d$var$copyArrayContents(colorsTexture.image.data, this._colorsTexture.image.data);
        }
    }
    setGeometrySize(maxVertexCount, maxIndexCount) {
        // Check if we can shrink to the requested vertex attribute size
        const validRanges = [
            ...this._geometryInfo
        ].filter((info)=>info.active);
        const requiredVertexLength = Math.max(...validRanges.map((range)=>range.vertexStart + range.reservedVertexCount));
        if (requiredVertexLength > maxVertexCount) throw new Error(`BatchedMesh: Geometry vertex values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        // Check if we can shrink to the requested index attribute size
        if (this.geometry.index) {
            const requiredIndexLength = Math.max(...validRanges.map((range)=>range.indexStart + range.reservedIndexCount));
            if (requiredIndexLength > maxIndexCount) throw new Error(`BatchedMesh: Geometry index values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        }
        //
        // dispose of the previous geometry
        const oldGeometry = this.geometry;
        oldGeometry.dispose();
        // recreate the geometry needed based on the previous variant
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        if (this._geometryInitialized) {
            this._geometryInitialized = false;
            this.geometry = new $ee56638efea8544d$export$b7be63a67df8959();
            this._initializeGeometry(oldGeometry);
        }
        // copy data from the previous geometry
        const geometry = this.geometry;
        if (oldGeometry.index) $ee56638efea8544d$var$copyArrayContents(oldGeometry.index.array, geometry.index.array);
        for(const key in oldGeometry.attributes)$ee56638efea8544d$var$copyArrayContents(oldGeometry.attributes[key].array, geometry.attributes[key].array);
    }
    raycast(raycaster, intersects) {
        const instanceInfo = this._instanceInfo;
        const geometryInfoList = this._geometryInfo;
        const matrixWorld = this.matrixWorld;
        const batchGeometry = this.geometry;
        // iterate over each geometry
        $ee56638efea8544d$var$_mesh.material = this.material;
        $ee56638efea8544d$var$_mesh.geometry.index = batchGeometry.index;
        $ee56638efea8544d$var$_mesh.geometry.attributes = batchGeometry.attributes;
        if ($ee56638efea8544d$var$_mesh.geometry.boundingBox === null) $ee56638efea8544d$var$_mesh.geometry.boundingBox = new $ee56638efea8544d$export$6f7d5a9418ab2aa3();
        if ($ee56638efea8544d$var$_mesh.geometry.boundingSphere === null) $ee56638efea8544d$var$_mesh.geometry.boundingSphere = new $ee56638efea8544d$export$805e8b72413ccaba();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (!instanceInfo[i].visible || !instanceInfo[i].active) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            const geometryInfo = geometryInfoList[geometryId];
            $ee56638efea8544d$var$_mesh.geometry.setDrawRange(geometryInfo.start, geometryInfo.count);
            // get the intersects
            this.getMatrixAt(i, $ee56638efea8544d$var$_mesh.matrixWorld).premultiply(matrixWorld);
            this.getBoundingBoxAt(geometryId, $ee56638efea8544d$var$_mesh.geometry.boundingBox);
            this.getBoundingSphereAt(geometryId, $ee56638efea8544d$var$_mesh.geometry.boundingSphere);
            $ee56638efea8544d$var$_mesh.raycast(raycaster, $ee56638efea8544d$var$_batchIntersects);
            // add batch id to the intersects
            for(let j = 0, l = $ee56638efea8544d$var$_batchIntersects.length; j < l; j++){
                const intersect = $ee56638efea8544d$var$_batchIntersects[j];
                intersect.object = this;
                intersect.batchId = i;
                intersects.push(intersect);
            }
            $ee56638efea8544d$var$_batchIntersects.length = 0;
        }
        $ee56638efea8544d$var$_mesh.material = null;
        $ee56638efea8544d$var$_mesh.geometry.index = null;
        $ee56638efea8544d$var$_mesh.geometry.attributes = {};
        $ee56638efea8544d$var$_mesh.geometry.setDrawRange(0, Infinity);
    }
    copy(source) {
        super.copy(source);
        this.geometry = source.geometry.clone();
        this.perObjectFrustumCulled = source.perObjectFrustumCulled;
        this.sortObjects = source.sortObjects;
        this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
        this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
        this._geometryInfo = source._geometryInfo.map((info)=>({
                ...info,
                boundingBox: info.boundingBox !== null ? info.boundingBox.clone() : null,
                boundingSphere: info.boundingSphere !== null ? info.boundingSphere.clone() : null
            }));
        this._instanceInfo = source._instanceInfo.map((info)=>({
                ...info
            }));
        this._maxInstanceCount = source._maxInstanceCount;
        this._maxVertexCount = source._maxVertexCount;
        this._maxIndexCount = source._maxIndexCount;
        this._geometryInitialized = source._geometryInitialized;
        this._geometryCount = source._geometryCount;
        this._multiDrawCounts = source._multiDrawCounts.slice();
        this._multiDrawStarts = source._multiDrawStarts.slice();
        this._matricesTexture = source._matricesTexture.clone();
        this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
        if (this._colorsTexture !== null) {
            this._colorsTexture = source._colorsTexture.clone();
            this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
        }
        return this;
    }
    dispose() {
        // Assuming the geometry is not shared with other meshes
        this.geometry.dispose();
        this._matricesTexture.dispose();
        this._matricesTexture = null;
        this._indirectTexture.dispose();
        this._indirectTexture = null;
        if (this._colorsTexture !== null) {
            this._colorsTexture.dispose();
            this._colorsTexture = null;
        }
        return this;
    }
    onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
        // if visibility has not changed and frustum culling and object sorting is not required
        // then skip iterating over all items
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        // the indexed version of the multi draw function requires specifying the start
        // offset in bytes.
        const index = geometry.getIndex();
        const bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
        const instanceInfo = this._instanceInfo;
        const multiDrawStarts = this._multiDrawStarts;
        const multiDrawCounts = this._multiDrawCounts;
        const geometryInfoList = this._geometryInfo;
        const perObjectFrustumCulled = this.perObjectFrustumCulled;
        const indirectTexture = this._indirectTexture;
        const indirectArray = indirectTexture.image.data;
        // prepare the frustum in the local frame
        if (perObjectFrustumCulled) {
            $ee56638efea8544d$var$_matrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
            $ee56638efea8544d$var$_frustum.setFromProjectionMatrix($ee56638efea8544d$var$_matrix$1, renderer.coordinateSystem);
        }
        let multiDrawCount = 0;
        if (this.sortObjects) {
            // get the camera position in the local frame
            $ee56638efea8544d$var$_matrix$1.copy(this.matrixWorld).invert();
            $ee56638efea8544d$var$_vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4($ee56638efea8544d$var$_matrix$1);
            $ee56638efea8544d$var$_forward.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection($ee56638efea8544d$var$_matrix$1);
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // get the bounds in world space
                this.getMatrixAt(i, $ee56638efea8544d$var$_matrix$1);
                this.getBoundingSphereAt(geometryId, $ee56638efea8544d$var$_sphere$2).applyMatrix4($ee56638efea8544d$var$_matrix$1);
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) culled = !$ee56638efea8544d$var$_frustum.intersectsSphere($ee56638efea8544d$var$_sphere$2);
                if (!culled) {
                    // get the distance from camera used for sorting
                    const geometryInfo = geometryInfoList[geometryId];
                    const z = $ee56638efea8544d$var$_temp.subVectors($ee56638efea8544d$var$_sphere$2.center, $ee56638efea8544d$var$_vector$5).dot($ee56638efea8544d$var$_forward);
                    $ee56638efea8544d$var$_renderList.push(geometryInfo.start, geometryInfo.count, z, i);
                }
            }
            // Sort the draw ranges and prep for rendering
            const list = $ee56638efea8544d$var$_renderList.list;
            const customSort = this.customSort;
            if (customSort === null) list.sort(material.transparent ? $ee56638efea8544d$var$sortTransparent : $ee56638efea8544d$var$sortOpaque);
            else customSort.call(this, list, camera);
            for(let i = 0, l = list.length; i < l; i++){
                const item = list[i];
                multiDrawStarts[multiDrawCount] = item.start * bytesPerElement;
                multiDrawCounts[multiDrawCount] = item.count;
                indirectArray[multiDrawCount] = item.index;
                multiDrawCount++;
            }
            $ee56638efea8544d$var$_renderList.reset();
        } else {
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) {
                    // get the bounds in world space
                    this.getMatrixAt(i, $ee56638efea8544d$var$_matrix$1);
                    this.getBoundingSphereAt(geometryId, $ee56638efea8544d$var$_sphere$2).applyMatrix4($ee56638efea8544d$var$_matrix$1);
                    culled = !$ee56638efea8544d$var$_frustum.intersectsSphere($ee56638efea8544d$var$_sphere$2);
                }
                if (!culled) {
                    const geometryInfo = geometryInfoList[geometryId];
                    multiDrawStarts[multiDrawCount] = geometryInfo.start * bytesPerElement;
                    multiDrawCounts[multiDrawCount] = geometryInfo.count;
                    indirectArray[multiDrawCount] = i;
                    multiDrawCount++;
                }
            }
        }
        indirectTexture.needsUpdate = true;
        this._multiDrawCount = multiDrawCount;
        this._visibilityChanged = false;
    }
    onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
        this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
    }
}
class $ee56638efea8544d$export$fbaaa33907730a0c extends $ee56638efea8544d$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        this.color = new $ee56638efea8544d$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.linewidth = 1;
        this.linecap = 'round';
        this.linejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const $ee56638efea8544d$var$_vStart = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_vEnd = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_inverseMatrix$1 = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_ray$1 = /*@__PURE__*/ new $ee56638efea8544d$export$a186db52eed6d40e();
const $ee56638efea8544d$var$_sphere$1 = /*@__PURE__*/ new $ee56638efea8544d$export$805e8b72413ccaba();
const $ee56638efea8544d$var$_intersectPointOnRay = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_intersectPointOnSegment = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$17d680238e50603e extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(geometry = new $ee56638efea8544d$export$b7be63a67df8959(), material = new $ee56638efea8544d$export$fbaaa33907730a0c()){
        super();
        this.isLine = true;
        this.type = 'Line';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                $ee56638efea8544d$var$_vStart.fromBufferAttribute(positionAttribute, i - 1);
                $ee56638efea8544d$var$_vEnd.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += $ee56638efea8544d$var$_vStart.distanceTo($ee56638efea8544d$var$_vEnd);
            }
            geometry.setAttribute('lineDistance', new $ee56638efea8544d$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $ee56638efea8544d$var$_sphere$1.copy(geometry.boundingSphere);
        $ee56638efea8544d$var$_sphere$1.applyMatrix4(matrixWorld);
        $ee56638efea8544d$var$_sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere($ee56638efea8544d$var$_sphere$1) === false) return;
        //
        $ee56638efea8544d$var$_inverseMatrix$1.copy(matrixWorld).invert();
        $ee56638efea8544d$var$_ray$1.copy(raycaster.ray).applyMatrix4($ee56638efea8544d$var$_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                const intersect = $ee56638efea8544d$var$checkIntersection(this, raycaster, $ee56638efea8544d$var$_ray$1, localThresholdSq, a, b);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const a = index.getX(end - 1);
                const b = index.getX(start);
                const intersect = $ee56638efea8544d$var$checkIntersection(this, raycaster, $ee56638efea8544d$var$_ray$1, localThresholdSq, a, b);
                if (intersect) intersects.push(intersect);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const intersect = $ee56638efea8544d$var$checkIntersection(this, raycaster, $ee56638efea8544d$var$_ray$1, localThresholdSq, i, i + 1);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const intersect = $ee56638efea8544d$var$checkIntersection(this, raycaster, $ee56638efea8544d$var$_ray$1, localThresholdSq, end - 1, start);
                if (intersect) intersects.push(intersect);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $ee56638efea8544d$var$checkIntersection(object, raycaster, ray, thresholdSq, a, b) {
    const positionAttribute = object.geometry.attributes.position;
    $ee56638efea8544d$var$_vStart.fromBufferAttribute(positionAttribute, a);
    $ee56638efea8544d$var$_vEnd.fromBufferAttribute(positionAttribute, b);
    const distSq = ray.distanceSqToSegment($ee56638efea8544d$var$_vStart, $ee56638efea8544d$var$_vEnd, $ee56638efea8544d$var$_intersectPointOnRay, $ee56638efea8544d$var$_intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    $ee56638efea8544d$var$_intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    const distance = raycaster.ray.origin.distanceTo($ee56638efea8544d$var$_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: $ee56638efea8544d$var$_intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: a,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: object
    };
}
const $ee56638efea8544d$var$_start = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_end = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$ff1ed10fedfdd604 extends $ee56638efea8544d$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                $ee56638efea8544d$var$_start.fromBufferAttribute(positionAttribute, i);
                $ee56638efea8544d$var$_end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + $ee56638efea8544d$var$_start.distanceTo($ee56638efea8544d$var$_end);
            }
            geometry.setAttribute('lineDistance', new $ee56638efea8544d$export$cbe7a62641830ebd(lineDistances, 1));
        } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
class $ee56638efea8544d$export$f85a24d745e4f17d extends $ee56638efea8544d$export$17d680238e50603e {
    constructor(geometry, material){
        super(geometry, material);
        this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
class $ee56638efea8544d$export$a178c45366ce5d6b extends $ee56638efea8544d$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        this.color = new $ee56638efea8544d$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.alphaMap = null;
        this.size = 1;
        this.sizeAttenuation = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const $ee56638efea8544d$var$_inverseMatrix = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_ray = /*@__PURE__*/ new $ee56638efea8544d$export$a186db52eed6d40e();
const $ee56638efea8544d$var$_sphere = /*@__PURE__*/ new $ee56638efea8544d$export$805e8b72413ccaba();
const $ee56638efea8544d$var$_position$2 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$1c787534cb11aa3e extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(geometry = new $ee56638efea8544d$export$b7be63a67df8959(), material = new $ee56638efea8544d$export$a178c45366ce5d6b()){
        super();
        this.isPoints = true;
        this.type = 'Points';
        this.geometry = geometry;
        this.material = material;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        $ee56638efea8544d$var$_sphere.copy(geometry.boundingSphere);
        $ee56638efea8544d$var$_sphere.applyMatrix4(matrixWorld);
        $ee56638efea8544d$var$_sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere($ee56638efea8544d$var$_sphere) === false) return;
        //
        $ee56638efea8544d$var$_inverseMatrix.copy(matrixWorld).invert();
        $ee56638efea8544d$var$_ray.copy(raycaster.ray).applyMatrix4($ee56638efea8544d$var$_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                $ee56638efea8544d$var$_position$2.fromBufferAttribute(positionAttribute, a);
                $ee56638efea8544d$var$testPoint($ee56638efea8544d$var$_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                $ee56638efea8544d$var$_position$2.fromBufferAttribute(positionAttribute, i);
                $ee56638efea8544d$var$testPoint($ee56638efea8544d$var$_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function $ee56638efea8544d$var$testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = $ee56638efea8544d$var$_ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new $ee56638efea8544d$export$64b5c384219d3699();
        $ee56638efea8544d$var$_ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: object
        });
    }
}
class $ee56638efea8544d$export$eb2fcfdbd7ba97d4 extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.isGroup = true;
        this.type = 'Group';
    }
}
class $ee56638efea8544d$export$6e09d1edf8d5a25c extends $ee56638efea8544d$export$5431306cf43de24a {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isVideoTexture = true;
        this.minFilter = minFilter !== undefined ? minFilter : $ee56638efea8544d$export$8a72f490b25c56c8;
        this.magFilter = magFilter !== undefined ? magFilter : $ee56638efea8544d$export$8a72f490b25c56c8;
        this.generateMipmaps = false;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
}
class $ee56638efea8544d$export$9270d786f73ce6fe extends $ee56638efea8544d$export$5431306cf43de24a {
    constructor(width, height){
        super({
            width: width,
            height: height
        });
        this.isFramebufferTexture = true;
        this.magFilter = $ee56638efea8544d$export$727aa5ec3fe39bf0;
        this.minFilter = $ee56638efea8544d$export$727aa5ec3fe39bf0;
        this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
class $ee56638efea8544d$export$3466bac9141a5cc4 extends $ee56638efea8544d$export$5431306cf43de24a {
    constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        this.isCompressedTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.mipmaps = mipmaps;
        // no flipping for cube textures
        // (also flipping doesn't work for compressed textures )
        this.flipY = false;
        // can't generate mipmaps for compressed textures
        // mips must be embedded in DDS files
        this.generateMipmaps = false;
    }
}
class $ee56638efea8544d$export$5fe6b8e34b274fcb extends $ee56638efea8544d$export$3466bac9141a5cc4 {
    constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        this.isCompressedArrayTexture = true;
        this.image.depth = depth;
        this.wrapR = $ee56638efea8544d$export$9d9334239a5a5e06;
        this.layerUpdates = new Set();
    }
    addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
class $ee56638efea8544d$export$d80173634de65bff extends $ee56638efea8544d$export$3466bac9141a5cc4 {
    constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, $ee56638efea8544d$export$8759762a6477f2c4);
        this.isCompressedCubeTexture = true;
        this.isCubeTexture = true;
        this.image = images;
    }
}
class $ee56638efea8544d$export$f7189e49152d1c13 extends $ee56638efea8544d$export$5431306cf43de24a {
    constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
class $ee56638efea8544d$export$fc830aa069cc8c2f extends $ee56638efea8544d$export$5431306cf43de24a {
    constructor(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format = $ee56638efea8544d$export$c1b6b5136be58045){
        if (format !== $ee56638efea8544d$export$c1b6b5136be58045 && format !== $ee56638efea8544d$export$1e113ac2d0905829) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        if (type === undefined && format === $ee56638efea8544d$export$c1b6b5136be58045) type = $ee56638efea8544d$export$c3c7fc4518ebba96;
        if (type === undefined && format === $ee56638efea8544d$export$1e113ac2d0905829) type = $ee56638efea8544d$export$6c8ea339bfab1301;
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        this.isDepthTexture = true;
        this.image = {
            width: width,
            height: height
        };
        this.magFilter = magFilter !== undefined ? magFilter : $ee56638efea8544d$export$727aa5ec3fe39bf0;
        this.minFilter = minFilter !== undefined ? minFilter : $ee56638efea8544d$export$727aa5ec3fe39bf0;
        this.flipY = false;
        this.generateMipmaps = false;
        this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ class $ee56638efea8544d$export$b0e83c3ef8d2db1 {
    constructor(){
        this.type = 'Curve';
        this.arcLengthDivisions = 200;
    }
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint() {
        console.warn('THREE.Curve: .getPoint() not implemented.');
        return null;
    }
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    // Get sequence of points using getPoint( t )
    getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    // Get total curve arc length
    getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    // Get list of cumulative segment lengths
    getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new $ee56638efea8544d$export$c977b3e384af9ae1() : new $ee56638efea8544d$export$64b5c384219d3699());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    computeFrenetFrames(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new $ee56638efea8544d$export$64b5c384219d3699();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new $ee56638efea8544d$export$64b5c384219d3699();
        const mat = new $ee56638efea8544d$export$2ae72fc923e5eb5();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new $ee56638efea8544d$export$64b5c384219d3699());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new $ee56638efea8544d$export$64b5c384219d3699();
        binormals[0] = new $ee56638efea8544d$export$64b5c384219d3699();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos($ee56638efea8544d$var$clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos($ee56638efea8544d$var$clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    toJSON() {
        const data = {
            metadata: {
                version: 4.6,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
class $ee56638efea8544d$export$3f87a931616cde04 extends $ee56638efea8544d$export$b0e83c3ef8d2db1 {
    constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        this.aX = aX;
        this.aY = aY;
        this.xRadius = xRadius;
        this.yRadius = yRadius;
        this.aStartAngle = aStartAngle;
        this.aEndAngle = aEndAngle;
        this.aClockwise = aClockwise;
        this.aRotation = aRotation;
    }
    getPoint(t, optionalTarget = new $ee56638efea8544d$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
class $ee56638efea8544d$export$b1eedc9aab6300e8 extends $ee56638efea8544d$export$3f87a931616cde04 {
    constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function $ee56638efea8544d$var$CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const $ee56638efea8544d$var$tmp = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$px = /*@__PURE__*/ new $ee56638efea8544d$var$CubicPoly();
const $ee56638efea8544d$var$py = /*@__PURE__*/ new $ee56638efea8544d$var$CubicPoly();
const $ee56638efea8544d$var$pz = /*@__PURE__*/ new $ee56638efea8544d$var$CubicPoly();
class $ee56638efea8544d$export$b9146b27c24b744c extends $ee56638efea8544d$export$b0e83c3ef8d2db1 {
    constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        this.points = points;
        this.closed = closed;
        this.curveType = curveType;
        this.tension = tension;
    }
    getPoint(t, optionalTarget = new $ee56638efea8544d$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            $ee56638efea8544d$var$tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = $ee56638efea8544d$var$tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            $ee56638efea8544d$var$tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = $ee56638efea8544d$var$tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            $ee56638efea8544d$var$px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            $ee56638efea8544d$var$py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            $ee56638efea8544d$var$pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            $ee56638efea8544d$var$px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            $ee56638efea8544d$var$py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            $ee56638efea8544d$var$pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set($ee56638efea8544d$var$px.calc(weight), $ee56638efea8544d$var$py.calc(weight), $ee56638efea8544d$var$pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $ee56638efea8544d$export$64b5c384219d3699().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Bezier Curves formulas obtained from
 * https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 */ function $ee56638efea8544d$var$CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function $ee56638efea8544d$var$QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function $ee56638efea8544d$var$QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function $ee56638efea8544d$var$QuadraticBezierP2(t, p) {
    return t * t * p;
}
function $ee56638efea8544d$var$QuadraticBezier(t, p0, p1, p2) {
    return $ee56638efea8544d$var$QuadraticBezierP0(t, p0) + $ee56638efea8544d$var$QuadraticBezierP1(t, p1) + $ee56638efea8544d$var$QuadraticBezierP2(t, p2);
}
//
function $ee56638efea8544d$var$CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function $ee56638efea8544d$var$CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function $ee56638efea8544d$var$CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function $ee56638efea8544d$var$CubicBezierP3(t, p) {
    return t * t * t * p;
}
function $ee56638efea8544d$var$CubicBezier(t, p0, p1, p2, p3) {
    return $ee56638efea8544d$var$CubicBezierP0(t, p0) + $ee56638efea8544d$var$CubicBezierP1(t, p1) + $ee56638efea8544d$var$CubicBezierP2(t, p2) + $ee56638efea8544d$var$CubicBezierP3(t, p3);
}
class $ee56638efea8544d$export$e36650d36468bb39 extends $ee56638efea8544d$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $ee56638efea8544d$export$c977b3e384af9ae1(), v1 = new $ee56638efea8544d$export$c977b3e384af9ae1(), v2 = new $ee56638efea8544d$export$c977b3e384af9ae1(), v3 = new $ee56638efea8544d$export$c977b3e384af9ae1()){
        super();
        this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $ee56638efea8544d$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($ee56638efea8544d$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $ee56638efea8544d$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $ee56638efea8544d$export$13d5f1c9525f246c extends $ee56638efea8544d$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $ee56638efea8544d$export$64b5c384219d3699(), v1 = new $ee56638efea8544d$export$64b5c384219d3699(), v2 = new $ee56638efea8544d$export$64b5c384219d3699(), v3 = new $ee56638efea8544d$export$64b5c384219d3699()){
        super();
        this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
        this.v3 = v3;
    }
    getPoint(t, optionalTarget = new $ee56638efea8544d$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set($ee56638efea8544d$var$CubicBezier(t, v0.x, v1.x, v2.x, v3.x), $ee56638efea8544d$var$CubicBezier(t, v0.y, v1.y, v2.y, v3.y), $ee56638efea8544d$var$CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
class $ee56638efea8544d$export$ab2e07e76531a47e extends $ee56638efea8544d$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $ee56638efea8544d$export$c977b3e384af9ae1(), v2 = new $ee56638efea8544d$export$c977b3e384af9ae1()){
        super();
        this.isLineCurve = true;
        this.type = 'LineCurve';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $ee56638efea8544d$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $ee56638efea8544d$export$c977b3e384af9ae1()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $ee56638efea8544d$export$1fdfd9d9cf487600 extends $ee56638efea8544d$export$b0e83c3ef8d2db1 {
    constructor(v1 = new $ee56638efea8544d$export$64b5c384219d3699(), v2 = new $ee56638efea8544d$export$64b5c384219d3699()){
        super();
        this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $ee56638efea8544d$export$64b5c384219d3699()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new $ee56638efea8544d$export$64b5c384219d3699()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $ee56638efea8544d$export$5938c4ee491a43ad extends $ee56638efea8544d$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $ee56638efea8544d$export$c977b3e384af9ae1(), v1 = new $ee56638efea8544d$export$c977b3e384af9ae1(), v2 = new $ee56638efea8544d$export$c977b3e384af9ae1()){
        super();
        this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $ee56638efea8544d$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($ee56638efea8544d$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $ee56638efea8544d$var$QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $ee56638efea8544d$export$bf3f4c7e459f90fc extends $ee56638efea8544d$export$b0e83c3ef8d2db1 {
    constructor(v0 = new $ee56638efea8544d$export$64b5c384219d3699(), v1 = new $ee56638efea8544d$export$64b5c384219d3699(), v2 = new $ee56638efea8544d$export$64b5c384219d3699()){
        super();
        this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        this.v0 = v0;
        this.v1 = v1;
        this.v2 = v2;
    }
    getPoint(t, optionalTarget = new $ee56638efea8544d$export$64b5c384219d3699()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set($ee56638efea8544d$var$QuadraticBezier(t, v0.x, v1.x, v2.x), $ee56638efea8544d$var$QuadraticBezier(t, v0.y, v1.y, v2.y), $ee56638efea8544d$var$QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
class $ee56638efea8544d$export$d3bdd77da77afc1b extends $ee56638efea8544d$export$b0e83c3ef8d2db1 {
    constructor(points = []){
        super();
        this.isSplineCurve = true;
        this.type = 'SplineCurve';
        this.points = points;
    }
    getPoint(t, optionalTarget = new $ee56638efea8544d$export$c977b3e384af9ae1()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set($ee56638efea8544d$var$CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), $ee56638efea8544d$var$CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new $ee56638efea8544d$export$c977b3e384af9ae1().fromArray(point));
        }
        return this;
    }
}
var $ee56638efea8544d$var$Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: $ee56638efea8544d$export$b1eedc9aab6300e8,
    CatmullRomCurve3: $ee56638efea8544d$export$b9146b27c24b744c,
    CubicBezierCurve: $ee56638efea8544d$export$e36650d36468bb39,
    CubicBezierCurve3: $ee56638efea8544d$export$13d5f1c9525f246c,
    EllipseCurve: $ee56638efea8544d$export$3f87a931616cde04,
    LineCurve: $ee56638efea8544d$export$ab2e07e76531a47e,
    LineCurve3: $ee56638efea8544d$export$1fdfd9d9cf487600,
    QuadraticBezierCurve: $ee56638efea8544d$export$5938c4ee491a43ad,
    QuadraticBezierCurve3: $ee56638efea8544d$export$bf3f4c7e459f90fc,
    SplineCurve: $ee56638efea8544d$export$d3bdd77da77afc1b
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ class $ee56638efea8544d$export$4aaf9b66af1bbf2c extends $ee56638efea8544d$export$b0e83c3ef8d2db1 {
    constructor(){
        super();
        this.type = 'CurvePath';
        this.curves = [];
        this.autoClose = false; // Automatically closes the path
    }
    add(curve) {
        this.curves.push(curve);
    }
    closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
            this.curves.push(new $ee56638efea8544d$var$Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint(t, optionalTarget) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    // cacheLengths must be recalculated.
    updateArcLengths() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new $ee56638efea8544d$var$Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
class $ee56638efea8544d$export$4b2950bdac9b6ee9 extends $ee56638efea8544d$export$4aaf9b66af1bbf2c {
    constructor(points){
        super();
        this.type = 'Path';
        this.currentPoint = new $ee56638efea8544d$export$c977b3e384af9ae1();
        if (points) this.setFromPoints(points);
    }
    setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    lineTo(x, y) {
        const curve = new $ee56638efea8544d$export$ab2e07e76531a47e(this.currentPoint.clone(), new $ee56638efea8544d$export$c977b3e384af9ae1(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new $ee56638efea8544d$export$5938c4ee491a43ad(this.currentPoint.clone(), new $ee56638efea8544d$export$c977b3e384af9ae1(aCPx, aCPy), new $ee56638efea8544d$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new $ee56638efea8544d$export$e36650d36468bb39(this.currentPoint.clone(), new $ee56638efea8544d$export$c977b3e384af9ae1(aCP1x, aCP1y), new $ee56638efea8544d$export$c977b3e384af9ae1(aCP2x, aCP2y), new $ee56638efea8544d$export$c977b3e384af9ae1(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    splineThru(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new $ee56638efea8544d$export$d3bdd77da77afc1b(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new $ee56638efea8544d$export$3f87a931616cde04(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
class $ee56638efea8544d$export$6d839803fcd1882c extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(points = [
        new $ee56638efea8544d$export$c977b3e384af9ae1(0, -0.5),
        new $ee56638efea8544d$export$c977b3e384af9ae1(0.5, 0),
        new $ee56638efea8544d$export$c977b3e384af9ae1(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = $ee56638efea8544d$var$clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new $ee56638efea8544d$export$64b5c384219d3699();
        const uv = new $ee56638efea8544d$export$c977b3e384af9ae1();
        const normal = new $ee56638efea8544d$export$64b5c384219d3699();
        const curNormal = new $ee56638efea8544d$export$64b5c384219d3699();
        const prevNormal = new $ee56638efea8544d$export$64b5c384219d3699();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('uv', new $ee56638efea8544d$export$cbe7a62641830ebd(uvs, 2));
        this.setAttribute('normal', new $ee56638efea8544d$export$cbe7a62641830ebd(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$6d839803fcd1882c(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
class $ee56638efea8544d$export$41680e8551036033 extends $ee56638efea8544d$export$6d839803fcd1882c {
    constructor(radius = 1, length = 1, capSegments = 4, radialSegments = 8){
        const path = new $ee56638efea8544d$export$4b2950bdac9b6ee9();
        path.absarc(0, -length / 2, radius, Math.PI * 1.5, 0);
        path.absarc(0, length / 2, radius, 0, Math.PI * 0.5);
        super(path.getPoints(capSegments), radialSegments);
        this.type = 'CapsuleGeometry';
        this.parameters = {
            radius: radius,
            length: length,
            capSegments: capSegments,
            radialSegments: radialSegments
        };
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$41680e8551036033(data.radius, data.length, data.capSegments, data.radialSegments);
    }
}
class $ee56638efea8544d$export$d5c0e8d607467193 extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $ee56638efea8544d$export$64b5c384219d3699();
        const uv = new $ee56638efea8544d$export$c977b3e384af9ae1();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ee56638efea8544d$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ee56638efea8544d$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$d5c0e8d607467193(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
class $ee56638efea8544d$export$68f745719dbe5198 extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ee56638efea8544d$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ee56638efea8544d$export$cbe7a62641830ebd(uvs, 2));
        function generateTorso() {
            const normal = new $ee56638efea8544d$export$64b5c384219d3699();
            const vertex = new $ee56638efea8544d$export$64b5c384219d3699();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                if (radiusTop > 0 || y !== 0) {
                    indices.push(a, b, d);
                    groupCount += 3;
                }
                if (radiusBottom > 0 || y !== heightSegments - 1) {
                    indices.push(b, c, d);
                    groupCount += 3;
                }
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new $ee56638efea8544d$export$c977b3e384af9ae1();
            const vertex = new $ee56638efea8544d$export$64b5c384219d3699();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$68f745719dbe5198(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $ee56638efea8544d$export$a7a48974f285c9b3 extends $ee56638efea8544d$export$68f745719dbe5198 {
    constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$a7a48974f285c9b3(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
class $ee56638efea8544d$export$60e57a7d3f20ff65 extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertexBuffer, 3));
        this.setAttribute('normal', new $ee56638efea8544d$export$cbe7a62641830ebd(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new $ee56638efea8544d$export$cbe7a62641830ebd(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new $ee56638efea8544d$export$64b5c384219d3699();
            const b = new $ee56638efea8544d$export$64b5c384219d3699();
            const c = new $ee56638efea8544d$export$64b5c384219d3699();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new $ee56638efea8544d$export$64b5c384219d3699();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new $ee56638efea8544d$export$64b5c384219d3699();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new $ee56638efea8544d$export$64b5c384219d3699();
            const b = new $ee56638efea8544d$export$64b5c384219d3699();
            const c = new $ee56638efea8544d$export$64b5c384219d3699();
            const centroid = new $ee56638efea8544d$export$64b5c384219d3699();
            const uvA = new $ee56638efea8544d$export$c977b3e384af9ae1();
            const uvB = new $ee56638efea8544d$export$c977b3e384af9ae1();
            const uvC = new $ee56638efea8544d$export$c977b3e384af9ae1();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$60e57a7d3f20ff65(data.vertices, data.indices, data.radius, data.details);
    }
}
class $ee56638efea8544d$export$c0babfeb8708fc9c extends $ee56638efea8544d$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$c0babfeb8708fc9c(data.radius, data.detail);
    }
}
const $ee56638efea8544d$var$_v0 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_v1$1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_normal = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_triangle = /*@__PURE__*/ new $ee56638efea8544d$export$5a465592bfe74b48();
class $ee56638efea8544d$export$4730b1542707547f extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos($ee56638efea8544d$var$DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a: a, b: b, c: c } = $ee56638efea8544d$var$_triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                $ee56638efea8544d$var$_triangle.getNormal($ee56638efea8544d$var$_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = $ee56638efea8544d$var$_triangle[vertKeys[j]];
                    const v1 = $ee56638efea8544d$var$_triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if ($ee56638efea8544d$var$_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: $ee56638efea8544d$var$_normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0: index0, index1: index1 } = edgeData[key];
                $ee56638efea8544d$var$_v0.fromBufferAttribute(positionAttr, index0);
                $ee56638efea8544d$var$_v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push($ee56638efea8544d$var$_v0.x, $ee56638efea8544d$var$_v0.y, $ee56638efea8544d$var$_v0.z);
                vertices.push($ee56638efea8544d$var$_v1$1.x, $ee56638efea8544d$var$_v1$1.y, $ee56638efea8544d$var$_v1$1.z);
            }
            this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
class $ee56638efea8544d$export$6428a7f2611ef1fa extends $ee56638efea8544d$export$4b2950bdac9b6ee9 {
    constructor(points){
        super(points);
        this.uuid = $ee56638efea8544d$var$generateUUID();
        this.type = 'Shape';
        this.holes = [];
    }
    getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new $ee56638efea8544d$export$4b2950bdac9b6ee9().fromJSON(hole));
        }
        return this;
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.4)
 */ const $ee56638efea8544d$var$Earcut = {
    triangulate: function(data, holeIndices, dim = 2) {
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = $ee56638efea8544d$var$linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = $ee56638efea8544d$var$eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 32767 / invSize : 0;
        }
        $ee56638efea8544d$var$earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function $ee56638efea8544d$var$linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === $ee56638efea8544d$var$signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = $ee56638efea8544d$var$insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = $ee56638efea8544d$var$insertNode(i, data[i], data[i + 1], last);
    if (last && $ee56638efea8544d$var$equals(last, last.next)) {
        $ee56638efea8544d$var$removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function $ee56638efea8544d$var$filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && ($ee56638efea8544d$var$equals(p, p.next) || $ee56638efea8544d$var$area(p.prev, p, p.next) === 0)) {
            $ee56638efea8544d$var$removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function $ee56638efea8544d$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) $ee56638efea8544d$var$indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? $ee56638efea8544d$var$isEarHashed(ear, minX, minY, invSize) : $ee56638efea8544d$var$isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim | 0);
            triangles.push(ear.i / dim | 0);
            triangles.push(next.i / dim | 0);
            $ee56638efea8544d$var$removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) $ee56638efea8544d$var$earcutLinked($ee56638efea8544d$var$filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = $ee56638efea8544d$var$cureLocalIntersections($ee56638efea8544d$var$filterPoints(ear), triangles, dim);
                $ee56638efea8544d$var$earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) $ee56638efea8544d$var$splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function $ee56638efea8544d$var$isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($ee56638efea8544d$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && $ee56638efea8544d$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $ee56638efea8544d$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function $ee56638efea8544d$var$isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if ($ee56638efea8544d$var$area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox; min & max are calculated like this for speed
    const x0 = ax < bx ? ax < cx ? ax : cx : bx < cx ? bx : cx, y0 = ay < by ? ay < cy ? ay : cy : by < cy ? by : cy, x1 = ax > bx ? ax > cx ? ax : cx : bx > cx ? bx : cx, y1 = ay > by ? ay > cy ? ay : cy : by > cy ? by : cy;
    // z-order range for the current triangle bbox;
    const minZ = $ee56638efea8544d$var$zOrder(x0, y0, minX, minY, invSize), maxZ = $ee56638efea8544d$var$zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $ee56638efea8544d$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $ee56638efea8544d$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $ee56638efea8544d$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $ee56638efea8544d$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && $ee56638efea8544d$var$pointInTriangle(ax, ay, bx, by, cx, cy, p.x, p.y) && $ee56638efea8544d$var$area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && $ee56638efea8544d$var$pointInTriangle(ax, ay, bx, by, cx, cy, n.x, n.y) && $ee56638efea8544d$var$area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function $ee56638efea8544d$var$cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!$ee56638efea8544d$var$equals(a, b) && $ee56638efea8544d$var$intersects(a, p, p.next, b) && $ee56638efea8544d$var$locallyInside(a, b) && $ee56638efea8544d$var$locallyInside(b, a)) {
            triangles.push(a.i / dim | 0);
            triangles.push(p.i / dim | 0);
            triangles.push(b.i / dim | 0);
            // remove two nodes involved
            $ee56638efea8544d$var$removeNode(p);
            $ee56638efea8544d$var$removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return $ee56638efea8544d$var$filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function $ee56638efea8544d$var$splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && $ee56638efea8544d$var$isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = $ee56638efea8544d$var$splitPolygon(a, b);
                // filter colinear points around the cuts
                a = $ee56638efea8544d$var$filterPoints(a, a.next);
                c = $ee56638efea8544d$var$filterPoints(c, c.next);
                // run earcut on each half
                $ee56638efea8544d$var$earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                $ee56638efea8544d$var$earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function $ee56638efea8544d$var$eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = $ee56638efea8544d$var$linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push($ee56638efea8544d$var$getLeftmost(list));
    }
    queue.sort($ee56638efea8544d$var$compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++)outerNode = $ee56638efea8544d$var$eliminateHole(queue[i], outerNode);
    return outerNode;
}
function $ee56638efea8544d$var$compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function $ee56638efea8544d$var$eliminateHole(hole, outerNode) {
    const bridge = $ee56638efea8544d$var$findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = $ee56638efea8544d$var$splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    $ee56638efea8544d$var$filterPoints(bridgeReverse, bridgeReverse.next);
    return $ee56638efea8544d$var$filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function $ee56638efea8544d$var$findHoleBridge(hole, outerNode) {
    let p = outerNode, qx = -Infinity, m;
    const hx = hole.x, hy = hole.y;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && $ee56638efea8544d$var$pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if ($ee56638efea8544d$var$locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && $ee56638efea8544d$var$sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function $ee56638efea8544d$var$sectorContainsSector(m, p) {
    return $ee56638efea8544d$var$area(m.prev, m, p.prev) < 0 && $ee56638efea8544d$var$area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function $ee56638efea8544d$var$indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = $ee56638efea8544d$var$zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    $ee56638efea8544d$var$sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function $ee56638efea8544d$var$sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function $ee56638efea8544d$var$zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function $ee56638efea8544d$var$getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function $ee56638efea8544d$var$pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function $ee56638efea8544d$var$isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !$ee56638efea8544d$var$intersectsPolygon(a, b) && // doesn't intersect other edges
    ($ee56638efea8544d$var$locallyInside(a, b) && $ee56638efea8544d$var$locallyInside(b, a) && $ee56638efea8544d$var$middleInside(a, b) && // locally visible
    ($ee56638efea8544d$var$area(a.prev, a, b.prev) || $ee56638efea8544d$var$area(a, b.prev, b)) || // does not create opposite-facing sectors
    $ee56638efea8544d$var$equals(a, b) && $ee56638efea8544d$var$area(a.prev, a, a.next) > 0 && $ee56638efea8544d$var$area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function $ee56638efea8544d$var$area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function $ee56638efea8544d$var$equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function $ee56638efea8544d$var$intersects(p1, q1, p2, q2) {
    const o1 = $ee56638efea8544d$var$sign($ee56638efea8544d$var$area(p1, q1, p2));
    const o2 = $ee56638efea8544d$var$sign($ee56638efea8544d$var$area(p1, q1, q2));
    const o3 = $ee56638efea8544d$var$sign($ee56638efea8544d$var$area(p2, q2, p1));
    const o4 = $ee56638efea8544d$var$sign($ee56638efea8544d$var$area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && $ee56638efea8544d$var$onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && $ee56638efea8544d$var$onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && $ee56638efea8544d$var$onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && $ee56638efea8544d$var$onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function $ee56638efea8544d$var$onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function $ee56638efea8544d$var$sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function $ee56638efea8544d$var$intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && $ee56638efea8544d$var$intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function $ee56638efea8544d$var$locallyInside(a, b) {
    return $ee56638efea8544d$var$area(a.prev, a, a.next) < 0 ? $ee56638efea8544d$var$area(a, b, a.next) >= 0 && $ee56638efea8544d$var$area(a, a.prev, b) >= 0 : $ee56638efea8544d$var$area(a, b, a.prev) < 0 || $ee56638efea8544d$var$area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function $ee56638efea8544d$var$middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function $ee56638efea8544d$var$splitPolygon(a, b) {
    const a2 = new $ee56638efea8544d$var$Node(a.i, a.x, a.y), b2 = new $ee56638efea8544d$var$Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function $ee56638efea8544d$var$insertNode(i, x, y, last) {
    const p = new $ee56638efea8544d$var$Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function $ee56638efea8544d$var$removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function $ee56638efea8544d$var$Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = 0;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function $ee56638efea8544d$var$signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
class $ee56638efea8544d$export$96bdf6d9c66d7ba8 {
    // calculate area of the contour polygon
    static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    static isClockWise(pts) {
        return $ee56638efea8544d$export$96bdf6d9c66d7ba8.area(pts) < 0;
    }
    static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        $ee56638efea8544d$var$removeDupEndPts(contour);
        $ee56638efea8544d$var$addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach($ee56638efea8544d$var$removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            $ee56638efea8544d$var$addContour(vertices, holes[i]);
        }
        //
        const triangles = $ee56638efea8544d$var$Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function $ee56638efea8544d$var$removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function $ee56638efea8544d$var$addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class $ee56638efea8544d$export$598697a1efa63ca7 extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(shapes = new $ee56638efea8544d$export$6428a7f2611ef1fa([
        new $ee56638efea8544d$export$c977b3e384af9ae1(0.5, 0.5),
        new $ee56638efea8544d$export$c977b3e384af9ae1(-0.5, 0.5),
        new $ee56638efea8544d$export$c977b3e384af9ae1(-0.5, -0.5),
        new $ee56638efea8544d$export$c977b3e384af9ae1(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(verticesArray, 3));
        this.setAttribute('uv', new $ee56638efea8544d$export$cbe7a62641830ebd(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : $ee56638efea8544d$var$WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new $ee56638efea8544d$export$64b5c384219d3699();
                normal = new $ee56638efea8544d$export$64b5c384219d3699();
                position2 = new $ee56638efea8544d$export$64b5c384219d3699();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !$ee56638efea8544d$export$96bdf6d9c66d7ba8.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if ($ee56638efea8544d$export$96bdf6d9c66d7ba8.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = $ee56638efea8544d$export$96bdf6d9c66d7ba8.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new $ee56638efea8544d$export$c977b3e384af9ae1(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new $ee56638efea8544d$export$c977b3e384af9ae1(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return $ee56638efea8544d$var$toJSON$1(shapes, options, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new $ee56638efea8544d$var$Curves[extrudePath.type]().fromJSON(extrudePath);
        return new $ee56638efea8544d$export$598697a1efa63ca7(geometryShapes, data.options);
    }
}
const $ee56638efea8544d$var$WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new $ee56638efea8544d$export$c977b3e384af9ae1(a_x, a_y),
            new $ee56638efea8544d$export$c977b3e384af9ae1(b_x, b_y),
            new $ee56638efea8544d$export$c977b3e384af9ae1(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new $ee56638efea8544d$export$c977b3e384af9ae1(a_x, 1 - a_z),
            new $ee56638efea8544d$export$c977b3e384af9ae1(b_x, 1 - b_z),
            new $ee56638efea8544d$export$c977b3e384af9ae1(c_x, 1 - c_z),
            new $ee56638efea8544d$export$c977b3e384af9ae1(d_x, 1 - d_z)
        ];
        else return [
            new $ee56638efea8544d$export$c977b3e384af9ae1(a_y, 1 - a_z),
            new $ee56638efea8544d$export$c977b3e384af9ae1(b_y, 1 - b_z),
            new $ee56638efea8544d$export$c977b3e384af9ae1(c_y, 1 - c_z),
            new $ee56638efea8544d$export$c977b3e384af9ae1(d_y, 1 - d_z)
        ];
    }
};
function $ee56638efea8544d$var$toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class $ee56638efea8544d$export$9567cc828c9535da extends $ee56638efea8544d$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$9567cc828c9535da(data.radius, data.detail);
    }
}
class $ee56638efea8544d$export$1954e2b809fe361e extends $ee56638efea8544d$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$1954e2b809fe361e(data.radius, data.detail);
    }
}
class $ee56638efea8544d$export$967d831af31f69ce extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ee56638efea8544d$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ee56638efea8544d$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$967d831af31f69ce(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
class $ee56638efea8544d$export$68cb731f50f614af extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new $ee56638efea8544d$export$64b5c384219d3699();
        const uv = new $ee56638efea8544d$export$c977b3e384af9ae1();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ee56638efea8544d$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ee56638efea8544d$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$68cb731f50f614af(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
class $ee56638efea8544d$export$57a29a1c803e9065 extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(shapes = new $ee56638efea8544d$export$6428a7f2611ef1fa([
        new $ee56638efea8544d$export$c977b3e384af9ae1(0, 0.5),
        new $ee56638efea8544d$export$c977b3e384af9ae1(-0.5, -0.5),
        new $ee56638efea8544d$export$c977b3e384af9ae1(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ee56638efea8544d$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ee56638efea8544d$export$cbe7a62641830ebd(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if ($ee56638efea8544d$export$96bdf6d9c66d7ba8.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if ($ee56638efea8544d$export$96bdf6d9c66d7ba8.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = $ee56638efea8544d$export$96bdf6d9c66d7ba8.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return $ee56638efea8544d$var$toJSON(shapes, data);
    }
    static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new $ee56638efea8544d$export$57a29a1c803e9065(geometryShapes, data.curveSegments);
    }
}
function $ee56638efea8544d$var$toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class $ee56638efea8544d$export$1b417fc3b307a251 extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new $ee56638efea8544d$export$64b5c384219d3699();
        const normal = new $ee56638efea8544d$export$64b5c384219d3699();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ee56638efea8544d$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ee56638efea8544d$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$1b417fc3b307a251(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
class $ee56638efea8544d$export$fb3f7adc68bd6e02 extends $ee56638efea8544d$export$60e57a7d3f20ff65 {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$fb3f7adc68bd6e02(data.radius, data.detail);
    }
}
class $ee56638efea8544d$export$a2312a2a1fa56495 extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new $ee56638efea8544d$export$64b5c384219d3699();
        const vertex = new $ee56638efea8544d$export$64b5c384219d3699();
        const normal = new $ee56638efea8544d$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ee56638efea8544d$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ee56638efea8544d$export$cbe7a62641830ebd(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$a2312a2a1fa56495(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
class $ee56638efea8544d$export$77e9bfadfb9ab8c8 extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new $ee56638efea8544d$export$64b5c384219d3699();
        const normal = new $ee56638efea8544d$export$64b5c384219d3699();
        const P1 = new $ee56638efea8544d$export$64b5c384219d3699();
        const P2 = new $ee56638efea8544d$export$64b5c384219d3699();
        const B = new $ee56638efea8544d$export$64b5c384219d3699();
        const T = new $ee56638efea8544d$export$64b5c384219d3699();
        const N = new $ee56638efea8544d$export$64b5c384219d3699();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ee56638efea8544d$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ee56638efea8544d$export$cbe7a62641830ebd(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    static fromJSON(data) {
        return new $ee56638efea8544d$export$77e9bfadfb9ab8c8(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
class $ee56638efea8544d$export$7897d9d48904490c extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(path = new $ee56638efea8544d$export$bf3f4c7e459f90fc(new $ee56638efea8544d$export$64b5c384219d3699(-1, -1, 0), new $ee56638efea8544d$export$64b5c384219d3699(-1, 1, 0), new $ee56638efea8544d$export$64b5c384219d3699(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new $ee56638efea8544d$export$64b5c384219d3699();
        const normal = new $ee56638efea8544d$export$64b5c384219d3699();
        const uv = new $ee56638efea8544d$export$c977b3e384af9ae1();
        let P = new $ee56638efea8544d$export$64b5c384219d3699();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        this.setAttribute('normal', new $ee56638efea8544d$export$cbe7a62641830ebd(normals, 3));
        this.setAttribute('uv', new $ee56638efea8544d$export$cbe7a62641830ebd(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new $ee56638efea8544d$export$7897d9d48904490c(new $ee56638efea8544d$var$Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
class $ee56638efea8544d$export$4b739da06d24892b extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new $ee56638efea8544d$export$64b5c384219d3699();
            const end = new $ee56638efea8544d$export$64b5c384219d3699();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if ($ee56638efea8544d$var$isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if ($ee56638efea8544d$var$isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function $ee56638efea8544d$var$isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var $ee56638efea8544d$var$Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: $ee56638efea8544d$export$33e43285f7406bd5,
    CapsuleGeometry: $ee56638efea8544d$export$41680e8551036033,
    CircleGeometry: $ee56638efea8544d$export$d5c0e8d607467193,
    ConeGeometry: $ee56638efea8544d$export$a7a48974f285c9b3,
    CylinderGeometry: $ee56638efea8544d$export$68f745719dbe5198,
    DodecahedronGeometry: $ee56638efea8544d$export$c0babfeb8708fc9c,
    EdgesGeometry: $ee56638efea8544d$export$4730b1542707547f,
    ExtrudeGeometry: $ee56638efea8544d$export$598697a1efa63ca7,
    IcosahedronGeometry: $ee56638efea8544d$export$9567cc828c9535da,
    LatheGeometry: $ee56638efea8544d$export$6d839803fcd1882c,
    OctahedronGeometry: $ee56638efea8544d$export$1954e2b809fe361e,
    PlaneGeometry: $ee56638efea8544d$export$967d831af31f69ce,
    PolyhedronGeometry: $ee56638efea8544d$export$60e57a7d3f20ff65,
    RingGeometry: $ee56638efea8544d$export$68cb731f50f614af,
    ShapeGeometry: $ee56638efea8544d$export$57a29a1c803e9065,
    SphereGeometry: $ee56638efea8544d$export$1b417fc3b307a251,
    TetrahedronGeometry: $ee56638efea8544d$export$fb3f7adc68bd6e02,
    TorusGeometry: $ee56638efea8544d$export$a2312a2a1fa56495,
    TorusKnotGeometry: $ee56638efea8544d$export$77e9bfadfb9ab8c8,
    TubeGeometry: $ee56638efea8544d$export$7897d9d48904490c,
    WireframeGeometry: $ee56638efea8544d$export$4b739da06d24892b
});
class $ee56638efea8544d$export$e8564da406055a3 extends $ee56638efea8544d$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        this.color = new $ee56638efea8544d$export$892596cec99bc70e(0x000000);
        this.transparent = true;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
class $ee56638efea8544d$export$21c421a2e1df9d22 extends $ee56638efea8544d$export$83c7d75d550a8b0d {
    constructor(parameters){
        super(parameters);
        this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
class $ee56638efea8544d$export$f2980790215acccd extends $ee56638efea8544d$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshStandardMaterial = true;
        this.type = 'MeshStandardMaterial';
        this.defines = {
            'STANDARD': ''
        };
        this.color = new $ee56638efea8544d$export$892596cec99bc70e(0xffffff); // diffuse
        this.roughness = 1.0;
        this.metalness = 0.0;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $ee56638efea8544d$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $ee56638efea8544d$export$2852a58ebdac27b8;
        this.normalScale = new $ee56638efea8544d$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.roughnessMap = null;
        this.metalnessMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $ee56638efea8544d$export$d93cc409a0768c5f();
        this.envMapIntensity = 1.0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $ee56638efea8544d$export$28d04986c4269c9f extends $ee56638efea8544d$export$f2980790215acccd {
    constructor(parameters){
        super();
        this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        this.anisotropyRotation = 0;
        this.anisotropyMap = null;
        this.clearcoatMap = null;
        this.clearcoatRoughness = 0.0;
        this.clearcoatRoughnessMap = null;
        this.clearcoatNormalScale = new $ee56638efea8544d$export$c977b3e384af9ae1(1, 1);
        this.clearcoatNormalMap = null;
        this.ior = 1.5;
        Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return $ee56638efea8544d$var$clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        this.iridescenceMap = null;
        this.iridescenceIOR = 1.3;
        this.iridescenceThicknessRange = [
            100,
            400
        ];
        this.iridescenceThicknessMap = null;
        this.sheenColor = new $ee56638efea8544d$export$892596cec99bc70e(0x000000);
        this.sheenColorMap = null;
        this.sheenRoughness = 1.0;
        this.sheenRoughnessMap = null;
        this.transmissionMap = null;
        this.thickness = 0;
        this.thicknessMap = null;
        this.attenuationDistance = Infinity;
        this.attenuationColor = new $ee56638efea8544d$export$892596cec99bc70e(1, 1, 1);
        this.specularIntensity = 1.0;
        this.specularIntensityMap = null;
        this.specularColor = new $ee56638efea8544d$export$892596cec99bc70e(1, 1, 1);
        this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    get dispersion() {
        return this._dispersion;
    }
    set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) this.version++;
        this._dispersion = value;
    }
    get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
class $ee56638efea8544d$export$24c72f71cbaf0678 extends $ee56638efea8544d$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        this.color = new $ee56638efea8544d$export$892596cec99bc70e(0xffffff); // diffuse
        this.specular = new $ee56638efea8544d$export$892596cec99bc70e(0x111111);
        this.shininess = 30;
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $ee56638efea8544d$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $ee56638efea8544d$export$2852a58ebdac27b8;
        this.normalScale = new $ee56638efea8544d$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $ee56638efea8544d$export$d93cc409a0768c5f();
        this.combine = $ee56638efea8544d$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $ee56638efea8544d$export$df893cf97e765622 extends $ee56638efea8544d$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        this.color = new $ee56638efea8544d$export$892596cec99bc70e(0xffffff);
        this.map = null;
        this.gradientMap = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $ee56638efea8544d$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $ee56638efea8544d$export$2852a58ebdac27b8;
        this.normalScale = new $ee56638efea8544d$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
class $ee56638efea8544d$export$bfe8c0a091f41ae7 extends $ee56638efea8544d$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $ee56638efea8544d$export$2852a58ebdac27b8;
        this.normalScale = new $ee56638efea8544d$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
class $ee56638efea8544d$export$5023a9a8114806b8 extends $ee56638efea8544d$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        this.color = new $ee56638efea8544d$export$892596cec99bc70e(0xffffff); // diffuse
        this.map = null;
        this.lightMap = null;
        this.lightMapIntensity = 1.0;
        this.aoMap = null;
        this.aoMapIntensity = 1.0;
        this.emissive = new $ee56638efea8544d$export$892596cec99bc70e(0x000000);
        this.emissiveIntensity = 1.0;
        this.emissiveMap = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $ee56638efea8544d$export$2852a58ebdac27b8;
        this.normalScale = new $ee56638efea8544d$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.specularMap = null;
        this.alphaMap = null;
        this.envMap = null;
        this.envMapRotation = new $ee56638efea8544d$export$d93cc409a0768c5f();
        this.combine = $ee56638efea8544d$export$e50ac29801f1774d;
        this.reflectivity = 1;
        this.refractionRatio = 0.98;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.wireframeLinecap = 'round';
        this.wireframeLinejoin = 'round';
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $ee56638efea8544d$export$2698c22ec13825db extends $ee56638efea8544d$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        this.depthPacking = $ee56638efea8544d$export$deeb383078690b50;
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.wireframe = false;
        this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
class $ee56638efea8544d$export$33e187ed002f2a19 extends $ee56638efea8544d$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        this.map = null;
        this.alphaMap = null;
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
class $ee56638efea8544d$export$6f5fef6235ec12ee extends $ee56638efea8544d$export$a2d8b23205c25948 {
    constructor(parameters){
        super();
        this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        this.color = new $ee56638efea8544d$export$892596cec99bc70e(0xffffff); // diffuse
        this.matcap = null;
        this.map = null;
        this.bumpMap = null;
        this.bumpScale = 1;
        this.normalMap = null;
        this.normalMapType = $ee56638efea8544d$export$2852a58ebdac27b8;
        this.normalScale = new $ee56638efea8544d$export$c977b3e384af9ae1(1, 1);
        this.displacementMap = null;
        this.displacementScale = 1;
        this.displacementBias = 0;
        this.alphaMap = null;
        this.flatShading = false;
        this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
class $ee56638efea8544d$export$327886a3efaeaebe extends $ee56638efea8544d$export$fbaaa33907730a0c {
    constructor(parameters){
        super();
        this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        this.scale = 1;
        this.dashSize = 3;
        this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
// converts an array to a specific type
function $ee56638efea8544d$var$convertArray(array, type, forceClone) {
    if (!array || // let 'undefined' and 'null' pass
    !forceClone && array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
function $ee56638efea8544d$var$isTypedArray(object) {
    return ArrayBuffer.isView(object) && !(object instanceof DataView);
}
// returns an array by which times and values can be sorted
function $ee56638efea8544d$var$getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
// uses the array previously returned by 'getKeyframeOrder' to sort data
function $ee56638efea8544d$var$sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
// function for parsing AOS keyframe formats
function $ee56638efea8544d$var$flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push.apply(values, value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
function $ee56638efea8544d$var$subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = $ee56638efea8544d$var$convertArray(times, track.times.constructor);
        track.values = $ee56638efea8544d$var$convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
function $ee56638efea8544d$var$makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new $ee56638efea8544d$export$23d6a54f0bbc85a3().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            $ee56638efea8544d$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = $ee56638efea8544d$export$d875e029ef558d3;
    return targetClip;
}
const $ee56638efea8544d$export$7ee8caa573e71ad1 = {
    convertArray: $ee56638efea8544d$var$convertArray,
    isTypedArray: $ee56638efea8544d$var$isTypedArray,
    getKeyframeOrder: $ee56638efea8544d$var$getKeyframeOrder,
    sortedArray: $ee56638efea8544d$var$sortedArray,
    flattenJSON: $ee56638efea8544d$var$flattenJSON,
    subclip: $ee56638efea8544d$var$subclip,
    makeClipAdditive: $ee56638efea8544d$var$makeClipAdditive
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ class $ee56638efea8544d$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        this.parameterPositions = parameterPositions;
        this._cachedIndex = 0;
        this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        this.sampleValues = sampleValues;
        this.valueSize = sampleSize;
        this.settings = null;
        this.DefaultSettings_ = {};
    }
    evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    // Template methods for derived classes:
    interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ class $ee56638efea8544d$export$3646682e7a3959 extends $ee56638efea8544d$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: $ee56638efea8544d$export$7f795934b84ab523,
            endingEnd: $ee56638efea8544d$export$7f795934b84ab523
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case $ee56638efea8544d$export$24a4ccb5099273b5:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case $ee56638efea8544d$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case $ee56638efea8544d$export$24a4ccb5099273b5:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case $ee56638efea8544d$export$8e8c3ecdcd8e1fee:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
class $ee56638efea8544d$export$a8e6009059f51e1a extends $ee56638efea8544d$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 *
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 */ class $ee56638efea8544d$export$fb9758ef7ef8d5cc extends $ee56638efea8544d$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
class $ee56638efea8544d$export$b0e479f45b7006d6 {
    constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        this.name = name;
        this.times = $ee56638efea8544d$var$convertArray(times, this.TimeBufferType);
        this.values = $ee56638efea8544d$var$convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': $ee56638efea8544d$var$convertArray(track.times, Array),
                'values': $ee56638efea8544d$var$convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    InterpolantFactoryMethodDiscrete(result) {
        return new $ee56638efea8544d$export$fb9758ef7ef8d5cc(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodLinear(result) {
        return new $ee56638efea8544d$export$a8e6009059f51e1a(this.times, this.values, this.getValueSize(), result);
    }
    InterpolantFactoryMethodSmooth(result) {
        return new $ee56638efea8544d$export$3646682e7a3959(this.times, this.values, this.getValueSize(), result);
    }
    setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case $ee56638efea8544d$export$995b32462a65e855:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case $ee56638efea8544d$export$30fac1aace31cf4d:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case $ee56638efea8544d$export$198b11ff4c72bb30:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn('THREE.KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return $ee56638efea8544d$export$995b32462a65e855;
            case this.InterpolantFactoryMethodLinear:
                return $ee56638efea8544d$export$30fac1aace31cf4d;
            case this.InterpolantFactoryMethodSmooth:
                return $ee56638efea8544d$export$198b11ff4c72bb30;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    // move all keyframes either forwards or backwards in time
    shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error('THREE.KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if ($ee56638efea8544d$var$isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === $ee56638efea8544d$export$198b11ff4c72bb30, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
$ee56638efea8544d$export$b0e479f45b7006d6.prototype.TimeBufferType = Float32Array;
$ee56638efea8544d$export$b0e479f45b7006d6.prototype.ValueBufferType = Float32Array;
$ee56638efea8544d$export$b0e479f45b7006d6.prototype.DefaultInterpolation = $ee56638efea8544d$export$30fac1aace31cf4d;
/**
 * A Track of Boolean keyframe values.
 */ class $ee56638efea8544d$export$d3a344b98cf0b775 extends $ee56638efea8544d$export$b0e479f45b7006d6 {
    // No interpolation parameter because only InterpolateDiscrete is valid.
    constructor(name, times, values){
        super(name, times, values);
    }
}
$ee56638efea8544d$export$d3a344b98cf0b775.prototype.ValueTypeName = 'bool';
$ee56638efea8544d$export$d3a344b98cf0b775.prototype.ValueBufferType = Array;
$ee56638efea8544d$export$d3a344b98cf0b775.prototype.DefaultInterpolation = $ee56638efea8544d$export$995b32462a65e855;
$ee56638efea8544d$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodLinear = undefined;
$ee56638efea8544d$export$d3a344b98cf0b775.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of keyframe values that represent color.
 */ class $ee56638efea8544d$export$83444c5d885347d8 extends $ee56638efea8544d$export$b0e479f45b7006d6 {
}
$ee56638efea8544d$export$83444c5d885347d8.prototype.ValueTypeName = 'color';
/**
 * A Track of numeric keyframe values.
 */ class $ee56638efea8544d$export$d45f0d1a4d9a9314 extends $ee56638efea8544d$export$b0e479f45b7006d6 {
}
$ee56638efea8544d$export$d45f0d1a4d9a9314.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 */ class $ee56638efea8544d$export$2db1cfb7923d931e extends $ee56638efea8544d$export$b558baee9c0f72d3 {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)$ee56638efea8544d$export$23d6a54f0bbc85a3.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A Track of quaternion keyframe values.
 */ class $ee56638efea8544d$export$b8043f12b5aafbd7 extends $ee56638efea8544d$export$b0e479f45b7006d6 {
    InterpolantFactoryMethodLinear(result) {
        return new $ee56638efea8544d$export$2db1cfb7923d931e(this.times, this.values, this.getValueSize(), result);
    }
}
$ee56638efea8544d$export$b8043f12b5aafbd7.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
$ee56638efea8544d$export$b8043f12b5aafbd7.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track that interpolates Strings
 */ class $ee56638efea8544d$export$6ce41d4f3a8df9cd extends $ee56638efea8544d$export$b0e479f45b7006d6 {
    // No interpolation parameter because only InterpolateDiscrete is valid.
    constructor(name, times, values){
        super(name, times, values);
    }
}
$ee56638efea8544d$export$6ce41d4f3a8df9cd.prototype.ValueTypeName = 'string';
$ee56638efea8544d$export$6ce41d4f3a8df9cd.prototype.ValueBufferType = Array;
$ee56638efea8544d$export$6ce41d4f3a8df9cd.prototype.DefaultInterpolation = $ee56638efea8544d$export$995b32462a65e855;
$ee56638efea8544d$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodLinear = undefined;
$ee56638efea8544d$export$6ce41d4f3a8df9cd.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A Track of vectored keyframe values.
 */ class $ee56638efea8544d$export$5ce2dcb4cc9f2bff extends $ee56638efea8544d$export$b0e479f45b7006d6 {
}
$ee56638efea8544d$export$5ce2dcb4cc9f2bff.prototype.ValueTypeName = 'vector';
class $ee56638efea8544d$export$d942c706bf23829c {
    constructor(name = '', duration = -1, tracks = [], blendMode = $ee56638efea8544d$export$bcfbbdcf8de7f8cd){
        this.name = name;
        this.tracks = tracks;
        this.duration = duration;
        this.blendMode = blendMode;
        this.uuid = $ee56638efea8544d$var$generateUUID();
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push($ee56638efea8544d$var$parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    }
    static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push($ee56638efea8544d$export$b0e479f45b7006d6.toJSON(clipTracks[i]));
        return json;
    }
    static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = $ee56638efea8544d$var$getKeyframeOrder(times);
            times = $ee56638efea8544d$var$sortedArray(times, 1, order);
            values = $ee56638efea8544d$var$sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new $ee56638efea8544d$export$d45f0d1a4d9a9314('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    // parse the animation.hierarchy format
    static parseAnimation(animation, bones) {
        if (!animation) {
            console.error('THREE.AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                $ee56638efea8544d$var$flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new $ee56638efea8544d$export$d45f0d1a4d9a9314('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack($ee56638efea8544d$export$5ce2dcb4cc9f2bff, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack($ee56638efea8544d$export$b8043f12b5aafbd7, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack($ee56638efea8544d$export$5ce2dcb4cc9f2bff, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new this.constructor(this.name, this.duration, tracks, this.blendMode);
    }
    toJSON() {
        return this.constructor.toJSON(this);
    }
}
function $ee56638efea8544d$var$getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return $ee56638efea8544d$export$d45f0d1a4d9a9314;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return $ee56638efea8544d$export$5ce2dcb4cc9f2bff;
        case 'color':
            return $ee56638efea8544d$export$83444c5d885347d8;
        case 'quaternion':
            return $ee56638efea8544d$export$b8043f12b5aafbd7;
        case 'bool':
        case 'boolean':
            return $ee56638efea8544d$export$d3a344b98cf0b775;
        case 'string':
            return $ee56638efea8544d$export$6ce41d4f3a8df9cd;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function $ee56638efea8544d$var$parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = $ee56638efea8544d$var$getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        $ee56638efea8544d$var$flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
const $ee56638efea8544d$export$94affb487e701bf2 = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
class $ee56638efea8544d$export$99cc795e99919eed {
    constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        this.onStart = undefined;
        this.onLoad = onLoad;
        this.onProgress = onProgress;
        this.onError = onError;
        this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
    }
}
const $ee56638efea8544d$export$b033c3f9a95c6a16 = /*@__PURE__*/ new $ee56638efea8544d$export$99cc795e99919eed();
class $ee56638efea8544d$export$3b0d6d7590275603 {
    constructor(manager){
        this.manager = manager !== undefined ? manager : $ee56638efea8544d$export$b033c3f9a95c6a16;
        this.crossOrigin = 'anonymous';
        this.withCredentials = false;
        this.path = '';
        this.resourcePath = '';
        this.requestHeader = {};
    }
    load() {}
    loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    parse() {}
    setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    setPath(path) {
        this.path = path;
        return this;
    }
    setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
}
$ee56638efea8544d$export$3b0d6d7590275603.DEFAULT_MATERIAL_NAME = '__DEFAULT';
const $ee56638efea8544d$var$loading = {};
class $ee56638efea8544d$var$HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
class $ee56638efea8544d$export$98435a25b5cf7b2b extends $ee56638efea8544d$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = $ee56638efea8544d$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if ($ee56638efea8544d$var$loading[url] !== undefined) {
            $ee56638efea8544d$var$loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        $ee56638efea8544d$var$loading[url] = [];
        $ee56638efea8544d$var$loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin'
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = $ee56638efea8544d$var$loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get('X-File-Size') || response.headers.get('Content-Length');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done: done, value: value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable: lengthComputable,
                                        loaded: loaded,
                                        total: total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            }, (e)=>{
                                controller.error(e);
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new $ee56638efea8544d$var$HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === undefined) return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            $ee56638efea8544d$export$94affb487e701bf2.add(url, data);
            const callbacks = $ee56638efea8544d$var$loading[url];
            delete $ee56638efea8544d$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = $ee56638efea8544d$var$loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete $ee56638efea8544d$var$loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    setResponseType(value) {
        this.responseType = value;
        return this;
    }
    setMimeType(value) {
        this.mimeType = value;
        return this;
    }
}
class $ee56638efea8544d$export$29711c7e14f61db extends $ee56638efea8544d$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $ee56638efea8544d$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = $ee56638efea8544d$export$d942c706bf23829c.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $ee56638efea8544d$export$bd73ce947a280350 extends $ee56638efea8544d$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new $ee56638efea8544d$export$3466bac9141a5cc4();
        const loader = new $ee56638efea8544d$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = $ee56638efea8544d$export$8a72f490b25c56c8;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = $ee56638efea8544d$export$8a72f490b25c56c8;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $ee56638efea8544d$export$8905ce1c7a2464a1 extends $ee56638efea8544d$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $ee56638efea8544d$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = $ee56638efea8544d$export$7094a064528c7fee('img');
        function onImageLoad() {
            removeEventListeners();
            $ee56638efea8544d$export$94affb487e701bf2.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
class $ee56638efea8544d$export$2ec114afc2cf6308 extends $ee56638efea8544d$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(urls, onLoad, onProgress, onError) {
        const texture = new $ee56638efea8544d$export$ee2e5a18258a4049();
        texture.colorSpace = $ee56638efea8544d$export$561f394b24edfcaa;
        const loader = new $ee56638efea8544d$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ class $ee56638efea8544d$export$792d8a18f2c55855 extends $ee56638efea8544d$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new $ee56638efea8544d$export$b691f601014eabe1();
        const loader = new $ee56638efea8544d$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    console.error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : $ee56638efea8544d$export$9d9334239a5a5e06;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : $ee56638efea8544d$export$9d9334239a5a5e06;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : $ee56638efea8544d$export$8a72f490b25c56c8;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : $ee56638efea8544d$export$8a72f490b25c56c8;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = $ee56638efea8544d$export$5d8599b6a933fb1b; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = $ee56638efea8544d$export$8a72f490b25c56c8;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
class $ee56638efea8544d$export$fd1bfc71f64c538c extends $ee56638efea8544d$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const texture = new $ee56638efea8544d$export$5431306cf43de24a();
        const loader = new $ee56638efea8544d$export$8905ce1c7a2464a1(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
class $ee56638efea8544d$export$6ecadb6ed240d696 extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(color, intensity = 1){
        super();
        this.isLight = true;
        this.type = 'Light';
        this.color = new $ee56638efea8544d$export$892596cec99bc70e(color);
        this.intensity = intensity;
    }
    dispose() {
    // Empty here in base class; some subclasses override.
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        if (this.target !== undefined) data.object.target = this.target.uuid;
        return data;
    }
}
class $ee56638efea8544d$export$8d474f55edbb9624 extends $ee56638efea8544d$export$6ecadb6ed240d696 {
    constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy($ee56638efea8544d$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.groundColor = new $ee56638efea8544d$export$892596cec99bc70e(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
}
const $ee56638efea8544d$var$_projScreenMatrix$1 = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_lightPositionWorld$1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_lookTarget$1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$var$LightShadow {
    constructor(camera){
        this.camera = camera;
        this.intensity = 1;
        this.bias = 0;
        this.normalBias = 0;
        this.radius = 1;
        this.blurSamples = 8;
        this.mapSize = new $ee56638efea8544d$export$c977b3e384af9ae1(512, 512);
        this.map = null;
        this.mapPass = null;
        this.matrix = new $ee56638efea8544d$export$2ae72fc923e5eb5();
        this.autoUpdate = true;
        this.needsUpdate = false;
        this._frustum = new $ee56638efea8544d$export$35efe6f4c85463d2();
        this._frameExtents = new $ee56638efea8544d$export$c977b3e384af9ae1(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new $ee56638efea8544d$export$fa7daccca11cdbe3(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        $ee56638efea8544d$var$_lightPositionWorld$1.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy($ee56638efea8544d$var$_lightPositionWorld$1);
        $ee56638efea8544d$var$_lookTarget$1.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt($ee56638efea8544d$var$_lookTarget$1);
        shadowCamera.updateMatrixWorld();
        $ee56638efea8544d$var$_projScreenMatrix$1.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($ee56638efea8544d$var$_projScreenMatrix$1);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply($ee56638efea8544d$var$_projScreenMatrix$1);
    }
    getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
class $ee56638efea8544d$var$SpotLightShadow extends $ee56638efea8544d$var$LightShadow {
    constructor(){
        super(new $ee56638efea8544d$export$74e4ae24825f68d7(50, 1, 0.5, 500));
        this.isSpotLightShadow = true;
        this.focus = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = $ee56638efea8544d$export$914076c8150813e5 * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
class $ee56638efea8544d$export$81495cbb73897362 extends $ee56638efea8544d$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy($ee56638efea8544d$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $ee56638efea8544d$export$e4dd07dff30cc924();
        this.distance = distance;
        this.angle = angle;
        this.penumbra = penumbra;
        this.decay = decay;
        this.map = null;
        this.shadow = new $ee56638efea8544d$var$SpotLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
const $ee56638efea8544d$var$_projScreenMatrix = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_lightPositionWorld = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_lookTarget = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$var$PointLightShadow extends $ee56638efea8544d$var$LightShadow {
    constructor(){
        super(new $ee56638efea8544d$export$74e4ae24825f68d7(90, 1, 0.5, 500));
        this.isPointLightShadow = true;
        this._frameExtents = new $ee56638efea8544d$export$c977b3e384af9ae1(4, 2);
        this._viewportCount = 6;
        this._viewports = [
            // These viewports map a cube-map onto a 2D texture with the
            // following orientation:
            //
            //  xzXZ
            //   y Y
            //
            // X - Positive x direction
            // x - Negative x direction
            // Y - Positive y direction
            // y - Negative y direction
            // Z - Positive z direction
            // z - Negative z direction
            // positive X
            new $ee56638efea8544d$export$fa7daccca11cdbe3(2, 1, 1, 1),
            // negative X
            new $ee56638efea8544d$export$fa7daccca11cdbe3(0, 1, 1, 1),
            // positive Z
            new $ee56638efea8544d$export$fa7daccca11cdbe3(3, 1, 1, 1),
            // negative Z
            new $ee56638efea8544d$export$fa7daccca11cdbe3(1, 1, 1, 1),
            // positive Y
            new $ee56638efea8544d$export$fa7daccca11cdbe3(3, 0, 1, 1),
            // negative Y
            new $ee56638efea8544d$export$fa7daccca11cdbe3(1, 0, 1, 1)
        ];
        this._cubeDirections = [
            new $ee56638efea8544d$export$64b5c384219d3699(1, 0, 0),
            new $ee56638efea8544d$export$64b5c384219d3699(-1, 0, 0),
            new $ee56638efea8544d$export$64b5c384219d3699(0, 0, 1),
            new $ee56638efea8544d$export$64b5c384219d3699(0, 0, -1),
            new $ee56638efea8544d$export$64b5c384219d3699(0, 1, 0),
            new $ee56638efea8544d$export$64b5c384219d3699(0, -1, 0)
        ];
        this._cubeUps = [
            new $ee56638efea8544d$export$64b5c384219d3699(0, 1, 0),
            new $ee56638efea8544d$export$64b5c384219d3699(0, 1, 0),
            new $ee56638efea8544d$export$64b5c384219d3699(0, 1, 0),
            new $ee56638efea8544d$export$64b5c384219d3699(0, 1, 0),
            new $ee56638efea8544d$export$64b5c384219d3699(0, 0, 1),
            new $ee56638efea8544d$export$64b5c384219d3699(0, 0, -1)
        ];
    }
    updateMatrices(light, viewportIndex = 0) {
        const camera = this.camera;
        const shadowMatrix = this.matrix;
        const far = light.distance || camera.far;
        if (far !== camera.far) {
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        $ee56638efea8544d$var$_lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy($ee56638efea8544d$var$_lightPositionWorld);
        $ee56638efea8544d$var$_lookTarget.copy(camera.position);
        $ee56638efea8544d$var$_lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt($ee56638efea8544d$var$_lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-$ee56638efea8544d$var$_lightPositionWorld.x, -$ee56638efea8544d$var$_lightPositionWorld.y, -$ee56638efea8544d$var$_lightPositionWorld.z);
        $ee56638efea8544d$var$_projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix($ee56638efea8544d$var$_projScreenMatrix);
    }
}
class $ee56638efea8544d$export$4c9c1cb3f0b6f455 extends $ee56638efea8544d$export$6ecadb6ed240d696 {
    constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        this.isPointLight = true;
        this.type = 'PointLight';
        this.distance = distance;
        this.decay = decay;
        this.shadow = new $ee56638efea8544d$var$PointLightShadow();
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $ee56638efea8544d$export$9ebf355ee4ed261b extends $ee56638efea8544d$export$79f141de891a5fed {
    constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        this.zoom = 1;
        this.view = null;
        this.left = left;
        this.right = right;
        this.top = top;
        this.bottom = bottom;
        this.near = near;
        this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
class $ee56638efea8544d$var$DirectionalLightShadow extends $ee56638efea8544d$var$LightShadow {
    constructor(){
        super(new $ee56638efea8544d$export$9ebf355ee4ed261b(-5, 5, 5, -5, 0.5, 500));
        this.isDirectionalLightShadow = true;
    }
}
class $ee56638efea8544d$export$3fea33cc9972c868 extends $ee56638efea8544d$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy($ee56638efea8544d$export$e4dd07dff30cc924.DEFAULT_UP);
        this.updateMatrix();
        this.target = new $ee56638efea8544d$export$e4dd07dff30cc924();
        this.shadow = new $ee56638efea8544d$var$DirectionalLightShadow();
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
}
class $ee56638efea8544d$export$af279bfef9ec2c96 extends $ee56638efea8544d$export$6ecadb6ed240d696 {
    constructor(color, intensity){
        super(color, intensity);
        this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
class $ee56638efea8544d$export$61db2d908bbd2429 extends $ee56638efea8544d$export$6ecadb6ed240d696 {
    constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        this.width = width;
        this.height = height;
    }
    get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class $ee56638efea8544d$export$ba61ce607e1f405a {
    constructor(){
        this.isSphericalHarmonics3 = true;
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new $ee56638efea8544d$export$64b5c384219d3699());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
class $ee56638efea8544d$export$e7ef036e309b38d2 extends $ee56638efea8544d$export$6ecadb6ed240d696 {
    constructor(sh = new $ee56638efea8544d$export$ba61ce607e1f405a(), intensity = 1){
        super(undefined, intensity);
        this.isLightProbe = true;
        this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    fromJSON(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
class $ee56638efea8544d$export$3bd6d323353dcf96 extends $ee56638efea8544d$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.textures = {};
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $ee56638efea8544d$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = this.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new $ee56638efea8544d$export$892596cec99bc70e().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.dispersion !== undefined) material.dispersion = json.dispersion;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
        if (json.blendDst !== undefined) material.blendDst = json.blendDst;
        if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
        if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
        if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
        if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
        if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
        if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new $ee56638efea8544d$export$892596cec99bc70e().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new $ee56638efea8544d$export$c977b3e384af9ae1().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new $ee56638efea8544d$export$64b5c384219d3699().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new $ee56638efea8544d$export$fa7daccca11cdbe3().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new $ee56638efea8544d$export$8ff26dafa08918().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new $ee56638efea8544d$export$2ae72fc923e5eb5().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new $ee56638efea8544d$export$c977b3e384af9ae1().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new $ee56638efea8544d$export$c977b3e384af9ae1().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    setTextures(value) {
        this.textures = value;
        return this;
    }
    createMaterialFromType(type) {
        return $ee56638efea8544d$export$3bd6d323353dcf96.createMaterialFromType(type);
    }
    static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial: $ee56638efea8544d$export$e8564da406055a3,
            SpriteMaterial: $ee56638efea8544d$export$5ec7dd1c6994bf8e,
            RawShaderMaterial: $ee56638efea8544d$export$21c421a2e1df9d22,
            ShaderMaterial: $ee56638efea8544d$export$83c7d75d550a8b0d,
            PointsMaterial: $ee56638efea8544d$export$a178c45366ce5d6b,
            MeshPhysicalMaterial: $ee56638efea8544d$export$28d04986c4269c9f,
            MeshStandardMaterial: $ee56638efea8544d$export$f2980790215acccd,
            MeshPhongMaterial: $ee56638efea8544d$export$24c72f71cbaf0678,
            MeshToonMaterial: $ee56638efea8544d$export$df893cf97e765622,
            MeshNormalMaterial: $ee56638efea8544d$export$bfe8c0a091f41ae7,
            MeshLambertMaterial: $ee56638efea8544d$export$5023a9a8114806b8,
            MeshDepthMaterial: $ee56638efea8544d$export$2698c22ec13825db,
            MeshDistanceMaterial: $ee56638efea8544d$export$33e187ed002f2a19,
            MeshBasicMaterial: $ee56638efea8544d$export$55cbcc9b622fe1f5,
            MeshMatcapMaterial: $ee56638efea8544d$export$6f5fef6235ec12ee,
            LineDashedMaterial: $ee56638efea8544d$export$327886a3efaeaebe,
            LineBasicMaterial: $ee56638efea8544d$export$fbaaa33907730a0c,
            Material: $ee56638efea8544d$export$a2d8b23205c25948
        };
        return new materialLib[type]();
    }
}
class $ee56638efea8544d$export$b5d2dc08d867e41a {
    static decodeText(array) {
        console.warn('THREE.LoaderUtils: decodeText() has been deprecated with r165 and will be removed with r175. Use TextDecoder instead.');
        if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = '';
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    }
    static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
class $ee56638efea8544d$export$231f009cbe414146 extends $ee56638efea8544d$export$b7be63a67df8959 {
    constructor(){
        super();
        this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
class $ee56638efea8544d$export$dc275bb96327833a extends $ee56638efea8544d$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $ee56638efea8544d$export$98435a25b5cf7b2b(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = $ee56638efea8544d$var$getTypedArray(interleavedBuffer.type, buffer);
            const ib = new $ee56638efea8544d$export$3d5cd879f108f53f(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new $ee56638efea8544d$export$231f009cbe414146() : new $ee56638efea8544d$export$b7be63a67df8959();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = $ee56638efea8544d$var$getTypedArray(index.type, index.array);
            geometry.setIndex(new $ee56638efea8544d$export$8dea267bd6bde117(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new $ee56638efea8544d$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = $ee56638efea8544d$var$getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? $ee56638efea8544d$export$32ea87a8b54d744a : $ee56638efea8544d$export$8dea267bd6bde117;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new $ee56638efea8544d$export$920b6d07334599c7(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = $ee56638efea8544d$var$getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new $ee56638efea8544d$export$8dea267bd6bde117(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new $ee56638efea8544d$export$64b5c384219d3699();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new $ee56638efea8544d$export$805e8b72413ccaba(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
class $ee56638efea8544d$export$40110c8505c5ad19 extends $ee56638efea8544d$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? $ee56638efea8544d$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $ee56638efea8544d$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                console.error('THREE.ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? $ee56638efea8544d$export$b5d2dc08d867e41a.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new $ee56638efea8544d$export$98435a25b5cf7b2b(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new $ee56638efea8544d$export$6428a7f2611ef1fa().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new $ee56638efea8544d$export$8f31e4c4a37b8e9c().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new $ee56638efea8544d$export$dc275bb96327833a();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in $ee56638efea8544d$var$Geometries) geometry = $ee56638efea8544d$var$Geometries[data.type].fromJSON(data, shapes);
                        else console.warn(`THREE.ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new $ee56638efea8544d$export$3bd6d323353dcf96();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = $ee56638efea8544d$export$d942c706bf23829c.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: $ee56638efea8544d$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new $ee56638efea8544d$export$99cc795e99919eed(onLoad);
            loader = new $ee56638efea8544d$export$8905ce1c7a2464a1(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $ee56638efea8544d$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $ee56638efea8544d$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new $ee56638efea8544d$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: $ee56638efea8544d$var$getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new $ee56638efea8544d$export$8905ce1c7a2464a1(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new $ee56638efea8544d$export$b691f601014eabe1(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new $ee56638efea8544d$export$1d2df86270c81ecb(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new $ee56638efea8544d$export$1d2df86270c81ecb(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new $ee56638efea8544d$export$ee2e5a18258a4049();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new $ee56638efea8544d$export$b691f601014eabe1();
                else texture = new $ee56638efea8544d$export$5431306cf43de24a();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, $ee56638efea8544d$var$TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], $ee56638efea8544d$var$TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], $ee56638efea8544d$var$TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, $ee56638efea8544d$var$TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, $ee56638efea8544d$var$TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new $ee56638efea8544d$export$38af1803e3442a7f();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new $ee56638efea8544d$export$892596cec99bc70e(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new $ee56638efea8544d$export$3c890837b09508d4(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new $ee56638efea8544d$export$6f1519f023b8d0f6(data.fog.color, data.fog.density);
                    if (data.fog.name !== '') object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                break;
            case 'PerspectiveCamera':
                object = new $ee56638efea8544d$export$74e4ae24825f68d7(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new $ee56638efea8544d$export$9ebf355ee4ed261b(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new $ee56638efea8544d$export$af279bfef9ec2c96(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new $ee56638efea8544d$export$3fea33cc9972c868(data.color, data.intensity);
                object.target = data.target || '';
                break;
            case 'PointLight':
                object = new $ee56638efea8544d$export$4c9c1cb3f0b6f455(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new $ee56638efea8544d$export$61db2d908bbd2429(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new $ee56638efea8544d$export$81495cbb73897362(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                object.target = data.target || '';
                break;
            case 'HemisphereLight':
                object = new $ee56638efea8544d$export$8d474f55edbb9624(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new $ee56638efea8544d$export$e7ef036e309b38d2().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $ee56638efea8544d$export$b303577035157ecf(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $ee56638efea8544d$export$e176487c05830cc5(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new $ee56638efea8544d$export$f3c979c331175ad7(geometry, material, count);
                object.instanceMatrix = new $ee56638efea8544d$export$32ea87a8b54d744a(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new $ee56638efea8544d$export$32ea87a8b54d744a(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'BatchedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new $ee56638efea8544d$export$6e01c5ee52ed8f7b(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                object.geometry = geometry;
                object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                object.sortObjects = data.sortObjects;
                object._drawRanges = data.drawRanges;
                object._reservedRanges = data.reservedRanges;
                object._visibility = data.visibility;
                object._active = data.active;
                object._bounds = data.bounds.map((bound)=>{
                    const box = new $ee56638efea8544d$export$6f7d5a9418ab2aa3();
                    box.min.fromArray(bound.boxMin);
                    box.max.fromArray(bound.boxMax);
                    const sphere = new $ee56638efea8544d$export$805e8b72413ccaba();
                    sphere.radius = bound.sphereRadius;
                    sphere.center.fromArray(bound.sphereCenter);
                    return {
                        boxInitialized: bound.boxInitialized,
                        box: box,
                        sphereInitialized: bound.sphereInitialized,
                        sphere: sphere
                    };
                });
                object._maxInstanceCount = data.maxInstanceCount;
                object._maxVertexCount = data.maxVertexCount;
                object._maxIndexCount = data.maxIndexCount;
                object._geometryInitialized = data.geometryInitialized;
                object._geometryCount = data.geometryCount;
                object._matricesTexture = getTexture(data.matricesTexture.uuid);
                if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                break;
            case 'LOD':
                object = new $ee56638efea8544d$export$112e7237be0c5f30();
                break;
            case 'Line':
                object = new $ee56638efea8544d$export$17d680238e50603e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new $ee56638efea8544d$export$f85a24d745e4f17d(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new $ee56638efea8544d$export$ff1ed10fedfdd604(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new $ee56638efea8544d$export$1c787534cb11aa3e(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new $ee56638efea8544d$export$3075603db8e6204c(getMaterial(data.material));
                break;
            case 'Group':
                object = new $ee56638efea8544d$export$eb2fcfdbd7ba97d4();
                break;
            case 'Bone':
                object = new $ee56638efea8544d$export$b127726e56765aa4();
                break;
            default:
                object = new $ee56638efea8544d$export$e4dd07dff30cc924();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    bindLightTargets(object) {
        object.traverse(function(child) {
            if (child.isDirectionalLight || child.isSpotLight) {
                const uuid = child.target;
                const target = object.getObjectByProperty('uuid', uuid);
                if (target !== undefined) child.target = target;
                else child.target = new $ee56638efea8544d$export$e4dd07dff30cc924();
            }
        });
    }
}
const $ee56638efea8544d$var$TEXTURE_MAPPING = {
    UVMapping: $ee56638efea8544d$export$1beec6768cbb3d2d,
    CubeReflectionMapping: $ee56638efea8544d$export$8759762a6477f2c4,
    CubeRefractionMapping: $ee56638efea8544d$export$dc59f8aed047f61d,
    EquirectangularReflectionMapping: $ee56638efea8544d$export$d64030b316d3b087,
    EquirectangularRefractionMapping: $ee56638efea8544d$export$ee99d97d46898098,
    CubeUVReflectionMapping: $ee56638efea8544d$export$dbf3e70ff37af79
};
const $ee56638efea8544d$var$TEXTURE_WRAPPING = {
    RepeatWrapping: $ee56638efea8544d$export$533346c8e8dac0f5,
    ClampToEdgeWrapping: $ee56638efea8544d$export$9d9334239a5a5e06,
    MirroredRepeatWrapping: $ee56638efea8544d$export$c7e7c00b14f51a4f
};
const $ee56638efea8544d$var$TEXTURE_FILTER = {
    NearestFilter: $ee56638efea8544d$export$727aa5ec3fe39bf0,
    NearestMipmapNearestFilter: $ee56638efea8544d$export$d129e38cf6feaa8c,
    NearestMipmapLinearFilter: $ee56638efea8544d$export$d2327c1afe5bfdf2,
    LinearFilter: $ee56638efea8544d$export$8a72f490b25c56c8,
    LinearMipmapNearestFilter: $ee56638efea8544d$export$19a719f377145a13,
    LinearMipmapLinearFilter: $ee56638efea8544d$export$5d8599b6a933fb1b
};
class $ee56638efea8544d$export$52286b55c4a9b51f extends $ee56638efea8544d$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
        this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
        this.options = {
            premultiplyAlpha: 'none'
        };
    }
    setOptions(options) {
        this.options = options;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = $ee56638efea8544d$export$94affb487e701bf2.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            // If cached is a promise, wait for it to resolve
            if (cached.then) {
                cached.then((imageBitmap)=>{
                    if (onLoad) onLoad(imageBitmap);
                    scope.manager.itemEnd(url);
                }).catch((e)=>{
                    if (onError) onError(e);
                });
                return;
            }
            // If cached is not a promise (i.e., it's already an imageBitmap)
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        const promise = fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            $ee56638efea8544d$export$94affb487e701bf2.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
            return imageBitmap;
        }).catch(function(e) {
            if (onError) onError(e);
            $ee56638efea8544d$export$94affb487e701bf2.remove(url);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        $ee56638efea8544d$export$94affb487e701bf2.add(url, promise);
        scope.manager.itemStart(url);
    }
}
let $ee56638efea8544d$var$_context;
class $ee56638efea8544d$export$fcbc63750ec2a81f {
    static getContext() {
        if ($ee56638efea8544d$var$_context === undefined) $ee56638efea8544d$var$_context = new (window.AudioContext || window.webkitAudioContext)();
        return $ee56638efea8544d$var$_context;
    }
    static setContext(value) {
        $ee56638efea8544d$var$_context = value;
    }
}
class $ee56638efea8544d$export$d8d5fccfbf47714e extends $ee56638efea8544d$export$3b0d6d7590275603 {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new $ee56638efea8544d$export$98435a25b5cf7b2b(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = $ee56638efea8544d$export$fcbc63750ec2a81f.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }).catch(handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
        }
    }
}
const $ee56638efea8544d$var$_eyeRight = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_eyeLeft = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_projectionMatrix = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
class $ee56638efea8544d$export$bc7f73a1065bee0c {
    constructor(){
        this.type = 'StereoCamera';
        this.aspect = 1;
        this.eyeSep = 0.064;
        this.cameraL = new $ee56638efea8544d$export$74e4ae24825f68d7();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        this.cameraR = new $ee56638efea8544d$export$74e4ae24825f68d7();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            $ee56638efea8544d$var$_projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan($ee56638efea8544d$var$DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            $ee56638efea8544d$var$_eyeLeft.elements[12] = -eyeSepHalf;
            $ee56638efea8544d$var$_eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            $ee56638efea8544d$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $ee56638efea8544d$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy($ee56638efea8544d$var$_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            $ee56638efea8544d$var$_projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            $ee56638efea8544d$var$_projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy($ee56638efea8544d$var$_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply($ee56638efea8544d$var$_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply($ee56638efea8544d$var$_eyeRight);
    }
}
class $ee56638efea8544d$export$56b937d9e5581166 extends $ee56638efea8544d$export$74e4ae24825f68d7 {
    constructor(array = []){
        super();
        this.isArrayCamera = true;
        this.cameras = array;
    }
}
class $ee56638efea8544d$export$9735c82c4bae3302 {
    constructor(autoStart = true){
        this.autoStart = autoStart;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = $ee56638efea8544d$var$now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = $ee56638efea8544d$var$now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function $ee56638efea8544d$var$now() {
    return performance.now();
}
const $ee56638efea8544d$var$_position$1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_quaternion$1 = /*@__PURE__*/ new $ee56638efea8544d$export$23d6a54f0bbc85a3();
const $ee56638efea8544d$var$_scale$1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_orientation$1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$8a1b810c6fde8951 extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(){
        super();
        this.type = 'AudioListener';
        this.context = $ee56638efea8544d$export$fcbc63750ec2a81f.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new $ee56638efea8544d$export$9735c82c4bae3302();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose($ee56638efea8544d$var$_position$1, $ee56638efea8544d$var$_quaternion$1, $ee56638efea8544d$var$_scale$1);
        $ee56638efea8544d$var$_orientation$1.set(0, 0, -1).applyQuaternion($ee56638efea8544d$var$_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime($ee56638efea8544d$var$_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime($ee56638efea8544d$var$_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime($ee56638efea8544d$var$_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime($ee56638efea8544d$var$_orientation$1.x, endTime);
            listener.forwardY.linearRampToValueAtTime($ee56638efea8544d$var$_orientation$1.y, endTime);
            listener.forwardZ.linearRampToValueAtTime($ee56638efea8544d$var$_orientation$1.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition($ee56638efea8544d$var$_position$1.x, $ee56638efea8544d$var$_position$1.y, $ee56638efea8544d$var$_position$1.z);
            listener.setOrientation($ee56638efea8544d$var$_orientation$1.x, $ee56638efea8544d$var$_orientation$1.y, $ee56638efea8544d$var$_orientation$1.z, up.x, up.y, up.z);
        }
    }
}
class $ee56638efea8544d$export$153755f98d9861de extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(listener){
        super();
        this.type = 'Audio';
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn('THREE.Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop(delay = 0) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop(this.context.currentTime + delay);
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
        this._progress = 0;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.sourceType !== 'buffer') {
            console.warn('THREE.Audio: Audio source type cannot be copied.');
            return this;
        }
        this.autoplay = source.autoplay;
        this.buffer = source.buffer;
        this.detune = source.detune;
        this.loop = source.loop;
        this.loopStart = source.loopStart;
        this.loopEnd = source.loopEnd;
        this.offset = source.offset;
        this.duration = source.duration;
        this.playbackRate = source.playbackRate;
        this.hasPlaybackControl = source.hasPlaybackControl;
        this.sourceType = source.sourceType;
        this.filters = source.filters.slice();
        return this;
    }
    clone(recursive) {
        return new this.constructor(this.listener).copy(this, recursive);
    }
}
const $ee56638efea8544d$var$_position = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_quaternion = /*@__PURE__*/ new $ee56638efea8544d$export$23d6a54f0bbc85a3();
const $ee56638efea8544d$var$_scale = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_orientation = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$4b3e397ef1832507 extends $ee56638efea8544d$export$153755f98d9861de {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose($ee56638efea8544d$var$_position, $ee56638efea8544d$var$_quaternion, $ee56638efea8544d$var$_scale);
        $ee56638efea8544d$var$_orientation.set(0, 0, 1).applyQuaternion($ee56638efea8544d$var$_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime($ee56638efea8544d$var$_position.x, endTime);
            panner.positionY.linearRampToValueAtTime($ee56638efea8544d$var$_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime($ee56638efea8544d$var$_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime($ee56638efea8544d$var$_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime($ee56638efea8544d$var$_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime($ee56638efea8544d$var$_orientation.z, endTime);
        } else {
            panner.setPosition($ee56638efea8544d$var$_position.x, $ee56638efea8544d$var$_position.y, $ee56638efea8544d$var$_position.z);
            panner.setOrientation($ee56638efea8544d$var$_orientation.x, $ee56638efea8544d$var$_orientation.y, $ee56638efea8544d$var$_orientation.z);
        }
    }
}
class $ee56638efea8544d$export$d47da1ef3d382827 {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
class $ee56638efea8544d$export$dfe0af1ca1acb78a {
    constructor(binding, typeName, valueSize){
        this.binding = binding;
        this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        this.useCount = 0;
        this.referenceCount = 0;
    }
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    // apply the state of 'accu<i>' to the binding when accus differ
    apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    // remember the state of the bound property and copy it to both accus
    saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        $ee56638efea8544d$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        $ee56638efea8544d$export$23d6a54f0bbc85a3.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        $ee56638efea8544d$export$23d6a54f0bbc85a3.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const $ee56638efea8544d$var$_RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const $ee56638efea8544d$var$_reservedRe = new RegExp('[' + $ee56638efea8544d$var$_RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const $ee56638efea8544d$var$_wordChar = '[^' + $ee56638efea8544d$var$_RESERVED_CHARS_RE + ']';
const $ee56638efea8544d$var$_wordCharOrDot = '[^' + $ee56638efea8544d$var$_RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const $ee56638efea8544d$var$_directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', $ee56638efea8544d$var$_wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const $ee56638efea8544d$var$_nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', $ee56638efea8544d$var$_wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const $ee56638efea8544d$var$_objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', $ee56638efea8544d$var$_wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const $ee56638efea8544d$var$_propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', $ee56638efea8544d$var$_wordChar);
const $ee56638efea8544d$var$_trackRe = new RegExp("^" + $ee56638efea8544d$var$_directoryRe + $ee56638efea8544d$var$_nodeRe + $ee56638efea8544d$var$_objectRe + $ee56638efea8544d$var$_propertyRe + '$');
const $ee56638efea8544d$var$_supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class $ee56638efea8544d$var$Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || $ee56638efea8544d$export$7bf70fcf9f891893.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
class $ee56638efea8544d$export$7bf70fcf9f891893 {
    constructor(rootNode, path, parsedPath){
        this.path = path;
        this.parsedPath = parsedPath || $ee56638efea8544d$export$7bf70fcf9f891893.parseTrackName(path);
        this.node = $ee56638efea8544d$export$7bf70fcf9f891893.findNode(rootNode, this.parsedPath.nodeName);
        this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new $ee56638efea8544d$export$7bf70fcf9f891893(root, path, parsedPath);
        else return new $ee56638efea8544d$export$7bf70fcf9f891893.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace($ee56638efea8544d$var$_reservedRe, '');
    }
    static parseTrackName(trackName) {
        const matches = $ee56638efea8544d$var$_trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if ($ee56638efea8544d$var$_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    // create getter / setter pair for a property in the scene graph
    bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = $ee56638efea8544d$export$7bf70fcf9f891893.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.warn('THREE.PropertyBinding: No target node found for track: ' + this.path + '.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        console.error('THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.isMaterial === true) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.isObject3D === true) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
$ee56638efea8544d$export$7bf70fcf9f891893.Composite = $ee56638efea8544d$var$Composite;
$ee56638efea8544d$export$7bf70fcf9f891893.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
$ee56638efea8544d$export$7bf70fcf9f891893.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
$ee56638efea8544d$export$7bf70fcf9f891893.prototype.GetterByBindingType = [
    $ee56638efea8544d$export$7bf70fcf9f891893.prototype._getValue_direct,
    $ee56638efea8544d$export$7bf70fcf9f891893.prototype._getValue_array,
    $ee56638efea8544d$export$7bf70fcf9f891893.prototype._getValue_arrayElement,
    $ee56638efea8544d$export$7bf70fcf9f891893.prototype._getValue_toArray
];
$ee56638efea8544d$export$7bf70fcf9f891893.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        $ee56638efea8544d$export$7bf70fcf9f891893.prototype._setValue_direct,
        $ee56638efea8544d$export$7bf70fcf9f891893.prototype._setValue_direct_setNeedsUpdate,
        $ee56638efea8544d$export$7bf70fcf9f891893.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        $ee56638efea8544d$export$7bf70fcf9f891893.prototype._setValue_array,
        $ee56638efea8544d$export$7bf70fcf9f891893.prototype._setValue_array_setNeedsUpdate,
        $ee56638efea8544d$export$7bf70fcf9f891893.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        $ee56638efea8544d$export$7bf70fcf9f891893.prototype._setValue_arrayElement,
        $ee56638efea8544d$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setNeedsUpdate,
        $ee56638efea8544d$export$7bf70fcf9f891893.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        $ee56638efea8544d$export$7bf70fcf9f891893.prototype._setValue_fromArray,
        $ee56638efea8544d$export$7bf70fcf9f891893.prototype._setValue_fromArray_setNeedsUpdate,
        $ee56638efea8544d$export$7bf70fcf9f891893.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ class $ee56638efea8544d$export$30619c2afd3f34db {
    constructor(){
        this.isAnimationObjectGroup = true;
        this.uuid = $ee56638efea8544d$var$generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new $ee56638efea8544d$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new $ee56638efea8544d$export$7bf70fcf9f891893(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // remove & forget
    uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new $ee56638efea8544d$export$7bf70fcf9f891893(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
class $ee56638efea8544d$export$6946940a69e799e {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: $ee56638efea8544d$export$7f795934b84ab523,
            endingEnd: $ee56638efea8544d$export$7f795934b84ab523
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = $ee56638efea8544d$export$dfaf4422ce096e29;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case $ee56638efea8544d$export$d875e029ef558d3:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case $ee56638efea8544d$export$bcfbbdcf8de7f8cd:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === $ee56638efea8544d$export$f8f6f2041b78e210;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === $ee56638efea8544d$export$d62fdc9d1b1cccad) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = $ee56638efea8544d$export$24a4ccb5099273b5;
            settings.endingEnd = $ee56638efea8544d$export$24a4ccb5099273b5;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? $ee56638efea8544d$export$24a4ccb5099273b5 : $ee56638efea8544d$export$7f795934b84ab523;
            else settings.endingStart = $ee56638efea8544d$export$8e8c3ecdcd8e1fee;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? $ee56638efea8544d$export$24a4ccb5099273b5 : $ee56638efea8544d$export$7f795934b84ab523;
            else settings.endingEnd = $ee56638efea8544d$export$8e8c3ecdcd8e1fee;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const $ee56638efea8544d$var$_controlInterpolantsResultBuffer = new Float32Array(1);
class $ee56638efea8544d$export$fbd77e5aefaa0102 extends $ee56638efea8544d$export$ec8b666c5fe2c75a {
    constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        this.time = 0;
        this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new $ee56638efea8544d$export$dfe0af1ca1acb78a($ee56638efea8544d$export$7bf70fcf9f891893.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new $ee56638efea8544d$export$a8e6009059f51e1a(new Float32Array(2), new Float32Array(2), 1, $ee56638efea8544d$var$_controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? $ee56638efea8544d$export$d942c706bf23829c.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = $ee56638efea8544d$export$bcfbbdcf8de7f8cd;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new $ee56638efea8544d$export$6946940a69e799e(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    // get an existing action
    existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? $ee56638efea8544d$export$d942c706bf23829c.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    // deactivates all previously scheduled actions
    stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    // advance the time and update apply the animation
    update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    // Allows you to seek to a specific time in an animation.
    setTime(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    // return this mixer's root target object
    getRoot() {
        return this._root;
    }
    // free all resources specific to a particular clip
    uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    // free all resources specific to a particular root target object
    uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    // remove a targeted clip from the cache
    uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
class $ee56638efea8544d$export$6b116d2fdfef087c extends $ee56638efea8544d$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isRenderTarget3D = true;
        this.depth = depth;
        this.texture = new $ee56638efea8544d$export$d7a3086320f856db(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $ee56638efea8544d$export$eb4d196341728d65 extends $ee56638efea8544d$export$efcb1f8bf367cbfb {
    constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        this.isRenderTargetArray = true;
        this.depth = depth;
        this.texture = new $ee56638efea8544d$export$dfac6c8e811406a3(null, width, height, depth);
        this.texture.isRenderTargetTexture = true;
    }
}
class $ee56638efea8544d$export$2947cebfe91c02f8 {
    constructor(value){
        this.value = value;
    }
    clone() {
        return new $ee56638efea8544d$export$2947cebfe91c02f8(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let $ee56638efea8544d$var$_id = 0;
class $ee56638efea8544d$export$c412d5ffe1f79209 extends $ee56638efea8544d$export$ec8b666c5fe2c75a {
    constructor(){
        super();
        this.isUniformsGroup = true;
        Object.defineProperty(this, 'id', {
            value: $ee56638efea8544d$var$_id++
        });
        this.name = '';
        this.usage = $ee56638efea8544d$export$763e8360f4d7f77d;
        this.uniforms = [];
    }
    add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    setName(name) {
        this.name = name;
        return this;
    }
    setUsage(value) {
        this.usage = value;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        return this;
    }
    copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++){
            const uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                uniformsSource[i]
            ];
            for(let j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $ee56638efea8544d$export$25ec0e1af1389358 extends $ee56638efea8544d$export$3d5cd879f108f53f {
    constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        this.isInstancedInterleavedBuffer = true;
        this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
class $ee56638efea8544d$export$6b7339ae8dbddf73 {
    constructor(buffer, type, itemSize, elementSize, count){
        this.isGLBufferAttribute = true;
        this.name = '';
        this.buffer = buffer;
        this.type = type;
        this.itemSize = itemSize;
        this.elementSize = elementSize;
        this.count = count;
        this.version = 0;
    }
    set needsUpdate(value) {
        if (value === true) this.version++;
    }
    setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    setCount(count) {
        this.count = count;
        return this;
    }
}
const $ee56638efea8544d$var$_matrix = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
class $ee56638efea8544d$export$8b7aaceff00bd2f {
    constructor(origin, direction, near = 0, far = Infinity){
        this.ray = new $ee56638efea8544d$export$a186db52eed6d40e(origin, direction);
        // direction is assumed to be normalized (for accurate distance calculations)
        this.near = near;
        this.far = far;
        this.camera = null;
        this.layers = new $ee56638efea8544d$export$89312ce47c0ca777();
        this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
    }
    setFromXRController(controller) {
        $ee56638efea8544d$var$_matrix.identity().extractRotation(controller.matrixWorld);
        this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        this.ray.direction.set(0, 0, -1).applyMatrix4($ee56638efea8544d$var$_matrix);
        return this;
    }
    intersectObject(object, recursive = true, intersects = []) {
        $ee56638efea8544d$var$intersect(object, this, intersects, recursive);
        intersects.sort($ee56638efea8544d$var$ascSort);
        return intersects;
    }
    intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)$ee56638efea8544d$var$intersect(objects[i], this, intersects, recursive);
        intersects.sort($ee56638efea8544d$var$ascSort);
        return intersects;
    }
}
function $ee56638efea8544d$var$ascSort(a, b) {
    return a.distance - b.distance;
}
function $ee56638efea8544d$var$intersect(object, raycaster, intersects, recursive) {
    let propagate = true;
    if (object.layers.test(raycaster.layers)) {
        const result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)$ee56638efea8544d$var$intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * phi (the polar angle) is measured from the positive y-axis. The positive y-axis is up.
 * theta (the azimuthal angle) is measured from the positive z-axis.
 */ class $ee56638efea8544d$export$d712cd887b4a00f7 {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be between EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = $ee56638efea8544d$var$clamp(this.phi, EPS, Math.PI - EPS);
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos($ee56638efea8544d$var$clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class $ee56638efea8544d$export$287165bb2177f4fd {
    constructor(radius = 1, theta = 0, y = 0){
        this.radius = radius; // distance from the origin to a point in the x-z plane
        this.theta = theta; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
class $ee56638efea8544d$export$cbcc6560bf79fb38 {
    constructor(n11, n12, n21, n22){
        $ee56638efea8544d$export$cbcc6560bf79fb38.prototype.isMatrix2 = true;
        this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
    identity() {
        this.set(1, 0, 0, 1);
        return this;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = array[i + offset];
        return this;
    }
    set(n11, n12, n21, n22) {
        const te = this.elements;
        te[0] = n11;
        te[2] = n12;
        te[1] = n21;
        te[3] = n22;
        return this;
    }
}
const $ee56638efea8544d$var$_vector$4 = /*@__PURE__*/ new $ee56638efea8544d$export$c977b3e384af9ae1();
class $ee56638efea8544d$export$60f553fa130f08b0 {
    constructor(min = new $ee56638efea8544d$export$c977b3e384af9ae1(Infinity, Infinity), max = new $ee56638efea8544d$export$c977b3e384af9ae1(-Infinity, -Infinity)){
        this.isBox2 = true;
        this.min = min;
        this.max = max;
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = $ee56638efea8544d$var$_vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
    }
    clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        return this.clampPoint(point, $ee56638efea8544d$var$_vector$4).distanceTo(point);
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const $ee56638efea8544d$var$_startP = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_startEnd = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$e0ba6359f1954fd3 {
    constructor(start = new $ee56638efea8544d$export$64b5c384219d3699(), end = new $ee56638efea8544d$export$64b5c384219d3699()){
        this.start = start;
        this.end = end;
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        $ee56638efea8544d$var$_startP.subVectors(point, this.start);
        $ee56638efea8544d$var$_startEnd.subVectors(this.end, this.start);
        const startEnd2 = $ee56638efea8544d$var$_startEnd.dot($ee56638efea8544d$var$_startEnd);
        const startEnd_startP = $ee56638efea8544d$var$_startEnd.dot($ee56638efea8544d$var$_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = $ee56638efea8544d$var$clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const $ee56638efea8544d$var$_vector$3 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$4b14638ffdd81e68 extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(light, color){
        super();
        this.light = light;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'SpotLightHelper';
        const geometry = new $ee56638efea8544d$export$b7be63a67df8959();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(positions, 3));
        const material = new $ee56638efea8544d$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.cone = new $ee56638efea8544d$export$ff1ed10fedfdd604(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        // update the local matrix based on the parent and light target transforms
        if (this.parent) {
            this.parent.updateWorldMatrix(true);
            this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
        } else this.matrix.copy(this.light.matrixWorld);
        this.matrixWorld.copy(this.light.matrixWorld);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        $ee56638efea8544d$var$_vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt($ee56638efea8544d$var$_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const $ee56638efea8544d$var$_vector$2 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_boneMatrix = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
const $ee56638efea8544d$var$_matrixWorldInv = /*@__PURE__*/ new $ee56638efea8544d$export$2ae72fc923e5eb5();
class $ee56638efea8544d$export$5277df3c9e732259 extends $ee56638efea8544d$export$ff1ed10fedfdd604 {
    constructor(object){
        const bones = $ee56638efea8544d$var$getBoneList(object);
        const geometry = new $ee56638efea8544d$export$b7be63a67df8959();
        const vertices = [];
        const colors = [];
        const color1 = new $ee56638efea8544d$export$892596cec99bc70e(0, 0, 1);
        const color2 = new $ee56638efea8544d$export$892596cec99bc70e(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $ee56638efea8544d$export$cbe7a62641830ebd(colors, 3));
        const material = new $ee56638efea8544d$export$fbaaa33907730a0c({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        $ee56638efea8544d$var$_matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                $ee56638efea8544d$var$_boneMatrix.multiplyMatrices($ee56638efea8544d$var$_matrixWorldInv, bone.matrixWorld);
                $ee56638efea8544d$var$_vector$2.setFromMatrixPosition($ee56638efea8544d$var$_boneMatrix);
                position.setXYZ(j, $ee56638efea8544d$var$_vector$2.x, $ee56638efea8544d$var$_vector$2.y, $ee56638efea8544d$var$_vector$2.z);
                $ee56638efea8544d$var$_boneMatrix.multiplyMatrices($ee56638efea8544d$var$_matrixWorldInv, bone.parent.matrixWorld);
                $ee56638efea8544d$var$_vector$2.setFromMatrixPosition($ee56638efea8544d$var$_boneMatrix);
                position.setXYZ(j + 1, $ee56638efea8544d$var$_vector$2.x, $ee56638efea8544d$var$_vector$2.y, $ee56638efea8544d$var$_vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $ee56638efea8544d$var$getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, $ee56638efea8544d$var$getBoneList(object.children[i]));
    return boneList;
}
class $ee56638efea8544d$export$9a9291685b9e4023 extends $ee56638efea8544d$export$e176487c05830cc5 {
    constructor(light, sphereSize, color){
        const geometry = new $ee56638efea8544d$export$1b417fc3b307a251(sphereSize, 4, 2);
        const material = new $ee56638efea8544d$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const $ee56638efea8544d$var$_vector$1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_color1 = /*@__PURE__*/ new $ee56638efea8544d$export$892596cec99bc70e();
const $ee56638efea8544d$var$_color2 = /*@__PURE__*/ new $ee56638efea8544d$export$892596cec99bc70e();
class $ee56638efea8544d$export$8dca15f13f4f8172 extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'HemisphereLightHelper';
        const geometry = new $ee56638efea8544d$export$1954e2b809fe361e(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new $ee56638efea8544d$export$55cbcc9b622fe1f5({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new $ee56638efea8544d$export$8dea267bd6bde117(colors, 3));
        this.add(new $ee56638efea8544d$export$e176487c05830cc5(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            $ee56638efea8544d$var$_color1.copy(this.light.color);
            $ee56638efea8544d$var$_color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? $ee56638efea8544d$var$_color1 : $ee56638efea8544d$var$_color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt($ee56638efea8544d$var$_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class $ee56638efea8544d$export$3875d39926561055 extends $ee56638efea8544d$export$ff1ed10fedfdd604 {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new $ee56638efea8544d$export$892596cec99bc70e(color1);
        color2 = new $ee56638efea8544d$export$892596cec99bc70e(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new $ee56638efea8544d$export$b7be63a67df8959();
        geometry.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $ee56638efea8544d$export$cbe7a62641830ebd(colors, 3));
        const material = new $ee56638efea8544d$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $ee56638efea8544d$export$361430a10f533cd3 extends $ee56638efea8544d$export$ff1ed10fedfdd604 {
    constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new $ee56638efea8544d$export$892596cec99bc70e(color1);
        color2 = new $ee56638efea8544d$export$892596cec99bc70e(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new $ee56638efea8544d$export$b7be63a67df8959();
        geometry.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $ee56638efea8544d$export$cbe7a62641830ebd(colors, 3));
        const material = new $ee56638efea8544d$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const $ee56638efea8544d$var$_v1 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_v2 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_v3 = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
class $ee56638efea8544d$export$f8e434dc14203e7d extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    constructor(light, size, color){
        super();
        this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        let geometry = new $ee56638efea8544d$export$b7be63a67df8959();
        geometry.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new $ee56638efea8544d$export$fbaaa33907730a0c({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new $ee56638efea8544d$export$17d680238e50603e(geometry, material);
        this.add(this.lightPlane);
        geometry = new $ee56638efea8544d$export$b7be63a67df8959();
        geometry.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new $ee56638efea8544d$export$17d680238e50603e(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        $ee56638efea8544d$var$_v1.setFromMatrixPosition(this.light.matrixWorld);
        $ee56638efea8544d$var$_v2.setFromMatrixPosition(this.light.target.matrixWorld);
        $ee56638efea8544d$var$_v3.subVectors($ee56638efea8544d$var$_v2, $ee56638efea8544d$var$_v1);
        this.lightPlane.lookAt($ee56638efea8544d$var$_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt($ee56638efea8544d$var$_v2);
        this.targetLine.scale.z = $ee56638efea8544d$var$_v3.length();
    }
}
const $ee56638efea8544d$var$_vector = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
const $ee56638efea8544d$var$_camera = /*@__PURE__*/ new $ee56638efea8544d$export$79f141de891a5fed();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html
 */ class $ee56638efea8544d$export$ed8e93f853cd795 extends $ee56638efea8544d$export$ff1ed10fedfdd604 {
    constructor(camera){
        const geometry = new $ee56638efea8544d$export$b7be63a67df8959();
        const material = new $ee56638efea8544d$export$fbaaa33907730a0c({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $ee56638efea8544d$export$cbe7a62641830ebd(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new $ee56638efea8544d$export$892596cec99bc70e(0xffaa00);
        const colorCone = new $ee56638efea8544d$export$892596cec99bc70e(0xff0000);
        const colorUp = new $ee56638efea8544d$export$892596cec99bc70e(0x00aaff);
        const colorTarget = new $ee56638efea8544d$export$892596cec99bc70e(0xffffff);
        const colorCross = new $ee56638efea8544d$export$892596cec99bc70e(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        $ee56638efea8544d$var$_camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // Adjust z values based on coordinate system
        const nearZ = this.camera.coordinateSystem === $ee56638efea8544d$export$5a0e9190d10875d3 ? -1 : 0;
        // center / target
        $ee56638efea8544d$var$setPoint('c', pointMap, geometry, $ee56638efea8544d$var$_camera, 0, 0, nearZ);
        $ee56638efea8544d$var$setPoint('t', pointMap, geometry, $ee56638efea8544d$var$_camera, 0, 0, 1);
        // near
        $ee56638efea8544d$var$setPoint('n1', pointMap, geometry, $ee56638efea8544d$var$_camera, -w, -h, nearZ);
        $ee56638efea8544d$var$setPoint('n2', pointMap, geometry, $ee56638efea8544d$var$_camera, w, -h, nearZ);
        $ee56638efea8544d$var$setPoint('n3', pointMap, geometry, $ee56638efea8544d$var$_camera, -w, h, nearZ);
        $ee56638efea8544d$var$setPoint('n4', pointMap, geometry, $ee56638efea8544d$var$_camera, w, h, nearZ);
        // far
        $ee56638efea8544d$var$setPoint('f1', pointMap, geometry, $ee56638efea8544d$var$_camera, -w, -h, 1);
        $ee56638efea8544d$var$setPoint('f2', pointMap, geometry, $ee56638efea8544d$var$_camera, w, -h, 1);
        $ee56638efea8544d$var$setPoint('f3', pointMap, geometry, $ee56638efea8544d$var$_camera, -w, h, 1);
        $ee56638efea8544d$var$setPoint('f4', pointMap, geometry, $ee56638efea8544d$var$_camera, w, h, 1);
        // up
        $ee56638efea8544d$var$setPoint('u1', pointMap, geometry, $ee56638efea8544d$var$_camera, w * 0.7, h * 1.1, nearZ);
        $ee56638efea8544d$var$setPoint('u2', pointMap, geometry, $ee56638efea8544d$var$_camera, -w * 0.7, h * 1.1, nearZ);
        $ee56638efea8544d$var$setPoint('u3', pointMap, geometry, $ee56638efea8544d$var$_camera, 0, h * 2, nearZ);
        // cross
        $ee56638efea8544d$var$setPoint('cf1', pointMap, geometry, $ee56638efea8544d$var$_camera, -w, 0, 1);
        $ee56638efea8544d$var$setPoint('cf2', pointMap, geometry, $ee56638efea8544d$var$_camera, w, 0, 1);
        $ee56638efea8544d$var$setPoint('cf3', pointMap, geometry, $ee56638efea8544d$var$_camera, 0, -h, 1);
        $ee56638efea8544d$var$setPoint('cf4', pointMap, geometry, $ee56638efea8544d$var$_camera, 0, h, 1);
        $ee56638efea8544d$var$setPoint('cn1', pointMap, geometry, $ee56638efea8544d$var$_camera, -w, 0, nearZ);
        $ee56638efea8544d$var$setPoint('cn2', pointMap, geometry, $ee56638efea8544d$var$_camera, w, 0, nearZ);
        $ee56638efea8544d$var$setPoint('cn3', pointMap, geometry, $ee56638efea8544d$var$_camera, 0, -h, nearZ);
        $ee56638efea8544d$var$setPoint('cn4', pointMap, geometry, $ee56638efea8544d$var$_camera, 0, h, nearZ);
        geometry.getAttribute('position').needsUpdate = true;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function $ee56638efea8544d$var$setPoint(point, pointMap, geometry, camera, x, y, z) {
    $ee56638efea8544d$var$_vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], $ee56638efea8544d$var$_vector.x, $ee56638efea8544d$var$_vector.y, $ee56638efea8544d$var$_vector.z);
    }
}
const $ee56638efea8544d$var$_box = /*@__PURE__*/ new $ee56638efea8544d$export$6f7d5a9418ab2aa3();
class $ee56638efea8544d$export$38a664cc862a6a9d extends $ee56638efea8544d$export$ff1ed10fedfdd604 {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new $ee56638efea8544d$export$b7be63a67df8959();
        geometry.setIndex(new $ee56638efea8544d$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $ee56638efea8544d$export$8dea267bd6bde117(positions, 3));
        super(geometry, new $ee56638efea8544d$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn('THREE.BoxHelper: .update() has no longer arguments.');
        if (this.object !== undefined) $ee56638efea8544d$var$_box.setFromObject(this.object);
        if ($ee56638efea8544d$var$_box.isEmpty()) return;
        const min = $ee56638efea8544d$var$_box.min;
        const max = $ee56638efea8544d$var$_box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $ee56638efea8544d$export$ce39f4bb96c9a290 extends $ee56638efea8544d$export$ff1ed10fedfdd604 {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new $ee56638efea8544d$export$b7be63a67df8959();
        geometry.setIndex(new $ee56638efea8544d$export$8dea267bd6bde117(indices, 1));
        geometry.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(positions, 3));
        super(geometry, new $ee56638efea8544d$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $ee56638efea8544d$export$a34fe8156c66e5d7 extends $ee56638efea8544d$export$17d680238e50603e {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new $ee56638efea8544d$export$b7be63a67df8959();
        geometry.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new $ee56638efea8544d$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new $ee56638efea8544d$export$b7be63a67df8959();
        geometry2.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new $ee56638efea8544d$export$e176487c05830cc5(geometry2, new $ee56638efea8544d$export$55cbcc9b622fe1f5({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const $ee56638efea8544d$var$_axis = /*@__PURE__*/ new $ee56638efea8544d$export$64b5c384219d3699();
let $ee56638efea8544d$var$_lineGeometry, $ee56638efea8544d$var$_coneGeometry;
class $ee56638efea8544d$export$a3008e7bd8d2cbe7 extends $ee56638efea8544d$export$e4dd07dff30cc924 {
    // dir is assumed to be normalized
    constructor(dir = new $ee56638efea8544d$export$64b5c384219d3699(0, 0, 1), origin = new $ee56638efea8544d$export$64b5c384219d3699(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if ($ee56638efea8544d$var$_lineGeometry === undefined) {
            $ee56638efea8544d$var$_lineGeometry = new $ee56638efea8544d$export$b7be63a67df8959();
            $ee56638efea8544d$var$_lineGeometry.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            $ee56638efea8544d$var$_coneGeometry = new $ee56638efea8544d$export$68f745719dbe5198(0, 0.5, 1, 5, 1);
            $ee56638efea8544d$var$_coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new $ee56638efea8544d$export$17d680238e50603e($ee56638efea8544d$var$_lineGeometry, new $ee56638efea8544d$export$fbaaa33907730a0c({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new $ee56638efea8544d$export$e176487c05830cc5($ee56638efea8544d$var$_coneGeometry, new $ee56638efea8544d$export$55cbcc9b622fe1f5({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            $ee56638efea8544d$var$_axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle($ee56638efea8544d$var$_axis, radians);
        }
    }
    setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
class $ee56638efea8544d$export$6c8303f35b8578fd extends $ee56638efea8544d$export$ff1ed10fedfdd604 {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new $ee56638efea8544d$export$b7be63a67df8959();
        geometry.setAttribute('position', new $ee56638efea8544d$export$cbe7a62641830ebd(vertices, 3));
        geometry.setAttribute('color', new $ee56638efea8544d$export$cbe7a62641830ebd(colors, 3));
        const material = new $ee56638efea8544d$export$fbaaa33907730a0c({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new $ee56638efea8544d$export$892596cec99bc70e();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
class $ee56638efea8544d$export$148534a3c727230b {
    constructor(){
        this.type = 'ShapePath';
        this.color = new $ee56638efea8544d$export$892596cec99bc70e();
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(x, y) {
        this.currentPath = new $ee56638efea8544d$export$4b2950bdac9b6ee9();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new $ee56638efea8544d$export$6428a7f2611ef1fa();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = $ee56638efea8544d$export$96bdf6d9c66d7ba8.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new $ee56638efea8544d$export$6428a7f2611ef1fa();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new $ee56638efea8544d$export$6428a7f2611ef1fa(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
}
class $ee56638efea8544d$export$c7c44baae9d9f25f extends $ee56638efea8544d$export$ec8b666c5fe2c75a {
    constructor(object, domElement = null){
        super();
        this.object = object;
        this.domElement = domElement;
        this.enabled = true;
        this.state = -1;
        this.keys = {};
        this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        };
        this.touches = {
            ONE: null,
            TWO: null
        };
    }
    connect() {}
    disconnect() {}
    dispose() {}
    update() {}
}
function $ee56638efea8544d$var$contain(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
function $ee56638efea8544d$var$cover(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
function $ee56638efea8544d$var$fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Given the width, height, format, and type of a texture. Determines how many
 * bytes must be used to represent the texture.
 *
 * @param {Number} width
 * @param {Number} height
 * @param {Number} format
 * @param {Number} type
 * @return {Number} The number of bytes required to represent the texture.
 */ function $ee56638efea8544d$export$cc8c3b705bb8e6e2(width, height, format, type) {
    const typeByteLength = $ee56638efea8544d$var$getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case $ee56638efea8544d$export$988473390501ed4b:
            return width * height;
        case $ee56638efea8544d$export$cc09ccbf6d1ed449:
            return width * height;
        case $ee56638efea8544d$export$9053a81c4a69c289:
            return width * height * 2;
        case $ee56638efea8544d$export$4e041a7967d15c4b:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $ee56638efea8544d$export$aa92e870a709d190:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case $ee56638efea8544d$export$6cdf0b461c7ce8a0:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $ee56638efea8544d$export$1ba1c45f9f77d4d7:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case $ee56638efea8544d$export$7c67423a5ee6f5eb:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case $ee56638efea8544d$export$3f8bb04b555a363c:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case $ee56638efea8544d$export$c200e7d26f592f21:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case $ee56638efea8544d$export$21d1799c6d552fc0:
        case $ee56638efea8544d$export$afa304c3e981b668:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $ee56638efea8544d$export$d2a1a68024a3e56c:
        case $ee56638efea8544d$export$9a79c424327dacf9:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case $ee56638efea8544d$export$d0f0355bb3d948e4:
        case $ee56638efea8544d$export$b71692456c47b6c3:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case $ee56638efea8544d$export$19ada9bbb1af3573:
        case $ee56638efea8544d$export$b82296714358084c:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case $ee56638efea8544d$export$6ab91af2d757aee7:
        case $ee56638efea8544d$export$7800993ef8106a6a:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case $ee56638efea8544d$export$23ed8300a860e7d8:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case $ee56638efea8544d$export$dc5570b4a2b92d48:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case $ee56638efea8544d$export$68880cd325f8b2fb:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case $ee56638efea8544d$export$7d2c0be323373d95:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case $ee56638efea8544d$export$22b52da301fc3a3e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case $ee56638efea8544d$export$c009e2cb4a66485e:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case $ee56638efea8544d$export$118fff5afa255b63:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case $ee56638efea8544d$export$120713c829ae0667:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case $ee56638efea8544d$export$c79eeabbf53313e9:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case $ee56638efea8544d$export$443cf6567cdd6424:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case $ee56638efea8544d$export$6573984fc9840780:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case $ee56638efea8544d$export$e7aee563f30091de:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case $ee56638efea8544d$export$2eb8634622ddeab7:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case $ee56638efea8544d$export$202b1ce7b5d25742:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case $ee56638efea8544d$export$18ab77abd087e467:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case $ee56638efea8544d$export$ce40b115e188bc81:
        case $ee56638efea8544d$export$d279c5c4bac5121e:
        case $ee56638efea8544d$export$cde52d17225fdbd3:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case $ee56638efea8544d$export$b1688df4c4c21670:
        case $ee56638efea8544d$export$fc15e5d8261eed58:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case $ee56638efea8544d$export$d220f6ade8463a0f:
        case $ee56638efea8544d$export$768646d09dc1b6ef:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${format} format.`);
}
function $ee56638efea8544d$var$getTextureTypeByteLength(type) {
    switch(type){
        case $ee56638efea8544d$export$2e8ce08d3f6f5e10:
        case $ee56638efea8544d$export$545fce0311a9796a:
            return {
                byteLength: 1,
                components: 1
            };
        case $ee56638efea8544d$export$c63dc51868b06a9d:
        case $ee56638efea8544d$export$88572337f312435f:
        case $ee56638efea8544d$export$2697304443f382bc:
            return {
                byteLength: 2,
                components: 1
            };
        case $ee56638efea8544d$export$b3969b01faf587f2:
        case $ee56638efea8544d$export$18886f8ae33e90de:
            return {
                byteLength: 2,
                components: 4
            };
        case $ee56638efea8544d$export$c3c7fc4518ebba96:
        case $ee56638efea8544d$export$5c612977753abe2:
        case $ee56638efea8544d$export$f6d331659b644596:
            return {
                byteLength: 4,
                components: 1
            };
        case $ee56638efea8544d$export$5a4c329b7e2092d3:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${type}.`);
}
const $ee56638efea8544d$export$ec276d39f33d4b7 = {
    contain: $ee56638efea8544d$var$contain,
    cover: $ee56638efea8544d$var$cover,
    fill: $ee56638efea8544d$var$fill,
    getByteLength: $ee56638efea8544d$export$cc8c3b705bb8e6e2
};
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: $ee56638efea8544d$export$3545e07a80636437
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = $ee56638efea8544d$export$3545e07a80636437;
}

/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ 
function $54cdb8f680e2b923$var$WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function $54cdb8f680e2b923$var$WebGLAttributes(gl) {
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const size = array.byteLength;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.bufferSubData`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousRange.start + previousRange.count + 1) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            attribute.clearUpdateRanges();
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error('THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.');
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
var $54cdb8f680e2b923$var$alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var $54cdb8f680e2b923$var$alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var $54cdb8f680e2b923$var$alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var $54cdb8f680e2b923$var$alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $54cdb8f680e2b923$var$alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var $54cdb8f680e2b923$var$aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var $54cdb8f680e2b923$var$batching_pars_vertex = "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec3 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n\t}\n#endif";
var $54cdb8f680e2b923$var$batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var $54cdb8f680e2b923$var$begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var $54cdb8f680e2b923$var$beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var $54cdb8f680e2b923$var$bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var $54cdb8f680e2b923$var$iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var $54cdb8f680e2b923$var$bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var $54cdb8f680e2b923$var$clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var $54cdb8f680e2b923$var$clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var $54cdb8f680e2b923$var$clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var $54cdb8f680e2b923$var$color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var $54cdb8f680e2b923$var$color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $54cdb8f680e2b923$var$color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var $54cdb8f680e2b923$var$color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n\tvColor.xyz *= batchingColor.xyz;\n#endif";
var $54cdb8f680e2b923$var$common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var $54cdb8f680e2b923$var$cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var $54cdb8f680e2b923$var$defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var $54cdb8f680e2b923$var$displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var $54cdb8f680e2b923$var$emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var $54cdb8f680e2b923$var$emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var $54cdb8f680e2b923$var$colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var $54cdb8f680e2b923$var$colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var $54cdb8f680e2b923$var$envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var $54cdb8f680e2b923$var$envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var $54cdb8f680e2b923$var$fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var $54cdb8f680e2b923$var$fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var $54cdb8f680e2b923$var$fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var $54cdb8f680e2b923$var$lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var $54cdb8f680e2b923$var$lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var $54cdb8f680e2b923$var$lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var $54cdb8f680e2b923$var$lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var $54cdb8f680e2b923$var$envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var $54cdb8f680e2b923$var$lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var $54cdb8f680e2b923$var$lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var $54cdb8f680e2b923$var$lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var $54cdb8f680e2b923$var$lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var $54cdb8f680e2b923$var$lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var $54cdb8f680e2b923$var$lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var $54cdb8f680e2b923$var$lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var $54cdb8f680e2b923$var$logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var $54cdb8f680e2b923$var$logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $54cdb8f680e2b923$var$logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var $54cdb8f680e2b923$var$logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var $54cdb8f680e2b923$var$map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var $54cdb8f680e2b923$var$map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var $54cdb8f680e2b923$var$map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var $54cdb8f680e2b923$var$map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var $54cdb8f680e2b923$var$metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var $54cdb8f680e2b923$var$metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var $54cdb8f680e2b923$var$morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";
var $54cdb8f680e2b923$var$morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var $54cdb8f680e2b923$var$morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $54cdb8f680e2b923$var$morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif";
var $54cdb8f680e2b923$var$morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var $54cdb8f680e2b923$var$normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var $54cdb8f680e2b923$var$normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var $54cdb8f680e2b923$var$normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var $54cdb8f680e2b923$var$clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var $54cdb8f680e2b923$var$clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var $54cdb8f680e2b923$var$clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var $54cdb8f680e2b923$var$iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var $54cdb8f680e2b923$var$opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var $54cdb8f680e2b923$var$packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var $54cdb8f680e2b923$var$premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var $54cdb8f680e2b923$var$project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var $54cdb8f680e2b923$var$dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var $54cdb8f680e2b923$var$dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var $54cdb8f680e2b923$var$roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var $54cdb8f680e2b923$var$roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var $54cdb8f680e2b923$var$shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\t\n\t\tfloat lightToPositionLength = length( lightToPosition );\n\t\tif ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t\t) * ( 1.0 / 9.0 );\n\t\t\t#else\n\t\t\t\tshadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n#endif";
var $54cdb8f680e2b923$var$shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var $54cdb8f680e2b923$var$shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var $54cdb8f680e2b923$var$skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var $54cdb8f680e2b923$var$skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";
var $54cdb8f680e2b923$var$skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var $54cdb8f680e2b923$var$skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var $54cdb8f680e2b923$var$specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var $54cdb8f680e2b923$var$specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var $54cdb8f680e2b923$var$tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var $54cdb8f680e2b923$var$tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var $54cdb8f680e2b923$var$transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var $54cdb8f680e2b923$var$transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var $54cdb8f680e2b923$var$uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $54cdb8f680e2b923$var$uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var $54cdb8f680e2b923$var$uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var $54cdb8f680e2b923$var$worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const $54cdb8f680e2b923$var$vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const $54cdb8f680e2b923$var$fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $54cdb8f680e2b923$var$vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $54cdb8f680e2b923$var$fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $54cdb8f680e2b923$var$vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const $54cdb8f680e2b923$var$fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $54cdb8f680e2b923$var$vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const $54cdb8f680e2b923$var$fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}";
const $54cdb8f680e2b923$var$vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const $54cdb8f680e2b923$var$fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
const $54cdb8f680e2b923$var$vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const $54cdb8f680e2b923$var$fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const $54cdb8f680e2b923$var$vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $54cdb8f680e2b923$var$fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $54cdb8f680e2b923$var$vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const $54cdb8f680e2b923$var$fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $54cdb8f680e2b923$var$vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $54cdb8f680e2b923$var$fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $54cdb8f680e2b923$var$vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const $54cdb8f680e2b923$var$fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $54cdb8f680e2b923$var$vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const $54cdb8f680e2b923$var$fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const $54cdb8f680e2b923$var$vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $54cdb8f680e2b923$var$fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $54cdb8f680e2b923$var$vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const $54cdb8f680e2b923$var$fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $54cdb8f680e2b923$var$vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $54cdb8f680e2b923$var$fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const $54cdb8f680e2b923$var$vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const $54cdb8f680e2b923$var$fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const $54cdb8f680e2b923$var$vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const $54cdb8f680e2b923$var$fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $54cdb8f680e2b923$var$vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const $54cdb8f680e2b923$var$fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const $54cdb8f680e2b923$export$955f9f2e84c43c8b = {
    alphahash_fragment: $54cdb8f680e2b923$var$alphahash_fragment,
    alphahash_pars_fragment: $54cdb8f680e2b923$var$alphahash_pars_fragment,
    alphamap_fragment: $54cdb8f680e2b923$var$alphamap_fragment,
    alphamap_pars_fragment: $54cdb8f680e2b923$var$alphamap_pars_fragment,
    alphatest_fragment: $54cdb8f680e2b923$var$alphatest_fragment,
    alphatest_pars_fragment: $54cdb8f680e2b923$var$alphatest_pars_fragment,
    aomap_fragment: $54cdb8f680e2b923$var$aomap_fragment,
    aomap_pars_fragment: $54cdb8f680e2b923$var$aomap_pars_fragment,
    batching_pars_vertex: $54cdb8f680e2b923$var$batching_pars_vertex,
    batching_vertex: $54cdb8f680e2b923$var$batching_vertex,
    begin_vertex: $54cdb8f680e2b923$var$begin_vertex,
    beginnormal_vertex: $54cdb8f680e2b923$var$beginnormal_vertex,
    bsdfs: $54cdb8f680e2b923$var$bsdfs,
    iridescence_fragment: $54cdb8f680e2b923$var$iridescence_fragment,
    bumpmap_pars_fragment: $54cdb8f680e2b923$var$bumpmap_pars_fragment,
    clipping_planes_fragment: $54cdb8f680e2b923$var$clipping_planes_fragment,
    clipping_planes_pars_fragment: $54cdb8f680e2b923$var$clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: $54cdb8f680e2b923$var$clipping_planes_pars_vertex,
    clipping_planes_vertex: $54cdb8f680e2b923$var$clipping_planes_vertex,
    color_fragment: $54cdb8f680e2b923$var$color_fragment,
    color_pars_fragment: $54cdb8f680e2b923$var$color_pars_fragment,
    color_pars_vertex: $54cdb8f680e2b923$var$color_pars_vertex,
    color_vertex: $54cdb8f680e2b923$var$color_vertex,
    common: $54cdb8f680e2b923$var$common,
    cube_uv_reflection_fragment: $54cdb8f680e2b923$var$cube_uv_reflection_fragment,
    defaultnormal_vertex: $54cdb8f680e2b923$var$defaultnormal_vertex,
    displacementmap_pars_vertex: $54cdb8f680e2b923$var$displacementmap_pars_vertex,
    displacementmap_vertex: $54cdb8f680e2b923$var$displacementmap_vertex,
    emissivemap_fragment: $54cdb8f680e2b923$var$emissivemap_fragment,
    emissivemap_pars_fragment: $54cdb8f680e2b923$var$emissivemap_pars_fragment,
    colorspace_fragment: $54cdb8f680e2b923$var$colorspace_fragment,
    colorspace_pars_fragment: $54cdb8f680e2b923$var$colorspace_pars_fragment,
    envmap_fragment: $54cdb8f680e2b923$var$envmap_fragment,
    envmap_common_pars_fragment: $54cdb8f680e2b923$var$envmap_common_pars_fragment,
    envmap_pars_fragment: $54cdb8f680e2b923$var$envmap_pars_fragment,
    envmap_pars_vertex: $54cdb8f680e2b923$var$envmap_pars_vertex,
    envmap_physical_pars_fragment: $54cdb8f680e2b923$var$envmap_physical_pars_fragment,
    envmap_vertex: $54cdb8f680e2b923$var$envmap_vertex,
    fog_vertex: $54cdb8f680e2b923$var$fog_vertex,
    fog_pars_vertex: $54cdb8f680e2b923$var$fog_pars_vertex,
    fog_fragment: $54cdb8f680e2b923$var$fog_fragment,
    fog_pars_fragment: $54cdb8f680e2b923$var$fog_pars_fragment,
    gradientmap_pars_fragment: $54cdb8f680e2b923$var$gradientmap_pars_fragment,
    lightmap_pars_fragment: $54cdb8f680e2b923$var$lightmap_pars_fragment,
    lights_lambert_fragment: $54cdb8f680e2b923$var$lights_lambert_fragment,
    lights_lambert_pars_fragment: $54cdb8f680e2b923$var$lights_lambert_pars_fragment,
    lights_pars_begin: $54cdb8f680e2b923$var$lights_pars_begin,
    lights_toon_fragment: $54cdb8f680e2b923$var$lights_toon_fragment,
    lights_toon_pars_fragment: $54cdb8f680e2b923$var$lights_toon_pars_fragment,
    lights_phong_fragment: $54cdb8f680e2b923$var$lights_phong_fragment,
    lights_phong_pars_fragment: $54cdb8f680e2b923$var$lights_phong_pars_fragment,
    lights_physical_fragment: $54cdb8f680e2b923$var$lights_physical_fragment,
    lights_physical_pars_fragment: $54cdb8f680e2b923$var$lights_physical_pars_fragment,
    lights_fragment_begin: $54cdb8f680e2b923$var$lights_fragment_begin,
    lights_fragment_maps: $54cdb8f680e2b923$var$lights_fragment_maps,
    lights_fragment_end: $54cdb8f680e2b923$var$lights_fragment_end,
    logdepthbuf_fragment: $54cdb8f680e2b923$var$logdepthbuf_fragment,
    logdepthbuf_pars_fragment: $54cdb8f680e2b923$var$logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: $54cdb8f680e2b923$var$logdepthbuf_pars_vertex,
    logdepthbuf_vertex: $54cdb8f680e2b923$var$logdepthbuf_vertex,
    map_fragment: $54cdb8f680e2b923$var$map_fragment,
    map_pars_fragment: $54cdb8f680e2b923$var$map_pars_fragment,
    map_particle_fragment: $54cdb8f680e2b923$var$map_particle_fragment,
    map_particle_pars_fragment: $54cdb8f680e2b923$var$map_particle_pars_fragment,
    metalnessmap_fragment: $54cdb8f680e2b923$var$metalnessmap_fragment,
    metalnessmap_pars_fragment: $54cdb8f680e2b923$var$metalnessmap_pars_fragment,
    morphinstance_vertex: $54cdb8f680e2b923$var$morphinstance_vertex,
    morphcolor_vertex: $54cdb8f680e2b923$var$morphcolor_vertex,
    morphnormal_vertex: $54cdb8f680e2b923$var$morphnormal_vertex,
    morphtarget_pars_vertex: $54cdb8f680e2b923$var$morphtarget_pars_vertex,
    morphtarget_vertex: $54cdb8f680e2b923$var$morphtarget_vertex,
    normal_fragment_begin: $54cdb8f680e2b923$var$normal_fragment_begin,
    normal_fragment_maps: $54cdb8f680e2b923$var$normal_fragment_maps,
    normal_pars_fragment: $54cdb8f680e2b923$var$normal_pars_fragment,
    normal_pars_vertex: $54cdb8f680e2b923$var$normal_pars_vertex,
    normal_vertex: $54cdb8f680e2b923$var$normal_vertex,
    normalmap_pars_fragment: $54cdb8f680e2b923$var$normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: $54cdb8f680e2b923$var$clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: $54cdb8f680e2b923$var$clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: $54cdb8f680e2b923$var$clearcoat_pars_fragment,
    iridescence_pars_fragment: $54cdb8f680e2b923$var$iridescence_pars_fragment,
    opaque_fragment: $54cdb8f680e2b923$var$opaque_fragment,
    packing: $54cdb8f680e2b923$var$packing,
    premultiplied_alpha_fragment: $54cdb8f680e2b923$var$premultiplied_alpha_fragment,
    project_vertex: $54cdb8f680e2b923$var$project_vertex,
    dithering_fragment: $54cdb8f680e2b923$var$dithering_fragment,
    dithering_pars_fragment: $54cdb8f680e2b923$var$dithering_pars_fragment,
    roughnessmap_fragment: $54cdb8f680e2b923$var$roughnessmap_fragment,
    roughnessmap_pars_fragment: $54cdb8f680e2b923$var$roughnessmap_pars_fragment,
    shadowmap_pars_fragment: $54cdb8f680e2b923$var$shadowmap_pars_fragment,
    shadowmap_pars_vertex: $54cdb8f680e2b923$var$shadowmap_pars_vertex,
    shadowmap_vertex: $54cdb8f680e2b923$var$shadowmap_vertex,
    shadowmask_pars_fragment: $54cdb8f680e2b923$var$shadowmask_pars_fragment,
    skinbase_vertex: $54cdb8f680e2b923$var$skinbase_vertex,
    skinning_pars_vertex: $54cdb8f680e2b923$var$skinning_pars_vertex,
    skinning_vertex: $54cdb8f680e2b923$var$skinning_vertex,
    skinnormal_vertex: $54cdb8f680e2b923$var$skinnormal_vertex,
    specularmap_fragment: $54cdb8f680e2b923$var$specularmap_fragment,
    specularmap_pars_fragment: $54cdb8f680e2b923$var$specularmap_pars_fragment,
    tonemapping_fragment: $54cdb8f680e2b923$var$tonemapping_fragment,
    tonemapping_pars_fragment: $54cdb8f680e2b923$var$tonemapping_pars_fragment,
    transmission_fragment: $54cdb8f680e2b923$var$transmission_fragment,
    transmission_pars_fragment: $54cdb8f680e2b923$var$transmission_pars_fragment,
    uv_pars_fragment: $54cdb8f680e2b923$var$uv_pars_fragment,
    uv_pars_vertex: $54cdb8f680e2b923$var$uv_pars_vertex,
    uv_vertex: $54cdb8f680e2b923$var$uv_vertex,
    worldpos_vertex: $54cdb8f680e2b923$var$worldpos_vertex,
    background_vert: $54cdb8f680e2b923$var$vertex$h,
    background_frag: $54cdb8f680e2b923$var$fragment$h,
    backgroundCube_vert: $54cdb8f680e2b923$var$vertex$g,
    backgroundCube_frag: $54cdb8f680e2b923$var$fragment$g,
    cube_vert: $54cdb8f680e2b923$var$vertex$f,
    cube_frag: $54cdb8f680e2b923$var$fragment$f,
    depth_vert: $54cdb8f680e2b923$var$vertex$e,
    depth_frag: $54cdb8f680e2b923$var$fragment$e,
    distanceRGBA_vert: $54cdb8f680e2b923$var$vertex$d,
    distanceRGBA_frag: $54cdb8f680e2b923$var$fragment$d,
    equirect_vert: $54cdb8f680e2b923$var$vertex$c,
    equirect_frag: $54cdb8f680e2b923$var$fragment$c,
    linedashed_vert: $54cdb8f680e2b923$var$vertex$b,
    linedashed_frag: $54cdb8f680e2b923$var$fragment$b,
    meshbasic_vert: $54cdb8f680e2b923$var$vertex$a,
    meshbasic_frag: $54cdb8f680e2b923$var$fragment$a,
    meshlambert_vert: $54cdb8f680e2b923$var$vertex$9,
    meshlambert_frag: $54cdb8f680e2b923$var$fragment$9,
    meshmatcap_vert: $54cdb8f680e2b923$var$vertex$8,
    meshmatcap_frag: $54cdb8f680e2b923$var$fragment$8,
    meshnormal_vert: $54cdb8f680e2b923$var$vertex$7,
    meshnormal_frag: $54cdb8f680e2b923$var$fragment$7,
    meshphong_vert: $54cdb8f680e2b923$var$vertex$6,
    meshphong_frag: $54cdb8f680e2b923$var$fragment$6,
    meshphysical_vert: $54cdb8f680e2b923$var$vertex$5,
    meshphysical_frag: $54cdb8f680e2b923$var$fragment$5,
    meshtoon_vert: $54cdb8f680e2b923$var$vertex$4,
    meshtoon_frag: $54cdb8f680e2b923$var$fragment$4,
    points_vert: $54cdb8f680e2b923$var$vertex$3,
    points_frag: $54cdb8f680e2b923$var$fragment$3,
    shadow_vert: $54cdb8f680e2b923$var$vertex$2,
    shadow_frag: $54cdb8f680e2b923$var$fragment$2,
    sprite_vert: $54cdb8f680e2b923$var$vertex$1,
    sprite_frag: $54cdb8f680e2b923$var$fragment$1
};
/**
 * Uniforms library for shared webgl shaders
 */ const $54cdb8f680e2b923$export$6643083551874bf5 = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        },
        normalScale: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$c977b3e384af9ae1)(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$892596cec99bc70e)(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$892596cec99bc70e)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$c977b3e384af9ae1)(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
        },
        alphaTest: {
            value: 0
        }
    }
};
const $54cdb8f680e2b923$export$bee4a7d47f8f5014 = {
    basic: {
        uniforms: /*@__PURE__*/ (0, $ee56638efea8544d$export$8916ce6879271f43)([
            $54cdb8f680e2b923$export$6643083551874bf5.common,
            $54cdb8f680e2b923$export$6643083551874bf5.specularmap,
            $54cdb8f680e2b923$export$6643083551874bf5.envmap,
            $54cdb8f680e2b923$export$6643083551874bf5.aomap,
            $54cdb8f680e2b923$export$6643083551874bf5.lightmap,
            $54cdb8f680e2b923$export$6643083551874bf5.fog
        ]),
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshbasic_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ (0, $ee56638efea8544d$export$8916ce6879271f43)([
            $54cdb8f680e2b923$export$6643083551874bf5.common,
            $54cdb8f680e2b923$export$6643083551874bf5.specularmap,
            $54cdb8f680e2b923$export$6643083551874bf5.envmap,
            $54cdb8f680e2b923$export$6643083551874bf5.aomap,
            $54cdb8f680e2b923$export$6643083551874bf5.lightmap,
            $54cdb8f680e2b923$export$6643083551874bf5.emissivemap,
            $54cdb8f680e2b923$export$6643083551874bf5.bumpmap,
            $54cdb8f680e2b923$export$6643083551874bf5.normalmap,
            $54cdb8f680e2b923$export$6643083551874bf5.displacementmap,
            $54cdb8f680e2b923$export$6643083551874bf5.fog,
            $54cdb8f680e2b923$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$892596cec99bc70e)(0x000000)
                }
            }
        ]),
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshlambert_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ (0, $ee56638efea8544d$export$8916ce6879271f43)([
            $54cdb8f680e2b923$export$6643083551874bf5.common,
            $54cdb8f680e2b923$export$6643083551874bf5.specularmap,
            $54cdb8f680e2b923$export$6643083551874bf5.envmap,
            $54cdb8f680e2b923$export$6643083551874bf5.aomap,
            $54cdb8f680e2b923$export$6643083551874bf5.lightmap,
            $54cdb8f680e2b923$export$6643083551874bf5.emissivemap,
            $54cdb8f680e2b923$export$6643083551874bf5.bumpmap,
            $54cdb8f680e2b923$export$6643083551874bf5.normalmap,
            $54cdb8f680e2b923$export$6643083551874bf5.displacementmap,
            $54cdb8f680e2b923$export$6643083551874bf5.fog,
            $54cdb8f680e2b923$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$892596cec99bc70e)(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$892596cec99bc70e)(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshphong_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ (0, $ee56638efea8544d$export$8916ce6879271f43)([
            $54cdb8f680e2b923$export$6643083551874bf5.common,
            $54cdb8f680e2b923$export$6643083551874bf5.envmap,
            $54cdb8f680e2b923$export$6643083551874bf5.aomap,
            $54cdb8f680e2b923$export$6643083551874bf5.lightmap,
            $54cdb8f680e2b923$export$6643083551874bf5.emissivemap,
            $54cdb8f680e2b923$export$6643083551874bf5.bumpmap,
            $54cdb8f680e2b923$export$6643083551874bf5.normalmap,
            $54cdb8f680e2b923$export$6643083551874bf5.displacementmap,
            $54cdb8f680e2b923$export$6643083551874bf5.roughnessmap,
            $54cdb8f680e2b923$export$6643083551874bf5.metalnessmap,
            $54cdb8f680e2b923$export$6643083551874bf5.fog,
            $54cdb8f680e2b923$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$892596cec99bc70e)(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshphysical_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ (0, $ee56638efea8544d$export$8916ce6879271f43)([
            $54cdb8f680e2b923$export$6643083551874bf5.common,
            $54cdb8f680e2b923$export$6643083551874bf5.aomap,
            $54cdb8f680e2b923$export$6643083551874bf5.lightmap,
            $54cdb8f680e2b923$export$6643083551874bf5.emissivemap,
            $54cdb8f680e2b923$export$6643083551874bf5.bumpmap,
            $54cdb8f680e2b923$export$6643083551874bf5.normalmap,
            $54cdb8f680e2b923$export$6643083551874bf5.displacementmap,
            $54cdb8f680e2b923$export$6643083551874bf5.gradientmap,
            $54cdb8f680e2b923$export$6643083551874bf5.fog,
            $54cdb8f680e2b923$export$6643083551874bf5.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$892596cec99bc70e)(0x000000)
                }
            }
        ]),
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshtoon_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ (0, $ee56638efea8544d$export$8916ce6879271f43)([
            $54cdb8f680e2b923$export$6643083551874bf5.common,
            $54cdb8f680e2b923$export$6643083551874bf5.bumpmap,
            $54cdb8f680e2b923$export$6643083551874bf5.normalmap,
            $54cdb8f680e2b923$export$6643083551874bf5.displacementmap,
            $54cdb8f680e2b923$export$6643083551874bf5.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshmatcap_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ (0, $ee56638efea8544d$export$8916ce6879271f43)([
            $54cdb8f680e2b923$export$6643083551874bf5.points,
            $54cdb8f680e2b923$export$6643083551874bf5.fog
        ]),
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.points_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ (0, $ee56638efea8544d$export$8916ce6879271f43)([
            $54cdb8f680e2b923$export$6643083551874bf5.common,
            $54cdb8f680e2b923$export$6643083551874bf5.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.linedashed_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ (0, $ee56638efea8544d$export$8916ce6879271f43)([
            $54cdb8f680e2b923$export$6643083551874bf5.common,
            $54cdb8f680e2b923$export$6643083551874bf5.displacementmap
        ]),
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.depth_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ (0, $ee56638efea8544d$export$8916ce6879271f43)([
            $54cdb8f680e2b923$export$6643083551874bf5.common,
            $54cdb8f680e2b923$export$6643083551874bf5.bumpmap,
            $54cdb8f680e2b923$export$6643083551874bf5.normalmap,
            $54cdb8f680e2b923$export$6643083551874bf5.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshnormal_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ (0, $ee56638efea8544d$export$8916ce6879271f43)([
            $54cdb8f680e2b923$export$6643083551874bf5.sprite,
            $54cdb8f680e2b923$export$6643083551874bf5.fog
        ]),
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.sprite_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.background_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
            }
        },
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.backgroundCube_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.cube_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.equirect_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.equirect_frag
    },
    distanceRGBA: {
        uniforms: /*@__PURE__*/ (0, $ee56638efea8544d$export$8916ce6879271f43)([
            $54cdb8f680e2b923$export$6643083551874bf5.common,
            $54cdb8f680e2b923$export$6643083551874bf5.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$64b5c384219d3699)()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.distanceRGBA_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.distanceRGBA_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ (0, $ee56638efea8544d$export$8916ce6879271f43)([
            $54cdb8f680e2b923$export$6643083551874bf5.lights,
            $54cdb8f680e2b923$export$6643083551874bf5.fog,
            {
                color: {
                    value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$892596cec99bc70e)(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.shadow_vert,
        fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.shadow_frag
    }
};
$54cdb8f680e2b923$export$bee4a7d47f8f5014.physical = {
    uniforms: /*@__PURE__*/ (0, $ee56638efea8544d$export$8916ce6879271f43)([
        $54cdb8f680e2b923$export$bee4a7d47f8f5014.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$c977b3e384af9ae1)(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$892596cec99bc70e)(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$c977b3e384af9ae1)()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$892596cec99bc70e)(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$892596cec99bc70e)(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$c977b3e384af9ae1)()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)()
            }
        }
    ]),
    vertexShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshphysical_vert,
    fragmentShader: $54cdb8f680e2b923$export$955f9f2e84c43c8b.meshphysical_frag
};
const $54cdb8f680e2b923$var$_rgb = {
    r: 0,
    b: 0,
    g: 0
};
const $54cdb8f680e2b923$var$_e1$1 = /*@__PURE__*/ new (0, $ee56638efea8544d$export$d93cc409a0768c5f)();
const $54cdb8f680e2b923$var$_m1$1 = /*@__PURE__*/ new (0, $ee56638efea8544d$export$2ae72fc923e5eb5)();
function $54cdb8f680e2b923$var$WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new (0, $ee56638efea8544d$export$892596cec99bc70e)(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function getBackground(scene) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        return background;
    }
    function render(scene) {
        let forceClear = false;
        const background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        const background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === (0, $ee56638efea8544d$export$dbf3e70ff37af79))) {
            if (boxMesh === undefined) {
                boxMesh = new (0, $ee56638efea8544d$export$e176487c05830cc5)(new (0, $ee56638efea8544d$export$33e43285f7406bd5)(1, 1, 1), new (0, $ee56638efea8544d$export$83c7d75d550a8b0d)({
                    name: 'BackgroundCubeMaterial',
                    uniforms: (0, $ee56638efea8544d$export$acda854380553452)($54cdb8f680e2b923$export$bee4a7d47f8f5014.backgroundCube.uniforms),
                    vertexShader: $54cdb8f680e2b923$export$bee4a7d47f8f5014.backgroundCube.vertexShader,
                    fragmentShader: $54cdb8f680e2b923$export$bee4a7d47f8f5014.backgroundCube.fragmentShader,
                    side: (0, $ee56638efea8544d$export$d9f0486e75b5ace),
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            $54cdb8f680e2b923$var$_e1$1.copy(scene.backgroundRotation);
            // accommodate left-handed frame
            $54cdb8f680e2b923$var$_e1$1.x *= -1;
            $54cdb8f680e2b923$var$_e1$1.y *= -1;
            $54cdb8f680e2b923$var$_e1$1.z *= -1;
            if (background.isCubeTexture && background.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $54cdb8f680e2b923$var$_e1$1.y *= -1;
                $54cdb8f680e2b923$var$_e1$1.z *= -1;
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4($54cdb8f680e2b923$var$_m1$1.makeRotationFromEuler($54cdb8f680e2b923$var$_e1$1));
            boxMesh.material.toneMapped = (0, $ee56638efea8544d$export$5e6fd513f44698c).getTransfer(background.colorSpace) !== (0, $ee56638efea8544d$export$8d0a61916cc26abb);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new (0, $ee56638efea8544d$export$e176487c05830cc5)(new (0, $ee56638efea8544d$export$967d831af31f69ce)(2, 2), new (0, $ee56638efea8544d$export$83c7d75d550a8b0d)({
                    name: 'BackgroundMaterial',
                    uniforms: (0, $ee56638efea8544d$export$acda854380553452)($54cdb8f680e2b923$export$bee4a7d47f8f5014.background.uniforms),
                    vertexShader: $54cdb8f680e2b923$export$bee4a7d47f8f5014.background.vertexShader,
                    fragmentShader: $54cdb8f680e2b923$export$bee4a7d47f8f5014.background.fragmentShader,
                    side: (0, $ee56638efea8544d$export$2ede184fc2998901),
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = (0, $ee56638efea8544d$export$5e6fd513f44698c).getTransfer(background.colorSpace) !== (0, $ee56638efea8544d$export$8d0a61916cc26abb);
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB($54cdb8f680e2b923$var$_rgb, (0, $ee56638efea8544d$export$a630742c640528c1)(renderer));
        state.buffers.color.setClear($54cdb8f680e2b923$var$_rgb.r, $54cdb8f680e2b923$var$_rgb.g, $54cdb8f680e2b923$var$_rgb.b, alpha, premultipliedAlpha);
    }
    function dispose() {
        if (boxMesh !== undefined) {
            boxMesh.geometry.dispose();
            boxMesh.material.dispose();
        }
        if (planeMesh !== undefined) {
            planeMesh.geometry.dispose();
            planeMesh.material.dispose();
        }
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList,
        dispose: dispose
    };
}
function $54cdb8f680e2b923$var$WebGLBindingStates(gl, attributes) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        const state = getBindingState(geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === (0, $ee56638efea8544d$export$5c612977753abe2);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function $54cdb8f680e2b923$var$WebGLBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i], counts[i], primcount[i]);
        else {
            extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $54cdb8f680e2b923$var$WebGLCapabilities(gl, extensions, parameters, utils) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== (0, $ee56638efea8544d$export$3f8bb04b555a363c) && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        const halfFloatSupportedByExt = textureType === (0, $ee56638efea8544d$export$2697304443f382bc) && (extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float'));
        if (textureType !== (0, $ee56638efea8544d$export$2e8ce08d3f6f5e10) && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== (0, $ee56638efea8544d$export$f6d331659b644596) && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const reverseDepthBuffer = parameters.reverseDepthBuffer === true && extensions.has('EXT_clip_control');
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const vertexTextures = maxVertexTextures > 0;
    const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        reverseDepthBuffer: reverseDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        maxSamples: maxSamples
    };
}
function $54cdb8f680e2b923$var$WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new (0, $ee56638efea8544d$export$7ff5ac152ef991b0)(), viewNormalMatrix = new (0, $ee56638efea8544d$export$8ff26dafa08918)(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function $54cdb8f680e2b923$var$WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === (0, $ee56638efea8544d$export$d64030b316d3b087)) texture.mapping = (0, $ee56638efea8544d$export$8759762a6477f2c4);
        else if (mapping === (0, $ee56638efea8544d$export$ee99d97d46898098)) texture.mapping = (0, $ee56638efea8544d$export$dc59f8aed047f61d);
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === (0, $ee56638efea8544d$export$d64030b316d3b087) || mapping === (0, $ee56638efea8544d$export$ee99d97d46898098)) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new (0, $ee56638efea8544d$export$ac386671d651941e)(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const $54cdb8f680e2b923$var$LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const $54cdb8f680e2b923$var$EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const $54cdb8f680e2b923$var$MAX_SAMPLES = 20;
const $54cdb8f680e2b923$var$_flatCamera = /*@__PURE__*/ new (0, $ee56638efea8544d$export$9ebf355ee4ed261b)();
const $54cdb8f680e2b923$var$_clearColor = /*@__PURE__*/ new (0, $ee56638efea8544d$export$892596cec99bc70e)();
let $54cdb8f680e2b923$var$_oldTarget = null;
let $54cdb8f680e2b923$var$_oldActiveCubeFace = 0;
let $54cdb8f680e2b923$var$_oldActiveMipmapLevel = 0;
let $54cdb8f680e2b923$var$_oldXrEnabled = false;
// Golden Ratio
const $54cdb8f680e2b923$var$PHI = (1 + Math.sqrt(5)) / 2;
const $54cdb8f680e2b923$var$INV_PHI = 1 / $54cdb8f680e2b923$var$PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const $54cdb8f680e2b923$var$_axisDirections = [
    /*@__PURE__*/ new (0, $ee56638efea8544d$export$64b5c384219d3699)(-$54cdb8f680e2b923$var$PHI, $54cdb8f680e2b923$var$INV_PHI, 0),
    /*@__PURE__*/ new (0, $ee56638efea8544d$export$64b5c384219d3699)($54cdb8f680e2b923$var$PHI, $54cdb8f680e2b923$var$INV_PHI, 0),
    /*@__PURE__*/ new (0, $ee56638efea8544d$export$64b5c384219d3699)(-$54cdb8f680e2b923$var$INV_PHI, 0, $54cdb8f680e2b923$var$PHI),
    /*@__PURE__*/ new (0, $ee56638efea8544d$export$64b5c384219d3699)($54cdb8f680e2b923$var$INV_PHI, 0, $54cdb8f680e2b923$var$PHI),
    /*@__PURE__*/ new (0, $ee56638efea8544d$export$64b5c384219d3699)(0, $54cdb8f680e2b923$var$PHI, -$54cdb8f680e2b923$var$INV_PHI),
    /*@__PURE__*/ new (0, $ee56638efea8544d$export$64b5c384219d3699)(0, $54cdb8f680e2b923$var$PHI, $54cdb8f680e2b923$var$INV_PHI),
    /*@__PURE__*/ new (0, $ee56638efea8544d$export$64b5c384219d3699)(-1, 1, -1),
    /*@__PURE__*/ new (0, $ee56638efea8544d$export$64b5c384219d3699)(1, 1, -1),
    /*@__PURE__*/ new (0, $ee56638efea8544d$export$64b5c384219d3699)(-1, 1, 1),
    /*@__PURE__*/ new (0, $ee56638efea8544d$export$64b5c384219d3699)(1, 1, 1)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * Paper: Fast, Accurate Image-Based Lighting
 * https://drive.google.com/file/d/15y8r_UpKlU9SvV4ILb0C3qCPecS8pvLz/view
*/ class $54cdb8f680e2b923$export$6add42717753e221 {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._lodPlanes = [];
        this._sizeLods = [];
        this._sigmas = [];
        this._blurMaterial = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 *
	 * @param {Scene} scene
	 * @param {number} sigma
	 * @param {number} near
	 * @param {number} far
	 * @return {WebGLRenderTarget}
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        $54cdb8f680e2b923$var$_oldTarget = this._renderer.getRenderTarget();
        $54cdb8f680e2b923$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $54cdb8f680e2b923$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $54cdb8f680e2b923$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        this._setSize(256);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported equirectangular image size is 64 x 32.
	 *
	 * @param {Texture} equirectangular
	 * @param {WebGLRenderTarget} [renderTarget=null] - Optional render target.
	 * @return {WebGLRenderTarget}
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 * The smallest supported cube size is 16 x 16.
	 *
	 * @param {Texture} cubemap
	 * @param {null} [renderTarget=null] - Optional render target.
	 * @return {WebGLRenderTarget}
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = $54cdb8f680e2b923$var$_getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = $54cdb8f680e2b923$var$_getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodPlanes.length; i++)this._lodPlanes[i].dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget($54cdb8f680e2b923$var$_oldTarget, $54cdb8f680e2b923$var$_oldActiveCubeFace, $54cdb8f680e2b923$var$_oldActiveMipmapLevel);
        this._renderer.xr.enabled = $54cdb8f680e2b923$var$_oldXrEnabled;
        outputTarget.scissorTest = false;
        $54cdb8f680e2b923$var$_setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === (0, $ee56638efea8544d$export$8759762a6477f2c4) || texture.mapping === (0, $ee56638efea8544d$export$dc59f8aed047f61d)) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        $54cdb8f680e2b923$var$_oldTarget = this._renderer.getRenderTarget();
        $54cdb8f680e2b923$var$_oldActiveCubeFace = this._renderer.getActiveCubeFace();
        $54cdb8f680e2b923$var$_oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        $54cdb8f680e2b923$var$_oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: (0, $ee56638efea8544d$export$8a72f490b25c56c8),
            minFilter: (0, $ee56638efea8544d$export$8a72f490b25c56c8),
            generateMipmaps: false,
            type: (0, $ee56638efea8544d$export$2697304443f382bc),
            format: (0, $ee56638efea8544d$export$3f8bb04b555a363c),
            colorSpace: (0, $ee56638efea8544d$export$42429b3acfb233a4),
            depthBuffer: false
        };
        const cubeUVRenderTarget = $54cdb8f680e2b923$var$_createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = $54cdb8f680e2b923$var$_createRenderTarget(width, height, params);
            const { _lodMax: _lodMax } = this;
            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = $54cdb8f680e2b923$var$_createPlanes(_lodMax));
            this._blurMaterial = $54cdb8f680e2b923$var$_getBlurShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new (0, $ee56638efea8544d$export$e176487c05830cc5)(this._lodPlanes[0], material);
        this._renderer.compile(tmpMesh, $54cdb8f680e2b923$var$_flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new (0, $ee56638efea8544d$export$74e4ae24825f68d7)(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor($54cdb8f680e2b923$var$_clearColor);
        renderer.toneMapping = (0, $ee56638efea8544d$export$9fcb6b4294603b2);
        renderer.autoClear = false;
        const backgroundMaterial = new (0, $ee56638efea8544d$export$55cbcc9b622fe1f5)({
            name: 'PMREM.Background',
            side: (0, $ee56638efea8544d$export$d9f0486e75b5ace),
            depthWrite: false,
            depthTest: false
        });
        const backgroundBox = new (0, $ee56638efea8544d$export$e176487c05830cc5)(new (0, $ee56638efea8544d$export$33e43285f7406bd5)(), backgroundMaterial);
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy($54cdb8f680e2b923$var$_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            const size = this._cubeSize;
            $54cdb8f680e2b923$var$_setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        backgroundBox.geometry.dispose();
        backgroundBox.material.dispose();
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === (0, $ee56638efea8544d$export$8759762a6477f2c4) || texture.mapping === (0, $ee56638efea8544d$export$dc59f8aed047f61d);
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = $54cdb8f680e2b923$var$_getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = $54cdb8f680e2b923$var$_getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = new (0, $ee56638efea8544d$export$e176487c05830cc5)(this._lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        $54cdb8f680e2b923$var$_setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, $54cdb8f680e2b923$var$_flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodPlanes.length;
        for(let i = 1; i < n; i++){
            const sigma = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]);
            const poleAxis = $54cdb8f680e2b923$var$_axisDirections[(n - i - 1) % $54cdb8f680e2b923$var$_axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 *
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn
	 * @param {number} lodOut
	 * @param {number} sigma
	 * @param {Vector3} [poleAxis]
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new (0, $ee56638efea8544d$export$e176487c05830cc5)(this._lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * $54cdb8f680e2b923$var$MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : $54cdb8f680e2b923$var$MAX_SAMPLES;
        if (samples > $54cdb8f680e2b923$var$MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${$54cdb8f680e2b923$var$MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < $54cdb8f680e2b923$var$MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax: _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - $54cdb8f680e2b923$var$LOD_MIN ? lodOut - _lodMax + $54cdb8f680e2b923$var$LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        $54cdb8f680e2b923$var$_setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, $54cdb8f680e2b923$var$_flatCamera);
    }
}
function $54cdb8f680e2b923$var$_createPlanes(lodMax) {
    const lodPlanes = [];
    const sizeLods = [];
    const sigmas = [];
    let lod = lodMax;
    const totalLods = lodMax - $54cdb8f680e2b923$var$LOD_MIN + 1 + $54cdb8f680e2b923$var$EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - $54cdb8f680e2b923$var$LOD_MIN) sigma = $54cdb8f680e2b923$var$EXTRA_LOD_SIGMA[i - lodMax + $54cdb8f680e2b923$var$LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new (0, $ee56638efea8544d$export$b7be63a67df8959)();
        planes.setAttribute('position', new (0, $ee56638efea8544d$export$8dea267bd6bde117)(position, positionSize));
        planes.setAttribute('uv', new (0, $ee56638efea8544d$export$8dea267bd6bde117)(uv, uvSize));
        planes.setAttribute('faceIndex', new (0, $ee56638efea8544d$export$8dea267bd6bde117)(faceIndex, faceIndexSize));
        lodPlanes.push(planes);
        if (lod > $54cdb8f680e2b923$var$LOD_MIN) lod--;
    }
    return {
        lodPlanes: lodPlanes,
        sizeLods: sizeLods,
        sigmas: sigmas
    };
}
function $54cdb8f680e2b923$var$_createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new (0, $ee56638efea8544d$export$3c052beb2e51e23f)(width, height, params);
    cubeUVRenderTarget.texture.mapping = (0, $ee56638efea8544d$export$dbf3e70ff37af79);
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function $54cdb8f680e2b923$var$_setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function $54cdb8f680e2b923$var$_getBlurShader(lodMax, width, height) {
    const weights = new Float32Array($54cdb8f680e2b923$var$MAX_SAMPLES);
    const poleAxis = new (0, $ee56638efea8544d$export$64b5c384219d3699)(0, 1, 0);
    const shaderMaterial = new (0, $ee56638efea8544d$export$83c7d75d550a8b0d)({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': $54cdb8f680e2b923$var$MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: $54cdb8f680e2b923$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: (0, $ee56638efea8544d$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function $54cdb8f680e2b923$var$_getEquirectMaterial() {
    return new (0, $ee56638efea8544d$export$83c7d75d550a8b0d)({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: $54cdb8f680e2b923$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: (0, $ee56638efea8544d$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
}
function $54cdb8f680e2b923$var$_getCubemapMaterial() {
    return new (0, $ee56638efea8544d$export$83c7d75d550a8b0d)({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: $54cdb8f680e2b923$var$_getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: (0, $ee56638efea8544d$export$63b8d6b580fc65ba),
        depthTest: false,
        depthWrite: false
    });
}
function $54cdb8f680e2b923$var$_getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function $54cdb8f680e2b923$var$WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === (0, $ee56638efea8544d$export$d64030b316d3b087) || mapping === (0, $ee56638efea8544d$export$ee99d97d46898098);
            const isCubeMap = mapping === (0, $ee56638efea8544d$export$8759762a6477f2c4) || mapping === (0, $ee56638efea8544d$export$dc59f8aed047f61d);
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                let renderTarget = cubeUVmaps.get(texture);
                const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new $54cdb8f680e2b923$export$6add42717753e221(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new $54cdb8f680e2b923$export$6add42717753e221(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $54cdb8f680e2b923$var$WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function() {
            getExtension('EXT_color_buffer_float');
            getExtension('WEBGL_clip_cull_distance');
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
            getExtension('WEBGL_render_shared_exponent');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) (0, $ee56638efea8544d$export$5b28268982f175ba)('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function $54cdb8f680e2b923$var$WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ((0, $ee56638efea8544d$export$bc6f937da07eae17)(indices) ? (0, $ee56638efea8544d$export$7eb8c9fa25cd5bd6) : (0, $ee56638efea8544d$export$640a853f68025f2e))(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function $54cdb8f680e2b923$var$WebGLIndexedBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
        else {
            extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function $54cdb8f680e2b923$var$WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function $54cdb8f680e2b923$var$WebGLMorphtargets(gl, capabilities, textures) {
    const morphTextures = new WeakMap();
    const morph = new (0, $ee56638efea8544d$export$fa7daccca11cdbe3)();
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            const hasMorphPosition = geometry.morphAttributes.position !== undefined;
            const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            const hasMorphColors = geometry.morphAttributes.color !== undefined;
            const morphTargets = geometry.morphAttributes.position || [];
            const morphNormals = geometry.morphAttributes.normal || [];
            const morphColors = geometry.morphAttributes.color || [];
            let vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            let width = geometry.attributes.position.count * vertexDataCount;
            let height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            const texture = new (0, $ee56638efea8544d$export$dfac6c8e811406a3)(buffer, width, height, morphTargetsCount);
            texture.type = (0, $ee56638efea8544d$export$f6d331659b644596);
            texture.needsUpdate = true;
            // fill buffer
            const vertexDataStride = vertexDataCount * 4;
            for(let i = 0; i < morphTargetsCount; i++){
                const morphTarget = morphTargets[i];
                const morphNormal = morphNormals[i];
                const morphColor = morphColors[i];
                const offset = width * height * 4 * i;
                for(let j = 0; j < morphTarget.count; j++){
                    const stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new (0, $ee56638efea8544d$export$c977b3e384af9ae1)(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures.delete(geometry);
                geometry.removeEventListener('dispose', disposeTexture);
            }
            geometry.addEventListener('dispose', disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, 'morphTexture', object.morphTexture, textures);
        else {
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
        }
        program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
        program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
    }
    return {
        update: update
    };
}
function $54cdb8f680e2b923$var$WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const $54cdb8f680e2b923$var$emptyTexture = /*@__PURE__*/ new (0, $ee56638efea8544d$export$5431306cf43de24a)();
const $54cdb8f680e2b923$var$emptyShadowTexture = /*@__PURE__*/ new (0, $ee56638efea8544d$export$fc830aa069cc8c2f)(1, 1);
const $54cdb8f680e2b923$var$emptyArrayTexture = /*@__PURE__*/ new (0, $ee56638efea8544d$export$dfac6c8e811406a3)();
const $54cdb8f680e2b923$var$empty3dTexture = /*@__PURE__*/ new (0, $ee56638efea8544d$export$d7a3086320f856db)();
const $54cdb8f680e2b923$var$emptyCubeTexture = /*@__PURE__*/ new (0, $ee56638efea8544d$export$ee2e5a18258a4049)();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const $54cdb8f680e2b923$var$arrayCacheF32 = [];
const $54cdb8f680e2b923$var$arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const $54cdb8f680e2b923$var$mat4array = new Float32Array(16);
const $54cdb8f680e2b923$var$mat3array = new Float32Array(9);
const $54cdb8f680e2b923$var$mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function $54cdb8f680e2b923$var$flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = $54cdb8f680e2b923$var$arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        $54cdb8f680e2b923$var$arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function $54cdb8f680e2b923$var$arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $54cdb8f680e2b923$var$copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function $54cdb8f680e2b923$var$allocTexUnits(textures, n) {
    let r = $54cdb8f680e2b923$var$arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        $54cdb8f680e2b923$var$arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function $54cdb8f680e2b923$var$setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function $54cdb8f680e2b923$var$setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        $54cdb8f680e2b923$var$copyArray(cache, v);
    }
}
function $54cdb8f680e2b923$var$setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        $54cdb8f680e2b923$var$copyArray(cache, v);
    }
}
function $54cdb8f680e2b923$var$setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        $54cdb8f680e2b923$var$copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function $54cdb8f680e2b923$var$setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        $54cdb8f680e2b923$var$copyArray(cache, v);
    } else {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, elements)) return;
        $54cdb8f680e2b923$var$mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, $54cdb8f680e2b923$var$mat2array);
        $54cdb8f680e2b923$var$copyArray(cache, elements);
    }
}
function $54cdb8f680e2b923$var$setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        $54cdb8f680e2b923$var$copyArray(cache, v);
    } else {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, elements)) return;
        $54cdb8f680e2b923$var$mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, $54cdb8f680e2b923$var$mat3array);
        $54cdb8f680e2b923$var$copyArray(cache, elements);
    }
}
function $54cdb8f680e2b923$var$setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        $54cdb8f680e2b923$var$copyArray(cache, v);
    } else {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, elements)) return;
        $54cdb8f680e2b923$var$mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, $54cdb8f680e2b923$var$mat4array);
        $54cdb8f680e2b923$var$copyArray(cache, elements);
    }
}
// Single integer / boolean
function $54cdb8f680e2b923$var$setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function $54cdb8f680e2b923$var$setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        $54cdb8f680e2b923$var$copyArray(cache, v);
    }
}
function $54cdb8f680e2b923$var$setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        $54cdb8f680e2b923$var$copyArray(cache, v);
    }
}
function $54cdb8f680e2b923$var$setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        $54cdb8f680e2b923$var$copyArray(cache, v);
    }
}
// Single unsigned integer
function $54cdb8f680e2b923$var$setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function $54cdb8f680e2b923$var$setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        $54cdb8f680e2b923$var$copyArray(cache, v);
    }
}
function $54cdb8f680e2b923$var$setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        $54cdb8f680e2b923$var$copyArray(cache, v);
    }
}
function $54cdb8f680e2b923$var$setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if ($54cdb8f680e2b923$var$arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        $54cdb8f680e2b923$var$copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function $54cdb8f680e2b923$var$setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        $54cdb8f680e2b923$var$emptyShadowTexture.compareFunction = (0, $ee56638efea8544d$export$64eea11eb407ddf1); // #28670
        emptyTexture2D = $54cdb8f680e2b923$var$emptyShadowTexture;
    } else emptyTexture2D = $54cdb8f680e2b923$var$emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function $54cdb8f680e2b923$var$setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || $54cdb8f680e2b923$var$empty3dTexture, unit);
}
function $54cdb8f680e2b923$var$setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || $54cdb8f680e2b923$var$emptyCubeTexture, unit);
}
function $54cdb8f680e2b923$var$setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || $54cdb8f680e2b923$var$emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function $54cdb8f680e2b923$var$getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return $54cdb8f680e2b923$var$setValueV1f; // FLOAT
        case 0x8b50:
            return $54cdb8f680e2b923$var$setValueV2f; // _VEC2
        case 0x8b51:
            return $54cdb8f680e2b923$var$setValueV3f; // _VEC3
        case 0x8b52:
            return $54cdb8f680e2b923$var$setValueV4f; // _VEC4
        case 0x8b5a:
            return $54cdb8f680e2b923$var$setValueM2; // _MAT2
        case 0x8b5b:
            return $54cdb8f680e2b923$var$setValueM3; // _MAT3
        case 0x8b5c:
            return $54cdb8f680e2b923$var$setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $54cdb8f680e2b923$var$setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $54cdb8f680e2b923$var$setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $54cdb8f680e2b923$var$setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $54cdb8f680e2b923$var$setValueV4i; // _VEC4
        case 0x1405:
            return $54cdb8f680e2b923$var$setValueV1ui; // UINT
        case 0x8dc6:
            return $54cdb8f680e2b923$var$setValueV2ui; // _VEC2
        case 0x8dc7:
            return $54cdb8f680e2b923$var$setValueV3ui; // _VEC3
        case 0x8dc8:
            return $54cdb8f680e2b923$var$setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $54cdb8f680e2b923$var$setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $54cdb8f680e2b923$var$setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $54cdb8f680e2b923$var$setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $54cdb8f680e2b923$var$setValueT2DArray1;
    }
}
// Array of scalars
function $54cdb8f680e2b923$var$setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function $54cdb8f680e2b923$var$setValueV2fArray(gl, v) {
    const data = $54cdb8f680e2b923$var$flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function $54cdb8f680e2b923$var$setValueV3fArray(gl, v) {
    const data = $54cdb8f680e2b923$var$flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function $54cdb8f680e2b923$var$setValueV4fArray(gl, v) {
    const data = $54cdb8f680e2b923$var$flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function $54cdb8f680e2b923$var$setValueM2Array(gl, v) {
    const data = $54cdb8f680e2b923$var$flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function $54cdb8f680e2b923$var$setValueM3Array(gl, v) {
    const data = $54cdb8f680e2b923$var$flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function $54cdb8f680e2b923$var$setValueM4Array(gl, v) {
    const data = $54cdb8f680e2b923$var$flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function $54cdb8f680e2b923$var$setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function $54cdb8f680e2b923$var$setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function $54cdb8f680e2b923$var$setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function $54cdb8f680e2b923$var$setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function $54cdb8f680e2b923$var$setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function $54cdb8f680e2b923$var$setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function $54cdb8f680e2b923$var$setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function $54cdb8f680e2b923$var$setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function $54cdb8f680e2b923$var$setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $54cdb8f680e2b923$var$allocTexUnits(textures, n);
    if (!$54cdb8f680e2b923$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $54cdb8f680e2b923$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || $54cdb8f680e2b923$var$emptyTexture, units[i]);
}
function $54cdb8f680e2b923$var$setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $54cdb8f680e2b923$var$allocTexUnits(textures, n);
    if (!$54cdb8f680e2b923$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $54cdb8f680e2b923$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || $54cdb8f680e2b923$var$empty3dTexture, units[i]);
}
function $54cdb8f680e2b923$var$setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $54cdb8f680e2b923$var$allocTexUnits(textures, n);
    if (!$54cdb8f680e2b923$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $54cdb8f680e2b923$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || $54cdb8f680e2b923$var$emptyCubeTexture, units[i]);
}
function $54cdb8f680e2b923$var$setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = $54cdb8f680e2b923$var$allocTexUnits(textures, n);
    if (!$54cdb8f680e2b923$var$arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        $54cdb8f680e2b923$var$copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || $54cdb8f680e2b923$var$emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function $54cdb8f680e2b923$var$getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return $54cdb8f680e2b923$var$setValueV1fArray; // FLOAT
        case 0x8b50:
            return $54cdb8f680e2b923$var$setValueV2fArray; // _VEC2
        case 0x8b51:
            return $54cdb8f680e2b923$var$setValueV3fArray; // _VEC3
        case 0x8b52:
            return $54cdb8f680e2b923$var$setValueV4fArray; // _VEC4
        case 0x8b5a:
            return $54cdb8f680e2b923$var$setValueM2Array; // _MAT2
        case 0x8b5b:
            return $54cdb8f680e2b923$var$setValueM3Array; // _MAT3
        case 0x8b5c:
            return $54cdb8f680e2b923$var$setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return $54cdb8f680e2b923$var$setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return $54cdb8f680e2b923$var$setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return $54cdb8f680e2b923$var$setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return $54cdb8f680e2b923$var$setValueV4iArray; // _VEC4
        case 0x1405:
            return $54cdb8f680e2b923$var$setValueV1uiArray; // UINT
        case 0x8dc6:
            return $54cdb8f680e2b923$var$setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return $54cdb8f680e2b923$var$setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return $54cdb8f680e2b923$var$setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return $54cdb8f680e2b923$var$setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return $54cdb8f680e2b923$var$setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return $54cdb8f680e2b923$var$setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return $54cdb8f680e2b923$var$setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class $54cdb8f680e2b923$var$SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.setValue = $54cdb8f680e2b923$var$getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $54cdb8f680e2b923$var$PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.size = activeInfo.size;
        this.setValue = $54cdb8f680e2b923$var$getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class $54cdb8f680e2b923$var$StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const $54cdb8f680e2b923$var$RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function $54cdb8f680e2b923$var$addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function $54cdb8f680e2b923$var$parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    $54cdb8f680e2b923$var$RePathPart.lastIndex = 0;
    while(true){
        const match = $54cdb8f680e2b923$var$RePathPart.exec(path), matchEnd = $54cdb8f680e2b923$var$RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            $54cdb8f680e2b923$var$addUniform(container, subscript === undefined ? new $54cdb8f680e2b923$var$SingleUniform(id, activeInfo, addr) : new $54cdb8f680e2b923$var$PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new $54cdb8f680e2b923$var$StructuredUniform(id);
                $54cdb8f680e2b923$var$addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class $54cdb8f680e2b923$var$WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            $54cdb8f680e2b923$var$parseUniform(info, addr, this);
        }
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function $54cdb8f680e2b923$var$WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const $54cdb8f680e2b923$var$COMPLETION_STATUS_KHR = 0x91B1;
let $54cdb8f680e2b923$var$programIdCount = 0;
function $54cdb8f680e2b923$var$handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
const $54cdb8f680e2b923$var$_m0 = /*@__PURE__*/ new (0, $ee56638efea8544d$export$8ff26dafa08918)();
function $54cdb8f680e2b923$var$getEncodingComponents(colorSpace) {
    (0, $ee56638efea8544d$export$5e6fd513f44698c)._getMatrix($54cdb8f680e2b923$var$_m0, (0, $ee56638efea8544d$export$5e6fd513f44698c).workingColorSpace, colorSpace);
    const encodingMatrix = `mat3( ${$54cdb8f680e2b923$var$_m0.elements.map((v)=>v.toFixed(4))} )`;
    switch((0, $ee56638efea8544d$export$5e6fd513f44698c).getTransfer(colorSpace)){
        case 0, $ee56638efea8544d$export$f197347d588c1b4a:
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
        case 0, $ee56638efea8544d$export$8d0a61916cc26abb:
            return [
                encodingMatrix,
                'sRGBTransferOETF'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported color space: ', colorSpace);
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
    }
}
function $54cdb8f680e2b923$var$getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const errors = gl.getShaderInfoLog(shader).trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + $54cdb8f680e2b923$var$handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function $54cdb8f680e2b923$var$getTexelEncodingFunction(functionName, colorSpace) {
    const components = $54cdb8f680e2b923$var$getEncodingComponents(colorSpace);
    return [
        `vec4 ${functionName}( vec4 value ) {`,
        `	return ${components[1]}( vec4( value.rgb * ${components[0]}, value.a ) );`,
        '}'
    ].join('\n');
}
function $54cdb8f680e2b923$var$getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case 0, $ee56638efea8544d$export$98f52c2a46c598ca:
            toneMappingName = 'Linear';
            break;
        case 0, $ee56638efea8544d$export$74b25e54b3bcd548:
            toneMappingName = 'Reinhard';
            break;
        case 0, $ee56638efea8544d$export$932b3dd283d4a366:
            toneMappingName = 'Cineon';
            break;
        case 0, $ee56638efea8544d$export$a0d98fe6d7e4af64:
            toneMappingName = 'ACESFilmic';
            break;
        case 0, $ee56638efea8544d$export$212d53a513a325b2:
            toneMappingName = 'AgX';
            break;
        case 0, $ee56638efea8544d$export$f2863e1668a8e317:
            toneMappingName = 'Neutral';
            break;
        case 0, $ee56638efea8544d$export$2c7b09c1e9abfb5e:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
const $54cdb8f680e2b923$var$_v0 = /*@__PURE__*/ new (0, $ee56638efea8544d$export$64b5c384219d3699)();
function $54cdb8f680e2b923$var$getLuminanceFunction() {
    (0, $ee56638efea8544d$export$5e6fd513f44698c).getLuminanceCoefficients($54cdb8f680e2b923$var$_v0);
    const r = $54cdb8f680e2b923$var$_v0.x.toFixed(4);
    const g = $54cdb8f680e2b923$var$_v0.y.toFixed(4);
    const b = $54cdb8f680e2b923$var$_v0.z.toFixed(4);
    return [
        'float luminance( const in vec3 rgb ) {',
        `	const vec3 weights = vec3( ${r}, ${g}, ${b} );`,
        '	return dot( weights, rgb );',
        '}'
    ].join('\n');
}
function $54cdb8f680e2b923$var$generateVertexExtensions(parameters) {
    const chunks = [
        parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
        parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : ''
    ];
    return chunks.filter($54cdb8f680e2b923$var$filterEmptyLine).join('\n');
}
function $54cdb8f680e2b923$var$generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function $54cdb8f680e2b923$var$fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function $54cdb8f680e2b923$var$filterEmptyLine(string) {
    return string !== '';
}
function $54cdb8f680e2b923$var$replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function $54cdb8f680e2b923$var$replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const $54cdb8f680e2b923$var$includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function $54cdb8f680e2b923$var$resolveIncludes(string) {
    return string.replace($54cdb8f680e2b923$var$includePattern, $54cdb8f680e2b923$var$includeReplacer);
}
const $54cdb8f680e2b923$var$shaderChunkMap = new Map();
function $54cdb8f680e2b923$var$includeReplacer(match, include) {
    let string = $54cdb8f680e2b923$export$955f9f2e84c43c8b[include];
    if (string === undefined) {
        const newInclude = $54cdb8f680e2b923$var$shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = $54cdb8f680e2b923$export$955f9f2e84c43c8b[newInclude];
            console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return $54cdb8f680e2b923$var$resolveIncludes(string);
}
// Unroll Loops
const $54cdb8f680e2b923$var$unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function $54cdb8f680e2b923$var$unrollLoops(string) {
    return string.replace($54cdb8f680e2b923$var$unrollLoopPattern, $54cdb8f680e2b923$var$loopReplacer);
}
function $54cdb8f680e2b923$var$loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function $54cdb8f680e2b923$var$generatePrecision(parameters) {
    let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function $54cdb8f680e2b923$var$generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === (0, $ee56638efea8544d$export$5813f879eee7cd88)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === (0, $ee56638efea8544d$export$a47c4b43a1be34f0)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === (0, $ee56638efea8544d$export$896ae1ade6c829c4)) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function $54cdb8f680e2b923$var$generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case 0, $ee56638efea8544d$export$8759762a6477f2c4:
        case 0, $ee56638efea8544d$export$dc59f8aed047f61d:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case 0, $ee56638efea8544d$export$dbf3e70ff37af79:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function $54cdb8f680e2b923$var$generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case 0, $ee56638efea8544d$export$dc59f8aed047f61d:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function $54cdb8f680e2b923$var$generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case 0, $ee56638efea8544d$export$e50ac29801f1774d:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case 0, $ee56638efea8544d$export$9f9d94f963c85479:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case 0, $ee56638efea8544d$export$e641dc52bc3494aa:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function $54cdb8f680e2b923$var$generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth: texelWidth,
        texelHeight: texelHeight,
        maxMip: maxMip
    };
}
function $54cdb8f680e2b923$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // console.log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = $54cdb8f680e2b923$var$generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = $54cdb8f680e2b923$var$generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = $54cdb8f680e2b923$var$generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = $54cdb8f680e2b923$var$generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = $54cdb8f680e2b923$var$generateCubeUVSize(parameters);
    const customVertexExtensions = $54cdb8f680e2b923$var$generateVertexExtensions(parameters);
    const customDefines = $54cdb8f680e2b923$var$generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($54cdb8f680e2b923$var$filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter($54cdb8f680e2b923$var$filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            $54cdb8f680e2b923$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
            parameters.batching ? '#define USE_BATCHING' : '',
            parameters.batchingColor ? '#define USE_BATCHING_COLOR' : '',
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.reverseDepthBuffer ? '#define USE_REVERSEDEPTHBUF' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            '#ifdef USE_INSTANCING_MORPH',
            '	uniform sampler2D morphTexture;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter($54cdb8f680e2b923$var$filterEmptyLine).join('\n');
        prefixFragment = [
            $54cdb8f680e2b923$var$generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.dispersion ? '#define USE_DISPERSION' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.decodeVideoTextureEmissive ? '#define DECODE_VIDEO_TEXTURE_EMISSIVE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.reverseDepthBuffer ? '#define USE_REVERSEDEPTHBUF' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== (0, $ee56638efea8544d$export$9fcb6b4294603b2) ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== (0, $ee56638efea8544d$export$9fcb6b4294603b2) ? $54cdb8f680e2b923$export$955f9f2e84c43c8b['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== (0, $ee56638efea8544d$export$9fcb6b4294603b2) ? $54cdb8f680e2b923$var$getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            $54cdb8f680e2b923$export$955f9f2e84c43c8b['colorspace_pars_fragment'],
            $54cdb8f680e2b923$var$getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            $54cdb8f680e2b923$var$getLuminanceFunction(),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter($54cdb8f680e2b923$var$filterEmptyLine).join('\n');
    }
    vertexShader = $54cdb8f680e2b923$var$resolveIncludes(vertexShader);
    vertexShader = $54cdb8f680e2b923$var$replaceLightNums(vertexShader, parameters);
    vertexShader = $54cdb8f680e2b923$var$replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = $54cdb8f680e2b923$var$resolveIncludes(fragmentShader);
    fragmentShader = $54cdb8f680e2b923$var$replaceLightNums(fragmentShader, parameters);
    fragmentShader = $54cdb8f680e2b923$var$replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = $54cdb8f680e2b923$var$unrollLoops(vertexShader);
    fragmentShader = $54cdb8f680e2b923$var$unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            customVertexExtensions,
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === (0, $ee56638efea8544d$export$f63012db5506e7dd) ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === (0, $ee56638efea8544d$export$f63012db5506e7dd) ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = $54cdb8f680e2b923$var$WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = $54cdb8f680e2b923$var$WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            const programLog = gl.getProgramInfoLog(program).trim();
            const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
            const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
            let runnable = true;
            let haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = $54cdb8f680e2b923$var$getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = $54cdb8f680e2b923$var$getShaderErrors(gl, glFragmentShader, 'fragment');
                    console.error('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Material Name: ' + self1.name + '\n' + 'Material Type: ' + self1.type + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') console.warn('THREE.WebGLProgram: Program Info Log:', programLog);
            else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new $54cdb8f680e2b923$var$WebGLUniforms(gl, program);
        cachedAttributes = $54cdb8f680e2b923$var$fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, $54cdb8f680e2b923$var$COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = $54cdb8f680e2b923$var$programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let $54cdb8f680e2b923$var$_id = 0;
class $54cdb8f680e2b923$var$WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new $54cdb8f680e2b923$var$WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class $54cdb8f680e2b923$var$WebGLShaderStage {
    constructor(code){
        this.id = $54cdb8f680e2b923$var$_id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function $54cdb8f680e2b923$var$WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new (0, $ee56638efea8544d$export$89312ce47c0ca777)();
    const _customShaders = new $54cdb8f680e2b923$var$WebGLShaderCache();
    const _activeChannels = new Set();
    const programs = [];
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const SUPPORTS_VERTEX_TEXTURES = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return 'uv';
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === (0, $ee56638efea8544d$export$dbf3e70ff37af79) ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = $54cdb8f680e2b923$export$bee4a7d47f8f5014[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const reverseDepthBuffer = renderer.state.buffers.depth.getReversed();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const IS_BATCHEDMESH = object.isBatchedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_DISPERSION = material.dispersion > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        let toneMapping = (0, $ee56638efea8544d$export$9fcb6b4294603b2);
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            supportsVertexTextures: SUPPORTS_VERTEX_TEXTURES,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : (0, $ee56638efea8544d$export$42429b3acfb233a4),
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: SUPPORTS_VERTEX_TEXTURES && HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === (0, $ee56638efea8544d$export$9990ad26f9db5b2c),
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === (0, $ee56638efea8544d$export$2852a58ebdac27b8),
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === (0, $ee56638efea8544d$export$5b29a26d96ee6af0) && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.flatShading === true,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            reverseDepthBuffer: reverseDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && (0, $ee56638efea8544d$export$5e6fd513f44698c).getTransfer(material.map.colorSpace) === (0, $ee56638efea8544d$export$8d0a61916cc26abb),
            decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && (0, $ee56638efea8544d$export$5e6fd513f44698c).getTransfer(material.emissiveMap.colorSpace) === (0, $ee56638efea8544d$export$8d0a61916cc26abb),
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === (0, $ee56638efea8544d$export$3b296b6f144d5b03),
            flipSided: material.side === (0, $ee56638efea8544d$export$d9f0486e75b5ace),
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has('WEBGL_clip_cull_distance'),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has('WEBGL_multi_draw'),
            rendererExtensionParallelShaderCompile: extensions.has('KHR_parallel_shader_compile'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.supportsVertexTextures) _programLayers.enable(0);
        if (parameters.instancing) _programLayers.enable(1);
        if (parameters.instancingColor) _programLayers.enable(2);
        if (parameters.instancingMorph) _programLayers.enable(3);
        if (parameters.matcap) _programLayers.enable(4);
        if (parameters.envMap) _programLayers.enable(5);
        if (parameters.normalMapObjectSpace) _programLayers.enable(6);
        if (parameters.normalMapTangentSpace) _programLayers.enable(7);
        if (parameters.clearcoat) _programLayers.enable(8);
        if (parameters.iridescence) _programLayers.enable(9);
        if (parameters.alphaTest) _programLayers.enable(10);
        if (parameters.vertexColors) _programLayers.enable(11);
        if (parameters.vertexAlphas) _programLayers.enable(12);
        if (parameters.vertexUv1s) _programLayers.enable(13);
        if (parameters.vertexUv2s) _programLayers.enable(14);
        if (parameters.vertexUv3s) _programLayers.enable(15);
        if (parameters.vertexTangents) _programLayers.enable(16);
        if (parameters.anisotropy) _programLayers.enable(17);
        if (parameters.alphaHash) _programLayers.enable(18);
        if (parameters.batching) _programLayers.enable(19);
        if (parameters.dispersion) _programLayers.enable(20);
        if (parameters.batchingColor) _programLayers.enable(21);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.reverseDepthBuffer) _programLayers.enable(4);
        if (parameters.skinning) _programLayers.enable(5);
        if (parameters.morphTargets) _programLayers.enable(6);
        if (parameters.morphNormals) _programLayers.enable(7);
        if (parameters.morphColors) _programLayers.enable(8);
        if (parameters.premultipliedAlpha) _programLayers.enable(9);
        if (parameters.shadowMapEnabled) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        if (parameters.decodeVideoTextureEmissive) _programLayers.enable(20);
        if (parameters.alphaToCoverage) _programLayers.enable(21);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = $54cdb8f680e2b923$export$bee4a7d47f8f5014[shaderID];
            uniforms = (0, $ee56638efea8544d$export$d8ecdf8615bfea69).clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new $54cdb8f680e2b923$var$WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function $54cdb8f680e2b923$var$WebGLProperties() {
    let properties = new WeakMap();
    function has(object) {
        return properties.has(object);
    }
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        has: has,
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function $54cdb8f680e2b923$var$painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function $54cdb8f680e2b923$var$reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function $54cdb8f680e2b923$var$WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || $54cdb8f680e2b923$var$painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || $54cdb8f680e2b923$var$reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || $54cdb8f680e2b923$var$reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function $54cdb8f680e2b923$var$WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new $54cdb8f680e2b923$var$WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new $54cdb8f680e2b923$var$WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function $54cdb8f680e2b923$var$UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new (0, $ee56638efea8544d$export$64b5c384219d3699)(),
                        color: new (0, $ee56638efea8544d$export$892596cec99bc70e)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new (0, $ee56638efea8544d$export$64b5c384219d3699)(),
                        direction: new (0, $ee56638efea8544d$export$64b5c384219d3699)(),
                        color: new (0, $ee56638efea8544d$export$892596cec99bc70e)(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new (0, $ee56638efea8544d$export$64b5c384219d3699)(),
                        color: new (0, $ee56638efea8544d$export$892596cec99bc70e)(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new (0, $ee56638efea8544d$export$64b5c384219d3699)(),
                        skyColor: new (0, $ee56638efea8544d$export$892596cec99bc70e)(),
                        groundColor: new (0, $ee56638efea8544d$export$892596cec99bc70e)()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new (0, $ee56638efea8544d$export$892596cec99bc70e)(),
                        position: new (0, $ee56638efea8544d$export$64b5c384219d3699)(),
                        halfWidth: new (0, $ee56638efea8544d$export$64b5c384219d3699)(),
                        halfHeight: new (0, $ee56638efea8544d$export$64b5c384219d3699)()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function $54cdb8f680e2b923$var$ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $ee56638efea8544d$export$c977b3e384af9ae1)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $ee56638efea8544d$export$c977b3e384af9ae1)()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, $ee56638efea8544d$export$c977b3e384af9ae1)(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let $54cdb8f680e2b923$var$nextVersion = 0;
function $54cdb8f680e2b923$var$shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function $54cdb8f680e2b923$var$WebGLLights(extensions) {
    const cache = new $54cdb8f680e2b923$var$UniformsCache();
    const shadowCache = $54cdb8f680e2b923$var$ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new (0, $ee56638efea8544d$export$64b5c384219d3699)());
    const vector3 = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
    const matrix4 = new (0, $ee56638efea8544d$export$2ae72fc923e5eb5)();
    const matrix42 = new (0, $ee56638efea8544d$export$2ae72fc923e5eb5)();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort($54cdb8f680e2b923$var$shadowCastingAndTexturingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has('OES_texture_float_linear') === true) {
                state.rectAreaLTC1 = $54cdb8f680e2b923$export$6643083551874bf5.LTC_FLOAT_1;
                state.rectAreaLTC2 = $54cdb8f680e2b923$export$6643083551874bf5.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = $54cdb8f680e2b923$export$6643083551874bf5.LTC_HALF_1;
                state.rectAreaLTC2 = $54cdb8f680e2b923$export$6643083551874bf5.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = $54cdb8f680e2b923$var$nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function $54cdb8f680e2b923$var$WebGLRenderState(extensions) {
    const lights = new $54cdb8f680e2b923$var$WebGLLights(extensions);
    const lightsArray = [];
    const shadowsArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {}
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function $54cdb8f680e2b923$var$WebGLRenderStates(extensions) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new $54cdb8f680e2b923$var$WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new $54cdb8f680e2b923$var$WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const $54cdb8f680e2b923$var$vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const $54cdb8f680e2b923$var$fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
function $54cdb8f680e2b923$var$WebGLShadowMap(renderer, objects, capabilities) {
    let _frustum = new (0, $ee56638efea8544d$export$35efe6f4c85463d2)();
    const _shadowMapSize = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)(), _viewportSize = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)(), _viewport = new (0, $ee56638efea8544d$export$fa7daccca11cdbe3)(), _depthMaterial = new (0, $ee56638efea8544d$export$2698c22ec13825db)({
        depthPacking: (0, $ee56638efea8544d$export$8f910f4c4f73df11)
    }), _distanceMaterial = new (0, $ee56638efea8544d$export$33e187ed002f2a19)(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    const shadowSide = {
        [(0, $ee56638efea8544d$export$2ede184fc2998901)]: (0, $ee56638efea8544d$export$d9f0486e75b5ace),
        [(0, $ee56638efea8544d$export$d9f0486e75b5ace)]: (0, $ee56638efea8544d$export$2ede184fc2998901),
        [(0, $ee56638efea8544d$export$3b296b6f144d5b03)]: (0, $ee56638efea8544d$export$3b296b6f144d5b03)
    };
    const shadowMaterialVertical = new (0, $ee56638efea8544d$export$83c7d75d550a8b0d)({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new (0, $ee56638efea8544d$export$c977b3e384af9ae1)()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: $54cdb8f680e2b923$var$vertex,
        fragmentShader: $54cdb8f680e2b923$var$fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new (0, $ee56638efea8544d$export$b7be63a67df8959)();
    fullScreenTri.setAttribute('position', new (0, $ee56638efea8544d$export$8dea267bd6bde117)(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new (0, $ee56638efea8544d$export$e176487c05830cc5)(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = (0, $ee56638efea8544d$export$5813f879eee7cd88);
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = renderer.getRenderTarget();
        const activeCubeFace = renderer.getActiveCubeFace();
        const activeMipmapLevel = renderer.getActiveMipmapLevel();
        const _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending((0, $ee56638efea8544d$export$63b8d6b580fc65ba));
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const toVSM = _previousType !== (0, $ee56638efea8544d$export$896ae1ade6c829c4) && this.type === (0, $ee56638efea8544d$export$896ae1ade6c829c4);
        const fromVSM = _previousType === (0, $ee56638efea8544d$export$896ae1ade6c829c4) && this.type !== (0, $ee56638efea8544d$export$896ae1ade6c829c4);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || toVSM === true || fromVSM === true) {
                const pars = this.type !== (0, $ee56638efea8544d$export$896ae1ade6c829c4) ? {
                    minFilter: (0, $ee56638efea8544d$export$727aa5ec3fe39bf0),
                    magFilter: (0, $ee56638efea8544d$export$727aa5ec3fe39bf0)
                } : {};
                if (shadow.map !== null) shadow.map.dispose();
                shadow.map = new (0, $ee56638efea8544d$export$3c052beb2e51e23f)(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            renderer.setRenderTarget(shadow.map);
            renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === (0, $ee56638efea8544d$export$896ae1ade6c829c4)) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new (0, $ee56638efea8544d$export$3c052beb2e51e23f)(_shadowMapSize.x, _shadowMapSize.y);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener('dispose', onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === (0, $ee56638efea8544d$export$896ae1ade6c829c4)) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaTest;
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === (0, $ee56638efea8544d$export$896ae1ade6c829c4)) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(const id in _materialCache){
            const cache = _materialCache[id];
            const uuid = event.target.uuid;
            if (uuid in cache) {
                const shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
const $54cdb8f680e2b923$var$reversedFuncs = {
    [(0, $ee56638efea8544d$export$69025ce147cee220)]: (0, $ee56638efea8544d$export$7182eb52ea3b3f04),
    [(0, $ee56638efea8544d$export$eedccec66ab7ebe)]: (0, $ee56638efea8544d$export$c5e2c52991f30937),
    [(0, $ee56638efea8544d$export$a60d398fc7b7590e)]: (0, $ee56638efea8544d$export$2f843afa843d8916),
    [(0, $ee56638efea8544d$export$296f78a0b892f81a)]: (0, $ee56638efea8544d$export$7d7234c1240a1fc4),
    [(0, $ee56638efea8544d$export$7182eb52ea3b3f04)]: (0, $ee56638efea8544d$export$69025ce147cee220),
    [(0, $ee56638efea8544d$export$c5e2c52991f30937)]: (0, $ee56638efea8544d$export$eedccec66ab7ebe),
    [(0, $ee56638efea8544d$export$2f843afa843d8916)]: (0, $ee56638efea8544d$export$a60d398fc7b7590e),
    [(0, $ee56638efea8544d$export$7d7234c1240a1fc4)]: (0, $ee56638efea8544d$export$296f78a0b892f81a)
};
function $54cdb8f680e2b923$var$WebGLState(gl, extensions) {
    function ColorBuffer() {
        let locked = false;
        const color = new (0, $ee56638efea8544d$export$fa7daccca11cdbe3)();
        let currentColorMask = null;
        const currentColorClear = new (0, $ee56638efea8544d$export$fa7daccca11cdbe3)(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let reversed = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setReversed: function(value) {
                if (reversed !== value) {
                    const ext = extensions.get('EXT_clip_control');
                    if (reversed) ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
                    else ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
                    const oldDepth = currentDepthClear;
                    currentDepthClear = null;
                    this.setClear(oldDepth);
                }
                reversed = value;
            },
            getReversed: function() {
                return reversed;
            },
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (reversed) depthFunc = $54cdb8f680e2b923$var$reversedFuncs[depthFunc];
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case 0, $ee56638efea8544d$export$69025ce147cee220:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case 0, $ee56638efea8544d$export$7182eb52ea3b3f04:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case 0, $ee56638efea8544d$export$eedccec66ab7ebe:
                            gl.depthFunc(gl.LESS);
                            break;
                        case 0, $ee56638efea8544d$export$296f78a0b892f81a:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case 0, $ee56638efea8544d$export$a60d398fc7b7590e:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case 0, $ee56638efea8544d$export$7d7234c1240a1fc4:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case 0, $ee56638efea8544d$export$c5e2c52991f30937:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case 0, $ee56638efea8544d$export$2f843afa843d8916:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    if (reversed) depth = 1 - depth;
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
                reversed = false;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new (0, $ee56638efea8544d$export$892596cec99bc70e)(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new (0, $ee56638efea8544d$export$fa7daccca11cdbe3)().fromArray(scissorParam);
    const currentViewport = new (0, $ee56638efea8544d$export$fa7daccca11cdbe3)().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc((0, $ee56638efea8544d$export$296f78a0b892f81a));
    setFlipSided(false);
    setCullFace((0, $ee56638efea8544d$export$b9a7b4fc5cb15f9b));
    enable(gl.CULL_FACE);
    setBlending((0, $ee56638efea8544d$export$63b8d6b580fc65ba));
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderTarget.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [(0, $ee56638efea8544d$export$20183a0484ce21a0)]: gl.FUNC_ADD,
        [(0, $ee56638efea8544d$export$73e0df5177988548)]: gl.FUNC_SUBTRACT,
        [(0, $ee56638efea8544d$export$28e582859cbec660)]: gl.FUNC_REVERSE_SUBTRACT
    };
    equationToGL[0, $ee56638efea8544d$export$c8c1508da8d0600c] = gl.MIN;
    equationToGL[0, $ee56638efea8544d$export$99948c02fb51055f] = gl.MAX;
    const factorToGL = {
        [(0, $ee56638efea8544d$export$2110f05edf778d3d)]: gl.ZERO,
        [(0, $ee56638efea8544d$export$8805bad65e24940e)]: gl.ONE,
        [(0, $ee56638efea8544d$export$7fbe15b28d28cf52)]: gl.SRC_COLOR,
        [(0, $ee56638efea8544d$export$d5773124e86cf28c)]: gl.SRC_ALPHA,
        [(0, $ee56638efea8544d$export$c05e2a1fc8609506)]: gl.SRC_ALPHA_SATURATE,
        [(0, $ee56638efea8544d$export$ef5f2dd8ffac5574)]: gl.DST_COLOR,
        [(0, $ee56638efea8544d$export$a78aed1ca2a87192)]: gl.DST_ALPHA,
        [(0, $ee56638efea8544d$export$947829af9f2c17f6)]: gl.ONE_MINUS_SRC_COLOR,
        [(0, $ee56638efea8544d$export$11d468cc7f19e971)]: gl.ONE_MINUS_SRC_ALPHA,
        [(0, $ee56638efea8544d$export$56b85b2686ab16)]: gl.ONE_MINUS_DST_COLOR,
        [(0, $ee56638efea8544d$export$5d0fe17fd8773bac)]: gl.ONE_MINUS_DST_ALPHA,
        [(0, $ee56638efea8544d$export$7dd8f434fd59075)]: gl.CONSTANT_COLOR,
        [(0, $ee56638efea8544d$export$99c8d898a9afbcee)]: gl.ONE_MINUS_CONSTANT_COLOR,
        [(0, $ee56638efea8544d$export$310cd2be38d13b56)]: gl.CONSTANT_ALPHA,
        [(0, $ee56638efea8544d$export$db77b8fbcf45dbf4)]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === (0, $ee56638efea8544d$export$63b8d6b580fc65ba)) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== (0, $ee56638efea8544d$export$eda4864c68df1fa2)) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== (0, $ee56638efea8544d$export$20183a0484ce21a0) || currentBlendEquationAlpha !== (0, $ee56638efea8544d$export$20183a0484ce21a0)) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = (0, $ee56638efea8544d$export$20183a0484ce21a0);
                    currentBlendEquationAlpha = (0, $ee56638efea8544d$export$20183a0484ce21a0);
                }
                if (premultipliedAlpha) switch(blending){
                    case 0, $ee56638efea8544d$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $ee56638efea8544d$export$777d8f9551c2216b:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case 0, $ee56638efea8544d$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $ee56638efea8544d$export$4138e1c684b46a20:
                        gl.blendFuncSeparate(gl.ZERO, gl.SRC_COLOR, gl.ZERO, gl.SRC_ALPHA);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case 0, $ee56638efea8544d$export$5b29a26d96ee6af0:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, $ee56638efea8544d$export$777d8f9551c2216b:
                        gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
                        break;
                    case 0, $ee56638efea8544d$export$cdfa06f868e2e467:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, $ee56638efea8544d$export$4138e1c684b46a20:
                        gl.blendFunc(gl.ZERO, gl.SRC_COLOR);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === (0, $ee56638efea8544d$export$3b296b6f144d5b03) ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === (0, $ee56638efea8544d$export$d9f0486e75b5ace);
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === (0, $ee56638efea8544d$export$5b29a26d96ee6af0) && material.transparent === false ? setBlending((0, $ee56638efea8544d$export$63b8d6b580fc65ba)) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== (0, $ee56638efea8544d$export$3237e1f2c1ea1f44)) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === (0, $ee56638efea8544d$export$b9a7b4fc5cb15f9b)) gl.cullFace(gl.BACK);
                else if (cullFace === (0, $ee56638efea8544d$export$b8058bcc7037d3f3)) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        depthBuffer.setReversed(false);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new (0, $ee56638efea8544d$export$892596cec99bc70e)(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function $54cdb8f680e2b923$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _imageDimensions = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)();
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? // eslint-disable-next-line compat/compat
        new OffscreenCanvas(width, height) : (0, $ee56638efea8544d$export$7094a064528c7fee)('canvas');
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        let scale = 1;
        const dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap || typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                const width = Math.floor(scale * dimensions.width);
                const height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').');
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getTargetType(texture) {
        if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
        if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
        if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
        return _gl.TEXTURE_2D;
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
            if (glType === _gl.INT) internalFormat = _gl.RGB32I;
        }
        if (glFormat === _gl.RGBA_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
            if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? (0, $ee56638efea8544d$export$f197347d588c1b4a) : (0, $ee56638efea8544d$export$5e6fd513f44698c).getTransfer(colorSpace);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        let glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === (0, $ee56638efea8544d$export$c3c7fc4518ebba96) || depthType === (0, $ee56638efea8544d$export$6c8ea339bfab1301)) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === (0, $ee56638efea8544d$export$f6d331659b644596)) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === (0, $ee56638efea8544d$export$c63dc51868b06a9d)) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                console.warn('DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.');
            }
        } else {
            if (depthType === null || depthType === (0, $ee56638efea8544d$export$c3c7fc4518ebba96) || depthType === (0, $ee56638efea8544d$export$6c8ea339bfab1301)) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === (0, $ee56638efea8544d$export$f6d331659b644596)) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === (0, $ee56638efea8544d$export$c63dc51868b06a9d)) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== (0, $ee56638efea8544d$export$727aa5ec3fe39bf0) && texture.minFilter !== (0, $ee56638efea8544d$export$8a72f490b25c56c8)) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) {
            renderTarget.depthTexture.dispose();
            properties.remove(renderTarget.depthTexture);
        }
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const attachmentProperties = properties.get(textures[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i]);
        }
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) console.warn('THREE.WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [(0, $ee56638efea8544d$export$533346c8e8dac0f5)]: _gl.REPEAT,
        [(0, $ee56638efea8544d$export$9d9334239a5a5e06)]: _gl.CLAMP_TO_EDGE,
        [(0, $ee56638efea8544d$export$c7e7c00b14f51a4f)]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [(0, $ee56638efea8544d$export$727aa5ec3fe39bf0)]: _gl.NEAREST,
        [(0, $ee56638efea8544d$export$d129e38cf6feaa8c)]: _gl.NEAREST_MIPMAP_NEAREST,
        [(0, $ee56638efea8544d$export$d2327c1afe5bfdf2)]: _gl.NEAREST_MIPMAP_LINEAR,
        [(0, $ee56638efea8544d$export$8a72f490b25c56c8)]: _gl.LINEAR,
        [(0, $ee56638efea8544d$export$19a719f377145a13)]: _gl.LINEAR_MIPMAP_NEAREST,
        [(0, $ee56638efea8544d$export$5d8599b6a933fb1b)]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [(0, $ee56638efea8544d$export$d9e2d19a747baaab)]: _gl.NEVER,
        [(0, $ee56638efea8544d$export$187b73a3e352c145)]: _gl.ALWAYS,
        [(0, $ee56638efea8544d$export$36bcf49c713b3eb7)]: _gl.LESS,
        [(0, $ee56638efea8544d$export$64eea11eb407ddf1)]: _gl.LEQUAL,
        [(0, $ee56638efea8544d$export$66f28d946fc6a0d5)]: _gl.EQUAL,
        [(0, $ee56638efea8544d$export$1cdcb70d53d65f61)]: _gl.GEQUAL,
        [(0, $ee56638efea8544d$export$155af022118f3a38)]: _gl.GREATER,
        [(0, $ee56638efea8544d$export$67ab95dde6bed156)]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture) {
        if (texture.type === (0, $ee56638efea8544d$export$f6d331659b644596) && extensions.has('OES_texture_float_linear') === false && (texture.magFilter === (0, $ee56638efea8544d$export$8a72f490b25c56c8) || texture.magFilter === (0, $ee56638efea8544d$export$19a719f377145a13) || texture.magFilter === (0, $ee56638efea8544d$export$d2327c1afe5bfdf2) || texture.magFilter === (0, $ee56638efea8544d$export$5d8599b6a933fb1b) || texture.minFilter === (0, $ee56638efea8544d$export$8a72f490b25c56c8) || texture.minFilter === (0, $ee56638efea8544d$export$19a719f377145a13) || texture.minFilter === (0, $ee56638efea8544d$export$d2327c1afe5bfdf2) || texture.minFilter === (0, $ee56638efea8544d$export$5d8599b6a933fb1b))) console.warn('THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.');
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === (0, $ee56638efea8544d$export$727aa5ec3fe39bf0)) return;
            if (texture.minFilter !== (0, $ee56638efea8544d$export$d2327c1afe5bfdf2) && texture.minFilter !== (0, $ee56638efea8544d$export$5d8599b6a933fb1b)) return;
            if (texture.type === (0, $ee56638efea8544d$export$f6d331659b644596) && extensions.has('OES_texture_float_linear') === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                const extension = extensions.get('EXT_texture_filter_anisotropic');
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $ee56638efea8544d$export$5e6fd513f44698c).getPrimaries((0, $ee56638efea8544d$export$5e6fd513f44698c).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $ee56638efea8544d$export$bfcb490c2dd3db51) ? null : (0, $ee56638efea8544d$export$5e6fd513f44698c).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $ee56638efea8544d$export$bfcb490c2dd3db51) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            const glFormat = utils.convert(texture.format, texture.colorSpace);
            const glType = utils.convert(texture.type);
            let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            const levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === (0, $ee56638efea8544d$export$1e113ac2d0905829), texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $ee56638efea8544d$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            const layerByteLength = (0, $ee56638efea8544d$export$cc8c3b705bb8e6e2)(mipmap.width, mipmap.height, texture.format, texture.type);
                                            for (const layerIndex of texture.layerUpdates){
                                                const layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, $ee56638efea8544d$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            const layerByteLength = (0, $ee56638efea8544d$export$cc8c3b705bb8e6e2)(image.width, image.height, texture.format, texture.type);
                            for (const layerIndex of texture.layerUpdates){
                                const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        const dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        const dimensions = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, $ee56638efea8544d$export$5e6fd513f44698c).getPrimaries((0, $ee56638efea8544d$export$5e6fd513f44698c).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, $ee56638efea8544d$export$bfcb490c2dd3db51) ? null : (0, $ee56638efea8544d$export$5e6fd513f44698c).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, $ee56638efea8544d$export$bfcb490c2dd3db51) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            let levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== (0, $ee56638efea8544d$export$3f8bb04b555a363c)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    const dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        textureProperties.__renderTarget = renderTarget;
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            const depthTexture = renderTarget.depthTexture;
            const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            const samples = getRenderTargetSamples(renderTarget);
            const isUseMultisampledRTT = useMultisampledRTT(renderTarget);
            if (isUseMultisampledRTT) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else if (isMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                const samples = getRenderTargetSamples(renderTarget);
                if (isMultisample && useMultisampledRTT(renderTarget) === false) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        const textureProperties = properties.get(renderTarget.depthTexture);
        textureProperties.__renderTarget = renderTarget;
        // upload an empty depth texture with framebuffer size
        if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = textureProperties.__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        if (renderTarget.depthTexture.format === (0, $ee56638efea8544d$export$c1b6b5136be58045)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === (0, $ee56638efea8544d$export$1e113ac2d0905829)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.DEPTH_STENCIL_ATTACHMENT, _gl.TEXTURE_2D, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        // if the bound depth texture has changed
        if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
            // fire the dispose event to get rid of stored state associated with the previously bound depth buffer
            const depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__depthDisposeCallback) renderTargetProperties.__depthDisposeCallback();
            // set up dispose listeners to track when the currently attached buffer is implicitly unbound
            if (depthTexture) {
                const disposeEvent = ()=>{
                    delete renderTargetProperties.__boundDepthTexture;
                    delete renderTargetProperties.__depthDisposeCallback;
                    depthTexture.removeEventListener('dispose', disposeEvent);
                };
                depthTexture.addEventListener('dispose', disposeEvent);
                renderTargetProperties.__depthDisposeCallback = disposeEvent;
            }
            renderTargetProperties.__boundDepthTexture = depthTexture;
        }
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                if (renderTargetProperties.__webglDepthbuffer[i] === undefined) {
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                } else {
                    // attach buffer if it's been created already
                    const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                    const renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
                }
            }
        } else {
            state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer === undefined) {
                renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
            } else {
                // attach buffer if it's been created already
                const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderbuffer = renderTargetProperties.__webglDepthbuffer;
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
            }
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        const textures = renderTarget.textures;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(let i = 0, il = textures.length; i < il; i++){
                const attachmentProperties = properties.get(textures[i]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(let i = 0; i < 6; i++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                state.bindTexture(_gl.TEXTURE_2D, attachmentProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_2D, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(_gl.TEXTURE_2D);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                const targetType = getTargetType(renderTarget);
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(targetType, webglTexture);
                generateMipmap(targetType);
                state.unbindTexture();
            }
        }
    }
    const invalidationArrayRead = [];
    const invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                const textures = renderTarget.textures;
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = _gl.COLOR_BUFFER_BIT;
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderTargetProperties = properties.get(renderTarget);
                const isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                        const webglTexture = properties.get(textures[i]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace !== (0, $ee56638efea8544d$export$42429b3acfb233a4) && colorSpace !== (0, $ee56638efea8544d$export$bfcb490c2dd3db51)) {
            // sRGB
            if ((0, $ee56638efea8544d$export$5e6fd513f44698c).getTransfer(colorSpace) === (0, $ee56638efea8544d$export$8d0a61916cc26abb)) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== (0, $ee56638efea8544d$export$3f8bb04b555a363c) || type !== (0, $ee56638efea8544d$export$2e8ce08d3f6f5e10)) console.warn('THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else console.error('THREE.WebGLTextures: Unsupported texture color space:', colorSpace);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
}
function $54cdb8f680e2b923$export$ddaebcad857649a8(gl, extensions) {
    function convert(p, colorSpace = (0, $ee56638efea8544d$export$bfcb490c2dd3db51)) {
        let extension;
        const transfer = (0, $ee56638efea8544d$export$5e6fd513f44698c).getTransfer(colorSpace);
        if (p === (0, $ee56638efea8544d$export$2e8ce08d3f6f5e10)) return gl.UNSIGNED_BYTE;
        if (p === (0, $ee56638efea8544d$export$b3969b01faf587f2)) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === (0, $ee56638efea8544d$export$18886f8ae33e90de)) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === (0, $ee56638efea8544d$export$5a4c329b7e2092d3)) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === (0, $ee56638efea8544d$export$545fce0311a9796a)) return gl.BYTE;
        if (p === (0, $ee56638efea8544d$export$88572337f312435f)) return gl.SHORT;
        if (p === (0, $ee56638efea8544d$export$c63dc51868b06a9d)) return gl.UNSIGNED_SHORT;
        if (p === (0, $ee56638efea8544d$export$5c612977753abe2)) return gl.INT;
        if (p === (0, $ee56638efea8544d$export$c3c7fc4518ebba96)) return gl.UNSIGNED_INT;
        if (p === (0, $ee56638efea8544d$export$f6d331659b644596)) return gl.FLOAT;
        if (p === (0, $ee56638efea8544d$export$2697304443f382bc)) return gl.HALF_FLOAT;
        if (p === (0, $ee56638efea8544d$export$988473390501ed4b)) return gl.ALPHA;
        if (p === (0, $ee56638efea8544d$export$7c67423a5ee6f5eb)) return gl.RGB;
        if (p === (0, $ee56638efea8544d$export$3f8bb04b555a363c)) return gl.RGBA;
        if (p === (0, $ee56638efea8544d$export$cc09ccbf6d1ed449)) return gl.LUMINANCE;
        if (p === (0, $ee56638efea8544d$export$9053a81c4a69c289)) return gl.LUMINANCE_ALPHA;
        if (p === (0, $ee56638efea8544d$export$c1b6b5136be58045)) return gl.DEPTH_COMPONENT;
        if (p === (0, $ee56638efea8544d$export$1e113ac2d0905829)) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === (0, $ee56638efea8544d$export$4e041a7967d15c4b)) return gl.RED;
        if (p === (0, $ee56638efea8544d$export$aa92e870a709d190)) return gl.RED_INTEGER;
        if (p === (0, $ee56638efea8544d$export$6cdf0b461c7ce8a0)) return gl.RG;
        if (p === (0, $ee56638efea8544d$export$1ba1c45f9f77d4d7)) return gl.RG_INTEGER;
        if (p === (0, $ee56638efea8544d$export$c200e7d26f592f21)) return gl.RGBA_INTEGER;
        // S3TC
        if (p === (0, $ee56638efea8544d$export$21d1799c6d552fc0) || p === (0, $ee56638efea8544d$export$afa304c3e981b668) || p === (0, $ee56638efea8544d$export$d2a1a68024a3e56c) || p === (0, $ee56638efea8544d$export$9a79c424327dacf9)) {
            if (transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb)) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === (0, $ee56638efea8544d$export$21d1799c6d552fc0)) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === (0, $ee56638efea8544d$export$afa304c3e981b668)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === (0, $ee56638efea8544d$export$d2a1a68024a3e56c)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === (0, $ee56638efea8544d$export$9a79c424327dacf9)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === (0, $ee56638efea8544d$export$21d1799c6d552fc0)) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === (0, $ee56638efea8544d$export$afa304c3e981b668)) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === (0, $ee56638efea8544d$export$d2a1a68024a3e56c)) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === (0, $ee56638efea8544d$export$9a79c424327dacf9)) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === (0, $ee56638efea8544d$export$19ada9bbb1af3573) || p === (0, $ee56638efea8544d$export$d0f0355bb3d948e4) || p === (0, $ee56638efea8544d$export$b82296714358084c) || p === (0, $ee56638efea8544d$export$b71692456c47b6c3)) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === (0, $ee56638efea8544d$export$19ada9bbb1af3573)) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === (0, $ee56638efea8544d$export$d0f0355bb3d948e4)) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === (0, $ee56638efea8544d$export$b82296714358084c)) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === (0, $ee56638efea8544d$export$b71692456c47b6c3)) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === (0, $ee56638efea8544d$export$6ab91af2d757aee7) || p === (0, $ee56638efea8544d$export$7800993ef8106a6a) || p === (0, $ee56638efea8544d$export$23ed8300a860e7d8)) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === (0, $ee56638efea8544d$export$6ab91af2d757aee7) || p === (0, $ee56638efea8544d$export$7800993ef8106a6a)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === (0, $ee56638efea8544d$export$23ed8300a860e7d8)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        // ASTC
        if (p === (0, $ee56638efea8544d$export$dc5570b4a2b92d48) || p === (0, $ee56638efea8544d$export$68880cd325f8b2fb) || p === (0, $ee56638efea8544d$export$7d2c0be323373d95) || p === (0, $ee56638efea8544d$export$22b52da301fc3a3e) || p === (0, $ee56638efea8544d$export$c009e2cb4a66485e) || p === (0, $ee56638efea8544d$export$118fff5afa255b63) || p === (0, $ee56638efea8544d$export$120713c829ae0667) || p === (0, $ee56638efea8544d$export$c79eeabbf53313e9) || p === (0, $ee56638efea8544d$export$443cf6567cdd6424) || p === (0, $ee56638efea8544d$export$6573984fc9840780) || p === (0, $ee56638efea8544d$export$e7aee563f30091de) || p === (0, $ee56638efea8544d$export$2eb8634622ddeab7) || p === (0, $ee56638efea8544d$export$202b1ce7b5d25742) || p === (0, $ee56638efea8544d$export$18ab77abd087e467)) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === (0, $ee56638efea8544d$export$dc5570b4a2b92d48)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === (0, $ee56638efea8544d$export$68880cd325f8b2fb)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === (0, $ee56638efea8544d$export$7d2c0be323373d95)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === (0, $ee56638efea8544d$export$22b52da301fc3a3e)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === (0, $ee56638efea8544d$export$c009e2cb4a66485e)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === (0, $ee56638efea8544d$export$118fff5afa255b63)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === (0, $ee56638efea8544d$export$120713c829ae0667)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === (0, $ee56638efea8544d$export$c79eeabbf53313e9)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === (0, $ee56638efea8544d$export$443cf6567cdd6424)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === (0, $ee56638efea8544d$export$6573984fc9840780)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === (0, $ee56638efea8544d$export$e7aee563f30091de)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === (0, $ee56638efea8544d$export$2eb8634622ddeab7)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === (0, $ee56638efea8544d$export$202b1ce7b5d25742)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === (0, $ee56638efea8544d$export$18ab77abd087e467)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === (0, $ee56638efea8544d$export$ce40b115e188bc81) || p === (0, $ee56638efea8544d$export$d279c5c4bac5121e) || p === (0, $ee56638efea8544d$export$cde52d17225fdbd3)) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === (0, $ee56638efea8544d$export$ce40b115e188bc81)) return transfer === (0, $ee56638efea8544d$export$8d0a61916cc26abb) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === (0, $ee56638efea8544d$export$d279c5c4bac5121e)) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === (0, $ee56638efea8544d$export$cde52d17225fdbd3)) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === (0, $ee56638efea8544d$export$b1688df4c4c21670) || p === (0, $ee56638efea8544d$export$fc15e5d8261eed58) || p === (0, $ee56638efea8544d$export$d220f6ade8463a0f) || p === (0, $ee56638efea8544d$export$768646d09dc1b6ef)) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === (0, $ee56638efea8544d$export$ce40b115e188bc81)) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === (0, $ee56638efea8544d$export$fc15e5d8261eed58)) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === (0, $ee56638efea8544d$export$d220f6ade8463a0f)) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === (0, $ee56638efea8544d$export$768646d09dc1b6ef)) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === (0, $ee56638efea8544d$export$6c8ea339bfab1301)) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
const $54cdb8f680e2b923$var$_moveEvent = {
    type: 'move'
};
class $54cdb8f680e2b923$var$WebXRController {
    constructor(){
        this._targetRay = null;
        this._grip = null;
        this._hand = null;
    }
    getHandSpace() {
        if (this._hand === null) {
            this._hand = new (0, $ee56638efea8544d$export$eb2fcfdbd7ba97d4)();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new (0, $ee56638efea8544d$export$eb2fcfdbd7ba97d4)();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
        }
        return this._targetRay;
    }
    getGripSpace() {
        if (this._grip === null) {
            this._grip = new (0, $ee56638efea8544d$export$eb2fcfdbd7ba97d4)();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
        }
        return this._grip;
    }
    dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: 'connected',
            data: inputSource
        });
        return this;
    }
    disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent($54cdb8f680e2b923$var$_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    // private method
    _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new (0, $ee56638efea8544d$export$eb2fcfdbd7ba97d4)();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
const $54cdb8f680e2b923$var$_occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const $54cdb8f680e2b923$var$_occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
class $54cdb8f680e2b923$var$WebXRDepthSensing {
    constructor(){
        this.texture = null;
        this.mesh = null;
        this.depthNear = 0;
        this.depthFar = 0;
    }
    init(renderer, depthData, renderState) {
        if (this.texture === null) {
            const texture = new (0, $ee56638efea8544d$export$5431306cf43de24a)();
            const texProps = renderer.properties.get(texture);
            texProps.__webglTexture = depthData.texture;
            if (depthData.depthNear !== renderState.depthNear || depthData.depthFar !== renderState.depthFar) {
                this.depthNear = depthData.depthNear;
                this.depthFar = depthData.depthFar;
            }
            this.texture = texture;
        }
    }
    getMesh(cameraXR) {
        if (this.texture !== null) {
            if (this.mesh === null) {
                const viewport = cameraXR.cameras[0].viewport;
                const material = new (0, $ee56638efea8544d$export$83c7d75d550a8b0d)({
                    vertexShader: $54cdb8f680e2b923$var$_occlusion_vertex,
                    fragmentShader: $54cdb8f680e2b923$var$_occlusion_fragment,
                    uniforms: {
                        depthColor: {
                            value: this.texture
                        },
                        depthWidth: {
                            value: viewport.z
                        },
                        depthHeight: {
                            value: viewport.w
                        }
                    }
                });
                this.mesh = new (0, $ee56638efea8544d$export$e176487c05830cc5)(new (0, $ee56638efea8544d$export$967d831af31f69ce)(20, 20), material);
            }
        }
        return this.mesh;
    }
    reset() {
        this.texture = null;
        this.mesh = null;
    }
    getDepthTexture() {
        return this.texture;
    }
}
class $54cdb8f680e2b923$var$WebXRManager extends (0, $ee56638efea8544d$export$ec8b666c5fe2c75a) {
    constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const depthSensing = new $54cdb8f680e2b923$var$WebXRDepthSensing();
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const currentSize = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)();
        let currentPixelRatio = null;
        //
        const cameraL = new (0, $ee56638efea8544d$export$74e4ae24825f68d7)();
        cameraL.viewport = new (0, $ee56638efea8544d$export$fa7daccca11cdbe3)();
        const cameraR = new (0, $ee56638efea8544d$export$74e4ae24825f68d7)();
        cameraR.viewport = new (0, $ee56638efea8544d$export$fa7daccca11cdbe3)();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new (0, $ee56638efea8544d$export$56b937d9e5581166)();
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        this.cameraAutoUpdate = true;
        this.enabled = false;
        this.isPresenting = false;
        this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $54cdb8f680e2b923$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $54cdb8f680e2b923$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new $54cdb8f680e2b923$var$WebXRController();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
        };
        this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        this.getBinding = function() {
            return glBinding;
        };
        this.getFrame = function() {
            return xrFrame;
        };
        this.getSession = function() {
            return session;
        };
        this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                currentPixelRatio = renderer.getPixelRatio();
                renderer.getSize(currentSize);
                const useLayers = session.enabledFeatures !== undefined && session.enabledFeatures.includes('layers');
                if (!useLayers) {
                    const layerInit = {
                        antialias: attributes.antialias,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                    newRenderTarget = new (0, $ee56638efea8544d$export$3c052beb2e51e23f)(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: (0, $ee56638efea8544d$export$3f8bb04b555a363c),
                        type: (0, $ee56638efea8544d$export$2e8ce08d3f6f5e10),
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? (0, $ee56638efea8544d$export$1e113ac2d0905829) : (0, $ee56638efea8544d$export$c1b6b5136be58045);
                        depthType = attributes.stencil ? (0, $ee56638efea8544d$export$6c8ea339bfab1301) : (0, $ee56638efea8544d$export$c3c7fc4518ebba96);
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = new XRWebGLBinding(session, gl);
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                    newRenderTarget = new (0, $ee56638efea8544d$export$3c052beb2e51e23f)(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: (0, $ee56638efea8544d$export$3f8bb04b555a363c),
                        type: (0, $ee56638efea8544d$export$2e8ce08d3f6f5e10),
                        depthTexture: new (0, $ee56638efea8544d$export$fc830aa069cc8c2f)(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0,
                        resolveDepthBuffer: glProjLayer.ignoreDepthValues === false
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        this.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
        const cameraRPos = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 *
		 * @param {ArrayCamera} camera - The camera to update.
		 * @param {PerspectiveCamera} cameraL - The left camera.
		 * @param {PerspectiveCamera} cameraR - The right camera.
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Check if the projection uses an infinite far plane.
            if (projL[10] === -1) {
                // Use the projection matrix from the left eye.
                // The camera offset is sufficient to include the view volumes
                // of both eyes (assuming symmetric projections).
                camera.projectionMatrix.copy(cameraL.projectionMatrix);
                camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
            } else {
                // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                const near2 = near + zOffset;
                const far2 = far + zOffset;
                const left2 = left - xOffset;
                const right2 = right + (ipd - xOffset);
                const top2 = topFov * far / far2 * near2;
                const bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
                camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            }
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        this.updateCamera = function(camera) {
            if (session === null) return;
            let depthNear = camera.near;
            let depthFar = camera.far;
            if (depthSensing.texture !== null) {
                if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
                if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = depthNear;
            cameraXR.far = cameraR.far = cameraL.far = depthFar;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            cameraL.layers.mask = camera.layers.mask | 2;
            cameraR.layers.mask = camera.layers.mask | 4;
            cameraXR.layers.mask = cameraL.layers.mask | cameraR.layers.mask;
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = (0, $ee56638efea8544d$export$914076c8150813e5) * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        this.getCamera = function() {
            return cameraXR;
        };
        this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        this.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        this.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glProjLayer.ignoreDepthValues ? undefined : glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new (0, $ee56638efea8544d$export$74e4ae24825f68d7)();
                        camera.layers.enable(i);
                        camera.viewport = new (0, $ee56638efea8544d$export$fa7daccca11cdbe3)();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                const enabledFeatures = session.enabledFeatures;
                if (enabledFeatures && enabledFeatures.includes('depth-sensing')) {
                    const depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(renderer, depthData, session.renderState);
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        const animation = new $54cdb8f680e2b923$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
const $54cdb8f680e2b923$var$_e1 = /*@__PURE__*/ new (0, $ee56638efea8544d$export$d93cc409a0768c5f)();
const $54cdb8f680e2b923$var$_m1 = /*@__PURE__*/ new (0, $ee56638efea8544d$export$2ae72fc923e5eb5)();
function $54cdb8f680e2b923$var$WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, (0, $ee56638efea8544d$export$a630742c640528c1)(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === (0, $ee56638efea8544d$export$d9f0486e75b5ace)) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === (0, $ee56638efea8544d$export$d9f0486e75b5ace)) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const materialProperties = properties.get(material);
        const envMap = materialProperties.envMap;
        const envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            $54cdb8f680e2b923$var$_e1.copy(envMapRotation);
            // accommodate left-handed frame
            $54cdb8f680e2b923$var$_e1.x *= -1;
            $54cdb8f680e2b923$var$_e1.y *= -1;
            $54cdb8f680e2b923$var$_e1.z *= -1;
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                $54cdb8f680e2b923$var$_e1.y *= -1;
                $54cdb8f680e2b923$var$_e1.z *= -1;
            }
            uniforms.envMapRotation.value.setFromMatrix4($54cdb8f680e2b923$var$_m1.makeRotationFromEuler($54cdb8f680e2b923$var$_e1));
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === (0, $ee56638efea8544d$export$d9f0486e75b5ace)) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function $54cdb8f680e2b923$var$WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        console.error('THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    const offset = uniform.__offset;
                    const values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    let arrayOffset = 0;
                    for(let k = 0; k < values.length; k++){
                        const value = values[k];
                        const info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === 'number' || typeof value === 'boolean') {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        const value = uniform.value;
        const indexString = index + '_' + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number' || typeof value === 'boolean') cache[indexString] = value;
            else cache[indexString] = value.clone();
            return true;
        } else {
            const cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === 'number' || typeof value === 'boolean') {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(let k = 0, kl = values.length; k < kl; k++){
                    const value = values[k];
                    const info = getUniformSize(value);
                    const chunkOffset = offset % chunkSize; // offset in the current chunk
                    const chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    const chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        const chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number' || typeof value === 'boolean') {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) console.warn('THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else console.warn('THREE.WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
class $54cdb8f680e2b923$export$f6cc00ef28d7cf97 {
    constructor(parameters = {}){
        const { canvas: canvas = (0, $ee56638efea8544d$export$1033a2df66368859)(), context: context = null, depth: depth = true, stencil: stencil = false, alpha: alpha = false, antialias: antialias = false, premultipliedAlpha: premultipliedAlpha = true, preserveDrawingBuffer: preserveDrawingBuffer = false, powerPreference: powerPreference = 'default', failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat = false, reverseDepthBuffer: reverseDepthBuffer = false } = parameters;
        this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext) throw new Error('THREE.WebGLRenderer: WebGL 1 is not supported since r163.');
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // public properties
        this.domElement = canvas;
        // Debug configuration container
        this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        this.autoClear = true;
        this.autoClearColor = true;
        this.autoClearDepth = true;
        this.autoClearStencil = true;
        // scene graph
        this.sortObjects = true;
        // user-defined clipping
        this.clippingPlanes = [];
        this.localClippingEnabled = false;
        // physically based shading
        this._outputColorSpace = (0, $ee56638efea8544d$export$561f394b24edfcaa);
        // tone mapping
        this.toneMapping = (0, $ee56638efea8544d$export$9fcb6b4294603b2);
        this.toneMappingExposure = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new (0, $ee56638efea8544d$export$fa7daccca11cdbe3)();
        const _currentScissor = new (0, $ee56638efea8544d$export$fa7daccca11cdbe3)();
        let _currentScissorTest = null;
        const _currentClearColor = new (0, $ee56638efea8544d$export$892596cec99bc70e)(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new (0, $ee56638efea8544d$export$fa7daccca11cdbe3)(0, 0, _width, _height);
        const _scissor = new (0, $ee56638efea8544d$export$fa7daccca11cdbe3)(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new (0, $ee56638efea8544d$export$35efe6f4c85463d2)();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // transmission render target scale
        this.transmissionResolutionScale = 1.0;
        // camera matrices cache
        const _currentProjectionMatrix = new (0, $ee56638efea8544d$export$2ae72fc923e5eb5)();
        const _projScreenMatrix = new (0, $ee56638efea8544d$export$2ae72fc923e5eb5)();
        const _vector3 = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
        const _vector4 = new (0, $ee56638efea8544d$export$fa7daccca11cdbe3)();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        let _renderBackground = false;
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth: depth,
                stencil: stencil,
                antialias: antialias,
                premultipliedAlpha: premultipliedAlpha,
                preserveDrawingBuffer: preserveDrawingBuffer,
                powerPreference: powerPreference,
                failIfMajorPerformanceCaveat: failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', `three.js r${(0, $ee56638efea8544d$export$3545e07a80636437)}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                const contextName = 'webgl2';
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
        } catch (error) {
            console.error('THREE.WebGLRenderer: ' + error.message);
            throw error;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new $54cdb8f680e2b923$var$WebGLExtensions(_gl);
            extensions.init();
            utils = new $54cdb8f680e2b923$export$ddaebcad857649a8(_gl, extensions);
            capabilities = new $54cdb8f680e2b923$var$WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new $54cdb8f680e2b923$var$WebGLState(_gl, extensions);
            if (capabilities.reverseDepthBuffer && reverseDepthBuffer) state.buffers.depth.setReversed(true);
            info = new $54cdb8f680e2b923$var$WebGLInfo(_gl);
            properties = new $54cdb8f680e2b923$var$WebGLProperties();
            textures = new $54cdb8f680e2b923$var$WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new $54cdb8f680e2b923$var$WebGLCubeMaps(_this);
            cubeuvmaps = new $54cdb8f680e2b923$var$WebGLCubeUVMaps(_this);
            attributes = new $54cdb8f680e2b923$var$WebGLAttributes(_gl);
            bindingStates = new $54cdb8f680e2b923$var$WebGLBindingStates(_gl, attributes);
            geometries = new $54cdb8f680e2b923$var$WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new $54cdb8f680e2b923$var$WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new $54cdb8f680e2b923$var$WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new $54cdb8f680e2b923$var$WebGLClipping(properties);
            programCache = new $54cdb8f680e2b923$var$WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new $54cdb8f680e2b923$var$WebGLMaterials(_this, properties);
            renderLists = new $54cdb8f680e2b923$var$WebGLRenderLists();
            renderStates = new $54cdb8f680e2b923$var$WebGLRenderStates(extensions);
            background = new $54cdb8f680e2b923$var$WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new $54cdb8f680e2b923$var$WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new $54cdb8f680e2b923$var$WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new $54cdb8f680e2b923$var$WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new $54cdb8f680e2b923$var$WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            _this.capabilities = capabilities;
            _this.extensions = extensions;
            _this.properties = properties;
            _this.renderLists = renderLists;
            _this.shadowMap = shadowMap;
            _this.state = state;
            _this.info = info;
        }
        initGLContext();
        // xr
        const xr = new $54cdb8f680e2b923$var$WebXRManager(_this, _gl);
        this.xr = xr;
        // API
        this.getContext = function() {
            return _gl;
        };
        this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        this.forceContextLoss = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        this.forceContextRestore = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        this.getPixelRatio = function() {
            return _pixelRatio;
        };
        this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        this.getSize = function(target) {
            return target.set(_width, _height);
        };
        this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            this.setViewport(0, 0, width, height);
        };
        this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        this.getScissorTest = function() {
            return _scissorTest;
        };
        this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        this.setClearColor = function() {
            background.setClearColor.apply(background, arguments);
        };
        this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        this.setClearAlpha = function() {
            background.setClearAlpha.apply(background, arguments);
        };
        this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = targetFormat === (0, $ee56638efea8544d$export$c200e7d26f592f21) || targetFormat === (0, $ee56638efea8544d$export$1ba1c45f9f77d4d7) || targetFormat === (0, $ee56638efea8544d$export$aa92e870a709d190);
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = targetType === (0, $ee56638efea8544d$export$2e8ce08d3f6f5e10) || targetType === (0, $ee56638efea8544d$export$c3c7fc4518ebba96) || targetType === (0, $ee56638efea8544d$export$c63dc51868b06a9d) || targetType === (0, $ee56638efea8544d$export$6c8ea339bfab1301) || targetType === (0, $ee56638efea8544d$export$b3969b01faf587f2) || targetType === (0, $ee56638efea8544d$export$18886f8ae33e90de);
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            _gl.clear(bits);
        };
        this.clearColor = function() {
            this.clear(true, false, false);
        };
        this.clearDepth = function() {
            this.clear(false, true, false);
        };
        this.clearStencil = function() {
            this.clear(false, false, true);
        };
        //
        this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            background.dispose();
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            console.log('THREE.WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            console.log('THREE.WebGLRenderer: Context Restored.');
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            console.error('THREE.WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                else if (!extensions.get('WEBGL_multi_draw')) {
                    const starts = object._multiDrawStarts;
                    const counts = object._multiDrawCounts;
                    const drawCount = object._multiDrawCount;
                    const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    const uniforms = properties.get(material).currentProgram.getUniforms();
                    for(let i = 0; i < drawCount; i++){
                        uniforms.setValue(_gl, '_gl_DrawID', i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === (0, $ee56638efea8544d$export$3b296b6f144d5b03) && material.forceSinglePass === false) {
                material.side = (0, $ee56638efea8544d$export$d9f0486e75b5ace);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $ee56638efea8544d$export$2ede184fc2998901);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, $ee56638efea8544d$export$3b296b6f144d5b03);
            } else getProgram(material, scene, object);
        }
        this.compile = function(scene, camera, targetScene = null) {
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            const materials = new Set();
            scene.traverse(function(object) {
                if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) return;
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            renderStateStack.pop();
            currentRenderState = null;
            return materials;
        };
        // compileAsync
        this.compileAsync = function(scene, camera, targetScene = null) {
            const materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise((resolve)=>{
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        const materialProperties = properties.get(material);
                        const program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get('KHR_parallel_shader_compile') !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new $54cdb8f680e2b923$var$WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                const depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            currentRenderState.setupLights();
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                if (transmissiveObjects.length > 0) for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                }
                if (_renderBackground) background.render(scene);
                for(let i = 0, l = cameras.length; i < l; i++){
                    const camera2 = cameras[i];
                    renderScene(currentRenderList, scene, camera2, camera2.viewport);
                }
            } else {
                if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                if (_renderBackground) background.render(scene);
                renderScene(currentRenderList, scene, camera);
            }
            //
            if (_currentRenderTarget !== null && _currentActiveMipmapLevel === 0) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector4.copy(geometry.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const opaqueObjects = currentRenderList.opaque;
            const transmissiveObjects = currentRenderList.transmissive;
            const transparentObjects = currentRenderList.transparent;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) currentRenderState.state.transmissionRenderTarget[camera.id] = new (0, $ee56638efea8544d$export$3c052beb2e51e23f)(1, 1, {
                generateMipmaps: true,
                type: extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float') ? (0, $ee56638efea8544d$export$2697304443f382bc) : (0, $ee56638efea8544d$export$2e8ce08d3f6f5e10),
                minFilter: (0, $ee56638efea8544d$export$5d8599b6a933fb1b),
                samples: 4,
                stencilBuffer: stencil,
                resolveDepthBuffer: false,
                resolveStencilBuffer: false,
                colorSpace: (0, $ee56638efea8544d$export$5e6fd513f44698c).workingColorSpace
            });
            const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            const activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z * _this.transmissionResolutionScale, activeViewport.w * _this.transmissionResolutionScale);
            //
            const currentRenderTarget = _this.getRenderTarget();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = (0, $ee56638efea8544d$export$9fcb6b4294603b2);
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            const currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has('WEBGL_multisampled_render_to_texture') === false) {
                let renderTargetNeedsUpdate = false;
                for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                    const renderItem = transmissiveObjects[i];
                    const object = renderItem.object;
                    const geometry = renderItem.geometry;
                    const material = renderItem.material;
                    const group = renderItem.group;
                    if (material.side === (0, $ee56638efea8544d$export$3b296b6f144d5b03) && object.layers.test(camera.layers)) {
                        const currentSide = material.side;
                        material.side = (0, $ee56638efea8544d$export$d9f0486e75b5ace);
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const object = renderItem.object;
                const geometry = renderItem.geometry;
                const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
                const group = renderItem.group;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === (0, $ee56638efea8544d$export$3b296b6f144d5b03) && material.forceSinglePass === false) {
                material.side = (0, $ee56638efea8544d$export$d9f0486e75b5ace);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $ee56638efea8544d$export$2ede184fc2998901);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, $ee56638efea8544d$export$3b296b6f144d5b03);
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                const progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = $54cdb8f680e2b923$var$WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : (0, $ee56638efea8544d$export$42429b3acfb233a4);
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = (0, $ee56638efea8544d$export$9fcb6b4294603b2);
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                const reverseDepthBuffer = state.buffers.depth.getReversed();
                if (reverseDepthBuffer) {
                    _currentProjectionMatrix.copy(camera.projectionMatrix);
                    (0, $ee56638efea8544d$export$5238391f68c729b)(_currentProjectionMatrix);
                    (0, $ee56638efea8544d$export$f8cf97d08da9bc86)(_currentProjectionMatrix);
                    p_uniforms.setValue(_gl, 'projectionMatrix', _currentProjectionMatrix);
                } else p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, 'batchingTexture');
                p_uniforms.setValue(_gl, 'batchingTexture', object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingIdTexture');
                p_uniforms.setValue(_gl, 'batchingIdTexture', object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingColorTexture');
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, 'batchingColorTexture', object._colorsTexture, textures);
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                $54cdb8f680e2b923$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                $54cdb8f680e2b923$var$WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++){
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = depthTexture;
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__hasExternalTextures = true;
            renderTargetProperties.__autoAllocateDepthBuffer = depthTexture === undefined;
            if (!renderTargetProperties.__autoAllocateDepthBuffer) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            {
                if (extensions.has('WEBGL_multisampled_render_to_texture') === true) {
                    console.warn('THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided');
                    renderTargetProperties.__useRenderToTexture = false;
                }
            }
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        const _scratchFrameBuffer = _gl.createFramebuffer();
        this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let useDefaultFramebuffer = true;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // We need to make sure to rebind the framebuffer.
                    state.bindFramebuffer(_gl.FRAMEBUFFER, null);
                    useDefaultFramebuffer = false;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                else if (renderTarget.depthBuffer) {
                    // check if the depth texture is already bound to the frame buffer and that it's been initialized
                    const depthTexture = renderTarget.depthTexture;
                    if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                        // check if the depth texture is compatible
                        if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) throw new Error('WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.');
                        // Swap the depth buffer to the currently attached one
                        textures.setupDepthRenderbuffer(renderTarget);
                    }
                }
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            // Use a scratch frame buffer if rendering to a mip level to avoid depth buffers
            // being bound that are different sizes.
            if (activeMipmapLevel !== 0) framebuffer = _scratchFrameBuffer;
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound && useDefaultFramebuffer) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const textureProperties = properties.get(renderTarget.texture);
                const layer = activeCubeFace;
                _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, textureProperties.__webglTexture, activeMipmapLevel, layer);
            } else if (renderTarget !== null && activeMipmapLevel !== 0) {
                // Only bind the frame buffer if we are using a scratch frame buffer to render to a mipmap.
                // If we rebind the texture when using a multi sample buffer then an error about inconsistent samples will be thrown.
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, textureProperties.__webglTexture, activeMipmapLevel);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.texture;
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                const texture = renderTarget.texture;
                const textureFormat = texture.format;
                const textureType = texture.type;
                if (!capabilities.textureFormatReadable(textureFormat)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.');
                if (!capabilities.textureTypeReadable(textureType)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.');
                // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                    // set the active frame buffer to the one we want to read
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                    const glBuffer = _gl.createBuffer();
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                    _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                    // reset the frame buffer to the currently set buffer before waiting
                    const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
                    // check if the commands have finished every 8 ms
                    const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    _gl.flush();
                    await (0, $ee56638efea8544d$export$d43f91ebeafb2c7)(_gl, sync, 4);
                    // read the data and delete the buffer
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                    _gl.deleteBuffer(glBuffer);
                    _gl.deleteSync(sync);
                    return buffer;
                } else throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.');
            }
        };
        this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
            // support previous signature with position first
            if (texture.isTexture !== true) {
                // @deprecated, r165
                (0, $ee56638efea8544d$export$5b28268982f175ba)('WebGLRenderer: copyFramebufferToTexture function signature has changed.');
                position = arguments[0] || null;
                texture = arguments[1];
            }
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            const x = position !== null ? position.x : 0;
            const y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        const _srcFramebuffer = _gl.createFramebuffer();
        const _dstFramebuffer = _gl.createFramebuffer();
        this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = null) {
            // support previous signature with dstPosition first
            if (srcTexture.isTexture !== true) {
                // @deprecated, r165
                (0, $ee56638efea8544d$export$5b28268982f175ba)('WebGLRenderer: copyTextureToTexture function signature has changed.');
                dstPosition = arguments[0] || null;
                srcTexture = arguments[1];
                dstTexture = arguments[2];
                dstLevel = arguments[3] || 0;
                srcRegion = null;
            }
            // support the previous signature with just a single dst mipmap level
            if (dstLevel === null) {
                if (srcLevel !== 0) {
                    // @deprecated, r171
                    (0, $ee56638efea8544d$export$5b28268982f175ba)('WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels.');
                    dstLevel = srcLevel;
                    srcLevel = 0;
                } else dstLevel = 0;
            }
            // gather the necessary dimensions to copy
            let width, height, depth, minX, minY, minZ;
            let dstX, dstY, dstZ;
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
            } else {
                const levelScale = Math.pow(2, -srcLevel);
                width = Math.floor(image.width * levelScale);
                height = Math.floor(image.height * levelScale);
                if (srcTexture.isDataArrayTexture) depth = image.depth;
                else if (srcTexture.isData3DTexture) depth = Math.floor(image.depth * levelScale);
                else depth = 1;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            // Set up the destination target
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                textures.setTexture2D(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            // used for copying data from cpu
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            // set up the src texture
            const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
            const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
            if (srcTexture.isDepthTexture) {
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                const srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
                const dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < depth; i++){
                    // if the source or destination are a 3d target then a layer needs to be bound
                    if (isSrc3D) {
                        _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i);
                        _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i);
                    }
                    _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
                // get the appropriate frame buffers
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                // bind the frame buffer targets
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
                for(let i = 0; i < depth; i++){
                    // assign the correct layers and mip maps to the frame buffers
                    if (isSrc3D) _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties.__webglTexture, srcLevel, minZ + i);
                    else _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties.__webglTexture, srcLevel);
                    if (isDst3D) _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties.__webglTexture, dstLevel, dstZ + i);
                    else _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties.__webglTexture, dstLevel);
                    // copy the data using the fastest function that can achieve the copy
                    if (srcLevel !== 0) _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
                    else if (isDst3D) _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i, minX, minY, width, height);
                    else _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
                }
                // unbind read, draw buffers
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (isDst3D) {
                // copy data into the 3d texture
                if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
                else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
                else _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            } else {
                // copy data into the 2d texture
                if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
                else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
                else _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
            }
            // reset values
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (dstLevel === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        this.copyTextureToTexture3D = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, level = 0) {
            // support previous signature with source box first
            if (srcTexture.isTexture !== true) {
                // @deprecated, r165
                (0, $ee56638efea8544d$export$5b28268982f175ba)('WebGLRenderer: copyTextureToTexture3D function signature has changed.');
                srcRegion = arguments[0] || null;
                dstPosition = arguments[1] || null;
                srcTexture = arguments[2];
                dstTexture = arguments[3];
                level = arguments[4] || 0;
            }
            // @deprecated, r170
            (0, $ee56638efea8544d$export$5b28268982f175ba)('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.');
            return this.copyTextureToTexture(srcTexture, dstTexture, srcRegion, dstPosition, level);
        };
        this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    get coordinateSystem() {
        return 0, $ee56638efea8544d$export$5a0e9190d10875d3;
    }
    get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace) {
        this._outputColorSpace = colorSpace;
        const gl = this.getContext();
        gl.drawingBufferColorspace = (0, $ee56638efea8544d$export$5e6fd513f44698c)._getDrawingBufferColorSpace(colorSpace);
        gl.unpackColorSpace = (0, $ee56638efea8544d$export$5e6fd513f44698c)._getUnpackColorSpace();
    }
}



// OrbitControls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move
const $db77f41475ae732a$var$_changeEvent = {
    type: 'change'
};
const $db77f41475ae732a$var$_startEvent = {
    type: 'start'
};
const $db77f41475ae732a$var$_endEvent = {
    type: 'end'
};
const $db77f41475ae732a$var$_ray = new (0, $ee56638efea8544d$export$a186db52eed6d40e)();
const $db77f41475ae732a$var$_plane = new (0, $ee56638efea8544d$export$7ff5ac152ef991b0)();
const $db77f41475ae732a$var$_TILT_LIMIT = Math.cos(70 * (0, $ee56638efea8544d$export$6a7ef315a0d1ef07).DEG2RAD);
const $db77f41475ae732a$var$_v = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
const $db77f41475ae732a$var$_twoPI = 2 * Math.PI;
const $db77f41475ae732a$var$_STATE = {
    NONE: -1,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2,
    TOUCH_ROTATE: 3,
    TOUCH_PAN: 4,
    TOUCH_DOLLY_PAN: 5,
    TOUCH_DOLLY_ROTATE: 6
};
const $db77f41475ae732a$var$_EPS = 0.000001;
class $db77f41475ae732a$export$8ff7788029dfdf52 extends (0, $ee56638efea8544d$export$c7c44baae9d9f25f) {
    constructor(object, domElement = null){
        super(object, domElement);
        this.state = $db77f41475ae732a$var$_STATE.NONE;
        // Set to false to disable this control
        this.enabled = true;
        // "target" sets the location of focus, where the object orbits around
        this.target = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
        // Sets the 3D cursor (similar to Blender), from which the maxTargetRadius takes effect
        this.cursor = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
        // How far you can dolly in and out ( PerspectiveCamera only )
        this.minDistance = 0;
        this.maxDistance = Infinity;
        // How far you can zoom in and out ( OrthographicCamera only )
        this.minZoom = 0;
        this.maxZoom = Infinity;
        // Limit camera target within a spherical area around the cursor
        this.minTargetRadius = 0;
        this.maxTargetRadius = Infinity;
        // How far you can orbit vertically, upper and lower limits.
        // Range is 0 to Math.PI radians.
        this.minPolarAngle = 0; // radians
        this.maxPolarAngle = Math.PI; // radians
        // How far you can orbit horizontally, upper and lower limits.
        // If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )
        this.minAzimuthAngle = -Infinity; // radians
        this.maxAzimuthAngle = Infinity; // radians
        // Set to true to enable damping (inertia)
        // If damping is enabled, you must call controls.update() in your animation loop
        this.enableDamping = false;
        this.dampingFactor = 0.05;
        // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
        // Set to false to disable zooming
        this.enableZoom = true;
        this.zoomSpeed = 1.0;
        // Set to false to disable rotating
        this.enableRotate = true;
        this.rotateSpeed = 1.0;
        this.keyRotateSpeed = 1.0;
        // Set to false to disable panning
        this.enablePan = true;
        this.panSpeed = 1.0;
        this.screenSpacePanning = true; // if false, pan orthogonal to world-space direction camera.up
        this.keyPanSpeed = 7.0; // pixels moved per arrow key push
        this.zoomToCursor = false;
        // Set to true to automatically rotate around the target
        // If auto-rotate is enabled, you must call controls.update() in your animation loop
        this.autoRotate = false;
        this.autoRotateSpeed = 2.0; // 30 seconds per orbit when fps is 60
        // The four arrow keys
        this.keys = {
            LEFT: 'ArrowLeft',
            UP: 'ArrowUp',
            RIGHT: 'ArrowRight',
            BOTTOM: 'ArrowDown'
        };
        // Mouse buttons
        this.mouseButtons = {
            LEFT: (0, $ee56638efea8544d$export$7177b3e430c2d7ca).ROTATE,
            MIDDLE: (0, $ee56638efea8544d$export$7177b3e430c2d7ca).DOLLY,
            RIGHT: (0, $ee56638efea8544d$export$7177b3e430c2d7ca).PAN
        };
        // Touch fingers
        this.touches = {
            ONE: (0, $ee56638efea8544d$export$d46bd3ead7cc759b).ROTATE,
            TWO: (0, $ee56638efea8544d$export$d46bd3ead7cc759b).DOLLY_PAN
        };
        // for reset
        this.target0 = this.target.clone();
        this.position0 = this.object.position.clone();
        this.zoom0 = this.object.zoom;
        // the target DOM element for key events
        this._domElementKeyEvents = null;
        // internals
        this._lastPosition = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
        this._lastQuaternion = new (0, $ee56638efea8544d$export$23d6a54f0bbc85a3)();
        this._lastTargetPosition = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
        // so camera.up is the orbit axis
        this._quat = new (0, $ee56638efea8544d$export$23d6a54f0bbc85a3)().setFromUnitVectors(object.up, new (0, $ee56638efea8544d$export$64b5c384219d3699)(0, 1, 0));
        this._quatInverse = this._quat.clone().invert();
        // current position in spherical coordinates
        this._spherical = new (0, $ee56638efea8544d$export$d712cd887b4a00f7)();
        this._sphericalDelta = new (0, $ee56638efea8544d$export$d712cd887b4a00f7)();
        this._scale = 1;
        this._panOffset = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
        this._rotateStart = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)();
        this._rotateEnd = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)();
        this._rotateDelta = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)();
        this._panStart = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)();
        this._panEnd = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)();
        this._panDelta = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)();
        this._dollyStart = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)();
        this._dollyEnd = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)();
        this._dollyDelta = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)();
        this._dollyDirection = new (0, $ee56638efea8544d$export$64b5c384219d3699)();
        this._mouse = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)();
        this._performCursorZoom = false;
        this._pointers = [];
        this._pointerPositions = {};
        this._controlActive = false;
        // event listeners
        this._onPointerMove = $db77f41475ae732a$var$onPointerMove.bind(this);
        this._onPointerDown = $db77f41475ae732a$var$onPointerDown.bind(this);
        this._onPointerUp = $db77f41475ae732a$var$onPointerUp.bind(this);
        this._onContextMenu = $db77f41475ae732a$var$onContextMenu.bind(this);
        this._onMouseWheel = $db77f41475ae732a$var$onMouseWheel.bind(this);
        this._onKeyDown = $db77f41475ae732a$var$onKeyDown.bind(this);
        this._onTouchStart = $db77f41475ae732a$var$onTouchStart.bind(this);
        this._onTouchMove = $db77f41475ae732a$var$onTouchMove.bind(this);
        this._onMouseDown = $db77f41475ae732a$var$onMouseDown.bind(this);
        this._onMouseMove = $db77f41475ae732a$var$onMouseMove.bind(this);
        this._interceptControlDown = $db77f41475ae732a$var$interceptControlDown.bind(this);
        this._interceptControlUp = $db77f41475ae732a$var$interceptControlUp.bind(this);
        //
        if (this.domElement !== null) this.connect();
        this.update();
    }
    connect() {
        this.domElement.addEventListener('pointerdown', this._onPointerDown);
        this.domElement.addEventListener('pointercancel', this._onPointerUp);
        this.domElement.addEventListener('contextmenu', this._onContextMenu);
        this.domElement.addEventListener('wheel', this._onMouseWheel, {
            passive: false
        });
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.addEventListener('keydown', this._interceptControlDown, {
            passive: true,
            capture: true
        });
        this.domElement.style.touchAction = 'none'; // disable touch scroll
    }
    disconnect() {
        this.domElement.removeEventListener('pointerdown', this._onPointerDown);
        this.domElement.removeEventListener('pointermove', this._onPointerMove);
        this.domElement.removeEventListener('pointerup', this._onPointerUp);
        this.domElement.removeEventListener('pointercancel', this._onPointerUp);
        this.domElement.removeEventListener('wheel', this._onMouseWheel);
        this.domElement.removeEventListener('contextmenu', this._onContextMenu);
        this.stopListenToKeyEvents();
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.removeEventListener('keydown', this._interceptControlDown, {
            capture: true
        });
        this.domElement.style.touchAction = 'auto';
    }
    dispose() {
        this.disconnect();
    }
    getPolarAngle() {
        return this._spherical.phi;
    }
    getAzimuthalAngle() {
        return this._spherical.theta;
    }
    getDistance() {
        return this.object.position.distanceTo(this.target);
    }
    listenToKeyEvents(domElement) {
        domElement.addEventListener('keydown', this._onKeyDown);
        this._domElementKeyEvents = domElement;
    }
    stopListenToKeyEvents() {
        if (this._domElementKeyEvents !== null) {
            this._domElementKeyEvents.removeEventListener('keydown', this._onKeyDown);
            this._domElementKeyEvents = null;
        }
    }
    saveState() {
        this.target0.copy(this.target);
        this.position0.copy(this.object.position);
        this.zoom0 = this.object.zoom;
    }
    reset() {
        this.target.copy(this.target0);
        this.object.position.copy(this.position0);
        this.object.zoom = this.zoom0;
        this.object.updateProjectionMatrix();
        this.dispatchEvent($db77f41475ae732a$var$_changeEvent);
        this.update();
        this.state = $db77f41475ae732a$var$_STATE.NONE;
    }
    update(deltaTime = null) {
        const position = this.object.position;
        $db77f41475ae732a$var$_v.copy(position).sub(this.target);
        // rotate offset to "y-axis-is-up" space
        $db77f41475ae732a$var$_v.applyQuaternion(this._quat);
        // angle from z-axis around y-axis
        this._spherical.setFromVector3($db77f41475ae732a$var$_v);
        if (this.autoRotate && this.state === $db77f41475ae732a$var$_STATE.NONE) this._rotateLeft(this._getAutoRotationAngle(deltaTime));
        if (this.enableDamping) {
            this._spherical.theta += this._sphericalDelta.theta * this.dampingFactor;
            this._spherical.phi += this._sphericalDelta.phi * this.dampingFactor;
        } else {
            this._spherical.theta += this._sphericalDelta.theta;
            this._spherical.phi += this._sphericalDelta.phi;
        }
        // restrict theta to be between desired limits
        let min = this.minAzimuthAngle;
        let max = this.maxAzimuthAngle;
        if (isFinite(min) && isFinite(max)) {
            if (min < -Math.PI) min += $db77f41475ae732a$var$_twoPI;
            else if (min > Math.PI) min -= $db77f41475ae732a$var$_twoPI;
            if (max < -Math.PI) max += $db77f41475ae732a$var$_twoPI;
            else if (max > Math.PI) max -= $db77f41475ae732a$var$_twoPI;
            if (min <= max) this._spherical.theta = Math.max(min, Math.min(max, this._spherical.theta));
            else this._spherical.theta = this._spherical.theta > (min + max) / 2 ? Math.max(min, this._spherical.theta) : Math.min(max, this._spherical.theta);
        }
        // restrict phi to be between desired limits
        this._spherical.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this._spherical.phi));
        this._spherical.makeSafe();
        // move target to panned location
        if (this.enableDamping === true) this.target.addScaledVector(this._panOffset, this.dampingFactor);
        else this.target.add(this._panOffset);
        // Limit the target distance from the cursor to create a sphere around the center of interest
        this.target.sub(this.cursor);
        this.target.clampLength(this.minTargetRadius, this.maxTargetRadius);
        this.target.add(this.cursor);
        let zoomChanged = false;
        // adjust the camera position based on zoom only if we're not zooming to the cursor or if it's an ortho camera
        // we adjust zoom later in these cases
        if (this.zoomToCursor && this._performCursorZoom || this.object.isOrthographicCamera) this._spherical.radius = this._clampDistance(this._spherical.radius);
        else {
            const prevRadius = this._spherical.radius;
            this._spherical.radius = this._clampDistance(this._spherical.radius * this._scale);
            zoomChanged = prevRadius != this._spherical.radius;
        }
        $db77f41475ae732a$var$_v.setFromSpherical(this._spherical);
        // rotate offset back to "camera-up-vector-is-up" space
        $db77f41475ae732a$var$_v.applyQuaternion(this._quatInverse);
        position.copy(this.target).add($db77f41475ae732a$var$_v);
        this.object.lookAt(this.target);
        if (this.enableDamping === true) {
            this._sphericalDelta.theta *= 1 - this.dampingFactor;
            this._sphericalDelta.phi *= 1 - this.dampingFactor;
            this._panOffset.multiplyScalar(1 - this.dampingFactor);
        } else {
            this._sphericalDelta.set(0, 0, 0);
            this._panOffset.set(0, 0, 0);
        }
        // adjust camera position
        if (this.zoomToCursor && this._performCursorZoom) {
            let newRadius = null;
            if (this.object.isPerspectiveCamera) {
                // move the camera down the pointer ray
                // this method avoids floating point error
                const prevRadius = $db77f41475ae732a$var$_v.length();
                newRadius = this._clampDistance(prevRadius * this._scale);
                const radiusDelta = prevRadius - newRadius;
                this.object.position.addScaledVector(this._dollyDirection, radiusDelta);
                this.object.updateMatrixWorld();
                zoomChanged = !!radiusDelta;
            } else if (this.object.isOrthographicCamera) {
                // adjust the ortho camera position based on zoom changes
                const mouseBefore = new (0, $ee56638efea8544d$export$64b5c384219d3699)(this._mouse.x, this._mouse.y, 0);
                mouseBefore.unproject(this.object);
                const prevZoom = this.object.zoom;
                this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
                this.object.updateProjectionMatrix();
                zoomChanged = prevZoom !== this.object.zoom;
                const mouseAfter = new (0, $ee56638efea8544d$export$64b5c384219d3699)(this._mouse.x, this._mouse.y, 0);
                mouseAfter.unproject(this.object);
                this.object.position.sub(mouseAfter).add(mouseBefore);
                this.object.updateMatrixWorld();
                newRadius = $db77f41475ae732a$var$_v.length();
            } else {
                console.warn('WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled.');
                this.zoomToCursor = false;
            }
            // handle the placement of the target
            if (newRadius !== null) {
                if (this.screenSpacePanning) // position the orbit target in front of the new camera position
                this.target.set(0, 0, -1).transformDirection(this.object.matrix).multiplyScalar(newRadius).add(this.object.position);
                else {
                    // get the ray and translation plane to compute target
                    $db77f41475ae732a$var$_ray.origin.copy(this.object.position);
                    $db77f41475ae732a$var$_ray.direction.set(0, 0, -1).transformDirection(this.object.matrix);
                    // if the camera is 20 degrees above the horizon then don't adjust the focus target to avoid
                    // extremely large values
                    if (Math.abs(this.object.up.dot($db77f41475ae732a$var$_ray.direction)) < $db77f41475ae732a$var$_TILT_LIMIT) this.object.lookAt(this.target);
                    else {
                        $db77f41475ae732a$var$_plane.setFromNormalAndCoplanarPoint(this.object.up, this.target);
                        $db77f41475ae732a$var$_ray.intersectPlane($db77f41475ae732a$var$_plane, this.target);
                    }
                }
            }
        } else if (this.object.isOrthographicCamera) {
            const prevZoom = this.object.zoom;
            this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale));
            if (prevZoom !== this.object.zoom) {
                this.object.updateProjectionMatrix();
                zoomChanged = true;
            }
        }
        this._scale = 1;
        this._performCursorZoom = false;
        // update condition is:
        // min(camera displacement, camera rotation in radians)^2 > EPS
        // using small-angle approximation cos(x/2) = 1 - x^2 / 8
        if (zoomChanged || this._lastPosition.distanceToSquared(this.object.position) > $db77f41475ae732a$var$_EPS || 8 * (1 - this._lastQuaternion.dot(this.object.quaternion)) > $db77f41475ae732a$var$_EPS || this._lastTargetPosition.distanceToSquared(this.target) > $db77f41475ae732a$var$_EPS) {
            this.dispatchEvent($db77f41475ae732a$var$_changeEvent);
            this._lastPosition.copy(this.object.position);
            this._lastQuaternion.copy(this.object.quaternion);
            this._lastTargetPosition.copy(this.target);
            return true;
        }
        return false;
    }
    _getAutoRotationAngle(deltaTime) {
        if (deltaTime !== null) return $db77f41475ae732a$var$_twoPI / 60 * this.autoRotateSpeed * deltaTime;
        else return $db77f41475ae732a$var$_twoPI / 60 / 60 * this.autoRotateSpeed;
    }
    _getZoomScale(delta) {
        const normalizedDelta = Math.abs(delta * 0.01);
        return Math.pow(0.95, this.zoomSpeed * normalizedDelta);
    }
    _rotateLeft(angle) {
        this._sphericalDelta.theta -= angle;
    }
    _rotateUp(angle) {
        this._sphericalDelta.phi -= angle;
    }
    _panLeft(distance, objectMatrix) {
        $db77f41475ae732a$var$_v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
        $db77f41475ae732a$var$_v.multiplyScalar(-distance);
        this._panOffset.add($db77f41475ae732a$var$_v);
    }
    _panUp(distance, objectMatrix) {
        if (this.screenSpacePanning === true) $db77f41475ae732a$var$_v.setFromMatrixColumn(objectMatrix, 1);
        else {
            $db77f41475ae732a$var$_v.setFromMatrixColumn(objectMatrix, 0);
            $db77f41475ae732a$var$_v.crossVectors(this.object.up, $db77f41475ae732a$var$_v);
        }
        $db77f41475ae732a$var$_v.multiplyScalar(distance);
        this._panOffset.add($db77f41475ae732a$var$_v);
    }
    // deltaX and deltaY are in pixels; right and down are positive
    _pan(deltaX, deltaY) {
        const element = this.domElement;
        if (this.object.isPerspectiveCamera) {
            // perspective
            const position = this.object.position;
            $db77f41475ae732a$var$_v.copy(position).sub(this.target);
            let targetDistance = $db77f41475ae732a$var$_v.length();
            // half of the fov is center to top of screen
            targetDistance *= Math.tan(this.object.fov / 2 * Math.PI / 180.0);
            // we use only clientHeight here so aspect ratio does not distort speed
            this._panLeft(2 * deltaX * targetDistance / element.clientHeight, this.object.matrix);
            this._panUp(2 * deltaY * targetDistance / element.clientHeight, this.object.matrix);
        } else if (this.object.isOrthographicCamera) {
            // orthographic
            this._panLeft(deltaX * (this.object.right - this.object.left) / this.object.zoom / element.clientWidth, this.object.matrix);
            this._panUp(deltaY * (this.object.top - this.object.bottom) / this.object.zoom / element.clientHeight, this.object.matrix);
        } else {
            // camera neither orthographic nor perspective
            console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
            this.enablePan = false;
        }
    }
    _dollyOut(dollyScale) {
        if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) this._scale /= dollyScale;
        else {
            console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
            this.enableZoom = false;
        }
    }
    _dollyIn(dollyScale) {
        if (this.object.isPerspectiveCamera || this.object.isOrthographicCamera) this._scale *= dollyScale;
        else {
            console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
            this.enableZoom = false;
        }
    }
    _updateZoomParameters(x, y) {
        if (!this.zoomToCursor) return;
        this._performCursorZoom = true;
        const rect = this.domElement.getBoundingClientRect();
        const dx = x - rect.left;
        const dy = y - rect.top;
        const w = rect.width;
        const h = rect.height;
        this._mouse.x = dx / w * 2 - 1;
        this._mouse.y = -(dy / h) * 2 + 1;
        this._dollyDirection.set(this._mouse.x, this._mouse.y, 1).unproject(this.object).sub(this.object.position).normalize();
    }
    _clampDistance(dist) {
        return Math.max(this.minDistance, Math.min(this.maxDistance, dist));
    }
    //
    // event callbacks - update the object state
    //
    _handleMouseDownRotate(event) {
        this._rotateStart.set(event.clientX, event.clientY);
    }
    _handleMouseDownDolly(event) {
        this._updateZoomParameters(event.clientX, event.clientX);
        this._dollyStart.set(event.clientX, event.clientY);
    }
    _handleMouseDownPan(event) {
        this._panStart.set(event.clientX, event.clientY);
    }
    _handleMouseMoveRotate(event) {
        this._rotateEnd.set(event.clientX, event.clientY);
        this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
        const element = this.domElement;
        this._rotateLeft($db77f41475ae732a$var$_twoPI * this._rotateDelta.x / element.clientHeight); // yes, height
        this._rotateUp($db77f41475ae732a$var$_twoPI * this._rotateDelta.y / element.clientHeight);
        this._rotateStart.copy(this._rotateEnd);
        this.update();
    }
    _handleMouseMoveDolly(event) {
        this._dollyEnd.set(event.clientX, event.clientY);
        this._dollyDelta.subVectors(this._dollyEnd, this._dollyStart);
        if (this._dollyDelta.y > 0) this._dollyOut(this._getZoomScale(this._dollyDelta.y));
        else if (this._dollyDelta.y < 0) this._dollyIn(this._getZoomScale(this._dollyDelta.y));
        this._dollyStart.copy(this._dollyEnd);
        this.update();
    }
    _handleMouseMovePan(event) {
        this._panEnd.set(event.clientX, event.clientY);
        this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
        this._pan(this._panDelta.x, this._panDelta.y);
        this._panStart.copy(this._panEnd);
        this.update();
    }
    _handleMouseWheel(event) {
        this._updateZoomParameters(event.clientX, event.clientY);
        if (event.deltaY < 0) this._dollyIn(this._getZoomScale(event.deltaY));
        else if (event.deltaY > 0) this._dollyOut(this._getZoomScale(event.deltaY));
        this.update();
    }
    _handleKeyDown(event) {
        let needsUpdate = false;
        switch(event.code){
            case this.keys.UP:
                if (event.ctrlKey || event.metaKey || event.shiftKey) {
                    if (this.enableRotate) this._rotateUp($db77f41475ae732a$var$_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
                } else if (this.enablePan) this._pan(0, this.keyPanSpeed);
                needsUpdate = true;
                break;
            case this.keys.BOTTOM:
                if (event.ctrlKey || event.metaKey || event.shiftKey) {
                    if (this.enableRotate) this._rotateUp(-$db77f41475ae732a$var$_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
                } else if (this.enablePan) this._pan(0, -this.keyPanSpeed);
                needsUpdate = true;
                break;
            case this.keys.LEFT:
                if (event.ctrlKey || event.metaKey || event.shiftKey) {
                    if (this.enableRotate) this._rotateLeft($db77f41475ae732a$var$_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
                } else if (this.enablePan) this._pan(this.keyPanSpeed, 0);
                needsUpdate = true;
                break;
            case this.keys.RIGHT:
                if (event.ctrlKey || event.metaKey || event.shiftKey) {
                    if (this.enableRotate) this._rotateLeft(-$db77f41475ae732a$var$_twoPI * this.keyRotateSpeed / this.domElement.clientHeight);
                } else if (this.enablePan) this._pan(-this.keyPanSpeed, 0);
                needsUpdate = true;
                break;
        }
        if (needsUpdate) {
            // prevent the browser from scrolling on cursor keys
            event.preventDefault();
            this.update();
        }
    }
    _handleTouchStartRotate(event) {
        if (this._pointers.length === 1) this._rotateStart.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._rotateStart.set(x, y);
        }
    }
    _handleTouchStartPan(event) {
        if (this._pointers.length === 1) this._panStart.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._panStart.set(x, y);
        }
    }
    _handleTouchStartDolly(event) {
        const position = this._getSecondPointerPosition(event);
        const dx = event.pageX - position.x;
        const dy = event.pageY - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        this._dollyStart.set(0, distance);
    }
    _handleTouchStartDollyPan(event) {
        if (this.enableZoom) this._handleTouchStartDolly(event);
        if (this.enablePan) this._handleTouchStartPan(event);
    }
    _handleTouchStartDollyRotate(event) {
        if (this.enableZoom) this._handleTouchStartDolly(event);
        if (this.enableRotate) this._handleTouchStartRotate(event);
    }
    _handleTouchMoveRotate(event) {
        if (this._pointers.length == 1) this._rotateEnd.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._rotateEnd.set(x, y);
        }
        this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
        const element = this.domElement;
        this._rotateLeft($db77f41475ae732a$var$_twoPI * this._rotateDelta.x / element.clientHeight); // yes, height
        this._rotateUp($db77f41475ae732a$var$_twoPI * this._rotateDelta.y / element.clientHeight);
        this._rotateStart.copy(this._rotateEnd);
    }
    _handleTouchMovePan(event) {
        if (this._pointers.length === 1) this._panEnd.set(event.pageX, event.pageY);
        else {
            const position = this._getSecondPointerPosition(event);
            const x = 0.5 * (event.pageX + position.x);
            const y = 0.5 * (event.pageY + position.y);
            this._panEnd.set(x, y);
        }
        this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed);
        this._pan(this._panDelta.x, this._panDelta.y);
        this._panStart.copy(this._panEnd);
    }
    _handleTouchMoveDolly(event) {
        const position = this._getSecondPointerPosition(event);
        const dx = event.pageX - position.x;
        const dy = event.pageY - position.y;
        const distance = Math.sqrt(dx * dx + dy * dy);
        this._dollyEnd.set(0, distance);
        this._dollyDelta.set(0, Math.pow(this._dollyEnd.y / this._dollyStart.y, this.zoomSpeed));
        this._dollyOut(this._dollyDelta.y);
        this._dollyStart.copy(this._dollyEnd);
        const centerX = (event.pageX + position.x) * 0.5;
        const centerY = (event.pageY + position.y) * 0.5;
        this._updateZoomParameters(centerX, centerY);
    }
    _handleTouchMoveDollyPan(event) {
        if (this.enableZoom) this._handleTouchMoveDolly(event);
        if (this.enablePan) this._handleTouchMovePan(event);
    }
    _handleTouchMoveDollyRotate(event) {
        if (this.enableZoom) this._handleTouchMoveDolly(event);
        if (this.enableRotate) this._handleTouchMoveRotate(event);
    }
    // pointers
    _addPointer(event) {
        this._pointers.push(event.pointerId);
    }
    _removePointer(event) {
        delete this._pointerPositions[event.pointerId];
        for(let i = 0; i < this._pointers.length; i++)if (this._pointers[i] == event.pointerId) {
            this._pointers.splice(i, 1);
            return;
        }
    }
    _isTrackingPointer(event) {
        for(let i = 0; i < this._pointers.length; i++){
            if (this._pointers[i] == event.pointerId) return true;
        }
        return false;
    }
    _trackPointer(event) {
        let position = this._pointerPositions[event.pointerId];
        if (position === undefined) {
            position = new (0, $ee56638efea8544d$export$c977b3e384af9ae1)();
            this._pointerPositions[event.pointerId] = position;
        }
        position.set(event.pageX, event.pageY);
    }
    _getSecondPointerPosition(event) {
        const pointerId = event.pointerId === this._pointers[0] ? this._pointers[1] : this._pointers[0];
        return this._pointerPositions[pointerId];
    }
    //
    _customWheelEvent(event) {
        const mode = event.deltaMode;
        // minimal wheel event altered to meet delta-zoom demand
        const newEvent = {
            clientX: event.clientX,
            clientY: event.clientY,
            deltaY: event.deltaY
        };
        switch(mode){
            case 1:
                newEvent.deltaY *= 16;
                break;
            case 2:
                newEvent.deltaY *= 100;
                break;
        }
        // detect if event was triggered by pinching
        if (event.ctrlKey && !this._controlActive) newEvent.deltaY *= 10;
        return newEvent;
    }
}
function $db77f41475ae732a$var$onPointerDown(event) {
    if (this.enabled === false) return;
    if (this._pointers.length === 0) {
        this.domElement.setPointerCapture(event.pointerId);
        this.domElement.addEventListener('pointermove', this._onPointerMove);
        this.domElement.addEventListener('pointerup', this._onPointerUp);
    }
    //
    if (this._isTrackingPointer(event)) return;
    //
    this._addPointer(event);
    if (event.pointerType === 'touch') this._onTouchStart(event);
    else this._onMouseDown(event);
}
function $db77f41475ae732a$var$onPointerMove(event) {
    if (this.enabled === false) return;
    if (event.pointerType === 'touch') this._onTouchMove(event);
    else this._onMouseMove(event);
}
function $db77f41475ae732a$var$onPointerUp(event) {
    this._removePointer(event);
    switch(this._pointers.length){
        case 0:
            this.domElement.releasePointerCapture(event.pointerId);
            this.domElement.removeEventListener('pointermove', this._onPointerMove);
            this.domElement.removeEventListener('pointerup', this._onPointerUp);
            this.dispatchEvent($db77f41475ae732a$var$_endEvent);
            this.state = $db77f41475ae732a$var$_STATE.NONE;
            break;
        case 1:
            const pointerId = this._pointers[0];
            const position = this._pointerPositions[pointerId];
            // minimal placeholder event - allows state correction on pointer-up
            this._onTouchStart({
                pointerId: pointerId,
                pageX: position.x,
                pageY: position.y
            });
            break;
    }
}
function $db77f41475ae732a$var$onMouseDown(event) {
    let mouseAction;
    switch(event.button){
        case 0:
            mouseAction = this.mouseButtons.LEFT;
            break;
        case 1:
            mouseAction = this.mouseButtons.MIDDLE;
            break;
        case 2:
            mouseAction = this.mouseButtons.RIGHT;
            break;
        default:
            mouseAction = -1;
    }
    switch(mouseAction){
        case (0, $ee56638efea8544d$export$7177b3e430c2d7ca).DOLLY:
            if (this.enableZoom === false) return;
            this._handleMouseDownDolly(event);
            this.state = $db77f41475ae732a$var$_STATE.DOLLY;
            break;
        case (0, $ee56638efea8544d$export$7177b3e430c2d7ca).ROTATE:
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
                if (this.enablePan === false) return;
                this._handleMouseDownPan(event);
                this.state = $db77f41475ae732a$var$_STATE.PAN;
            } else {
                if (this.enableRotate === false) return;
                this._handleMouseDownRotate(event);
                this.state = $db77f41475ae732a$var$_STATE.ROTATE;
            }
            break;
        case (0, $ee56638efea8544d$export$7177b3e430c2d7ca).PAN:
            if (event.ctrlKey || event.metaKey || event.shiftKey) {
                if (this.enableRotate === false) return;
                this._handleMouseDownRotate(event);
                this.state = $db77f41475ae732a$var$_STATE.ROTATE;
            } else {
                if (this.enablePan === false) return;
                this._handleMouseDownPan(event);
                this.state = $db77f41475ae732a$var$_STATE.PAN;
            }
            break;
        default:
            this.state = $db77f41475ae732a$var$_STATE.NONE;
    }
    if (this.state !== $db77f41475ae732a$var$_STATE.NONE) this.dispatchEvent($db77f41475ae732a$var$_startEvent);
}
function $db77f41475ae732a$var$onMouseMove(event) {
    switch(this.state){
        case $db77f41475ae732a$var$_STATE.ROTATE:
            if (this.enableRotate === false) return;
            this._handleMouseMoveRotate(event);
            break;
        case $db77f41475ae732a$var$_STATE.DOLLY:
            if (this.enableZoom === false) return;
            this._handleMouseMoveDolly(event);
            break;
        case $db77f41475ae732a$var$_STATE.PAN:
            if (this.enablePan === false) return;
            this._handleMouseMovePan(event);
            break;
    }
}
function $db77f41475ae732a$var$onMouseWheel(event) {
    if (this.enabled === false || this.enableZoom === false || this.state !== $db77f41475ae732a$var$_STATE.NONE) return;
    event.preventDefault();
    this.dispatchEvent($db77f41475ae732a$var$_startEvent);
    this._handleMouseWheel(this._customWheelEvent(event));
    this.dispatchEvent($db77f41475ae732a$var$_endEvent);
}
function $db77f41475ae732a$var$onKeyDown(event) {
    if (this.enabled === false) return;
    this._handleKeyDown(event);
}
function $db77f41475ae732a$var$onTouchStart(event) {
    this._trackPointer(event);
    switch(this._pointers.length){
        case 1:
            switch(this.touches.ONE){
                case (0, $ee56638efea8544d$export$d46bd3ead7cc759b).ROTATE:
                    if (this.enableRotate === false) return;
                    this._handleTouchStartRotate(event);
                    this.state = $db77f41475ae732a$var$_STATE.TOUCH_ROTATE;
                    break;
                case (0, $ee56638efea8544d$export$d46bd3ead7cc759b).PAN:
                    if (this.enablePan === false) return;
                    this._handleTouchStartPan(event);
                    this.state = $db77f41475ae732a$var$_STATE.TOUCH_PAN;
                    break;
                default:
                    this.state = $db77f41475ae732a$var$_STATE.NONE;
            }
            break;
        case 2:
            switch(this.touches.TWO){
                case (0, $ee56638efea8544d$export$d46bd3ead7cc759b).DOLLY_PAN:
                    if (this.enableZoom === false && this.enablePan === false) return;
                    this._handleTouchStartDollyPan(event);
                    this.state = $db77f41475ae732a$var$_STATE.TOUCH_DOLLY_PAN;
                    break;
                case (0, $ee56638efea8544d$export$d46bd3ead7cc759b).DOLLY_ROTATE:
                    if (this.enableZoom === false && this.enableRotate === false) return;
                    this._handleTouchStartDollyRotate(event);
                    this.state = $db77f41475ae732a$var$_STATE.TOUCH_DOLLY_ROTATE;
                    break;
                default:
                    this.state = $db77f41475ae732a$var$_STATE.NONE;
            }
            break;
        default:
            this.state = $db77f41475ae732a$var$_STATE.NONE;
    }
    if (this.state !== $db77f41475ae732a$var$_STATE.NONE) this.dispatchEvent($db77f41475ae732a$var$_startEvent);
}
function $db77f41475ae732a$var$onTouchMove(event) {
    this._trackPointer(event);
    switch(this.state){
        case $db77f41475ae732a$var$_STATE.TOUCH_ROTATE:
            if (this.enableRotate === false) return;
            this._handleTouchMoveRotate(event);
            this.update();
            break;
        case $db77f41475ae732a$var$_STATE.TOUCH_PAN:
            if (this.enablePan === false) return;
            this._handleTouchMovePan(event);
            this.update();
            break;
        case $db77f41475ae732a$var$_STATE.TOUCH_DOLLY_PAN:
            if (this.enableZoom === false && this.enablePan === false) return;
            this._handleTouchMoveDollyPan(event);
            this.update();
            break;
        case $db77f41475ae732a$var$_STATE.TOUCH_DOLLY_ROTATE:
            if (this.enableZoom === false && this.enableRotate === false) return;
            this._handleTouchMoveDollyRotate(event);
            this.update();
            break;
        default:
            this.state = $db77f41475ae732a$var$_STATE.NONE;
    }
}
function $db77f41475ae732a$var$onContextMenu(event) {
    if (this.enabled === false) return;
    event.preventDefault();
}
function $db77f41475ae732a$var$interceptControlDown(event) {
    if (event.key === 'Control') {
        this._controlActive = true;
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.addEventListener('keyup', this._interceptControlUp, {
            passive: true,
            capture: true
        });
    }
}
function $db77f41475ae732a$var$interceptControlUp(event) {
    if (event.key === 'Control') {
        this._controlActive = false;
        const document = this.domElement.getRootNode(); // offscreen canvas compatibility
        document.removeEventListener('keyup', this._interceptControlUp, {
            passive: true,
            capture: true
        });
    }
}




var $3a6a618a8ab498ec$var$Stats = function() {
    var mode = 0;
    var container = document.createElement('div');
    container.style.cssText = 'position:fixed;top:0;left:0;cursor:pointer;opacity:0.9;z-index:10000';
    container.addEventListener('click', function(event) {
        event.preventDefault();
        showPanel(++mode % container.children.length);
    }, false);
    //
    function addPanel(panel) {
        container.appendChild(panel.dom);
        return panel;
    }
    function showPanel(id) {
        for(var i = 0; i < container.children.length; i++)container.children[i].style.display = i === id ? 'block' : 'none';
        mode = id;
    }
    //
    var beginTime = (performance || Date).now(), prevTime = beginTime, frames = 0;
    var fpsPanel = addPanel(new $3a6a618a8ab498ec$var$Stats.Panel('FPS', '#0ff', '#002'));
    var msPanel = addPanel(new $3a6a618a8ab498ec$var$Stats.Panel('MS', '#0f0', '#020'));
    if (self.performance && self.performance.memory) var memPanel = addPanel(new $3a6a618a8ab498ec$var$Stats.Panel('MB', '#f08', '#201'));
    showPanel(0);
    return {
        REVISION: 16,
        dom: container,
        addPanel: addPanel,
        showPanel: showPanel,
        begin: function() {
            beginTime = (performance || Date).now();
        },
        end: function() {
            frames++;
            var time = (performance || Date).now();
            msPanel.update(time - beginTime, 200);
            if (time >= prevTime + 1000) {
                fpsPanel.update(frames * 1000 / (time - prevTime), 100);
                prevTime = time;
                frames = 0;
                if (memPanel) {
                    var memory = performance.memory;
                    memPanel.update(memory.usedJSHeapSize / 1048576, memory.jsHeapSizeLimit / 1048576);
                }
            }
            return time;
        },
        update: function() {
            beginTime = this.end();
        },
        // Backwards Compatibility
        domElement: container,
        setMode: showPanel
    };
};
$3a6a618a8ab498ec$var$Stats.Panel = function(name, fg, bg) {
    var min = Infinity, max = 0, round = Math.round;
    var PR = round(window.devicePixelRatio || 1);
    var WIDTH = 80 * PR, HEIGHT = 48 * PR, TEXT_X = 3 * PR, TEXT_Y = 2 * PR, GRAPH_X = 3 * PR, GRAPH_Y = 15 * PR, GRAPH_WIDTH = 74 * PR, GRAPH_HEIGHT = 30 * PR;
    var canvas = document.createElement('canvas');
    canvas.width = WIDTH;
    canvas.height = HEIGHT;
    canvas.style.cssText = 'width:80px;height:48px';
    var context = canvas.getContext('2d');
    context.font = 'bold ' + 9 * PR + 'px Helvetica,Arial,sans-serif';
    context.textBaseline = 'top';
    context.fillStyle = bg;
    context.fillRect(0, 0, WIDTH, HEIGHT);
    context.fillStyle = fg;
    context.fillText(name, TEXT_X, TEXT_Y);
    context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);
    context.fillStyle = bg;
    context.globalAlpha = 0.9;
    context.fillRect(GRAPH_X, GRAPH_Y, GRAPH_WIDTH, GRAPH_HEIGHT);
    return {
        dom: canvas,
        update: function(value, maxValue) {
            min = Math.min(min, value);
            max = Math.max(max, value);
            context.fillStyle = bg;
            context.globalAlpha = 1;
            context.fillRect(0, 0, WIDTH, GRAPH_Y);
            context.fillStyle = fg;
            context.fillText(round(value) + ' ' + name + ' (' + round(min) + '-' + round(max) + ')', TEXT_X, TEXT_Y);
            context.drawImage(canvas, GRAPH_X + PR, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT, GRAPH_X, GRAPH_Y, GRAPH_WIDTH - PR, GRAPH_HEIGHT);
            context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, GRAPH_HEIGHT);
            context.fillStyle = bg;
            context.globalAlpha = 0.9;
            context.fillRect(GRAPH_X + GRAPH_WIDTH - PR, GRAPH_Y, PR, round((1 - value / maxValue) * GRAPH_HEIGHT));
        }
    };
};
var $3a6a618a8ab498ec$export$2e2bcd8739ae039 = $3a6a618a8ab498ec$var$Stats;


/**
 * dat-gui JavaScript Controller Library
 * https://github.com/dataarts/dat.gui
 *
 * Copyright 2011 Data Arts Team, Google Creative Lab
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $116652c03be0baae$var$___$insertStyle(css) {
    if (!css) return;
    if (typeof window === 'undefined') return;
    var style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}
function $116652c03be0baae$var$colorToString(color, forceCSSHex) {
    var colorFormat = color.__state.conversionName.toString();
    var r = Math.round(color.r);
    var g = Math.round(color.g);
    var b = Math.round(color.b);
    var a = color.a;
    var h = Math.round(color.h);
    var s = color.s.toFixed(1);
    var v = color.v.toFixed(1);
    if (forceCSSHex || colorFormat === 'THREE_CHAR_HEX' || colorFormat === 'SIX_CHAR_HEX') {
        var str = color.hex.toString(16);
        while(str.length < 6)str = '0' + str;
        return '#' + str;
    } else if (colorFormat === 'CSS_RGB') return 'rgb(' + r + ',' + g + ',' + b + ')';
    else if (colorFormat === 'CSS_RGBA') return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
    else if (colorFormat === 'HEX') return '0x' + color.hex.toString(16);
    else if (colorFormat === 'RGB_ARRAY') return '[' + r + ',' + g + ',' + b + ']';
    else if (colorFormat === 'RGBA_ARRAY') return '[' + r + ',' + g + ',' + b + ',' + a + ']';
    else if (colorFormat === 'RGB_OBJ') return '{r:' + r + ',g:' + g + ',b:' + b + '}';
    else if (colorFormat === 'RGBA_OBJ') return '{r:' + r + ',g:' + g + ',b:' + b + ',a:' + a + '}';
    else if (colorFormat === 'HSV_OBJ') return '{h:' + h + ',s:' + s + ',v:' + v + '}';
    else if (colorFormat === 'HSVA_OBJ') return '{h:' + h + ',s:' + s + ',v:' + v + ',a:' + a + '}';
    return 'unknown format';
}
var $116652c03be0baae$var$ARR_EACH = Array.prototype.forEach;
var $116652c03be0baae$var$ARR_SLICE = Array.prototype.slice;
var $116652c03be0baae$var$Common = {
    BREAK: {},
    extend: function extend(target) {
        this.each($116652c03be0baae$var$ARR_SLICE.call(arguments, 1), function(obj) {
            var keys = this.isObject(obj) ? Object.keys(obj) : [];
            keys.forEach((function(key) {
                if (!this.isUndefined(obj[key])) target[key] = obj[key];
            }).bind(this));
        }, this);
        return target;
    },
    defaults: function defaults(target) {
        this.each($116652c03be0baae$var$ARR_SLICE.call(arguments, 1), function(obj) {
            var keys = this.isObject(obj) ? Object.keys(obj) : [];
            keys.forEach((function(key) {
                if (this.isUndefined(target[key])) target[key] = obj[key];
            }).bind(this));
        }, this);
        return target;
    },
    compose: function compose() {
        var toCall = $116652c03be0baae$var$ARR_SLICE.call(arguments);
        return function() {
            var args = $116652c03be0baae$var$ARR_SLICE.call(arguments);
            for(var i = toCall.length - 1; i >= 0; i--)args = [
                toCall[i].apply(this, args)
            ];
            return args[0];
        };
    },
    each: function each(obj, itr, scope) {
        if (!obj) return;
        if ($116652c03be0baae$var$ARR_EACH && obj.forEach && obj.forEach === $116652c03be0baae$var$ARR_EACH) obj.forEach(itr, scope);
        else if (obj.length === obj.length + 0) {
            var key = void 0;
            var l = void 0;
            for(key = 0, l = obj.length; key < l; key++){
                if (key in obj && itr.call(scope, obj[key], key) === this.BREAK) return;
            }
        } else for(var _key in obj){
            if (itr.call(scope, obj[_key], _key) === this.BREAK) return;
        }
    },
    defer: function defer(fnc) {
        setTimeout(fnc, 0);
    },
    debounce: function debounce(func, threshold, callImmediately) {
        var timeout = void 0;
        return function() {
            var obj = this;
            var args = arguments;
            function delayed() {
                timeout = null;
                if (!callImmediately) func.apply(obj, args);
            }
            var callNow = callImmediately || !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(delayed, threshold);
            if (callNow) func.apply(obj, args);
        };
    },
    toArray: function toArray(obj) {
        if (obj.toArray) return obj.toArray();
        return $116652c03be0baae$var$ARR_SLICE.call(obj);
    },
    isUndefined: function isUndefined(obj) {
        return obj === undefined;
    },
    isNull: function isNull(obj) {
        return obj === null;
    },
    isNaN: function(_isNaN) {
        function isNaN1(_x) {
            return _isNaN.apply(this, arguments);
        }
        isNaN1.toString = function() {
            return _isNaN.toString();
        };
        return isNaN1;
    }(function(obj) {
        return isNaN(obj);
    }),
    isArray: Array.isArray || function(obj) {
        return obj.constructor === Array;
    },
    isObject: function isObject(obj) {
        return obj === Object(obj);
    },
    isNumber: function isNumber(obj) {
        return obj === obj + 0;
    },
    isString: function isString(obj) {
        return obj === obj + '';
    },
    isBoolean: function isBoolean(obj) {
        return obj === false || obj === true;
    },
    isFunction: function isFunction(obj) {
        return obj instanceof Function;
    }
};
var $116652c03be0baae$var$INTERPRETATIONS = [
    {
        litmus: $116652c03be0baae$var$Common.isString,
        conversions: {
            THREE_CHAR_HEX: {
                read: function read(original) {
                    var test = original.match(/^#([A-F0-9])([A-F0-9])([A-F0-9])$/i);
                    if (test === null) return false;
                    return {
                        space: 'HEX',
                        hex: parseInt('0x' + test[1].toString() + test[1].toString() + test[2].toString() + test[2].toString() + test[3].toString() + test[3].toString(), 0)
                    };
                },
                write: $116652c03be0baae$var$colorToString
            },
            SIX_CHAR_HEX: {
                read: function read(original) {
                    var test = original.match(/^#([A-F0-9]{6})$/i);
                    if (test === null) return false;
                    return {
                        space: 'HEX',
                        hex: parseInt('0x' + test[1].toString(), 0)
                    };
                },
                write: $116652c03be0baae$var$colorToString
            },
            CSS_RGB: {
                read: function read(original) {
                    var test = original.match(/^rgb\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
                    if (test === null) return false;
                    return {
                        space: 'RGB',
                        r: parseFloat(test[1]),
                        g: parseFloat(test[2]),
                        b: parseFloat(test[3])
                    };
                },
                write: $116652c03be0baae$var$colorToString
            },
            CSS_RGBA: {
                read: function read(original) {
                    var test = original.match(/^rgba\(\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*,\s*(\S+)\s*\)/);
                    if (test === null) return false;
                    return {
                        space: 'RGB',
                        r: parseFloat(test[1]),
                        g: parseFloat(test[2]),
                        b: parseFloat(test[3]),
                        a: parseFloat(test[4])
                    };
                },
                write: $116652c03be0baae$var$colorToString
            }
        }
    },
    {
        litmus: $116652c03be0baae$var$Common.isNumber,
        conversions: {
            HEX: {
                read: function read(original) {
                    return {
                        space: 'HEX',
                        hex: original,
                        conversionName: 'HEX'
                    };
                },
                write: function write(color) {
                    return color.hex;
                }
            }
        }
    },
    {
        litmus: $116652c03be0baae$var$Common.isArray,
        conversions: {
            RGB_ARRAY: {
                read: function read(original) {
                    if (original.length !== 3) return false;
                    return {
                        space: 'RGB',
                        r: original[0],
                        g: original[1],
                        b: original[2]
                    };
                },
                write: function write(color) {
                    return [
                        color.r,
                        color.g,
                        color.b
                    ];
                }
            },
            RGBA_ARRAY: {
                read: function read(original) {
                    if (original.length !== 4) return false;
                    return {
                        space: 'RGB',
                        r: original[0],
                        g: original[1],
                        b: original[2],
                        a: original[3]
                    };
                },
                write: function write(color) {
                    return [
                        color.r,
                        color.g,
                        color.b,
                        color.a
                    ];
                }
            }
        }
    },
    {
        litmus: $116652c03be0baae$var$Common.isObject,
        conversions: {
            RGBA_OBJ: {
                read: function read(original) {
                    if ($116652c03be0baae$var$Common.isNumber(original.r) && $116652c03be0baae$var$Common.isNumber(original.g) && $116652c03be0baae$var$Common.isNumber(original.b) && $116652c03be0baae$var$Common.isNumber(original.a)) return {
                        space: 'RGB',
                        r: original.r,
                        g: original.g,
                        b: original.b,
                        a: original.a
                    };
                    return false;
                },
                write: function write(color) {
                    return {
                        r: color.r,
                        g: color.g,
                        b: color.b,
                        a: color.a
                    };
                }
            },
            RGB_OBJ: {
                read: function read(original) {
                    if ($116652c03be0baae$var$Common.isNumber(original.r) && $116652c03be0baae$var$Common.isNumber(original.g) && $116652c03be0baae$var$Common.isNumber(original.b)) return {
                        space: 'RGB',
                        r: original.r,
                        g: original.g,
                        b: original.b
                    };
                    return false;
                },
                write: function write(color) {
                    return {
                        r: color.r,
                        g: color.g,
                        b: color.b
                    };
                }
            },
            HSVA_OBJ: {
                read: function read(original) {
                    if ($116652c03be0baae$var$Common.isNumber(original.h) && $116652c03be0baae$var$Common.isNumber(original.s) && $116652c03be0baae$var$Common.isNumber(original.v) && $116652c03be0baae$var$Common.isNumber(original.a)) return {
                        space: 'HSV',
                        h: original.h,
                        s: original.s,
                        v: original.v,
                        a: original.a
                    };
                    return false;
                },
                write: function write(color) {
                    return {
                        h: color.h,
                        s: color.s,
                        v: color.v,
                        a: color.a
                    };
                }
            },
            HSV_OBJ: {
                read: function read(original) {
                    if ($116652c03be0baae$var$Common.isNumber(original.h) && $116652c03be0baae$var$Common.isNumber(original.s) && $116652c03be0baae$var$Common.isNumber(original.v)) return {
                        space: 'HSV',
                        h: original.h,
                        s: original.s,
                        v: original.v
                    };
                    return false;
                },
                write: function write(color) {
                    return {
                        h: color.h,
                        s: color.s,
                        v: color.v
                    };
                }
            }
        }
    }
];
var $116652c03be0baae$var$result = void 0;
var $116652c03be0baae$var$toReturn = void 0;
var $116652c03be0baae$var$interpret = function interpret() {
    $116652c03be0baae$var$toReturn = false;
    var original = arguments.length > 1 ? $116652c03be0baae$var$Common.toArray(arguments) : arguments[0];
    $116652c03be0baae$var$Common.each($116652c03be0baae$var$INTERPRETATIONS, function(family) {
        if (family.litmus(original)) {
            $116652c03be0baae$var$Common.each(family.conversions, function(conversion, conversionName) {
                $116652c03be0baae$var$result = conversion.read(original);
                if ($116652c03be0baae$var$toReturn === false && $116652c03be0baae$var$result !== false) {
                    $116652c03be0baae$var$toReturn = $116652c03be0baae$var$result;
                    $116652c03be0baae$var$result.conversionName = conversionName;
                    $116652c03be0baae$var$result.conversion = conversion;
                    return $116652c03be0baae$var$Common.BREAK;
                }
            });
            return $116652c03be0baae$var$Common.BREAK;
        }
    });
    return $116652c03be0baae$var$toReturn;
};
var $116652c03be0baae$var$tmpComponent = void 0;
var $116652c03be0baae$var$ColorMath = {
    hsv_to_rgb: function hsv_to_rgb(h, s, v) {
        var hi = Math.floor(h / 60) % 6;
        var f = h / 60 - Math.floor(h / 60);
        var p = v * (1.0 - s);
        var q = v * (1.0 - f * s);
        var t = v * (1.0 - (1.0 - f) * s);
        var c = [
            [
                v,
                t,
                p
            ],
            [
                q,
                v,
                p
            ],
            [
                p,
                v,
                t
            ],
            [
                p,
                q,
                v
            ],
            [
                t,
                p,
                v
            ],
            [
                v,
                p,
                q
            ]
        ][hi];
        return {
            r: c[0] * 255,
            g: c[1] * 255,
            b: c[2] * 255
        };
    },
    rgb_to_hsv: function rgb_to_hsv(r, g, b) {
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var delta = max - min;
        var h = void 0;
        var s = void 0;
        if (max !== 0) s = delta / max;
        else return {
            h: NaN,
            s: 0,
            v: 0
        };
        if (r === max) h = (g - b) / delta;
        else if (g === max) h = 2 + (b - r) / delta;
        else h = 4 + (r - g) / delta;
        h /= 6;
        if (h < 0) h += 1;
        return {
            h: h * 360,
            s: s,
            v: max / 255
        };
    },
    rgb_to_hex: function rgb_to_hex(r, g, b) {
        var hex = this.hex_with_component(0, 2, r);
        hex = this.hex_with_component(hex, 1, g);
        hex = this.hex_with_component(hex, 0, b);
        return hex;
    },
    component_from_hex: function component_from_hex(hex, componentIndex) {
        return hex >> componentIndex * 8 & 0xFF;
    },
    hex_with_component: function hex_with_component(hex, componentIndex, value) {
        return value << ($116652c03be0baae$var$tmpComponent = componentIndex * 8) | hex & ~(0xFF << $116652c03be0baae$var$tmpComponent);
    }
};
var $116652c03be0baae$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $116652c03be0baae$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $116652c03be0baae$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $116652c03be0baae$var$get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);
    if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);
        if (parent === null) return undefined;
        else return get(parent, property, receiver);
    } else if ("value" in desc) return desc.value;
    else {
        var getter = desc.get;
        if (getter === undefined) return undefined;
        return getter.call(receiver);
    }
};
var $116652c03be0baae$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $116652c03be0baae$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $116652c03be0baae$var$Color = function() {
    function Color() {
        $116652c03be0baae$var$classCallCheck(this, Color);
        this.__state = $116652c03be0baae$var$interpret.apply(this, arguments);
        if (this.__state === false) throw new Error('Failed to interpret color arguments');
        this.__state.a = this.__state.a || 1;
    }
    $116652c03be0baae$var$createClass(Color, [
        {
            key: 'toString',
            value: function toString() {
                return $116652c03be0baae$var$colorToString(this);
            }
        },
        {
            key: 'toHexString',
            value: function toHexString() {
                return $116652c03be0baae$var$colorToString(this, true);
            }
        },
        {
            key: 'toOriginal',
            value: function toOriginal() {
                return this.__state.conversion.write(this);
            }
        }
    ]);
    return Color;
}();
function $116652c03be0baae$var$defineRGBComponent(target, component, componentHexIndex) {
    Object.defineProperty(target, component, {
        get: function get$$1() {
            if (this.__state.space === 'RGB') return this.__state[component];
            $116652c03be0baae$var$Color.recalculateRGB(this, component, componentHexIndex);
            return this.__state[component];
        },
        set: function set$$1(v) {
            if (this.__state.space !== 'RGB') {
                $116652c03be0baae$var$Color.recalculateRGB(this, component, componentHexIndex);
                this.__state.space = 'RGB';
            }
            this.__state[component] = v;
        }
    });
}
function $116652c03be0baae$var$defineHSVComponent(target, component) {
    Object.defineProperty(target, component, {
        get: function get$$1() {
            if (this.__state.space === 'HSV') return this.__state[component];
            $116652c03be0baae$var$Color.recalculateHSV(this);
            return this.__state[component];
        },
        set: function set$$1(v) {
            if (this.__state.space !== 'HSV') {
                $116652c03be0baae$var$Color.recalculateHSV(this);
                this.__state.space = 'HSV';
            }
            this.__state[component] = v;
        }
    });
}
$116652c03be0baae$var$Color.recalculateRGB = function(color, component, componentHexIndex) {
    if (color.__state.space === 'HEX') color.__state[component] = $116652c03be0baae$var$ColorMath.component_from_hex(color.__state.hex, componentHexIndex);
    else if (color.__state.space === 'HSV') $116652c03be0baae$var$Common.extend(color.__state, $116652c03be0baae$var$ColorMath.hsv_to_rgb(color.__state.h, color.__state.s, color.__state.v));
    else throw new Error('Corrupted color state');
};
$116652c03be0baae$var$Color.recalculateHSV = function(color) {
    var result = $116652c03be0baae$var$ColorMath.rgb_to_hsv(color.r, color.g, color.b);
    $116652c03be0baae$var$Common.extend(color.__state, {
        s: result.s,
        v: result.v
    });
    if (!$116652c03be0baae$var$Common.isNaN(result.h)) color.__state.h = result.h;
    else if ($116652c03be0baae$var$Common.isUndefined(color.__state.h)) color.__state.h = 0;
};
$116652c03be0baae$var$Color.COMPONENTS = [
    'r',
    'g',
    'b',
    'h',
    's',
    'v',
    'hex',
    'a'
];
$116652c03be0baae$var$defineRGBComponent($116652c03be0baae$var$Color.prototype, 'r', 2);
$116652c03be0baae$var$defineRGBComponent($116652c03be0baae$var$Color.prototype, 'g', 1);
$116652c03be0baae$var$defineRGBComponent($116652c03be0baae$var$Color.prototype, 'b', 0);
$116652c03be0baae$var$defineHSVComponent($116652c03be0baae$var$Color.prototype, 'h');
$116652c03be0baae$var$defineHSVComponent($116652c03be0baae$var$Color.prototype, 's');
$116652c03be0baae$var$defineHSVComponent($116652c03be0baae$var$Color.prototype, 'v');
Object.defineProperty($116652c03be0baae$var$Color.prototype, 'a', {
    get: function get$$1() {
        return this.__state.a;
    },
    set: function set$$1(v) {
        this.__state.a = v;
    }
});
Object.defineProperty($116652c03be0baae$var$Color.prototype, 'hex', {
    get: function get$$1() {
        if (this.__state.space !== 'HEX') {
            this.__state.hex = $116652c03be0baae$var$ColorMath.rgb_to_hex(this.r, this.g, this.b);
            this.__state.space = 'HEX';
        }
        return this.__state.hex;
    },
    set: function set$$1(v) {
        this.__state.space = 'HEX';
        this.__state.hex = v;
    }
});
var $116652c03be0baae$var$Controller = function() {
    function Controller(object, property) {
        $116652c03be0baae$var$classCallCheck(this, Controller);
        this.initialValue = object[property];
        this.domElement = document.createElement('div');
        this.object = object;
        this.property = property;
        this.__onChange = undefined;
        this.__onFinishChange = undefined;
    }
    $116652c03be0baae$var$createClass(Controller, [
        {
            key: 'onChange',
            value: function onChange(fnc) {
                this.__onChange = fnc;
                return this;
            }
        },
        {
            key: 'onFinishChange',
            value: function onFinishChange(fnc) {
                this.__onFinishChange = fnc;
                return this;
            }
        },
        {
            key: 'setValue',
            value: function setValue(newValue) {
                this.object[this.property] = newValue;
                if (this.__onChange) this.__onChange.call(this, newValue);
                this.updateDisplay();
                return this;
            }
        },
        {
            key: 'getValue',
            value: function getValue() {
                return this.object[this.property];
            }
        },
        {
            key: 'updateDisplay',
            value: function updateDisplay() {
                return this;
            }
        },
        {
            key: 'isModified',
            value: function isModified() {
                return this.initialValue !== this.getValue();
            }
        }
    ]);
    return Controller;
}();
var $116652c03be0baae$var$EVENT_MAP = {
    HTMLEvents: [
        'change'
    ],
    MouseEvents: [
        'click',
        'mousemove',
        'mousedown',
        'mouseup',
        'mouseover'
    ],
    KeyboardEvents: [
        'keydown'
    ]
};
var $116652c03be0baae$var$EVENT_MAP_INV = {};
$116652c03be0baae$var$Common.each($116652c03be0baae$var$EVENT_MAP, function(v, k) {
    $116652c03be0baae$var$Common.each(v, function(e) {
        $116652c03be0baae$var$EVENT_MAP_INV[e] = k;
    });
});
var $116652c03be0baae$var$CSS_VALUE_PIXELS = /(\d+(\.\d+)?)px/;
function $116652c03be0baae$var$cssValueToPixels(val) {
    if (val === '0' || $116652c03be0baae$var$Common.isUndefined(val)) return 0;
    var match = val.match($116652c03be0baae$var$CSS_VALUE_PIXELS);
    if (!$116652c03be0baae$var$Common.isNull(match)) return parseFloat(match[1]);
    return 0;
}
var $116652c03be0baae$var$dom = {
    makeSelectable: function makeSelectable(elem, selectable) {
        if (elem === undefined || elem.style === undefined) return;
        elem.onselectstart = selectable ? function() {
            return false;
        } : function() {};
        elem.style.MozUserSelect = selectable ? 'auto' : 'none';
        elem.style.KhtmlUserSelect = selectable ? 'auto' : 'none';
        elem.unselectable = selectable ? 'on' : 'off';
    },
    makeFullscreen: function makeFullscreen(elem, hor, vert) {
        var vertical = vert;
        var horizontal = hor;
        if ($116652c03be0baae$var$Common.isUndefined(horizontal)) horizontal = true;
        if ($116652c03be0baae$var$Common.isUndefined(vertical)) vertical = true;
        elem.style.position = 'absolute';
        if (horizontal) {
            elem.style.left = 0;
            elem.style.right = 0;
        }
        if (vertical) {
            elem.style.top = 0;
            elem.style.bottom = 0;
        }
    },
    fakeEvent: function fakeEvent(elem, eventType, pars, aux) {
        var params = pars || {};
        var className = $116652c03be0baae$var$EVENT_MAP_INV[eventType];
        if (!className) throw new Error('Event type ' + eventType + ' not supported.');
        var evt = document.createEvent(className);
        switch(className){
            case 'MouseEvents':
                var clientX = params.x || params.clientX || 0;
                var clientY = params.y || params.clientY || 0;
                evt.initMouseEvent(eventType, params.bubbles || false, params.cancelable || true, window, params.clickCount || 1, 0, 0, clientX, clientY, false, false, false, false, 0, null);
                break;
            case 'KeyboardEvents':
                var init = evt.initKeyboardEvent || evt.initKeyEvent;
                $116652c03be0baae$var$Common.defaults(params, {
                    cancelable: true,
                    ctrlKey: false,
                    altKey: false,
                    shiftKey: false,
                    metaKey: false,
                    keyCode: undefined,
                    charCode: undefined
                });
                init(eventType, params.bubbles || false, params.cancelable, window, params.ctrlKey, params.altKey, params.shiftKey, params.metaKey, params.keyCode, params.charCode);
                break;
            default:
                evt.initEvent(eventType, params.bubbles || false, params.cancelable || true);
                break;
        }
        $116652c03be0baae$var$Common.defaults(evt, aux);
        elem.dispatchEvent(evt);
    },
    bind: function bind(elem, event, func, newBool) {
        var bool = newBool || false;
        if (elem.addEventListener) elem.addEventListener(event, func, bool);
        else if (elem.attachEvent) elem.attachEvent('on' + event, func);
        return $116652c03be0baae$var$dom;
    },
    unbind: function unbind(elem, event, func, newBool) {
        var bool = newBool || false;
        if (elem.removeEventListener) elem.removeEventListener(event, func, bool);
        else if (elem.detachEvent) elem.detachEvent('on' + event, func);
        return $116652c03be0baae$var$dom;
    },
    addClass: function addClass(elem, className) {
        if (elem.className === undefined) elem.className = className;
        else if (elem.className !== className) {
            var classes = elem.className.split(/ +/);
            if (classes.indexOf(className) === -1) {
                classes.push(className);
                elem.className = classes.join(' ').replace(/^\s+/, '').replace(/\s+$/, '');
            }
        }
        return $116652c03be0baae$var$dom;
    },
    removeClass: function removeClass(elem, className) {
        if (className) {
            if (elem.className === className) elem.removeAttribute('class');
            else {
                var classes = elem.className.split(/ +/);
                var index = classes.indexOf(className);
                if (index !== -1) {
                    classes.splice(index, 1);
                    elem.className = classes.join(' ');
                }
            }
        } else elem.className = undefined;
        return $116652c03be0baae$var$dom;
    },
    hasClass: function hasClass(elem, className) {
        return new RegExp('(?:^|\\s+)' + className + '(?:\\s+|$)').test(elem.className) || false;
    },
    getWidth: function getWidth(elem) {
        var style = getComputedStyle(elem);
        return $116652c03be0baae$var$cssValueToPixels(style['border-left-width']) + $116652c03be0baae$var$cssValueToPixels(style['border-right-width']) + $116652c03be0baae$var$cssValueToPixels(style['padding-left']) + $116652c03be0baae$var$cssValueToPixels(style['padding-right']) + $116652c03be0baae$var$cssValueToPixels(style.width);
    },
    getHeight: function getHeight(elem) {
        var style = getComputedStyle(elem);
        return $116652c03be0baae$var$cssValueToPixels(style['border-top-width']) + $116652c03be0baae$var$cssValueToPixels(style['border-bottom-width']) + $116652c03be0baae$var$cssValueToPixels(style['padding-top']) + $116652c03be0baae$var$cssValueToPixels(style['padding-bottom']) + $116652c03be0baae$var$cssValueToPixels(style.height);
    },
    getOffset: function getOffset(el) {
        var elem = el;
        var offset = {
            left: 0,
            top: 0
        };
        if (elem.offsetParent) do {
            offset.left += elem.offsetLeft;
            offset.top += elem.offsetTop;
            elem = elem.offsetParent;
        }while (elem);
        return offset;
    },
    isActive: function isActive(elem) {
        return elem === document.activeElement && (elem.type || elem.href);
    }
};
var $116652c03be0baae$var$BooleanController = function(_Controller) {
    $116652c03be0baae$var$inherits(BooleanController, _Controller);
    function BooleanController(object, property) {
        $116652c03be0baae$var$classCallCheck(this, BooleanController);
        var _this2 = $116652c03be0baae$var$possibleConstructorReturn(this, (BooleanController.__proto__ || Object.getPrototypeOf(BooleanController)).call(this, object, property));
        var _this = _this2;
        _this2.__prev = _this2.getValue();
        _this2.__checkbox = document.createElement('input');
        _this2.__checkbox.setAttribute('type', 'checkbox');
        function onChange() {
            _this.setValue(!_this.__prev);
        }
        $116652c03be0baae$var$dom.bind(_this2.__checkbox, 'change', onChange, false);
        _this2.domElement.appendChild(_this2.__checkbox);
        _this2.updateDisplay();
        return _this2;
    }
    $116652c03be0baae$var$createClass(BooleanController, [
        {
            key: 'setValue',
            value: function setValue(v) {
                var toReturn = $116652c03be0baae$var$get(BooleanController.prototype.__proto__ || Object.getPrototypeOf(BooleanController.prototype), 'setValue', this).call(this, v);
                if (this.__onFinishChange) this.__onFinishChange.call(this, this.getValue());
                this.__prev = this.getValue();
                return toReturn;
            }
        },
        {
            key: 'updateDisplay',
            value: function updateDisplay() {
                if (this.getValue() === true) {
                    this.__checkbox.setAttribute('checked', 'checked');
                    this.__checkbox.checked = true;
                    this.__prev = true;
                } else {
                    this.__checkbox.checked = false;
                    this.__prev = false;
                }
                return $116652c03be0baae$var$get(BooleanController.prototype.__proto__ || Object.getPrototypeOf(BooleanController.prototype), 'updateDisplay', this).call(this);
            }
        }
    ]);
    return BooleanController;
}($116652c03be0baae$var$Controller);
var $116652c03be0baae$var$OptionController = function(_Controller) {
    $116652c03be0baae$var$inherits(OptionController, _Controller);
    function OptionController(object, property, opts) {
        $116652c03be0baae$var$classCallCheck(this, OptionController);
        var _this2 = $116652c03be0baae$var$possibleConstructorReturn(this, (OptionController.__proto__ || Object.getPrototypeOf(OptionController)).call(this, object, property));
        var options = opts;
        var _this = _this2;
        _this2.__select = document.createElement('select');
        if ($116652c03be0baae$var$Common.isArray(options)) {
            var map = {};
            $116652c03be0baae$var$Common.each(options, function(element) {
                map[element] = element;
            });
            options = map;
        }
        $116652c03be0baae$var$Common.each(options, function(value, key) {
            var opt = document.createElement('option');
            opt.innerHTML = key;
            opt.setAttribute('value', value);
            _this.__select.appendChild(opt);
        });
        _this2.updateDisplay();
        $116652c03be0baae$var$dom.bind(_this2.__select, 'change', function() {
            var desiredValue = this.options[this.selectedIndex].value;
            _this.setValue(desiredValue);
        });
        _this2.domElement.appendChild(_this2.__select);
        return _this2;
    }
    $116652c03be0baae$var$createClass(OptionController, [
        {
            key: 'setValue',
            value: function setValue(v) {
                var toReturn = $116652c03be0baae$var$get(OptionController.prototype.__proto__ || Object.getPrototypeOf(OptionController.prototype), 'setValue', this).call(this, v);
                if (this.__onFinishChange) this.__onFinishChange.call(this, this.getValue());
                return toReturn;
            }
        },
        {
            key: 'updateDisplay',
            value: function updateDisplay() {
                if ($116652c03be0baae$var$dom.isActive(this.__select)) return this;
                this.__select.value = this.getValue();
                return $116652c03be0baae$var$get(OptionController.prototype.__proto__ || Object.getPrototypeOf(OptionController.prototype), 'updateDisplay', this).call(this);
            }
        }
    ]);
    return OptionController;
}($116652c03be0baae$var$Controller);
var $116652c03be0baae$var$StringController = function(_Controller) {
    $116652c03be0baae$var$inherits(StringController, _Controller);
    function StringController(object, property) {
        $116652c03be0baae$var$classCallCheck(this, StringController);
        var _this2 = $116652c03be0baae$var$possibleConstructorReturn(this, (StringController.__proto__ || Object.getPrototypeOf(StringController)).call(this, object, property));
        var _this = _this2;
        function onChange() {
            _this.setValue(_this.__input.value);
        }
        function onBlur() {
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.getValue());
        }
        _this2.__input = document.createElement('input');
        _this2.__input.setAttribute('type', 'text');
        $116652c03be0baae$var$dom.bind(_this2.__input, 'keyup', onChange);
        $116652c03be0baae$var$dom.bind(_this2.__input, 'change', onChange);
        $116652c03be0baae$var$dom.bind(_this2.__input, 'blur', onBlur);
        $116652c03be0baae$var$dom.bind(_this2.__input, 'keydown', function(e) {
            if (e.keyCode === 13) this.blur();
        });
        _this2.updateDisplay();
        _this2.domElement.appendChild(_this2.__input);
        return _this2;
    }
    $116652c03be0baae$var$createClass(StringController, [
        {
            key: 'updateDisplay',
            value: function updateDisplay() {
                if (!$116652c03be0baae$var$dom.isActive(this.__input)) this.__input.value = this.getValue();
                return $116652c03be0baae$var$get(StringController.prototype.__proto__ || Object.getPrototypeOf(StringController.prototype), 'updateDisplay', this).call(this);
            }
        }
    ]);
    return StringController;
}($116652c03be0baae$var$Controller);
function $116652c03be0baae$var$numDecimals(x) {
    var _x = x.toString();
    if (_x.indexOf('.') > -1) return _x.length - _x.indexOf('.') - 1;
    return 0;
}
var $116652c03be0baae$var$NumberController = function(_Controller) {
    $116652c03be0baae$var$inherits(NumberController, _Controller);
    function NumberController(object, property, params) {
        $116652c03be0baae$var$classCallCheck(this, NumberController);
        var _this = $116652c03be0baae$var$possibleConstructorReturn(this, (NumberController.__proto__ || Object.getPrototypeOf(NumberController)).call(this, object, property));
        var _params = params || {};
        _this.__min = _params.min;
        _this.__max = _params.max;
        _this.__step = _params.step;
        if ($116652c03be0baae$var$Common.isUndefined(_this.__step)) {
            if (_this.initialValue === 0) _this.__impliedStep = 1;
            else _this.__impliedStep = Math.pow(10, Math.floor(Math.log(Math.abs(_this.initialValue)) / Math.LN10)) / 10;
        } else _this.__impliedStep = _this.__step;
        _this.__precision = $116652c03be0baae$var$numDecimals(_this.__impliedStep);
        return _this;
    }
    $116652c03be0baae$var$createClass(NumberController, [
        {
            key: 'setValue',
            value: function setValue(v) {
                var _v = v;
                if (this.__min !== undefined && _v < this.__min) _v = this.__min;
                else if (this.__max !== undefined && _v > this.__max) _v = this.__max;
                if (this.__step !== undefined && _v % this.__step !== 0) _v = Math.round(_v / this.__step) * this.__step;
                return $116652c03be0baae$var$get(NumberController.prototype.__proto__ || Object.getPrototypeOf(NumberController.prototype), 'setValue', this).call(this, _v);
            }
        },
        {
            key: 'min',
            value: function min(minValue) {
                this.__min = minValue;
                return this;
            }
        },
        {
            key: 'max',
            value: function max(maxValue) {
                this.__max = maxValue;
                return this;
            }
        },
        {
            key: 'step',
            value: function step(stepValue) {
                this.__step = stepValue;
                this.__impliedStep = stepValue;
                this.__precision = $116652c03be0baae$var$numDecimals(stepValue);
                return this;
            }
        }
    ]);
    return NumberController;
}($116652c03be0baae$var$Controller);
function $116652c03be0baae$var$roundToDecimal(value, decimals) {
    var tenTo = Math.pow(10, decimals);
    return Math.round(value * tenTo) / tenTo;
}
var $116652c03be0baae$var$NumberControllerBox = function(_NumberController) {
    $116652c03be0baae$var$inherits(NumberControllerBox, _NumberController);
    function NumberControllerBox(object, property, params) {
        $116652c03be0baae$var$classCallCheck(this, NumberControllerBox);
        var _this2 = $116652c03be0baae$var$possibleConstructorReturn(this, (NumberControllerBox.__proto__ || Object.getPrototypeOf(NumberControllerBox)).call(this, object, property, params));
        _this2.__truncationSuspended = false;
        var _this = _this2;
        var prevY = void 0;
        function onChange() {
            var attempted = parseFloat(_this.__input.value);
            if (!$116652c03be0baae$var$Common.isNaN(attempted)) _this.setValue(attempted);
        }
        function onFinish() {
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.getValue());
        }
        function onBlur() {
            onFinish();
        }
        function onMouseDrag(e) {
            var diff = prevY - e.clientY;
            _this.setValue(_this.getValue() + diff * _this.__impliedStep);
            prevY = e.clientY;
        }
        function onMouseUp() {
            $116652c03be0baae$var$dom.unbind(window, 'mousemove', onMouseDrag);
            $116652c03be0baae$var$dom.unbind(window, 'mouseup', onMouseUp);
            onFinish();
        }
        function onMouseDown(e) {
            $116652c03be0baae$var$dom.bind(window, 'mousemove', onMouseDrag);
            $116652c03be0baae$var$dom.bind(window, 'mouseup', onMouseUp);
            prevY = e.clientY;
        }
        _this2.__input = document.createElement('input');
        _this2.__input.setAttribute('type', 'text');
        $116652c03be0baae$var$dom.bind(_this2.__input, 'change', onChange);
        $116652c03be0baae$var$dom.bind(_this2.__input, 'blur', onBlur);
        $116652c03be0baae$var$dom.bind(_this2.__input, 'mousedown', onMouseDown);
        $116652c03be0baae$var$dom.bind(_this2.__input, 'keydown', function(e) {
            if (e.keyCode === 13) {
                _this.__truncationSuspended = true;
                this.blur();
                _this.__truncationSuspended = false;
                onFinish();
            }
        });
        _this2.updateDisplay();
        _this2.domElement.appendChild(_this2.__input);
        return _this2;
    }
    $116652c03be0baae$var$createClass(NumberControllerBox, [
        {
            key: 'updateDisplay',
            value: function updateDisplay() {
                this.__input.value = this.__truncationSuspended ? this.getValue() : $116652c03be0baae$var$roundToDecimal(this.getValue(), this.__precision);
                return $116652c03be0baae$var$get(NumberControllerBox.prototype.__proto__ || Object.getPrototypeOf(NumberControllerBox.prototype), 'updateDisplay', this).call(this);
            }
        }
    ]);
    return NumberControllerBox;
}($116652c03be0baae$var$NumberController);
function $116652c03be0baae$var$map(v, i1, i2, o1, o2) {
    return o1 + (o2 - o1) * ((v - i1) / (i2 - i1));
}
var $116652c03be0baae$var$NumberControllerSlider = function(_NumberController) {
    $116652c03be0baae$var$inherits(NumberControllerSlider, _NumberController);
    function NumberControllerSlider(object, property, min, max, step) {
        $116652c03be0baae$var$classCallCheck(this, NumberControllerSlider);
        var _this2 = $116652c03be0baae$var$possibleConstructorReturn(this, (NumberControllerSlider.__proto__ || Object.getPrototypeOf(NumberControllerSlider)).call(this, object, property, {
            min: min,
            max: max,
            step: step
        }));
        var _this = _this2;
        _this2.__background = document.createElement('div');
        _this2.__foreground = document.createElement('div');
        $116652c03be0baae$var$dom.bind(_this2.__background, 'mousedown', onMouseDown);
        $116652c03be0baae$var$dom.bind(_this2.__background, 'touchstart', onTouchStart);
        $116652c03be0baae$var$dom.addClass(_this2.__background, 'slider');
        $116652c03be0baae$var$dom.addClass(_this2.__foreground, 'slider-fg');
        function onMouseDown(e) {
            document.activeElement.blur();
            $116652c03be0baae$var$dom.bind(window, 'mousemove', onMouseDrag);
            $116652c03be0baae$var$dom.bind(window, 'mouseup', onMouseUp);
            onMouseDrag(e);
        }
        function onMouseDrag(e) {
            e.preventDefault();
            var bgRect = _this.__background.getBoundingClientRect();
            _this.setValue($116652c03be0baae$var$map(e.clientX, bgRect.left, bgRect.right, _this.__min, _this.__max));
            return false;
        }
        function onMouseUp() {
            $116652c03be0baae$var$dom.unbind(window, 'mousemove', onMouseDrag);
            $116652c03be0baae$var$dom.unbind(window, 'mouseup', onMouseUp);
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.getValue());
        }
        function onTouchStart(e) {
            if (e.touches.length !== 1) return;
            $116652c03be0baae$var$dom.bind(window, 'touchmove', onTouchMove);
            $116652c03be0baae$var$dom.bind(window, 'touchend', onTouchEnd);
            onTouchMove(e);
        }
        function onTouchMove(e) {
            var clientX = e.touches[0].clientX;
            var bgRect = _this.__background.getBoundingClientRect();
            _this.setValue($116652c03be0baae$var$map(clientX, bgRect.left, bgRect.right, _this.__min, _this.__max));
        }
        function onTouchEnd() {
            $116652c03be0baae$var$dom.unbind(window, 'touchmove', onTouchMove);
            $116652c03be0baae$var$dom.unbind(window, 'touchend', onTouchEnd);
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.getValue());
        }
        _this2.updateDisplay();
        _this2.__background.appendChild(_this2.__foreground);
        _this2.domElement.appendChild(_this2.__background);
        return _this2;
    }
    $116652c03be0baae$var$createClass(NumberControllerSlider, [
        {
            key: 'updateDisplay',
            value: function updateDisplay() {
                var pct = (this.getValue() - this.__min) / (this.__max - this.__min);
                this.__foreground.style.width = pct * 100 + '%';
                return $116652c03be0baae$var$get(NumberControllerSlider.prototype.__proto__ || Object.getPrototypeOf(NumberControllerSlider.prototype), 'updateDisplay', this).call(this);
            }
        }
    ]);
    return NumberControllerSlider;
}($116652c03be0baae$var$NumberController);
var $116652c03be0baae$var$FunctionController = function(_Controller) {
    $116652c03be0baae$var$inherits(FunctionController, _Controller);
    function FunctionController(object, property, text) {
        $116652c03be0baae$var$classCallCheck(this, FunctionController);
        var _this2 = $116652c03be0baae$var$possibleConstructorReturn(this, (FunctionController.__proto__ || Object.getPrototypeOf(FunctionController)).call(this, object, property));
        var _this = _this2;
        _this2.__button = document.createElement('div');
        _this2.__button.innerHTML = text === undefined ? 'Fire' : text;
        $116652c03be0baae$var$dom.bind(_this2.__button, 'click', function(e) {
            e.preventDefault();
            _this.fire();
            return false;
        });
        $116652c03be0baae$var$dom.addClass(_this2.__button, 'button');
        _this2.domElement.appendChild(_this2.__button);
        return _this2;
    }
    $116652c03be0baae$var$createClass(FunctionController, [
        {
            key: 'fire',
            value: function fire() {
                if (this.__onChange) this.__onChange.call(this);
                this.getValue().call(this.object);
                if (this.__onFinishChange) this.__onFinishChange.call(this, this.getValue());
            }
        }
    ]);
    return FunctionController;
}($116652c03be0baae$var$Controller);
var $116652c03be0baae$var$ColorController = function(_Controller) {
    $116652c03be0baae$var$inherits(ColorController, _Controller);
    function ColorController(object, property) {
        $116652c03be0baae$var$classCallCheck(this, ColorController);
        var _this2 = $116652c03be0baae$var$possibleConstructorReturn(this, (ColorController.__proto__ || Object.getPrototypeOf(ColorController)).call(this, object, property));
        _this2.__color = new $116652c03be0baae$var$Color(_this2.getValue());
        _this2.__temp = new $116652c03be0baae$var$Color(0);
        var _this = _this2;
        _this2.domElement = document.createElement('div');
        $116652c03be0baae$var$dom.makeSelectable(_this2.domElement, false);
        _this2.__selector = document.createElement('div');
        _this2.__selector.className = 'selector';
        _this2.__saturation_field = document.createElement('div');
        _this2.__saturation_field.className = 'saturation-field';
        _this2.__field_knob = document.createElement('div');
        _this2.__field_knob.className = 'field-knob';
        _this2.__field_knob_border = '2px solid ';
        _this2.__hue_knob = document.createElement('div');
        _this2.__hue_knob.className = 'hue-knob';
        _this2.__hue_field = document.createElement('div');
        _this2.__hue_field.className = 'hue-field';
        _this2.__input = document.createElement('input');
        _this2.__input.type = 'text';
        _this2.__input_textShadow = '0 1px 1px ';
        $116652c03be0baae$var$dom.bind(_this2.__input, 'keydown', function(e) {
            if (e.keyCode === 13) onBlur.call(this);
        });
        $116652c03be0baae$var$dom.bind(_this2.__input, 'blur', onBlur);
        $116652c03be0baae$var$dom.bind(_this2.__selector, 'mousedown', function() {
            $116652c03be0baae$var$dom.addClass(this, 'drag').bind(window, 'mouseup', function() {
                $116652c03be0baae$var$dom.removeClass(_this.__selector, 'drag');
            });
        });
        $116652c03be0baae$var$dom.bind(_this2.__selector, 'touchstart', function() {
            $116652c03be0baae$var$dom.addClass(this, 'drag').bind(window, 'touchend', function() {
                $116652c03be0baae$var$dom.removeClass(_this.__selector, 'drag');
            });
        });
        var valueField = document.createElement('div');
        $116652c03be0baae$var$Common.extend(_this2.__selector.style, {
            width: '122px',
            height: '102px',
            padding: '3px',
            backgroundColor: '#222',
            boxShadow: '0px 1px 3px rgba(0,0,0,0.3)'
        });
        $116652c03be0baae$var$Common.extend(_this2.__field_knob.style, {
            position: 'absolute',
            width: '12px',
            height: '12px',
            border: _this2.__field_knob_border + (_this2.__color.v < 0.5 ? '#fff' : '#000'),
            boxShadow: '0px 1px 3px rgba(0,0,0,0.5)',
            borderRadius: '12px',
            zIndex: 1
        });
        $116652c03be0baae$var$Common.extend(_this2.__hue_knob.style, {
            position: 'absolute',
            width: '15px',
            height: '2px',
            borderRight: '4px solid #fff',
            zIndex: 1
        });
        $116652c03be0baae$var$Common.extend(_this2.__saturation_field.style, {
            width: '100px',
            height: '100px',
            border: '1px solid #555',
            marginRight: '3px',
            display: 'inline-block',
            cursor: 'pointer'
        });
        $116652c03be0baae$var$Common.extend(valueField.style, {
            width: '100%',
            height: '100%',
            background: 'none'
        });
        $116652c03be0baae$var$linearGradient(valueField, 'top', 'rgba(0,0,0,0)', '#000');
        $116652c03be0baae$var$Common.extend(_this2.__hue_field.style, {
            width: '15px',
            height: '100px',
            border: '1px solid #555',
            cursor: 'ns-resize',
            position: 'absolute',
            top: '3px',
            right: '3px'
        });
        $116652c03be0baae$var$hueGradient(_this2.__hue_field);
        $116652c03be0baae$var$Common.extend(_this2.__input.style, {
            outline: 'none',
            textAlign: 'center',
            color: '#fff',
            border: 0,
            fontWeight: 'bold',
            textShadow: _this2.__input_textShadow + 'rgba(0,0,0,0.7)'
        });
        $116652c03be0baae$var$dom.bind(_this2.__saturation_field, 'mousedown', fieldDown);
        $116652c03be0baae$var$dom.bind(_this2.__saturation_field, 'touchstart', fieldDown);
        $116652c03be0baae$var$dom.bind(_this2.__field_knob, 'mousedown', fieldDown);
        $116652c03be0baae$var$dom.bind(_this2.__field_knob, 'touchstart', fieldDown);
        $116652c03be0baae$var$dom.bind(_this2.__hue_field, 'mousedown', fieldDownH);
        $116652c03be0baae$var$dom.bind(_this2.__hue_field, 'touchstart', fieldDownH);
        function fieldDown(e) {
            setSV(e);
            $116652c03be0baae$var$dom.bind(window, 'mousemove', setSV);
            $116652c03be0baae$var$dom.bind(window, 'touchmove', setSV);
            $116652c03be0baae$var$dom.bind(window, 'mouseup', fieldUpSV);
            $116652c03be0baae$var$dom.bind(window, 'touchend', fieldUpSV);
        }
        function fieldDownH(e) {
            setH(e);
            $116652c03be0baae$var$dom.bind(window, 'mousemove', setH);
            $116652c03be0baae$var$dom.bind(window, 'touchmove', setH);
            $116652c03be0baae$var$dom.bind(window, 'mouseup', fieldUpH);
            $116652c03be0baae$var$dom.bind(window, 'touchend', fieldUpH);
        }
        function fieldUpSV() {
            $116652c03be0baae$var$dom.unbind(window, 'mousemove', setSV);
            $116652c03be0baae$var$dom.unbind(window, 'touchmove', setSV);
            $116652c03be0baae$var$dom.unbind(window, 'mouseup', fieldUpSV);
            $116652c03be0baae$var$dom.unbind(window, 'touchend', fieldUpSV);
            onFinish();
        }
        function fieldUpH() {
            $116652c03be0baae$var$dom.unbind(window, 'mousemove', setH);
            $116652c03be0baae$var$dom.unbind(window, 'touchmove', setH);
            $116652c03be0baae$var$dom.unbind(window, 'mouseup', fieldUpH);
            $116652c03be0baae$var$dom.unbind(window, 'touchend', fieldUpH);
            onFinish();
        }
        function onBlur() {
            var i = $116652c03be0baae$var$interpret(this.value);
            if (i !== false) {
                _this.__color.__state = i;
                _this.setValue(_this.__color.toOriginal());
            } else this.value = _this.__color.toString();
        }
        function onFinish() {
            if (_this.__onFinishChange) _this.__onFinishChange.call(_this, _this.__color.toOriginal());
        }
        _this2.__saturation_field.appendChild(valueField);
        _this2.__selector.appendChild(_this2.__field_knob);
        _this2.__selector.appendChild(_this2.__saturation_field);
        _this2.__selector.appendChild(_this2.__hue_field);
        _this2.__hue_field.appendChild(_this2.__hue_knob);
        _this2.domElement.appendChild(_this2.__input);
        _this2.domElement.appendChild(_this2.__selector);
        _this2.updateDisplay();
        function setSV(e) {
            if (e.type.indexOf('touch') === -1) e.preventDefault();
            var fieldRect = _this.__saturation_field.getBoundingClientRect();
            var _ref = e.touches && e.touches[0] || e, clientX = _ref.clientX, clientY = _ref.clientY;
            var s = (clientX - fieldRect.left) / (fieldRect.right - fieldRect.left);
            var v = 1 - (clientY - fieldRect.top) / (fieldRect.bottom - fieldRect.top);
            if (v > 1) v = 1;
            else if (v < 0) v = 0;
            if (s > 1) s = 1;
            else if (s < 0) s = 0;
            _this.__color.v = v;
            _this.__color.s = s;
            _this.setValue(_this.__color.toOriginal());
            return false;
        }
        function setH(e) {
            if (e.type.indexOf('touch') === -1) e.preventDefault();
            var fieldRect = _this.__hue_field.getBoundingClientRect();
            var _ref2 = e.touches && e.touches[0] || e, clientY = _ref2.clientY;
            var h = 1 - (clientY - fieldRect.top) / (fieldRect.bottom - fieldRect.top);
            if (h > 1) h = 1;
            else if (h < 0) h = 0;
            _this.__color.h = h * 360;
            _this.setValue(_this.__color.toOriginal());
            return false;
        }
        return _this2;
    }
    $116652c03be0baae$var$createClass(ColorController, [
        {
            key: 'updateDisplay',
            value: function updateDisplay() {
                var i = $116652c03be0baae$var$interpret(this.getValue());
                if (i !== false) {
                    var mismatch = false;
                    $116652c03be0baae$var$Common.each($116652c03be0baae$var$Color.COMPONENTS, function(component) {
                        if (!$116652c03be0baae$var$Common.isUndefined(i[component]) && !$116652c03be0baae$var$Common.isUndefined(this.__color.__state[component]) && i[component] !== this.__color.__state[component]) {
                            mismatch = true;
                            return {};
                        }
                    }, this);
                    if (mismatch) $116652c03be0baae$var$Common.extend(this.__color.__state, i);
                }
                $116652c03be0baae$var$Common.extend(this.__temp.__state, this.__color.__state);
                this.__temp.a = 1;
                var flip = this.__color.v < 0.5 || this.__color.s > 0.5 ? 255 : 0;
                var _flip = 255 - flip;
                $116652c03be0baae$var$Common.extend(this.__field_knob.style, {
                    marginLeft: 100 * this.__color.s - 7 + 'px',
                    marginTop: 100 * (1 - this.__color.v) - 7 + 'px',
                    backgroundColor: this.__temp.toHexString(),
                    border: this.__field_knob_border + 'rgb(' + flip + ',' + flip + ',' + flip + ')'
                });
                this.__hue_knob.style.marginTop = (1 - this.__color.h / 360) * 100 + 'px';
                this.__temp.s = 1;
                this.__temp.v = 1;
                $116652c03be0baae$var$linearGradient(this.__saturation_field, 'left', '#fff', this.__temp.toHexString());
                this.__input.value = this.__color.toString();
                $116652c03be0baae$var$Common.extend(this.__input.style, {
                    backgroundColor: this.__color.toHexString(),
                    color: 'rgb(' + flip + ',' + flip + ',' + flip + ')',
                    textShadow: this.__input_textShadow + 'rgba(' + _flip + ',' + _flip + ',' + _flip + ',.7)'
                });
            }
        }
    ]);
    return ColorController;
}($116652c03be0baae$var$Controller);
var $116652c03be0baae$var$vendors = [
    '-moz-',
    '-o-',
    '-webkit-',
    '-ms-',
    ''
];
function $116652c03be0baae$var$linearGradient(elem, x, a, b) {
    elem.style.background = '';
    $116652c03be0baae$var$Common.each($116652c03be0baae$var$vendors, function(vendor) {
        elem.style.cssText += 'background: ' + vendor + 'linear-gradient(' + x + ', ' + a + ' 0%, ' + b + ' 100%); ';
    });
}
function $116652c03be0baae$var$hueGradient(elem) {
    elem.style.background = '';
    elem.style.cssText += 'background: -moz-linear-gradient(top,  #ff0000 0%, #ff00ff 17%, #0000ff 34%, #00ffff 50%, #00ff00 67%, #ffff00 84%, #ff0000 100%);';
    elem.style.cssText += 'background: -webkit-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);';
    elem.style.cssText += 'background: -o-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);';
    elem.style.cssText += 'background: -ms-linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);';
    elem.style.cssText += 'background: linear-gradient(top,  #ff0000 0%,#ff00ff 17%,#0000ff 34%,#00ffff 50%,#00ff00 67%,#ffff00 84%,#ff0000 100%);';
}
var $116652c03be0baae$var$css = {
    load: function load(url, indoc) {
        var doc = indoc || document;
        var link = doc.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = url;
        doc.getElementsByTagName('head')[0].appendChild(link);
    },
    inject: function inject(cssContent, indoc) {
        var doc = indoc || document;
        var injected = document.createElement('style');
        injected.type = 'text/css';
        injected.innerHTML = cssContent;
        var head = doc.getElementsByTagName('head')[0];
        try {
            head.appendChild(injected);
        } catch (e) {}
    }
};
var $116652c03be0baae$var$saveDialogContents = "<div id=\"dg-save\" class=\"dg dialogue\">\n\n  Here's the new load parameter for your <code>GUI</code>'s constructor:\n\n  <textarea id=\"dg-new-constructor\"></textarea>\n\n  <div id=\"dg-save-locally\">\n\n    <input id=\"dg-local-storage\" type=\"checkbox\"/> Automatically save\n    values to <code>localStorage</code> on exit.\n\n    <div id=\"dg-local-explain\">The values saved to <code>localStorage</code> will\n      override those passed to <code>dat.GUI</code>'s constructor. This makes it\n      easier to work incrementally, but <code>localStorage</code> is fragile,\n      and your friends may not see the same values you do.\n\n    </div>\n\n  </div>\n\n</div>";
var $116652c03be0baae$var$ControllerFactory = function ControllerFactory(object, property) {
    var initialValue = object[property];
    if ($116652c03be0baae$var$Common.isArray(arguments[2]) || $116652c03be0baae$var$Common.isObject(arguments[2])) return new $116652c03be0baae$var$OptionController(object, property, arguments[2]);
    if ($116652c03be0baae$var$Common.isNumber(initialValue)) {
        if ($116652c03be0baae$var$Common.isNumber(arguments[2]) && $116652c03be0baae$var$Common.isNumber(arguments[3])) {
            if ($116652c03be0baae$var$Common.isNumber(arguments[4])) return new $116652c03be0baae$var$NumberControllerSlider(object, property, arguments[2], arguments[3], arguments[4]);
            return new $116652c03be0baae$var$NumberControllerSlider(object, property, arguments[2], arguments[3]);
        }
        if ($116652c03be0baae$var$Common.isNumber(arguments[4])) return new $116652c03be0baae$var$NumberControllerBox(object, property, {
            min: arguments[2],
            max: arguments[3],
            step: arguments[4]
        });
        return new $116652c03be0baae$var$NumberControllerBox(object, property, {
            min: arguments[2],
            max: arguments[3]
        });
    }
    if ($116652c03be0baae$var$Common.isString(initialValue)) return new $116652c03be0baae$var$StringController(object, property);
    if ($116652c03be0baae$var$Common.isFunction(initialValue)) return new $116652c03be0baae$var$FunctionController(object, property, '');
    if ($116652c03be0baae$var$Common.isBoolean(initialValue)) return new $116652c03be0baae$var$BooleanController(object, property);
    return null;
};
function $116652c03be0baae$var$requestAnimationFrame(callback) {
    setTimeout(callback, 1000 / 60);
}
var $116652c03be0baae$var$requestAnimationFrame$1 = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || $116652c03be0baae$var$requestAnimationFrame;
var $116652c03be0baae$var$CenteredDiv = function() {
    function CenteredDiv() {
        $116652c03be0baae$var$classCallCheck(this, CenteredDiv);
        this.backgroundElement = document.createElement('div');
        $116652c03be0baae$var$Common.extend(this.backgroundElement.style, {
            backgroundColor: 'rgba(0,0,0,0.8)',
            top: 0,
            left: 0,
            display: 'none',
            zIndex: '1000',
            opacity: 0,
            WebkitTransition: 'opacity 0.2s linear',
            transition: 'opacity 0.2s linear'
        });
        $116652c03be0baae$var$dom.makeFullscreen(this.backgroundElement);
        this.backgroundElement.style.position = 'fixed';
        this.domElement = document.createElement('div');
        $116652c03be0baae$var$Common.extend(this.domElement.style, {
            position: 'fixed',
            display: 'none',
            zIndex: '1001',
            opacity: 0,
            WebkitTransition: '-webkit-transform 0.2s ease-out, opacity 0.2s linear',
            transition: 'transform 0.2s ease-out, opacity 0.2s linear'
        });
        document.body.appendChild(this.backgroundElement);
        document.body.appendChild(this.domElement);
        var _this = this;
        $116652c03be0baae$var$dom.bind(this.backgroundElement, 'click', function() {
            _this.hide();
        });
    }
    $116652c03be0baae$var$createClass(CenteredDiv, [
        {
            key: 'show',
            value: function show() {
                var _this = this;
                this.backgroundElement.style.display = 'block';
                this.domElement.style.display = 'block';
                this.domElement.style.opacity = 0;
                this.domElement.style.webkitTransform = 'scale(1.1)';
                this.layout();
                $116652c03be0baae$var$Common.defer(function() {
                    _this.backgroundElement.style.opacity = 1;
                    _this.domElement.style.opacity = 1;
                    _this.domElement.style.webkitTransform = 'scale(1)';
                });
            }
        },
        {
            key: 'hide',
            value: function hide() {
                var _this = this;
                var hide = function hide() {
                    _this.domElement.style.display = 'none';
                    _this.backgroundElement.style.display = 'none';
                    $116652c03be0baae$var$dom.unbind(_this.domElement, 'webkitTransitionEnd', hide);
                    $116652c03be0baae$var$dom.unbind(_this.domElement, 'transitionend', hide);
                    $116652c03be0baae$var$dom.unbind(_this.domElement, 'oTransitionEnd', hide);
                };
                $116652c03be0baae$var$dom.bind(this.domElement, 'webkitTransitionEnd', hide);
                $116652c03be0baae$var$dom.bind(this.domElement, 'transitionend', hide);
                $116652c03be0baae$var$dom.bind(this.domElement, 'oTransitionEnd', hide);
                this.backgroundElement.style.opacity = 0;
                this.domElement.style.opacity = 0;
                this.domElement.style.webkitTransform = 'scale(1.1)';
            }
        },
        {
            key: 'layout',
            value: function layout() {
                this.domElement.style.left = window.innerWidth / 2 - $116652c03be0baae$var$dom.getWidth(this.domElement) / 2 + 'px';
                this.domElement.style.top = window.innerHeight / 2 - $116652c03be0baae$var$dom.getHeight(this.domElement) / 2 + 'px';
            }
        }
    ]);
    return CenteredDiv;
}();
var $116652c03be0baae$var$styleSheet = $116652c03be0baae$var$___$insertStyle(".dg ul{list-style:none;margin:0;padding:0;width:100%;clear:both}.dg.ac{position:fixed;top:0;left:0;right:0;height:0;z-index:0}.dg:not(.ac) .main{overflow:hidden}.dg.main{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear}.dg.main.taller-than-window{overflow-y:auto}.dg.main.taller-than-window .close-button{opacity:1;margin-top:-1px;border-top:1px solid #2c2c2c}.dg.main ul.closed .close-button{opacity:1 !important}.dg.main:hover .close-button,.dg.main .close-button.drag{opacity:1}.dg.main .close-button{-webkit-transition:opacity .1s linear;-o-transition:opacity .1s linear;-moz-transition:opacity .1s linear;transition:opacity .1s linear;border:0;line-height:19px;height:20px;cursor:pointer;text-align:center;background-color:#000}.dg.main .close-button.close-top{position:relative}.dg.main .close-button.close-bottom{position:absolute}.dg.main .close-button:hover{background-color:#111}.dg.a{float:right;margin-right:15px;overflow-y:visible}.dg.a.has-save>ul.close-top{margin-top:0}.dg.a.has-save>ul.close-bottom{margin-top:27px}.dg.a.has-save>ul.closed{margin-top:0}.dg.a .save-row{top:0;z-index:1002}.dg.a .save-row.close-top{position:relative}.dg.a .save-row.close-bottom{position:fixed}.dg li{-webkit-transition:height .1s ease-out;-o-transition:height .1s ease-out;-moz-transition:height .1s ease-out;transition:height .1s ease-out;-webkit-transition:overflow .1s linear;-o-transition:overflow .1s linear;-moz-transition:overflow .1s linear;transition:overflow .1s linear}.dg li:not(.folder){cursor:auto;height:27px;line-height:27px;padding:0 4px 0 5px}.dg li.folder{padding:0;border-left:4px solid rgba(0,0,0,0)}.dg li.title{cursor:pointer;margin-left:-4px}.dg .closed li:not(.title),.dg .closed ul li,.dg .closed ul li>*{height:0;overflow:hidden;border:0}.dg .cr{clear:both;padding-left:3px;height:27px;overflow:hidden}.dg .property-name{cursor:default;float:left;clear:left;width:40%;overflow:hidden;text-overflow:ellipsis}.dg .cr.function .property-name{width:100%}.dg .c{float:left;width:60%;position:relative}.dg .c input[type=text]{border:0;margin-top:4px;padding:3px;width:100%;float:right}.dg .has-slider input[type=text]{width:30%;margin-left:0}.dg .slider{float:left;width:66%;margin-left:-5px;margin-right:0;height:19px;margin-top:4px}.dg .slider-fg{height:100%}.dg .c input[type=checkbox]{margin-top:7px}.dg .c select{margin-top:5px}.dg .cr.function,.dg .cr.function .property-name,.dg .cr.function *,.dg .cr.boolean,.dg .cr.boolean *{cursor:pointer}.dg .cr.color{overflow:visible}.dg .selector{display:none;position:absolute;margin-left:-9px;margin-top:23px;z-index:10}.dg .c:hover .selector,.dg .selector.drag{display:block}.dg li.save-row{padding:0}.dg li.save-row .button{display:inline-block;padding:0px 6px}.dg.dialogue{background-color:#222;width:460px;padding:15px;font-size:13px;line-height:15px}#dg-new-constructor{padding:10px;color:#222;font-family:Monaco, monospace;font-size:10px;border:0;resize:none;box-shadow:inset 1px 1px 1px #888;word-wrap:break-word;margin:12px 0;display:block;width:440px;overflow-y:scroll;height:100px;position:relative}#dg-local-explain{display:none;font-size:11px;line-height:17px;border-radius:3px;background-color:#333;padding:8px;margin-top:10px}#dg-local-explain code{font-size:10px}#dat-gui-save-locally{display:none}.dg{color:#eee;font:11px 'Lucida Grande', sans-serif;text-shadow:0 -1px 0 #111}.dg.main::-webkit-scrollbar{width:5px;background:#1a1a1a}.dg.main::-webkit-scrollbar-corner{height:0;display:none}.dg.main::-webkit-scrollbar-thumb{border-radius:5px;background:#676767}.dg li:not(.folder){background:#1a1a1a;border-bottom:1px solid #2c2c2c}.dg li.save-row{line-height:25px;background:#dad5cb;border:0}.dg li.save-row select{margin-left:5px;width:108px}.dg li.save-row .button{margin-left:5px;margin-top:1px;border-radius:2px;font-size:9px;line-height:7px;padding:4px 4px 5px 4px;background:#c5bdad;color:#fff;text-shadow:0 1px 0 #b0a58f;box-shadow:0 -1px 0 #b0a58f;cursor:pointer}.dg li.save-row .button.gears{background:#c5bdad url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAQJJREFUeNpiYKAU/P//PwGIC/ApCABiBSAW+I8AClAcgKxQ4T9hoMAEUrxx2QSGN6+egDX+/vWT4e7N82AMYoPAx/evwWoYoSYbACX2s7KxCxzcsezDh3evFoDEBYTEEqycggWAzA9AuUSQQgeYPa9fPv6/YWm/Acx5IPb7ty/fw+QZblw67vDs8R0YHyQhgObx+yAJkBqmG5dPPDh1aPOGR/eugW0G4vlIoTIfyFcA+QekhhHJhPdQxbiAIguMBTQZrPD7108M6roWYDFQiIAAv6Aow/1bFwXgis+f2LUAynwoIaNcz8XNx3Dl7MEJUDGQpx9gtQ8YCueB+D26OECAAQDadt7e46D42QAAAABJRU5ErkJggg==) 2px 1px no-repeat;height:7px;width:8px}.dg li.save-row .button:hover{background-color:#bab19e;box-shadow:0 -1px 0 #b0a58f}.dg li.folder{border-bottom:0}.dg li.title{padding-left:16px;background:#000 url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlI+hKgFxoCgAOw==) 6px 10px no-repeat;cursor:pointer;border-bottom:1px solid rgba(255,255,255,0.2)}.dg .closed li.title{background-image:url(data:image/gif;base64,R0lGODlhBQAFAJEAAP////Pz8////////yH5BAEAAAIALAAAAAAFAAUAAAIIlGIWqMCbWAEAOw==)}.dg .cr.boolean{border-left:3px solid #806787}.dg .cr.color{border-left:3px solid}.dg .cr.function{border-left:3px solid #e61d5f}.dg .cr.number{border-left:3px solid #2FA1D6}.dg .cr.number input[type=text]{color:#2FA1D6}.dg .cr.string{border-left:3px solid #1ed36f}.dg .cr.string input[type=text]{color:#1ed36f}.dg .cr.function:hover,.dg .cr.boolean:hover{background:#111}.dg .c input[type=text]{background:#303030;outline:none}.dg .c input[type=text]:hover{background:#3c3c3c}.dg .c input[type=text]:focus{background:#494949;color:#fff}.dg .c .slider{background:#303030;cursor:ew-resize}.dg .c .slider-fg{background:#2FA1D6;max-width:100%}.dg .c .slider:hover{background:#3c3c3c}.dg .c .slider:hover .slider-fg{background:#44abda}\n");
$116652c03be0baae$var$css.inject($116652c03be0baae$var$styleSheet);
var $116652c03be0baae$var$CSS_NAMESPACE = 'dg';
var $116652c03be0baae$var$HIDE_KEY_CODE = 72;
var $116652c03be0baae$var$CLOSE_BUTTON_HEIGHT = 20;
var $116652c03be0baae$var$DEFAULT_DEFAULT_PRESET_NAME = 'Default';
var $116652c03be0baae$var$SUPPORTS_LOCAL_STORAGE = function() {
    try {
        return !!window.localStorage;
    } catch (e) {
        return false;
    }
}();
var $116652c03be0baae$var$SAVE_DIALOGUE = void 0;
var $116652c03be0baae$var$autoPlaceVirgin = true;
var $116652c03be0baae$var$autoPlaceContainer = void 0;
var $116652c03be0baae$var$hide = false;
var $116652c03be0baae$var$hideableGuis = [];
var $116652c03be0baae$var$GUI = function GUI(pars) {
    var _this = this;
    var params = pars || {};
    this.domElement = document.createElement('div');
    this.__ul = document.createElement('ul');
    this.domElement.appendChild(this.__ul);
    $116652c03be0baae$var$dom.addClass(this.domElement, $116652c03be0baae$var$CSS_NAMESPACE);
    this.__folders = {};
    this.__controllers = [];
    this.__rememberedObjects = [];
    this.__rememberedObjectIndecesToControllers = [];
    this.__listening = [];
    params = $116652c03be0baae$var$Common.defaults(params, {
        closeOnTop: false,
        autoPlace: true,
        width: GUI.DEFAULT_WIDTH
    });
    params = $116652c03be0baae$var$Common.defaults(params, {
        resizable: params.autoPlace,
        hideable: params.autoPlace
    });
    if (!$116652c03be0baae$var$Common.isUndefined(params.load)) {
        if (params.preset) params.load.preset = params.preset;
    } else params.load = {
        preset: $116652c03be0baae$var$DEFAULT_DEFAULT_PRESET_NAME
    };
    if ($116652c03be0baae$var$Common.isUndefined(params.parent) && params.hideable) $116652c03be0baae$var$hideableGuis.push(this);
    params.resizable = $116652c03be0baae$var$Common.isUndefined(params.parent) && params.resizable;
    if (params.autoPlace && $116652c03be0baae$var$Common.isUndefined(params.scrollable)) params.scrollable = true;
    var useLocalStorage = $116652c03be0baae$var$SUPPORTS_LOCAL_STORAGE && localStorage.getItem($116652c03be0baae$var$getLocalStorageHash(this, 'isLocal')) === 'true';
    var saveToLocalStorage = void 0;
    var titleRow = void 0;
    Object.defineProperties(this, {
        parent: {
            get: function get$$1() {
                return params.parent;
            }
        },
        scrollable: {
            get: function get$$1() {
                return params.scrollable;
            }
        },
        autoPlace: {
            get: function get$$1() {
                return params.autoPlace;
            }
        },
        closeOnTop: {
            get: function get$$1() {
                return params.closeOnTop;
            }
        },
        preset: {
            get: function get$$1() {
                if (_this.parent) return _this.getRoot().preset;
                return params.load.preset;
            },
            set: function set$$1(v) {
                if (_this.parent) _this.getRoot().preset = v;
                else params.load.preset = v;
                $116652c03be0baae$var$setPresetSelectIndex(this);
                _this.revert();
            }
        },
        width: {
            get: function get$$1() {
                return params.width;
            },
            set: function set$$1(v) {
                params.width = v;
                $116652c03be0baae$var$setWidth(_this, v);
            }
        },
        name: {
            get: function get$$1() {
                return params.name;
            },
            set: function set$$1(v) {
                params.name = v;
                if (titleRow) titleRow.innerHTML = params.name;
            }
        },
        closed: {
            get: function get$$1() {
                return params.closed;
            },
            set: function set$$1(v) {
                params.closed = v;
                if (params.closed) $116652c03be0baae$var$dom.addClass(_this.__ul, GUI.CLASS_CLOSED);
                else $116652c03be0baae$var$dom.removeClass(_this.__ul, GUI.CLASS_CLOSED);
                this.onResize();
                if (_this.__closeButton) _this.__closeButton.innerHTML = v ? GUI.TEXT_OPEN : GUI.TEXT_CLOSED;
            }
        },
        load: {
            get: function get$$1() {
                return params.load;
            }
        },
        useLocalStorage: {
            get: function get$$1() {
                return useLocalStorage;
            },
            set: function set$$1(bool) {
                if ($116652c03be0baae$var$SUPPORTS_LOCAL_STORAGE) {
                    useLocalStorage = bool;
                    if (bool) $116652c03be0baae$var$dom.bind(window, 'unload', saveToLocalStorage);
                    else $116652c03be0baae$var$dom.unbind(window, 'unload', saveToLocalStorage);
                    localStorage.setItem($116652c03be0baae$var$getLocalStorageHash(_this, 'isLocal'), bool);
                }
            }
        }
    });
    if ($116652c03be0baae$var$Common.isUndefined(params.parent)) {
        this.closed = params.closed || false;
        $116652c03be0baae$var$dom.addClass(this.domElement, GUI.CLASS_MAIN);
        $116652c03be0baae$var$dom.makeSelectable(this.domElement, false);
        if ($116652c03be0baae$var$SUPPORTS_LOCAL_STORAGE) {
            if (useLocalStorage) {
                _this.useLocalStorage = true;
                var savedGui = localStorage.getItem($116652c03be0baae$var$getLocalStorageHash(this, 'gui'));
                if (savedGui) params.load = JSON.parse(savedGui);
            }
        }
        this.__closeButton = document.createElement('div');
        this.__closeButton.innerHTML = GUI.TEXT_CLOSED;
        $116652c03be0baae$var$dom.addClass(this.__closeButton, GUI.CLASS_CLOSE_BUTTON);
        if (params.closeOnTop) {
            $116652c03be0baae$var$dom.addClass(this.__closeButton, GUI.CLASS_CLOSE_TOP);
            this.domElement.insertBefore(this.__closeButton, this.domElement.childNodes[0]);
        } else {
            $116652c03be0baae$var$dom.addClass(this.__closeButton, GUI.CLASS_CLOSE_BOTTOM);
            this.domElement.appendChild(this.__closeButton);
        }
        $116652c03be0baae$var$dom.bind(this.__closeButton, 'click', function() {
            _this.closed = !_this.closed;
        });
    } else {
        if (params.closed === undefined) params.closed = true;
        var titleRowName = document.createTextNode(params.name);
        $116652c03be0baae$var$dom.addClass(titleRowName, 'controller-name');
        titleRow = $116652c03be0baae$var$addRow(_this, titleRowName);
        var onClickTitle = function onClickTitle(e) {
            e.preventDefault();
            _this.closed = !_this.closed;
            return false;
        };
        $116652c03be0baae$var$dom.addClass(this.__ul, GUI.CLASS_CLOSED);
        $116652c03be0baae$var$dom.addClass(titleRow, 'title');
        $116652c03be0baae$var$dom.bind(titleRow, 'click', onClickTitle);
        if (!params.closed) this.closed = false;
    }
    if (params.autoPlace) {
        if ($116652c03be0baae$var$Common.isUndefined(params.parent)) {
            if ($116652c03be0baae$var$autoPlaceVirgin) {
                $116652c03be0baae$var$autoPlaceContainer = document.createElement('div');
                $116652c03be0baae$var$dom.addClass($116652c03be0baae$var$autoPlaceContainer, $116652c03be0baae$var$CSS_NAMESPACE);
                $116652c03be0baae$var$dom.addClass($116652c03be0baae$var$autoPlaceContainer, GUI.CLASS_AUTO_PLACE_CONTAINER);
                document.body.appendChild($116652c03be0baae$var$autoPlaceContainer);
                $116652c03be0baae$var$autoPlaceVirgin = false;
            }
            $116652c03be0baae$var$autoPlaceContainer.appendChild(this.domElement);
            $116652c03be0baae$var$dom.addClass(this.domElement, GUI.CLASS_AUTO_PLACE);
        }
        if (!this.parent) $116652c03be0baae$var$setWidth(_this, params.width);
    }
    this.__resizeHandler = function() {
        _this.onResizeDebounced();
    };
    $116652c03be0baae$var$dom.bind(window, 'resize', this.__resizeHandler);
    $116652c03be0baae$var$dom.bind(this.__ul, 'webkitTransitionEnd', this.__resizeHandler);
    $116652c03be0baae$var$dom.bind(this.__ul, 'transitionend', this.__resizeHandler);
    $116652c03be0baae$var$dom.bind(this.__ul, 'oTransitionEnd', this.__resizeHandler);
    this.onResize();
    if (params.resizable) $116652c03be0baae$var$addResizeHandle(this);
    saveToLocalStorage = function saveToLocalStorage() {
        if ($116652c03be0baae$var$SUPPORTS_LOCAL_STORAGE && localStorage.getItem($116652c03be0baae$var$getLocalStorageHash(_this, 'isLocal')) === 'true') localStorage.setItem($116652c03be0baae$var$getLocalStorageHash(_this, 'gui'), JSON.stringify(_this.getSaveObject()));
    };
    this.saveToLocalStorageIfPossible = saveToLocalStorage;
    function resetWidth() {
        var root = _this.getRoot();
        root.width += 1;
        $116652c03be0baae$var$Common.defer(function() {
            root.width -= 1;
        });
    }
    if (!params.parent) resetWidth();
};
$116652c03be0baae$var$GUI.toggleHide = function() {
    $116652c03be0baae$var$hide = !$116652c03be0baae$var$hide;
    $116652c03be0baae$var$Common.each($116652c03be0baae$var$hideableGuis, function(gui) {
        gui.domElement.style.display = $116652c03be0baae$var$hide ? 'none' : '';
    });
};
$116652c03be0baae$var$GUI.CLASS_AUTO_PLACE = 'a';
$116652c03be0baae$var$GUI.CLASS_AUTO_PLACE_CONTAINER = 'ac';
$116652c03be0baae$var$GUI.CLASS_MAIN = 'main';
$116652c03be0baae$var$GUI.CLASS_CONTROLLER_ROW = 'cr';
$116652c03be0baae$var$GUI.CLASS_TOO_TALL = 'taller-than-window';
$116652c03be0baae$var$GUI.CLASS_CLOSED = 'closed';
$116652c03be0baae$var$GUI.CLASS_CLOSE_BUTTON = 'close-button';
$116652c03be0baae$var$GUI.CLASS_CLOSE_TOP = 'close-top';
$116652c03be0baae$var$GUI.CLASS_CLOSE_BOTTOM = 'close-bottom';
$116652c03be0baae$var$GUI.CLASS_DRAG = 'drag';
$116652c03be0baae$var$GUI.DEFAULT_WIDTH = 245;
$116652c03be0baae$var$GUI.TEXT_CLOSED = 'Close Controls';
$116652c03be0baae$var$GUI.TEXT_OPEN = 'Open Controls';
$116652c03be0baae$var$GUI._keydownHandler = function(e) {
    if (document.activeElement.type !== 'text' && (e.which === $116652c03be0baae$var$HIDE_KEY_CODE || e.keyCode === $116652c03be0baae$var$HIDE_KEY_CODE)) $116652c03be0baae$var$GUI.toggleHide();
};
$116652c03be0baae$var$dom.bind(window, 'keydown', $116652c03be0baae$var$GUI._keydownHandler, false);
$116652c03be0baae$var$Common.extend($116652c03be0baae$var$GUI.prototype, {
    add: function add(object, property) {
        return $116652c03be0baae$var$_add(this, object, property, {
            factoryArgs: Array.prototype.slice.call(arguments, 2)
        });
    },
    addColor: function addColor(object, property) {
        return $116652c03be0baae$var$_add(this, object, property, {
            color: true
        });
    },
    remove: function remove(controller) {
        this.__ul.removeChild(controller.__li);
        this.__controllers.splice(this.__controllers.indexOf(controller), 1);
        var _this = this;
        $116652c03be0baae$var$Common.defer(function() {
            _this.onResize();
        });
    },
    destroy: function destroy() {
        if (this.parent) throw new Error("Only the root GUI should be removed with .destroy(). For subfolders, use gui.removeFolder(folder) instead.");
        if (this.autoPlace) $116652c03be0baae$var$autoPlaceContainer.removeChild(this.domElement);
        var _this = this;
        $116652c03be0baae$var$Common.each(this.__folders, function(subfolder) {
            _this.removeFolder(subfolder);
        });
        $116652c03be0baae$var$dom.unbind(window, 'keydown', $116652c03be0baae$var$GUI._keydownHandler, false);
        $116652c03be0baae$var$removeListeners(this);
    },
    addFolder: function addFolder(name) {
        if (this.__folders[name] !== undefined) throw new Error('You already have a folder in this GUI by the name "' + name + '"');
        var newGuiParams = {
            name: name,
            parent: this
        };
        newGuiParams.autoPlace = this.autoPlace;
        if (this.load && this.load.folders && this.load.folders[name]) {
            newGuiParams.closed = this.load.folders[name].closed;
            newGuiParams.load = this.load.folders[name];
        }
        var gui = new $116652c03be0baae$var$GUI(newGuiParams);
        this.__folders[name] = gui;
        var li = $116652c03be0baae$var$addRow(this, gui.domElement);
        $116652c03be0baae$var$dom.addClass(li, 'folder');
        return gui;
    },
    removeFolder: function removeFolder(folder) {
        this.__ul.removeChild(folder.domElement.parentElement);
        delete this.__folders[folder.name];
        if (this.load && this.load.folders && this.load.folders[folder.name]) delete this.load.folders[folder.name];
        $116652c03be0baae$var$removeListeners(folder);
        var _this = this;
        $116652c03be0baae$var$Common.each(folder.__folders, function(subfolder) {
            folder.removeFolder(subfolder);
        });
        $116652c03be0baae$var$Common.defer(function() {
            _this.onResize();
        });
    },
    open: function open() {
        this.closed = false;
    },
    close: function close() {
        this.closed = true;
    },
    hide: function hide() {
        this.domElement.style.display = 'none';
    },
    show: function show() {
        this.domElement.style.display = '';
    },
    onResize: function onResize() {
        var root = this.getRoot();
        if (root.scrollable) {
            var top = $116652c03be0baae$var$dom.getOffset(root.__ul).top;
            var h = 0;
            $116652c03be0baae$var$Common.each(root.__ul.childNodes, function(node) {
                if (!(root.autoPlace && node === root.__save_row)) h += $116652c03be0baae$var$dom.getHeight(node);
            });
            if (window.innerHeight - top - $116652c03be0baae$var$CLOSE_BUTTON_HEIGHT < h) {
                $116652c03be0baae$var$dom.addClass(root.domElement, $116652c03be0baae$var$GUI.CLASS_TOO_TALL);
                root.__ul.style.height = window.innerHeight - top - $116652c03be0baae$var$CLOSE_BUTTON_HEIGHT + 'px';
            } else {
                $116652c03be0baae$var$dom.removeClass(root.domElement, $116652c03be0baae$var$GUI.CLASS_TOO_TALL);
                root.__ul.style.height = 'auto';
            }
        }
        if (root.__resize_handle) $116652c03be0baae$var$Common.defer(function() {
            root.__resize_handle.style.height = root.__ul.offsetHeight + 'px';
        });
        if (root.__closeButton) root.__closeButton.style.width = root.width + 'px';
    },
    onResizeDebounced: $116652c03be0baae$var$Common.debounce(function() {
        this.onResize();
    }, 50),
    remember: function remember() {
        if ($116652c03be0baae$var$Common.isUndefined($116652c03be0baae$var$SAVE_DIALOGUE)) {
            $116652c03be0baae$var$SAVE_DIALOGUE = new $116652c03be0baae$var$CenteredDiv();
            $116652c03be0baae$var$SAVE_DIALOGUE.domElement.innerHTML = $116652c03be0baae$var$saveDialogContents;
        }
        if (this.parent) throw new Error('You can only call remember on a top level GUI.');
        var _this = this;
        $116652c03be0baae$var$Common.each(Array.prototype.slice.call(arguments), function(object) {
            if (_this.__rememberedObjects.length === 0) $116652c03be0baae$var$addSaveMenu(_this);
            if (_this.__rememberedObjects.indexOf(object) === -1) _this.__rememberedObjects.push(object);
        });
        if (this.autoPlace) $116652c03be0baae$var$setWidth(this, this.width);
    },
    getRoot: function getRoot() {
        var gui = this;
        while(gui.parent)gui = gui.parent;
        return gui;
    },
    getSaveObject: function getSaveObject() {
        var toReturn = this.load;
        toReturn.closed = this.closed;
        if (this.__rememberedObjects.length > 0) {
            toReturn.preset = this.preset;
            if (!toReturn.remembered) toReturn.remembered = {};
            toReturn.remembered[this.preset] = $116652c03be0baae$var$getCurrentPreset(this);
        }
        toReturn.folders = {};
        $116652c03be0baae$var$Common.each(this.__folders, function(element, key) {
            toReturn.folders[key] = element.getSaveObject();
        });
        return toReturn;
    },
    save: function save() {
        if (!this.load.remembered) this.load.remembered = {};
        this.load.remembered[this.preset] = $116652c03be0baae$var$getCurrentPreset(this);
        $116652c03be0baae$var$markPresetModified(this, false);
        this.saveToLocalStorageIfPossible();
    },
    saveAs: function saveAs(presetName) {
        if (!this.load.remembered) {
            this.load.remembered = {};
            this.load.remembered[$116652c03be0baae$var$DEFAULT_DEFAULT_PRESET_NAME] = $116652c03be0baae$var$getCurrentPreset(this, true);
        }
        this.load.remembered[presetName] = $116652c03be0baae$var$getCurrentPreset(this);
        this.preset = presetName;
        $116652c03be0baae$var$addPresetOption(this, presetName, true);
        this.saveToLocalStorageIfPossible();
    },
    revert: function revert(gui) {
        $116652c03be0baae$var$Common.each(this.__controllers, function(controller) {
            if (!this.getRoot().load.remembered) controller.setValue(controller.initialValue);
            else $116652c03be0baae$var$recallSavedValue(gui || this.getRoot(), controller);
            if (controller.__onFinishChange) controller.__onFinishChange.call(controller, controller.getValue());
        }, this);
        $116652c03be0baae$var$Common.each(this.__folders, function(folder) {
            folder.revert(folder);
        });
        if (!gui) $116652c03be0baae$var$markPresetModified(this.getRoot(), false);
    },
    listen: function listen(controller) {
        var init = this.__listening.length === 0;
        this.__listening.push(controller);
        if (init) $116652c03be0baae$var$updateDisplays(this.__listening);
    },
    updateDisplay: function updateDisplay() {
        $116652c03be0baae$var$Common.each(this.__controllers, function(controller) {
            controller.updateDisplay();
        });
        $116652c03be0baae$var$Common.each(this.__folders, function(folder) {
            folder.updateDisplay();
        });
    }
});
function $116652c03be0baae$var$addRow(gui, newDom, liBefore) {
    var li = document.createElement('li');
    if (newDom) li.appendChild(newDom);
    if (liBefore) gui.__ul.insertBefore(li, liBefore);
    else gui.__ul.appendChild(li);
    gui.onResize();
    return li;
}
function $116652c03be0baae$var$removeListeners(gui) {
    $116652c03be0baae$var$dom.unbind(window, 'resize', gui.__resizeHandler);
    if (gui.saveToLocalStorageIfPossible) $116652c03be0baae$var$dom.unbind(window, 'unload', gui.saveToLocalStorageIfPossible);
}
function $116652c03be0baae$var$markPresetModified(gui, modified) {
    var opt = gui.__preset_select[gui.__preset_select.selectedIndex];
    if (modified) opt.innerHTML = opt.value + '*';
    else opt.innerHTML = opt.value;
}
function $116652c03be0baae$var$augmentController(gui, li, controller) {
    controller.__li = li;
    controller.__gui = gui;
    $116652c03be0baae$var$Common.extend(controller, {
        options: function options(_options) {
            if (arguments.length > 1) {
                var nextSibling = controller.__li.nextElementSibling;
                controller.remove();
                return $116652c03be0baae$var$_add(gui, controller.object, controller.property, {
                    before: nextSibling,
                    factoryArgs: [
                        $116652c03be0baae$var$Common.toArray(arguments)
                    ]
                });
            }
            if ($116652c03be0baae$var$Common.isArray(_options) || $116652c03be0baae$var$Common.isObject(_options)) {
                var _nextSibling = controller.__li.nextElementSibling;
                controller.remove();
                return $116652c03be0baae$var$_add(gui, controller.object, controller.property, {
                    before: _nextSibling,
                    factoryArgs: [
                        _options
                    ]
                });
            }
        },
        name: function name(_name) {
            controller.__li.firstElementChild.firstElementChild.innerHTML = _name;
            return controller;
        },
        listen: function listen() {
            controller.__gui.listen(controller);
            return controller;
        },
        remove: function remove() {
            controller.__gui.remove(controller);
            return controller;
        }
    });
    if (controller instanceof $116652c03be0baae$var$NumberControllerSlider) {
        var box = new $116652c03be0baae$var$NumberControllerBox(controller.object, controller.property, {
            min: controller.__min,
            max: controller.__max,
            step: controller.__step
        });
        $116652c03be0baae$var$Common.each([
            'updateDisplay',
            'onChange',
            'onFinishChange',
            'step',
            'min',
            'max'
        ], function(method) {
            var pc = controller[method];
            var pb = box[method];
            controller[method] = box[method] = function() {
                var args = Array.prototype.slice.call(arguments);
                pb.apply(box, args);
                return pc.apply(controller, args);
            };
        });
        $116652c03be0baae$var$dom.addClass(li, 'has-slider');
        controller.domElement.insertBefore(box.domElement, controller.domElement.firstElementChild);
    } else if (controller instanceof $116652c03be0baae$var$NumberControllerBox) {
        var r = function r(returned) {
            if ($116652c03be0baae$var$Common.isNumber(controller.__min) && $116652c03be0baae$var$Common.isNumber(controller.__max)) {
                var oldName = controller.__li.firstElementChild.firstElementChild.innerHTML;
                var wasListening = controller.__gui.__listening.indexOf(controller) > -1;
                controller.remove();
                var newController = $116652c03be0baae$var$_add(gui, controller.object, controller.property, {
                    before: controller.__li.nextElementSibling,
                    factoryArgs: [
                        controller.__min,
                        controller.__max,
                        controller.__step
                    ]
                });
                newController.name(oldName);
                if (wasListening) newController.listen();
                return newController;
            }
            return returned;
        };
        controller.min = $116652c03be0baae$var$Common.compose(r, controller.min);
        controller.max = $116652c03be0baae$var$Common.compose(r, controller.max);
    } else if (controller instanceof $116652c03be0baae$var$BooleanController) {
        $116652c03be0baae$var$dom.bind(li, 'click', function() {
            $116652c03be0baae$var$dom.fakeEvent(controller.__checkbox, 'click');
        });
        $116652c03be0baae$var$dom.bind(controller.__checkbox, 'click', function(e) {
            e.stopPropagation();
        });
    } else if (controller instanceof $116652c03be0baae$var$FunctionController) {
        $116652c03be0baae$var$dom.bind(li, 'click', function() {
            $116652c03be0baae$var$dom.fakeEvent(controller.__button, 'click');
        });
        $116652c03be0baae$var$dom.bind(li, 'mouseover', function() {
            $116652c03be0baae$var$dom.addClass(controller.__button, 'hover');
        });
        $116652c03be0baae$var$dom.bind(li, 'mouseout', function() {
            $116652c03be0baae$var$dom.removeClass(controller.__button, 'hover');
        });
    } else if (controller instanceof $116652c03be0baae$var$ColorController) {
        $116652c03be0baae$var$dom.addClass(li, 'color');
        controller.updateDisplay = $116652c03be0baae$var$Common.compose(function(val) {
            li.style.borderLeftColor = controller.__color.toString();
            return val;
        }, controller.updateDisplay);
        controller.updateDisplay();
    }
    controller.setValue = $116652c03be0baae$var$Common.compose(function(val) {
        if (gui.getRoot().__preset_select && controller.isModified()) $116652c03be0baae$var$markPresetModified(gui.getRoot(), true);
        return val;
    }, controller.setValue);
}
function $116652c03be0baae$var$recallSavedValue(gui, controller) {
    var root = gui.getRoot();
    var matchedIndex = root.__rememberedObjects.indexOf(controller.object);
    if (matchedIndex !== -1) {
        var controllerMap = root.__rememberedObjectIndecesToControllers[matchedIndex];
        if (controllerMap === undefined) {
            controllerMap = {};
            root.__rememberedObjectIndecesToControllers[matchedIndex] = controllerMap;
        }
        controllerMap[controller.property] = controller;
        if (root.load && root.load.remembered) {
            var presetMap = root.load.remembered;
            var preset = void 0;
            if (presetMap[gui.preset]) preset = presetMap[gui.preset];
            else if (presetMap[$116652c03be0baae$var$DEFAULT_DEFAULT_PRESET_NAME]) preset = presetMap[$116652c03be0baae$var$DEFAULT_DEFAULT_PRESET_NAME];
            else return;
            if (preset[matchedIndex] && preset[matchedIndex][controller.property] !== undefined) {
                var value = preset[matchedIndex][controller.property];
                controller.initialValue = value;
                controller.setValue(value);
            }
        }
    }
}
function $116652c03be0baae$var$_add(gui, object, property, params) {
    if (object[property] === undefined) throw new Error('Object "' + object + '" has no property "' + property + '"');
    var controller = void 0;
    if (params.color) controller = new $116652c03be0baae$var$ColorController(object, property);
    else {
        var factoryArgs = [
            object,
            property
        ].concat(params.factoryArgs);
        controller = $116652c03be0baae$var$ControllerFactory.apply(gui, factoryArgs);
    }
    if (params.before instanceof $116652c03be0baae$var$Controller) params.before = params.before.__li;
    $116652c03be0baae$var$recallSavedValue(gui, controller);
    $116652c03be0baae$var$dom.addClass(controller.domElement, 'c');
    var name = document.createElement('span');
    $116652c03be0baae$var$dom.addClass(name, 'property-name');
    name.innerHTML = controller.property;
    var container = document.createElement('div');
    container.appendChild(name);
    container.appendChild(controller.domElement);
    var li = $116652c03be0baae$var$addRow(gui, container, params.before);
    $116652c03be0baae$var$dom.addClass(li, $116652c03be0baae$var$GUI.CLASS_CONTROLLER_ROW);
    if (controller instanceof $116652c03be0baae$var$ColorController) $116652c03be0baae$var$dom.addClass(li, 'color');
    else $116652c03be0baae$var$dom.addClass(li, $116652c03be0baae$var$_typeof(controller.getValue()));
    $116652c03be0baae$var$augmentController(gui, li, controller);
    gui.__controllers.push(controller);
    return controller;
}
function $116652c03be0baae$var$getLocalStorageHash(gui, key) {
    return document.location.href + '.' + key;
}
function $116652c03be0baae$var$addPresetOption(gui, name, setSelected) {
    var opt = document.createElement('option');
    opt.innerHTML = name;
    opt.value = name;
    gui.__preset_select.appendChild(opt);
    if (setSelected) gui.__preset_select.selectedIndex = gui.__preset_select.length - 1;
}
function $116652c03be0baae$var$showHideExplain(gui, explain) {
    explain.style.display = gui.useLocalStorage ? 'block' : 'none';
}
function $116652c03be0baae$var$addSaveMenu(gui) {
    var div = gui.__save_row = document.createElement('li');
    $116652c03be0baae$var$dom.addClass(gui.domElement, 'has-save');
    gui.__ul.insertBefore(div, gui.__ul.firstChild);
    $116652c03be0baae$var$dom.addClass(div, 'save-row');
    var gears = document.createElement('span');
    gears.innerHTML = '&nbsp;';
    $116652c03be0baae$var$dom.addClass(gears, 'button gears');
    var button = document.createElement('span');
    button.innerHTML = 'Save';
    $116652c03be0baae$var$dom.addClass(button, 'button');
    $116652c03be0baae$var$dom.addClass(button, 'save');
    var button2 = document.createElement('span');
    button2.innerHTML = 'New';
    $116652c03be0baae$var$dom.addClass(button2, 'button');
    $116652c03be0baae$var$dom.addClass(button2, 'save-as');
    var button3 = document.createElement('span');
    button3.innerHTML = 'Revert';
    $116652c03be0baae$var$dom.addClass(button3, 'button');
    $116652c03be0baae$var$dom.addClass(button3, 'revert');
    var select = gui.__preset_select = document.createElement('select');
    if (gui.load && gui.load.remembered) $116652c03be0baae$var$Common.each(gui.load.remembered, function(value, key) {
        $116652c03be0baae$var$addPresetOption(gui, key, key === gui.preset);
    });
    else $116652c03be0baae$var$addPresetOption(gui, $116652c03be0baae$var$DEFAULT_DEFAULT_PRESET_NAME, false);
    $116652c03be0baae$var$dom.bind(select, 'change', function() {
        for(var index = 0; index < gui.__preset_select.length; index++)gui.__preset_select[index].innerHTML = gui.__preset_select[index].value;
        gui.preset = this.value;
    });
    div.appendChild(select);
    div.appendChild(gears);
    div.appendChild(button);
    div.appendChild(button2);
    div.appendChild(button3);
    if ($116652c03be0baae$var$SUPPORTS_LOCAL_STORAGE) {
        var explain = document.getElementById('dg-local-explain');
        var localStorageCheckBox = document.getElementById('dg-local-storage');
        var saveLocally = document.getElementById('dg-save-locally');
        saveLocally.style.display = 'block';
        if (localStorage.getItem($116652c03be0baae$var$getLocalStorageHash(gui, 'isLocal')) === 'true') localStorageCheckBox.setAttribute('checked', 'checked');
        $116652c03be0baae$var$showHideExplain(gui, explain);
        $116652c03be0baae$var$dom.bind(localStorageCheckBox, 'change', function() {
            gui.useLocalStorage = !gui.useLocalStorage;
            $116652c03be0baae$var$showHideExplain(gui, explain);
        });
    }
    var newConstructorTextArea = document.getElementById('dg-new-constructor');
    $116652c03be0baae$var$dom.bind(newConstructorTextArea, 'keydown', function(e) {
        if (e.metaKey && (e.which === 67 || e.keyCode === 67)) $116652c03be0baae$var$SAVE_DIALOGUE.hide();
    });
    $116652c03be0baae$var$dom.bind(gears, 'click', function() {
        newConstructorTextArea.innerHTML = JSON.stringify(gui.getSaveObject(), undefined, 2);
        $116652c03be0baae$var$SAVE_DIALOGUE.show();
        newConstructorTextArea.focus();
        newConstructorTextArea.select();
    });
    $116652c03be0baae$var$dom.bind(button, 'click', function() {
        gui.save();
    });
    $116652c03be0baae$var$dom.bind(button2, 'click', function() {
        var presetName = prompt('Enter a new preset name.');
        if (presetName) gui.saveAs(presetName);
    });
    $116652c03be0baae$var$dom.bind(button3, 'click', function() {
        gui.revert();
    });
}
function $116652c03be0baae$var$addResizeHandle(gui) {
    var pmouseX = void 0;
    gui.__resize_handle = document.createElement('div');
    $116652c03be0baae$var$Common.extend(gui.__resize_handle.style, {
        width: '6px',
        marginLeft: '-3px',
        height: '200px',
        cursor: 'ew-resize',
        position: 'absolute'
    });
    function drag(e) {
        e.preventDefault();
        gui.width += pmouseX - e.clientX;
        gui.onResize();
        pmouseX = e.clientX;
        return false;
    }
    function dragStop() {
        $116652c03be0baae$var$dom.removeClass(gui.__closeButton, $116652c03be0baae$var$GUI.CLASS_DRAG);
        $116652c03be0baae$var$dom.unbind(window, 'mousemove', drag);
        $116652c03be0baae$var$dom.unbind(window, 'mouseup', dragStop);
    }
    function dragStart(e) {
        e.preventDefault();
        pmouseX = e.clientX;
        $116652c03be0baae$var$dom.addClass(gui.__closeButton, $116652c03be0baae$var$GUI.CLASS_DRAG);
        $116652c03be0baae$var$dom.bind(window, 'mousemove', drag);
        $116652c03be0baae$var$dom.bind(window, 'mouseup', dragStop);
        return false;
    }
    $116652c03be0baae$var$dom.bind(gui.__resize_handle, 'mousedown', dragStart);
    $116652c03be0baae$var$dom.bind(gui.__closeButton, 'mousedown', dragStart);
    gui.domElement.insertBefore(gui.__resize_handle, gui.domElement.firstElementChild);
}
function $116652c03be0baae$var$setWidth(gui, w) {
    gui.domElement.style.width = w + 'px';
    if (gui.__save_row && gui.autoPlace) gui.__save_row.style.width = w + 'px';
    if (gui.__closeButton) gui.__closeButton.style.width = w + 'px';
}
function $116652c03be0baae$var$getCurrentPreset(gui, useInitialValues) {
    var toReturn = {};
    $116652c03be0baae$var$Common.each(gui.__rememberedObjects, function(val, index) {
        var savedValues = {};
        var controllerMap = gui.__rememberedObjectIndecesToControllers[index];
        $116652c03be0baae$var$Common.each(controllerMap, function(controller, property) {
            savedValues[property] = useInitialValues ? controller.initialValue : controller.getValue();
        });
        toReturn[index] = savedValues;
    });
    return toReturn;
}
function $116652c03be0baae$var$setPresetSelectIndex(gui) {
    for(var index = 0; index < gui.__preset_select.length; index++)if (gui.__preset_select[index].value === gui.preset) gui.__preset_select.selectedIndex = index;
}
function $116652c03be0baae$var$updateDisplays(controllerArray) {
    if (controllerArray.length !== 0) $116652c03be0baae$var$requestAnimationFrame$1.call(window, function() {
        $116652c03be0baae$var$updateDisplays(controllerArray);
    });
    $116652c03be0baae$var$Common.each(controllerArray, function(c) {
        c.updateDisplay();
    });
}
var $116652c03be0baae$export$35e9368ef982300f = {
    Color: $116652c03be0baae$var$Color,
    math: $116652c03be0baae$var$ColorMath,
    interpret: $116652c03be0baae$var$interpret
};
var $116652c03be0baae$export$a6506504f799c5d5 = {
    Controller: $116652c03be0baae$var$Controller,
    BooleanController: $116652c03be0baae$var$BooleanController,
    OptionController: $116652c03be0baae$var$OptionController,
    StringController: $116652c03be0baae$var$StringController,
    NumberController: $116652c03be0baae$var$NumberController,
    NumberControllerBox: $116652c03be0baae$var$NumberControllerBox,
    NumberControllerSlider: $116652c03be0baae$var$NumberControllerSlider,
    FunctionController: $116652c03be0baae$var$FunctionController,
    ColorController: $116652c03be0baae$var$ColorController
};
var $116652c03be0baae$export$df3a06d6289f983e = {
    dom: $116652c03be0baae$var$dom
};
var $116652c03be0baae$export$6367ea12ae86a4eb = {
    GUI: $116652c03be0baae$var$GUI
};
var $116652c03be0baae$export$983832d820c96993 = $116652c03be0baae$var$GUI;
var $116652c03be0baae$var$index = {
    color: $116652c03be0baae$export$35e9368ef982300f,
    controllers: $116652c03be0baae$export$a6506504f799c5d5,
    dom: $116652c03be0baae$export$df3a06d6289f983e,
    gui: $116652c03be0baae$export$6367ea12ae86a4eb,
    GUI: $116652c03be0baae$export$983832d820c96993
};
var $116652c03be0baae$export$2e2bcd8739ae039 = $116652c03be0baae$var$index;





function $6fd974a9bd48a893$var$rot2quat(rot_dir, rot_angle) {
    let s = Math.sin(rot_angle / 2);
    return [
        Math.cos(rot_angle / 2),
        rot_dir.x * s,
        rot_dir.y * s,
        rot_dir.z * s
    ];
}
function $6fd974a9bd48a893$var$dir2quat(d) {
    let rot_angle = 0;
    let rot_dir = d;
    if ((0, $347b986847663c76$export$e6f70e714c0fa418)(d, (0, $347b986847663c76$export$1eeca8128376e4e9))) rot_angle = Math.PI;
    else if ((0, $347b986847663c76$export$e6f70e714c0fa418)(d, (0, $347b986847663c76$export$f981f70d61d1405a))) {
        rot_angle = -Math.PI / 2;
        rot_dir = (0, $347b986847663c76$export$51ec4a2fc467eaa7);
    } else if ((0, $347b986847663c76$export$e6f70e714c0fa418)(d, (0, $347b986847663c76$export$1cac5500365a4eb4))) {
        rot_angle = Math.PI / 2;
        rot_dir = (0, $347b986847663c76$export$51ec4a2fc467eaa7);
    } else if ((0, $347b986847663c76$export$e6f70e714c0fa418)(d, (0, $347b986847663c76$export$50e63dfb05a215ef))) {
        rot_angle = -Math.PI / 2;
        rot_dir = (0, $347b986847663c76$export$f981f70d61d1405a);
    } else if ((0, $347b986847663c76$export$e6f70e714c0fa418)(d, (0, $347b986847663c76$export$d73203a818a78b30))) {
        rot_angle = Math.PI / 2;
        rot_dir = (0, $347b986847663c76$export$f981f70d61d1405a);
    }
    return $6fd974a9bd48a893$var$rot2quat(rot_dir, rot_angle);
}
function $6fd974a9bd48a893$export$2e2bcd8739ae039(algo, _currentConfig, r, mixer, arrowOpacity, fake = false) {
    const geometry = new $ee56638efea8544d$export$33e43285f7406bd5(8, 8, 8);
    let materials;
    let dir;
    if (!fake) {
        dir = (0, $347b986847663c76$export$17045a50f8f50a6c)(algo, _currentConfig, r.pos);
        if ((0, $347b986847663c76$export$e6f70e714c0fa418)(dir[0], (0, $347b986847663c76$export$49984ede44adf88d))) materials = new $ee56638efea8544d$export$24c72f71cbaf0678({
            color: algo.options.colors[r.color] || 0x555555,
            flatShading: true
        });
        else {
            materials = [];
            for(let i = 0; i < 6; i++){
                const material = new $ee56638efea8544d$export$24c72f71cbaf0678();
                let canvas = document.createElement('canvas');
                let ctx = canvas.getContext('2d');
                ctx.fillStyle = "#" + (algo.options.colors[r.color] || 0x555555).toString(16).padStart(6, '0');
                ctx.fillRect(0, 0, 300, 300);
                ctx.globalAlpha = arrowOpacity;
                if (i == 2 || i == 3 || i == 4) {
                    ctx.strokeStyle = "#000000";
                    ctx.lineWidth = 10;
                    ctx.beginPath();
                    ctx.moveTo(0, 75);
                    ctx.lineTo(300, 75);
                    ctx.moveTo(300, 75);
                    ctx.lineTo(200, 20);
                    ctx.moveTo(300, 75);
                    ctx.lineTo(200, 130);
                    ctx.stroke();
                } else if (i == 5) {
                    ctx.strokeStyle = "#000000";
                    ctx.lineWidth = 10;
                    ctx.beginPath();
                    ctx.moveTo(300, 75);
                    ctx.lineTo(0, 75);
                    ctx.moveTo(0, 75);
                    ctx.lineTo(100, 20);
                    ctx.moveTo(0, 75);
                    ctx.lineTo(100, 130);
                    ctx.stroke();
                } else if (i == 0) {
                    ctx.strokeStyle = "#000000";
                    ctx.lineWidth = 10;
                    ctx.beginPath();
                    ctx.moveTo(75, 37.5);
                    ctx.lineTo(225, 112.5);
                    ctx.moveTo(225, 37.5);
                    ctx.lineTo(75, 112.5);
                    ctx.stroke();
                } else if (i == 1) {
                    ctx.fillStyle = "#000000";
                    ctx.beginPath();
                    ctx.arc(150, 75, 20, 0, 2 * Math.PI);
                    ctx.fill();
                }
                material.map = new $ee56638efea8544d$export$f7189e49152d1c13(canvas);
                materials.push(material);
            }
        }
    } else {
        materials = new $ee56638efea8544d$export$24c72f71cbaf0678({
            color: algo.options.colors[r.color] || 0x555555
        });
        materials.transparent = true;
        materials.opacity = 0.35;
    }
    let mesh = new $ee56638efea8544d$export$e176487c05830cc5(geometry, materials);
    mesh.position.x = r.pos.y * 10;
    mesh.position.y = r.pos.z * 10;
    mesh.position.z = r.pos.x * 10;
    mesh.castShadow = true;
    mesh.robotPos = r.pos; /*
                              if(directionEquals(dir[0], BACK)) {
                                 mesh.rotateY(Math.PI);
                             } else if(directionEquals(dir[0], LEFT)) {
                                 mesh.rotateY(Math.PI/2);
                             } else if(directionEquals(dir[0], RIGHT)) {
                                 mesh.rotateY(-Math.PI/2);
                             } else if(directionEquals(dir[0], ABOVE)) {
                                 mesh.rotateZ(Math.PI/2);
                             } else if(directionEquals(dir[0], BELOW)) {
                                 mesh.rotateZ(-Math.PI/2);
                             }
                             */ 
    if (!fake) {
        let timing = [];
        let quaterions = [];
        for (let d of dir){
            timing.push(timing.length);
            quaterions = quaterions.concat($6fd974a9bd48a893$var$dir2quat(d));
        }
        timing.push(timing.length);
        quaterions = quaterions.concat($6fd974a9bd48a893$var$dir2quat(dir[0]));
        let kf = new $ee56638efea8544d$export$b8043f12b5aafbd7('.quaternion', timing, quaterions);
        const clip = new $ee56638efea8544d$export$d942c706bf23829c('Action', -1, [
            kf
        ]);
        mixer.clipAction(clip, mesh).play();
    }
    return mesh;
}


function $fd1e808429d42ba4$export$61fc7d43ac8f84b0(func, wait, context = {}) {
    let timeout;
    return function() {
        const ctx = context || this, args = arguments;
        const later = function() {
            timeout = undefined;
            func.apply(ctx, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}


let $e0c9aa0e5bb8bd29$var$requestInit = ()=>{};
let $e0c9aa0e5bb8bd29$var$requestUpdate = ()=>{};
const $e0c9aa0e5bb8bd29$var$guiOptions = {
    nodeOpacity: 0.1,
    arrowOpacity: 0.7
};
const $e0c9aa0e5bb8bd29$var$gui = new (0, $116652c03be0baae$export$983832d820c96993)(); //{ autoPlace: false });
$e0c9aa0e5bb8bd29$var$gui.domElement.id = 'gui';
const $e0c9aa0e5bb8bd29$var$sceneGui = $e0c9aa0e5bb8bd29$var$gui.addFolder('Scene');
$e0c9aa0e5bb8bd29$var$sceneGui.add($e0c9aa0e5bb8bd29$var$guiOptions, 'nodeOpacity', 0, 1).onChange(function() {
    $e0c9aa0e5bb8bd29$var$requestInit();
});
$e0c9aa0e5bb8bd29$var$sceneGui.add($e0c9aa0e5bb8bd29$var$guiOptions, 'arrowOpacity', 0, 1).onChange(function() {
    $e0c9aa0e5bb8bd29$var$requestUpdate();
});
$e0c9aa0e5bb8bd29$var$gui.close();
let $e0c9aa0e5bb8bd29$var$scene = null;
let $e0c9aa0e5bb8bd29$var$camera = null;
let $e0c9aa0e5bb8bd29$var$gridHelper = null;
let $e0c9aa0e5bb8bd29$var$clock = null;
let $e0c9aa0e5bb8bd29$var$clockDeltaThrottle = 0;
let $e0c9aa0e5bb8bd29$var$mixer = null;
let $e0c9aa0e5bb8bd29$var$robotMesh = [];
let $e0c9aa0e5bb8bd29$var$nodeMarker = {};
let $e0c9aa0e5bb8bd29$var$nodeMarkerList = [];
let $e0c9aa0e5bb8bd29$var$algo = null;
let $e0c9aa0e5bb8bd29$var$currentConfig = null;
let $e0c9aa0e5bb8bd29$var$threeContainer = null;
const $e0c9aa0e5bb8bd29$export$1fe590ebb04610e5 = {
    printMarker: false
};
function $e0c9aa0e5bb8bd29$var$getCanvasDimensions() {
    return [
        $e0c9aa0e5bb8bd29$var$threeContainer.offsetWidth,
        $e0c9aa0e5bb8bd29$var$threeContainer.offsetHeight
    ];
}
let $e0c9aa0e5bb8bd29$var$renderer = null;
function $e0c9aa0e5bb8bd29$export$4aa259f2a0167a49() {
    return $e0c9aa0e5bb8bd29$var$renderer;
}
function $e0c9aa0e5bb8bd29$export$185802fd694ee1f5(container, _algo) {
    $e0c9aa0e5bb8bd29$var$algo = _algo;
    $e0c9aa0e5bb8bd29$var$scene = new $ee56638efea8544d$export$38af1803e3442a7f();
    $e0c9aa0e5bb8bd29$var$scene.background = new $ee56638efea8544d$export$892596cec99bc70e(0xf0f0f0);
    $e0c9aa0e5bb8bd29$var$clock = new $ee56638efea8544d$export$9735c82c4bae3302();
    $e0c9aa0e5bb8bd29$var$mixer = new $ee56638efea8544d$export$fbd77e5aefaa0102();
    const dirLight1 = new $ee56638efea8544d$export$3fea33cc9972c868(0xffffff);
    dirLight1.position.set(0.9, 0.7, 1);
    dirLight1.target.position.set(0, 0, 0);
    dirLight1.castShadow = true;
    dirLight1.shadow.mapSize.width = 1024;
    dirLight1.shadow.mapSize.height = 1024;
    $e0c9aa0e5bb8bd29$var$scene.add(dirLight1);
    const dirLight2 = new $ee56638efea8544d$export$3fea33cc9972c868(0x999999);
    dirLight2.position.set(-0.6, -0.6, -1);
    $e0c9aa0e5bb8bd29$var$scene.add(dirLight2);
    const ambientLight = new $ee56638efea8544d$export$af279bfef9ec2c96(0x999999);
    $e0c9aa0e5bb8bd29$var$scene.add(ambientLight); //var shadowHelper = new THREE.CameraHelper( dirLight1.shadow.camera );
    //scene.add( shadowHelper );
    const planeGeometry = new $ee56638efea8544d$export$967d831af31f69ce(2000, 2000);
    planeGeometry.rotateX(-Math.PI / 2);
    const planeMaterial = new $ee56638efea8544d$export$e8564da406055a3({
        opacity: 1
    });
    const plane = new $ee56638efea8544d$export$e176487c05830cc5(planeGeometry, planeMaterial);
    plane.position.y = -1;
    plane.receiveShadow = true;
    $e0c9aa0e5bb8bd29$var$scene.add(plane);
    $e0c9aa0e5bb8bd29$var$gridHelper = [];
    $e0c9aa0e5bb8bd29$var$renderer = new $54cdb8f680e2b923$export$f6cc00ef28d7cf97({
        antialias: true
    }); //renderer.shadowMap.enabled = true;
    $e0c9aa0e5bb8bd29$var$threeContainer = document.getElementById('three-container');
    $e0c9aa0e5bb8bd29$var$threeContainer.appendChild($e0c9aa0e5bb8bd29$var$renderer.domElement);
    window.addEventListener('resize', onWindowResize, false);
    $e0c9aa0e5bb8bd29$var$setupOnClickEvent();
    const frustumSize = 100;
    const [W, H] = $e0c9aa0e5bb8bd29$var$getCanvasDimensions();
    const aspect = W / H; //camera = new THREE.PerspectiveCamera( 75, aspect, 0.1, 1000 );
    $e0c9aa0e5bb8bd29$var$camera = new $ee56638efea8544d$export$9ebf355ee4ed261b(frustumSize * aspect / -2, frustumSize * aspect / 2, frustumSize / 2, frustumSize / -2, 1, 1000); //camera.position.set( 200, 150, 300 );
    $e0c9aa0e5bb8bd29$var$camera.position.set(-200, 150, 200);
    $e0c9aa0e5bb8bd29$var$camera.zoom = 0.7;
    function onWindowResize() {
        const [W, H] = $e0c9aa0e5bb8bd29$var$getCanvasDimensions();
        $e0c9aa0e5bb8bd29$var$renderer.setSize(W, H);
        const aspect = W / H;
        $e0c9aa0e5bb8bd29$var$camera.aspect = aspect;
        $e0c9aa0e5bb8bd29$var$camera.left = frustumSize * aspect / -2;
        $e0c9aa0e5bb8bd29$var$camera.right = frustumSize * aspect / 2;
        $e0c9aa0e5bb8bd29$var$camera.top = frustumSize / 2;
        $e0c9aa0e5bb8bd29$var$camera.bottom = -frustumSize / 2;
        $e0c9aa0e5bb8bd29$var$camera.updateProjectionMatrix();
    }
    onWindowResize(); // Controls
    const controls = new (0, $db77f41475ae732a$export$8ff7788029dfdf52)($e0c9aa0e5bb8bd29$var$camera, $e0c9aa0e5bb8bd29$var$renderer.domElement);
    controls.damping = 0.2;
    controls.target.x = 50;
    controls.target.y = 25;
    controls.target.z = 50;
    controls.addEventListener('change', render);
    controls.update();
    setTimeout(()=>{
        if ($e0c9aa0e5bb8bd29$var$algo.options.dimension === 2) {
            const currentConfigSize = $e0c9aa0e5bb8bd29$var$algo.options.walls[1].slice();
            $e0c9aa0e5bb8bd29$var$camera.position.set(currentConfigSize[0] * 10 / 2 - 1, 150, currentConfigSize[1] * 10 / 2);
            $e0c9aa0e5bb8bd29$var$camera.rotation.y += Math.PI / 2;
            $e0c9aa0e5bb8bd29$var$camera.zoom = 0.3;
            controls.target.x = currentConfigSize[0] * 10 / 2;
            controls.target.y = 25;
            controls.target.z = currentConfigSize[1] * 10 / 2;
            controls.update();
        }
    }, 400);
    const stats = (0, $3a6a618a8ab498ec$export$2e2bcd8739ae039)();
    document.body.appendChild(stats.dom);
    stats.dom.style.top = 'auto';
    stats.dom.style.bottom = '0';
    $e0c9aa0e5bb8bd29$var$sceneGui.add(stats.dom.style, 'display').options({
        visible: 'block',
        hidden: 'none'
    }).name('Stats').setValue('none');
    function animate() {
        requestAnimationFrame(animate);
        controls.update();
        $e0c9aa0e5bb8bd29$var$camera.updateProjectionMatrix();
        stats.update();
        render();
    }
    function render() {
        if ($e0c9aa0e5bb8bd29$var$mixer) {
            let delta = $e0c9aa0e5bb8bd29$var$clock.getDelta();
            $e0c9aa0e5bb8bd29$var$clockDeltaThrottle += delta;
            if ($e0c9aa0e5bb8bd29$var$clockDeltaThrottle >= 1) {
                $e0c9aa0e5bb8bd29$var$clockDeltaThrottle -= 1;
                if ($e0c9aa0e5bb8bd29$var$clockDeltaThrottle > 0.5) $e0c9aa0e5bb8bd29$var$clockDeltaThrottle = 0.5;
                $e0c9aa0e5bb8bd29$var$mixer.update(1);
            }
        }
        $e0c9aa0e5bb8bd29$var$renderer.render($e0c9aa0e5bb8bd29$var$scene, $e0c9aa0e5bb8bd29$var$camera);
    }
    render();
    animate();
}
function $e0c9aa0e5bb8bd29$var$setupOnClickEvent() {
    const raycaster = new $ee56638efea8544d$export$8b7aaceff00bd2f();
    const mouse = new $ee56638efea8544d$export$c977b3e384af9ae1();
    $e0c9aa0e5bb8bd29$var$threeContainer.addEventListener('click', onClick, false);
    function onClick(event) {
        event.stopPropagation();
        let [w, h] = $e0c9aa0e5bb8bd29$var$getCanvasDimensions();
        mouse.x = event.clientX / w * 2 - 1;
        mouse.y = -(event.clientY / h) * 2 + 1; // update the picking ray with the camera and mouse position
        raycaster.setFromCamera(mouse, $e0c9aa0e5bb8bd29$var$camera); // calculate objects intersecting the picking ray
        const intersects = raycaster.intersectObjects($e0c9aa0e5bb8bd29$var$scene.children);
        for(let i = 0; i < intersects.length; i++)if (intersects[i].object.robotPos) {
            let pos = intersects[i].object.robotPos;
            (0, $818bb3bf843b8c76$export$87422747c43910fd)($e0c9aa0e5bb8bd29$var$currentConfig.getView(pos, $e0c9aa0e5bb8bd29$var$algo.options.visibilityRange, $e0c9aa0e5bb8bd29$var$algo.options.dimension));
            console.log((0, $347b986847663c76$export$ea40dd710081b328)($e0c9aa0e5bb8bd29$var$currentConfig.getView(pos, $e0c9aa0e5bb8bd29$var$algo.options.visibilityRange, $e0c9aa0e5bb8bd29$var$algo.options.dimension), 3, {
                dest: 'idle'
            }));
            break;
        }
    }
}
let $e0c9aa0e5bb8bd29$var$cubeGrid = []; //TODO: Move the grid (now positions starts at 0,0,0)
function $e0c9aa0e5bb8bd29$export$2cd8252107eb640b(_currentConfig, algo) {
    $e0c9aa0e5bb8bd29$var$requestInit = (0, $fd1e808429d42ba4$export$61fc7d43ac8f84b0)(()=>$e0c9aa0e5bb8bd29$export$2cd8252107eb640b(_currentConfig, algo), 500);
    $e0c9aa0e5bb8bd29$var$currentConfig = _currentConfig;
    if ($e0c9aa0e5bb8bd29$var$gridHelper != null) {
        $e0c9aa0e5bb8bd29$var$gridHelper.forEach((l)=>$e0c9aa0e5bb8bd29$var$scene.remove(l));
        const currentConfigSize = algo.options.walls[1].slice();
        const material = new $ee56638efea8544d$export$fbaaa33907730a0c({
            color: 0x999999
        }); //material.opacity = 0.25;
        //material.transparent = true;
        for(let x = 0; x < currentConfigSize[0]; x++){
            const points = [];
            points.push(new $ee56638efea8544d$export$64b5c384219d3699(0, -5, x * 10));
            points.push(new $ee56638efea8544d$export$64b5c384219d3699(10 * (currentConfigSize[1] - 1), -5, x * 10));
            const geometry = new $ee56638efea8544d$export$b7be63a67df8959().setFromPoints(points);
            const line = new $ee56638efea8544d$export$17d680238e50603e(geometry, material);
            $e0c9aa0e5bb8bd29$var$scene.add(line);
            $e0c9aa0e5bb8bd29$var$gridHelper.push(line);
        }
        for(let y = 0; y < currentConfigSize[1]; y++){
            const points = [];
            points.push(new $ee56638efea8544d$export$64b5c384219d3699(y * 10, -5, 0));
            points.push(new $ee56638efea8544d$export$64b5c384219d3699(y * 10, -5, 10 * (currentConfigSize[0] - 1)));
            const geometry = new $ee56638efea8544d$export$b7be63a67df8959().setFromPoints(points);
            const line = new $ee56638efea8544d$export$17d680238e50603e(geometry, material);
            $e0c9aa0e5bb8bd29$var$scene.add(line);
            $e0c9aa0e5bb8bd29$var$gridHelper.push(line);
        } /*const maxConfigSize = Math.max(currentConfigSize[0],currentConfigSize[1]) - 2;
      gridHelper = new THREE.GridHelper( 10*maxConfigSize, maxConfigSize);
      gridHelper.position.y = 0;
      gridHelper.position.x = 10*(maxConfigSize+2)/2;
      gridHelper.position.z = 10*(maxConfigSize+2)/2;
      gridHelper.material.opacity = 0.25;
      gridHelper.material.transparent = true;*/ 
    }
    $e0c9aa0e5bb8bd29$var$cubeGrid.forEach((c)=>$e0c9aa0e5bb8bd29$var$scene.remove(c));
    $e0c9aa0e5bb8bd29$var$cubeGrid = [];
    if (algo.options.walls) {
        let [sx, sy, sz] = algo.options.walls[0];
        let [ex, ey, ez] = algo.options.walls[1];
        $e0c9aa0e5bb8bd29$var$nodeMarkerList.forEach((c)=>$e0c9aa0e5bb8bd29$var$scene.remove(c));
        $e0c9aa0e5bb8bd29$var$nodeMarker = {};
        for(let y = sy; y < ey; y++){
            for(let x = sx; x < ex; x++)for(let z = sz; z < ez; z++){
                const geometry = new $ee56638efea8544d$export$1b417fc3b307a251(1, 2, 2);
                const material = new $ee56638efea8544d$export$55cbcc9b622fe1f5({
                    color: 0x000000
                });
                const sphere = new $ee56638efea8544d$export$e176487c05830cc5(geometry, material);
                sphere.position.x = y * 10;
                sphere.position.y = z * 10;
                sphere.position.z = x * 10;
                sphere.material.opacity = $e0c9aa0e5bb8bd29$var$guiOptions.nodeOpacity;
                sphere.material.transparent = true;
                $e0c9aa0e5bb8bd29$var$cubeGrid.push(sphere);
                $e0c9aa0e5bb8bd29$var$scene.add(sphere);
            }
        }
        if ($e0c9aa0e5bb8bd29$export$1fe590ebb04610e5.printMarker) for(let x = sx + 1; x < ex; x++){
            $e0c9aa0e5bb8bd29$var$nodeMarker[x] = {};
            for(let y = sy + 1; y < ey; y++){
                $e0c9aa0e5bb8bd29$var$nodeMarker[x][y] = {};
                for(let z = sz + 1; z < ez; z++){
                    const geometry = new $ee56638efea8544d$export$1b417fc3b307a251(0.3, 4, 4);
                    const material = new $ee56638efea8544d$export$55cbcc9b622fe1f5({
                        color: 0xFF0000
                    });
                    const sphere = new $ee56638efea8544d$export$e176487c05830cc5(geometry, material);
                    sphere.position.x = y * 10;
                    sphere.position.y = z * 10;
                    sphere.position.z = x * 10;
                    sphere.material.opacity = 1;
                    sphere.material.transparent = false;
                    $e0c9aa0e5bb8bd29$var$nodeMarker[x][y][z] = sphere;
                    $e0c9aa0e5bb8bd29$var$scene.add(sphere);
                    $e0c9aa0e5bb8bd29$var$nodeMarkerList.push(sphere);
                }
            }
        }
    }
    $e0c9aa0e5bb8bd29$export$da3a242fdc570d73($e0c9aa0e5bb8bd29$var$currentConfig, algo);
}
function $e0c9aa0e5bb8bd29$export$da3a242fdc570d73(_currentConfig, algo) {
    $e0c9aa0e5bb8bd29$var$requestUpdate = (0, $fd1e808429d42ba4$export$61fc7d43ac8f84b0)(()=>$e0c9aa0e5bb8bd29$export$da3a242fdc570d73(_currentConfig, algo), 100);
    $e0c9aa0e5bb8bd29$var$currentConfig = _currentConfig;
    $e0c9aa0e5bb8bd29$var$robotMesh.forEach((m)=>$e0c9aa0e5bb8bd29$var$scene.remove(m));
    $e0c9aa0e5bb8bd29$var$robotMesh = [];
    $e0c9aa0e5bb8bd29$var$currentConfig.robots().forEach((r)=>{
        //if(r.color == 'W') return;
        let mesh = (0, $6fd974a9bd48a893$export$2e2bcd8739ae039)(algo, _currentConfig, r, $e0c9aa0e5bb8bd29$var$mixer, $e0c9aa0e5bb8bd29$var$guiOptions.arrowOpacity);
        $e0c9aa0e5bb8bd29$var$scene.add(mesh);
        $e0c9aa0e5bb8bd29$var$robotMesh.push(mesh);
        if ($e0c9aa0e5bb8bd29$export$1fe590ebb04610e5.printMarker && $e0c9aa0e5bb8bd29$var$nodeMarker[r.pos.x][r.pos.y][r.pos.z]) {
            $e0c9aa0e5bb8bd29$var$scene.remove($e0c9aa0e5bb8bd29$var$nodeMarker[r.pos.x][r.pos.y][r.pos.z]);
            $e0c9aa0e5bb8bd29$var$nodeMarker[r.pos.x][r.pos.y][r.pos.z] = null;
        }
    });
    if ($e0c9aa0e5bb8bd29$var$currentConfig.topology.type === 'torus') $e0c9aa0e5bb8bd29$var$currentConfig.robots().forEach((r)=>{
        if (r.color == 'W') return;
        for (let [offx, offy] of [
            [
                1,
                0
            ],
            [
                -1,
                0
            ],
            [
                0,
                -1
            ],
            [
                0,
                1
            ],
            [
                1,
                1
            ],
            [
                -1,
                -1
            ],
            [
                1,
                -1
            ],
            [
                -1,
                1
            ]
        ]){
            const fake_r = {
                ...r,
                pos: new (0, $fcbf04e630656d3a$export$13807d9ee5a34a42)(r.pos.x + offx * $e0c9aa0e5bb8bd29$var$currentConfig.topology.x, r.pos.y + offy * $e0c9aa0e5bb8bd29$var$currentConfig.topology.y, r.pos.z)
            };
            let mesh = (0, $6fd974a9bd48a893$export$2e2bcd8739ae039)(algo, _currentConfig, fake_r, $e0c9aa0e5bb8bd29$var$mixer, $e0c9aa0e5bb8bd29$var$guiOptions.arrowOpacity, true);
            $e0c9aa0e5bb8bd29$var$scene.add(mesh);
            $e0c9aa0e5bb8bd29$var$robotMesh.push(mesh);
        }
    });
    $e0c9aa0e5bb8bd29$var$clockDeltaThrottle = 1; // this will update the rotation of the robots
} /*
  function onMouseDown(event) {
    event.preventDefault();
    var rightclick;
      if (!event) var event = window.event;
      if (event.which) rightclick = (event.which == 3);
      else if (event.button) rightclick = (event.button == 2);
    if (!rightclick) return;
  
    raycaster.setFromCamera(mouse, camera);
  
    var intersects = raycaster.intersectObjects([torusKnot]);
  
    if (intersects.length) {
      intersect = intersects[0].object;
      menu.style.left = (event.clientX - rect.left) + "px";
      menu.style.top = (event.clientY - rect.top) + "px";
      menu.style.display = "";
    }
    else{
      intersect = undefined;
    }
  }*/ 




const $d9084119c629caff$var$initialConfigSelector = document.getElementById('initial-configurations-selector');
let $d9084119c629caff$var$defaultOptions = {
    walls: [
        [
            0,
            0,
            0
        ],
        [
            6,
            6,
            6
        ]
    ],
    colors: {
        'F': 0xff0000,
        'L': 0x00ff00,
        'A': 0x0000ff,
        'B': 0x00004f
    },
    visibilityRange: 1,
    is3d: true,
    chirality: true,
    cacheRules: false,
    seed: 0,
    dimension: 3
};
let $d9084119c629caff$var$algo = {
    rules: {},
    rulesReference: {},
    options: {
        ...$d9084119c629caff$var$defaultOptions
    },
    usedViews: new Set()
};
const $d9084119c629caff$var$container = document.getElementById("app");
$e0c9aa0e5bb8bd29$export$185802fd694ee1f5($d9084119c629caff$var$container, $d9084119c629caff$var$algo);
(0, $818bb3bf843b8c76$export$73235c61e66eff0b)($d9084119c629caff$var$algo);
(0, $818bb3bf843b8c76$export$62a6e6ed59805c20)($d9084119c629caff$var$algo);
(0, $16f8882f3e3ce876$export$2288787135a8f66e)('Welcome to the 3D robot simulator. Edit the rules to trigger compilation'); /*
                                                                                     const symmetryWorker = new Worker(
                                                                                       './src/symmetries.js',
                                                                                       {type: 'module'}
                                                                                     );
                                                                                     
                                                                                     symmetryWorker.onmessage = function(e) {
                                                                                       console.log('received data from worler', e)
                                                                                       algo = e.data;
                                                                                       let round = 0;
                                                                                       while(prevStep()) round++;
                                                                                       while(round--) nextStep();
                                                                                     
                                                                                     }
                                                                                     */ 
let $d9084119c629caff$var$initialConfigurations = {};
let $d9084119c629caff$var$_lastInitialConfigurationValue = '';
function $d9084119c629caff$var$onInitialConfigurationChange(v, { reload: reload } = {
    reload: false
}) {
    if (reload) v = $d9084119c629caff$var$_lastInitialConfigurationValue;
    else if ($d9084119c629caff$var$_lastInitialConfigurationValue === v) return;
    $d9084119c629caff$var$_lastInitialConfigurationValue = v;
    try {
        $d9084119c629caff$var$initialConfigurations = (0, $0df899459436dd50$export$2e2bcd8739ae039)(v, $d9084119c629caff$var$algo.options);
    } catch (e) {
        (0, $16f8882f3e3ce876$export$2288787135a8f66e)(e.message);
        return;
    }
    $d9084119c629caff$var$updateInitialConfigurationsList(Object.keys($d9084119c629caff$var$initialConfigurations));
}
let $d9084119c629caff$var$_lastOptionsValue = '';
function $d9084119c629caff$var$onOptionsChange(v) {
    if ($d9084119c629caff$var$_lastOptionsValue === v) return;
    $d9084119c629caff$var$_lastOptionsValue = v;
    console.log('Options Changed', v);
    $d9084119c629caff$var$jumpPrevStep(0);
    $d9084119c629caff$var$algo.options = {
        ...$d9084119c629caff$var$defaultOptions,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($e56d81185102178b$exports))).parse(v)
    };
    $d9084119c629caff$var$algo.options.colors = {
        ...$d9084119c629caff$var$defaultOptions.colors,
        ...$d9084119c629caff$var$algo.options.colors
    };
    if (isNaN($d9084119c629caff$var$algo.options.visibilityRange) || $d9084119c629caff$var$algo.options.visibilityRange <= 0) throw new Error('visibilityRange is not a valid number');
    $d9084119c629caff$var$onInitialConfigurationChange('', {
        reload: true
    }); //Scene.init(currentConfig, algo);
//currentConfig.seed = algo.options.seed;
}
let $d9084119c629caff$var$moveToSameRoundTimoutId = null;
function $d9084119c629caff$var$moveToSameRound(round) {
    if ($d9084119c629caff$var$moveToSameRoundTimoutId) clearTimeout($d9084119c629caff$var$moveToSameRoundTimoutId);
    $d9084119c629caff$var$moveToSameRoundTimoutId = setTimeout(()=>{
        $d9084119c629caff$var$moveToSameRoundTimoutId = null; //perform at most 10 steps
        let i = 10;
        while($d9084119c629caff$var$nextStep(false) && $d9084119c629caff$var$currentRound < round && i-- > 0);
        $e0c9aa0e5bb8bd29$export$da3a242fdc570d73($d9084119c629caff$var$currentConfig, $d9084119c629caff$var$algo);
        $d9084119c629caff$var$setCanvasRoundInfo($d9084119c629caff$var$currentRound);
        if (i === -1 && $d9084119c629caff$var$currentRound < round) $d9084119c629caff$var$moveToSameRound(round);
    }, 0);
}
let $d9084119c629caff$var$_lastRulesValue = '';
let $d9084119c629caff$var$_lastRulesParsed = '';
function $d9084119c629caff$var$onRulesChange(v) {
    if ($d9084119c629caff$var$_lastRulesValue === v) return;
    $d9084119c629caff$var$_lastRulesValue = v;
    try {
        //console.log('parsing with options', JSON.parse(JSON.stringify(algo.options)));
        const { rules: rules, rulesReference: rulesReference, alias: alias } = (0, $0640cb604c7a0caa$export$2e2bcd8739ae039)(v + '\n\n', $d9084119c629caff$var$algo.options.visibilityRange, $d9084119c629caff$var$algo.options.dimension); //_lastRulesParsed
        //const newRulesParsed = Object.values(rules).map(r => ruleToString(r)).join('\n'); // JSON.stringify(rules);
        //if(_lastRulesParsed == newRulesParsed) {
        //  return;
        //}
        //_lastRulesParsed = newRulesParsed;
        $e0c9aa0e5bb8bd29$export$2cd8252107eb640b($d9084119c629caff$var$currentConfig, $d9084119c629caff$var$algo);
        $d9084119c629caff$var$algo.alias = alias;
        $d9084119c629caff$var$algo.rules = rules;
        $d9084119c629caff$var$algo.rulesReference = rulesReference; //console.log(JSON.parse(JSON.stringify(algo.rules)));
        (0, $3ef10935a69594bb$export$c18765226966aa9)($d9084119c629caff$var$algo); //console.log(JSON.parse(JSON.stringify(algo.rules)));
        console.log('New Algo', $d9084119c629caff$var$algo);
        let round = $d9084119c629caff$var$currentRound; //while(prevStep()) round++;
        //while(round--) nextStep();
        $d9084119c629caff$var$selectInitialConfiguration($d9084119c629caff$var$currentConfigName);
        $e0c9aa0e5bb8bd29$export$da3a242fdc570d73($d9084119c629caff$var$currentConfig, $d9084119c629caff$var$algo);
        $d9084119c629caff$var$moveToSameRound(round); //symmetryWorker.postMessage(algo);
    //console.log(JSON.parse(JSON.stringify(rules)));
    //console.log(Object.keys(rules).length);
    } catch (e) {
        $d9084119c629caff$var$_lastRulesValue = '';
        (0, $16f8882f3e3ce876$export$2288787135a8f66e)(e);
        console.log(e);
        return;
    }
    (0, $16f8882f3e3ce876$export$2288787135a8f66e)(null);
}
(0, $818bb3bf843b8c76$export$4256f76d7567e2ca)($d9084119c629caff$var$onRulesChange, $d9084119c629caff$var$onOptionsChange, $d9084119c629caff$var$onInitialConfigurationChange);
function $d9084119c629caff$var$selectInitialConfiguration(name) {
    (0, $16f8882f3e3ce876$export$2288787135a8f66e)(null);
    $d9084119c629caff$var$jumpPrevStep(0);
    $d9084119c629caff$var$currentConfigName = name;
    $d9084119c629caff$var$currentConfig = $d9084119c629caff$var$initialConfigurations[name].config;
    $d9084119c629caff$var$algo.options.walls[1] = $d9084119c629caff$var$initialConfigurations[name].gridSize.slice();
    $d9084119c629caff$var$algo.usedViews = new Set();
    $d9084119c629caff$var$currentConfig.seed = $d9084119c629caff$var$initialConfigurations[name].seed;
    console.log('new Config wiht seed', $d9084119c629caff$var$algo.options.seed);
    $e0c9aa0e5bb8bd29$export$2cd8252107eb640b($d9084119c629caff$var$currentConfig, $d9084119c629caff$var$algo);
    $d9084119c629caff$var$nextStep();
    $d9084119c629caff$var$prevStep();
}
$d9084119c629caff$var$initialConfigSelector.addEventListener('change', (e)=>{
    console.log('selecting', e.target.value);
    $d9084119c629caff$var$selectInitialConfiguration(e.target.value);
});
let $d9084119c629caff$var$currentConfig;
let $d9084119c629caff$var$currentConfigName = 'default';
let $d9084119c629caff$var$currentRound = 0;
const $d9084119c629caff$var$configList = []; // go back to step 0
function $d9084119c629caff$var$jumpPrevStep(round) {
    if (round >= $d9084119c629caff$var$currentRound) return;
    while($d9084119c629caff$var$currentRound > round){
        if ($d9084119c629caff$var$configList.length === 0) break;
        $d9084119c629caff$var$currentConfig = $d9084119c629caff$var$configList.pop();
        $d9084119c629caff$var$currentRound--;
    }
    $e0c9aa0e5bb8bd29$export$da3a242fdc570d73($d9084119c629caff$var$currentConfig, $d9084119c629caff$var$algo);
    $d9084119c629caff$var$setCanvasRoundInfo($d9084119c629caff$var$currentRound);
    return true;
}
function $d9084119c629caff$var$nextStep(screenUpdate = true) {
    const nextConfig = (0, $347b986847663c76$export$8e29bb008a68fd1f)($d9084119c629caff$var$algo, $d9084119c629caff$var$currentConfig);
    if (nextConfig.equals($d9084119c629caff$var$currentConfig)) return false;
    $d9084119c629caff$var$configList.push($d9084119c629caff$var$currentConfig);
    $d9084119c629caff$var$currentConfig = nextConfig;
    $d9084119c629caff$var$currentRound++;
    if (screenUpdate) {
        $e0c9aa0e5bb8bd29$export$da3a242fdc570d73($d9084119c629caff$var$currentConfig, $d9084119c629caff$var$algo);
        $d9084119c629caff$var$setCanvasRoundInfo($d9084119c629caff$var$currentRound);
    }
    return true;
}
function $d9084119c629caff$var$prevStep() {
    if (!$d9084119c629caff$var$configList.length) return false;
    $d9084119c629caff$var$currentConfig = $d9084119c629caff$var$configList.pop();
    $e0c9aa0e5bb8bd29$export$da3a242fdc570d73($d9084119c629caff$var$currentConfig, $d9084119c629caff$var$algo);
    $d9084119c629caff$var$currentRound--;
    $d9084119c629caff$var$setCanvasRoundInfo($d9084119c629caff$var$currentRound);
    return true;
}
let $d9084119c629caff$var$keyPressed = null;
let $d9084119c629caff$var$keyPressedTimeoutID = null;
let $d9084119c629caff$var$keyPressedStepSpeed = 200;
function $d9084119c629caff$var$keyPressedLoop() {
    $d9084119c629caff$var$keyPressedStepSpeed = Math.max($d9084119c629caff$var$keyPressedStepSpeed - 10, 1);
    if ($d9084119c629caff$var$keyPressed === 'ArrowRight') $d9084119c629caff$var$nextStep();
    else if ($d9084119c629caff$var$keyPressed === 'ArrowLeft') $d9084119c629caff$var$prevStep();
    else return;
    $d9084119c629caff$var$keyPressedTimeoutID = setTimeout($d9084119c629caff$var$keyPressedLoop, $d9084119c629caff$var$keyPressedStepSpeed);
}
document.addEventListener('keydown', (e)=>{
    if (e.key === 'n' || e.key === 'ArrowRight') {
        $d9084119c629caff$var$keyPressed = 'ArrowRight';
        $d9084119c629caff$var$keyPressedStepSpeed = 200;
        $d9084119c629caff$var$keyPressedLoop();
    } else if (e.key === 'b' || e.key === 'ArrowLeft') {
        $d9084119c629caff$var$keyPressed = 'ArrowLeft';
        $d9084119c629caff$var$keyPressedStepSpeed = 200;
        $d9084119c629caff$var$keyPressedLoop();
    }
});
document.addEventListener('keyup', (e)=>{
    $d9084119c629caff$var$keyPressed = null;
    $d9084119c629caff$var$keyPressedTimeoutID && clearTimeout($d9084119c629caff$var$keyPressedTimeoutID);
}); /*
    if(localStorage.getItem('options')) {
      onOptionsChange(localStorage.getItem('options'));
    }
    if(localStorage.getItem('initial')) {
      onInitialConfigurationChange(localStorage.getItem('initial'));
    }
    if(localStorage.getItem('rules')) {
      //onRulesChange(localStorage.getItem('rules'));
    }
    */ 
let $d9084119c629caff$var$canvasInfo = document.createElement('div');
$d9084119c629caff$var$canvasInfo.style.position = 'absolute'; //canvasInfo.style.zIndex = 1;    // if you still don't see the label, try uncommenting this
$d9084119c629caff$var$canvasInfo.style.width = 100;
$d9084119c629caff$var$canvasInfo.style.height = 100;
$d9084119c629caff$var$canvasInfo.style.backgroundColor = "rgba(0,0,0,0.1)";
$d9084119c629caff$var$canvasInfo.style.top = "0px";
$d9084119c629caff$var$canvasInfo.style.left = "250px";
document.body.appendChild($d9084119c629caff$var$canvasInfo);
setTimeout(()=>{
    $d9084119c629caff$var$setCanvansInfo("You are out of focus, please click on the canvas.");
    document.getElementById('three-container').addEventListener('click', (e)=>{
        $d9084119c629caff$var$setCanvansInfo("use left or right arrow to execute a round");
    });
    document.addEventListener('click', ()=>{
        $d9084119c629caff$var$setCanvansInfo("You are out of focus, please click on the canvas.");
    });
}, 1000);
function $d9084119c629caff$var$setCanvansInfo(text) {
    $d9084119c629caff$var$canvasInfo.innerHTML = text;
}
let $d9084119c629caff$var$canvasControl = document.createElement('div');
$d9084119c629caff$var$canvasControl.style.position = 'absolute'; //canvasInfo.style.zIndex = 1;    // if you still don't see the label, try uncommenting this
$d9084119c629caff$var$canvasControl.style.width = 400;
$d9084119c629caff$var$canvasControl.style.height = 400;
$d9084119c629caff$var$canvasControl.style.backgroundColor = "rgba(0,0,0,0.1)";
$d9084119c629caff$var$canvasControl.style.top = "0px";
$d9084119c629caff$var$canvasControl.style.left = "600px";
$d9084119c629caff$var$canvasControl.innerHTML = `
<div id="canvas-control">
<label for="print-marker-option">Print un-visited marker</label>
<input type="checkbox" name="print-marker-option" id="print-marker-option">
<div>
`;
document.body.appendChild($d9084119c629caff$var$canvasControl);
document.getElementById('print-marker-option').addEventListener('click', (e)=>{
    (0, $e0c9aa0e5bb8bd29$export$1fe590ebb04610e5).printMarker = e.target.checked;
    $e0c9aa0e5bb8bd29$export$2cd8252107eb640b($d9084119c629caff$var$currentConfig, $d9084119c629caff$var$algo);
});
let $d9084119c629caff$var$canvasRoundInfo = document.createElement('div');
$d9084119c629caff$var$canvasRoundInfo.style.position = 'absolute'; //canvasInfo.style.zIndex = 1;    // if you still don't see the label, try uncommenting this
$d9084119c629caff$var$canvasRoundInfo.style.width = 100;
$d9084119c629caff$var$canvasRoundInfo.style.height = 100;
$d9084119c629caff$var$canvasRoundInfo.style.backgroundColor = "rgba(0,0,0,0.1)";
$d9084119c629caff$var$canvasRoundInfo.style.bottom = "0px";
$d9084119c629caff$var$canvasRoundInfo.style.left = "150px";
$d9084119c629caff$var$canvasRoundInfo.id = "canvas-round-info";
document.body.appendChild($d9084119c629caff$var$canvasRoundInfo);
$d9084119c629caff$var$canvasRoundInfo.addEventListener('click', ()=>{
    $d9084119c629caff$var$jumpPrevStep(0);
});
function $d9084119c629caff$var$setCanvasRoundInfo(r) {
    $d9084119c629caff$var$canvasRoundInfo.innerHTML = `Round ${r} (click here to go back to round 0) `;
}
$d9084119c629caff$var$setCanvasRoundInfo(0);
function $d9084119c629caff$var$updateInitialConfigurationsList(list) {
    let oldValue = $d9084119c629caff$var$initialConfigSelector.value || 'default';
    while($d9084119c629caff$var$initialConfigSelector.length)$d9084119c629caff$var$initialConfigSelector.remove(0);
    let found = false;
    list.forEach((el)=>{
        const opt = document.createElement("option");
        opt.value = el;
        opt.text = el;
        if (el === oldValue) {
            opt.selected = true;
            found = true;
        }
        $d9084119c629caff$var$initialConfigSelector.add(opt);
    });
    if (found) $d9084119c629caff$var$selectInitialConfiguration(oldValue);
    else $d9084119c629caff$var$selectInitialConfiguration(list[0]); //onError('the initial configuration disapeared.\nThe first one is now selected');
}

})();
//# sourceMappingURL=index.e08c96ed.js.map
